import "./assets/main.css";
import { j as rt } from "./jsx-runtime-p91LotPX.mjs";
import { GrowFlex as Pu } from "./BaseComponents/Flex/Flex.js";
import { HideWrapper as Py } from "./BaseComponents/HideWrapper/HideWrapper.js";
import { DragIcon as Dy, CloseIcon as Ay } from "./Icons/Icons.js";
import "./GrowAvatar-DJSlhesM.mjs";
import { GrowButton as kd } from "./BaseComponents/Button/AntButton.js";
import "./BaseComponents/CheckBox/style.js";
import "./BaseComponents/Typography/AntTypography.js";
import "./BaseComponents/utils/datetime-formatter.js";
import { C as Xl, u as xy, a as Dp, M as Fy, D as My, b as Iy, d as Ap, K as Ly, P as Ny } from "./core.esm-D9FG3ApV.mjs";
import { u as Gy, a as Hy, b as Vy, s as By } from "./SortableItem-C--6XTJo.mjs";
import "./lodash-lyheMOjd.mjs";
import Ye, { createContext as ky, useMemo as jd, useContext as jy, useState as Wy, useCallback as Uy } from "react";
import "./BaseComponents/Dnd/SortableContainer.js";
import "./AntDrawer-ChgesM8B.mjs";
import "./style-BCs5tvAM.mjs";
import "./BaseComponents/StatusTag/style.js";
import { r as Hi } from "./index-Omb0Wmns.mjs";
import "./style-ClHoikNh.mjs";
import "./BaseComponents/Table/ColumnCustom/ColumnSort/ColumnSortList.js";
import "./table-XsUAem3c.mjs";
import "./style-pk1ekFUy.mjs";
import { a as zy, c as P } from "./_commonjsHelpers-B7iq2c9Y.mjs";
import { p as $y } from "./index.es-YI5dIElQ.mjs";
import { r as Wd } from "./index-DLnWmpTv.mjs";
import "./BaseComponents/Table/BulkAction/style.js";
import "./BaseComponents/Table/Pagination/style.js";
import "./BaseComponents/Table/style.js";
import "./BaseComponents/Tree/style.js";
import "./BaseComponents/UI/FormArea/FormFooter.js";
import "./BaseComponents/css.js";
import { p as Ud } from "./styled-components.browser.esm-DBaC0ZEI.mjs";
import { T as zd } from "./index-BP092b3A.mjs";
import { E as Ky } from "./index-CXEaQcuD.mjs";
const Yy = (i) => {
  let {
    transform: t
  } = i;
  return {
    ...t,
    x: 0
  };
}, xp = Ud("li")`
  width: 100%;
  list-style: none;

  &:hover:not(.disabled):not(.drag-active) {
    background: var(--gray-2);
  }

  &.drag-active {
    padding-left: 40px;

    .SortableItem {
      position: relative;
      padding: 0;
      border-top: 2px solid var(--primary-7);
      opacity: 1;

      &::before {
        position: absolute;
        left: -2px;
        top: -6px;
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 1px solid var(--primary-5);
        background-color: #fff;
        content: "";
      }

      & > * {
        opacity: 0;
      }
    }
  }

  &.overlay {
    background: var(--gray-1);
    border: 1px solid var(--gray-4);
    box-shadow: var(--shadow-2);
    padding: var(--space-2);

    .DragHandle {
      pointer-events: none;
    }
  }
`, $d = ky({
  attributes: {},
  listeners: void 0,
  ref() {
  }
}), qy = ({
  isSorting: i,
  wasDragging: t
}) => !(i || t);
function Xy({
  children: i,
  id: t,
  disabled: e,
  isOverlay: r
}) {
  const {
    attributes: o,
    isDragging: n,
    listeners: s,
    setNodeRef: a,
    setActivatorNodeRef: l,
    transform: u,
    transition: c
  } = Gy({
    id: t,
    disabled: e,
    animateLayoutChanges: qy
  }), p = jd(() => ({
    attributes: o,
    listeners: s,
    ref: l
  }), [o, s, l]), d = {
    transform: Xl.Translate.toString(u),
    transition: c
  };
  return /* @__PURE__ */ rt.jsx(rt.Fragment, { children: e ? /* @__PURE__ */ rt.jsx(xp, { className: "SortableItem disabled ", children: i }) : /* @__PURE__ */ rt.jsx($d.Provider, { value: p, children: /* @__PURE__ */ rt.jsx(xp, { className: `${n ? "drag-active" : ""} ${r ? "overlay" : ""}`, ref: a, style: d, children: /* @__PURE__ */ rt.jsx("div", { className: "SortableItem", children: i }) }) }) });
}
function Qy(i) {
  const {
    attributes: t,
    listeners: e,
    ref: r
  } = jy($d);
  return /* @__PURE__ */ rt.jsx(zd, { title: "Drag to reorder", showArrow: !1, autoAdjustOverflow: !0, destroyTooltipOnHide: !0, placement: "left", children: /* @__PURE__ */ rt.jsx(kd, { onClick: (o) => {
    o.preventDefault(), o.stopPropagation();
  }, iconButton: "without_bg", style: {
    alignSelf: "flex-start",
    cursor: "grab"
  }, icon: /* @__PURE__ */ rt.jsx(Dy, { onClick: (o) => {
    o.preventDefault(), o.stopPropagation();
  } }), className: "DragHandle", ...t, ...e, ref: r, disabled: i.disabled, title: i.list.headerName }) });
}
const Jy = ({
  transform: i
}) => ({
  ...i,
  x: i.x - 25,
  y: i.y - 25
}), Zy = {
  keyframes({
    transform: i
  }) {
    return [{
      opacity: 1,
      transform: Xl.Transform.toString(i.initial)
    }, {
      opacity: 0,
      transform: Xl.Transform.toString({
        ...i.final,
        x: i.final.x + 5,
        y: i.final.y + 5
      })
    }];
  },
  easing: "ease-out",
  sideEffects({
    active: i
  }) {
    i.node.animate([{
      opacity: 0
    }, {
      opacity: 1
    }], {
      duration: Ap.duration,
      easing: Ap.easing
    });
  }
};
function Kd({
  items: i,
  onChange: t,
  renderItem: e,
  onDragging: r
}) {
  const [o, n] = Wy(null), s = jd(() => i.find((p) => p.id === (o == null ? void 0 : o.id)), [o, i]), a = xy(Dp(Ny), Dp(Ly, {
    coordinateGetter: By
  }));
  function l(p, d) {
    return e(p, d);
  }
  const u = Uy(l, [e]), c = {
    droppable: {
      strategy: Fy.Always
    }
  };
  return /* @__PURE__ */ rt.jsx(rt.Fragment, { children: i.length ? /* @__PURE__ */ rt.jsxs(My, { measuring: c, modifiers: [Yy], sensors: a, onDragStart: ({
    active: p
  }) => {
    n(p), r(!0);
  }, onDragEnd: ({
    active: p,
    over: d
  }) => {
    if (d && p.id !== (d == null ? void 0 : d.id)) {
      const h = i.findIndex(({
        id: S
      }) => S === p.id), g = i.findIndex(({
        id: S
      }) => S === d.id), y = i.find(({
        id: S
      }) => S === p.id);
      t(Hy(i, h, g), y, h, g);
    }
    n(null), r(!1);
  }, onDragCancel: () => {
    n(null), r(!1);
  }, children: [
    /* @__PURE__ */ rt.jsx(Vy, { items: i, children: /* @__PURE__ */ rt.jsx(Pu, { className: "SortableList", role: "application", vertical: !0, style: {
      width: "100%"
    }, gap: 2, children: i.map((p) => /* @__PURE__ */ rt.jsx(Ye.Fragment, { children: u(p) }, p.id)) }) }),
    Hi.createPortal(/* @__PURE__ */ rt.jsx(Iy, { dropAnimation: Zy, modifiers: [Jy], wrapperElement: "ul", zIndex: 99999, style: {
      left: "auto !important",
      right: "0"
    }, children: s ? u(s, !0) : null }), document.body)
  ] }) : /* @__PURE__ */ rt.jsx(Ky, { style: {
    width: "100%"
  }, description: "No Columns found", image: !1 }) });
}
Kd.Item = Xy;
Kd.DragHandle = Qy;
var _a = {}, Ea = {};
/**
          * @ag-grid-community/all-modules - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue * @version v29.3.5
          * @link https://www.ag-grid.com/
          * @license MIT
          */
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function Go(i) {
  return i == null || i === "" ? null : i;
}
function k(i, t) {
  return t === void 0 && (t = !1), i != null && (i !== "" || t);
}
function ue(i) {
  return !k(i);
}
function cr(i) {
  return i == null || i.length === 0;
}
function Du(i) {
  return i != null && typeof i.toString == "function" ? i.toString() : null;
}
function Sr(i) {
  if (i !== void 0) {
    if (i === null || i === "")
      return null;
    if (typeof i == "number")
      return isNaN(i) ? void 0 : i;
    var t = parseInt(i, 10);
    return isNaN(t) ? void 0 : t;
  }
}
function eo(i) {
  if (i !== void 0)
    return i === null || i === "" ? !1 : typeof i == "boolean" ? i : /true/i.test(i);
}
function em(i) {
  if (!(i == null || i === ""))
    return i;
}
function tm(i, t) {
  return i == null && t == null ? !0 : i == null && t != null || i != null && t == null ? !1 : i === t;
}
function rm(i, t) {
  var e = i ? JSON.stringify(i) : null, r = t ? JSON.stringify(t) : null;
  return e === r;
}
function om(i, t, e) {
  e === void 0 && (e = !1);
  var r = i == null, o = t == null;
  if (i && i.toNumber && (i = i.toNumber()), t && t.toNumber && (t = t.toNumber()), r && o)
    return 0;
  if (r)
    return -1;
  if (o)
    return 1;
  function n(s, a) {
    return s > a ? 1 : s < a ? -1 : 0;
  }
  if (typeof i != "string" || !e)
    return n(i, t);
  try {
    return i.localeCompare(t);
  } catch {
    return n(i, t);
  }
}
function Vi(i) {
  if (i instanceof Set || i instanceof Map) {
    var t = [];
    return i.forEach(function(e) {
      return t.push(e);
    }), t;
  }
  return Object.values(i);
}
var nm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  makeNull: Go,
  exists: k,
  missing: ue,
  missingOrEmpty: cr,
  toStringOrNull: Du,
  attrToNumber: Sr,
  attrToBoolean: eo,
  attrToString: em,
  referenceCompare: tm,
  jsonEquals: rm,
  defaultComparator: om,
  values: Vi
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Yd = (
  /** @class */
  function() {
    function i() {
      this.existingKeys = {};
    }
    return i.prototype.addExistingKeys = function(t) {
      for (var e = 0; e < t.length; e++)
        this.existingKeys[t[e]] = !0;
    }, i.prototype.getUniqueKey = function(t, e) {
      t = Du(t);
      for (var r = 0; ; ) {
        var o = void 0;
        if (t ? (o = t, r !== 0 && (o += "_" + r)) : e ? (o = e, r !== 0 && (o += "_" + r)) : o = "" + r, !this.existingKeys[o])
          return this.existingKeys[o] = !0, o;
        r++;
      }
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function Ke(i, t) {
  i != null && (Array.isArray(i) ? i.forEach(function(e, r) {
    return t("" + r, e);
  }) : Object.keys(i).forEach(function(e) {
    return t(e, i[e]);
  }));
}
function Au(i) {
  for (var t = {}, e = Object.keys(i), r = 0; r < e.length; r++) {
    var o = e[r], n = i[o];
    t[o] = n;
  }
  return t;
}
function im(i) {
  return JSON.parse(JSON.stringify(i));
}
function zs(i, t) {
  if (i) {
    var e = i, r = {};
    return Object.keys(e).forEach(function(o) {
      if (!(t && t.indexOf(o) >= 0)) {
        var n = e[o], s = Ks(n) && n.constructor === Object;
        s ? r[o] = zs(n) : r[o] = n;
      }
    }), r;
  }
}
function qd(i, t) {
  return i[t];
}
function Xd(i, t, e) {
  i[t] = e;
}
function sm(i, t) {
  for (var e = [], r = 2; r < arguments.length; r++)
    e[r - 2] = arguments[r];
  e.forEach(function(o) {
    return Qd(i, t, o);
  });
}
function Qd(i, t, e, r) {
  var o = qd(i, e);
  o !== void 0 && Xd(t, e, r ? r(o) : o);
}
function Jd(i) {
  var t = {};
  return i.filter(function(e) {
    return e != null;
  }).forEach(function(e) {
    Object.keys(e).forEach(function(r) {
      return t[r] = null;
    });
  }), Object.keys(t);
}
function io(i) {
  if (!i)
    return [];
  var t = Object;
  if (typeof t.values == "function")
    return t.values(i);
  var e = [];
  for (var r in i)
    i.hasOwnProperty(r) && i.propertyIsEnumerable(r) && e.push(i[r]);
  return e;
}
function ir(i, t, e, r) {
  e === void 0 && (e = !0), r === void 0 && (r = !1), k(t) && Ke(t, function(o, n) {
    var s = i[o];
    if (s !== n) {
      if (r) {
        var a = s == null && n != null;
        if (a) {
          var l = typeof n == "object" && n.constructor === Object, u = l;
          u && (s = {}, i[o] = s);
        }
      }
      Ks(n) && Ks(s) && !Array.isArray(s) ? ir(s, n, e, r) : (e || n !== void 0) && (i[o] = n);
    }
  });
}
function am(i) {
  return ue(i) || Object.keys(i).length === 0;
}
function lm(i, t, e) {
  if (i == null)
    return e;
  for (var r = t.split("."), o = i; r.length > 1; )
    if (o = o[r.shift()], o == null)
      return e;
  var n = o[r[0]];
  return n ?? e;
}
function um(i, t, e) {
  if (i != null) {
    var r = t.split("."), o = i;
    r.forEach(function(n, s) {
      o[n] || (o[n] = {}), s < r.length - 1 && (o = o[n]);
    }), o[r[r.length - 1]] = e;
  }
}
function $s(i, t, e) {
  if (!(!t || !i)) {
    if (!e)
      return i[t];
    for (var r = t.split("."), o = i, n = 0; n < r.length; n++) {
      if (o == null)
        return;
      o = o[r[n]];
    }
    return o;
  }
}
function Zd(i, t) {
  Object.keys(i).forEach(function(o) {
    var n = i[o];
    typeof n == "object" && (i[o] = void 0);
  });
  var e = Object.getPrototypeOf(i), r = {};
  Object.keys(e).forEach(function(o) {
    var n = e[o];
    if (typeof n == "function") {
      var s = function() {
        console.warn("AG Grid: " + t + " function " + o + `() cannot be called as the grid has been destroyed.
                     Please don't call grid API functions on destroyed grids - as a matter of fact you shouldn't
                     be keeping the API reference, your application has a memory leak! Remove the API reference
                     when the grid is destroyed.`);
      };
      r[o] = { value: s, writable: !0 };
    }
  }), Object.defineProperties(i, r);
}
function Ks(i) {
  return typeof i == "object" && i !== null;
}
var cm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  iterateObject: Ke,
  cloneObject: Au,
  deepCloneObject: im,
  deepCloneDefinition: zs,
  getProperty: qd,
  setProperty: Xd,
  copyPropertiesIfPresent: sm,
  copyPropertyIfPresent: Qd,
  getAllKeysInObjects: Jd,
  getAllValuesInObject: io,
  mergeDeep: ir,
  missingOrEmptyObject: am,
  get: lm,
  set: um,
  getValueUsingField: $s,
  removeAllReferences: Zd,
  isNonNullObject: Ks
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Fp = {};
function Pe(i, t) {
  Fp[t] || (i(), Fp[t] = !0);
}
function Ra(i) {
  if (i.name)
    return i.name;
  var t = /function\s+([^\(]+)/.exec(i.toString());
  return t && t.length === 2 ? t[1].trim() : null;
}
function Oa(i) {
  return !!(i && i.constructor && i.call && i.apply);
}
function ef(i) {
  tf(i, 400);
}
var Qa = [], Ja = !1;
function Ql(i) {
  Qa.push(i), !Ja && (Ja = !0, window.setTimeout(function() {
    var t = Qa.slice();
    Qa.length = 0, Ja = !1, t.forEach(function(e) {
      return e();
    });
  }, 0));
}
function tf(i, t) {
  t === void 0 && (t = 0), i.length > 0 && window.setTimeout(function() {
    return i.forEach(function(e) {
      return e();
    });
  }, t);
}
function ro(i, t) {
  var e;
  return function() {
    for (var r = [], o = 0; o < arguments.length; o++)
      r[o] = arguments[o];
    var n = this;
    window.clearTimeout(e), e = window.setTimeout(function() {
      i.apply(n, r);
    }, t);
  };
}
function Jl(i, t) {
  var e = 0;
  return function() {
    for (var r = [], o = 0; o < arguments.length; o++)
      r[o] = arguments[o];
    var n = this, s = (/* @__PURE__ */ new Date()).getTime();
    s - e < t || (e = s, i.apply(n, r));
  };
}
function rf(i, t, e, r) {
  e === void 0 && (e = 100);
  var o = (/* @__PURE__ */ new Date()).getTime(), n = null, s = !1, a = function() {
    var l = (/* @__PURE__ */ new Date()).getTime() - o > e;
    (i() || l) && (t(), s = !0, n != null && (window.clearInterval(n), n = null), l && r && console.warn(r));
  };
  a(), s || (n = window.setInterval(a, 10));
}
function pm() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i[t] = arguments[t];
  return function(e) {
    return i.reduce(function(r, o) {
      return o(r);
    }, e);
  };
}
function of(i) {
  i && i();
}
var dm = function() {
}, fm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  doOnce: Pe,
  getFunctionName: Ra,
  isFunction: Oa,
  executeInAWhile: ef,
  executeNextVMTurn: Ql,
  executeAfter: tf,
  debounce: ro,
  throttle: Jl,
  waitUntil: rf,
  compose: pm,
  callIfPresent: of,
  noop: dm
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var hm = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, vm = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(hm(arguments[t]));
  return i;
}, nf = (
  /** @class */
  function() {
    function i(t, e) {
      if (this.beanWrappers = {}, this.destroyed = !1, !(!t || !t.beanClasses)) {
        this.contextParams = t, this.logger = e, this.logger.log(">> creating ag-Application Context"), this.createBeans();
        var r = this.getBeanInstances();
        this.wireBeans(r), this.logger.log(">> ag-Application Context ready - component is alive");
      }
    }
    return i.prototype.getBeanInstances = function() {
      return Vi(this.beanWrappers).map(function(t) {
        return t.beanInstance;
      });
    }, i.prototype.createBean = function(t, e) {
      if (!t)
        throw Error("Can't wire to bean since it is null");
      return this.wireBeans([t], e), t;
    }, i.prototype.wireBeans = function(t, e) {
      this.autoWireBeans(t), this.methodWireBeans(t), this.callLifeCycleMethods(t, "preConstructMethods"), k(e) && t.forEach(e), this.callLifeCycleMethods(t, "postConstructMethods");
    }, i.prototype.createBeans = function() {
      var t = this;
      this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this)), Ke(this.beanWrappers, function(r, o) {
        var n;
        o.bean.__agBeanMetaData && o.bean.__agBeanMetaData.autowireMethods && o.bean.__agBeanMetaData.autowireMethods.agConstructor && (n = o.bean.__agBeanMetaData.autowireMethods.agConstructor);
        var s = t.getBeansForParameters(n, o.bean.name), a = new (o.bean.bind.apply(o.bean, vm([null], s)))();
        o.beanInstance = a;
      });
      var e = Object.keys(this.beanWrappers).join(", ");
      this.logger.log("created beans: " + e);
    }, i.prototype.createBeanWrapper = function(t) {
      var e = t.__agBeanMetaData;
      if (!e) {
        var r = void 0;
        t.prototype.constructor ? r = Ra(t.prototype.constructor) : r = "" + t, console.error("Context item " + r + " is not a bean");
        return;
      }
      var o = {
        bean: t,
        beanInstance: null,
        beanName: e.beanName
      };
      this.beanWrappers[e.beanName] = o;
    }, i.prototype.autoWireBeans = function(t) {
      var e = this;
      t.forEach(function(r) {
        e.forEachMetaDataInHierarchy(r, function(o, n) {
          var s = o.agClassAttributes;
          s && s.forEach(function(a) {
            var l = e.lookupBeanInstance(n, a.beanName, a.optional);
            r[a.attributeName] = l;
          });
        });
      });
    }, i.prototype.methodWireBeans = function(t) {
      var e = this;
      t.forEach(function(r) {
        e.forEachMetaDataInHierarchy(r, function(o, n) {
          Ke(o.autowireMethods, function(s, a) {
            if (s !== "agConstructor") {
              var l = e.getBeansForParameters(a, n);
              r[s].apply(r, l);
            }
          });
        });
      });
    }, i.prototype.forEachMetaDataInHierarchy = function(t, e) {
      for (var r = Object.getPrototypeOf(t); r != null; ) {
        var o = r.constructor;
        if (o.hasOwnProperty("__agBeanMetaData")) {
          var n = o.__agBeanMetaData, s = this.getBeanName(o);
          e(n, s);
        }
        r = Object.getPrototypeOf(r);
      }
    }, i.prototype.getBeanName = function(t) {
      if (t.__agBeanMetaData && t.__agBeanMetaData.beanName)
        return t.__agBeanMetaData.beanName;
      var e = t.toString(), r = e.substring(9, e.indexOf("("));
      return r;
    }, i.prototype.getBeansForParameters = function(t, e) {
      var r = this, o = [];
      return t && Ke(t, function(n, s) {
        var a = r.lookupBeanInstance(e, s);
        o[Number(n)] = a;
      }), o;
    }, i.prototype.lookupBeanInstance = function(t, e, r) {
      if (r === void 0 && (r = !1), e === "context")
        return this;
      if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(e))
        return this.contextParams.providedBeanInstances[e];
      var o = this.beanWrappers[e];
      return o ? o.beanInstance : (r || console.error("AG Grid: unable to find bean reference " + e + " while initialising " + t), null);
    }, i.prototype.callLifeCycleMethods = function(t, e) {
      var r = this;
      t.forEach(function(o) {
        return r.callLifeCycleMethodsOnBean(o, e);
      });
    }, i.prototype.callLifeCycleMethodsOnBean = function(t, e, r) {
      var o = {};
      this.forEachMetaDataInHierarchy(t, function(s) {
        var a = s[e];
        a && a.forEach(function(l) {
          l != r && (o[l] = !0);
        });
      });
      var n = Object.keys(o);
      n.forEach(function(s) {
        return t[s]();
      });
    }, i.prototype.getBean = function(t) {
      return this.lookupBeanInstance("getBean", t, !0);
    }, i.prototype.destroy = function() {
      if (!this.destroyed) {
        this.logger.log(">> Shutting down ag-Application Context");
        var t = this.getBeanInstances();
        this.destroyBeans(t), this.contextParams.providedBeanInstances = null, this.destroyed = !0, this.logger.log(">> ag-Application Context shut down - component is dead");
      }
    }, i.prototype.destroyBean = function(t) {
      t && this.destroyBeans([t]);
    }, i.prototype.destroyBeans = function(t) {
      var e = this;
      return t ? (t.forEach(function(r) {
        e.callLifeCycleMethodsOnBean(r, "preDestroyMethods", "destroy");
        var o = r;
        typeof o.destroy == "function" && o.destroy();
      }), []) : [];
    }, i;
  }()
);
function Zl(i, t, e) {
  var r = dn(i.constructor);
  r.preConstructMethods || (r.preConstructMethods = []), r.preConstructMethods.push(t);
}
function U(i, t, e) {
  var r = dn(i.constructor);
  r.postConstructMethods || (r.postConstructMethods = []), r.postConstructMethods.push(t);
}
function At(i, t, e) {
  var r = dn(i.constructor);
  r.preDestroyMethods || (r.preDestroyMethods = []), r.preDestroyMethods.push(t);
}
function te(i) {
  return function(t) {
    var e = dn(t);
    e.beanName = i;
  };
}
function v(i) {
  return function(t, e, r) {
    sf(t, i, !1, t, e, null);
  };
}
function Fe(i) {
  return function(t, e, r) {
    sf(t, i, !0, t, e, null);
  };
}
function sf(i, t, e, r, o, n) {
  if (t === null) {
    console.error("AG Grid: Autowired name should not be null");
    return;
  }
  if (typeof n == "number") {
    console.error("AG Grid: Autowired should be on an attribute");
    return;
  }
  var s = dn(i.constructor);
  s.agClassAttributes || (s.agClassAttributes = []), s.agClassAttributes.push({
    attributeName: o,
    beanName: t,
    optional: e
  });
}
function Bt(i) {
  return function(t, e, r) {
    var o = typeof t == "function" ? t : t.constructor, n;
    if (typeof r == "number") {
      var s = void 0;
      e ? (n = dn(o), s = e) : (n = dn(o), s = "agConstructor"), n.autowireMethods || (n.autowireMethods = {}), n.autowireMethods[s] || (n.autowireMethods[s] = {}), n.autowireMethods[s][r] = i;
    }
  };
}
function dn(i) {
  return i.hasOwnProperty("__agBeanMetaData") || (i.__agBeanMetaData = {}), i.__agBeanMetaData;
}
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Mp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, ns = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, mo = (
  /** @class */
  function() {
    function i() {
      this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
    }
    return i.prototype.setBeans = function(t, e, r, o) {
      if (o === void 0 && (o = null), this.frameworkOverrides = r, this.gridOptionsService = e, o) {
        var n = e.useAsyncEvents();
        this.addGlobalListener(o, n);
      }
    }, i.prototype.getListeners = function(t, e, r) {
      var o = e ? this.allAsyncListeners : this.allSyncListeners, n = o.get(t);
      return !n && r && (n = /* @__PURE__ */ new Set(), o.set(t, n)), n;
    }, i.prototype.noRegisteredListenersExist = function() {
      return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }, i.prototype.addEventListener = function(t, e, r) {
      r === void 0 && (r = !1), this.getListeners(t, r, !0).add(e);
    }, i.prototype.removeEventListener = function(t, e, r) {
      r === void 0 && (r = !1);
      var o = this.getListeners(t, r, !1);
      if (o && (o.delete(e), o.size === 0)) {
        var n = r ? this.allAsyncListeners : this.allSyncListeners;
        n.delete(t);
      }
    }, i.prototype.addGlobalListener = function(t, e) {
      e === void 0 && (e = !1), (e ? this.globalAsyncListeners : this.globalSyncListeners).add(t);
    }, i.prototype.removeGlobalListener = function(t, e) {
      e === void 0 && (e = !1), (e ? this.globalAsyncListeners : this.globalSyncListeners).delete(t);
    }, i.prototype.dispatchEvent = function(t) {
      var e = t;
      if (this.gridOptionsService) {
        var r = this.gridOptionsService, o = r.api, n = r.columnApi, s = r.context;
        e.api = o, e.columnApi = n, e.context = s;
      }
      this.dispatchToListeners(e, !0), this.dispatchToListeners(e, !1), this.firedEvents[e.type] = !0;
    }, i.prototype.dispatchEventOnce = function(t) {
      this.firedEvents[t.type] || this.dispatchEvent(t);
    }, i.prototype.dispatchToListeners = function(t, e) {
      var r = this, o = t.type;
      if (e && "event" in t) {
        var n = t.event;
        n instanceof Event && (t.eventPath = n.composedPath());
      }
      var s = function(u) {
        return u.forEach(function(c) {
          e ? r.dispatchAsync(function() {
            return c(t);
          }) : c(t);
        });
      }, a = this.getListeners(o, e, !1);
      a && s(a);
      var l = e ? this.globalAsyncListeners : this.globalSyncListeners;
      l.forEach(function(u) {
        e ? r.dispatchAsync(function() {
          return r.frameworkOverrides.dispatchEvent(o, function() {
            return u(o, t);
          }, !0);
        }) : r.frameworkOverrides.dispatchEvent(o, function() {
          return u(o, t);
        }, !0);
      });
    }, i.prototype.dispatchAsync = function(t) {
      this.asyncFunctionsQueue.push(t), this.scheduled || (window.setTimeout(this.flushAsyncQueue.bind(this), 0), this.scheduled = !0);
    }, i.prototype.flushAsyncQueue = function() {
      this.scheduled = !1;
      var t = this.asyncFunctionsQueue.slice();
      this.asyncFunctionsQueue = [], t.forEach(function(e) {
        return e();
      });
    }, Mp([
      ns(0, Bt("loggerFactory")),
      ns(1, Bt("gridOptionsService")),
      ns(2, Bt("frameworkOverrides")),
      ns(3, Bt("globalEventListener"))
    ], i.prototype, "setBeans", null), i = Mp([
      te("eventService")
    ], i), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var re;
(function(i) {
  i.CommunityCoreModule = "@ag-grid-community/core", i.InfiniteRowModelModule = "@ag-grid-community/infinite-row-model", i.ClientSideRowModelModule = "@ag-grid-community/client-side-row-model", i.CsvExportModule = "@ag-grid-community/csv-export", i.EnterpriseCoreModule = "@ag-grid-enterprise/core", i.RowGroupingModule = "@ag-grid-enterprise/row-grouping", i.ColumnsToolPanelModule = "@ag-grid-enterprise/column-tool-panel", i.FiltersToolPanelModule = "@ag-grid-enterprise/filter-tool-panel", i.MenuModule = "@ag-grid-enterprise/menu", i.SetFilterModule = "@ag-grid-enterprise/set-filter", i.MultiFilterModule = "@ag-grid-enterprise/multi-filter", i.StatusBarModule = "@ag-grid-enterprise/status-bar", i.SideBarModule = "@ag-grid-enterprise/side-bar", i.RangeSelectionModule = "@ag-grid-enterprise/range-selection", i.MasterDetailModule = "@ag-grid-enterprise/master-detail", i.RichSelectModule = "@ag-grid-enterprise/rich-select", i.GridChartsModule = "@ag-grid-enterprise/charts", i.ViewportRowModelModule = "@ag-grid-enterprise/viewport-row-model", i.ServerSideRowModelModule = "@ag-grid-enterprise/server-side-row-model", i.ExcelExportModule = "@ag-grid-enterprise/excel-export", i.ClipboardModule = "@ag-grid-enterprise/clipboard", i.SparklinesModule = "@ag-grid-enterprise/sparklines", i.AngularModule = "@ag-grid-community/angular", i.ReactModule = "@ag-grid-community/react", i.VueModule = "@ag-grid-community/vue";
})(re || (re = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var gm = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, pe = (
  /** @class */
  function() {
    function i() {
    }
    return i.register = function(t, e) {
      e === void 0 && (e = !0), i.runVersionChecks(t), i.modulesMap[t.moduleName] = t, i.setModuleBased(e);
    }, i.runVersionChecks = function(t) {
      if (i.currentModuleVersion || (i.currentModuleVersion = t.version), t.version ? t.version !== i.currentModuleVersion && console.error("AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '" + t.moduleName + "' is version " + t.version + " but the other modules are version " + this.currentModuleVersion + ". Please update all modules to the same version.") : console.error("AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '" + t.moduleName + "' is incompatible. Please update all modules to the same version."), t.validate) {
        var e = t.validate();
        if (!e.isValid) {
          var r = e;
          console.error("AG Grid: " + r.message);
        }
      }
    }, i.setModuleBased = function(t) {
      i.moduleBased === void 0 ? i.moduleBased = t : i.moduleBased !== t && Pe(function() {
        console.warn("AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms."), console.warn("Please see https://www.ag-grid.com/javascript-grid/packages-modules/ for more information.");
      }, "ModulePackageCheck");
    }, i.setIsBundled = function() {
      i.isBundled = !0;
    }, i.registerModules = function(t, e) {
      e === void 0 && (e = !0), i.setModuleBased(e), t && t.forEach(function(r) {
        return i.register(r, e);
      });
    }, i.assertRegistered = function(t, e) {
      var r;
      if (this.isRegistered(t))
        return !0;
      var o = e + t, n;
      if (i.isBundled)
        n = "AG Grid: unable to use " + e + ` as 'ag-grid-enterprise' has not been loaded. Check you are using the Enterprise bundle:
        
        <script src="https://cdn.jsdelivr.net/npm/ag-grid-enterprise@AG_GRID_VERSION/dist/ag-grid-enterprise.min.js"><\/script>
        
For more info see: https://ag-grid.com/javascript-data-grid/getting-started/#getting-started-with-ag-grid-enterprise`;
      else if (i.moduleBased || i.moduleBased === void 0) {
        var s = (r = Object.entries(re).find(function(a) {
          var l = gm(a, 2);
          l[0];
          var u = l[1];
          return u === t;
        })) === null || r === void 0 ? void 0 : r[0];
        n = "AG Grid: unable to use " + e + " as the " + s + ` is not registered. Check if you have registered the module:
           
    import { ModuleRegistry } from '@ag-grid-community/core';
    import { ` + s + " } from '" + t + `';
    
    ModuleRegistry.registerModules([ ` + s + ` ]);

For more info see: https://www.ag-grid.com/javascript-grid/modules/`;
      } else
        n = "AG Grid: unable to use " + e + ` as package 'ag-grid-enterprise' has not been imported. Check that you have imported the package:
            
    import 'ag-grid-enterprise';
            
For more info see: https://www.ag-grid.com/javascript-grid/packages/`;
      return Pe(function() {
        console.warn(n);
      }, o), !1;
    }, i.isRegistered = function(t) {
      return !!i.modulesMap[t];
    }, i.getRegisteredModules = function() {
      return Vi(i.modulesMap);
    }, i.isPackageBased = function() {
      return !i.moduleBased;
    }, i.modulesMap = {}, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var is = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, ym = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, mm = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(ym(arguments[t]));
  return i;
}, Cm = 0;
function af() {
  return Cm++;
}
var $e = (
  /** @class */
  function() {
    function i(t, e, r, o) {
      this.instanceId = af(), this.autoHeaderHeight = null, this.moving = !1, this.menuVisible = !1, this.filterActive = !1, this.eventService = new mo(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.colDef = t, this.userProvidedColDef = e, this.colId = r, this.primary = o, this.setState(t);
    }
    return i.prototype.getInstanceId = function() {
      return this.instanceId;
    }, i.prototype.setState = function(t) {
      t.sort !== void 0 ? (t.sort === "asc" || t.sort === "desc") && (this.sort = t.sort) : (t.initialSort === "asc" || t.initialSort === "desc") && (this.sort = t.initialSort);
      var e = Sr(t.sortIndex), r = Sr(t.initialSortIndex);
      e !== void 0 ? e !== null && (this.sortIndex = e) : r !== null && (this.sortIndex = r);
      var o = eo(t.hide), n = eo(t.initialHide);
      o !== void 0 ? this.visible = !o : this.visible = !n, t.pinned !== void 0 ? this.setPinned(t.pinned) : this.setPinned(t.initialPinned);
      var s = Sr(t.flex), a = Sr(t.initialFlex);
      s !== void 0 ? this.flex = s : a !== void 0 && (this.flex = a);
    }, i.prototype.setColDef = function(t, e) {
      this.colDef = t, this.userProvidedColDef = e, this.initMinAndMaxWidths(), this.initDotNotation(), this.eventService.dispatchEvent(this.createColumnEvent("colDefChanged", "api"));
    }, i.prototype.getUserProvidedColDef = function() {
      return this.userProvidedColDef;
    }, i.prototype.setParent = function(t) {
      this.parent = t;
    }, i.prototype.getParent = function() {
      return this.parent;
    }, i.prototype.setOriginalParent = function(t) {
      this.originalParent = t;
    }, i.prototype.getOriginalParent = function() {
      return this.originalParent;
    }, i.prototype.initialise = function() {
      this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip(), this.validate();
    }, i.prototype.initDotNotation = function() {
      var t = this.gridOptionsService.is("suppressFieldDotNotation");
      this.fieldContainsDots = k(this.colDef.field) && this.colDef.field.indexOf(".") >= 0 && !t, this.tooltipFieldContainsDots = k(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf(".") >= 0 && !t;
    }, i.prototype.initMinAndMaxWidths = function() {
      var t = this.colDef;
      this.minWidth = this.columnUtils.calculateColMinWidth(t), this.maxWidth = this.columnUtils.calculateColMaxWidth(t);
    }, i.prototype.initTooltip = function() {
      this.tooltipEnabled = k(this.colDef.tooltipField) || k(this.colDef.tooltipValueGetter) || k(this.colDef.tooltipComponent) || k(this.colDef.tooltipComponentFramework);
    }, i.prototype.resetActualWidth = function(t) {
      t === void 0 && (t = "api");
      var e = this.columnUtils.calculateColInitialWidth(this.colDef);
      this.setActualWidth(e, t, !0);
    }, i.prototype.isEmptyGroup = function() {
      return !1;
    }, i.prototype.isRowGroupDisplayed = function(t) {
      if (ue(this.colDef) || ue(this.colDef.showRowGroup))
        return !1;
      var e = this.colDef.showRowGroup === !0, r = this.colDef.showRowGroup === t;
      return e || r;
    }, i.prototype.isPrimary = function() {
      return this.primary;
    }, i.prototype.isFilterAllowed = function() {
      var t = !!this.colDef.filter || !!this.colDef.filterFramework;
      return t;
    }, i.prototype.isFieldContainsDots = function() {
      return this.fieldContainsDots;
    }, i.prototype.isTooltipEnabled = function() {
      return this.tooltipEnabled;
    }, i.prototype.isTooltipFieldContainsDots = function() {
      return this.tooltipFieldContainsDots;
    }, i.prototype.validate = function() {
      var t = this.colDef;
      function e(u, c, p) {
        Pe(function() {
          p ? console.warn(u, p) : Pe(function() {
            return console.warn(u);
          }, c);
        }, c);
      }
      var r = this.gridOptionsService.isRowModelType("clientSide");
      if (r && !pe.isRegistered(re.RowGroupingModule)) {
        var o = ["enableRowGroup", "rowGroup", "rowGroupIndex", "enablePivot", "enableValue", "pivot", "pivotIndex", "aggFunc"], n = o.filter(function(u) {
          return k(t[u]);
        });
        n.length > 0 && pe.assertRegistered(re.RowGroupingModule, n.map(function(u) {
          return "colDef." + u;
        }).join(", "));
      }
      if ((this.colDef.cellEditor === "agRichSelect" || this.colDef.cellEditor === "agRichSelectCellEditor") && pe.assertRegistered(re.RichSelectModule, this.colDef.cellEditor), this.gridOptionsService.isTreeData()) {
        var s = ["rowGroup", "rowGroupIndex", "pivot", "pivotIndex"], n = s.filter(function(c) {
          return k(t[c]);
        });
        n.length > 0 && e("AG Grid: " + n.join() + " is not possible when doing tree data, your column definition should not have " + n.join(), "TreeDataCannotRowGroup");
      }
      if (k(t.menuTabs))
        if (Array.isArray(t.menuTabs)) {
          var a = ["filterMenuTab"], l = ["columnsMenuTab", "generalMenuTab"], n = l.filter(function(c) {
            return t.menuTabs.includes(c);
          });
          n.length > 0 && pe.assertRegistered(re.MenuModule, "menuTab(s): " + n.map(function(c) {
            return "'" + c + "'";
          }).join()), t.menuTabs.forEach(function(c) {
            !l.includes(c) && !a.includes(c) && e("AG Grid: '" + c + "' is not valid for 'colDef.menuTabs'. Valid values are: " + mm(a, l).map(function(p) {
              return "'" + p + "'";
            }).join() + ".", "wrongValue_menuTabs_" + c);
          });
        } else
          e("AG Grid: The typeof 'colDef.menuTabs' should be an array not:" + typeof t.menuTabs, "wrongType_menuTabs");
      k(t.columnsMenuParams) && pe.assertRegistered(re.MenuModule, "columnsMenuParams"), k(t.columnsMenuParams) && pe.assertRegistered(re.ColumnsToolPanelModule, "columnsMenuParams"), k(this.colDef.width) && typeof this.colDef.width != "number" && e("AG Grid: colDef.width should be a number, not " + typeof this.colDef.width, "ColumnCheck"), (t.pinnedRowCellRenderer || t.pinnedRowCellRendererParams || t.pinnedRowCellRendererFramework) && e("AG Grid: pinnedRowCellRenderer[Params,Framework] no longer exist. Use cellRendererSelector if you want a different Cell Renderer for pinned rows. Check params.node.rowPinned.", "colDef.pinnedRowCellRenderer-deprecated"), k(t.columnGroupShow) && t.columnGroupShow !== "closed" && t.columnGroupShow !== "open" && e("AG Grid: '" + t.columnGroupShow + "' is not valid for columnGroupShow. Valid values are 'open', 'closed', undefined, null", "columnGroupShow_invalid");
    }, i.prototype.addEventListener = function(t, e) {
      this.eventService.addEventListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      this.eventService.removeEventListener(t, e);
    }, i.prototype.createColumnFunctionCallbackParams = function(t) {
      return {
        node: t,
        data: t.data,
        column: this,
        colDef: this.colDef,
        context: this.gridOptionsService.context,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi
      };
    }, i.prototype.isSuppressNavigable = function(t) {
      if (typeof this.colDef.suppressNavigable == "boolean")
        return this.colDef.suppressNavigable;
      if (typeof this.colDef.suppressNavigable == "function") {
        var e = this.createColumnFunctionCallbackParams(t), r = this.colDef.suppressNavigable;
        return r(e);
      }
      return !1;
    }, i.prototype.isCellEditable = function(t) {
      return t.group && !this.gridOptionsService.is("enableGroupEdit") ? !1 : this.isColumnFunc(t, this.colDef.editable);
    }, i.prototype.isSuppressFillHandle = function() {
      return !!eo(this.colDef.suppressFillHandle);
    }, i.prototype.isAutoHeight = function() {
      return !!eo(this.colDef.autoHeight);
    }, i.prototype.isAutoHeaderHeight = function() {
      return !!eo(this.colDef.autoHeaderHeight);
    }, i.prototype.isRowDrag = function(t) {
      return this.isColumnFunc(t, this.colDef.rowDrag);
    }, i.prototype.isDndSource = function(t) {
      return this.isColumnFunc(t, this.colDef.dndSource);
    }, i.prototype.isCellCheckboxSelection = function(t) {
      return this.isColumnFunc(t, this.colDef.checkboxSelection);
    }, i.prototype.isSuppressPaste = function(t) {
      return this.isColumnFunc(t, this.colDef ? this.colDef.suppressPaste : null);
    }, i.prototype.isResizable = function() {
      return !!eo(this.colDef.resizable);
    }, i.prototype.isColumnFunc = function(t, e) {
      if (typeof e == "boolean")
        return e;
      if (typeof e == "function") {
        var r = this.createColumnFunctionCallbackParams(t), o = e;
        return o(r);
      }
      return !1;
    }, i.prototype.setMoving = function(t, e) {
      e === void 0 && (e = "api"), this.moving = t, this.eventService.dispatchEvent(this.createColumnEvent("movingChanged", e));
    }, i.prototype.createColumnEvent = function(t, e) {
      return {
        type: t,
        column: this,
        columns: [this],
        source: e,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context
      };
    }, i.prototype.isMoving = function() {
      return this.moving;
    }, i.prototype.getSort = function() {
      return this.sort;
    }, i.prototype.setSort = function(t, e) {
      e === void 0 && (e = "api"), this.sort !== t && (this.sort = t, this.eventService.dispatchEvent(this.createColumnEvent("sortChanged", e)));
    }, i.prototype.setMenuVisible = function(t, e) {
      e === void 0 && (e = "api"), this.menuVisible !== t && (this.menuVisible = t, this.eventService.dispatchEvent(this.createColumnEvent("menuVisibleChanged", e)));
    }, i.prototype.isMenuVisible = function() {
      return this.menuVisible;
    }, i.prototype.isSortAscending = function() {
      return this.sort === "asc";
    }, i.prototype.isSortDescending = function() {
      return this.sort === "desc";
    }, i.prototype.isSortNone = function() {
      return ue(this.sort);
    }, i.prototype.isSorting = function() {
      return k(this.sort);
    }, i.prototype.getSortIndex = function() {
      return this.sortIndex;
    }, i.prototype.setSortIndex = function(t) {
      this.sortIndex = t;
    }, i.prototype.setAggFunc = function(t) {
      this.aggFunc = t;
    }, i.prototype.getAggFunc = function() {
      return this.aggFunc;
    }, i.prototype.getLeft = function() {
      return this.left;
    }, i.prototype.getOldLeft = function() {
      return this.oldLeft;
    }, i.prototype.getRight = function() {
      return this.left + this.actualWidth;
    }, i.prototype.setLeft = function(t, e) {
      e === void 0 && (e = "api"), this.oldLeft = this.left, this.left !== t && (this.left = t, this.eventService.dispatchEvent(this.createColumnEvent("leftChanged", e)));
    }, i.prototype.isFilterActive = function() {
      return this.filterActive;
    }, i.prototype.setFilterActive = function(t, e, r) {
      e === void 0 && (e = "api"), this.filterActive !== t && (this.filterActive = t, this.eventService.dispatchEvent(this.createColumnEvent("filterActiveChanged", e)));
      var o = this.createColumnEvent("filterChanged", e);
      r && ir(o, r), this.eventService.dispatchEvent(o);
    }, i.prototype.isHovered = function() {
      return this.columnHoverService.isHovered(this);
    }, i.prototype.setPinned = function(t) {
      t === !0 || t === "left" ? this.pinned = "left" : t === "right" ? this.pinned = "right" : this.pinned = null;
    }, i.prototype.setFirstRightPinned = function(t, e) {
      e === void 0 && (e = "api"), this.firstRightPinned !== t && (this.firstRightPinned = t, this.eventService.dispatchEvent(this.createColumnEvent("firstRightPinnedChanged", e)));
    }, i.prototype.setLastLeftPinned = function(t, e) {
      e === void 0 && (e = "api"), this.lastLeftPinned !== t && (this.lastLeftPinned = t, this.eventService.dispatchEvent(this.createColumnEvent("lastLeftPinnedChanged", e)));
    }, i.prototype.isFirstRightPinned = function() {
      return this.firstRightPinned;
    }, i.prototype.isLastLeftPinned = function() {
      return this.lastLeftPinned;
    }, i.prototype.isPinned = function() {
      return this.pinned === "left" || this.pinned === "right";
    }, i.prototype.isPinnedLeft = function() {
      return this.pinned === "left";
    }, i.prototype.isPinnedRight = function() {
      return this.pinned === "right";
    }, i.prototype.getPinned = function() {
      return this.pinned;
    }, i.prototype.setVisible = function(t, e) {
      e === void 0 && (e = "api");
      var r = t === !0;
      this.visible !== r && (this.visible = r, this.eventService.dispatchEvent(this.createColumnEvent("visibleChanged", e)));
    }, i.prototype.isVisible = function() {
      return this.visible;
    }, i.prototype.isSpanHeaderHeight = function() {
      return !!this.getColDef().spanHeaderHeight;
    }, i.prototype.getColDef = function() {
      return this.colDef;
    }, i.prototype.getColumnGroupShow = function() {
      return this.colDef.columnGroupShow;
    }, i.prototype.getColId = function() {
      return this.colId;
    }, i.prototype.getId = function() {
      return this.colId;
    }, i.prototype.getUniqueId = function() {
      return this.colId;
    }, i.prototype.getDefinition = function() {
      return this.colDef;
    }, i.prototype.getActualWidth = function() {
      return this.actualWidth;
    }, i.prototype.getAutoHeaderHeight = function() {
      return this.autoHeaderHeight;
    }, i.prototype.setAutoHeaderHeight = function(t) {
      var e = t !== this.autoHeaderHeight;
      return this.autoHeaderHeight = t, e;
    }, i.prototype.createBaseColDefParams = function(t) {
      var e = {
        node: t,
        data: t.data,
        colDef: this.colDef,
        column: this,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context
      };
      return e;
    }, i.prototype.getColSpan = function(t) {
      if (ue(this.colDef.colSpan))
        return 1;
      var e = this.createBaseColDefParams(t), r = this.colDef.colSpan(e);
      return Math.max(r, 1);
    }, i.prototype.getRowSpan = function(t) {
      if (ue(this.colDef.rowSpan))
        return 1;
      var e = this.createBaseColDefParams(t), r = this.colDef.rowSpan(e);
      return Math.max(r, 1);
    }, i.prototype.setActualWidth = function(t, e, r) {
      e === void 0 && (e = "api"), r === void 0 && (r = !1), this.minWidth != null && (t = Math.max(t, this.minWidth)), this.maxWidth != null && (t = Math.min(t, this.maxWidth)), this.actualWidth !== t && (this.actualWidth = t, this.flex && e !== "flex" && e !== "gridInitializing" && (this.flex = null), r || this.fireColumnWidthChangedEvent(e));
    }, i.prototype.fireColumnWidthChangedEvent = function(t) {
      this.eventService.dispatchEvent(this.createColumnEvent("widthChanged", t));
    }, i.prototype.isGreaterThanMax = function(t) {
      return this.maxWidth != null ? t > this.maxWidth : !1;
    }, i.prototype.getMinWidth = function() {
      return this.minWidth;
    }, i.prototype.getMaxWidth = function() {
      return this.maxWidth;
    }, i.prototype.getFlex = function() {
      return this.flex || 0;
    }, i.prototype.setFlex = function(t) {
      this.flex !== t && (this.flex = t);
    }, i.prototype.setMinimum = function(t) {
      t === void 0 && (t = "api"), k(this.minWidth) && this.setActualWidth(this.minWidth, t);
    }, i.prototype.setRowGroupActive = function(t, e) {
      e === void 0 && (e = "api"), this.rowGroupActive !== t && (this.rowGroupActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnRowGroupChanged", e)));
    }, i.prototype.isRowGroupActive = function() {
      return this.rowGroupActive;
    }, i.prototype.setPivotActive = function(t, e) {
      e === void 0 && (e = "api"), this.pivotActive !== t && (this.pivotActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnPivotChanged", e)));
    }, i.prototype.isPivotActive = function() {
      return this.pivotActive;
    }, i.prototype.isAnyFunctionActive = function() {
      return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }, i.prototype.isAnyFunctionAllowed = function() {
      return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }, i.prototype.setValueActive = function(t, e) {
      e === void 0 && (e = "api"), this.aggregationActive !== t && (this.aggregationActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnValueChanged", e)));
    }, i.prototype.isValueActive = function() {
      return this.aggregationActive;
    }, i.prototype.isAllowPivot = function() {
      return this.colDef.enablePivot === !0;
    }, i.prototype.isAllowValue = function() {
      return this.colDef.enableValue === !0;
    }, i.prototype.isAllowRowGroup = function() {
      return this.colDef.enableRowGroup === !0;
    }, i.prototype.getMenuTabs = function(t) {
      var e = this.getColDef().menuTabs;
      return e == null && (e = t), e;
    }, i.EVENT_MOVING_CHANGED = "movingChanged", i.EVENT_LEFT_CHANGED = "leftChanged", i.EVENT_WIDTH_CHANGED = "widthChanged", i.EVENT_LAST_LEFT_PINNED_CHANGED = "lastLeftPinnedChanged", i.EVENT_FIRST_RIGHT_PINNED_CHANGED = "firstRightPinnedChanged", i.EVENT_VISIBLE_CHANGED = "visibleChanged", i.EVENT_FILTER_CHANGED = "filterChanged", i.EVENT_FILTER_ACTIVE_CHANGED = "filterActiveChanged", i.EVENT_SORT_CHANGED = "sortChanged", i.EVENT_COL_DEF_CHANGED = "colDefChanged", i.EVENT_MENU_VISIBLE_CHANGED = "menuVisibleChanged", i.EVENT_ROW_GROUP_CHANGED = "columnRowGroupChanged", i.EVENT_PIVOT_CHANGED = "columnPivotChanged", i.EVENT_VALUE_CHANGED = "columnValueChanged", is([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), is([
      v("columnUtils")
    ], i.prototype, "columnUtils", void 0), is([
      v("columnHoverService")
    ], i.prototype, "columnHoverService", void 0), is([
      U
    ], i.prototype, "initialise", null), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var wm = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, et = (
  /** @class */
  function() {
    function i(t, e, r, o) {
      this.localEventService = new mo(), this.expandable = !1, this.instanceId = af(), this.expandableListenerRemoveCallback = null, this.colGroupDef = t, this.groupId = e, this.expanded = !!t && !!t.openByDefault, this.padding = r, this.level = o;
    }
    return i.prototype.destroy = function() {
      this.expandableListenerRemoveCallback && this.reset(null, void 0);
    }, i.prototype.reset = function(t, e) {
      this.colGroupDef = t, this.level = e, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
    }, i.prototype.getInstanceId = function() {
      return this.instanceId;
    }, i.prototype.setOriginalParent = function(t) {
      this.originalParent = t;
    }, i.prototype.getOriginalParent = function() {
      return this.originalParent;
    }, i.prototype.getLevel = function() {
      return this.level;
    }, i.prototype.isVisible = function() {
      return this.children ? this.children.some(function(t) {
        return t.isVisible();
      }) : !1;
    }, i.prototype.isPadding = function() {
      return this.padding;
    }, i.prototype.setExpanded = function(t) {
      this.expanded = t === void 0 ? !1 : t;
      var e = {
        type: i.EVENT_EXPANDED_CHANGED
      };
      this.localEventService.dispatchEvent(e);
    }, i.prototype.isExpandable = function() {
      return this.expandable;
    }, i.prototype.isExpanded = function() {
      return this.expanded;
    }, i.prototype.getGroupId = function() {
      return this.groupId;
    }, i.prototype.getId = function() {
      return this.getGroupId();
    }, i.prototype.setChildren = function(t) {
      this.children = t;
    }, i.prototype.getChildren = function() {
      return this.children;
    }, i.prototype.getColGroupDef = function() {
      return this.colGroupDef;
    }, i.prototype.getLeafColumns = function() {
      var t = [];
      return this.addLeafColumns(t), t;
    }, i.prototype.addLeafColumns = function(t) {
      this.children && this.children.forEach(function(e) {
        e instanceof $e ? t.push(e) : e instanceof i && e.addLeafColumns(t);
      });
    }, i.prototype.getColumnGroupShow = function() {
      var t = this.colGroupDef;
      if (t)
        return t.columnGroupShow;
    }, i.prototype.setupExpandable = function() {
      var t = this;
      this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
      var e = this.onColumnVisibilityChanged.bind(this);
      this.getLeafColumns().forEach(function(r) {
        return r.addEventListener("visibleChanged", e);
      }), this.expandableListenerRemoveCallback = function() {
        t.getLeafColumns().forEach(function(r) {
          return r.removeEventListener("visibleChanged", e);
        }), t.expandableListenerRemoveCallback = null;
      };
    }, i.prototype.setExpandable = function() {
      if (!this.isPadding()) {
        for (var t = !1, e = !1, r = !1, o = this.findChildrenRemovingPadding(), n = 0, s = o.length; n < s; n++) {
          var a = o[n];
          if (a.isVisible()) {
            var l = a.getColumnGroupShow();
            l === "open" ? (t = !0, r = !0) : l === "closed" ? (e = !0, r = !0) : (t = !0, e = !0);
          }
        }
        var u = t && e && r;
        if (this.expandable !== u) {
          this.expandable = u;
          var c = {
            type: i.EVENT_EXPANDABLE_CHANGED
          };
          this.localEventService.dispatchEvent(c);
        }
      }
    }, i.prototype.findChildrenRemovingPadding = function() {
      var t = [], e = function(r) {
        r.forEach(function(o) {
          var n = o instanceof i && o.isPadding();
          n ? e(o.children) : t.push(o);
        });
      };
      return e(this.children), t;
    }, i.prototype.onColumnVisibilityChanged = function() {
      this.setExpandable();
    }, i.prototype.addEventListener = function(t, e) {
      this.localEventService.addEventListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      this.localEventService.removeEventListener(t, e);
    }, i.EVENT_EXPANDED_CHANGED = "expandedChanged", i.EVENT_EXPANDABLE_CHANGED = "expandableChanged", wm([
      At
    ], i.prototype, "destroy", null), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Sm = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
};
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function lf() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i[t] = arguments[t];
  for (var e = 0; e < i.length; e++) {
    var r = i[e];
    if (k(r))
      return r;
  }
  return null;
}
function _m(i) {
  return i != null && i.length > 0;
}
function Ne(i) {
  if (!(!i || !i.length))
    return i[i.length - 1];
}
function No(i, t, e) {
  return i == null && t == null ? !0 : i != null && t != null && i.length === t.length && i.every(function(r, o) {
    return e ? e(r, t[o]) : t[o] === r;
  });
}
function Em(i, t) {
  return No(i, t);
}
function uf(i) {
  return i.sort(function(t, e) {
    return t - e;
  });
}
function Rm(i, t) {
  if (i)
    for (var e = i.length - 2; e >= 0; e--) {
      var r = i[e] === t, o = i[e + 1] === t;
      r && o && i.splice(e + 1, 1);
    }
}
function Vt(i, t) {
  var e = i.indexOf(t);
  e >= 0 && i.splice(e, 1);
}
function xu(i, t) {
  t.forEach(function(e) {
    return Vt(i, e);
  });
}
function Di(i, t, e) {
  i.splice(e, 0, t);
}
function Om(i, t, e) {
  if (!(i == null || t == null))
    for (var r = t.length - 1; r >= 0; r--) {
      var o = t[r];
      Di(i, o, e);
    }
}
function eu(i, t, e) {
  xu(i, t), t.slice().reverse().forEach(function(r) {
    return Di(i, r, e);
  });
}
function _r(i, t) {
  return i.indexOf(t) > -1;
}
function cf(i) {
  return [].concat.apply([], i);
}
function tu(i, t) {
  t == null || i == null || t.forEach(function(e) {
    return i.push(e);
  });
}
function bm(i) {
  return i.map(Du);
}
function Tm(i, t) {
  if (i != null)
    for (var e = i.length - 1; e >= 0; e--)
      t(i[e], e);
}
var Pm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstExistingValue: lf,
  existsAndNotEmpty: _m,
  last: Ne,
  areEqual: No,
  shallowCompare: Em,
  sortNumerically: uf,
  removeRepeatsFromArray: Rm,
  removeFromArray: Vt,
  removeAllFromArray: xu,
  insertIntoArray: Di,
  insertArrayIntoArray: Om,
  moveInArray: eu,
  includes: _r,
  flatten: cf,
  pushAll: tu,
  toStrings: bm,
  forEachReverse: Tm
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var pf = "__ag_Grid_Stop_Propagation", Dm = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], Za = {};
function Un(i) {
  i[pf] = !0;
}
function oo(i) {
  return i[pf] === !0;
}
var Fu = /* @__PURE__ */ function() {
  var i = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  }, t = function(e) {
    if (typeof Za[e] == "boolean")
      return Za[e];
    var r = document.createElement(i[e] || "div");
    return e = "on" + e, Za[e] = e in r;
  };
  return t;
}();
function Ys(i, t, e) {
  for (var r = t; r; ) {
    var o = i.getDomData(r, e);
    if (o)
      return o;
    r = r.parentElement;
  }
  return null;
}
function qs(i, t) {
  return !t || !i ? !1 : ff(t).indexOf(i) >= 0;
}
function df(i) {
  for (var t = [], e = i.target; e; )
    t.push(e), e = e.parentElement;
  return t;
}
function ff(i) {
  var t = i;
  return t.path ? t.path : t.composedPath ? t.composedPath() : df(t);
}
function hf(i, t, e, r) {
  var o = _r(Dm, e), n = o ? { passive: !0 } : void 0;
  i && i.addEventListener && i.addEventListener(t, e, r, n);
}
var Am = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  stopPropagationForAgGrid: Un,
  isStopPropagationForAgGrid: oo,
  isEventSupported: Fu,
  getCtrlForEventTarget: Ys,
  isElementInEventPath: qs,
  createEventPath: df,
  getEventPath: ff,
  addSafePassiveEventListener: hf
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ko = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, j = (
  /** @class */
  function() {
    function i() {
      var t = this;
      this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.isAlive = function() {
        return !t.destroyed;
      };
    }
    return i.prototype.getFrameworkOverrides = function() {
      return this.frameworkOverrides;
    }, i.prototype.getContext = function() {
      return this.context;
    }, i.prototype.destroy = function() {
      this.destroyFunctions.forEach(function(t) {
        return t();
      }), this.destroyFunctions.length = 0, this.destroyed = !0, this.dispatchEvent({ type: i.EVENT_DESTROYED });
    }, i.prototype.addEventListener = function(t, e) {
      this.localEventService || (this.localEventService = new mo()), this.localEventService.addEventListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      this.localEventService && this.localEventService.removeEventListener(t, e);
    }, i.prototype.dispatchEventAsync = function(t) {
      var e = this;
      window.setTimeout(function() {
        return e.dispatchEvent(t);
      }, 0);
    }, i.prototype.dispatchEvent = function(t) {
      this.localEventService && this.localEventService.dispatchEvent(t);
    }, i.prototype.addManagedListener = function(t, e, r) {
      var o = this;
      if (!this.destroyed) {
        t instanceof HTMLElement ? hf(this.getFrameworkOverrides(), t, e, r) : t.addEventListener(e, r);
        var n = function() {
          return t.removeEventListener(e, r), o.destroyFunctions = o.destroyFunctions.filter(function(s) {
            return s !== n;
          }), null;
        };
        return this.destroyFunctions.push(n), n;
      }
    }, i.prototype.addManagedPropertyListener = function(t, e) {
      var r = this;
      if (!this.destroyed) {
        this.gridOptionsService.addEventListener(t, e);
        var o = function() {
          return r.gridOptionsService.removeEventListener(t, e), r.destroyFunctions = r.destroyFunctions.filter(function(n) {
            return n !== o;
          }), null;
        };
        return this.destroyFunctions.push(o), o;
      }
    }, i.prototype.addDestroyFunc = function(t) {
      this.isAlive() ? this.destroyFunctions.push(t) : t();
    }, i.prototype.createManagedBean = function(t, e) {
      var r = this.createBean(t, e);
      return this.addDestroyFunc(this.destroyBean.bind(this, t, e)), r;
    }, i.prototype.createBean = function(t, e, r) {
      return (e || this.getContext()).createBean(t, r);
    }, i.prototype.destroyBean = function(t, e) {
      return (e || this.getContext()).destroyBean(t);
    }, i.prototype.destroyBeans = function(t, e) {
      var r = this;
      return t && t.forEach(function(o) {
        return r.destroyBean(o, e);
      }), [];
    }, i.EVENT_DESTROYED = "destroyed", Ko([
      v("frameworkOverrides")
    ], i.prototype, "frameworkOverrides", void 0), Ko([
      v("context")
    ], i.prototype, "context", void 0), Ko([
      v("eventService")
    ], i.prototype, "eventService", void 0), Ko([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), Ko([
      v("localeService")
    ], i.prototype, "localeService", void 0), Ko([
      v("environment")
    ], i.prototype, "environment", void 0), Ko([
      At
    ], i.prototype, "destroy", null), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var xm = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), el = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Fm = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, vf = (
  /** @class */
  function(i) {
    xm(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("ColumnFactory");
    }, t.prototype.createColumnTree = function(e, r, o) {
      var n = new Yd(), s = this.extractExistingTreeData(o), a = s.existingCols, l = s.existingGroups, u = s.existingColKeys;
      n.addExistingKeys(u);
      var c = this.recursivelyCreateColumns(e, 0, r, a, n, l), p = this.findMaxDept(c, 0);
      this.logger.log("Number of levels for grouped columns is " + p);
      var d = this.balanceColumnTree(c, 0, p, n), h = function(g, y) {
        g instanceof et && g.setupExpandable(), g.setOriginalParent(y);
      };
      return this.columnUtils.depthFirstOriginalTreeSearch(null, d, h), {
        columnTree: d,
        treeDept: p
      };
    }, t.prototype.extractExistingTreeData = function(e) {
      var r = [], o = [], n = [];
      return e && this.columnUtils.depthFirstOriginalTreeSearch(null, e, function(s) {
        if (s instanceof et) {
          var a = s;
          o.push(a);
        } else {
          var l = s;
          n.push(l.getId()), r.push(l);
        }
      }), { existingCols: r, existingGroups: o, existingColKeys: n };
    }, t.prototype.createForAutoGroups = function(e, r) {
      var o = this;
      return e.map(function(n) {
        return o.createAutoGroupTreeItem(r, n);
      });
    }, t.prototype.createAutoGroupTreeItem = function(e, r) {
      for (var o = this.findDepth(e), n = r, s = o - 1; s >= 0; s--) {
        var a = new et(null, "FAKE_PATH_" + r.getId() + "}_" + s, !0, s);
        this.createBean(a), a.setChildren([n]), n.setOriginalParent(a), n = a;
      }
      return n;
    }, t.prototype.findDepth = function(e) {
      for (var r = 0, o = e; o && o[0] && o[0] instanceof et; )
        r++, o = o[0].getChildren();
      return r;
    }, t.prototype.balanceColumnTree = function(e, r, o, n) {
      for (var s = [], a = 0; a < e.length; a++) {
        var l = e[a];
        if (l instanceof et) {
          var u = l, c = this.balanceColumnTree(u.getChildren(), r + 1, o, n);
          u.setChildren(c), s.push(u);
        } else {
          for (var p = void 0, d = void 0, h = o - 1; h >= r; h--) {
            var g = n.getUniqueKey(null, null), y = this.createMergedColGroupDef(null), S = new et(y, g, !0, r);
            this.createBean(S), d && d.setChildren([S]), d = S, p || (p = d);
          }
          if (p && d) {
            s.push(p);
            var _ = e.some(function(w) {
              return w instanceof et;
            });
            if (_) {
              d.setChildren([l]);
              continue;
            } else {
              d.setChildren(e);
              break;
            }
          }
          s.push(l);
        }
      }
      return s;
    }, t.prototype.findMaxDept = function(e, r) {
      for (var o = r, n = 0; n < e.length; n++) {
        var s = e[n];
        if (s instanceof et) {
          var a = s, l = this.findMaxDept(a.getChildren(), r + 1);
          o < l && (o = l);
        }
      }
      return o;
    }, t.prototype.recursivelyCreateColumns = function(e, r, o, n, s, a) {
      var l = this;
      return (e || []).map(function(u) {
        return l.isColumnGroup(u) ? l.createColumnGroup(o, u, r, n, s, a) : l.createColumn(o, u, n, s);
      });
    }, t.prototype.createColumnGroup = function(e, r, o, n, s, a) {
      var l = this.createMergedColGroupDef(r), u = s.getUniqueKey(l.groupId || null, null), c = new et(l, u, !1, o);
      this.createBean(c);
      var p = this.findExistingGroup(r, a);
      p && Vt(a, p), p && p.isExpanded() && c.setExpanded(!0);
      var d = this.recursivelyCreateColumns(l.children, o + 1, e, n, s, a);
      return c.setChildren(d), c;
    }, t.prototype.createMergedColGroupDef = function(e) {
      var r = {};
      return Object.assign(r, this.gridOptionsService.get("defaultColGroupDef")), Object.assign(r, e), r;
    }, t.prototype.createColumn = function(e, r, o, n) {
      var s = this.mergeColDefs(r), a = this.findExistingColumn(r, o);
      if (o && a && Vt(o, a), a)
        a.setColDef(s, r), this.applyColumnState(a, s);
      else {
        var l = n.getUniqueKey(s.colId, s.field);
        a = new $e(s, r, l, e), this.context.createBean(a);
      }
      return a;
    }, t.prototype.applyColumnState = function(e, r) {
      var o = Sr(r.flex);
      o !== void 0 && e.setFlex(o);
      var n = e.getFlex() <= 0;
      if (n) {
        var s = Sr(r.width);
        if (s != null)
          e.setActualWidth(s);
        else {
          var a = e.getActualWidth();
          e.setActualWidth(a);
        }
      }
      r.sort !== void 0 && (r.sort == "asc" || r.sort == "desc" ? e.setSort(r.sort) : e.setSort(void 0));
      var l = Sr(r.sortIndex);
      l !== void 0 && e.setSortIndex(l);
      var u = eo(r.hide);
      u !== void 0 && e.setVisible(!u), r.pinned !== void 0 && e.setPinned(r.pinned);
    }, t.prototype.findExistingColumn = function(e, r) {
      return (r || []).find(function(o) {
        var n = o.getUserProvidedColDef();
        if (!n)
          return !1;
        var s = e.colId != null, a = e.field != null;
        return s ? o.getId() === e.colId : a ? n.field === e.field : n === e;
      });
    }, t.prototype.findExistingGroup = function(e, r) {
      return r.find(function(o) {
        var n = o.getColGroupDef();
        if (!n)
          return !1;
        var s = e.groupId != null;
        return s ? o.getId() === e.groupId : !1;
      });
    }, t.prototype.mergeColDefs = function(e) {
      var r = {}, o = this.gridOptionsService.get("defaultColDef");
      ir(r, o, !1, !0);
      var n = e.type;
      n || (n = o && o.type), n && this.assignColumnTypes(n, r), ir(r, e, !1, !0);
      var s = this.gridOptionsService.get("autoGroupColumnDef"), a = this.gridOptionsService.isColumnsSortingCoupledToGroup();
      return e.rowGroup && s && a && ir(r, { sort: s.sort, initialSort: s.initialSort }, !1, !0), r;
    }, t.prototype.assignColumnTypes = function(e, r) {
      var o = [];
      if (e instanceof Array) {
        var n = e.some(function(l) {
          return typeof l != "string";
        });
        n ? console.warn("AG Grid: if colDef.type is supplied an array it should be of type 'string[]'") : o = e;
      } else if (typeof e == "string")
        o = e.split(",");
      else {
        console.warn("AG Grid: colDef.type should be of type 'string' | 'string[]'");
        return;
      }
      var s = Object.assign({}, Sm), a = this.gridOptionsService.get("columnTypes") || {};
      Ke(a, function(l, u) {
        l in s ? console.warn("AG Grid: the column type '" + l + "' is a default column type and cannot be overridden.") : s[l] = u;
      }), o.forEach(function(l) {
        var u = s[l.trim()];
        u ? ir(r, u, !1, !0) : console.warn("AG Grid: colDef.type '" + l + "' does not correspond to defined gridOptions.columnTypes");
      });
    }, t.prototype.isColumnGroup = function(e) {
      return e.children !== void 0;
    }, el([
      v("columnUtils")
    ], t.prototype, "columnUtils", void 0), el([
      Fm(0, Bt("loggerFactory"))
    ], t.prototype, "setBeans", null), t = el([
      te("columnFactory")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ru = (
  /** @class */
  function() {
    function i() {
    }
    return i.ColDefPropertyMap = {
      headerName: void 0,
      columnGroupShow: void 0,
      headerClass: void 0,
      toolPanelClass: void 0,
      headerValueGetter: void 0,
      pivotKeys: void 0,
      groupId: void 0,
      colId: void 0,
      sort: void 0,
      initialSort: void 0,
      field: void 0,
      type: void 0,
      tooltipComponent: void 0,
      tooltipField: void 0,
      headerTooltip: void 0,
      cellClass: void 0,
      showRowGroup: void 0,
      filter: void 0,
      initialAggFunc: void 0,
      defaultAggFunc: void 0,
      aggFunc: void 0,
      pinned: void 0,
      initialPinned: void 0,
      chartDataType: void 0,
      cellEditorPopupPosition: void 0,
      headerGroupComponent: void 0,
      headerGroupComponentFramework: void 0,
      headerGroupComponentParams: void 0,
      cellStyle: void 0,
      cellRenderer: void 0,
      cellRendererParams: void 0,
      cellRendererFramework: void 0,
      cellEditor: void 0,
      cellEditorFramework: void 0,
      cellEditorParams: void 0,
      filterFramework: void 0,
      filterParams: void 0,
      pivotValueColumn: void 0,
      headerComponent: void 0,
      headerComponentFramework: void 0,
      headerComponentParams: void 0,
      floatingFilterComponent: void 0,
      floatingFilterComponentParams: void 0,
      floatingFilterComponentFramework: void 0,
      tooltipComponentParams: void 0,
      tooltipComponentFramework: void 0,
      refData: void 0,
      columnsMenuParams: void 0,
      children: void 0,
      sortingOrder: void 0,
      allowedAggFuncs: void 0,
      menuTabs: void 0,
      pivotTotalColumnIds: void 0,
      cellClassRules: void 0,
      icons: void 0,
      sortIndex: void 0,
      initialSortIndex: void 0,
      flex: void 0,
      initialFlex: void 0,
      width: void 0,
      initialWidth: void 0,
      minWidth: void 0,
      maxWidth: void 0,
      rowGroupIndex: void 0,
      initialRowGroupIndex: void 0,
      pivotIndex: void 0,
      initialPivotIndex: void 0,
      suppressCellFlash: void 0,
      suppressColumnsToolPanel: void 0,
      suppressFiltersToolPanel: void 0,
      openByDefault: void 0,
      marryChildren: void 0,
      stickyLabel: void 0,
      hide: void 0,
      initialHide: void 0,
      rowGroup: void 0,
      initialRowGroup: void 0,
      pivot: void 0,
      initialPivot: void 0,
      checkboxSelection: void 0,
      showDisabledCheckboxes: void 0,
      headerCheckboxSelection: void 0,
      headerCheckboxSelectionFilteredOnly: void 0,
      headerCheckboxSelectionCurrentPageOnly: void 0,
      suppressMenu: void 0,
      suppressMovable: void 0,
      lockPosition: void 0,
      lockVisible: void 0,
      lockPinned: void 0,
      unSortIcon: void 0,
      suppressSizeToFit: void 0,
      suppressAutoSize: void 0,
      enableRowGroup: void 0,
      enablePivot: void 0,
      enableValue: void 0,
      editable: void 0,
      suppressPaste: void 0,
      suppressNavigable: void 0,
      enableCellChangeFlash: void 0,
      rowDrag: void 0,
      dndSource: void 0,
      autoHeight: void 0,
      wrapText: void 0,
      sortable: void 0,
      resizable: void 0,
      singleClickEdit: void 0,
      floatingFilter: void 0,
      cellEditorPopup: void 0,
      suppressFillHandle: void 0,
      wrapHeaderText: void 0,
      autoHeaderHeight: void 0,
      dndSourceOnRowDrag: void 0,
      valueGetter: void 0,
      valueSetter: void 0,
      filterValueGetter: void 0,
      keyCreator: void 0,
      valueFormatter: void 0,
      valueParser: void 0,
      comparator: void 0,
      equals: void 0,
      pivotComparator: void 0,
      suppressKeyboardEvent: void 0,
      suppressHeaderKeyboardEvent: void 0,
      colSpan: void 0,
      rowSpan: void 0,
      getQuickFilterText: void 0,
      onCellValueChanged: void 0,
      onCellClicked: void 0,
      onCellDoubleClicked: void 0,
      onCellContextMenu: void 0,
      rowDragText: void 0,
      tooltipValueGetter: void 0,
      cellRendererSelector: void 0,
      cellEditorSelector: void 0,
      spanHeaderHeight: void 0
    }, i.ALL_PROPERTIES = Object.keys(i.ColDefPropertyMap), i.FRAMEWORK_PROPERTIES = [
      "__ob__",
      "__v_skip",
      "__metadata__",
      "mappedColumnProperties",
      "hasChildColumns",
      "toColDef",
      "createColDefFromGridColumn"
    ], i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var m = (
  /** @class */
  function() {
    function i() {
    }
    return i.EVENT_COLUMN_EVERYTHING_CHANGED = "columnEverythingChanged", i.EVENT_NEW_COLUMNS_LOADED = "newColumnsLoaded", i.EVENT_COLUMN_PIVOT_MODE_CHANGED = "columnPivotModeChanged", i.EVENT_COLUMN_ROW_GROUP_CHANGED = "columnRowGroupChanged", i.EVENT_EXPAND_COLLAPSE_ALL = "expandOrCollapseAll", i.EVENT_COLUMN_PIVOT_CHANGED = "columnPivotChanged", i.EVENT_GRID_COLUMNS_CHANGED = "gridColumnsChanged", i.EVENT_COLUMN_VALUE_CHANGED = "columnValueChanged", i.EVENT_COLUMN_MOVED = "columnMoved", i.EVENT_COLUMN_VISIBLE = "columnVisible", i.EVENT_COLUMN_PINNED = "columnPinned", i.EVENT_COLUMN_GROUP_OPENED = "columnGroupOpened", i.EVENT_COLUMN_RESIZED = "columnResized", i.EVENT_DISPLAYED_COLUMNS_CHANGED = "displayedColumnsChanged", i.EVENT_VIRTUAL_COLUMNS_CHANGED = "virtualColumnsChanged", i.EVENT_ASYNC_TRANSACTIONS_FLUSHED = "asyncTransactionsFlushed", i.EVENT_ROW_GROUP_OPENED = "rowGroupOpened", i.EVENT_ROW_DATA_CHANGED = "rowDataChanged", i.EVENT_ROW_DATA_UPDATED = "rowDataUpdated", i.EVENT_PINNED_ROW_DATA_CHANGED = "pinnedRowDataChanged", i.EVENT_RANGE_SELECTION_CHANGED = "rangeSelectionChanged", i.EVENT_CHART_CREATED = "chartCreated", i.EVENT_CHART_RANGE_SELECTION_CHANGED = "chartRangeSelectionChanged", i.EVENT_CHART_OPTIONS_CHANGED = "chartOptionsChanged", i.EVENT_CHART_DESTROYED = "chartDestroyed", i.EVENT_TOOL_PANEL_VISIBLE_CHANGED = "toolPanelVisibleChanged", i.EVENT_TOOL_PANEL_SIZE_CHANGED = "toolPanelSizeChanged", i.EVENT_INTERNAL_TOOL_PANEL_VISIBLE_CHANGED = "internalToolPanelVisibleChanged", i.EVENT_COLUMN_PANEL_ITEM_DRAG_START = "columnPanelItemDragStart", i.EVENT_COLUMN_PANEL_ITEM_DRAG_END = "columnPanelItemDragEnd", i.EVENT_MODEL_UPDATED = "modelUpdated", i.EVENT_PASTE_START = "pasteStart", i.EVENT_PASTE_END = "pasteEnd", i.EVENT_FILL_START = "fillStart", i.EVENT_FILL_END = "fillEnd", i.EVENT_UNDO_STARTED = "undoStarted", i.EVENT_UNDO_ENDED = "undoEnded", i.EVENT_REDO_STARTED = "redoStarted", i.EVENT_REDO_ENDED = "redoEnded", i.EVENT_KEY_SHORTCUT_CHANGED_CELL_START = "keyShortcutChangedCellStart", i.EVENT_KEY_SHORTCUT_CHANGED_CELL_END = "keyShortcutChangedCellEnd", i.EVENT_CELL_CLICKED = "cellClicked", i.EVENT_CELL_DOUBLE_CLICKED = "cellDoubleClicked", i.EVENT_CELL_MOUSE_DOWN = "cellMouseDown", i.EVENT_CELL_CONTEXT_MENU = "cellContextMenu", i.EVENT_CELL_VALUE_CHANGED = "cellValueChanged", i.EVENT_CELL_EDIT_REQUEST = "cellEditRequest", i.EVENT_ROW_VALUE_CHANGED = "rowValueChanged", i.EVENT_CELL_FOCUSED = "cellFocused", i.EVENT_CELL_FOCUS_CLEARED = "cellFocusCleared", i.EVENT_FULL_WIDTH_ROW_FOCUSED = "fullWidthRowFocused", i.EVENT_ROW_SELECTED = "rowSelected", i.EVENT_SELECTION_CHANGED = "selectionChanged", i.EVENT_CELL_KEY_DOWN = "cellKeyDown", i.EVENT_CELL_KEY_PRESS = "cellKeyPress", i.EVENT_CELL_MOUSE_OVER = "cellMouseOver", i.EVENT_CELL_MOUSE_OUT = "cellMouseOut", i.EVENT_FILTER_CHANGED = "filterChanged", i.EVENT_FILTER_MODIFIED = "filterModified", i.EVENT_FILTER_OPENED = "filterOpened", i.EVENT_SORT_CHANGED = "sortChanged", i.EVENT_VIRTUAL_ROW_REMOVED = "virtualRowRemoved", i.EVENT_ROW_CLICKED = "rowClicked", i.EVENT_ROW_DOUBLE_CLICKED = "rowDoubleClicked", i.EVENT_GRID_READY = "gridReady", i.EVENT_GRID_SIZE_CHANGED = "gridSizeChanged", i.EVENT_VIEWPORT_CHANGED = "viewportChanged", i.EVENT_SCROLLBAR_WIDTH_CHANGED = "scrollbarWidthChanged", i.EVENT_FIRST_DATA_RENDERED = "firstDataRendered", i.EVENT_DRAG_STARTED = "dragStarted", i.EVENT_DRAG_STOPPED = "dragStopped", i.EVENT_CHECKBOX_CHANGED = "checkboxChanged", i.EVENT_ROW_EDITING_STARTED = "rowEditingStarted", i.EVENT_ROW_EDITING_STOPPED = "rowEditingStopped", i.EVENT_CELL_EDITING_STARTED = "cellEditingStarted", i.EVENT_CELL_EDITING_STOPPED = "cellEditingStopped", i.EVENT_BODY_SCROLL = "bodyScroll", i.EVENT_BODY_SCROLL_END = "bodyScrollEnd", i.EVENT_HEIGHT_SCALE_CHANGED = "heightScaleChanged", i.EVENT_PAGINATION_CHANGED = "paginationChanged", i.EVENT_COMPONENT_STATE_CHANGED = "componentStateChanged", i.EVENT_STORE_REFRESHED = "storeRefreshed", i.EVENT_BODY_HEIGHT_CHANGED = "bodyHeightChanged", i.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = "displayedColumnsWidthChanged", i.EVENT_SCROLL_VISIBILITY_CHANGED = "scrollVisibilityChanged", i.EVENT_COLUMN_HOVER_CHANGED = "columnHoverChanged", i.EVENT_FLASH_CELLS = "flashCells", i.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = "paginationPixelOffsetChanged", i.EVENT_DISPLAYED_ROWS_CHANGED = "displayedRowsChanged", i.EVENT_LEFT_PINNED_WIDTH_CHANGED = "leftPinnedWidthChanged", i.EVENT_RIGHT_PINNED_WIDTH_CHANGED = "rightPinnedWidthChanged", i.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = "rowContainerHeightChanged", i.EVENT_HEADER_HEIGHT_CHANGED = "headerHeightChanged", i.EVENT_COLUMN_HEADER_HEIGHT_CHANGED = "columnHeaderHeightChanged", i.EVENT_ROW_DRAG_ENTER = "rowDragEnter", i.EVENT_ROW_DRAG_MOVE = "rowDragMove", i.EVENT_ROW_DRAG_LEAVE = "rowDragLeave", i.EVENT_ROW_DRAG_END = "rowDragEnd", i.EVENT_GRID_STYLES_CHANGED = "gridStylesChanged", i.EVENT_POPUP_TO_FRONT = "popupToFront", i.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = "columnRowGroupChangeRequest", i.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = "columnPivotChangeRequest", i.EVENT_COLUMN_VALUE_CHANGE_REQUEST = "columnValueChangeRequest", i.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = "columnAggFuncChangeRequest", i.EVENT_KEYBOARD_FOCUS = "keyboardFocus", i.EVENT_MOUSE_FOCUS = "mouseFocus", i.EVENT_STORE_UPDATED = "storeUpdated", i.EVENT_FILTER_DESTROYED = "filterDestroyed", i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Mm = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, Ip = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(Mm(arguments[t]));
  return i;
}, Nr = (
  /** @class */
  function() {
    function i() {
    }
    return i.STRING_PROPERTIES = [
      "rowSelection",
      "overlayLoadingTemplate",
      "overlayNoRowsTemplate",
      "quickFilterText",
      "rowModelType",
      "editType",
      "domLayout",
      "clipboardDelimiter",
      "rowGroupPanelShow",
      "multiSortKey",
      "pivotColumnGroupTotals",
      "pivotRowTotals",
      "pivotPanelShow",
      "fillHandleDirection",
      "serverSideStoreType",
      "groupDisplayType",
      "treeDataDisplayType",
      "colResizeDefault"
    ], i.OBJECT_PROPERTIES = [
      "components",
      "frameworkComponents",
      "rowStyle",
      "context",
      "autoGroupColumnDef",
      "localeText",
      "icons",
      "datasource",
      "serverSideDatasource",
      "viewportDatasource",
      "groupRowRendererParams",
      "aggFuncs",
      "fullWidthCellRendererParams",
      "defaultColGroupDef",
      "defaultColDef",
      "defaultCsvExportParams",
      "defaultExcelExportParams",
      "columnTypes",
      "rowClassRules",
      "detailCellRendererParams",
      "loadingCellRendererParams",
      "loadingOverlayComponentParams",
      "noRowsOverlayComponentParams",
      "popupParent",
      "statusBar",
      "sideBar",
      "chartThemeOverrides",
      "customChartThemes",
      "chartToolPanelsDef"
    ], i.ARRAY_PROPERTIES = [
      "sortingOrder",
      "alignedGrids",
      "rowData",
      "columnDefs",
      "excelStyles",
      "pinnedTopRowData",
      "pinnedBottomRowData",
      "chartThemes",
      "rowClass"
    ], i.NUMBER_PROPERTIES = [
      "rowHeight",
      "detailRowHeight",
      "rowBuffer",
      "headerHeight",
      "groupHeaderHeight",
      "floatingFiltersHeight",
      "pivotHeaderHeight",
      "pivotGroupHeaderHeight",
      "groupDefaultExpanded",
      "viewportRowModelPageSize",
      "viewportRowModelBufferSize",
      "autoSizePadding",
      "maxBlocksInCache",
      "maxConcurrentDatasourceRequests",
      "tooltipShowDelay",
      "tooltipHideDelay",
      "cacheOverflowSize",
      "paginationPageSize",
      "cacheBlockSize",
      "infiniteInitialRowCount",
      "serverSideInitialRowCount",
      "scrollbarWidth",
      "asyncTransactionWaitMillis",
      "blockLoadDebounceMillis",
      "keepDetailRowsCount",
      "undoRedoCellEditingLimit",
      "cellFlashDelay",
      "cellFadeDelay",
      "tabIndex"
    ], i.BOOLEAN_PROPERTIES = [
      "suppressMakeColumnVisibleAfterUnGroup",
      "suppressRowClickSelection",
      "suppressCellSelection",
      "suppressCellFocus",
      "suppressHorizontalScroll",
      "alwaysShowHorizontalScroll",
      "alwaysShowVerticalScroll",
      "debug",
      "enableBrowserTooltips",
      "enableCellExpressions",
      "groupSelectsChildren",
      "groupIncludeFooter",
      "groupIncludeTotalFooter",
      "groupSuppressBlankHeader",
      "suppressMenuHide",
      "suppressRowDeselection",
      "unSortIcon",
      "suppressMultiSort",
      "alwaysMultiSort",
      "singleClickEdit",
      "suppressLoadingOverlay",
      "suppressNoRowsOverlay",
      "suppressAutoSize",
      "skipHeaderOnAutoSize",
      "suppressParentsInRowNodes",
      "suppressColumnMoveAnimation",
      "suppressMovableColumns",
      "suppressFieldDotNotation",
      "enableRangeSelection",
      "enableRangeHandle",
      "enableFillHandle",
      "suppressClearOnFillReduction",
      "deltaSort",
      "suppressTouch",
      "suppressAsyncEvents",
      "allowContextMenuWithControlKey",
      "suppressContextMenu",
      "rememberGroupStateWhenNewData",
      "enableCellChangeFlash",
      "suppressDragLeaveHidesColumns",
      "suppressRowGroupHidesColumns",
      "suppressMiddleClickScrolls",
      "suppressPreventDefaultOnMouseWheel",
      "suppressCopyRowsToClipboard",
      "copyHeadersToClipboard",
      "copyGroupHeadersToClipboard",
      "pivotMode",
      "suppressAggFuncInHeader",
      "suppressColumnVirtualisation",
      "suppressAggAtRootLevel",
      "suppressFocusAfterRefresh",
      "functionsPassive",
      "functionsReadOnly",
      "animateRows",
      "groupSelectsFiltered",
      "groupRemoveSingleChildren",
      "groupRemoveLowestSingleChildren",
      "enableRtl",
      "suppressClickEdit",
      "rowDragEntireRow",
      "rowDragManaged",
      "suppressRowDrag",
      "suppressMoveWhenRowDragging",
      "rowDragMultiRow",
      "enableGroupEdit",
      "embedFullWidthRows",
      "suppressPaginationPanel",
      "groupHideOpenParents",
      "groupAllowUnbalanced",
      "pagination",
      "paginationAutoPageSize",
      "suppressScrollOnNewData",
      "suppressScrollWhenPopupsAreOpen",
      "purgeClosedRowNodes",
      "cacheQuickFilter",
      "excludeHiddenColumnsFromQuickFilter",
      "ensureDomOrder",
      "accentedSort",
      "suppressChangeDetection",
      "valueCache",
      "valueCacheNeverExpires",
      "aggregateOnlyChangedColumns",
      "suppressAnimationFrame",
      "suppressExcelExport",
      "suppressCsvExport",
      "treeData",
      "masterDetail",
      "suppressMultiRangeSelection",
      "enterMovesDownAfterEdit",
      "enterMovesDown",
      "suppressPropertyNamesCheck",
      "rowMultiSelectWithClick",
      "suppressRowHoverHighlight",
      "suppressRowTransform",
      "suppressClipboardPaste",
      "suppressLastEmptyLineOnPaste",
      "enableCharts",
      "enableChartToolPanelsButton",
      "suppressChartToolPanelsButton",
      "suppressMaintainUnsortedOrder",
      "enableCellTextSelection",
      "suppressBrowserResizeObserver",
      "suppressMaxRenderedRowRestriction",
      "excludeChildrenWhenTreeDataFiltering",
      "tooltipMouseTrack",
      "keepDetailRows",
      "paginateChildRows",
      "preventDefaultOnContextMenu",
      "undoRedoCellEditing",
      "allowDragFromColumnsToolPanel",
      "immutableData",
      "pivotSuppressAutoColumn",
      "suppressExpandablePivotGroups",
      "debounceVerticalScrollbar",
      "detailRowAutoHeight",
      "serverSideFilteringAlwaysResets",
      "serverSideSortingAlwaysResets",
      "serverSideSortAllLevels",
      "serverSideFilterAllLevels",
      "serverSideSortOnServer",
      "serverSideFilterOnServer",
      "suppressAggFilteredOnly",
      "showOpenedGroup",
      "suppressClipboardApi",
      "suppressModelUpdateAfterUpdateTransaction",
      "stopEditingWhenCellsLoseFocus",
      "maintainColumnOrder",
      "groupMaintainOrder",
      "columnHoverHighlight",
      "reactUi",
      "suppressReactUi",
      "readOnlyEdit",
      "suppressRowVirtualisation",
      "enableCellEditingOnBackspace",
      "resetRowDataOnUpdate",
      "removePivotHeaderRowWhenSingleValueColumn",
      "suppressCopySingleCellRanges",
      "groupRowsSticky",
      "suppressServerSideInfiniteScroll",
      "rowGroupPanelSuppressSort",
      "allowShowChangeAfterFilter",
      "suppressCutToClipboard"
    ], i.FUNCTIONAL_PROPERTIES = [
      "localeTextFunc",
      "doesExternalFilterPass",
      "groupRowAggNodes",
      "isFullWidthCell",
      "processSecondaryColDef",
      "processSecondaryColGroupDef",
      "processPivotResultColDef",
      "processPivotResultColGroupDef",
      "getBusinessKeyForNode",
      "isRowSelectable",
      "postSort",
      "defaultGroupOrderComparator",
      "rowDragText",
      "groupRowRenderer",
      "groupRowRendererFramework",
      "fullWidthCellRenderer",
      "fullWidthCellRendererFramework",
      "loadingCellRenderer",
      "loadingCellRendererFramework",
      "loadingOverlayComponent",
      "loadingOverlayComponentFramework",
      "noRowsOverlayComponent",
      "noRowsOverlayComponentFramework",
      "detailCellRenderer",
      "detailCellRendererFramework"
    ], i.CALLBACK_PROPERTIES = [
      "getLocaleText",
      "isExternalFilterPresent",
      "getRowHeight",
      "getRowClass",
      "getRowStyle",
      "getContextMenuItems",
      "getMainMenuItems",
      "processRowPostCreate",
      "processCellForClipboard",
      "getGroupRowAgg",
      "getRowNodeId",
      "isFullWidthRow",
      "sendToClipboard",
      "navigateToNextHeader",
      "tabToNextHeader",
      "navigateToNextCell",
      "tabToNextCell",
      "processCellFromClipboard",
      "getDocument",
      "postProcessPopup",
      "getChildCount",
      "getDataPath",
      "isRowMaster",
      "postSortRows",
      "processHeaderForClipboard",
      "processGroupHeaderForClipboard",
      "paginationNumberFormatter",
      "processDataFromClipboard",
      "getServerSideGroupKey",
      "isServerSideGroup",
      "createChartContainer",
      "getChartToolbarItems",
      "fillOperation",
      "isApplyServerSideTransaction",
      "getServerSideStoreParams",
      "getServerSideGroupLevelParams",
      "isServerSideGroupOpenByDefault",
      "isGroupOpenByDefault",
      "initialGroupOrderComparator",
      "loadingCellRendererSelector",
      "getRowId",
      "groupAggFiltering"
    ], i.FUNCTION_PROPERTIES = Ip(i.FUNCTIONAL_PROPERTIES, i.CALLBACK_PROPERTIES), i.ALL_PROPERTIES = Ip(i.ARRAY_PROPERTIES, i.OBJECT_PROPERTIES, i.STRING_PROPERTIES, i.NUMBER_PROPERTIES, i.FUNCTION_PROPERTIES, i.BOOLEAN_PROPERTIES), i.FRAMEWORK_PROPERTIES = [
      "__ob__",
      "__v_skip",
      "__metadata__",
      "mappedColumnProperties",
      "hasChildColumns",
      "toColDef",
      "createColDefFromGridColumn"
    ], i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ou = function() {
  return ou = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ou.apply(this, arguments);
}, Im = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, Lm = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(Im(arguments[t]));
  return i;
}, Oi = (
  /** @class */
  function() {
    function i() {
    }
    return i.getCallbackForEvent = function(t) {
      return !t || t.length < 2 ? t : "on" + t[0].toUpperCase() + t.substr(1);
    }, i.getCoercionLookup = function() {
      var t = {};
      return Lm(i.ARRAY_PROPERTIES, i.OBJECT_PROPERTIES, i.STRING_PROPERTIES, i.FUNCTION_PROPERTIES, i.EVENT_CALLBACKS).forEach(function(e) {
        return t[e] = "none";
      }), i.BOOLEAN_PROPERTIES.forEach(function(e) {
        return t[e] = "boolean";
      }), i.NUMBER_PROPERTIES.forEach(function(e) {
        return t[e] = "number";
      }), t;
    }, i.getValue = function(t, e) {
      var r = i.coercionLookup[t];
      if (r) {
        var o = e;
        switch (r) {
          case "number": {
            o = i.toNumber(e);
            break;
          }
          case "boolean": {
            o = i.toBoolean(e);
            break;
          }
          case "none": {
            t === "groupAggFiltering" && typeof e != "function" && (o = i.toBoolean(e));
            break;
          }
        }
        return o;
      }
    }, i.getGridOptionKeys = function(t, e) {
      return Object.keys(e ? i.coercionLookup : t);
    }, i.copyAttributesToGridOptions = function(t, e, r) {
      r === void 0 && (r = !1), typeof t != "object" && (t = {});
      var o = t, n = i.getGridOptionKeys(e, r);
      return n.forEach(function(s) {
        var a = e[s];
        if (typeof a < "u") {
          var l = i.getValue(s, a);
          l !== void 0 && (o[s] = l);
        }
      }), t;
    }, i.processOnChange = function(t, e) {
      if (!(!t || Object.keys(t).length === 0)) {
        var r = ou({}, t);
        r.columnTypes && (e.setColumnTypes(r.columnTypes.currentValue, "gridOptionsChanged"), delete r.columnTypes), r.autoGroupColumnDef && (e.setAutoGroupColumnDef(r.autoGroupColumnDef.currentValue, "gridOptionsChanged"), delete r.autoGroupColumnDef), r.defaultColDef && (e.setDefaultColDef(r.defaultColDef.currentValue, "gridOptionsChanged"), delete r.defaultColDef), r.columnDefs && (e.setColumnDefs(r.columnDefs.currentValue, "gridOptionsChanged"), delete r.columnDefs), Object.keys(r).forEach(function(n) {
          var s = n, a = i.getValue(s, r[s].currentValue);
          e.__setProperty(s, a);
        });
        var o = {
          type: m.EVENT_COMPONENT_STATE_CHANGED
        };
        Ke(t, function(n, s) {
          o[n] = s;
        }), e.dispatchEvent(o);
      }
    }, i.toBoolean = function(t) {
      return typeof t == "boolean" ? t : typeof t == "string" ? t.toUpperCase() === "TRUE" || t == "" : !1;
    }, i.toNumber = function(t) {
      if (typeof t == "number")
        return t;
      if (typeof t == "string")
        return Number(t);
    }, i.EVENTS = Vi(m), i.EXCLUDED_INTERNAL_EVENTS = [
      m.EVENT_SCROLLBAR_WIDTH_CHANGED,
      m.EVENT_CHECKBOX_CHANGED,
      m.EVENT_HEIGHT_SCALE_CHANGED,
      m.EVENT_BODY_HEIGHT_CHANGED,
      m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
      m.EVENT_SCROLL_VISIBILITY_CHANGED,
      m.EVENT_COLUMN_HOVER_CHANGED,
      m.EVENT_FLASH_CELLS,
      m.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED,
      m.EVENT_DISPLAYED_ROWS_CHANGED,
      m.EVENT_LEFT_PINNED_WIDTH_CHANGED,
      m.EVENT_RIGHT_PINNED_WIDTH_CHANGED,
      m.EVENT_ROW_CONTAINER_HEIGHT_CHANGED,
      m.EVENT_POPUP_TO_FRONT,
      m.EVENT_KEYBOARD_FOCUS,
      m.EVENT_MOUSE_FOCUS,
      m.EVENT_STORE_UPDATED,
      m.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
      m.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
      m.EVENT_FILL_START,
      m.EVENT_FILL_END,
      m.EVENT_KEY_SHORTCUT_CHANGED_CELL_START,
      m.EVENT_KEY_SHORTCUT_CHANGED_CELL_END,
      m.EVENT_FULL_WIDTH_ROW_FOCUSED,
      m.EVENT_HEADER_HEIGHT_CHANGED,
      m.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
      m.EVENT_INTERNAL_TOOL_PANEL_VISIBLE_CHANGED,
      m.EVENT_CELL_FOCUS_CLEARED,
      m.EVENT_GRID_STYLES_CHANGED,
      m.EVENT_FILTER_DESTROYED
    ], i.PUBLIC_EVENTS = i.EVENTS.filter(function(t) {
      return !_r(i.EXCLUDED_INTERNAL_EVENTS, t);
    }), i.EVENT_CALLBACKS = i.EVENTS.map(function(t) {
      return i.getCallbackForEvent(t);
    }), i.STRING_PROPERTIES = Nr.STRING_PROPERTIES, i.OBJECT_PROPERTIES = Nr.OBJECT_PROPERTIES, i.ARRAY_PROPERTIES = Nr.ARRAY_PROPERTIES, i.NUMBER_PROPERTIES = Nr.NUMBER_PROPERTIES, i.BOOLEAN_PROPERTIES = Nr.BOOLEAN_PROPERTIES, i.FUNCTION_PROPERTIES = Nr.FUNCTION_PROPERTIES, i.ALL_PROPERTIES = Nr.ALL_PROPERTIES, i.ALL_PROPERTIES_SET = new Set(Nr.ALL_PROPERTIES), i.coercionLookup = i.getCoercionLookup(), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function gf(i, t, e) {
  var r = {}, o = i.filter(function(n) {
    return !t.some(function(s) {
      return s === n;
    });
  });
  return o.length > 0 && o.forEach(function(n) {
    return r[n] = Mu(n, e);
  }), r;
}
function Mu(i, t, e, r) {
  var o = t.map(function(a) {
    return {
      value: a,
      relevance: Nm(i.toLowerCase(), a.toLocaleLowerCase())
    };
  });
  if (o.sort(function(a, l) {
    return l.relevance - a.relevance;
  }), e && (o = o.filter(function(a) {
    return a.relevance !== 0;
  })), r && r > 0) {
    var n = o[0].relevance, s = n * r;
    o = o.filter(function(a) {
      return s - a.relevance < 0;
    });
  }
  return o.map(function(a) {
    return a.value;
  });
}
function Nm(i, t) {
  for (var e = i.replace(/\s/g, ""), r = t.replace(/\s/g, ""), o = 0, n = -1, s = 0; s < e.length; s++) {
    var a = r.indexOf(e[s], n + 1);
    a !== -1 && (n = a, o += 100 - n * 100 / 1e4 * 100);
  }
  return o;
}
var Gm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fuzzyCheckStrings: gf,
  fuzzySuggestions: Mu
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ss = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, yf = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, tl = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(yf(arguments[t]));
  return i;
};
function bt(i, t, e, r) {
  var o = e ? "Please use '" + e + "' instead. " : "";
  Pe(function() {
    return console.warn("AG Grid: since v" + i + ", '" + t + "' is deprecated. " + o + (r ?? ""));
  }, "Deprecated_" + t);
}
var Hm = (
  /** @class */
  function() {
    function i() {
      this.deprecatedProperties = {
        serverSideInfiniteScroll: { version: "29", message: "Infinite Scrolling is now the default behaviour. This can be suppressed with `suppressServerSideInfiniteScroll`." },
        rememberGroupStateWhenNewData: { version: "24", message: "Now that transaction updates are possible and they keep group state, this feature is no longer needed." },
        suppressEnterpriseResetOnNewColumns: { version: "25", message: "Now that it is possible to dynamically change columns in the grid, this is no longer needed." },
        suppressColumnStateEvents: { version: "25", message: 'Events should be ignored based on the `event.source`, which will be "api" if the event was due to setting column state via the API.' },
        defaultExportParams: { version: "25.2", message: "The property `defaultExportParams` has been replaced by `defaultCsvExportParams` and `defaultExcelExportParams`" },
        stopEditingWhenGridLosesFocus: { version: "25.2.2", newProp: "stopEditingWhenCellsLoseFocus", copyToNewProp: !0 },
        applyColumnDefOrder: { version: "26", message: "The property `applyColumnDefOrder` is no longer needed, as this is the default behaviour. To turn this behaviour off, set maintainColumnOrder=true" },
        groupMultiAutoColumn: { version: "26", newProp: "groupDisplayType", copyToNewProp: !0, newPropValue: "multipleColumns" },
        groupUseEntireRow: { version: "26", newProp: "groupDisplayType", copyToNewProp: !0, newPropValue: "groupRows" },
        defaultGroupSortComparator: { version: "26", newProp: "initialGroupOrderComparator" },
        enableMultiRowDragging: { version: "26.1", newProp: "rowDragMultiRow", copyToNewProp: !0 },
        colWidth: { version: "26.1", newProp: "defaultColDef.width" },
        minColWidth: { version: "26.1", newProp: "defaultColDef.minWidth" },
        maxColWidth: { version: "26.1", newProp: "defaultColDef.maxWidth" },
        reactUi: { version: "26.1", message: "React UI is on by default, so no need for reactUi=true. To turn it off, set suppressReactUi=true." },
        suppressCellSelection: { version: "27", newProp: "suppressCellFocus", copyToNewProp: !0 },
        clipboardDeliminator: { version: "27.1", newProp: "clipboardDelimiter", copyToNewProp: !0 },
        getRowNodeId: { version: "27.1", newProp: "getRowId", message: "The difference: if getRowId() is implemented then immutable data is enabled by default." },
        defaultGroupOrderComparator: { version: "27.2", newProp: "initialGroupOrderComparator" },
        groupRowAggNodes: { version: "27.2", newProp: "getGroupRowAgg" },
        postSort: { version: "27.2", newProp: "postSortRows" },
        isFullWidthCell: { version: "27.2", newProp: "isFullWidthRow" },
        localeTextFunc: { version: "27.2", newProp: "getLocaleText" },
        serverSideFilteringAlwaysResets: { version: "28.0", newProp: "serverSideFilterAllLevels", copyToNewProp: !0 },
        serverSideSortingAlwaysResets: { version: "28.0", newProp: "serverSideSortAllLevels", copyToNewProp: !0 },
        suppressReactUi: { version: "28", message: "The legacy React rendering engine is deprecated and will be removed in the next major version of the grid." },
        processSecondaryColDef: { version: "28", newProp: "processPivotResultColDef", copyToNewProp: !0 },
        processSecondaryColGroupDef: { version: "28", newProp: "processPivotResultColGroupDef", copyToNewProp: !0 },
        getServerSideStoreParams: { version: "28", newProp: "getServerSideGroupLevelParams", copyToNewProp: !0 },
        enableChartToolPanelsButton: { version: "29", message: "The Chart Tool Panels button is now enabled by default. To hide the Chart Tool Panels button and display the hamburger button instead, set suppressChartToolPanelsButton=true." },
        functionsPassive: { version: "29.2" },
        onColumnRowGroupChangeRequest: { version: "29.2" },
        onColumnPivotChangeRequest: { version: "29.2" },
        onColumnValueChangeRequest: { version: "29.2" },
        onColumnAggFuncChangeRequest: { version: "29.2" }
      };
    }
    return i.prototype.pickOneWarning = function(t, e) {
      console.warn("AG Grid: " + t + " and " + e + " do not work with each other, you need to pick one.");
    }, i.prototype.init = function() {
      var t = this;
      if (this.checkForDeprecated(), this.checkForViolations(), this.gridOptions.suppressPropertyNamesCheck !== !0 && (this.checkGridOptionsProperties(), this.checkColumnDefProperties()), this.checkColumnDefViolations(), this.gridOptionsService.is("groupSelectsChildren") && this.gridOptionsService.is("suppressParentsInRowNodes") && console.warn("AG Grid: 'groupSelectsChildren' does not work with 'suppressParentsInRowNodes', this selection method needs the part in rowNode to work"), this.gridOptionsService.is("groupSelectsChildren") && this.gridOptionsService.get("rowSelection") !== "multiple" && console.warn("AG Grid: rowSelection must be 'multiple' for groupSelectsChildren to make sense"), this.gridOptionsService.is("groupRemoveSingleChildren") && this.gridOptionsService.is("groupHideOpenParents") && this.pickOneWarning("groupRemoveSingleChildren", "groupHideOpenParents"), this.gridOptionsService.get("domLayout") === "autoHeight" && !this.gridOptionsService.isRowModelType("clientSide") && (this.gridOptionsService.is("pagination") || (console.warn("AG Grid: domLayout='autoHeight' was ignored as it is only supported by the Client-Side row model, unless using pagination."), this.gridOptions.domLayout = "normal")), this.gridOptionsService.isRowModelType("serverSide")) {
        var e = function(o, n) {
          return "AG Grid: '" + o + "' is not supported on the Server-Side Row Model." + (n ? " Please use " + n + " instead." : "");
        };
        this.gridOptionsService.exists("groupDefaultExpanded") && console.warn(e("groupDefaultExpanded", "isServerSideGroupOpenByDefault callback")), this.gridOptionsService.exists("groupIncludeFooter") && console.warn(e("groupIncludeFooter")), this.gridOptionsService.exists("groupIncludeTotalFooter") && console.warn(e("groupIncludeTotalFooter"));
      }
      this.gridOptionsService.is("enableRangeSelection") ? pe.assertRegistered(re.RangeSelectionModule, "enableRangeSelection") : (this.gridOptionsService.is("enableRangeHandle") || this.gridOptionsService.is("enableFillHandle")) && console.warn("AG Grid: 'enableRangeHandle' or 'enableFillHandle' will not work unless 'enableRangeSelection' is set to true");
      var r = function(o, n) {
        return t.gridOptionsService.exists(o) && pe.assertRegistered(n, o);
      };
      r("sideBar", re.SideBarModule), r("statusBar", re.StatusBarModule), r("enableCharts", re.GridChartsModule), r("getMainMenuItems", re.MenuModule), r("getContextMenuItems", re.MenuModule), r("allowContextMenuWithControlKey", re.MenuModule), this.gridOptionsService.is("groupRowsSticky") && (this.gridOptionsService.is("groupHideOpenParents") && this.pickOneWarning("groupRowsSticky", "groupHideOpenParents"), this.gridOptionsService.is("masterDetail") && this.pickOneWarning("groupRowsSticky", "masterDetail"), this.gridOptionsService.is("pagination") && this.pickOneWarning("groupRowsSticky", "pagination"));
    }, i.prototype.checkColumnDefProperties = function() {
      var t = this;
      if (this.gridOptions.columnDefs != null) {
        var e = tl(ru.ALL_PROPERTIES, ru.FRAMEWORK_PROPERTIES), r = function(o, n) {
          var s = Object.getOwnPropertyNames(o);
          t.checkProperties(s, e, e, n, "https://www.ag-grid.com/javascript-data-grid/column-properties/"), o.children && o.children.forEach(function(a) {
            return r(a, "columnDefs.children");
          });
        };
        this.gridOptions.columnDefs.forEach(function(o) {
          return r(o, "columnDefs");
        }), this.gridOptions.defaultColDef && r(this.gridOptions.defaultColDef, "defaultColDef");
      }
    }, i.prototype.checkColumnDefViolations = function() {
      var t, e = (t = this.gridOptionsService.get("rowModelType")) !== null && t !== void 0 ? t : "clientSide", r = {
        infinite: ["headerCheckboxSelection", "headerCheckboxSelectionFilteredOnly", "headerCheckboxSelectionCurrentPageOnly"],
        viewport: ["headerCheckboxSelection", "headerCheckboxSelectionFilteredOnly", "headerCheckboxSelectionCurrentPageOnly"],
        serverSide: ["headerCheckboxSelectionFilteredOnly", "headerCheckboxSelectionCurrentPageOnly"],
        clientSide: []
      }, o = r[e];
      if (o != null && o.length) {
        var n = function(s) {
          o.forEach(function(a) {
            a in s && s[a] && console.warn("AG Grid: Column property " + a + " is not supported with the row model type " + e + ".");
          });
        };
        this.gridOptions.columnDefs != null && this.gridOptions.columnDefs.forEach(function(s) {
          return n(s);
        }), this.gridOptions.autoGroupColumnDef != null && n(this.gridOptions.autoGroupColumnDef), this.gridOptions.defaultColDef != null && n(this.gridOptions.defaultColDef);
      }
    }, i.prototype.checkGridOptionsProperties = function() {
      var t = Object.getOwnPropertyNames(this.gridOptions), e = tl(Nr.ALL_PROPERTIES, Nr.FRAMEWORK_PROPERTIES, Oi.EVENT_CALLBACKS), r = tl(e, ["api", "columnApi"], Object.keys(this.deprecatedProperties));
      this.checkProperties(t, r, e, "gridOptions", "https://www.ag-grid.com/javascript-data-grid/grid-options/");
    }, i.prototype.checkProperties = function(t, e, r, o, n) {
      var s = gf(t, e, r);
      Ke(s, function(a, l) {
        Pe(function() {
          return console.warn("AG Grid: invalid " + o + " property '" + a + "' did you mean any of these: " + l.slice(0, 8).join(", "));
        }, "invalidProperty" + o + a);
      }), Object.keys(s).length > 0 && Pe(function() {
        return console.warn("AG Grid: to see all the valid " + o + " properties please check: " + n);
      }, "invalidProperties" + o + n);
    }, i.prototype.checkForDeprecated = function() {
      var t = this.gridOptions;
      if (Object.entries(this.deprecatedProperties).forEach(function(r) {
        var o, n = yf(r, 2), s = n[0], a = n[1], l = t[s];
        l && (bt(a.version, s, a.newProp, a.message), a.copyToNewProp && a.newProp && t[a.newProp] == null && (t[a.newProp] = (o = a.newPropValue) !== null && o !== void 0 ? o : l));
      }), t.groupSuppressAutoColumn) {
        var e = t.treeData ? "treeDataDisplayType" : "groupDisplayType";
        console.warn("AG Grid: since v26.0, the grid property `groupSuppressAutoColumn` has been replaced by `" + e + " = 'custom'`"), t[e] = "custom";
      }
      t.immutableData && (t.getRowId ? console.warn("AG Grid: since v27.1, `immutableData` is deprecated. With the `getRowId` callback implemented, immutable data is enabled by default so you can remove `immutableData=true`.") : console.warn("AG Grid: since v27.1, `immutableData` is deprecated. To enable immutable data you must implement the `getRowId()` callback.")), t.serverSideStoreType && (console.warn("AG Grid: since v29.0, `serverSideStoreType` has been replaced by `suppressServerSideInfiniteScroll`. Set to false to use Partial Store, and true to use Full Store."), t.suppressServerSideInfiniteScroll = t.serverSideStoreType !== "partial");
    }, i.prototype.checkForViolations = function() {
      this.gridOptionsService.is("treeData") && this.treeDataViolations();
    }, i.prototype.treeDataViolations = function() {
      this.gridOptionsService.isRowModelType("clientSide") && (this.gridOptionsService.exists("getDataPath") || console.warn("AG Grid: property usingTreeData=true with rowModel=clientSide, but you did not provide getDataPath function, please provide getDataPath function if using tree data.")), this.gridOptionsService.isRowModelType("serverSide") && (this.gridOptionsService.exists("isServerSideGroup") || console.warn("AG Grid: property usingTreeData=true with rowModel=serverSide, but you did not provide isServerSideGroup function, please provide isServerSideGroup function if using tree data."), this.gridOptionsService.exists("getServerSideGroupKey") || console.warn("AG Grid: property usingTreeData=true with rowModel=serverSide, but you did not provide getServerSideGroupKey function, please provide getServerSideGroupKey function if using tree data."));
    }, ss([
      v("gridOptions")
    ], i.prototype, "gridOptions", void 0), ss([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), ss([
      U
    ], i.prototype, "init", null), i = ss([
      te("gridOptionsValidator")
    ], i), i;
  }()
);
function nu(i, t) {
  var e = ["groupRows", "multipleColumns", "custom", "singleColumn"];
  return e.indexOf(t) < 0 ? (console.warn("AG Grid: '" + t + "' is not a valid groupDisplayType value - possible values are: '" + e.join("', '") + "'"), !1) : t === i;
}
function Vm(i, t) {
  var e = ["auto", "custom"];
  return e.indexOf(t) < 0 ? (console.warn("AG Grid: '" + t + "' is not a valid treeDataDisplayType value - possible values are: '" + e.join("', '") + "'"), !1) : t === i;
}
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Bm = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, qt = (
  /** @class */
  function() {
    function i(t, e, r, o) {
      this.displayedChildren = [], this.localEventService = new mo(), this.groupId = e, this.partId = r, this.providedColumnGroup = t, this.pinned = o;
    }
    return i.createUniqueId = function(t, e) {
      return t + "_" + e;
    }, i.prototype.reset = function() {
      this.parent = null, this.children = null, this.displayedChildren = null;
    }, i.prototype.getParent = function() {
      return this.parent;
    }, i.prototype.setParent = function(t) {
      this.parent = t;
    }, i.prototype.getUniqueId = function() {
      return i.createUniqueId(this.groupId, this.partId);
    }, i.prototype.isEmptyGroup = function() {
      return this.displayedChildren.length === 0;
    }, i.prototype.isMoving = function() {
      var t = this.getProvidedColumnGroup().getLeafColumns();
      return !t || t.length === 0 ? !1 : t.every(function(e) {
        return e.isMoving();
      });
    }, i.prototype.checkLeft = function() {
      if (this.displayedChildren.forEach(function(o) {
        o instanceof i && o.checkLeft();
      }), this.displayedChildren.length > 0)
        if (this.gridOptionsService.is("enableRtl")) {
          var t = Ne(this.displayedChildren), e = t.getLeft();
          this.setLeft(e);
        } else {
          var r = this.displayedChildren[0].getLeft();
          this.setLeft(r);
        }
      else
        this.setLeft(null);
    }, i.prototype.getLeft = function() {
      return this.left;
    }, i.prototype.getOldLeft = function() {
      return this.oldLeft;
    }, i.prototype.setLeft = function(t) {
      this.oldLeft = t, this.left !== t && (this.left = t, this.localEventService.dispatchEvent(this.createAgEvent(i.EVENT_LEFT_CHANGED)));
    }, i.prototype.getPinned = function() {
      return this.pinned;
    }, i.prototype.createAgEvent = function(t) {
      return { type: t };
    }, i.prototype.addEventListener = function(t, e) {
      this.localEventService.addEventListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      this.localEventService.removeEventListener(t, e);
    }, i.prototype.getGroupId = function() {
      return this.groupId;
    }, i.prototype.getPartId = function() {
      return this.partId;
    }, i.prototype.isChildInThisGroupDeepSearch = function(t) {
      var e = !1;
      return this.children.forEach(function(r) {
        t === r && (e = !0), r instanceof i && r.isChildInThisGroupDeepSearch(t) && (e = !0);
      }), e;
    }, i.prototype.getActualWidth = function() {
      var t = 0;
      return this.displayedChildren && this.displayedChildren.forEach(function(e) {
        t += e.getActualWidth();
      }), t;
    }, i.prototype.isResizable = function() {
      if (!this.displayedChildren)
        return !1;
      var t = !1;
      return this.displayedChildren.forEach(function(e) {
        e.isResizable() && (t = !0);
      }), t;
    }, i.prototype.getMinWidth = function() {
      var t = 0;
      return this.displayedChildren.forEach(function(e) {
        t += e.getMinWidth() || 0;
      }), t;
    }, i.prototype.addChild = function(t) {
      this.children || (this.children = []), this.children.push(t);
    }, i.prototype.getDisplayedChildren = function() {
      return this.displayedChildren;
    }, i.prototype.getLeafColumns = function() {
      var t = [];
      return this.addLeafColumns(t), t;
    }, i.prototype.getDisplayedLeafColumns = function() {
      var t = [];
      return this.addDisplayedLeafColumns(t), t;
    }, i.prototype.getDefinition = function() {
      return this.providedColumnGroup.getColGroupDef();
    }, i.prototype.getColGroupDef = function() {
      return this.providedColumnGroup.getColGroupDef();
    }, i.prototype.isPadding = function() {
      return this.providedColumnGroup.isPadding();
    }, i.prototype.isExpandable = function() {
      return this.providedColumnGroup.isExpandable();
    }, i.prototype.isExpanded = function() {
      return this.providedColumnGroup.isExpanded();
    }, i.prototype.setExpanded = function(t) {
      this.providedColumnGroup.setExpanded(t);
    }, i.prototype.addDisplayedLeafColumns = function(t) {
      this.displayedChildren.forEach(function(e) {
        e instanceof $e ? t.push(e) : e instanceof i && e.addDisplayedLeafColumns(t);
      });
    }, i.prototype.addLeafColumns = function(t) {
      this.children.forEach(function(e) {
        e instanceof $e ? t.push(e) : e instanceof i && e.addLeafColumns(t);
      });
    }, i.prototype.getChildren = function() {
      return this.children;
    }, i.prototype.getColumnGroupShow = function() {
      return this.providedColumnGroup.getColumnGroupShow();
    }, i.prototype.getProvidedColumnGroup = function() {
      return this.providedColumnGroup;
    }, i.prototype.getOriginalColumnGroup = function() {
      return bt("27", "getOriginalColumnGroup", "getProvidedColumnGroup"), this.getProvidedColumnGroup();
    }, i.prototype.getPaddingLevel = function() {
      var t = this.getParent();
      return !this.isPadding() || !t || !t.isPadding() ? 0 : 1 + t.getPaddingLevel();
    }, i.prototype.calculateDisplayedColumns = function() {
      var t = this;
      this.displayedChildren = [];
      for (var e = this; e != null && e.isPadding(); )
        e = e.getParent();
      var r = e ? e.providedColumnGroup.isExpandable() : !1;
      if (!r) {
        this.displayedChildren = this.children, this.localEventService.dispatchEvent(this.createAgEvent(i.EVENT_DISPLAYED_CHILDREN_CHANGED));
        return;
      }
      this.children.forEach(function(o) {
        var n = o instanceof i && (!o.displayedChildren || !o.displayedChildren.length);
        if (!n) {
          var s = o.getColumnGroupShow();
          switch (s) {
            case "open":
              e.providedColumnGroup.isExpanded() && t.displayedChildren.push(o);
              break;
            case "closed":
              e.providedColumnGroup.isExpanded() || t.displayedChildren.push(o);
              break;
            default:
              t.displayedChildren.push(o);
              break;
          }
        }
      }), this.localEventService.dispatchEvent(this.createAgEvent(i.EVENT_DISPLAYED_CHILDREN_CHANGED));
    }, i.EVENT_LEFT_CHANGED = "leftChanged", i.EVENT_DISPLAYED_CHILDREN_CHANGED = "displayedChildrenChanged", Bm([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Iu = (
  /** @class */
  function() {
    function i() {
      this.existingIds = {};
    }
    return i.prototype.getInstanceIdForKey = function(t) {
      var e = this.existingIds[t], r;
      return typeof e != "number" ? r = 0 : r = e + 1, this.existingIds[t] = r, r;
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var km = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, zn = "ag-Grid-AutoColumn", jm = (
  /** @class */
  function(i) {
    km(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.createAutoGroupColumns = function(e, r) {
      var o = this, n = [], s = this.gridOptionsService.isTreeData(), a = this.gridOptionsService.isGroupMultiAutoColumn();
      return s && a && (console.warn('AG Grid: you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data'), a = !1), a ? r.forEach(function(l, u) {
        n.push(o.createOneAutoGroupColumn(e, l, u));
      }) : n.push(this.createOneAutoGroupColumn(e)), n;
    }, t.prototype.createOneAutoGroupColumn = function(e, r, o) {
      var n = this.generateDefaultColDef(r), s;
      r ? s = zn + "-" + r.getId() : s = zn;
      var a = this.gridOptionsService.get("autoGroupColumnDef");
      if (ir(n, a), n = this.columnFactory.mergeColDefs(n), n.colId = s, !this.gridOptionsService.isTreeData()) {
        var l = ue(n.field) && ue(n.valueGetter) && ue(n.filterValueGetter) && n.filter !== "agGroupColumnFilter";
        l && (n.filter = !1);
      }
      o && o > 0 && (n.headerCheckboxSelection = !1);
      var u = e.find(function(d) {
        return d.getId() == s;
      });
      if (u)
        return u.setColDef(n, null), this.columnFactory.applyColumnState(u, n), u;
      var c = this.gridOptionsService.isColumnsSortingCoupledToGroup();
      c && (n.sort || n.initialSort) && !n.field && ir(n, { sort: null, initialSort: null }, !0, !0);
      var p = new $e(n, null, s, !0);
      return this.context.createBean(p), p;
    }, t.prototype.generateDefaultColDef = function(e) {
      var r = this.gridOptionsService.get("autoGroupColumnDef"), o = this.localeService.getLocaleTextFunc(), n = {
        headerName: o("group", "Group")
      }, s = r && (r.cellRenderer || r.cellRendererFramework || r.cellRendererSelector);
      if (s || (n.cellRenderer = "agGroupCellRenderer"), e) {
        var a = e.getColDef();
        Object.assign(n, {
          // cellRendererParams.groupKey: colDefToCopy.field;
          headerName: this.columnModel.getDisplayNameForColumn(e, "header"),
          headerValueGetter: a.headerValueGetter
        }), (a.cellRenderer || a.cellRendererFramework) && Object.assign(n, {
          cellRendererParams: {
            innerRenderer: a.cellRenderer,
            innerRendererFramework: a.cellRendererFramework,
            innerRendererParams: a.cellRendererParams
          }
        }), n.showRowGroup = e.getColId();
      } else
        n.showRowGroup = !0;
      return n;
    }, rl([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), rl([
      v("columnFactory")
    ], t.prototype, "columnFactory", void 0), t = rl([
      te("autoGroupColService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Wm = /[&<>"']/g, Um = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function zm(i) {
  var t = String.fromCharCode;
  function e(p) {
    var d = [];
    if (!p)
      return [];
    for (var h = p.length, g = 0, y, S; g < h; )
      y = p.charCodeAt(g++), y >= 55296 && y <= 56319 && g < h ? (S = p.charCodeAt(g++), (S & 64512) == 56320 ? d.push(((y & 1023) << 10) + (S & 1023) + 65536) : (d.push(y), g--)) : d.push(y);
    return d;
  }
  function r(p) {
    if (p >= 55296 && p <= 57343)
      throw Error("Lone surrogate U+" + p.toString(16).toUpperCase() + " is not a scalar value");
  }
  function o(p, d) {
    return t(p >> d & 63 | 128);
  }
  function n(p) {
    if (p >= 0 && p <= 31 && p !== 10) {
      var d = p.toString(16).toUpperCase(), h = d.padStart(4, "0");
      return "_x" + h + "_";
    }
    if (!(p & 4294967168))
      return t(p);
    var g = "";
    return p & 4294965248 ? p & 4294901760 ? p & 4292870144 || (g = t(p >> 18 & 7 | 240), g += o(p, 12), g += o(p, 6)) : (r(p), g = t(p >> 12 & 15 | 224), g += o(p, 6)) : g = t(p >> 6 & 31 | 192), g += t(p & 63 | 128), g;
  }
  for (var s = e(i), a = s.length, l = -1, u, c = ""; ++l < a; )
    u = s[l], c += n(u);
  return c;
}
function mf(i) {
  return i[0].toUpperCase() + i.substr(1).toLowerCase();
}
function so(i, t) {
  if (i == null)
    return null;
  var e = i.toString().toString();
  return t ? e : e.replace(Wm, function(r) {
    return Um[r];
  });
}
function Cf(i) {
  if (!i || i == null)
    return null;
  var t = /([a-z])([A-Z])/g, e = /([A-Z]+)([A-Z])([a-z])/g, r = i.replace(t, "$1 $2").replace(e, "$1 $2$3").replace(/\./g, " ").split(" ");
  return r.map(function(o) {
    return o.substring(0, 1).toUpperCase() + (o.length > 1 ? o.substring(1, o.length) : "");
  }).join(" ");
}
var $m = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  utf8_encode: zm,
  capitalise: mf,
  escapeString: so,
  camelCaseToHumanText: Cf
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function ho(i) {
  var t = /* @__PURE__ */ new Map();
  return i.forEach(function(e) {
    return t.set(e[0], e[1]);
  }), t;
}
function Km(i, t) {
  var e = /* @__PURE__ */ new Map();
  return i.forEach(function(r) {
    return e.set(t(r), r);
  }), e;
}
function Ym(i) {
  var t = [];
  return i.forEach(function(e, r) {
    return t.push(r);
  }), t;
}
var qm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  convertToMap: ho,
  mapById: Km,
  keys: Ym
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Xm = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Mt = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Qm = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, Jm = function(i, t) {
  var e = {};
  for (var r in i)
    Object.prototype.hasOwnProperty.call(i, r) && t.indexOf(r) < 0 && (e[r] = i[r]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(i); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(i, r[o]) && (e[r[o]] = i[r[o]]);
  return e;
}, Lp = function(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], r = 0;
  if (e)
    return e.call(i);
  if (i && typeof i.length == "number")
    return {
      next: function() {
        return i && r >= i.length && (i = void 0), { value: i && i[r++], done: !i };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Zm = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, ri = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(Zm(arguments[t]));
  return i;
}, wf = (
  /** @class */
  function(i) {
    Xm(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.primaryHeaderRowCount = 0, e.secondaryHeaderRowCount = 0, e.gridHeaderRowCount = 0, e.displayedColumnsLeft = [], e.displayedColumnsRight = [], e.displayedColumnsCenter = [], e.displayedColumns = [], e.displayedColumnsAndGroupsMap = {}, e.viewportColumns = [], e.viewportColumnsHash = "", e.headerViewportColumns = [], e.viewportColumnsCenter = [], e.headerViewportColumnsCenter = [], e.autoHeightActiveAtLeastOnce = !1, e.rowGroupColumns = [], e.valueColumns = [], e.pivotColumns = [], e.ready = !1, e.autoGroupsNeedBuilding = !1, e.forceRecreateAutoGroups = !1, e.pivotMode = !1, e.bodyWidth = 0, e.leftWidth = 0, e.rightWidth = 0, e.bodyWidthDirty = !0, e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.suppressColumnVirtualisation = this.gridOptionsService.is("suppressColumnVirtualisation");
      var r = this.gridOptionsService.is("pivotMode");
      this.isPivotSettingAllowed(r) && (this.pivotMode = r), this.usingTreeData = this.gridOptionsService.isTreeData(), this.addManagedPropertyListener("groupDisplayType", function() {
        return e.onAutoGroupColumnDefChanged();
      }), this.addManagedPropertyListener("autoGroupColumnDef", function() {
        return e.onAutoGroupColumnDefChanged();
      }), this.addManagedPropertyListener("defaultColDef", function(o) {
        return e.onSharedColDefChanged(o.source);
      }), this.addManagedPropertyListener("columnTypes", function(o) {
        return e.onSharedColDefChanged(o.source);
      });
    }, t.prototype.onAutoGroupColumnDefChanged = function() {
      this.autoGroupsNeedBuilding = !0, this.forceRecreateAutoGroups = !0, this.updateGridColumns(), this.updateDisplayedColumns("gridOptionsChanged");
    }, t.prototype.onSharedColDefChanged = function(e) {
      e === void 0 && (e = "api"), this.forceRecreateAutoGroups = !0, this.createColumnsFromColumnDefs(!0, e);
    }, t.prototype.setColumnDefs = function(e, r) {
      r === void 0 && (r = "api");
      var o = !!this.columnDefs;
      this.columnDefs = e, this.createColumnsFromColumnDefs(o, r);
    }, t.prototype.destroyOldColumns = function(e, r) {
      var o = {};
      if (e) {
        this.columnUtils.depthFirstOriginalTreeSearch(null, e, function(s) {
          o[s.getInstanceId()] = s;
        }), r && this.columnUtils.depthFirstOriginalTreeSearch(null, r, function(s) {
          o[s.getInstanceId()] = null;
        });
        var n = Object.values(o).filter(function(s) {
          return s != null;
        });
        this.destroyBeans(n);
      }
    }, t.prototype.destroyColumns = function() {
      this.destroyOldColumns(this.primaryColumnTree), this.destroyOldColumns(this.secondaryBalancedTree), this.destroyOldColumns(this.groupAutoColsBalancedTree);
    }, t.prototype.createColumnsFromColumnDefs = function(e, r) {
      var o = this;
      r === void 0 && (r = "api");
      var n = e ? this.compareColumnStatesAndDispatchEvents(r) : void 0;
      this.valueCache.expire(), this.autoGroupsNeedBuilding = !0;
      var s = this.primaryColumns, a = this.primaryColumnTree, l = this.columnFactory.createColumnTree(this.columnDefs, !0, a);
      this.destroyOldColumns(this.primaryColumnTree, l.columnTree), this.primaryColumnTree = l.columnTree, this.primaryHeaderRowCount = l.treeDept + 1, this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree), this.primaryColumnsMap = {}, this.primaryColumns.forEach(function(p) {
        return o.primaryColumnsMap[p.getId()] = p;
      }), this.extractRowGroupColumns(r, s), this.extractPivotColumns(r, s), this.extractValueColumns(r, s), this.ready = !0;
      var u = this.gridColsArePrimary === void 0, c = this.gridColsArePrimary || u;
      c && (this.updateGridColumns(), e && !this.gridOptionsService.is("maintainColumnOrder") && this.orderGridColumnsLikePrimary(), this.updateDisplayedColumns(r), this.checkViewportColumns()), this.dispatchEverythingChanged(r), n && n(), this.dispatchNewColumnsLoaded();
    }, t.prototype.dispatchNewColumnsLoaded = function() {
      var e = {
        type: m.EVENT_NEW_COLUMNS_LOADED
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.dispatchEverythingChanged = function(e) {
      e === void 0 && (e = "api");
      var r = {
        type: m.EVENT_COLUMN_EVERYTHING_CHANGED,
        source: e
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.orderGridColumnsLikePrimary = function() {
      var e = this, r = this.primaryColumns;
      r && (this.gridColumns.sort(function(o, n) {
        var s = r.indexOf(o), a = r.indexOf(n), l = s >= 0, u = a >= 0;
        if (l && u)
          return s - a;
        if (l)
          return 1;
        if (u)
          return -1;
        var c = e.gridColumns.indexOf(o), p = e.gridColumns.indexOf(n);
        return c - p;
      }), this.gridColumns = this.placeLockedColumns(this.gridColumns));
    }, t.prototype.getAllDisplayedAutoHeightCols = function() {
      return this.displayedAutoHeightCols;
    }, t.prototype.setViewport = function() {
      this.gridOptionsService.is("enableRtl") ? (this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth, this.viewportRight = this.bodyWidth - this.scrollPosition) : (this.viewportLeft = this.scrollPosition, this.viewportRight = this.scrollWidth + this.scrollPosition);
    }, t.prototype.getDisplayedColumnsStartingAt = function(e) {
      for (var r = e, o = []; r != null; )
        o.push(r), r = this.getDisplayedColAfter(r);
      return o;
    }, t.prototype.checkViewportColumns = function() {
      if (this.displayedColumnsCenter != null) {
        var e = this.extractViewport();
        if (e) {
          var r = {
            type: m.EVENT_VIRTUAL_COLUMNS_CHANGED
          };
          this.eventService.dispatchEvent(r);
        }
      }
    }, t.prototype.setViewportPosition = function(e, r) {
      (e !== this.scrollWidth || r !== this.scrollPosition || this.bodyWidthDirty) && (this.scrollWidth = e, this.scrollPosition = r, this.bodyWidthDirty = !0, this.setViewport(), this.ready && this.checkViewportColumns());
    }, t.prototype.isPivotMode = function() {
      return this.pivotMode;
    }, t.prototype.isPivotSettingAllowed = function(e) {
      return e && this.gridOptionsService.isTreeData() ? (console.warn("AG Grid: Pivot mode not available in conjunction Tree Data i.e. 'gridOptions.treeData: true'"), !1) : !0;
    }, t.prototype.setPivotMode = function(e, r) {
      if (r === void 0 && (r = "api"), !(e === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode))) {
        this.pivotMode = e, this.autoGroupsNeedBuilding = !0, this.updateGridColumns(), this.updateDisplayedColumns(r);
        var o = {
          type: m.EVENT_COLUMN_PIVOT_MODE_CHANGED
        };
        this.eventService.dispatchEvent(o);
      }
    }, t.prototype.getSecondaryPivotColumn = function(e, r) {
      if (ue(this.secondaryColumns))
        return null;
      var o = this.getPrimaryColumn(r), n = null;
      return this.secondaryColumns.forEach(function(s) {
        var a = s.getColDef().pivotKeys, l = s.getColDef().pivotValueColumn, u = No(a, e), c = l === o;
        u && c && (n = s);
      }), n;
    }, t.prototype.setBeans = function(e) {
      this.logger = e.create("columnModel");
    }, t.prototype.setFirstRightAndLastLeftPinned = function(e) {
      var r, o;
      this.gridOptionsService.is("enableRtl") ? (r = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null, o = this.displayedColumnsRight ? Ne(this.displayedColumnsRight) : null) : (r = this.displayedColumnsLeft ? Ne(this.displayedColumnsLeft) : null, o = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null), this.gridColumns.forEach(function(n) {
        n.setLastLeftPinned(n === r, e), n.setFirstRightPinned(n === o, e);
      });
    }, t.prototype.autoSizeColumns = function(e) {
      var r = this, o = e.columns, n = e.skipHeader, s = e.skipHeaderGroups, a = e.stopAtGroup, l = e.source, u = l === void 0 ? "api" : l;
      this.animationFrameService.flushAllFrames();
      for (var c = [], p = -1, d = n ?? this.gridOptionsService.is("skipHeaderOnAutoSize"), h = s ?? d; p !== 0; )
        p = 0, this.actionOnGridColumns(o, function(g) {
          if (c.indexOf(g) >= 0)
            return !1;
          var y = r.autoWidthCalculator.getPreferredWidthForColumn(g, d);
          if (y > 0) {
            var S = r.normaliseColumnWidth(g, y);
            g.setActualWidth(S, u), c.push(g), p++;
          }
          return !0;
        }, u);
      h || this.autoSizeColumnGroupsByColumns(o, u, a), this.dispatchColumnResizedEvent(c, !0, "autosizeColumns");
    }, t.prototype.dispatchColumnResizedEvent = function(e, r, o, n) {
      if (n === void 0 && (n = null), e && e.length) {
        var s = {
          type: m.EVENT_COLUMN_RESIZED,
          columns: e,
          column: e.length === 1 ? e[0] : null,
          flexColumns: n,
          finished: r,
          source: o
        };
        this.eventService.dispatchEvent(s);
      }
    }, t.prototype.dispatchColumnChangedEvent = function(e, r, o) {
      var n = {
        type: e,
        columns: r,
        column: r && r.length == 1 ? r[0] : null,
        source: o
      };
      this.eventService.dispatchEvent(n);
    }, t.prototype.dispatchColumnMovedEvent = function(e) {
      var r = e.movedColumns, o = e.source, n = e.toIndex, s = e.finished, a = {
        type: m.EVENT_COLUMN_MOVED,
        columns: r,
        column: r && r.length === 1 ? r[0] : null,
        toIndex: n,
        finished: s,
        source: o
      };
      this.eventService.dispatchEvent(a);
    }, t.prototype.dispatchColumnPinnedEvent = function(e, r) {
      if (e.length) {
        var o = e.length === 1 ? e[0] : null, n = this.getCommonValue(e, function(a) {
          return a.getPinned();
        }), s = {
          type: m.EVENT_COLUMN_PINNED,
          // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
          pinned: n ?? null,
          columns: e,
          column: o,
          source: r
        };
        this.eventService.dispatchEvent(s);
      }
    }, t.prototype.dispatchColumnVisibleEvent = function(e, r) {
      if (e.length) {
        var o = e.length === 1 ? e[0] : null, n = this.getCommonValue(e, function(a) {
          return a.isVisible();
        }), s = {
          type: m.EVENT_COLUMN_VISIBLE,
          visible: n,
          columns: e,
          column: o,
          source: r
        };
        this.eventService.dispatchEvent(s);
      }
    }, t.prototype.autoSizeColumn = function(e, r, o) {
      o === void 0 && (o = "api"), e && this.autoSizeColumns({ columns: [e], skipHeader: r, skipHeaderGroups: !0, source: o });
    }, t.prototype.autoSizeColumnGroupsByColumns = function(e, r, o) {
      var n, s, a, l, u = /* @__PURE__ */ new Set(), c = this.getGridColumns(e);
      c.forEach(function(E) {
        for (var R = E.getParent(); R && R != o; )
          R.isPadding() || u.add(R), R = R.getParent();
      });
      var p, d = [];
      try {
        for (var h = Lp(u), g = h.next(); !g.done; g = h.next()) {
          var y = g.value;
          try {
            for (var S = (a = void 0, Lp(this.ctrlsService.getHeaderRowContainerCtrls())), _ = S.next(); !_.done; _ = S.next()) {
              var w = _.value;
              if (p = w.getHeaderCtrlForColumn(y), p)
                break;
            }
          } catch (E) {
            a = { error: E };
          } finally {
            try {
              _ && !_.done && (l = S.return) && l.call(S);
            } finally {
              if (a)
                throw a.error;
            }
          }
          p && p.resizeLeafColumnsToFit(r);
        }
      } catch (E) {
        n = { error: E };
      } finally {
        try {
          g && !g.done && (s = h.return) && s.call(h);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return d;
    }, t.prototype.autoSizeAllColumns = function(e, r) {
      r === void 0 && (r = "api");
      var o = this.getAllDisplayedColumns();
      this.autoSizeColumns({ columns: o, skipHeader: e, source: r });
    }, t.prototype.getColumnsFromTree = function(e) {
      var r = [], o = function(n) {
        for (var s = 0; s < n.length; s++) {
          var a = n[s];
          a instanceof $e ? r.push(a) : a instanceof et && o(a.getChildren());
        }
      };
      return o(e), r;
    }, t.prototype.getAllDisplayedTrees = function() {
      return this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre ? this.displayedTreeLeft.concat(this.displayedTreeCentre).concat(this.displayedTreeRight) : null;
    }, t.prototype.getPrimaryColumnTree = function() {
      return this.primaryColumnTree;
    }, t.prototype.getHeaderRowCount = function() {
      return this.gridHeaderRowCount;
    }, t.prototype.getDisplayedTreeLeft = function() {
      return this.displayedTreeLeft;
    }, t.prototype.getDisplayedTreeRight = function() {
      return this.displayedTreeRight;
    }, t.prototype.getDisplayedTreeCentre = function() {
      return this.displayedTreeCentre;
    }, t.prototype.isColumnDisplayed = function(e) {
      return this.getAllDisplayedColumns().indexOf(e) >= 0;
    }, t.prototype.getAllDisplayedColumns = function() {
      return this.displayedColumns;
    }, t.prototype.getViewportColumns = function() {
      return this.viewportColumns;
    }, t.prototype.getDisplayedLeftColumnsForRow = function(e) {
      return this.colSpanActive ? this.getDisplayedColumnsForRow(e, this.displayedColumnsLeft) : this.displayedColumnsLeft;
    }, t.prototype.getDisplayedRightColumnsForRow = function(e) {
      return this.colSpanActive ? this.getDisplayedColumnsForRow(e, this.displayedColumnsRight) : this.displayedColumnsRight;
    }, t.prototype.isColSpanActive = function() {
      return this.colSpanActive;
    }, t.prototype.getDisplayedColumnsForRow = function(e, r, o, n) {
      for (var s = [], a = null, l = function(p) {
        var d = r[p], h = r.length - p, g = Math.min(d.getColSpan(e), h), y = [d];
        if (g > 1) {
          for (var S = g - 1, _ = 1; _ <= S; _++)
            y.push(r[p + _]);
          p += S;
        }
        var w;
        if (o ? (w = !1, y.forEach(function(R) {
          o(R) && (w = !0);
        })) : w = !0, w) {
          if (s.length === 0 && a) {
            var E = n ? n(d) : !1;
            E && s.push(a);
          }
          s.push(d);
        }
        a = d, u = p;
      }, u, c = 0; c < r.length; c++)
        l(c), c = u;
      return s;
    }, t.prototype.getViewportCenterColumnsForRow = function(e) {
      var r = this;
      if (!this.colSpanActive)
        return this.viewportColumnsCenter;
      var o = function(s) {
        var a = s.getLeft();
        return k(a) && a > r.viewportLeft;
      }, n = this.suppressColumnVirtualisation ? null : this.isColumnInRowViewport.bind(this);
      return this.getDisplayedColumnsForRow(e, this.displayedColumnsCenter, n, o);
    }, t.prototype.getAriaColumnIndex = function(e) {
      return this.getAllGridColumns().indexOf(e) + 1;
    }, t.prototype.isColumnInHeaderViewport = function(e) {
      return e.isAutoHeaderHeight() ? !0 : this.isColumnInRowViewport(e);
    }, t.prototype.isColumnInRowViewport = function(e) {
      if (e.isAutoHeight())
        return !0;
      var r = e.getLeft() || 0, o = r + e.getActualWidth(), n = this.viewportLeft - 200, s = this.viewportRight + 200, a = r < n && o < n, l = r > s && o > s;
      return !a && !l;
    }, t.prototype.getDisplayedColumnsLeftWidth = function() {
      return this.getWidthOfColsInList(this.displayedColumnsLeft);
    }, t.prototype.getDisplayedColumnsRightWidth = function() {
      return this.getWidthOfColsInList(this.displayedColumnsRight);
    }, t.prototype.updatePrimaryColumnList = function(e, r, o, n, s, a) {
      var l = this;
      if (a === void 0 && (a = "api"), !(!e || cr(e))) {
        var u = !1;
        if (e.forEach(function(p) {
          var d = l.getPrimaryColumn(p);
          if (d) {
            if (o) {
              if (r.indexOf(d) >= 0)
                return;
              r.push(d);
            } else {
              if (r.indexOf(d) < 0)
                return;
              Vt(r, d);
            }
            n(d), u = !0;
          }
        }), !!u) {
          this.autoGroupsNeedBuilding && this.updateGridColumns(), this.updateDisplayedColumns(a);
          var c = {
            type: s,
            columns: r,
            column: r.length === 1 ? r[0] : null,
            source: a
          };
          this.eventService.dispatchEvent(c);
        }
      }
    }, t.prototype.setRowGroupColumns = function(e, r) {
      r === void 0 && (r = "api"), this.autoGroupsNeedBuilding = !0, this.setPrimaryColumnList(e, this.rowGroupColumns, m.EVENT_COLUMN_ROW_GROUP_CHANGED, this.setRowGroupActive.bind(this), r);
    }, t.prototype.setRowGroupActive = function(e, r, o) {
      e !== r.isRowGroupActive() && (r.setRowGroupActive(e, o), e && !this.gridOptionsService.is("suppressRowGroupHidesColumns") && this.setColumnVisible(r, !1, o), !e && !this.gridOptionsService.is("suppressMakeColumnVisibleAfterUnGroup") && this.setColumnVisible(r, !0, o));
    }, t.prototype.addRowGroupColumn = function(e, r) {
      r === void 0 && (r = "api"), e && this.addRowGroupColumns([e], r);
    }, t.prototype.addRowGroupColumns = function(e, r) {
      r === void 0 && (r = "api"), this.autoGroupsNeedBuilding = !0, this.updatePrimaryColumnList(e, this.rowGroupColumns, !0, this.setRowGroupActive.bind(this, !0), m.EVENT_COLUMN_ROW_GROUP_CHANGED, r);
    }, t.prototype.removeRowGroupColumns = function(e, r) {
      r === void 0 && (r = "api"), this.autoGroupsNeedBuilding = !0, this.updatePrimaryColumnList(e, this.rowGroupColumns, !1, this.setRowGroupActive.bind(this, !1), m.EVENT_COLUMN_ROW_GROUP_CHANGED, r);
    }, t.prototype.removeRowGroupColumn = function(e, r) {
      r === void 0 && (r = "api"), e && this.removeRowGroupColumns([e], r);
    }, t.prototype.addPivotColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.pivotColumns, !0, function(o) {
        return o.setPivotActive(!0, r);
      }, m.EVENT_COLUMN_PIVOT_CHANGED, r);
    }, t.prototype.setPivotColumns = function(e, r) {
      r === void 0 && (r = "api"), this.setPrimaryColumnList(e, this.pivotColumns, m.EVENT_COLUMN_PIVOT_CHANGED, function(o, n) {
        n.setPivotActive(o, r);
      }, r);
    }, t.prototype.addPivotColumn = function(e, r) {
      r === void 0 && (r = "api"), this.addPivotColumns([e], r);
    }, t.prototype.removePivotColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.pivotColumns, !1, function(o) {
        return o.setPivotActive(!1, r);
      }, m.EVENT_COLUMN_PIVOT_CHANGED, r);
    }, t.prototype.removePivotColumn = function(e, r) {
      r === void 0 && (r = "api"), this.removePivotColumns([e], r);
    }, t.prototype.setPrimaryColumnList = function(e, r, o, n, s) {
      var a = this;
      r.length = 0, k(e) && e.forEach(function(l) {
        var u = a.getPrimaryColumn(l);
        u && r.push(u);
      }), (this.primaryColumns || []).forEach(function(l) {
        var u = r.indexOf(l) >= 0;
        n(u, l);
      }), this.autoGroupsNeedBuilding && this.updateGridColumns(), this.updateDisplayedColumns(s), this.dispatchColumnChangedEvent(o, r, s);
    }, t.prototype.setValueColumns = function(e, r) {
      r === void 0 && (r = "api"), this.setPrimaryColumnList(e, this.valueColumns, m.EVENT_COLUMN_VALUE_CHANGED, this.setValueActive.bind(this), r);
    }, t.prototype.setValueActive = function(e, r, o) {
      if (e !== r.isValueActive() && (r.setValueActive(e, o), e && !r.getAggFunc())) {
        var n = this.aggFuncService.getDefaultAggFunc(r);
        r.setAggFunc(n);
      }
    }, t.prototype.addValueColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.valueColumns, !0, this.setValueActive.bind(this, !0), m.EVENT_COLUMN_VALUE_CHANGED, r);
    }, t.prototype.addValueColumn = function(e, r) {
      r === void 0 && (r = "api"), e && this.addValueColumns([e], r);
    }, t.prototype.removeValueColumn = function(e, r) {
      r === void 0 && (r = "api"), this.removeValueColumns([e], r);
    }, t.prototype.removeValueColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.valueColumns, !1, this.setValueActive.bind(this, !1), m.EVENT_COLUMN_VALUE_CHANGED, r);
    }, t.prototype.normaliseColumnWidth = function(e, r) {
      var o = e.getMinWidth();
      k(o) && r < o && (r = o);
      var n = e.getMaxWidth();
      return k(n) && e.isGreaterThanMax(r) && (r = n), r;
    }, t.prototype.getPrimaryOrGridColumn = function(e) {
      var r = this.getPrimaryColumn(e);
      return r || this.getGridColumn(e);
    }, t.prototype.setColumnWidths = function(e, r, o, n) {
      var s = this;
      n === void 0 && (n = "api");
      var a = [];
      e.forEach(function(l) {
        var u = s.getPrimaryOrGridColumn(l.key);
        if (u) {
          a.push({
            width: l.newWidth,
            ratios: [1],
            columns: [u]
          });
          var c = s.gridOptionsService.get("colResizeDefault") === "shift";
          if (c && (r = !r), r) {
            var p = s.getDisplayedColAfter(u);
            if (!p)
              return;
            var d = u.getActualWidth() - l.newWidth, h = p.getActualWidth() + d;
            a.push({
              width: h,
              ratios: [1],
              columns: [p]
            });
          }
        }
      }), a.length !== 0 && this.resizeColumnSets({
        resizeSets: a,
        finished: o,
        source: n
      });
    }, t.prototype.checkMinAndMaxWidthsForSet = function(e) {
      var r = e.columns, o = e.width, n = 0, s = 0, a = !0;
      r.forEach(function(c) {
        var p = c.getMinWidth();
        n += p || 0;
        var d = c.getMaxWidth();
        k(d) && d > 0 ? s += d : a = !1;
      });
      var l = o >= n, u = !a || o <= s;
      return l && u;
    }, t.prototype.resizeColumnSets = function(e) {
      var r = this, o = e.resizeSets, n = e.finished, s = e.source, a = !o || o.every(function(g) {
        return r.checkMinAndMaxWidthsForSet(g);
      });
      if (!a) {
        if (n) {
          var l = o && o.length > 0 ? o[0].columns : null;
          this.dispatchColumnResizedEvent(l, n, s);
        }
        return;
      }
      var u = [], c = [];
      o.forEach(function(g) {
        var y = g.width, S = g.columns, _ = g.ratios, w = {}, E = {};
        S.forEach(function(A) {
          return c.push(A);
        });
        for (var R = !0, D = 0, B = function() {
          if (D++, D > 1e3)
            return console.error("AG Grid: infinite loop in resizeColumnSets"), "break";
          R = !1;
          var A = [], N = 0, G = y;
          S.forEach(function(J, de) {
            var ve = E[J.getId()];
            if (ve)
              G -= w[J.getId()];
            else {
              A.push(J);
              var oe = _[de];
              N += oe;
            }
          });
          var W = 1 / N;
          A.forEach(function(J, de) {
            var ve = de === A.length - 1, oe;
            ve ? oe = G : (oe = Math.round(_[de] * y * W), G -= oe);
            var ne = J.getMinWidth(), fe = J.getMaxWidth();
            k(ne) && oe < ne ? (oe = ne, E[J.getId()] = !0, R = !0) : k(fe) && fe > 0 && oe > fe && (oe = fe, E[J.getId()] = !0, R = !0), w[J.getId()] = oe;
          });
        }; R; ) {
          var H = B();
          if (H === "break")
            break;
        }
        S.forEach(function(A) {
          var N = w[A.getId()], G = A.getActualWidth();
          G !== N && (A.setActualWidth(N, s), u.push(A));
        });
      });
      var p = u.length > 0, d = [];
      p && (d = this.refreshFlexedColumns({ resizingCols: c, skipSetLeft: !0 }), this.setLeftValues(s), this.updateBodyWidths(), this.checkViewportColumns());
      var h = c.concat(d);
      (p || n) && this.dispatchColumnResizedEvent(h, n, s, d);
    }, t.prototype.setColumnAggFunc = function(e, r, o) {
      if (o === void 0 && (o = "api"), !!e) {
        var n = this.getPrimaryColumn(e);
        n && (n.setAggFunc(r), this.dispatchColumnChangedEvent(m.EVENT_COLUMN_VALUE_CHANGED, [n], o));
      }
    }, t.prototype.moveRowGroupColumn = function(e, r, o) {
      o === void 0 && (o = "api");
      var n = this.rowGroupColumns[e];
      this.rowGroupColumns.splice(e, 1), this.rowGroupColumns.splice(r, 0, n);
      var s = {
        type: m.EVENT_COLUMN_ROW_GROUP_CHANGED,
        columns: this.rowGroupColumns,
        column: this.rowGroupColumns.length === 1 ? this.rowGroupColumns[0] : null,
        source: o
      };
      this.eventService.dispatchEvent(s);
    }, t.prototype.moveColumns = function(e, r, o, n) {
      if (o === void 0 && (o = "api"), n === void 0 && (n = !0), this.columnAnimationService.start(), r > this.gridColumns.length - e.length) {
        console.warn("AG Grid: tried to insert columns in invalid location, toIndex = " + r), console.warn("AG Grid: remember that you should not count the moving columns when calculating the new index");
        return;
      }
      var s = this.getGridColumns(e), a = !this.doesMovePassRules(s, r);
      a || (eu(this.gridColumns, s, r), this.updateDisplayedColumns(o), this.dispatchColumnMovedEvent({ movedColumns: s, source: o, toIndex: r, finished: n }), this.columnAnimationService.finish());
    }, t.prototype.doesMovePassRules = function(e, r) {
      var o = this.getProposedColumnOrder(e, r);
      return this.doesOrderPassRules(o);
    }, t.prototype.doesOrderPassRules = function(e) {
      return !(!this.doesMovePassMarryChildren(e) || !this.doesMovePassLockedPositions(e));
    }, t.prototype.getProposedColumnOrder = function(e, r) {
      var o = this.gridColumns.slice();
      return eu(o, e, r), o;
    }, t.prototype.sortColumnsLikeGridColumns = function(e) {
      var r = this;
      if (!(!e || e.length <= 1)) {
        var o = e.filter(function(n) {
          return r.gridColumns.indexOf(n) < 0;
        }).length > 0;
        o || e.sort(function(n, s) {
          var a = r.gridColumns.indexOf(n), l = r.gridColumns.indexOf(s);
          return a - l;
        });
      }
    }, t.prototype.doesMovePassLockedPositions = function(e) {
      var r = 0, o = !0, n = function(s) {
        return s ? s === !0 || s === "left" ? 0 : 2 : 1;
      };
      return e.forEach(function(s) {
        var a = n(s.getColDef().lockPosition);
        a < r && (o = !1), r = a;
      }), o;
    }, t.prototype.doesMovePassMarryChildren = function(e) {
      var r = !0;
      return this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function(o) {
        if (o instanceof et) {
          var n = o, s = n.getColGroupDef(), a = s && s.marryChildren;
          if (a) {
            var l = [];
            n.getLeafColumns().forEach(function(h) {
              var g = e.indexOf(h);
              l.push(g);
            });
            var u = Math.max.apply(Math, l), c = Math.min.apply(Math, l), p = u - c, d = n.getLeafColumns().length - 1;
            p > d && (r = !1);
          }
        }
      }), r;
    }, t.prototype.moveColumn = function(e, r, o) {
      o === void 0 && (o = "api"), this.moveColumns([e], r, o);
    }, t.prototype.moveColumnByIndex = function(e, r, o) {
      o === void 0 && (o = "api");
      var n = this.gridColumns[e];
      this.moveColumn(n, r, o);
    }, t.prototype.getColumnDefs = function() {
      var e = this;
      if (this.primaryColumns) {
        var r = this.primaryColumns.slice();
        return this.gridColsArePrimary ? r.sort(function(o, n) {
          return e.gridColumns.indexOf(o) - e.gridColumns.indexOf(n);
        }) : this.lastPrimaryOrder && r.sort(function(o, n) {
          return e.lastPrimaryOrder.indexOf(o) - e.lastPrimaryOrder.indexOf(n);
        }), this.columnDefFactory.buildColumnDefs(r, this.rowGroupColumns, this.pivotColumns);
      }
    }, t.prototype.getBodyContainerWidth = function() {
      return this.bodyWidth;
    }, t.prototype.getContainerWidth = function(e) {
      switch (e) {
        case "left":
          return this.leftWidth;
        case "right":
          return this.rightWidth;
        default:
          return this.bodyWidth;
      }
    }, t.prototype.updateBodyWidths = function() {
      var e = this.getWidthOfColsInList(this.displayedColumnsCenter), r = this.getWidthOfColsInList(this.displayedColumnsLeft), o = this.getWidthOfColsInList(this.displayedColumnsRight);
      this.bodyWidthDirty = this.bodyWidth !== e;
      var n = this.bodyWidth !== e || this.leftWidth !== r || this.rightWidth !== o;
      if (n) {
        this.bodyWidth = e, this.leftWidth = r, this.rightWidth = o;
        var s = {
          type: m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED
        };
        this.eventService.dispatchEvent(s);
      }
    }, t.prototype.getValueColumns = function() {
      return this.valueColumns ? this.valueColumns : [];
    }, t.prototype.getPivotColumns = function() {
      return this.pivotColumns ? this.pivotColumns : [];
    }, t.prototype.isPivotActive = function() {
      return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
    }, t.prototype.getRowGroupColumns = function() {
      return this.rowGroupColumns ? this.rowGroupColumns : [];
    }, t.prototype.getDisplayedCenterColumns = function() {
      return this.displayedColumnsCenter;
    }, t.prototype.getDisplayedLeftColumns = function() {
      return this.displayedColumnsLeft;
    }, t.prototype.getDisplayedRightColumns = function() {
      return this.displayedColumnsRight;
    }, t.prototype.getDisplayedColumns = function(e) {
      switch (e) {
        case "left":
          return this.getDisplayedLeftColumns();
        case "right":
          return this.getDisplayedRightColumns();
        default:
          return this.getDisplayedCenterColumns();
      }
    }, t.prototype.getAllPrimaryColumns = function() {
      return this.primaryColumns ? this.primaryColumns.slice() : null;
    }, t.prototype.getSecondaryColumns = function() {
      return this.secondaryColumns ? this.secondaryColumns.slice() : null;
    }, t.prototype.getAllColumnsForQuickFilter = function() {
      return this.columnsForQuickFilter;
    }, t.prototype.getAllGridColumns = function() {
      return this.gridColumns;
    }, t.prototype.isEmpty = function() {
      return cr(this.gridColumns);
    }, t.prototype.isRowGroupEmpty = function() {
      return cr(this.rowGroupColumns);
    }, t.prototype.setColumnVisible = function(e, r, o) {
      o === void 0 && (o = "api"), this.setColumnsVisible([e], r, o);
    }, t.prototype.setColumnsVisible = function(e, r, o) {
      r === void 0 && (r = !1), o === void 0 && (o = "api"), this.applyColumnState({
        state: e.map(function(n) {
          return {
            colId: typeof n == "string" ? n : n.getColId(),
            hide: !r
          };
        })
      }, o);
    }, t.prototype.setColumnPinned = function(e, r, o) {
      o === void 0 && (o = "api"), e && this.setColumnsPinned([e], r, o);
    }, t.prototype.setColumnsPinned = function(e, r, o) {
      if (o === void 0 && (o = "api"), this.gridOptionsService.isDomLayout("print")) {
        console.warn("AG Grid: Changing the column pinning status is not allowed with domLayout='print'");
        return;
      }
      this.columnAnimationService.start();
      var n;
      r === !0 || r === "left" ? n = "left" : r === "right" ? n = "right" : n = null, this.actionOnGridColumns(e, function(s) {
        return s.getPinned() !== n ? (s.setPinned(n), !0) : !1;
      }, o, function() {
        var s = {
          type: m.EVENT_COLUMN_PINNED,
          pinned: n,
          column: null,
          columns: null,
          source: o
        };
        return s;
      }), this.columnAnimationService.finish();
    }, t.prototype.actionOnGridColumns = function(e, r, o, n) {
      var s = this;
      if (!cr(e)) {
        var a = [];
        if (e.forEach(function(u) {
          var c = s.getGridColumn(u);
          if (c) {
            var p = r(c);
            p !== !1 && a.push(c);
          }
        }), !!a.length && (this.updateDisplayedColumns(o), k(n) && n)) {
          var l = n();
          l.columns = a, l.column = a.length === 1 ? a[0] : null, this.eventService.dispatchEvent(l);
        }
      }
    }, t.prototype.getDisplayedColBefore = function(e) {
      var r = this.getAllDisplayedColumns(), o = r.indexOf(e);
      return o > 0 ? r[o - 1] : null;
    }, t.prototype.getDisplayedColAfter = function(e) {
      var r = this.getAllDisplayedColumns(), o = r.indexOf(e);
      return o < r.length - 1 ? r[o + 1] : null;
    }, t.prototype.getDisplayedGroupAfter = function(e) {
      return this.getDisplayedGroupAtDirection(e, "After");
    }, t.prototype.getDisplayedGroupBefore = function(e) {
      return this.getDisplayedGroupAtDirection(e, "Before");
    }, t.prototype.getDisplayedGroupAtDirection = function(e, r) {
      for (var o = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), n = e.getDisplayedLeafColumns(), s = r === "After" ? Ne(n) : n[0], a = "getDisplayedCol" + r; ; ) {
        var l = this[a](s);
        if (!l)
          return null;
        var u = this.getColumnGroupAtLevel(l, o);
        if (u !== e)
          return u;
      }
    }, t.prototype.getColumnGroupAtLevel = function(e, r) {
      for (var o = e.getParent(), n, s; ; ) {
        var a = o.getProvidedColumnGroup();
        if (n = a.getLevel(), s = o.getPaddingLevel(), n + s <= r)
          break;
        o = o.getParent();
      }
      return o;
    }, t.prototype.isPinningLeft = function() {
      return this.displayedColumnsLeft.length > 0;
    }, t.prototype.isPinningRight = function() {
      return this.displayedColumnsRight.length > 0;
    }, t.prototype.getPrimaryAndSecondaryAndAutoColumns = function() {
      var e;
      return (e = []).concat.apply(e, ri([
        this.primaryColumns || [],
        this.groupAutoColumns || [],
        this.secondaryColumns || []
      ]));
    }, t.prototype.createStateItemFromColumn = function(e) {
      var r = e.isRowGroupActive() ? this.rowGroupColumns.indexOf(e) : null, o = e.isPivotActive() ? this.pivotColumns.indexOf(e) : null, n = e.isValueActive() ? e.getAggFunc() : null, s = e.getSort() != null ? e.getSort() : null, a = e.getSortIndex() != null ? e.getSortIndex() : null, l = e.getFlex() != null && e.getFlex() > 0 ? e.getFlex() : null, u = {
        colId: e.getColId(),
        width: e.getActualWidth(),
        hide: !e.isVisible(),
        pinned: e.getPinned(),
        sort: s,
        sortIndex: a,
        aggFunc: n,
        rowGroup: e.isRowGroupActive(),
        rowGroupIndex: r,
        pivot: e.isPivotActive(),
        pivotIndex: o,
        flex: l
      };
      return u;
    }, t.prototype.getColumnState = function() {
      if (ue(this.primaryColumns) || !this.isAlive())
        return [];
      var e = this.getPrimaryAndSecondaryAndAutoColumns(), r = e.map(this.createStateItemFromColumn.bind(this));
      return this.orderColumnStateList(r), r;
    }, t.prototype.orderColumnStateList = function(e) {
      var r = ho(this.gridColumns.map(function(o, n) {
        return [o.getColId(), n];
      }));
      e.sort(function(o, n) {
        var s = r.has(o.colId) ? r.get(o.colId) : -1, a = r.has(n.colId) ? r.get(n.colId) : -1;
        return s - a;
      });
    }, t.prototype.resetColumnState = function(e) {
      e === void 0 && (e = "api");
      var r = this.getColumnsFromTree(this.primaryColumnTree), o = [], n = 1e3, s = 1e3, a = [];
      this.groupAutoColumns && (a = a.concat(this.groupAutoColumns)), r && (a = a.concat(r)), a.forEach(function(l) {
        var u = function(H, A) {
          return H ?? A ?? null;
        }, c = l.getColDef(), p = u(c.sort, c.initialSort), d = u(c.sortIndex, c.initialSortIndex), h = u(c.hide, c.initialHide), g = u(c.pinned, c.initialPinned), y = u(c.width, c.initialWidth), S = u(c.flex, c.initialFlex), _ = u(c.rowGroupIndex, c.initialRowGroupIndex), w = u(c.rowGroup, c.initialRowGroup);
        _ == null && (w == null || w == !1) && (_ = null, w = null);
        var E = u(c.pivotIndex, c.initialPivotIndex), R = u(c.pivot, c.initialPivot);
        E == null && (R == null || R == !1) && (E = null, R = null);
        var D = u(c.aggFunc, c.initialAggFunc), B = {
          colId: l.getColId(),
          sort: p,
          sortIndex: d,
          hide: h,
          pinned: g,
          width: y,
          flex: S,
          rowGroup: w,
          rowGroupIndex: _,
          pivot: R,
          pivotIndex: E,
          aggFunc: D
        };
        ue(_) && w && (B.rowGroupIndex = n++), ue(E) && R && (B.pivotIndex = s++), o.push(B);
      }), this.applyColumnState({ state: o, applyOrder: !0 }, e);
    }, t.prototype.applyColumnState = function(e, r) {
      var o = this;
      if (cr(this.primaryColumns))
        return !1;
      if (e && e.state && !e.state.forEach)
        return console.warn("AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state."), !1;
      var n = function(u, c, p) {
        var d = o.compareColumnStatesAndDispatchEvents(r);
        o.autoGroupsNeedBuilding = !0;
        var h = c.slice(), g = {}, y = {}, S = [], _ = [], w = 0, E = o.rowGroupColumns.slice(), R = o.pivotColumns.slice();
        u.forEach(function(A) {
          var N = A.colId || "", G = N.startsWith(zn);
          if (G) {
            S.push(A), _.push(A);
            return;
          }
          var W = p(N);
          W ? (o.syncColumnWithStateItem(W, A, e.defaultState, g, y, !1, r), Vt(h, W)) : (_.push(A), w += 1);
        });
        var D = function(A) {
          return o.syncColumnWithStateItem(A, null, e.defaultState, g, y, !1, r);
        };
        h.forEach(D);
        var B = function(A, N, G, W) {
          var J = A[G.getId()], de = A[W.getId()], ve = J != null, oe = de != null;
          if (ve && oe)
            return J - de;
          if (ve)
            return -1;
          if (oe)
            return 1;
          var ne = N.indexOf(G), fe = N.indexOf(W), ce = ne >= 0, se = fe >= 0;
          return ce && se ? ne - fe : ce ? -1 : 1;
        };
        o.rowGroupColumns.sort(B.bind(o, g, E)), o.pivotColumns.sort(B.bind(o, y, R)), o.updateGridColumns();
        var H = o.groupAutoColumns ? o.groupAutoColumns.slice() : [];
        return S.forEach(function(A) {
          var N = o.getAutoColumn(A.colId);
          Vt(H, N), o.syncColumnWithStateItem(N, A, e.defaultState, null, null, !0, r);
        }), H.forEach(D), o.applyOrderAfterApplyState(e), o.updateDisplayedColumns(r), o.dispatchEverythingChanged(r), d(), { unmatchedAndAutoStates: _, unmatchedCount: w };
      };
      this.columnAnimationService.start();
      var s = n(e.state || [], this.primaryColumns || [], function(u) {
        return o.getPrimaryColumn(u);
      }), a = s.unmatchedAndAutoStates, l = s.unmatchedCount;
      return (a.length > 0 || k(e.defaultState)) && (l = n(a, this.secondaryColumns || [], function(u) {
        return o.getSecondaryColumn(u);
      }).unmatchedCount), this.columnAnimationService.finish(), l === 0;
    }, t.prototype.applyOrderAfterApplyState = function(e) {
      var r = this;
      if (!(!e.applyOrder || !e.state)) {
        var o = [], n = {};
        e.state.forEach(function(a) {
          if (!(!a.colId || n[a.colId])) {
            var l = r.gridColumnsMap[a.colId];
            l && (o.push(l), n[a.colId] = !0);
          }
        });
        var s = 0;
        if (this.gridColumns.forEach(function(a) {
          var l = a.getColId(), u = n[l] != null;
          if (!u) {
            var c = l.startsWith(zn);
            c ? Di(o, a, s++) : o.push(a);
          }
        }), o = this.placeLockedColumns(o), !this.doesMovePassMarryChildren(o)) {
          console.warn("AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.");
          return;
        }
        this.gridColumns = o;
      }
    }, t.prototype.compareColumnStatesAndDispatchEvents = function(e) {
      var r = this, o = {
        rowGroupColumns: this.rowGroupColumns.slice(),
        pivotColumns: this.pivotColumns.slice(),
        valueColumns: this.valueColumns.slice()
      }, n = this.getColumnState(), s = {};
      return n.forEach(function(a) {
        s[a.colId] = a;
      }), function() {
        var a = r.getPrimaryAndSecondaryAndAutoColumns(), l = function(_, w, E, R) {
          var D = w.map(R), B = E.map(R), H = No(D, B);
          if (!H) {
            var A = {
              type: _,
              columns: E,
              column: E.length === 1 ? E[0] : null,
              source: e
            };
            r.eventService.dispatchEvent(A);
          }
        }, u = function(_) {
          var w = [];
          return a.forEach(function(E) {
            var R = s[E.getColId()];
            R && _(R, E) && w.push(E);
          }), w;
        }, c = function(_) {
          return _.getColId();
        };
        l(m.EVENT_COLUMN_ROW_GROUP_CHANGED, o.rowGroupColumns, r.rowGroupColumns, c), l(m.EVENT_COLUMN_PIVOT_CHANGED, o.pivotColumns, r.pivotColumns, c);
        var p = function(_, w) {
          var E = _.aggFunc != null, R = E != w.isValueActive(), D = E && _.aggFunc != w.getAggFunc();
          return R || D;
        }, d = u(p);
        d.length > 0 && r.dispatchColumnChangedEvent(m.EVENT_COLUMN_VALUE_CHANGED, r.valueColumns, e);
        var h = function(_, w) {
          return _.width != w.getActualWidth();
        };
        r.dispatchColumnResizedEvent(u(h), !0, e);
        var g = function(_, w) {
          return _.pinned != w.getPinned();
        };
        r.dispatchColumnPinnedEvent(u(g), e);
        var y = function(_, w) {
          return _.hide == w.isVisible();
        };
        r.dispatchColumnVisibleEvent(u(y), e);
        var S = function(_, w) {
          return _.sort != w.getSort() || _.sortIndex != w.getSortIndex();
        };
        u(S).length > 0 && r.sortController.dispatchSortChangedEvents(e), r.normaliseColumnMovedEventForColumnState(n, e);
      };
    }, t.prototype.getCommonValue = function(e, r) {
      if (!(!e || e.length == 0)) {
        for (var o = r(e[0]), n = 1; n < e.length; n++)
          if (o !== r(e[n]))
            return;
        return o;
      }
    }, t.prototype.normaliseColumnMovedEventForColumnState = function(e, r) {
      var o = this, n = this.getColumnState(), s = {};
      n.forEach(function(p) {
        return s[p.colId] = p;
      });
      var a = {};
      e.forEach(function(p) {
        s[p.colId] && (a[p.colId] = !0);
      });
      var l = e.filter(function(p) {
        return a[p.colId];
      }), u = n.filter(function(p) {
        return a[p.colId];
      }), c = [];
      u.forEach(function(p, d) {
        var h = l && l[d];
        if (h && h.colId !== p.colId) {
          var g = o.getGridColumn(h.colId);
          g && c.push(g);
        }
      }), c.length && this.dispatchColumnMovedEvent({ movedColumns: c, source: r, finished: !0 });
    }, t.prototype.syncColumnWithStateItem = function(e, r, o, n, s, a, l) {
      if (e) {
        var u = function(N, G) {
          var W = { value1: void 0, value2: void 0 }, J = !1;
          return r && (r[N] !== void 0 && (W.value1 = r[N], J = !0), k(G) && r[G] !== void 0 && (W.value2 = r[G], J = !0)), !J && o && (o[N] !== void 0 && (W.value1 = o[N]), k(G) && o[G] !== void 0 && (W.value2 = o[G])), W;
        }, c = u("hide").value1;
        c !== void 0 && e.setVisible(!c, l);
        var p = u("pinned").value1;
        p !== void 0 && e.setPinned(p);
        var d = this.columnUtils.calculateColMinWidth(e.getColDef()), h = u("flex").value1;
        h !== void 0 && e.setFlex(h);
        var g = e.getFlex() <= 0;
        if (g) {
          var y = u("width").value1;
          y != null && d != null && y >= d && e.setActualWidth(y, l);
        }
        var S = u("sort").value1;
        S !== void 0 && (S === "desc" || S === "asc" ? e.setSort(S, l) : e.setSort(void 0, l));
        var _ = u("sortIndex").value1;
        if (_ !== void 0 && e.setSortIndex(_), !(a || !e.isPrimary())) {
          var w = u("aggFunc").value1;
          w !== void 0 && (typeof w == "string" ? (e.setAggFunc(w), e.isValueActive() || (e.setValueActive(!0, l), this.valueColumns.push(e))) : (k(w) && console.warn("AG Grid: stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON."), e.isValueActive() && (e.setValueActive(!1, l), Vt(this.valueColumns, e))));
          var E = u("rowGroup", "rowGroupIndex"), R = E.value1, D = E.value2;
          (R !== void 0 || D !== void 0) && (typeof D == "number" || R ? (e.isRowGroupActive() || (e.setRowGroupActive(!0, l), this.rowGroupColumns.push(e)), n && typeof D == "number" && (n[e.getId()] = D)) : e.isRowGroupActive() && (e.setRowGroupActive(!1, l), Vt(this.rowGroupColumns, e)));
          var B = u("pivot", "pivotIndex"), H = B.value1, A = B.value2;
          (H !== void 0 || A !== void 0) && (typeof A == "number" || H ? (e.isPivotActive() || (e.setPivotActive(!0, l), this.pivotColumns.push(e)), s && typeof A == "number" && (s[e.getId()] = A)) : e.isPivotActive() && (e.setPivotActive(!1, l), Vt(this.pivotColumns, e)));
        }
      }
    }, t.prototype.getGridColumns = function(e) {
      return this.getColumns(e, this.getGridColumn.bind(this));
    }, t.prototype.getColumns = function(e, r) {
      var o = [];
      return e && e.forEach(function(n) {
        var s = r(n);
        s && o.push(s);
      }), o;
    }, t.prototype.getColumnWithValidation = function(e) {
      if (e == null)
        return null;
      var r = this.getGridColumn(e);
      return r || console.warn("AG Grid: could not find column " + e), r;
    }, t.prototype.getPrimaryColumn = function(e) {
      return this.primaryColumns ? this.getColumn(e, this.primaryColumns, this.primaryColumnsMap) : null;
    }, t.prototype.getGridColumn = function(e) {
      return this.getColumn(e, this.gridColumns, this.gridColumnsMap);
    }, t.prototype.getSecondaryColumn = function(e) {
      return this.secondaryColumns ? this.getColumn(e, this.secondaryColumns, this.secondaryColumnsMap) : null;
    }, t.prototype.getColumn = function(e, r, o) {
      if (!e)
        return null;
      if (typeof e == "string" && o[e])
        return o[e];
      for (var n = 0; n < r.length; n++)
        if (this.columnsMatch(r[n], e))
          return r[n];
      return this.getAutoColumn(e);
    }, t.prototype.getSourceColumnsForGroupColumn = function(e) {
      var r = e.getColDef().showRowGroup;
      if (!r)
        return null;
      if (r === !0)
        return this.rowGroupColumns.slice(0);
      var o = this.getPrimaryColumn(r);
      return o ? [o] : null;
    }, t.prototype.getAutoColumn = function(e) {
      var r = this;
      return !this.groupAutoColumns || !k(this.groupAutoColumns) || ue(this.groupAutoColumns) ? null : this.groupAutoColumns.find(function(o) {
        return r.columnsMatch(o, e);
      }) || null;
    }, t.prototype.columnsMatch = function(e, r) {
      var o = e === r, n = e.getColDef() === r, s = e.getColId() == r;
      return o || n || s;
    }, t.prototype.getDisplayNameForColumn = function(e, r, o) {
      if (o === void 0 && (o = !1), !e)
        return null;
      var n = this.getHeaderName(e.getColDef(), e, null, null, r);
      return o ? this.wrapHeaderNameWithAggFunc(e, n) : n;
    }, t.prototype.getDisplayNameForProvidedColumnGroup = function(e, r, o) {
      var n = r ? r.getColGroupDef() : null;
      return n ? this.getHeaderName(n, null, e, r, o) : null;
    }, t.prototype.getDisplayNameForColumnGroup = function(e, r) {
      return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), r);
    }, t.prototype.getHeaderName = function(e, r, o, n, s) {
      var a = e.headerValueGetter;
      if (a) {
        var l = {
          colDef: e,
          column: r,
          columnGroup: o,
          providedColumnGroup: n,
          location: s,
          api: this.gridOptionsService.api,
          columnApi: this.gridOptionsService.columnApi,
          context: this.gridOptionsService.context
        };
        return typeof a == "function" ? a(l) : typeof a == "string" ? this.expressionService.evaluate(a, l) : (console.warn("AG Grid: headerValueGetter must be a function or a string"), "");
      } else {
        if (e.headerName != null)
          return e.headerName;
        if (e.field)
          return Cf(e.field);
      }
      return "";
    }, t.prototype.wrapHeaderNameWithAggFunc = function(e, r) {
      if (this.gridOptionsService.is("suppressAggFuncInHeader"))
        return r;
      var o = e.getColDef().pivotValueColumn, n = k(o), s = null, a;
      if (n) {
        var l = this.gridOptionsService.is("removePivotHeaderRowWhenSingleValueColumn") && this.valueColumns.length === 1, u = e.getColDef().pivotTotalColumnIds !== void 0;
        if (l && !u)
          return r;
        s = o ? o.getAggFunc() : null, a = !0;
      } else {
        var c = e.isValueActive(), p = this.pivotMode || !this.isRowGroupEmpty();
        c && p ? (s = e.getAggFunc(), a = !0) : a = !1;
      }
      if (a) {
        var d = typeof s == "string" ? s : "func", h = this.localeService.getLocaleTextFunc(), g = h(d, d);
        return g + "(" + r + ")";
      }
      return r;
    }, t.prototype.getColumnGroup = function(e, r) {
      if (!e)
        return null;
      if (e instanceof qt)
        return e;
      var o = this.getAllDisplayedTrees(), n = typeof r == "number", s = null;
      return this.columnUtils.depthFirstAllColumnTreeSearch(o, function(a) {
        if (a instanceof qt) {
          var l = a, u = void 0;
          n ? u = e === l.getGroupId() && r === l.getPartId() : u = e === l.getGroupId(), u && (s = l);
        }
      }), s;
    }, t.prototype.isReady = function() {
      return this.ready;
    }, t.prototype.extractValueColumns = function(e, r) {
      this.valueColumns = this.extractColumns(
        r,
        this.valueColumns,
        function(o, n) {
          return o.setValueActive(n, e);
        },
        // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
        function() {
        },
        function() {
        },
        // aggFunc is a string, so return it's existence
        function(o) {
          var n = o.aggFunc;
          if (n === null || n === "")
            return null;
          if (n !== void 0)
            return !!n;
        },
        function(o) {
          return o.initialAggFunc != null && o.initialAggFunc != "";
        }
      ), this.valueColumns.forEach(function(o) {
        var n = o.getColDef();
        n.aggFunc != null && n.aggFunc != "" ? o.setAggFunc(n.aggFunc) : o.getAggFunc() || o.setAggFunc(n.initialAggFunc);
      });
    }, t.prototype.extractRowGroupColumns = function(e, r) {
      this.rowGroupColumns = this.extractColumns(r, this.rowGroupColumns, function(o, n) {
        return o.setRowGroupActive(n, e);
      }, function(o) {
        return o.rowGroupIndex;
      }, function(o) {
        return o.initialRowGroupIndex;
      }, function(o) {
        return o.rowGroup;
      }, function(o) {
        return o.initialRowGroup;
      });
    }, t.prototype.extractColumns = function(e, r, o, n, s, a, l) {
      e === void 0 && (e = []), r === void 0 && (r = []);
      var u = [], c = [];
      (this.primaryColumns || []).forEach(function(h) {
        var g = e.indexOf(h) < 0, y = h.getColDef(), S = eo(a(y)), _ = eo(l(y)), w = Sr(n(y)), E = Sr(s(y)), R, D = S !== void 0, B = w !== void 0, H = _ !== void 0, A = E !== void 0;
        if (D ? R = S : B ? w === null ? R = !1 : R = w >= 0 : g ? H ? R = _ : A ? R = E != null && E >= 0 : R = !1 : R = r.indexOf(h) >= 0, R) {
          var N = g ? w != null || E != null : w != null;
          N ? u.push(h) : c.push(h);
        }
      });
      var p = function(h) {
        var g = n(h.getColDef()), y = s(h.getColDef());
        return g ?? y;
      };
      u.sort(function(h, g) {
        var y = p(h), S = p(g);
        return y === S ? 0 : y < S ? -1 : 1;
      });
      var d = [].concat(u);
      return r.forEach(function(h) {
        c.indexOf(h) >= 0 && d.push(h);
      }), c.forEach(function(h) {
        d.indexOf(h) < 0 && d.push(h);
      }), r.forEach(function(h) {
        d.indexOf(h) < 0 && o(h, !1);
      }), d.forEach(function(h) {
        r.indexOf(h) < 0 && o(h, !0);
      }), d;
    }, t.prototype.extractPivotColumns = function(e, r) {
      this.pivotColumns = this.extractColumns(r, this.pivotColumns, function(o, n) {
        return o.setPivotActive(n, e);
      }, function(o) {
        return o.pivotIndex;
      }, function(o) {
        return o.initialPivotIndex;
      }, function(o) {
        return o.pivot;
      }, function(o) {
        return o.initialPivot;
      });
    }, t.prototype.resetColumnGroupState = function(e) {
      e === void 0 && (e = "api");
      var r = [];
      this.columnUtils.depthFirstOriginalTreeSearch(null, this.primaryColumnTree, function(o) {
        if (o instanceof et) {
          var n = o.getColGroupDef(), s = {
            groupId: o.getGroupId(),
            open: n ? n.openByDefault : void 0
          };
          r.push(s);
        }
      }), this.setColumnGroupState(r, e);
    }, t.prototype.getColumnGroupState = function() {
      var e = [];
      return this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function(r) {
        r instanceof et && e.push({
          groupId: r.getGroupId(),
          open: r.isExpanded()
        });
      }), e;
    }, t.prototype.setColumnGroupState = function(e, r) {
      var o = this;
      r === void 0 && (r = "api"), this.columnAnimationService.start();
      var n = [];
      e.forEach(function(s) {
        var a = s.groupId, l = s.open, u = o.getProvidedColumnGroup(a);
        u && u.isExpanded() !== l && (o.logger.log("columnGroupOpened(" + u.getGroupId() + "," + l + ")"), u.setExpanded(l), n.push(u));
      }), this.updateGroupsAndDisplayedColumns(r), this.setFirstRightAndLastLeftPinned(r), n.forEach(function(s) {
        var a = {
          type: m.EVENT_COLUMN_GROUP_OPENED,
          columnGroup: s
        };
        o.eventService.dispatchEvent(a);
      }), this.columnAnimationService.finish();
    }, t.prototype.setColumnGroupOpened = function(e, r, o) {
      o === void 0 && (o = "api");
      var n;
      e instanceof et ? n = e.getId() : n = e || "", this.setColumnGroupState([{ groupId: n, open: r }], o);
    }, t.prototype.getProvidedColumnGroup = function(e) {
      typeof e != "string" && console.error("AG Grid: group key must be a string");
      var r = null;
      return this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function(o) {
        o instanceof et && o.getId() === e && (r = o);
      }), r;
    }, t.prototype.calculateColumnsForDisplay = function() {
      var e = this, r;
      return this.pivotMode && ue(this.secondaryColumns) ? r = this.gridColumns.filter(function(o) {
        var n = e.groupAutoColumns && _r(e.groupAutoColumns, o), s = e.valueColumns && _r(e.valueColumns, o);
        return n || s;
      }) : r = this.gridColumns.filter(function(o) {
        var n = e.groupAutoColumns && _r(e.groupAutoColumns, o);
        return n || o.isVisible();
      }), r;
    }, t.prototype.checkColSpanActiveInCols = function(e) {
      var r = !1;
      return e.forEach(function(o) {
        k(o.getColDef().colSpan) && (r = !0);
      }), r;
    }, t.prototype.calculateColumnsForGroupDisplay = function() {
      var e = this;
      this.groupDisplayColumns = [], this.groupDisplayColumnsMap = {};
      var r = function(o) {
        var n = o.getColDef(), s = n.showRowGroup;
        n && k(s) && (e.groupDisplayColumns.push(o), typeof s == "string" ? e.groupDisplayColumnsMap[s] = o : s === !0 && e.getRowGroupColumns().forEach(function(a) {
          e.groupDisplayColumnsMap[a.getId()] = o;
        }));
      };
      this.gridColumns.forEach(r), this.groupAutoColumns && this.groupAutoColumns.forEach(r);
    }, t.prototype.getGroupDisplayColumns = function() {
      return this.groupDisplayColumns;
    }, t.prototype.getGroupDisplayColumnForGroup = function(e) {
      return this.groupDisplayColumnsMap[e];
    }, t.prototype.updateDisplayedColumns = function(e) {
      var r = this.calculateColumnsForDisplay();
      this.buildDisplayedTrees(r), this.calculateColumnsForGroupDisplay(), this.updateGroupsAndDisplayedColumns(e), this.setFirstRightAndLastLeftPinned(e);
    }, t.prototype.isSecondaryColumnsPresent = function() {
      return k(this.secondaryColumns);
    }, t.prototype.setSecondaryColumns = function(e, r) {
      var o = this;
      r === void 0 && (r = "api");
      var n = e && e.length > 0;
      if (!(!n && ue(this.secondaryColumns))) {
        if (n) {
          this.processSecondaryColumnDefinitions(e);
          var s = this.columnFactory.createColumnTree(e, !1, this.secondaryBalancedTree || this.previousSecondaryColumns || void 0);
          this.destroyOldColumns(this.secondaryBalancedTree, s.columnTree), this.secondaryBalancedTree = s.columnTree, this.secondaryHeaderRowCount = s.treeDept + 1, this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree), this.secondaryColumnsMap = {}, this.secondaryColumns.forEach(function(a) {
            return o.secondaryColumnsMap[a.getId()] = a;
          }), this.previousSecondaryColumns = null;
        } else
          this.previousSecondaryColumns = this.secondaryBalancedTree, this.secondaryBalancedTree = null, this.secondaryHeaderRowCount = -1, this.secondaryColumns = null, this.secondaryColumnsMap = {};
        this.updateGridColumns(), this.updateDisplayedColumns(r);
      }
    }, t.prototype.processSecondaryColumnDefinitions = function(e) {
      var r = this.gridOptionsService.get("processPivotResultColDef") || this.gridOptionsService.get("processSecondaryColDef"), o = this.gridOptionsService.get("processPivotResultColGroupDef") || this.gridOptionsService.get("processSecondaryColGroupDef");
      if (!(!r && !o)) {
        var n = function(s) {
          s.forEach(function(a) {
            var l = k(a.children);
            if (l) {
              var u = a;
              o && o(u), n(u.children);
            } else {
              var c = a;
              r && r(c);
            }
          });
        };
        e && n(e);
      }
    }, t.prototype.updateGridColumns = function() {
      var e = this, r = this.gridBalancedTree;
      this.gridColsArePrimary ? this.lastPrimaryOrder = this.gridColumns : this.lastSecondaryOrder = this.gridColumns;
      var o;
      if (this.secondaryColumns && this.secondaryBalancedTree) {
        var n = this.secondaryColumns.every(function(u) {
          return e.gridColumnsMap[u.getColId()] !== void 0;
        });
        this.gridBalancedTree = this.secondaryBalancedTree.slice(), this.gridHeaderRowCount = this.secondaryHeaderRowCount, this.gridColumns = this.secondaryColumns.slice(), this.gridColsArePrimary = !1, n && (o = this.lastSecondaryOrder);
      } else
        this.primaryColumns && (this.gridBalancedTree = this.primaryColumnTree.slice(), this.gridHeaderRowCount = this.primaryHeaderRowCount, this.gridColumns = this.primaryColumns.slice(), this.gridColsArePrimary = !0, o = this.lastPrimaryOrder);
      var s = this.createGroupAutoColumnsIfNeeded();
      if (s && o) {
        var a = ho(this.groupAutoColumns.map(function(u) {
          return [u, !0];
        }));
        o = o.filter(function(u) {
          return !a.has(u);
        }), o = ri(this.groupAutoColumns, o);
      }
      if (this.addAutoGroupToGridColumns(), this.orderGridColsLike(o), this.gridColumns = this.placeLockedColumns(this.gridColumns), this.refreshQuickFilterColumns(), this.clearDisplayedAndViewportColumns(), this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns), this.gridColumnsMap = {}, this.gridColumns.forEach(function(u) {
        return e.gridColumnsMap[u.getId()] = u;
      }), this.setAutoHeightActive(), !No(r, this.gridBalancedTree)) {
        var l = {
          type: m.EVENT_GRID_COLUMNS_CHANGED
        };
        this.eventService.dispatchEvent(l);
      }
    }, t.prototype.setAutoHeightActive = function() {
      if (this.autoHeightActive = this.gridColumns.filter(function(o) {
        return o.isAutoHeight();
      }).length > 0, this.autoHeightActive) {
        this.autoHeightActiveAtLeastOnce = !0;
        var e = this.gridOptionsService.isRowModelType("clientSide") || this.gridOptionsService.isRowModelType("serverSide");
        if (!e) {
          var r = "AG Grid - autoHeight columns only work with Client Side Row Model and Server Side Row Model.";
          Pe(function() {
            return console.warn(r);
          }, "autoHeightActive.wrongRowModel");
        }
      }
    }, t.prototype.orderGridColsLike = function(e) {
      if (!ue(e)) {
        var r = ho(e.map(function(c, p) {
          return [c, p];
        })), o = !0;
        if (this.gridColumns.forEach(function(c) {
          r.has(c) && (o = !1);
        }), !o) {
          var n = ho(this.gridColumns.map(function(c) {
            return [c, !0];
          })), s = e.filter(function(c) {
            return n.has(c);
          }), a = ho(s.map(function(c) {
            return [c, !0];
          })), l = this.gridColumns.filter(function(c) {
            return !a.has(c);
          }), u = s.slice();
          l.forEach(function(c) {
            var p = c.getOriginalParent();
            if (!p) {
              u.push(c);
              return;
            }
            for (var d = []; !d.length && p; ) {
              var h = p.getLeafColumns();
              h.forEach(function(S) {
                var _ = u.indexOf(S) >= 0, w = d.indexOf(S) < 0;
                _ && w && d.push(S);
              }), p = p.getOriginalParent();
            }
            if (!d.length) {
              u.push(c);
              return;
            }
            var g = d.map(function(S) {
              return u.indexOf(S);
            }), y = Math.max.apply(Math, ri(g));
            Di(u, c, y + 1);
          }), this.gridColumns = u;
        }
      }
    }, t.prototype.isPrimaryColumnGroupsPresent = function() {
      return this.primaryHeaderRowCount > 1;
    }, t.prototype.refreshQuickFilterColumns = function() {
      var e, r;
      this.groupAutoColumns ? r = ((e = this.primaryColumns) !== null && e !== void 0 ? e : []).concat(this.groupAutoColumns) : this.primaryColumns && (r = this.primaryColumns), r = r ?? [], this.columnsForQuickFilter = this.gridOptionsService.is("excludeHiddenColumnsFromQuickFilter") ? r.filter(function(o) {
        return o.isVisible() || o.isRowGroupActive();
      }) : r;
    }, t.prototype.placeLockedColumns = function(e) {
      var r = [], o = [], n = [];
      return e.forEach(function(s) {
        var a = s.getColDef().lockPosition;
        a === "right" ? n.push(s) : a === "left" || a === !0 ? r.push(s) : o.push(s);
      }), ri(r, o, n);
    }, t.prototype.addAutoGroupToGridColumns = function() {
      if (ue(this.groupAutoColumns)) {
        this.destroyOldColumns(this.groupAutoColsBalancedTree), this.groupAutoColsBalancedTree = null;
        return;
      }
      this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
      var e = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
      this.destroyOldColumns(this.groupAutoColsBalancedTree, e), this.groupAutoColsBalancedTree = e, this.gridBalancedTree = e.concat(this.gridBalancedTree);
    }, t.prototype.clearDisplayedAndViewportColumns = function() {
      this.viewportRowLeft = {}, this.viewportRowRight = {}, this.viewportRowCenter = {}, this.displayedColumnsLeft = [], this.displayedColumnsRight = [], this.displayedColumnsCenter = [], this.displayedColumns = [], this.viewportColumns = [], this.headerViewportColumns = [], this.viewportColumnsHash = "";
    }, t.prototype.updateGroupsAndDisplayedColumns = function(e) {
      this.updateOpenClosedVisibilityInColumnGroups(), this.deriveDisplayedColumns(e), this.refreshFlexedColumns(), this.extractViewport(), this.updateBodyWidths();
      var r = {
        type: m.EVENT_DISPLAYED_COLUMNS_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.deriveDisplayedColumns = function(e) {
      this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft), this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter), this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight), this.joinDisplayedColumns(), this.setLeftValues(e), this.displayedAutoHeightCols = this.displayedColumns.filter(function(r) {
        return r.isAutoHeight();
      });
    }, t.prototype.isAutoRowHeightActive = function() {
      return this.autoHeightActive;
    }, t.prototype.wasAutoRowHeightEverActive = function() {
      return this.autoHeightActiveAtLeastOnce;
    }, t.prototype.joinDisplayedColumns = function() {
      this.gridOptionsService.is("enableRtl") ? this.displayedColumns = this.displayedColumnsRight.concat(this.displayedColumnsCenter).concat(this.displayedColumnsLeft) : this.displayedColumns = this.displayedColumnsLeft.concat(this.displayedColumnsCenter).concat(this.displayedColumnsRight);
    }, t.prototype.setLeftValues = function(e) {
      this.setLeftValuesOfColumns(e), this.setLeftValuesOfGroups();
    }, t.prototype.setLeftValuesOfColumns = function(e) {
      var r = this;
      if (this.primaryColumns) {
        var o = this.primaryColumns.slice(0), n = this.gridOptionsService.is("enableRtl");
        [
          this.displayedColumnsLeft,
          this.displayedColumnsRight,
          this.displayedColumnsCenter
        ].forEach(function(s) {
          if (n) {
            var a = r.getWidthOfColsInList(s);
            s.forEach(function(u) {
              a -= u.getActualWidth(), u.setLeft(a, e);
            });
          } else {
            var l = 0;
            s.forEach(function(u) {
              u.setLeft(l, e), l += u.getActualWidth();
            });
          }
          xu(o, s);
        }), o.forEach(function(s) {
          s.setLeft(null, e);
        });
      }
    }, t.prototype.setLeftValuesOfGroups = function() {
      [
        this.displayedTreeLeft,
        this.displayedTreeRight,
        this.displayedTreeCentre
      ].forEach(function(e) {
        e.forEach(function(r) {
          if (r instanceof qt) {
            var o = r;
            o.checkLeft();
          }
        });
      });
    }, t.prototype.derivedDisplayedColumnsFromDisplayedTree = function(e, r) {
      r.length = 0, this.columnUtils.depthFirstDisplayedColumnTreeSearch(e, function(o) {
        o instanceof $e && r.push(o);
      });
    }, t.prototype.extractViewportColumns = function() {
      this.suppressColumnVirtualisation ? (this.viewportColumnsCenter = this.displayedColumnsCenter, this.headerViewportColumnsCenter = this.displayedColumnsCenter) : (this.viewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this)), this.headerViewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this))), this.viewportColumns = this.viewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight), this.headerViewportColumns = this.headerViewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
    }, t.prototype.getVirtualHeaderGroupRow = function(e, r) {
      var o;
      switch (e) {
        case "left":
          o = this.viewportRowLeft[r];
          break;
        case "right":
          o = this.viewportRowRight[r];
          break;
        default:
          o = this.viewportRowCenter[r];
          break;
      }
      return ue(o) && (o = []), o;
    }, t.prototype.calculateHeaderRows = function() {
      this.viewportRowLeft = {}, this.viewportRowRight = {}, this.viewportRowCenter = {};
      var e = {};
      this.headerViewportColumns.forEach(function(o) {
        return e[o.getId()] = !0;
      });
      var r = function(o, n, s) {
        for (var a = !1, l = 0; l < o.length; l++) {
          var u = o[l], c = !1;
          if (u instanceof $e)
            c = e[u.getId()] === !0;
          else {
            var p = u, d = p.getDisplayedChildren();
            d && (c = r(d, n, s + 1));
          }
          c && (a = !0, n[s] || (n[s] = []), n[s].push(u));
        }
        return a;
      };
      r(this.displayedTreeLeft, this.viewportRowLeft, 0), r(this.displayedTreeRight, this.viewportRowRight, 0), r(this.displayedTreeCentre, this.viewportRowCenter, 0);
    }, t.prototype.extractViewport = function() {
      var e = function(n) {
        return n.getId() + "-" + (n.getPinned() || "normal");
      };
      this.extractViewportColumns();
      var r = this.viewportColumns.map(e).join("#"), o = this.viewportColumnsHash !== r;
      return o && (this.viewportColumnsHash = r, this.calculateHeaderRows()), o;
    }, t.prototype.refreshFlexedColumns = function(e) {
      var r = this;
      e === void 0 && (e = {});
      var o = e.source ? e.source : "flex";
      if (e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth), !this.flexViewportWidth)
        return [];
      var n = -1;
      e.resizingCols && e.resizingCols.forEach(function(R) {
        var D = r.displayedColumnsCenter.indexOf(R);
        n < D && (n = D);
      });
      var s = function(R) {
        var D = r.displayedColumnsCenter.indexOf(R) > n;
        return R.getFlex() && D;
      }, a = this.displayedColumnsCenter.filter(function(R) {
        return !s(R);
      }), l = this.displayedColumnsCenter.filter(function(R) {
        return s(R);
      }), u = [];
      if (!l.length)
        return [];
      var c = [], p;
      e:
        for (; ; ) {
          var d = l.reduce(function(R, D) {
            return R + D.getFlex();
          }, 0);
          p = this.flexViewportWidth - this.getWidthOfColsInList(a);
          for (var h = 0; h < l.length; h++) {
            var g = l[h], y = p * g.getFlex() / d, S = 0, _ = g.getMinWidth(), w = g.getMaxWidth();
            if (k(_) && y < _ ? S = _ : k(w) && y > w && (S = w), S) {
              g.setActualWidth(S, o), Vt(l, g), u.push(g), a.push(g);
              continue e;
            }
            c[h] = Math.round(y);
          }
          break;
        }
      var E = p;
      return l.forEach(function(R, D) {
        R.setActualWidth(Math.min(c[D], E), o), u.push(R), E -= c[D];
      }), e.skipSetLeft || this.setLeftValues(o), e.updateBodyWidths && this.updateBodyWidths(), e.fireResizedEvent && this.dispatchColumnResizedEvent(u, !0, o, l), l;
    }, t.prototype.sizeColumnsToFit = function(e, r, o, n) {
      var s, a, l, u, c;
      r === void 0 && (r = "sizeColumnsToFit");
      var p = {};
      n && ((s = n == null ? void 0 : n.columnLimits) === null || s === void 0 || s.forEach(function(ne) {
        var fe = ne.key, ce = Jm(ne, ["key"]);
        p[typeof fe == "string" ? fe : fe.getColId()] = ce;
      }));
      var d = this.getAllDisplayedColumns(), h = e === this.getWidthOfColsInList(d);
      if (!(e <= 0 || !d.length || h)) {
        var g = [], y = [];
        d.forEach(function(ne) {
          ne.getColDef().suppressSizeToFit === !0 ? y.push(ne) : g.push(ne);
        });
        var S = g.slice(0), _ = !1, w = function(ne) {
          Vt(g, ne), y.push(ne);
        };
        for (g.forEach(function(ne) {
          return ne.resetActualWidth(r);
        }); !_; ) {
          _ = !0;
          var E = e - this.getWidthOfColsInList(y);
          if (E <= 0)
            g.forEach(function(ne) {
              var fe, ce, se = (ce = (fe = p == null ? void 0 : p[ne.getId()]) === null || fe === void 0 ? void 0 : fe.minWidth) !== null && ce !== void 0 ? ce : n == null ? void 0 : n.defaultMinWidth;
              if (typeof se == "number") {
                ne.setActualWidth(se);
                return;
              }
              ne.setMinimum(r);
            });
          else
            for (var R = E / this.getWidthOfColsInList(g), D = E, B = g.length - 1; B >= 0; B--) {
              var H = g[B], A = p == null ? void 0 : p[H.getId()], N = (a = A == null ? void 0 : A.minWidth) !== null && a !== void 0 ? a : n == null ? void 0 : n.defaultMinWidth, G = (l = A == null ? void 0 : A.maxWidth) !== null && l !== void 0 ? l : n == null ? void 0 : n.defaultMaxWidth, W = (u = H.getMinWidth()) !== null && u !== void 0 ? u : 0, J = (c = H.getMaxWidth()) !== null && c !== void 0 ? c : Number.MAX_VALUE, de = typeof N == "number" && N > W ? N : H.getMinWidth(), ve = typeof G == "number" && G < J ? G : H.getMaxWidth(), oe = Math.round(H.getActualWidth() * R);
              k(de) && oe < de ? (oe = de, w(H), _ = !1) : k(ve) && oe > ve ? (oe = ve, w(H), _ = !1) : B === 0 && (oe = D), H.setActualWidth(oe, r, !0), D -= oe;
            }
        }
        S.forEach(function(ne) {
          ne.fireColumnWidthChangedEvent(r);
        }), this.setLeftValues(r), this.updateBodyWidths(), !o && this.dispatchColumnResizedEvent(S, !0, r);
      }
    }, t.prototype.buildDisplayedTrees = function(e) {
      var r = [], o = [], n = [];
      e.forEach(function(a) {
        switch (a.getPinned()) {
          case "left":
            r.push(a);
            break;
          case "right":
            o.push(a);
            break;
          default:
            n.push(a);
            break;
        }
      });
      var s = new Iu();
      this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(r, this.gridBalancedTree, s, "left", this.displayedTreeLeft), this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(o, this.gridBalancedTree, s, "right", this.displayedTreeRight), this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(n, this.gridBalancedTree, s, null, this.displayedTreeCentre), this.updateDisplayedMap();
    }, t.prototype.updateDisplayedMap = function() {
      var e = this;
      this.displayedColumnsAndGroupsMap = {};
      var r = function(o) {
        e.displayedColumnsAndGroupsMap[o.getUniqueId()] = o;
      };
      this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeCentre, r), this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeLeft, r), this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeRight, r);
    }, t.prototype.isDisplayed = function(e) {
      var r = this.displayedColumnsAndGroupsMap[e.getUniqueId()];
      return r === e;
    }, t.prototype.updateOpenClosedVisibilityInColumnGroups = function() {
      var e = this.getAllDisplayedTrees();
      this.columnUtils.depthFirstAllColumnTreeSearch(e, function(r) {
        if (r instanceof qt) {
          var o = r;
          o.calculateDisplayedColumns();
        }
      });
    }, t.prototype.getGroupAutoColumns = function() {
      return this.groupAutoColumns;
    }, t.prototype.createGroupAutoColumnsIfNeeded = function() {
      if (!this.autoGroupsNeedBuilding)
        return !1;
      this.autoGroupsNeedBuilding = !1;
      var e = this.gridOptionsService.isGroupUseEntireRow(this.pivotMode), r = this.pivotMode ? this.gridOptionsService.is("pivotSuppressAutoColumn") : this.isGroupSuppressAutoColumn(), o = this.rowGroupColumns.length > 0 || this.usingTreeData, n = o && !r && !e;
      if (n) {
        var s = this.groupAutoColumns || [], a = this.autoGroupColService.createAutoGroupColumns(s, this.rowGroupColumns), l = !this.autoColsEqual(a, this.groupAutoColumns);
        if (l || this.forceRecreateAutoGroups)
          return this.groupAutoColumns = a, !0;
      } else
        this.groupAutoColumns = null;
      return !1;
    }, t.prototype.isGroupSuppressAutoColumn = function() {
      var e = this.gridOptionsService.get("groupDisplayType"), r = e ? nu("custom", e) : !1;
      if (r)
        return !0;
      var o = this.gridOptionsService.get("treeDataDisplayType");
      return o ? Vm("custom", o) : !1;
    }, t.prototype.autoColsEqual = function(e, r) {
      return No(e, r, function(o, n) {
        return o.getColId() === n.getColId();
      });
    }, t.prototype.getWidthOfColsInList = function(e) {
      return e.reduce(function(r, o) {
        return r + o.getActualWidth();
      }, 0);
    }, t.prototype.getGridBalancedTree = function() {
      return this.gridBalancedTree;
    }, t.prototype.hasFloatingFilters = function() {
      if (!this.gridColumns)
        return !1;
      var e = this.gridColumns.some(function(r) {
        return r.getColDef().floatingFilter;
      });
      return e;
    }, t.prototype.getFirstDisplayedColumn = function() {
      var e = this.gridOptionsService.is("enableRtl"), r = [
        "getDisplayedLeftColumns",
        "getDisplayedCenterColumns",
        "getDisplayedRightColumns"
      ];
      e && r.reverse();
      for (var o = 0; o < r.length; o++) {
        var n = this[r[o]]();
        if (n.length)
          return e ? Ne(n) : n[0];
      }
      return null;
    }, t.prototype.setColumnHeaderHeight = function(e, r) {
      var o = e.setAutoHeaderHeight(r);
      if (o) {
        var n = {
          type: m.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
          column: e,
          columns: [e],
          source: "autosizeColumnHeaderHeight"
        };
        this.eventService.dispatchEvent(n);
      }
    }, t.prototype.getColumnGroupHeaderRowHeight = function() {
      return this.isPivotMode() ? this.getPivotGroupHeaderHeight() : this.getGroupHeaderHeight();
    }, t.prototype.getColumnHeaderRowHeight = function() {
      var e = this.isPivotMode() ? this.getPivotHeaderHeight() : this.getHeaderHeight(), r = this.getAllDisplayedColumns().filter(function(o) {
        return o.isAutoHeaderHeight();
      }).map(function(o) {
        return o.getAutoHeaderHeight() || 0;
      });
      return Math.max.apply(Math, ri([e], r));
    }, t.prototype.getHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.getNum("headerHeight")) !== null && e !== void 0 ? e : this.environment.getFromTheme(25, "headerHeight");
    }, t.prototype.getFloatingFiltersHeight = function() {
      var e;
      return (e = this.gridOptionsService.getNum("floatingFiltersHeight")) !== null && e !== void 0 ? e : this.getHeaderHeight();
    }, t.prototype.getGroupHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.getNum("groupHeaderHeight")) !== null && e !== void 0 ? e : this.getHeaderHeight();
    }, t.prototype.getPivotHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.getNum("pivotHeaderHeight")) !== null && e !== void 0 ? e : this.getHeaderHeight();
    }, t.prototype.getPivotGroupHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.getNum("pivotGroupHeaderHeight")) !== null && e !== void 0 ? e : this.getGroupHeaderHeight();
    }, Mt([
      v("expressionService")
    ], t.prototype, "expressionService", void 0), Mt([
      v("columnFactory")
    ], t.prototype, "columnFactory", void 0), Mt([
      v("displayedGroupCreator")
    ], t.prototype, "displayedGroupCreator", void 0), Mt([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Mt([
      v("autoWidthCalculator")
    ], t.prototype, "autoWidthCalculator", void 0), Mt([
      v("columnUtils")
    ], t.prototype, "columnUtils", void 0), Mt([
      v("columnAnimationService")
    ], t.prototype, "columnAnimationService", void 0), Mt([
      v("autoGroupColService")
    ], t.prototype, "autoGroupColService", void 0), Mt([
      Fe("aggFuncService")
    ], t.prototype, "aggFuncService", void 0), Mt([
      Fe("valueCache")
    ], t.prototype, "valueCache", void 0), Mt([
      Fe("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), Mt([
      v("sortController")
    ], t.prototype, "sortController", void 0), Mt([
      v("columnDefFactory")
    ], t.prototype, "columnDefFactory", void 0), Mt([
      U
    ], t.prototype, "init", null), Mt([
      At
    ], t.prototype, "destroyColumns", null), Mt([
      Qm(0, Bt("loggerFactory"))
    ], t.prototype, "setBeans", null), t = Mt([
      te("columnModel")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var eC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tC = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Sf = (
  /** @class */
  function(i) {
    eC(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.calculateColMinWidth = function(e) {
      return e.minWidth != null ? e.minWidth : this.environment.getMinColWidth();
    }, t.prototype.calculateColMaxWidth = function(e) {
      return e.maxWidth != null ? e.maxWidth : Number.MAX_SAFE_INTEGER;
    }, t.prototype.calculateColInitialWidth = function(e) {
      var r = this.calculateColMinWidth(e), o = this.calculateColMaxWidth(e), n, s = Sr(e.width), a = Sr(e.initialWidth);
      return s != null ? n = s : a != null ? n = a : n = 200, Math.max(Math.min(n, o), r);
    }, t.prototype.getOriginalPathForColumn = function(e, r) {
      var o = [], n = !1, s = function(a, l) {
        for (var u = 0; u < a.length; u++) {
          if (n)
            return;
          var c = a[u];
          if (c instanceof et) {
            var p = c;
            s(p.getChildren(), l + 1), o[l] = c;
          } else
            c === e && (n = !0);
        }
      };
      return s(r, 0), n ? o : null;
    }, t.prototype.depthFirstOriginalTreeSearch = function(e, r, o) {
      var n = this;
      r && r.forEach(function(s) {
        s instanceof et && n.depthFirstOriginalTreeSearch(s, s.getChildren(), o), o(s, e);
      });
    }, t.prototype.depthFirstAllColumnTreeSearch = function(e, r) {
      var o = this;
      e && e.forEach(function(n) {
        n instanceof qt && o.depthFirstAllColumnTreeSearch(n.getChildren(), r), r(n);
      });
    }, t.prototype.depthFirstDisplayedColumnTreeSearch = function(e, r) {
      var o = this;
      e && e.forEach(function(n) {
        n instanceof qt && o.depthFirstDisplayedColumnTreeSearch(n.getDisplayedChildren(), r), r(n);
      });
    }, t = tC([
      te("columnUtils")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var rC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), oC = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, _f = (
  /** @class */
  function(i) {
    rC(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.createDisplayedGroups = function(e, r, o, n, s) {
      var a = this, l = [], u, c, p = this.mapOldGroupsById(s);
      return e.forEach(function(d) {
        for (var h = a.getOriginalPathForColumn(r, d), g = [], y = !c, S = 0; S < h.length; S++)
          if (y || h[S] !== c[S]) {
            var _ = a.createColumnGroup(h[S], o, p, n);
            g[S] = _, S == 0 ? l.push(_) : g[S - 1].addChild(_);
          } else
            g[S] = u[S];
        var w = g.length === 0;
        if (w)
          l.push(d);
        else {
          var E = Ne(g);
          E.addChild(d);
        }
        u = g, c = h;
      }), this.setupParentsIntoColumns(l, null), l;
    }, t.prototype.createColumnGroup = function(e, r, o, n) {
      var s = e.getGroupId(), a = r.getInstanceIdForKey(s), l = qt.createUniqueId(s, a), u = o[l];
      return u && u.getProvidedColumnGroup() !== e && (u = null), k(u) ? u.reset() : (u = new qt(e, s, a, n), this.context.createBean(u)), u;
    }, t.prototype.mapOldGroupsById = function(e) {
      var r = {}, o = function(n) {
        n.forEach(function(s) {
          if (s instanceof qt) {
            var a = s;
            r[s.getUniqueId()] = a, o(a.getChildren());
          }
        });
      };
      return e && o(e), r;
    }, t.prototype.setupParentsIntoColumns = function(e, r) {
      var o = this;
      e.forEach(function(n) {
        if (n.setParent(r), n instanceof qt) {
          var s = n;
          o.setupParentsIntoColumns(s.getChildren(), s);
        }
      });
    }, t.prototype.getOriginalPathForColumn = function(e, r) {
      var o = [], n = !1, s = function(a, l) {
        for (var u = 0; u < a.length; u++) {
          if (n)
            return;
          var c = a[u];
          c instanceof et ? (s(c.getChildren(), l + 1), o[l] = c) : c === r && (n = !0);
        }
      };
      return s(e, 0), n ? o : (console.warn("AG Grid: could not get path"), null);
    }, t = oC([
      te("displayedGroupCreator")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var nC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), iC = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ef = (
  /** @class */
  function(i) {
    nC(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.componentsMappedByName = {}, e;
    }
    return t.prototype.setupComponents = function(e) {
      var r = this;
      e && e.forEach(function(o) {
        return r.addComponent(o);
      });
    }, t.prototype.addComponent = function(e) {
      var r = e.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), o = r.toUpperCase();
      this.componentsMappedByName[o] = e.componentClass;
    }, t.prototype.getComponentClass = function(e) {
      return this.componentsMappedByName[e];
    }, t = iC([
      te("agStackComponentsRegistry")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function Co(i, t, e) {
  e == null || e == "" ? Lu(i, t) : Rr(i, t, e);
}
function Rr(i, t, e) {
  i.setAttribute(Rf(t), e.toString());
}
function Lu(i, t) {
  i.removeAttribute(Rf(t));
}
function Rf(i) {
  return "aria-" + i;
}
function Dt(i, t) {
  t ? i.setAttribute("role", t) : i.removeAttribute("role");
}
function Of(i) {
  var t;
  return i === "asc" ? t = "ascending" : i === "desc" ? t = "descending" : i === "mixed" ? t = "other" : t = "none", t;
}
function bf(i) {
  return parseInt(i.getAttribute("aria-level"), 10);
}
function Tf(i) {
  return parseInt(i.getAttribute("aria-posinset"), 10);
}
function sC(i) {
  return i.getAttribute("aria-describedby") || "";
}
function yn(i, t) {
  Co(i, "label", t);
}
function Nu(i, t) {
  Co(i, "labelledby", t);
}
function Pf(i, t) {
  Co(i, "description", t);
}
function Df(i, t) {
  Co(i, "describedby", t);
}
function aC(i, t) {
  Co(i, "live", t);
}
function Af(i, t) {
  Co(i, "level", t);
}
function Gu(i, t) {
  Co(i, "disabled", t);
}
function ba(i, t) {
  Co(i, "hidden", t);
}
function Vr(i, t) {
  Rr(i, "expanded", t);
}
function xf(i) {
  Lu(i, "expanded");
}
function Hu(i, t) {
  Rr(i, "setsize", t);
}
function Vu(i, t) {
  Rr(i, "posinset", t);
}
function Ff(i, t) {
  Rr(i, "multiselectable", t);
}
function Mf(i, t) {
  Rr(i, "rowcount", t);
}
function Bu(i, t) {
  Rr(i, "rowindex", t);
}
function If(i, t) {
  Rr(i, "colcount", t);
}
function ku(i, t) {
  Rr(i, "colindex", t);
}
function Lf(i, t) {
  Rr(i, "colspan", t);
}
function Nf(i, t) {
  Rr(i, "sort", t);
}
function Gf(i) {
  Lu(i, "sort");
}
function $n(i, t) {
  Co(i, "selected", t);
}
function Hf(i, t) {
  Rr(i, "checked", t === void 0 ? "mixed" : t);
}
var lC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  setAriaRole: Dt,
  getAriaSortState: Of,
  getAriaLevel: bf,
  getAriaPosInSet: Tf,
  getAriaDescribedBy: sC,
  setAriaLabel: yn,
  setAriaLabelledBy: Nu,
  setAriaDescription: Pf,
  setAriaDescribedBy: Df,
  setAriaLive: aC,
  setAriaLevel: Af,
  setAriaDisabled: Gu,
  setAriaHidden: ba,
  setAriaExpanded: Vr,
  removeAriaExpanded: xf,
  setAriaSetSize: Hu,
  setAriaPosInSet: Vu,
  setAriaMultiSelectable: Ff,
  setAriaRowCount: Mf,
  setAriaRowIndex: Bu,
  setAriaColCount: If,
  setAriaColIndex: ku,
  setAriaColSpan: Lf,
  setAriaSort: Nf,
  removeAriaSort: Gf,
  setAriaSelected: $n,
  setAriaChecked: Hf
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ol, as, nl, il, sl, al, iu, su;
function ao() {
  return ol === void 0 && (ol = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), ol;
}
function ju() {
  if (as === void 0)
    if (ao()) {
      var i = navigator.userAgent.match(/version\/(\d+)/i);
      i && (as = i[1] != null ? parseFloat(i[1]) : 0);
    } else
      as = 0;
  return as;
}
function Bi() {
  if (nl === void 0) {
    var i = window;
    nl = !!i.chrome && (!!i.chrome.webstore || !!i.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
  return nl;
}
function Wu() {
  return il === void 0 && (il = /(firefox)/i.test(navigator.userAgent)), il;
}
function Uu() {
  return sl === void 0 && (sl = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), sl;
}
function jo() {
  return al === void 0 && (al = /iPad|iPhone|iPod/.test(navigator.platform) || // eslint-disable-next-line
  navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), al;
}
function Ta() {
  return !ao() || ju() >= 15;
}
function Xs(i) {
  if (!i)
    return null;
  var t = i.tabIndex, e = i.getAttribute("tabIndex");
  return t === -1 && (e === null || e === "" && !Wu()) ? null : t.toString();
}
function Vf() {
  if (!document.body)
    return -1;
  var i = 1e6, t = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9, e = document.createElement("div");
  for (document.body.appendChild(e); ; ) {
    var r = i * 2;
    if (e.style.height = r + "px", r > t || e.clientHeight !== r)
      break;
    i = r;
  }
  return document.body.removeChild(e), i;
}
function Bf() {
  var i, t, e;
  return (t = (i = document.body) === null || i === void 0 ? void 0 : i.clientWidth) !== null && t !== void 0 ? t : window.innerHeight || ((e = document.documentElement) === null || e === void 0 ? void 0 : e.clientWidth) || -1;
}
function kf() {
  var i, t, e;
  return (t = (i = document.body) === null || i === void 0 ? void 0 : i.clientHeight) !== null && t !== void 0 ? t : window.innerHeight || ((e = document.documentElement) === null || e === void 0 ? void 0 : e.clientHeight) || -1;
}
function jf() {
  return su == null && Wf(), su;
}
function Wf() {
  var i = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", i.appendChild(t);
  var e = t.offsetWidth - t.clientWidth;
  e === 0 && t.clientWidth === 0 && (e = null), t.parentNode && t.parentNode.removeChild(t), e != null && (su = e, iu = e === 0);
}
function kn() {
  return iu == null && Wf(), iu;
}
var uC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isBrowserSafari: ao,
  getSafariVersion: ju,
  isBrowserChrome: Bi,
  isBrowserFirefox: Wu,
  isMacOsUserAgent: Uu,
  isIOSUserAgent: jo,
  browserSupportsPreventScroll: Ta,
  getTabIndex: Xs,
  getMaxDivHeight: Vf,
  getBodyWidth: Bf,
  getBodyHeight: kf,
  getScrollbarWidth: jf,
  isInvisibleScrollbar: kn
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function jn(i, t) {
  return i.toString().padStart(t, "0");
}
function Uf(i, t) {
  for (var e = [], r = i; r <= t; r++)
    e.push(r);
  return e;
}
function cC(i) {
  return typeof i == "string" && (i = parseInt(i, 10)), typeof i == "number" ? Math.floor(i) : null;
}
function pC(i, t) {
  for (var e = "", r = 0; r < t; r++)
    e += String.fromCharCode(i & 255), i >>>= 8;
  return e;
}
function dC(i, t, e) {
  return typeof i != "number" ? "" : zu(Math.round(i * 100) / 100, t, e);
}
function zu(i, t, e) {
  return typeof i != "number" ? "" : i.toString().replace(".", e).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + t);
}
function fC(i) {
  return i == null ? null : i.reduce(function(t, e) {
    return t + e;
  }, 0);
}
function hC(i, t) {
  return i >= 0 ? i : t;
}
function vC(i, t) {
  var e = parseInt(i, 10);
  return !isNaN(e) && isFinite(e) && e > 0 ? e : t;
}
var gC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  padStartWidthZeros: jn,
  createArrayOfNumbers: Uf,
  cleanNumber: cC,
  decToHex: pC,
  formatNumberTwoDecimalPlacesAndCommas: dC,
  formatNumberCommas: zu,
  sum: fC,
  zeroOrGreater: hC,
  oneOrGreater: vC
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ll = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
};
function Ai(i, t, e) {
  if (t === void 0 && (t = !0), e === void 0 && (e = "-"), !i)
    return null;
  var r = [i.getFullYear(), i.getMonth() + 1, i.getDate()].map(function(o) {
    return jn(o, 2);
  }).join(e);
  return t && (r += " " + [i.getHours(), i.getMinutes(), i.getSeconds()].map(function(o) {
    return jn(o, 2);
  }).join(":")), r;
}
var ul = function(i) {
  if (i > 3 && i < 21)
    return "th";
  var t = i % 10;
  switch (t) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
  }
  return "th";
};
function Bs(i, t) {
  t === void 0 && (t = "YYYY-MM-DD");
  var e = jn(i.getFullYear(), 4), r = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ], o = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ], n = {
    YYYY: function() {
      return e.slice(e.length - 4, e.length);
    },
    YY: function() {
      return e.slice(e.length - 2, e.length);
    },
    Y: function() {
      return "" + i.getFullYear();
    },
    MMMM: function() {
      return r[i.getMonth()];
    },
    MMM: function() {
      return r[i.getMonth()].slice(0, 3);
    },
    MM: function() {
      return jn(i.getMonth() + 1, 2);
    },
    Mo: function() {
      return "" + (i.getMonth() + 1) + ul(i.getMonth() + 1);
    },
    M: function() {
      return "" + (i.getMonth() + 1);
    },
    Do: function() {
      return "" + i.getDate() + ul(i.getDate());
    },
    DD: function() {
      return jn(i.getDate(), 2);
    },
    D: function() {
      return "" + i.getDate();
    },
    dddd: function() {
      return o[i.getDay()];
    },
    ddd: function() {
      return o[i.getDay()].slice(0, 3);
    },
    dd: function() {
      return o[i.getDay()].slice(0, 2);
    },
    do: function() {
      return "" + i.getDay() + ul(i.getDay());
    },
    d: function() {
      return "" + i.getDay();
    }
  }, s = new RegExp(Object.keys(n).join("|"), "g");
  return t.replace(s, function(a) {
    return a in n ? n[a]() : a;
  });
}
function Bo(i) {
  if (!i)
    return null;
  var t = ll(i.split(" "), 2), e = t[0], r = t[1];
  if (!e)
    return null;
  var o = e.split("-").map(function(g) {
    return parseInt(g, 10);
  });
  if (o.filter(function(g) {
    return !isNaN(g);
  }).length !== 3)
    return null;
  var n = ll(o, 3), s = n[0], a = n[1], l = n[2], u = new Date(s, a - 1, l);
  if (u.getFullYear() !== s || u.getMonth() !== a - 1 || u.getDate() !== l)
    return null;
  if (!r || r === "00:00:00")
    return u;
  var c = ll(r.split(":").map(function(g) {
    return parseInt(g, 10);
  }), 3), p = c[0], d = c[1], h = c[2];
  return p >= 0 && p < 24 && u.setHours(p), d >= 0 && d < 60 && u.setMinutes(d), h >= 0 && h < 60 && u.setSeconds(h), u;
}
var yC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  serialiseDate: Ai,
  dateToFormattedString: Bs,
  parseDateTimeFromString: Bo
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var mC = function(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], r = 0;
  if (e)
    return e.call(i);
  if (i && typeof i.length == "number")
    return {
      next: function() {
        return i && r >= i.length && (i = void 0), { value: i && i[r++], done: !i };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, CC = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, ls;
function wC(i, t, e) {
  for (var r = i.parentElement, o = r && r.firstChild; o; )
    t && o.classList.toggle(t, o === i), e && o.classList.toggle(e, o !== i), o = o.nextSibling;
}
var zf = "[tabindex], input, select, button, textarea, [href]", $u = ".ag-hidden, .ag-hidden *, [disabled], .ag-disabled, .ag-disabled *";
function Ku(i) {
  var t = Element.prototype.matches || Element.prototype.msMatchesSelector, e = "input, select, button, textarea", r = t.call(i, e), o = t.call(i, $u), n = qn(i), s = r && !o && n;
  return s;
}
function be(i, t, e) {
  e === void 0 && (e = {});
  var r = e.skipAriaHidden;
  i.classList.toggle("ag-hidden", !t), r || ba(i, !t);
}
function $f(i, t, e) {
  e === void 0 && (e = {});
  var r = e.skipAriaHidden;
  i.classList.toggle("ag-invisible", !t), r || ba(i, !t);
}
function Kn(i, t) {
  var e = "disabled", r = t ? function(o) {
    return o.setAttribute(e, "");
  } : function(o) {
    return o.removeAttribute(e);
  };
  r(i), Zu(i.querySelectorAll("input"), function(o) {
    return r(o);
  });
}
function un(i, t, e) {
  for (var r = 0; i; ) {
    if (i.classList.contains(t))
      return !0;
    if (i = i.parentElement, typeof e == "number") {
      if (++r > e)
        break;
    } else if (i === e)
      break;
  }
  return !1;
}
function mn(i) {
  var t = window.getComputedStyle(i), e = t.height, r = t.width, o = t.borderTopWidth, n = t.borderRightWidth, s = t.borderBottomWidth, a = t.borderLeftWidth, l = t.paddingTop, u = t.paddingRight, c = t.paddingBottom, p = t.paddingLeft, d = t.marginTop, h = t.marginRight, g = t.marginBottom, y = t.marginLeft, S = t.boxSizing;
  return {
    height: parseFloat(e),
    width: parseFloat(r),
    borderTopWidth: parseFloat(o),
    borderRightWidth: parseFloat(n),
    borderBottomWidth: parseFloat(s),
    borderLeftWidth: parseFloat(a),
    paddingTop: parseFloat(l),
    paddingRight: parseFloat(u),
    paddingBottom: parseFloat(c),
    paddingLeft: parseFloat(p),
    marginTop: parseFloat(d),
    marginRight: parseFloat(h),
    marginBottom: parseFloat(g),
    marginLeft: parseFloat(y),
    boxSizing: S
  };
}
function ki(i) {
  var t = mn(i);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom : t.height;
}
function Pa(i) {
  var t = mn(i);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight : t.width;
}
function Yu(i) {
  var t = mn(i), e = t.marginBottom + t.marginTop;
  return Math.ceil(i.offsetHeight + e);
}
function Da(i) {
  var t = mn(i), e = t.marginLeft + t.marginRight;
  return Math.ceil(i.offsetWidth + e);
}
function xi() {
  if (typeof ls == "boolean")
    return ls;
  var i = document.createElement("div");
  return i.style.direction = "rtl", i.style.width = "1px", i.style.height = "1px", i.style.position = "fixed", i.style.top = "0px", i.style.overflow = "hidden", i.dir = "rtl", i.innerHTML = /* html */
  `<div style="width: 2px">
            <span style="display: inline-block; width: 1px"></span>
            <span style="display: inline-block; width: 1px"></span>
        </div>`, document.body.appendChild(i), i.scrollLeft = 1, ls = Math.floor(i.scrollLeft) === 0, document.body.removeChild(i), ls;
}
function Fi(i, t) {
  var e = i.scrollLeft;
  return t && (e = Math.abs(e), Bi() && !xi() && (e = i.scrollWidth - i.clientWidth - e)), e;
}
function Qs(i, t, e) {
  e && (xi() ? t *= -1 : (ao() || Bi()) && (t = i.scrollWidth - i.clientWidth - t)), i.scrollLeft = t;
}
function pr(i) {
  for (; i && i.firstChild; )
    i.removeChild(i.firstChild);
}
function SC(i, t) {
  go(i.querySelector(t));
}
function go(i) {
  i && i.parentNode && i.parentNode.removeChild(i);
}
function qn(i) {
  return i.offsetParent !== null;
}
function Lt(i) {
  var t = document.createElement("div");
  return t.innerHTML = (i || "").trim(), t.firstChild;
}
function _C(i, t) {
  i.lastChild ? i.insertAdjacentHTML("afterbegin", t) : i.innerHTML = t;
}
function EC(i, t) {
  if (i.attributes && i.attributes[t]) {
    var e = i.attributes[t];
    return e.value;
  }
  return null;
}
function au(i) {
  return i && i.clientHeight ? i.clientHeight : 0;
}
function lu(i) {
  return i && i.clientWidth ? i.clientWidth : 0;
}
function qu(i, t, e) {
  if (!(e && e.nextSibling === t)) {
    var r = document.activeElement, o = t.contains(r);
    e ? e.nextSibling ? i.insertBefore(t, e.nextSibling) : i.appendChild(t) : i.firstChild && i.firstChild !== t && i.insertAdjacentElement("afterbegin", t), o && r && Ta() && r.focus({ preventScroll: !0 });
  }
}
function Xu(i, t) {
  for (var e = 0; e < t.length; e++) {
    var r = t[e], o = i.children[e];
    o !== r && i.insertBefore(r, o);
  }
}
function Kf(i, t, e) {
  e ? e.insertAdjacentElement("afterend", t) : i.firstChild ? i.insertAdjacentElement("afterbegin", t) : i.appendChild(t);
}
function RC(i, t) {
  k(i.firstChild) ? i.insertBefore(t, i.firstChild) : i.appendChild(t);
}
function Qu(i, t) {
  var e, r;
  if (t)
    try {
      for (var o = mC(Object.entries(t)), n = o.next(); !n.done; n = o.next()) {
        var s = CC(n.value, 2), a = s[0], l = s[1];
        if (!(!a || !a.length || l == null)) {
          var u = a.replace(/[A-Z]/g, function(h) {
            return "-" + h.toLocaleLowerCase();
          }), c = l.toString(), p = c.replace(/\s*!important/g, ""), d = p.length != c.length ? "important" : void 0;
          i.style.setProperty(u, l, d);
        }
      }
    } catch (h) {
      e = { error: h };
    } finally {
      try {
        n && !n.done && (r = o.return) && r.call(o);
      } finally {
        if (e)
          throw e.error;
      }
    }
}
function Yf(i) {
  return i.clientWidth < i.scrollWidth;
}
function qf(i) {
  return i.clientHeight < i.scrollHeight;
}
function ji(i, t) {
  t === "flex" ? (i.style.removeProperty("width"), i.style.removeProperty("minWidth"), i.style.removeProperty("maxWidth"), i.style.flex = "1 1 auto") : Er(i, t);
}
function Er(i, t) {
  t = Ju(t), i.style.width = t.toString(), i.style.maxWidth = t.toString(), i.style.minWidth = t.toString();
}
function OC(i, t) {
  t === "flex" ? (i.style.removeProperty("height"), i.style.removeProperty("minHeight"), i.style.removeProperty("maxHeight"), i.style.flex = "1 1 auto") : cn(i, t);
}
function cn(i, t) {
  t = Ju(t), i.style.height = t.toString(), i.style.maxHeight = t.toString(), i.style.minHeight = t.toString();
}
function Ju(i) {
  return typeof i == "number" ? i + "px" : i;
}
function Wi(i) {
  return i instanceof Node || i instanceof HTMLElement;
}
function Xf(i) {
  if (i == null)
    return [];
  var t = [];
  return Zu(i, function(e) {
    return t.push(e);
  }), t;
}
function Qf(i, t) {
  if (i)
    for (var e = 0; e < i.length; e++) {
      var r = i[e];
      t(r.name, r.value);
    }
}
function bi(i, t, e) {
  e == null ? i.removeAttribute(t) : i.setAttribute(t, e.toString());
}
function Zu(i, t) {
  if (i != null)
    for (var e = 0; e < i.length; e++)
      t(i[e]);
}
var bC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  radioCssClass: wC,
  FOCUSABLE_SELECTOR: zf,
  FOCUSABLE_EXCLUDE: $u,
  isFocusableFormField: Ku,
  setDisplayed: be,
  setVisible: $f,
  setDisabled: Kn,
  isElementChildOfClass: un,
  getElementSize: mn,
  getInnerHeight: ki,
  getInnerWidth: Pa,
  getAbsoluteHeight: Yu,
  getAbsoluteWidth: Da,
  isRtlNegativeScroll: xi,
  getScrollLeft: Fi,
  setScrollLeft: Qs,
  clearElement: pr,
  removeElement: SC,
  removeFromParent: go,
  isVisible: qn,
  loadTemplate: Lt,
  appendHtml: _C,
  getElementAttribute: EC,
  offsetHeight: au,
  offsetWidth: lu,
  ensureDomOrder: qu,
  setDomChildOrder: Xu,
  insertWithDomOrder: Kf,
  prependDC: RC,
  addStylesToElement: Qu,
  isHorizontalScrollShowing: Yf,
  isVerticalScrollShowing: qf,
  setElementWidth: ji,
  setFixedWidth: Er,
  setElementHeight: OC,
  setFixedHeight: cn,
  formatSize: Ju,
  isNodeOrElement: Wi,
  copyNodeList: Xf,
  iterateNamedNodeMap: Qf,
  addOrRemoveAttribute: bi,
  nodeListForEach: Zu
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Jf = {
  // header column group shown when expanded (click to contract)
  columnGroupOpened: "expanded",
  // header column group shown when contracted (click to expand)
  columnGroupClosed: "contracted",
  // tool panel column group contracted (click to expand)
  columnSelectClosed: "tree-closed",
  // tool panel column group expanded (click to contract)
  columnSelectOpen: "tree-open",
  // column tool panel header expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  columnSelectIndeterminate: "tree-indeterminate",
  // shown on ghost icon while dragging column to the side of the grid to pin
  columnMovePin: "pin",
  // shown on ghost icon while dragging over part of the page that is not a drop zone
  columnMoveHide: "eye-slash",
  // shown on ghost icon while dragging columns to reorder
  columnMoveMove: "arrows",
  // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
  columnMoveLeft: "left",
  // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
  columnMoveRight: "right",
  // shown on ghost icon while dragging over Row Groups drop zone
  columnMoveGroup: "group",
  // shown on ghost icon while dragging over Values drop zone
  columnMoveValue: "aggregation",
  // shown on ghost icon while dragging over pivot drop zone
  columnMovePivot: "pivot",
  // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
  //     string column over aggregation drop zone
  dropNotAllowed: "not-allowed",
  // shown on row group when contracted (click to expand)
  groupContracted: "tree-closed",
  // shown on row group when expanded (click to contract)
  groupExpanded: "tree-open",
  // set filter tree list group contracted (click to expand)
  setFilterGroupClosed: "tree-closed",
  // set filter tree list group expanded (click to contract)
  setFilterGroupOpen: "tree-open",
  // set filter tree list expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  setFilterGroupIndeterminate: "tree-indeterminate",
  // context menu chart item
  chart: "chart",
  // chart window title bar
  close: "cross",
  // X (remove) on column 'pill' after adding it to a drop zone list
  cancel: "cancel",
  // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
  check: "tick",
  // "go to first" button in pagination controls
  first: "first",
  // "go to previous" button in pagination controls
  previous: "previous",
  // "go to next" button in pagination controls
  next: "next",
  // "go to last" button in pagination controls
  last: "last",
  // shown on top right of chart when chart is linked to range data (click to unlink)
  linked: "linked",
  // shown on top right of chart when chart is not linked to range data (click to link)
  unlinked: "unlinked",
  // "Choose colour" button on chart settings tab
  colorPicker: "color-picker",
  // rotating spinner shown by the loading cell renderer
  groupLoading: "loading",
  // button to launch enterprise column menu
  menu: "menu",
  // filter tool panel tab
  filter: "filter",
  // column tool panel tab
  columns: "columns",
  // button in chart regular size window title bar (click to maximise)
  maximize: "maximize",
  // button in chart maximised window title bar (click to make regular size)
  minimize: "minimize",
  // "Pin column" item in column header menu
  menuPin: "pin",
  // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
  menuValue: "aggregation",
  // "Group by {column-name}" item in column header menu
  menuAddRowGroup: "group",
  // "Un-Group by {column-name}" item in column header menu
  menuRemoveRowGroup: "group",
  // context menu copy item
  clipboardCopy: "copy",
  // context menu cut item
  clipboardCut: "cut",
  // context menu paste item
  clipboardPaste: "paste",
  // identifies the pivot drop zone
  pivotPanel: "pivot",
  // "Row groups" drop zone in column tool panel
  rowGroupPanel: "group",
  // columns tool panel Values drop zone
  valuePanel: "aggregation",
  // drag handle used to pick up draggable columns
  columnDrag: "grip",
  // drag handle used to pick up draggable rows
  rowDrag: "grip",
  // context menu export item
  save: "save",
  // csv export
  csvExport: "csv",
  // excel export,
  excelExport: "excel",
  // icon on dropdown editors
  smallDown: "small-down",
  // version of small-right used in RTL mode
  smallLeft: "small-left",
  // separater between column 'pills' when you add multiple columns to the header drop zone
  smallRight: "small-right",
  smallUp: "small-up",
  // show on column header when column is sorted ascending
  sortAscending: "asc",
  // show on column header when column is sorted descending
  sortDescending: "desc",
  // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
  sortUnSort: "none"
};
function Cr(i, t, e) {
  var r = ut(i, t, e);
  if (r) {
    var o = r.className;
    if (typeof o == "string" && o.indexOf("ag-icon") > -1 || typeof o == "object" && o["ag-icon"])
      return r;
  }
  var n = document.createElement("span");
  return n.appendChild(r), n;
}
function ut(i, t, e, r) {
  var o = null, n = e && e.getColDef().icons;
  if (n && (o = n[i]), t && !o) {
    var s = t.get("icons");
    s && (o = s[i]);
  }
  if (o) {
    var a = void 0;
    if (typeof o == "function")
      a = o();
    else if (typeof o == "string")
      a = o;
    else
      throw new Error("icon from grid options needs to be a string or a function");
    if (typeof a == "string")
      return Lt(a);
    if (Wi(a))
      return a;
    console.warn("AG Grid: iconRenderer should return back a string or a dom object");
  } else {
    var l = document.createElement("span"), u = Jf[i];
    return u || (r ? u = i : (console.warn("AG Grid: Did not find icon " + i), u = "")), l.setAttribute("class", "ag-icon ag-icon-" + u), l.setAttribute("unselectable", "on"), Dt(l, "presentation"), l;
  }
}
var TC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  iconNameClassMap: Jf,
  createIcon: Cr,
  createIconNoSpan: ut
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var L = (
  /** @class */
  function() {
    function i() {
    }
    return i.BACKSPACE = "Backspace", i.TAB = "Tab", i.ENTER = "Enter", i.ESCAPE = "Escape", i.SPACE = " ", i.LEFT = "ArrowLeft", i.UP = "ArrowUp", i.RIGHT = "ArrowRight", i.DOWN = "ArrowDown", i.DELETE = "Delete", i.F2 = "F2", i.PAGE_UP = "PageUp", i.PAGE_DOWN = "PageDown", i.PAGE_HOME = "Home", i.PAGE_END = "End", i.A = "KeyA", i.C = "KeyC", i.D = "KeyD", i.V = "KeyV", i.X = "KeyX", i.Y = "KeyY", i.Z = "KeyZ", i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var PC = 65, DC = 67, AC = 86, xC = 68, FC = 90, MC = 89;
function Zf(i) {
  if (i.altKey || i.ctrlKey || i.metaKey)
    return !1;
  var t = i.key.length === 1;
  return t;
}
function Js(i, t, e, r, o) {
  var n = r ? r.getColDef().suppressKeyboardEvent : void 0;
  if (!n)
    return !1;
  var s = {
    event: t,
    editing: o,
    column: r,
    api: i.api,
    node: e,
    data: e.data,
    colDef: r.getColDef(),
    context: i.context,
    columnApi: i.columnApi
  };
  if (n) {
    var a = n(s);
    if (a)
      return !0;
  }
  return !1;
}
function eh(i, t, e, r) {
  var o = r.getDefinition(), n = o && o.suppressHeaderKeyboardEvent;
  if (!k(n))
    return !1;
  var s = {
    api: i.api,
    columnApi: i.columnApi,
    context: i.context,
    colDef: o,
    column: r,
    headerRowIndex: e,
    event: t
  };
  return !!n(s);
}
function th(i) {
  var t = i.keyCode, e;
  switch (t) {
    case PC:
      e = L.A;
      break;
    case DC:
      e = L.C;
      break;
    case AC:
      e = L.V;
      break;
    case xC:
      e = L.D;
      break;
    case FC:
      e = L.Z;
      break;
    case MC:
      e = L.Y;
      break;
    default:
      e = i.code;
  }
  return e;
}
function rh(i, t) {
  return t === void 0 && (t = !1), i === L.DELETE ? !0 : !t && i === L.BACKSPACE ? Uu() : !1;
}
var IC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isEventFromPrintableCharacter: Zf,
  isUserSuppressingKeyboardEvent: Js,
  isUserSuppressingHeaderKeyboardEvent: eh,
  normaliseQwertyAzerty: th,
  isDeleteKey: rh
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function ec(i, t, e) {
  if (e === 0)
    return !1;
  var r = Math.abs(i.clientX - t.clientX), o = Math.abs(i.clientY - t.clientY);
  return Math.max(r, o) <= e;
}
var LC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  areEventsNear: ec
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function NC(i, t) {
  if (!i)
    return !1;
  for (var e = function(a, l) {
    var u = t[a.id], c = t[l.id], p = u !== void 0, d = c !== void 0, h = p && d, g = !p && !d;
    return h ? u - c : g ? a.__objectId - l.__objectId : p ? 1 : -1;
  }, r, o, n = !1, s = 0; s < i.length - 1; s++)
    if (r = i[s], o = i[s + 1], e(r, o) > 0) {
      n = !0;
      break;
    }
  return n ? (i.sort(e), !0) : !1;
}
function GC(i, t) {
  var e = [];
  r(i);
  function r(o) {
    o && o.forEach(function(n) {
      if (n.group || n.hasChildren()) {
        e.push(n.key);
        var s = e.join("|");
        t(n, s), r(n.childrenAfterGroup), e.pop();
      }
    });
  }
}
var HC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sortRowNodesByOrder: NC,
  traverseNodesWithKey: GC
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function tc(i) {
  var t = /* @__PURE__ */ new Set();
  return i.forEach(function(e) {
    return t.add(e);
  }), t;
}
var VC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  convertToSet: tc
});
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var gt = function() {
  return gt = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, gt.apply(this, arguments);
}, BC = gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt(gt({}, lC), Pm), uC), yC), bC), Am), fm), Gm), nm), TC), IC), qm), LC), gC), cm), HC), VC), $m), le = BC;
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var fn = (
  /** @class */
  function() {
    function i(t, e) {
      t === void 0 && (t = 0), e === void 0 && (e = 1), this.nextValue = t, this.step = e;
    }
    return i.prototype.next = function() {
      var t = this.nextValue;
      return this.nextValue += this.step, t;
    }, i.prototype.peek = function() {
      return this.nextValue;
    }, i.prototype.skip = function(t) {
      this.nextValue += t;
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var an;
(function(i) {
  i[i.IN_PROGRESS = 0] = "IN_PROGRESS", i[i.RESOLVED = 1] = "RESOLVED";
})(an || (an = {}));
var nr = (
  /** @class */
  function() {
    function i(t) {
      var e = this;
      this.status = an.IN_PROGRESS, this.resolution = null, this.waiters = [], t(function(r) {
        return e.onDone(r);
      }, function(r) {
        return e.onReject(r);
      });
    }
    return i.all = function(t) {
      return new i(function(e) {
        var r = t.length, o = new Array(r);
        t.forEach(function(n, s) {
          n.then(function(a) {
            o[s] = a, r--, r === 0 && e(o);
          });
        });
      });
    }, i.resolve = function(t) {
      return t === void 0 && (t = null), new i(function(e) {
        return e(t);
      });
    }, i.prototype.then = function(t) {
      var e = this;
      return new i(function(r) {
        e.status === an.RESOLVED ? r(t(e.resolution)) : e.waiters.push(function(o) {
          return r(t(o));
        });
      });
    }, i.prototype.resolveNow = function(t, e) {
      return this.status === an.RESOLVED ? e(this.resolution) : t;
    }, i.prototype.onDone = function(t) {
      this.status = an.RESOLVED, this.resolution = t, this.waiters.forEach(function(e) {
        return e(t);
      });
    }, i.prototype.onReject = function(t) {
      console.warn("TBI");
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var kC = (
  /** @class */
  function() {
    function i() {
      this.timestamp = (/* @__PURE__ */ new Date()).getTime();
    }
    return i.prototype.print = function(t) {
      var e = (/* @__PURE__ */ new Date()).getTime() - this.timestamp;
      console.info(t + " = " + e), this.timestamp = (/* @__PURE__ */ new Date()).getTime();
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var jC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), uu = function() {
  return uu = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, uu.apply(this, arguments);
}, cl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ir;
(function(i) {
  i[i.NOTHING = 0] = "NOTHING", i[i.WAITING_TO_SHOW = 1] = "WAITING_TO_SHOW", i[i.SHOWING = 2] = "SHOWING";
})(Ir || (Ir = {}));
var Aa = (
  /** @class */
  function(i) {
    jC(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.DEFAULT_SHOW_TOOLTIP_DELAY = 2e3, r.DEFAULT_HIDE_TOOLTIP_DELAY = 1e4, r.SHOW_QUICK_TOOLTIP_DIFF = 1e3, r.FADE_OUT_TOOLTIP_TIMEOUT = 1e3, r.state = Ir.NOTHING, r.tooltipInstanceCount = 0, r.tooltipMouseTrack = !1, r.parentComp = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.tooltipShowDelay = this.getTooltipDelay("show") || this.DEFAULT_SHOW_TOOLTIP_DELAY, this.tooltipHideDelay = this.getTooltipDelay("hide") || this.DEFAULT_HIDE_TOOLTIP_DELAY, this.tooltipMouseTrack = this.gridOptionsService.is("tooltipMouseTrack");
      var e = this.parentComp.getGui();
      this.addManagedListener(e, "mouseenter", this.onMouseEnter.bind(this)), this.addManagedListener(e, "mouseleave", this.onMouseLeave.bind(this)), this.addManagedListener(e, "mousemove", this.onMouseMove.bind(this)), this.addManagedListener(e, "mousedown", this.onMouseDown.bind(this)), this.addManagedListener(e, "keydown", this.onKeyDown.bind(this));
    }, t.prototype.destroy = function() {
      this.setToDoNothing(), i.prototype.destroy.call(this);
    }, t.prototype.onMouseEnter = function(e) {
      if (!jo() && this.state == Ir.NOTHING) {
        var r = this.isLastTooltipHiddenRecently() ? 200 : this.tooltipShowDelay;
        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), r), this.lastMouseEvent = e, this.state = Ir.WAITING_TO_SHOW;
      }
    }, t.prototype.onMouseLeave = function() {
      this.setToDoNothing();
    }, t.prototype.onKeyDown = function() {
      this.setToDoNothing();
    }, t.prototype.setToDoNothing = function() {
      this.state === Ir.SHOWING && this.hideTooltip(), this.clearTimeouts(), this.state = Ir.NOTHING;
    }, t.prototype.onMouseMove = function(e) {
      this.lastMouseEvent = e, this.tooltipMouseTrack && this.state === Ir.SHOWING && this.tooltipComp && this.positionTooltipUnderLastMouseEvent();
    }, t.prototype.onMouseDown = function() {
      this.setToDoNothing();
    }, t.prototype.getTooltipDelay = function(e) {
      var r = this.gridOptionsService.getNum("tooltipShowDelay"), o = this.gridOptionsService.getNum("tooltipHideDelay"), n = e === "show" ? r : o, s = mf(e);
      return k(n) ? (n < 0 && Pe(function() {
        return console.warn("AG Grid: tooltip" + s + "Delay should not be lower than 0");
      }, "tooltip" + s + "DelayWarn"), Math.max(200, n)) : null;
    }, t.prototype.hideTooltip = function() {
      this.tooltipComp && (this.destroyTooltipComp(), t.lastTooltipHideTime = (/* @__PURE__ */ new Date()).getTime()), this.state = Ir.NOTHING;
    }, t.prototype.destroyTooltipComp = function() {
      var e = this;
      this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
      var r = this.tooltipPopupDestroyFunc, o = this.tooltipComp;
      window.setTimeout(function() {
        r(), e.getContext().destroyBean(o);
      }, this.FADE_OUT_TOOLTIP_TIMEOUT), this.tooltipPopupDestroyFunc = void 0, this.tooltipComp = void 0;
    }, t.prototype.isLastTooltipHiddenRecently = function() {
      var e = (/* @__PURE__ */ new Date()).getTime(), r = t.lastTooltipHideTime;
      return e - r < this.SHOW_QUICK_TOOLTIP_DIFF;
    }, t.prototype.showTooltip = function() {
      var e = uu({}, this.parentComp.getTooltipParams());
      if (!k(e.value)) {
        this.setToDoNothing();
        return;
      }
      this.state = Ir.SHOWING, this.tooltipInstanceCount++;
      var r = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount), o = this.userComponentFactory.getTooltipCompDetails(e);
      o.newAgStackInstance().then(r);
    }, t.prototype.newTooltipComponentCallback = function(e, r) {
      var o = this.state !== Ir.SHOWING || this.tooltipInstanceCount !== e;
      if (o) {
        this.getContext().destroyBean(r);
        return;
      }
      var n = r.getGui();
      this.tooltipComp = r, n.classList.contains("ag-tooltip") || n.classList.add("ag-tooltip-custom");
      var s = this.localeService.getLocaleTextFunc(), a = this.popupService.addPopup({
        eChild: n,
        ariaLabel: s("ariaLabelTooltip", "Tooltip")
      });
      a && (this.tooltipPopupDestroyFunc = a.hideFunc), this.positionTooltipUnderLastMouseEvent(), this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.tooltipHideDelay);
    }, t.prototype.positionTooltipUnderLastMouseEvent = function() {
      this.popupService.positionPopupUnderMouseEvent({
        type: "tooltip",
        mouseEvent: this.lastMouseEvent,
        ePopup: this.tooltipComp.getGui(),
        nudgeY: 18,
        skipObserver: this.tooltipMouseTrack
      });
    }, t.prototype.clearTimeouts = function() {
      this.showTooltipTimeoutId && (window.clearTimeout(this.showTooltipTimeoutId), this.showTooltipTimeoutId = void 0), this.hideTooltipTimeoutId && (window.clearTimeout(this.hideTooltipTimeoutId), this.hideTooltipTimeoutId = void 0);
    }, cl([
      v("popupService")
    ], t.prototype, "popupService", void 0), cl([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), cl([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var oh = (
  /** @class */
  function() {
    function i(t) {
      this.cssClassStates = {}, this.getGui = t;
    }
    return i.prototype.addCssClass = function(t) {
      var e = this, r = (t || "").split(" ");
      if (r.length > 1) {
        r.forEach(function(s) {
          return e.addCssClass(s);
        });
        return;
      }
      var o = this.cssClassStates[t] !== !0;
      if (o && t.length) {
        var n = this.getGui();
        n && n.classList.add(t), this.cssClassStates[t] = !0;
      }
    }, i.prototype.removeCssClass = function(t) {
      var e = this, r = (t || "").split(" ");
      if (r.length > 1) {
        r.forEach(function(s) {
          return e.removeCssClass(s);
        });
        return;
      }
      var o = this.cssClassStates[t] !== !1;
      if (o && t.length) {
        var n = this.getGui();
        n && n.classList.remove(t), this.cssClassStates[t] = !1;
      }
    }, i.prototype.containsCssClass = function(t) {
      var e = this.getGui();
      return e ? e.classList.contains(t) : !1;
    }, i.prototype.addOrRemoveCssClass = function(t, e) {
      var r = this;
      if (t) {
        if (t.indexOf(" ") >= 0) {
          var o = (t || "").split(" ");
          if (o.length > 1) {
            o.forEach(function(a) {
              return r.addOrRemoveCssClass(a, e);
            });
            return;
          }
        }
        var n = this.cssClassStates[t] !== e;
        if (n && t.length) {
          var s = this.getGui();
          s && s.classList.toggle(t, e), this.cssClassStates[t] = e;
        }
      }
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var WC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, UC = new fn(), ge = (
  /** @class */
  function(i) {
    WC(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.displayed = !0, r.visible = !0, r.compId = UC.next(), r.cssClassManager = new oh(function() {
        return r.eGui;
      }), e && r.setTemplate(e), r;
    }
    return t.prototype.preConstructOnComponent = function() {
      this.usingBrowserTooltips = this.gridOptionsService.is("enableBrowserTooltips");
    }, t.prototype.getCompId = function() {
      return this.compId;
    }, t.prototype.getTooltipParams = function() {
      return {
        value: this.tooltipText,
        location: "UNKNOWN"
      };
    }, t.prototype.setTooltip = function(e) {
      var r = this, o = function() {
        r.usingBrowserTooltips ? r.getGui().removeAttribute("title") : r.tooltipFeature = r.destroyBean(r.tooltipFeature);
      }, n = function() {
        r.usingBrowserTooltips ? r.getGui().setAttribute("title", r.tooltipText) : r.tooltipFeature = r.createBean(new Aa(r));
      };
      this.tooltipText != e && (this.tooltipText && o(), e != null && (this.tooltipText = e, this.tooltipText && n()));
    }, t.prototype.createChildComponentsFromTags = function(e, r) {
      var o = this, n = Xf(e.childNodes);
      n.forEach(function(s) {
        if (s instanceof HTMLElement) {
          var a = o.createComponentFromElement(s, function(u) {
            var c = u.getGui();
            c && o.copyAttributesFromNode(s, u.getGui());
          }, r);
          if (a) {
            if (a.addItems && s.children.length) {
              o.createChildComponentsFromTags(s, r);
              var l = Array.prototype.slice.call(s.children);
              a.addItems(l);
            }
            o.swapComponentForNode(a, e, s);
          } else
            s.childNodes && o.createChildComponentsFromTags(s, r);
        }
      });
    }, t.prototype.createComponentFromElement = function(e, r, o) {
      var n = e.nodeName, s = o ? o[e.getAttribute("ref")] : void 0, a = this.agStackComponentsRegistry.getComponentClass(n);
      if (a) {
        t.elementGettingCreated = e;
        var l = new a(s);
        return l.setParentComponent(this), this.createBean(l, null, r), l;
      }
      return null;
    }, t.prototype.copyAttributesFromNode = function(e, r) {
      Qf(e.attributes, function(o, n) {
        return r.setAttribute(o, n);
      });
    }, t.prototype.swapComponentForNode = function(e, r, o) {
      var n = e.getGui();
      r.replaceChild(n, o), r.insertBefore(document.createComment(o.nodeName), n), this.addDestroyFunc(this.destroyBean.bind(this, e)), this.swapInComponentForQuerySelectors(e, o);
    }, t.prototype.swapInComponentForQuerySelectors = function(e, r) {
      var o = this;
      this.iterateOverQuerySelectors(function(n) {
        o[n.attributeName] === r && (o[n.attributeName] = e);
      });
    }, t.prototype.iterateOverQuerySelectors = function(e) {
      for (var r = Object.getPrototypeOf(this); r != null; ) {
        var o = r.__agComponentMetaData, n = Ra(r.constructor);
        o && o[n] && o[n].querySelectors && o[n].querySelectors.forEach(function(s) {
          return e(s);
        }), r = Object.getPrototypeOf(r);
      }
    }, t.prototype.setTemplate = function(e, r) {
      var o = Lt(e);
      this.setTemplateFromElement(o, r);
    }, t.prototype.setTemplateFromElement = function(e, r) {
      this.eGui = e, this.eGui.__agComponent = this, this.wireQuerySelectors(), this.getContext() && this.createChildComponentsFromTags(this.getGui(), r);
    }, t.prototype.createChildComponentsPreConstruct = function() {
      this.getGui() && this.createChildComponentsFromTags(this.getGui());
    }, t.prototype.wireQuerySelectors = function() {
      var e = this;
      if (this.eGui) {
        var r = this;
        this.iterateOverQuerySelectors(function(o) {
          var n = function(l) {
            return r[o.attributeName] = l;
          }, s = o.refSelector && e.eGui.getAttribute("ref") === o.refSelector;
          if (s)
            n(e.eGui);
          else {
            var a = e.eGui.querySelector(o.querySelector);
            a && n(a.__agComponent || a);
          }
        });
      }
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.getFocusableElement = function() {
      return this.eGui;
    }, t.prototype.setParentComponent = function(e) {
      this.parentComponent = e;
    }, t.prototype.getParentComponent = function() {
      return this.parentComponent;
    }, t.prototype.setGui = function(e) {
      this.eGui = e;
    }, t.prototype.queryForHtmlElement = function(e) {
      return this.eGui.querySelector(e);
    }, t.prototype.queryForHtmlInputElement = function(e) {
      return this.eGui.querySelector(e);
    }, t.prototype.appendChild = function(e, r) {
      if (e != null)
        if (r || (r = this.eGui), Wi(e))
          r.appendChild(e);
        else {
          var o = e;
          r.appendChild(o.getGui());
        }
    }, t.prototype.isDisplayed = function() {
      return this.displayed;
    }, t.prototype.setVisible = function(e, r) {
      if (r === void 0 && (r = {}), e !== this.visible) {
        this.visible = e;
        var o = r.skipAriaHidden;
        $f(this.eGui, e, { skipAriaHidden: o });
      }
    }, t.prototype.setDisplayed = function(e, r) {
      if (r === void 0 && (r = {}), e !== this.displayed) {
        this.displayed = e;
        var o = r.skipAriaHidden;
        be(this.eGui, e, { skipAriaHidden: o });
        var n = {
          type: t.EVENT_DISPLAYED_CHANGED,
          visible: this.displayed
        };
        this.dispatchEvent(n);
      }
    }, t.prototype.destroy = function() {
      this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature)), this.parentComponent && (this.parentComponent = void 0);
      var e = this.eGui;
      e && e.__agComponent && (e.__agComponent = void 0), i.prototype.destroy.call(this);
    }, t.prototype.addGuiEventListener = function(e, r, o) {
      var n = this;
      this.eGui.addEventListener(e, r, o), this.addDestroyFunc(function() {
        return n.eGui.removeEventListener(e, r);
      });
    }, t.prototype.addCssClass = function(e) {
      this.cssClassManager.addCssClass(e);
    }, t.prototype.removeCssClass = function(e) {
      this.cssClassManager.removeCssClass(e);
    }, t.prototype.containsCssClass = function(e) {
      return this.cssClassManager.containsCssClass(e);
    }, t.prototype.addOrRemoveCssClass = function(e, r) {
      this.cssClassManager.addOrRemoveCssClass(e, r);
    }, t.prototype.getAttribute = function(e) {
      var r = this.eGui;
      return r ? r.getAttribute(e) : null;
    }, t.prototype.getRefElement = function(e) {
      return this.queryForHtmlElement('[ref="' + e + '"]');
    }, t.EVENT_DISPLAYED_CHANGED = "displayedChanged", pl([
      v("agStackComponentsRegistry")
    ], t.prototype, "agStackComponentsRegistry", void 0), pl([
      Zl
    ], t.prototype, "preConstructOnComponent", null), pl([
      Zl
    ], t.prototype, "createChildComponentsPreConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function zC(i) {
  return nh.bind(this, i, void 0);
}
function Y(i) {
  return nh.bind(this, "[ref=" + i + "]", i);
}
function nh(i, t, e, r, o) {
  if (i === null) {
    console.error("AG Grid: QuerySelector selector should not be null");
    return;
  }
  if (typeof o == "number") {
    console.error("AG Grid: QuerySelector should be on an attribute");
    return;
  }
  $C(e, "querySelectors", {
    attributeName: r,
    querySelector: i,
    refSelector: t
  });
}
function $C(i, t, e) {
  var r = KC(i, Ra(i.constructor));
  r[t] || (r[t] = []), r[t].push(e);
}
function KC(i, t) {
  return i.__agComponentMetaData || (i.__agComponentMetaData = {}), i.__agComponentMetaData[t] || (i.__agComponentMetaData[t] = {}), i.__agComponentMetaData[t];
}
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var YC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Np = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, qC = (
  /** @class */
  function(i) {
    YC(t, i);
    function t() {
      return i.call(
        this,
        /* html */
        `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eFloatingFilterText"></ag-input-text-field>
            </div>`
      ) || this;
    }
    return t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      this.params = e;
      var r = this.columnModel.getDisplayNameForColumn(e.column, "header", !0), o = this.localeService.getLocaleTextFunc();
      this.eFloatingFilterText.setDisabled(!0).setInputAriaLabel(r + " " + o("ariaFilterInput", "Filter Input"));
    }, t.prototype.onParentModelChanged = function(e) {
      var r = this;
      if (!e) {
        this.eFloatingFilterText.setValue("");
        return;
      }
      this.params.parentFilterInstance(function(o) {
        if (o.getModelAsString) {
          var n = o.getModelAsString(e);
          r.eFloatingFilterText.setValue(n);
        }
      });
    }, Np([
      Y("eFloatingFilterText")
    ], t.prototype, "eFloatingFilterText", void 0), Np([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ih = (
  /** @class */
  function() {
    function i(t, e, r, o) {
      var n = this;
      this.alive = !0, this.context = t, this.eParent = o;
      var s = e.getDateCompDetails(r), a = s.newAgStackInstance();
      a.then(function(l) {
        if (!n.alive) {
          t.destroyBean(l);
          return;
        }
        n.dateComp = l, l && (o.appendChild(l.getGui()), l.afterGuiAttached && l.afterGuiAttached(), n.tempValue && l.setDate(n.tempValue), n.disabled != null && n.setDateCompDisabled(n.disabled));
      });
    }
    return i.prototype.destroy = function() {
      this.alive = !1, this.dateComp = this.context.destroyBean(this.dateComp);
    }, i.prototype.getDate = function() {
      return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }, i.prototype.setDate = function(t) {
      this.dateComp ? this.dateComp.setDate(t) : this.tempValue = t;
    }, i.prototype.setDisabled = function(t) {
      this.dateComp ? this.setDateCompDisabled(t) : this.disabled = t;
    }, i.prototype.setDisplayed = function(t) {
      be(this.eParent, t);
    }, i.prototype.setInputPlaceholder = function(t) {
      this.dateComp && this.dateComp.setInputPlaceholder && this.dateComp.setInputPlaceholder(t);
    }, i.prototype.setInputAriaLabel = function(t) {
      this.dateComp && this.dateComp.setInputAriaLabel && this.dateComp.setInputAriaLabel(t);
    }, i.prototype.afterGuiAttached = function(t) {
      this.dateComp && typeof this.dateComp.afterGuiAttached == "function" && this.dateComp.afterGuiAttached(t);
    }, i.prototype.setDateCompDisabled = function(t) {
      this.dateComp != null && this.dateComp.setDisabled != null && this.dateComp.setDisabled(t);
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var cu = function() {
  return cu = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, cu.apply(this, arguments);
}, sh = (
  /** @class */
  function() {
    function i() {
      this.customFilterOptions = {};
    }
    return i.prototype.init = function(t, e) {
      this.filterOptions = t.filterOptions || e, this.mapCustomOptions(), this.selectDefaultItem(t), this.checkForDeprecatedParams();
    }, i.prototype.checkForDeprecatedParams = function() {
      this.filterOptions.some(function(t) {
        return typeof t != "string" && t.test != null;
      }) && console.warn("AG Grid: [IFilterOptionDef] since v26.2.0, test() has been replaced with predicate()."), this.filterOptions.some(function(t) {
        return typeof t != "string" && t.hideFilterInput != null;
      }) && console.warn("AG Grid: [IFilterOptionDef] since v26.2.0, useOfHideFilterInput has been replaced with numberOfInputs.");
    }, i.prototype.getFilterOptions = function() {
      return this.filterOptions;
    }, i.prototype.mapCustomOptions = function() {
      var t = this;
      this.filterOptions && this.filterOptions.forEach(function(e) {
        if (typeof e != "string") {
          var r = [["displayKey"], ["displayName"], ["predicate", "test"]], o = function(a) {
            return a.some(function(l) {
              return e[l] != null;
            }) ? !0 : (console.warn("AG Grid: ignoring FilterOptionDef as it doesn't contain one of '" + a + "'"), !1);
          };
          if (!r.every(o)) {
            t.filterOptions = t.filterOptions.filter(function(a) {
              return a === e;
            }) || [];
            return;
          }
          var n = e.test, s = cu({}, e);
          n != null && e.predicate == null && (s.predicate = function(a, l) {
            return n(a[0], l);
          }, delete s.test), s.hideFilterInput && s.numberOfInputs == null && (s.numberOfInputs = 0, delete s.hideFilterInput), t.customFilterOptions[e.displayKey] = s;
        }
      });
    }, i.prototype.selectDefaultItem = function(t) {
      if (t.defaultOption)
        this.defaultOption = t.defaultOption;
      else if (this.filterOptions.length >= 1) {
        var e = this.filterOptions[0];
        typeof e == "string" ? this.defaultOption = e : e.displayKey ? this.defaultOption = e.displayKey : console.warn("AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
      } else
        console.warn("AG Grid: no filter options for filter");
    }, i.prototype.getDefaultOption = function() {
      return this.defaultOption;
    }, i.prototype.getCustomOption = function(t) {
      return this.customFilterOptions[t];
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ah = {
  applyFilter: "Apply",
  clearFilter: "Clear",
  resetFilter: "Reset",
  cancelFilter: "Cancel",
  textFilter: "Text Filter",
  numberFilter: "Number Filter",
  dateFilter: "Date Filter",
  setFilter: "Set Filter",
  filterOoo: "Filter...",
  empty: "Choose One",
  equals: "Equals",
  notEqual: "Not equal",
  lessThan: "Less than",
  greaterThan: "Greater than",
  inRange: "In range",
  inRangeStart: "From",
  inRangeEnd: "To",
  lessThanOrEqual: "Less than or equals",
  greaterThanOrEqual: "Greater than or equals",
  contains: "Contains",
  notContains: "Not contains",
  startsWith: "Starts with",
  endsWith: "Ends with",
  blank: "Blank",
  notBlank: "Not blank",
  andCondition: "AND",
  orCondition: "OR",
  dateFormatOoo: "yyyy-mm-dd"
};
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var XC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pu = function() {
  return pu = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, pu.apply(this, arguments);
}, Gp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, wo = (
  /** @class */
  function(i) {
    XC(t, i);
    function t(e, r) {
      r === void 0 && (r = {});
      var o = i.call(this) || this;
      return o.eFocusableElement = e, o.callbacks = r, o.callbacks = pu({ shouldStopEventPropagation: function() {
        return !1;
      }, onTabKeyDown: function(n) {
        if (!n.defaultPrevented) {
          var s = o.focusService.findNextFocusableElement(o.eFocusableElement, !1, n.shiftKey);
          s && (s.focus(), n.preventDefault());
        }
      } }, r), o;
    }
    return t.prototype.postConstruct = function() {
      this.eFocusableElement.classList.add(t.FOCUS_MANAGED_CLASS), this.addKeyDownListeners(this.eFocusableElement), this.callbacks.onFocusIn && this.addManagedListener(this.eFocusableElement, "focusin", this.callbacks.onFocusIn), this.callbacks.onFocusOut && this.addManagedListener(this.eFocusableElement, "focusout", this.callbacks.onFocusOut);
    }, t.prototype.addKeyDownListeners = function(e) {
      var r = this;
      this.addManagedListener(e, "keydown", function(o) {
        if (!(o.defaultPrevented || oo(o))) {
          if (r.callbacks.shouldStopEventPropagation(o)) {
            Un(o);
            return;
          }
          o.key === L.TAB ? r.callbacks.onTabKeyDown(o) : r.callbacks.handleKeyDown && r.callbacks.handleKeyDown(o);
        }
      });
    }, t.FOCUS_MANAGED_CLASS = "ag-focus-managed", Gp([
      v("focusService")
    ], t.prototype, "focusService", void 0), Gp([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var QC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), dl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, lh = "ag-resizer-wrapper", JC = (
  /* html */
  '<div class="' + lh + `">
        <div ref="eTopLeftResizer" class="ag-resizer ag-resizer-topLeft"></div>
        <div ref="eTopResizer" class="ag-resizer ag-resizer-top"></div>
        <div ref="eTopRightResizer" class="ag-resizer ag-resizer-topRight"></div>
        <div ref="eRightResizer" class="ag-resizer ag-resizer-right"></div>
        <div ref="eBottomRightResizer" class="ag-resizer ag-resizer-bottomRight"></div>
        <div ref="eBottomResizer" class="ag-resizer ag-resizer-bottom"></div>
        <div ref="eBottomLeftResizer" class="ag-resizer ag-resizer-bottomLeft"></div>
        <div ref="eLeftResizer" class="ag-resizer ag-resizer-left"></div>
    </div>`
), rc = (
  /** @class */
  function(i) {
    QC(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.element = e, o.dragStartPosition = {
        x: 0,
        y: 0
      }, o.position = {
        x: 0,
        y: 0
      }, o.lastSize = {
        width: -1,
        height: -1
      }, o.positioned = !1, o.resizersAdded = !1, o.resizeListeners = [], o.boundaryEl = null, o.isResizing = !1, o.isMoving = !1, o.resizable = {}, o.movable = !1, o.currentResizer = null, o.config = Object.assign({}, { popup: !1 }, r), o;
    }
    return t.prototype.center = function() {
      var e = this.offsetParent, r = e.clientHeight, o = e.clientWidth, n = o / 2 - this.getWidth() / 2, s = r / 2 - this.getHeight() / 2;
      this.offsetElement(n, s);
    }, t.prototype.initialisePosition = function() {
      if (!this.positioned) {
        var e = this.config, r = e.centered, o = e.forcePopupParentAsOffsetParent, n = e.minWidth, s = e.width, a = e.minHeight, l = e.height, u = e.x, c = e.y;
        this.offsetParent || this.setOffsetParent();
        var p = 0, d = 0, h = !!this.element.offsetParent;
        if (h) {
          var g = this.findBoundaryElement(), y = window.getComputedStyle(g);
          if (y.minWidth != null) {
            var S = g.offsetWidth - this.element.offsetWidth;
            d = parseInt(y.minWidth, 10) - S;
          }
          if (y.minHeight != null) {
            var _ = g.offsetHeight - this.element.offsetHeight;
            p = parseInt(y.minHeight, 10) - _;
          }
        }
        if (this.minHeight = a || p, this.minWidth = n || d, s && this.setWidth(s), l && this.setHeight(l), (!s || !l) && this.refreshSize(), r)
          this.center();
        else if (u || c)
          this.offsetElement(u, c);
        else if (h && o && this.boundaryEl) {
          var w = parseFloat(this.boundaryEl.style.top), E = parseFloat(this.boundaryEl.style.left);
          this.offsetElement(isNaN(E) ? 0 : E, isNaN(w) ? 0 : w);
        }
        this.positioned = !!this.offsetParent;
      }
    }, t.prototype.isPositioned = function() {
      return this.positioned;
    }, t.prototype.getPosition = function() {
      return this.position;
    }, t.prototype.setMovable = function(e, r) {
      if (!(!this.config.popup || e === this.movable)) {
        this.movable = e;
        var o = this.moveElementDragListener || {
          eElement: r,
          onDragStart: this.onMoveStart.bind(this),
          onDragging: this.onMove.bind(this),
          onDragStop: this.onMoveEnd.bind(this)
        };
        e ? (this.dragService.addDragSource(o), this.moveElementDragListener = o) : (this.dragService.removeDragSource(o), this.moveElementDragListener = void 0);
      }
    }, t.prototype.setResizable = function(e) {
      var r = this;
      if (this.clearResizeListeners(), e ? this.addResizers() : this.removeResizers(), typeof e == "boolean") {
        if (e === !1)
          return;
        e = {
          topLeft: e,
          top: e,
          topRight: e,
          right: e,
          bottomRight: e,
          bottom: e,
          bottomLeft: e,
          left: e
        };
      }
      Object.keys(e).forEach(function(o) {
        var n = e, s = !!n[o], a = r.getResizerElement(o), l = {
          dragStartPixels: 0,
          eElement: a,
          onDragStart: function(u) {
            return r.onResizeStart(u, o);
          },
          onDragging: r.onResize.bind(r),
          onDragStop: function(u) {
            return r.onResizeEnd(u, o);
          }
        };
        (s || !r.isAlive() && !s) && (s ? (r.dragService.addDragSource(l), r.resizeListeners.push(l), a.style.pointerEvents = "all") : a.style.pointerEvents = "none", r.resizable[o] = s);
      });
    }, t.prototype.removeSizeFromEl = function() {
      this.element.style.removeProperty("height"), this.element.style.removeProperty("width"), this.element.style.removeProperty("flex");
    }, t.prototype.restoreLastSize = function() {
      this.element.style.flex = "0 0 auto";
      var e = this.lastSize, r = e.height, o = e.width;
      o !== -1 && (this.element.style.width = o + "px"), r !== -1 && (this.element.style.height = r + "px");
    }, t.prototype.getHeight = function() {
      return this.element.offsetHeight;
    }, t.prototype.setHeight = function(e) {
      var r = this.config.popup, o = this.element, n = !1;
      if (typeof e == "string" && e.indexOf("%") !== -1)
        cn(o, e), e = Yu(o), n = !0;
      else if (this.positioned) {
        e = Math.max(this.minHeight, e);
        var s = this.getAvailableHeight();
        s && e > s && (e = s);
      }
      this.getHeight() !== e && (n ? (o.style.maxHeight = "unset", o.style.minHeight = "unset") : r ? cn(o, e) : (o.style.height = e + "px", o.style.flex = "0 0 auto", this.lastSize.height = typeof e == "number" ? e : parseFloat(e)));
    }, t.prototype.getAvailableHeight = function() {
      var e = this.config, r = e.popup, o = e.forcePopupParentAsOffsetParent;
      this.positioned || this.initialisePosition();
      var n = this.offsetParent.clientHeight;
      if (!n)
        return null;
      var s = this.element.getBoundingClientRect(), a = this.offsetParent.getBoundingClientRect(), l = r ? this.position.y : s.top, u = r ? 0 : a.top, c = 0;
      if (o) {
        var p = this.element.parentElement;
        if (p) {
          var d = p.getBoundingClientRect().bottom;
          c = d - s.bottom;
        }
      }
      var h = n + u - l - c;
      return h;
    }, t.prototype.getWidth = function() {
      return this.element.offsetWidth;
    }, t.prototype.setWidth = function(e) {
      var r = this.element, o = this.config.popup, n = !1;
      if (typeof e == "string" && e.indexOf("%") !== -1)
        Er(r, e), e = Da(r), n = !0;
      else if (this.positioned) {
        e = Math.max(this.minWidth, e);
        var s = this.offsetParent.clientWidth, a = o ? this.position.x : this.element.getBoundingClientRect().left;
        s && e + a > s && (e = s - a);
      }
      this.getWidth() !== e && (n ? (r.style.maxWidth = "unset", r.style.minWidth = "unset") : this.config.popup ? Er(r, e) : (r.style.width = e + "px", r.style.flex = " unset", this.lastSize.width = typeof e == "number" ? e : parseFloat(e)));
    }, t.prototype.offsetElement = function(e, r) {
      e === void 0 && (e = 0), r === void 0 && (r = 0);
      var o = this.config.forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
      this.popupService.positionPopup({
        ePopup: o,
        keepWithinBounds: !0,
        skipObserver: this.movable || this.isResizable(),
        updatePosition: function() {
          return { x: e, y: r };
        }
      }), this.setPosition(parseFloat(o.style.left), parseFloat(o.style.top));
    }, t.prototype.constrainSizeToAvailableHeight = function(e) {
      var r = this;
      if (this.config.forcePopupParentAsOffsetParent) {
        var o = function() {
          var n = r.getAvailableHeight();
          r.element.style.setProperty("max-height", n + "px");
        };
        e ? this.resizeObserverSubscriber = this.resizeObserverService.observeResize(this.popupService.getPopupParent(), o) : (this.element.style.removeProperty("max-height"), this.resizeObserverSubscriber && (this.resizeObserverSubscriber(), this.resizeObserverSubscriber = void 0));
      }
    }, t.prototype.setPosition = function(e, r) {
      this.position.x = e, this.position.y = r;
    }, t.prototype.updateDragStartPosition = function(e, r) {
      this.dragStartPosition = { x: e, y: r };
    }, t.prototype.calculateMouseMovement = function(e) {
      var r = e.e, o = e.isLeft, n = e.isTop, s = e.anywhereWithin, a = e.topBuffer, l = r.clientX - this.dragStartPosition.x, u = r.clientY - this.dragStartPosition.y, c = this.shouldSkipX(r, !!o, !!s, l) ? 0 : l, p = this.shouldSkipY(r, !!n, a, u) ? 0 : u;
      return { movementX: c, movementY: p };
    }, t.prototype.shouldSkipX = function(e, r, o, n) {
      var s = this.element.getBoundingClientRect(), a = this.offsetParent.getBoundingClientRect(), l = this.boundaryEl.getBoundingClientRect(), u = this.config.popup ? this.position.x : s.left, c = u <= 0 && a.left >= e.clientX || a.right <= e.clientX && a.right <= l.right;
      return c ? !0 : (r ? c = // skip if we are moving to the left and the cursor
      // is positioned to the right of the left side anchor
      n < 0 && e.clientX > u + a.left || // skip if we are moving to the right and the cursor
      // is positioned to the left of the dialog
      n > 0 && e.clientX < u + a.left : o ? c = n < 0 && e.clientX > l.right || n > 0 && e.clientX < u + a.left : c = // if the movement is bound to the right side of the dialog
      // we skip if we are moving to the left and the cursor
      // is to the right of the dialog
      n < 0 && e.clientX > l.right || // or skip if we are moving to the right and the cursor
      // is to the left of the right side anchor
      n > 0 && e.clientX < l.right, c);
    }, t.prototype.shouldSkipY = function(e, r, o, n) {
      o === void 0 && (o = 0);
      var s = this.element.getBoundingClientRect(), a = this.offsetParent.getBoundingClientRect(), l = this.boundaryEl.getBoundingClientRect(), u = this.config.popup ? this.position.y : s.top, c = u <= 0 && a.top >= e.clientY || a.bottom <= e.clientY && a.bottom <= l.bottom;
      return c ? !0 : (r ? c = // skip if we are moving to towards top and the cursor is
      // below the top anchor + topBuffer
      // note: topBuffer is used when moving the dialog using the title bar
      n < 0 && e.clientY > u + a.top + o || // skip if we are moving to the bottom and the cursor is
      // above the top anchor
      n > 0 && e.clientY < u + a.top : c = // skip if we are moving towards the top and the cursor
      // is below the bottom anchor
      n < 0 && e.clientY > l.bottom || // skip if we are moving towards the bottom and the cursor
      // is above the bottom anchor
      n > 0 && e.clientY < l.bottom, c);
    }, t.prototype.createResizeMap = function() {
      var e = this.element;
      this.resizerMap = {
        topLeft: { element: e.querySelector("[ref=eTopLeftResizer]") },
        top: { element: e.querySelector("[ref=eTopResizer]") },
        topRight: { element: e.querySelector("[ref=eTopRightResizer]") },
        right: { element: e.querySelector("[ref=eRightResizer]") },
        bottomRight: { element: e.querySelector("[ref=eBottomRightResizer]") },
        bottom: { element: e.querySelector("[ref=eBottomResizer]") },
        bottomLeft: { element: e.querySelector("[ref=eBottomLeftResizer]") },
        left: { element: e.querySelector("[ref=eLeftResizer]") }
      };
    }, t.prototype.addResizers = function() {
      if (!this.resizersAdded) {
        var e = this.element;
        if (e) {
          var r = new DOMParser(), o = r.parseFromString(JC, "text/html").body;
          e.appendChild(o.firstChild), this.createResizeMap(), this.resizersAdded = !0;
        }
      }
    }, t.prototype.removeResizers = function() {
      this.resizerMap = void 0;
      var e = this.element.querySelector("." + lh);
      e && this.element.removeChild(e), this.resizersAdded = !1;
    }, t.prototype.getResizerElement = function(e) {
      return this.resizerMap[e].element;
    }, t.prototype.onResizeStart = function(e, r) {
      this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.currentResizer = {
        isTop: !!r.match(/top/i),
        isRight: !!r.match(/right/i),
        isBottom: !!r.match(/bottom/i),
        isLeft: !!r.match(/left/i)
      }, this.element.classList.add("ag-resizing"), this.resizerMap[r].element.classList.add("ag-active");
      var o = this.config, n = o.popup, s = o.forcePopupParentAsOffsetParent;
      !n && !s && this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop), this.isResizing = !0, this.updateDragStartPosition(e.clientX, e.clientY);
    }, t.prototype.getSiblings = function() {
      var e = this.element, r = e.parentElement;
      return r ? Array.prototype.slice.call(r.children).filter(function(o) {
        return !o.classList.contains("ag-hidden");
      }) : null;
    }, t.prototype.getMinSizeOfSiblings = function() {
      for (var e = this.getSiblings() || [], r = 0, o = 0, n = 0; n < e.length; n++) {
        var s = e[n], a = !!s.style.flex && s.style.flex !== "0 0 auto";
        if (s !== this.element) {
          var l = this.minHeight || 0, u = this.minWidth || 0;
          if (a) {
            var c = window.getComputedStyle(s);
            c.minHeight && (l = parseInt(c.minHeight, 10)), c.minWidth && (u = parseInt(c.minWidth, 10));
          } else
            l = s.offsetHeight, u = s.offsetWidth;
          r += l, o += u;
        }
      }
      return { height: r, width: o };
    }, t.prototype.applySizeToSiblings = function(e) {
      var r = null, o = this.getSiblings();
      if (o) {
        for (var n = 0; n < o.length; n++) {
          var s = o[n];
          s !== r && (e ? s.style.height = s.offsetHeight + "px" : s.style.width = s.offsetWidth + "px", s.style.flex = "0 0 auto", s === this.element && (r = o[n + 1]));
        }
        r && (r.style.removeProperty("height"), r.style.removeProperty("min-height"), r.style.removeProperty("max-height"), r.style.flex = "1 1 auto");
      }
    }, t.prototype.isResizable = function() {
      return Object.values(this.resizable).some(function(e) {
        return e;
      });
    }, t.prototype.onResize = function(e) {
      if (!(!this.isResizing || !this.currentResizer)) {
        var r = this.config, o = r.popup, n = r.forcePopupParentAsOffsetParent, s = this.currentResizer, a = s.isTop, l = s.isRight, u = s.isBottom, c = s.isLeft, p = l || c, d = u || a, h = this.calculateMouseMovement({ e, isLeft: c, isTop: a }), g = h.movementX, y = h.movementY, S = this.position.x, _ = this.position.y, w = 0, E = 0;
        if (p && g) {
          var R = c ? -1 : 1, D = this.getWidth(), B = D + g * R, H = !1;
          c && (w = D - B, (S + w <= 0 || B <= this.minWidth) && (H = !0, w = 0)), H || this.setWidth(B);
        }
        if (d && y) {
          var R = a ? -1 : 1, A = this.getHeight(), N = A + y * R, G = !1;
          a ? (E = A - N, (_ + E <= 0 || N <= this.minHeight) && (G = !0, E = 0)) : !this.config.popup && !this.config.forcePopupParentAsOffsetParent && A < N && this.getMinSizeOfSiblings().height + N > this.element.parentElement.offsetHeight && (G = !0), G || this.setHeight(N);
        }
        this.updateDragStartPosition(e.clientX, e.clientY), ((o || n) && w || E) && this.offsetElement(S + w, _ + E);
      }
    }, t.prototype.onResizeEnd = function(e, r) {
      this.isResizing = !1, this.currentResizer = null, this.boundaryEl = null;
      var o = {
        type: "resize",
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi
      };
      this.element.classList.remove("ag-resizing"), this.resizerMap[r].element.classList.remove("ag-active"), this.dispatchEvent(o);
    }, t.prototype.refreshSize = function() {
      var e = this.element;
      this.config.popup && (this.config.width || this.setWidth(e.offsetWidth), this.config.height || this.setHeight(e.offsetHeight));
    }, t.prototype.onMoveStart = function(e) {
      this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.isMoving = !0, this.element.classList.add("ag-moving"), this.updateDragStartPosition(e.clientX, e.clientY);
    }, t.prototype.onMove = function(e) {
      if (this.isMoving) {
        var r = this.position, o = r.x, n = r.y, s;
        this.config.calculateTopBuffer && (s = this.config.calculateTopBuffer());
        var a = this.calculateMouseMovement({
          e,
          isTop: !0,
          anywhereWithin: !0,
          topBuffer: s
        }), l = a.movementX, u = a.movementY;
        this.offsetElement(o + l, n + u), this.updateDragStartPosition(e.clientX, e.clientY);
      }
    }, t.prototype.onMoveEnd = function() {
      this.isMoving = !1, this.boundaryEl = null, this.element.classList.remove("ag-moving");
    }, t.prototype.setOffsetParent = function() {
      this.config.forcePopupParentAsOffsetParent ? this.offsetParent = this.popupService.getPopupParent() : this.offsetParent = this.element.offsetParent;
    }, t.prototype.findBoundaryElement = function() {
      for (var e = this.element; e; ) {
        if (window.getComputedStyle(e).position !== "static")
          return e;
        e = e.parentElement;
      }
      return this.element;
    }, t.prototype.clearResizeListeners = function() {
      for (; this.resizeListeners.length; ) {
        var e = this.resizeListeners.pop();
        this.dragService.removeDragSource(e);
      }
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this), this.moveElementDragListener && this.dragService.removeDragSource(this.moveElementDragListener), this.constrainSizeToAvailableHeight(!1), this.clearResizeListeners(), this.removeResizers();
    }, dl([
      v("popupService")
    ], t.prototype, "popupService", void 0), dl([
      v("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), dl([
      v("dragService")
    ], t.prototype, "dragService", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ZC = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Mi = (
  /** @class */
  function(i) {
    ZC(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.filterNameKey = e, r.applyActive = !1, r.hidePopup = null, r.debouncePending = !1, r.appliedModel = null, r;
    }
    return t.prototype.postConstruct = function() {
      this.resetTemplate(), this.createManagedBean(new wo(this.getFocusableElement(), {
        handleKeyDown: this.handleKeyDown.bind(this)
      })), this.positionableFeature = new rc(this.getPositionableElement(), {
        forcePopupParentAsOffsetParent: !0
      }), this.createBean(this.positionableFeature);
    }, t.prototype.handleKeyDown = function(e) {
    }, t.prototype.getFilterTitle = function() {
      return this.translate(this.filterNameKey);
    }, t.prototype.isFilterActive = function() {
      return !!this.appliedModel;
    }, t.prototype.resetTemplate = function(e) {
      var r = this.getGui();
      r && r.removeEventListener("submit", this.onFormSubmit);
      var o = (
        /* html */
        `
            <form class="ag-filter-wrapper">
                <div class="ag-filter-body-wrapper ag-` + this.getCssIdentifier() + `-body-wrapper" ref="eFilterBody">
                    ` + this.createBodyTemplate() + `
                </div>
            </form>`
      );
      this.setTemplate(o, e), r = this.getGui(), r && r.addEventListener("submit", this.onFormSubmit);
    }, t.prototype.isReadOnly = function() {
      return !!this.providedFilterParams.readOnly;
    }, t.prototype.init = function(e) {
      var r = this;
      this.setParams(e), this.resetUiToDefaults(!0).then(function() {
        r.updateUiVisibility(), r.setupOnBtApplyDebounce();
      });
    }, t.prototype.setParams = function(e) {
      this.providedFilterParams = e, this.applyActive = t.isUseApplyButton(e), this.createButtonPanel();
    }, t.prototype.createButtonPanel = function() {
      var e = this, r = this.providedFilterParams.buttons;
      if (!(!r || r.length < 1 || this.isReadOnly())) {
        var o = document.createElement("div");
        o.classList.add("ag-filter-apply-panel");
        var n = function(s) {
          var a, l;
          switch (s) {
            case "apply":
              a = e.translate("applyFilter"), l = function(p) {
                return e.onBtApply(!1, !1, p);
              };
              break;
            case "clear":
              a = e.translate("clearFilter"), l = function() {
                return e.onBtClear();
              };
              break;
            case "reset":
              a = e.translate("resetFilter"), l = function() {
                return e.onBtReset();
              };
              break;
            case "cancel":
              a = e.translate("cancelFilter"), l = function(p) {
                e.onBtCancel(p);
              };
              break;
            default:
              console.warn("AG Grid: Unknown button type specified");
              return;
          }
          var u = s === "apply" ? "submit" : "button", c = Lt(
            /* html */
            `<button
                    type="` + u + `"
                    ref="` + s + `FilterButton"
                    class="ag-standard-button ag-filter-apply-panel-button"
                >` + a + `
                </button>`
          );
          o.appendChild(c), e.addManagedListener(c, "click", l);
        };
        tc(r).forEach(function(s) {
          return n(s);
        }), this.getGui().appendChild(o);
      }
    }, t.prototype.getDefaultDebounceMs = function() {
      return 0;
    }, t.prototype.setupOnBtApplyDebounce = function() {
      var e = this, r = t.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs()), o = ro(this.checkApplyDebounce.bind(this), r);
      this.onBtApplyDebounce = function() {
        e.debouncePending = !0, o();
      };
    }, t.prototype.checkApplyDebounce = function() {
      this.debouncePending && (this.debouncePending = !1, this.onBtApply());
    }, t.prototype.getModel = function() {
      return this.appliedModel ? this.appliedModel : null;
    }, t.prototype.setModel = function(e) {
      var r = this, o = e != null ? this.setModelIntoUi(e) : this.resetUiToDefaults();
      return o.then(function() {
        r.updateUiVisibility(), r.applyModel("api");
      });
    }, t.prototype.onBtCancel = function(e) {
      var r = this;
      this.resetUiToActiveModel(this.getModel(), function() {
        r.handleCancelEnd(e);
      });
    }, t.prototype.handleCancelEnd = function(e) {
      this.providedFilterParams.closeOnApply && this.close(e);
    }, t.prototype.resetUiToActiveModel = function(e, r) {
      var o = this, n = function() {
        o.onUiChanged(!1, "prevent"), r == null || r();
      };
      e != null ? this.setModelIntoUi(e).then(n) : this.resetUiToDefaults().then(n);
    }, t.prototype.onBtClear = function() {
      var e = this;
      this.resetUiToDefaults().then(function() {
        return e.onUiChanged();
      });
    }, t.prototype.onBtReset = function() {
      this.onBtClear(), this.onBtApply();
    }, t.prototype.applyModel = function(e) {
      var r = this.getModelFromUi();
      if (!this.isModelValid(r))
        return !1;
      var o = this.appliedModel;
      return this.appliedModel = r, !this.areModelsEqual(o, r);
    }, t.prototype.isModelValid = function(e) {
      return !0;
    }, t.prototype.onFormSubmit = function(e) {
      e.preventDefault();
    }, t.prototype.onBtApply = function(e, r, o) {
      e === void 0 && (e = !1), r === void 0 && (r = !1), o && o.preventDefault(), this.applyModel(r ? "rowDataUpdated" : "ui") && this.providedFilterParams.filterChangedCallback({ afterFloatingFilter: e, afterDataChange: r });
      var n = this.providedFilterParams.closeOnApply;
      n && this.applyActive && !e && !r && this.close(o);
    }, t.prototype.onNewRowsLoaded = function() {
    }, t.prototype.close = function(e) {
      if (this.hidePopup) {
        var r = e, o = r && r.key, n;
        (o === "Enter" || o === "Space") && (n = { keyboardEvent: r }), this.hidePopup(n), this.hidePopup = null;
      }
    }, t.prototype.onUiChanged = function(e, r) {
      if (e === void 0 && (e = !1), this.updateUiVisibility(), this.providedFilterParams.filterModifiedCallback(), this.applyActive && !this.isReadOnly()) {
        var o = this.isModelValid(this.getModelFromUi());
        Kn(this.getRefElement("applyFilterButton"), !o);
      }
      e && !r || r === "immediately" ? this.onBtApply(e) : (!this.applyActive && !r || r === "debounce") && this.onBtApplyDebounce();
    }, t.prototype.afterGuiAttached = function(e) {
      e && (this.hidePopup = e.hidePopup), this.refreshFilterResizer(e == null ? void 0 : e.container);
    }, t.prototype.refreshFilterResizer = function(e) {
      if (!(!this.positionableFeature || e === "toolPanel")) {
        var r = e === "floatingFilter", o = this, n = o.positionableFeature, s = o.gridOptionsService;
        r ? (n.restoreLastSize(), n.setResizable(s.is("enableRtl") ? { bottom: !0, bottomLeft: !0, left: !0 } : { bottom: !0, bottomRight: !0, right: !0 })) : (this.positionableFeature.removeSizeFromEl(), this.positionableFeature.setResizable(!1)), this.positionableFeature.constrainSizeToAvailableHeight(!0);
      }
    }, t.prototype.afterGuiDetached = function() {
      this.checkApplyDebounce(), this.positionableFeature && this.positionableFeature.constrainSizeToAvailableHeight(!1);
    }, t.getDebounceMs = function(e, r) {
      return t.isUseApplyButton(e) ? (e.debounceMs != null && console.warn("AG Grid: debounceMs is ignored when apply button is present"), 0) : e.debounceMs != null ? e.debounceMs : r;
    }, t.isUseApplyButton = function(e) {
      return !!e.buttons && e.buttons.indexOf("apply") >= 0;
    }, t.prototype.destroy = function() {
      var e = this.getGui();
      e && e.removeEventListener("submit", this.onFormSubmit), this.hidePopup = null, this.positionableFeature && (this.positionableFeature = this.destroyBean(this.positionableFeature)), i.prototype.destroy.call(this);
    }, t.prototype.translate = function(e) {
      var r = this.localeService.getLocaleTextFunc();
      return r(e, ah[e]);
    }, t.prototype.getCellValue = function(e) {
      var r = this.providedFilterParams, o = r.api, n = r.colDef, s = r.column, a = r.columnApi, l = r.context;
      return this.providedFilterParams.valueGetter({
        api: o,
        colDef: n,
        column: s,
        columnApi: a,
        context: l,
        data: e.data,
        getValue: function(u) {
          return e.data[u];
        },
        node: e
      });
    }, t.prototype.getPositionableElement = function() {
      return this.eFilterBody;
    }, fl([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), fl([
      Y("eFilterBody")
    ], t.prototype, "eFilterBody", void 0), fl([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ew = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, oc = (
  /** @class */
  function(i) {
    ew(t, i);
    function t(e, r) {
      var o = i.call(this, r) || this;
      return o.labelSeparator = "", o.labelAlignment = "left", o.disabled = !1, o.label = "", o.config = e || {}, o;
    }
    return t.prototype.postConstruct = function() {
      this.addCssClass("ag-labeled"), this.eLabel.classList.add("ag-label");
      var e = this.config, r = e.labelSeparator, o = e.label, n = e.labelWidth, s = e.labelAlignment;
      r != null && this.setLabelSeparator(r), o != null && this.setLabel(o), n != null && this.setLabelWidth(n), this.setLabelAlignment(s || this.labelAlignment), this.refreshLabel();
    }, t.prototype.refreshLabel = function() {
      pr(this.eLabel), typeof this.label == "string" ? this.eLabel.innerText = this.label + this.labelSeparator : this.label && this.eLabel.appendChild(this.label), this.label === "" ? (be(this.eLabel, !1), Dt(this.eLabel, "presentation")) : (be(this.eLabel, !0), Dt(this.eLabel, null));
    }, t.prototype.setLabelSeparator = function(e) {
      return this.labelSeparator === e ? this : (this.labelSeparator = e, this.label != null && this.refreshLabel(), this);
    }, t.prototype.getLabelId = function() {
      return this.eLabel.id = this.eLabel.id || "ag-" + this.getCompId() + "-label", this.eLabel.id;
    }, t.prototype.getLabel = function() {
      return this.label;
    }, t.prototype.setLabel = function(e) {
      return this.label === e ? this : (this.label = e, this.refreshLabel(), this);
    }, t.prototype.setLabelAlignment = function(e) {
      var r = this.getGui(), o = r.classList;
      return o.toggle("ag-label-align-left", e === "left"), o.toggle("ag-label-align-right", e === "right"), o.toggle("ag-label-align-top", e === "top"), this;
    }, t.prototype.setLabelEllipsis = function(e) {
      return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
    }, t.prototype.setLabelWidth = function(e) {
      return this.label == null ? this : (ji(this.eLabel, e), this);
    }, t.prototype.setDisabled = function(e) {
      e = !!e;
      var r = this.getGui();
      return Kn(r, e), r.classList.toggle("ag-disabled", e), this.disabled = e, this;
    }, t.prototype.isDisabled = function() {
      return !!this.disabled;
    }, tw([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var rw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), hn = (
  /** @class */
  function(i) {
    rw(t, i);
    function t(e, r, o) {
      var n = i.call(this, e, r) || this;
      return n.className = o, n;
    }
    return t.prototype.postConstruct = function() {
      i.prototype.postConstruct.call(this), this.className && this.addCssClass(this.className);
    }, t.prototype.onValueChange = function(e) {
      var r = this;
      return this.addManagedListener(this, t.EVENT_CHANGED, function() {
        return e(r.getValue());
      }), this;
    }, t.prototype.getWidth = function() {
      return this.getGui().clientWidth;
    }, t.prototype.setWidth = function(e) {
      return Er(this.getGui(), e), this;
    }, t.prototype.getPreviousValue = function() {
      return this.previousValue;
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.setValue = function(e, r) {
      return this.value === e ? this : (this.previousValue = this.value, this.value = e, r || this.dispatchEvent({ type: t.EVENT_CHANGED }), this);
    }, t.EVENT_CHANGED = "valueChange", t;
  }(oc)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ow = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), us = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, uh = (
  /** @class */
  function(i) {
    ow(t, i);
    function t(e, r, o, n) {
      var s = i.call(
        this,
        e,
        /* html */
        `<div class="ag-picker-field" role="presentation">
                <div ref="eLabel"></div>
                <div ref="eWrapper"
                    class="ag-wrapper ag-picker-field-wrapper"
                    tabIndex="-1"
                    aria-expanded="false"
                    ` + (n ? 'role="' + n + '"' : "") + `
                >
                    <div ref="eDisplayField" class="ag-picker-field-display"></div>
                    <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
                </div>
            </div>`,
        r
      ) || this;
      return s.pickerIcon = o, s.isPickerDisplayed = !1, s.isDestroyingPicker = !1, s.skipClick = !1, s;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      i.prototype.postConstruct.call(this);
      var r = this.getCompId() + "-display";
      this.eDisplayField.setAttribute("id", r), Df(this.eWrapper, r);
      var o = function() {
        if (e.skipClick) {
          e.skipClick = !1;
          return;
        }
        e.isDisabled() || (e.pickerComponent = e.showPicker());
      }, n = this.getGui();
      if (this.addManagedListener(n, "mousedown", function(a) {
        !e.skipClick && e.pickerComponent && e.pickerComponent.isAlive() && qn(e.pickerComponent.getGui()) && n.contains(a.target) && (e.skipClick = !0);
      }), this.addManagedListener(n, "keydown", function(a) {
        switch (a.key) {
          case L.UP:
          case L.DOWN:
          case L.ENTER:
          case L.SPACE:
            o();
          case L.ESCAPE:
            e.isPickerDisplayed && a.preventDefault();
            break;
        }
      }), this.addManagedListener(this.eWrapper, "click", o), this.addManagedListener(this.eLabel, "click", o), this.pickerIcon) {
        var s = ut(this.pickerIcon, this.gridOptionsService);
        s && this.eIcon.appendChild(s);
      }
    }, t.prototype.refreshLabel = function() {
      k(this.getLabel()) ? Nu(this.eWrapper, this.getLabelId()) : this.eWrapper.removeAttribute("aria-labelledby"), i.prototype.refreshLabel.call(this);
    }, t.prototype.setAriaLabel = function(e) {
      return yn(this.eWrapper, e), this;
    }, t.prototype.setInputWidth = function(e) {
      return ji(this.eWrapper, e), this;
    }, t.prototype.getFocusableElement = function() {
      return this.eWrapper;
    }, us([
      Y("eLabel")
    ], t.prototype, "eLabel", void 0), us([
      Y("eWrapper")
    ], t.prototype, "eWrapper", void 0), us([
      Y("eDisplayField")
    ], t.prototype, "eDisplayField", void 0), us([
      Y("eIcon")
    ], t.prototype, "eIcon", void 0), t;
  }(hn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var nw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), iw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Hp = (
  /** @class */
  function(i) {
    nw(t, i);
    function t(e) {
      e === void 0 && (e = "default");
      var r = i.call(
        this,
        /* html */
        '<div class="ag-list ag-' + e + '-list" role="listbox"></div>'
      ) || this;
      return r.cssIdentifier = e, r.options = [], r.itemEls = [], r;
    }
    return t.prototype.init = function() {
      this.addManagedListener(this.getGui(), "keydown", this.handleKeyDown.bind(this));
    }, t.prototype.handleKeyDown = function(e) {
      var r = e.key;
      switch (r) {
        case L.ENTER:
          if (!this.highlightedEl)
            this.setValue(this.getValue());
          else {
            var o = this.itemEls.indexOf(this.highlightedEl);
            this.setValueByIndex(o);
          }
          break;
        case L.DOWN:
        case L.UP:
          var n = r === L.DOWN, s = void 0;
          if (e.preventDefault(), !this.highlightedEl)
            s = this.itemEls[n ? 0 : this.itemEls.length - 1];
          else {
            var a = this.itemEls.indexOf(this.highlightedEl), l = a + (n ? 1 : -1);
            l = Math.min(Math.max(l, 0), this.itemEls.length - 1), s = this.itemEls[l];
          }
          this.highlightItem(s);
          break;
      }
    }, t.prototype.addOptions = function(e) {
      var r = this;
      return e.forEach(function(o) {
        return r.addOption(o);
      }), this;
    }, t.prototype.addOption = function(e) {
      var r = e.value, o = e.text, n = so(o || r);
      return this.options.push({ value: r, text: n }), this.renderOption(r, n), this.updateIndices(), this;
    }, t.prototype.updateIndices = function() {
      var e = this.getGui().querySelectorAll(".ag-list-item");
      e.forEach(function(r, o) {
        Vu(r, o + 1), Hu(r, e.length);
      });
    }, t.prototype.renderOption = function(e, r) {
      var o = this, n = document.createElement("div");
      Dt(n, "option"), n.classList.add("ag-list-item", "ag-" + this.cssIdentifier + "-list-item"), n.innerHTML = "<span>" + r + "</span>", n.tabIndex = -1, this.itemEls.push(n), this.addManagedListener(n, "mouseover", function() {
        return o.highlightItem(n);
      }), this.addManagedListener(n, "mouseleave", function() {
        return o.clearHighlighted();
      }), this.addManagedListener(n, "click", function() {
        return o.setValue(e);
      }), this.getGui().appendChild(n);
    }, t.prototype.setValue = function(e, r) {
      if (this.value === e)
        return this.fireItemSelected(), this;
      if (e == null)
        return this.reset(), this;
      var o = this.options.findIndex(function(s) {
        return s.value === e;
      });
      if (o !== -1) {
        var n = this.options[o];
        this.value = n.value, this.displayValue = n.text != null ? n.text : n.value, this.highlightItem(this.itemEls[o]), r || this.fireChangeEvent();
      }
      return this;
    }, t.prototype.setValueByIndex = function(e) {
      return this.setValue(this.options[e].value);
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getDisplayValue = function() {
      return this.displayValue;
    }, t.prototype.refreshHighlighted = function() {
      var e = this;
      this.clearHighlighted();
      var r = this.options.findIndex(function(o) {
        return o.value === e.value;
      });
      r !== -1 && this.highlightItem(this.itemEls[r]);
    }, t.prototype.reset = function() {
      this.value = null, this.displayValue = null, this.clearHighlighted(), this.fireChangeEvent();
    }, t.prototype.highlightItem = function(e) {
      e.offsetParent && (this.clearHighlighted(), this.highlightedEl = e, this.highlightedEl.classList.add(t.ACTIVE_CLASS), $n(this.highlightedEl, !0), this.highlightedEl.focus());
    }, t.prototype.clearHighlighted = function() {
      !this.highlightedEl || !this.highlightedEl.offsetParent || (this.highlightedEl.classList.remove(t.ACTIVE_CLASS), $n(this.highlightedEl, !1), this.highlightedEl = null);
    }, t.prototype.fireChangeEvent = function() {
      this.dispatchEvent({ type: hn.EVENT_CHANGED }), this.fireItemSelected();
    }, t.prototype.fireItemSelected = function() {
      this.dispatchEvent({ type: t.EVENT_ITEM_SELECTED });
    }, t.EVENT_ITEM_SELECTED = "selectedItem", t.ACTIVE_CLASS = "ag-active-item", iw([
      U
    ], t.prototype, "init", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var sw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Vp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ii = (
  /** @class */
  function(i) {
    sw(t, i);
    function t(e) {
      return i.call(this, e, "ag-select", "smallDown", "listbox") || this;
    }
    return t.prototype.init = function() {
      var e = this;
      this.listComponent = this.createBean(new Hp("select")), this.listComponent.setParentComponent(this), this.eWrapper.tabIndex = 0, this.listComponent.addManagedListener(this.listComponent, Hp.EVENT_ITEM_SELECTED, function() {
        e.hideList && e.hideList(), e.dispatchEvent({ type: t.EVENT_ITEM_SELECTED });
      }), this.listComponent.addManagedListener(this.listComponent, hn.EVENT_CHANGED, function() {
        e.setValue(e.listComponent.getValue(), !1, !0), e.hideList && e.hideList();
      });
    }, t.prototype.showPicker = function() {
      var e = this, r = this.listComponent.getGui(), o = this.gridOptionsService.getDocument(), n = this.addManagedListener(o.body, "wheel", function(u) {
        !r.contains(u.target) && e.hideList && e.hideList();
      }), s = this.addManagedListener(r, "focusout", function(u) {
        !r.contains(u.relatedTarget) && e.hideList && e.hideList();
      }), a = this.localeService.getLocaleTextFunc(), l = this.popupService.addPopup({
        modal: !0,
        eChild: r,
        closeOnEsc: !0,
        closedCallback: function() {
          e.hideList = null, e.isPickerDisplayed = !1, s(), n(), e.isAlive() && (Vr(e.eWrapper, !1), e.getFocusableElement().focus());
        },
        ariaLabel: a("ariaLabelSelectField", "Select Field")
      });
      return l && (this.hideList = l.hideFunc), this.isPickerDisplayed = !0, ji(r, Da(this.eWrapper)), Vr(this.eWrapper, !0), r.style.maxHeight = ki(this.popupService.getPopupParent()) + "px", r.style.position = "absolute", this.popupService.positionPopupByComponent({
        type: "ag-list",
        eventSource: this.eWrapper,
        ePopup: r,
        position: "under",
        keepWithinBounds: !0
      }), this.listComponent.refreshHighlighted(), this.listComponent;
    }, t.prototype.addOptions = function(e) {
      var r = this;
      return e.forEach(function(o) {
        return r.addOption(o);
      }), this;
    }, t.prototype.addOption = function(e) {
      return this.listComponent.addOption(e), this;
    }, t.prototype.setValue = function(e, r, o) {
      if (this.value === e)
        return this;
      o || this.listComponent.setValue(e, !0);
      var n = this.listComponent.getValue();
      return n === this.getValue() ? this : (this.eDisplayField.innerHTML = this.listComponent.getDisplayValue(), i.prototype.setValue.call(this, e, r));
    }, t.prototype.destroy = function() {
      this.hideList && this.hideList(), this.destroyBean(this.listComponent), i.prototype.destroy.call(this);
    }, t.EVENT_ITEM_SELECTED = "selectedItem", Vp([
      v("popupService")
    ], t.prototype, "popupService", void 0), Vp([
      U
    ], t.prototype, "init", null), t;
  }(uh)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var aw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), hl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, vo = (
  /** @class */
  function(i) {
    aw(t, i);
    function t(e, r, o, n) {
      o === void 0 && (o = "text"), n === void 0 && (n = "input");
      var s = i.call(
        this,
        e,
        /* html */
        `
            <div role="presentation">
                <div ref="eLabel" class="ag-input-field-label"></div>
                <div ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <` + n + ' ref="eInput" class="ag-input-field-input"></' + n + `>
                </div>
            </div>`,
        r
      ) || this;
      return s.inputType = o, s.displayFieldTag = n, s;
    }
    return t.prototype.postConstruct = function() {
      i.prototype.postConstruct.call(this), this.setInputType(), this.eLabel.classList.add(this.className + "-label"), this.eWrapper.classList.add(this.className + "-input-wrapper"), this.eInput.classList.add(this.className + "-input"), this.addCssClass("ag-input-field"), this.eInput.id = this.eInput.id || "ag-" + this.getCompId() + "-input";
      var e = this.config, r = e.width, o = e.value;
      r != null && this.setWidth(r), o != null && this.setValue(o), this.addInputListeners();
    }, t.prototype.refreshLabel = function() {
      k(this.getLabel()) ? Nu(this.eInput, this.getLabelId()) : this.eInput.removeAttribute("aria-labelledby"), i.prototype.refreshLabel.call(this);
    }, t.prototype.addInputListeners = function() {
      var e = this;
      this.addManagedListener(this.eInput, "input", function(r) {
        return e.setValue(r.target.value);
      });
    }, t.prototype.setInputType = function() {
      this.displayFieldTag === "input" && this.eInput.setAttribute("type", this.inputType);
    }, t.prototype.getInputElement = function() {
      return this.eInput;
    }, t.prototype.setInputWidth = function(e) {
      return ji(this.eWrapper, e), this;
    }, t.prototype.setInputName = function(e) {
      return this.getInputElement().setAttribute("name", e), this;
    }, t.prototype.getFocusableElement = function() {
      return this.eInput;
    }, t.prototype.setMaxLength = function(e) {
      var r = this.eInput;
      return r.maxLength = e, this;
    }, t.prototype.setInputPlaceholder = function(e) {
      return bi(this.eInput, "placeholder", e), this;
    }, t.prototype.setInputAriaLabel = function(e) {
      return yn(this.eInput, e), this;
    }, t.prototype.setDisabled = function(e) {
      return Kn(this.eInput, e), i.prototype.setDisabled.call(this, e);
    }, hl([
      Y("eLabel")
    ], t.prototype, "eLabel", void 0), hl([
      Y("eWrapper")
    ], t.prototype, "eWrapper", void 0), hl([
      Y("eInput")
    ], t.prototype, "eInput", void 0), t;
  }(hn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var lw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yn = (
  /** @class */
  function(i) {
    lw(t, i);
    function t(e, r, o) {
      r === void 0 && (r = "ag-checkbox"), o === void 0 && (o = "checkbox");
      var n = i.call(this, e, r, o) || this;
      return n.labelAlignment = "right", n.selected = !1, n.readOnly = !1, n.passive = !1, n;
    }
    return t.prototype.addInputListeners = function() {
      this.addManagedListener(this.eInput, "click", this.onCheckboxClick.bind(this)), this.addManagedListener(this.eLabel, "click", this.toggle.bind(this));
    }, t.prototype.getNextValue = function() {
      return this.selected === void 0 ? !0 : !this.selected;
    }, t.prototype.setPassive = function(e) {
      this.passive = e;
    }, t.prototype.isReadOnly = function() {
      return this.readOnly;
    }, t.prototype.setReadOnly = function(e) {
      this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
    }, t.prototype.setDisabled = function(e) {
      return this.eWrapper.classList.toggle("ag-disabled", e), i.prototype.setDisabled.call(this, e);
    }, t.prototype.toggle = function() {
      if (!this.eInput.disabled) {
        var e = this.isSelected(), r = this.getNextValue();
        this.passive ? this.dispatchChange(r, e) : this.setValue(r);
      }
    }, t.prototype.getValue = function() {
      return this.isSelected();
    }, t.prototype.setValue = function(e, r) {
      return this.refreshSelectedClass(e), this.setSelected(e, r), this;
    }, t.prototype.setName = function(e) {
      var r = this.getInputElement();
      return r.name = e, this;
    }, t.prototype.isSelected = function() {
      return this.selected;
    }, t.prototype.setSelected = function(e, r) {
      this.isSelected() !== e && (this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0, this.eInput.checked = e, this.eInput.indeterminate = e === void 0, r || this.dispatchChange(this.selected, this.previousValue));
    }, t.prototype.dispatchChange = function(e, r, o) {
      this.dispatchEvent({ type: t.EVENT_CHANGED, selected: e, previousValue: r, event: o });
      var n = this.getInputElement(), s = {
        type: m.EVENT_CHECKBOX_CHANGED,
        id: n.id,
        name: n.name,
        selected: e,
        previousValue: r
      };
      this.eventService.dispatchEvent(s);
    }, t.prototype.onCheckboxClick = function(e) {
      if (!(this.passive || this.eInput.disabled)) {
        var r = this.isSelected(), o = this.selected = e.target.checked;
        this.refreshSelectedClass(o), this.dispatchChange(o, r, e);
      }
    }, t.prototype.refreshSelectedClass = function(e) {
      this.eWrapper.classList.toggle("ag-checked", e === !0), this.eWrapper.classList.toggle("ag-indeterminate", e == null);
    }, t;
  }(vo)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var uw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), nc = (
  /** @class */
  function(i) {
    uw(t, i);
    function t(e) {
      return i.call(this, e, "ag-radio-button", "radio") || this;
    }
    return t.prototype.isSelected = function() {
      return this.eInput.checked;
    }, t.prototype.toggle = function() {
      this.eInput.disabled || this.isSelected() || this.setValue(!0);
    }, t.prototype.addInputListeners = function() {
      i.prototype.addInputListeners.call(this), this.addManagedListener(this.eventService, m.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
    }, t.prototype.onChange = function(e) {
      e.selected && e.name && this.eInput.name && this.eInput.name === e.name && e.id && this.eInput.id !== e.id && this.setValue(!1, !0);
    }, t;
  }(Yn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var cw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pw = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, dw = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(pw(arguments[t]));
  return i;
}, ic = (
  /** @class */
  function() {
    function i(t, e) {
      this.localeService = t, this.optionsFactory = e;
    }
    return i.prototype.getModelAsString = function(t) {
      var e = this;
      if (!t)
        return null;
      var r = t.operator != null, o = this.localeService.getLocaleTextFunc();
      if (r) {
        var n = t, s = n.conditions;
        if (!s) {
          var a = n.condition1, l = n.condition2;
          s = [a, l];
        }
        var u = s.map(function(_) {
          return e.getModelAsString(_);
        }), c = n.operator === "AND" ? "andCondition" : "orCondition";
        return u.join(" " + o(c, ah[c]) + " ");
      } else {
        if (t.type === Je.BLANK || t.type === Je.NOT_BLANK)
          return o(t.type, t.type);
        var p = t, d = this.optionsFactory.getCustomOption(p.type), h = d || {}, g = h.displayKey, y = h.displayName, S = h.numberOfInputs;
        return g && y && S === 0 ? (o(g, y), y) : this.conditionToString(p, d);
      }
    }, i;
  }()
), Je = (
  /** @class */
  function(i) {
    cw(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.eTypes = [], e.eJoinOperatorPanels = [], e.eJoinOperatorsAnd = [], e.eJoinOperatorsOr = [], e.eConditionBodies = [], e.listener = function() {
        return e.onUiChanged();
      }, e.lastUiCompletePosition = null, e.joinOperatorId = 0, e;
    }
    return t.prototype.getNumberOfInputs = function(e) {
      var r = this.optionsFactory.getCustomOption(e);
      if (r) {
        var o = r.numberOfInputs;
        return o ?? 1;
      }
      var n = [
        t.EMPTY,
        t.NOT_BLANK,
        t.BLANK
      ];
      return e && n.indexOf(e) >= 0 ? 0 : e === t.IN_RANGE ? 2 : 1;
    }, t.prototype.onFloatingFilterChanged = function(e, r) {
      this.setTypeFromFloatingFilter(e), this.setValueFromFloatingFilter(r), this.onUiChanged(!0);
    }, t.prototype.setTypeFromFloatingFilter = function(e) {
      var r = this;
      this.eTypes.forEach(function(o, n) {
        n === 0 ? o.setValue(e, !0) : o.setValue(r.optionsFactory.getDefaultOption(), !0);
      });
    }, t.prototype.getModelFromUi = function() {
      var e = this.getUiCompleteConditions();
      return e.length === 0 ? null : this.maxNumConditions > 1 && e.length > 1 ? {
        filterType: this.getFilterType(),
        operator: this.getJoinOperator(),
        condition1: e[0],
        condition2: e[1],
        conditions: e
      } : e[0];
    }, t.prototype.getConditionTypes = function() {
      return this.eTypes.map(function(e) {
        return e.getValue();
      });
    }, t.prototype.getConditionType = function(e) {
      return this.eTypes[e].getValue();
    }, t.prototype.getJoinOperator = function() {
      return this.eJoinOperatorsOr.length === 0 ? this.defaultJoinOperator : this.eJoinOperatorsOr[0].getValue() === !0 ? "OR" : "AND";
    }, t.prototype.areModelsEqual = function(e, r) {
      var o = this;
      if (!e && !r)
        return !0;
      if (!e && r || e && !r)
        return !1;
      var n = !e.operator, s = !r.operator, a = !n && s || n && !s;
      if (a)
        return !1;
      var l;
      if (n) {
        var u = e, c = r;
        l = this.areSimpleModelsEqual(u, c);
      } else {
        var p = e, d = r;
        l = p.operator === d.operator && No(p.conditions, d.conditions, function(h, g) {
          return o.areSimpleModelsEqual(h, g);
        });
      }
      return l;
    }, t.prototype.setModelIntoUi = function(e) {
      var r = this, o = e.operator;
      if (o) {
        var n = e;
        n.conditions || (n.conditions = [
          n.condition1,
          n.condition2
        ]);
        var s = this.validateAndUpdateConditions(n.conditions), a = this.getNumConditions();
        if (s < a)
          this.removeConditionsAndOperators(s);
        else if (s > a)
          for (var l = a; l < s; l++)
            this.createJoinOperatorPanel(), this.createOption();
        var u = n.operator === "OR";
        this.eJoinOperatorsAnd.forEach(function(p) {
          return p.setValue(!u, !0);
        }), this.eJoinOperatorsOr.forEach(function(p) {
          return p.setValue(u, !0);
        }), n.conditions.forEach(function(p, d) {
          r.eTypes[d].setValue(p.type, !0), r.setConditionIntoUi(p, d);
        });
      } else {
        var c = e;
        this.getNumConditions() > 1 && this.removeConditionsAndOperators(1), this.eTypes[0].setValue(c.type, !0), this.setConditionIntoUi(c, 0);
      }
      return this.lastUiCompletePosition = this.getNumConditions() - 1, this.createMissingConditionsAndOperators(), this.onUiChanged(), nr.resolve();
    }, t.prototype.validateAndUpdateConditions = function(e) {
      var r = e.length;
      return r > this.maxNumConditions && (e.splice(this.maxNumConditions), Pe(function() {
        return console.warn('AG Grid: Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.');
      }, "simpleFilterSetModelMaxNumConditions"), r = this.maxNumConditions), r;
    }, t.prototype.doesFilterPass = function(e) {
      var r = this, o, n = this.getModel();
      if (n == null)
        return !0;
      var s = n.operator, a = [];
      if (s) {
        var l = n;
        a.push.apply(a, dw((o = l.conditions) !== null && o !== void 0 ? o : []));
      } else
        a.push(n);
      var u = s && s === "OR" ? "some" : "every";
      return a[u](function(c) {
        return r.individualConditionPasses(e, c);
      });
    }, t.prototype.setParams = function(e) {
      i.prototype.setParams.call(this, e), this.setNumConditions(e), this.defaultJoinOperator = this.getDefaultJoinOperator(e.defaultJoinOperator), this.filterPlaceholder = e.filterPlaceholder, this.optionsFactory = new sh(), this.optionsFactory.init(e, this.getDefaultFilterOptions()), this.createOption(), this.createMissingConditionsAndOperators();
    }, t.prototype.setNumConditions = function(e) {
      var r, o;
      e.suppressAndOrCondition != null && Pe(function() {
        return console.warn('AG Grid: Since v29.2 "filterParams.suppressAndOrCondition" is deprecated. Use "filterParams.maxNumConditions = 1" instead.');
      }, "simpleFilterSuppressAndOrCondition"), e.alwaysShowBothConditions != null && Pe(function() {
        return console.warn('AG Grid: Since v29.2 "filterParams.alwaysShowBothConditions" is deprecated. Use "filterParams.numAlwaysVisibleConditions = 2" instead.');
      }, "simpleFilterAlwaysShowBothConditions"), this.maxNumConditions = (r = e.maxNumConditions) !== null && r !== void 0 ? r : e.suppressAndOrCondition ? 1 : 2, this.maxNumConditions < 1 && (Pe(function() {
        return console.warn('AG Grid: "filterParams.maxNumConditions" must be greater than or equal to zero.');
      }, "simpleFilterMaxNumConditions"), this.maxNumConditions = 1), this.numAlwaysVisibleConditions = (o = e.numAlwaysVisibleConditions) !== null && o !== void 0 ? o : e.alwaysShowBothConditions ? 2 : 1, this.numAlwaysVisibleConditions < 1 && (Pe(function() {
        return console.warn('AG Grid: "filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.');
      }, "simpleFilterNumAlwaysVisibleConditions"), this.numAlwaysVisibleConditions = 1), this.numAlwaysVisibleConditions > this.maxNumConditions && (Pe(function() {
        return console.warn('AG Grid: "filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".');
      }, "simpleFilterNumAlwaysVisibleGreaterThanMaxNumConditions"), this.numAlwaysVisibleConditions = this.maxNumConditions);
    }, t.prototype.createOption = function() {
      var e = this, r = this.createManagedBean(new Ii());
      this.eTypes.push(r), r.addCssClass("ag-filter-select"), this.eFilterBody.appendChild(r.getGui());
      var o = this.createValueElement();
      this.eConditionBodies.push(o), this.eFilterBody.appendChild(o), this.putOptionsIntoDropdown(r), this.resetType(r);
      var n = this.getNumConditions() - 1;
      this.forEachPositionInput(n, function(s) {
        return e.resetInput(s);
      }), this.addChangedListeners(r, n);
    }, t.prototype.createJoinOperatorPanel = function() {
      var e = document.createElement("div");
      this.eJoinOperatorPanels.push(e), e.classList.add("ag-filter-condition");
      var r = this.createJoinOperator(this.eJoinOperatorsAnd, e, "and"), o = this.createJoinOperator(this.eJoinOperatorsOr, e, "or");
      this.eFilterBody.appendChild(e);
      var n = this.eJoinOperatorPanels.length - 1, s = this.joinOperatorId++;
      this.resetJoinOperatorAnd(r, n, s), this.resetJoinOperatorOr(o, n, s), this.isReadOnly() || (r.onValueChange(this.listener), o.onValueChange(this.listener));
    }, t.prototype.createJoinOperator = function(e, r, o) {
      var n = this.createManagedBean(new nc());
      return e.push(n), n.addCssClass("ag-filter-condition-operator"), n.addCssClass("ag-filter-condition-operator-" + o), r.appendChild(n.getGui()), n;
    }, t.prototype.getDefaultJoinOperator = function(e) {
      return e === "AND" || e === "OR" ? e : "AND";
    }, t.prototype.putOptionsIntoDropdown = function(e) {
      var r = this, o = this.optionsFactory.getFilterOptions();
      o.forEach(function(n) {
        var s = typeof n == "string" ? r.createBoilerplateListOption(n) : r.createCustomListOption(n);
        e.addOption(s);
      }), e.setDisabled(o.length <= 1);
    }, t.prototype.createBoilerplateListOption = function(e) {
      return { value: e, text: this.translate(e) };
    }, t.prototype.createCustomListOption = function(e) {
      var r = e.displayKey, o = this.optionsFactory.getCustomOption(e.displayKey);
      return {
        value: r,
        text: o ? this.localeService.getLocaleTextFunc()(o.displayKey, o.displayName) : this.translate(r)
      };
    }, t.prototype.isAllowTwoConditions = function() {
      return this.maxNumConditions >= 2;
    }, t.prototype.createBodyTemplate = function() {
      return "";
    }, t.prototype.getCssIdentifier = function() {
      return "simple-filter";
    }, t.prototype.updateUiVisibility = function() {
      var e = this.getJoinOperator();
      this.updateNumConditions(), this.updateConditionStatusesAndValues(this.lastUiCompletePosition, e);
    }, t.prototype.updateNumConditions = function() {
      for (var e, r = -1, o = !0, n = 0; n < this.getNumConditions(); n++)
        this.isConditionUiComplete(n) ? r = n : o = !1;
      if (this.shouldAddNewConditionAtEnd(o))
        this.createJoinOperatorPanel(), this.createOption();
      else {
        var s = (e = this.lastUiCompletePosition) !== null && e !== void 0 ? e : this.getNumConditions() - 2;
        if (r < s) {
          this.removeConditionsAndOperators(s + 1);
          var a = r + 1, l = s - a;
          l > 0 && this.removeConditionsAndOperators(a, l), this.createMissingConditionsAndOperators();
        }
      }
      this.lastUiCompletePosition = r;
    }, t.prototype.updateConditionStatusesAndValues = function(e, r) {
      var o = this;
      this.eTypes.forEach(function(s, a) {
        var l = o.isConditionDisabled(a, e), u = a === 1 ? [s, o.eJoinOperatorPanels[0], o.eJoinOperatorsAnd[0], o.eJoinOperatorsOr[0]] : [s];
        u.forEach(function(c) {
          c instanceof vo || c instanceof Ii ? c.setDisabled(l) : Kn(c, l);
        });
      }), this.eConditionBodies.forEach(function(s, a) {
        be(s, o.isConditionBodyVisible(a));
      });
      var n = (r ?? this.getJoinOperator()) === "OR";
      this.eJoinOperatorsAnd.forEach(function(s, a) {
        s.setValue(!n, !0);
      }), this.eJoinOperatorsOr.forEach(function(s, a) {
        s.setValue(n, !0);
      }), this.forEachInput(function(s, a, l, u) {
        o.setElementDisplayed(s, a < u), o.setElementDisabled(s, o.isConditionDisabled(l, e));
      }), this.resetPlaceholder();
    }, t.prototype.shouldAddNewConditionAtEnd = function(e) {
      return e && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }, t.prototype.removeConditionsAndOperators = function(e, r) {
      if (!(e >= this.getNumConditions())) {
        this.removeComponents(this.eTypes, e, r), this.removeElements(this.eConditionBodies, e, r), this.removeValueElements(e, r);
        var o = Math.max(e - 1, 0);
        this.removeElements(this.eJoinOperatorPanels, o, r), this.removeComponents(this.eJoinOperatorsAnd, o, r), this.removeComponents(this.eJoinOperatorsOr, o, r);
      }
    }, t.prototype.removeElements = function(e, r, o) {
      var n = this.removeItems(e, r, o);
      n.forEach(function(s) {
        return go(s);
      });
    }, t.prototype.removeComponents = function(e, r, o) {
      var n = this, s = this.removeItems(e, r, o);
      s.forEach(function(a) {
        go(a.getGui()), n.destroyBean(a);
      });
    }, t.prototype.removeItems = function(e, r, o) {
      return o == null ? e.splice(r) : e.splice(r, o);
    }, t.prototype.afterGuiAttached = function(e) {
      if (i.prototype.afterGuiAttached.call(this, e), this.resetPlaceholder(), !e || !e.suppressFocus && !this.isReadOnly()) {
        var r = this.getInputs(0)[0];
        if (!r)
          return;
        r instanceof vo && r.getInputElement().focus();
      }
    }, t.prototype.afterGuiDetached = function() {
      i.prototype.afterGuiDetached.call(this);
      var e = this.getModel();
      this.areModelsEqual(e, this.getModelFromUi()) || this.resetUiToActiveModel(e);
      for (var r = -1, o = -1, n = !1, s = this.getJoinOperator(), a = this.getNumConditions() - 1; a >= 0; a--)
        if (this.isConditionUiComplete(a))
          r === -1 && (r = a, o = a);
        else {
          var l = a >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(a - 1), u = a < r;
          (l || u) && (this.removeConditionsAndOperators(a, 1), n = !0, u && o--);
        }
      var c = !1;
      this.getNumConditions() < this.numAlwaysVisibleConditions && (this.createMissingConditionsAndOperators(), c = !0), this.shouldAddNewConditionAtEnd(o === this.getNumConditions() - 1) && (this.createJoinOperatorPanel(), this.createOption(), c = !0), c && this.updateConditionStatusesAndValues(o, s), n && this.updateJoinOperatorsDisabled(), this.lastUiCompletePosition = o;
    }, t.prototype.getPlaceholderText = function(e, r) {
      var o = this.translate(e);
      if (Oa(this.filterPlaceholder)) {
        var n = this.filterPlaceholder, s = this.eTypes[r].getValue(), a = this.translate(s);
        o = n({
          filterOptionKey: s,
          filterOption: a,
          placeholder: o
        });
      } else
        typeof this.filterPlaceholder == "string" && (o = this.filterPlaceholder);
      return o;
    }, t.prototype.resetPlaceholder = function() {
      var e = this, r = this.localeService.getLocaleTextFunc();
      this.forEachInput(function(o, n, s, a) {
        if (o instanceof vo) {
          var l = n === 0 && a > 1 ? "inRangeStart" : n === 0 ? "filterOoo" : "inRangeEnd", u = n === 0 && a > 1 ? r("ariaFilterFromValue", "Filter from value") : n === 0 ? r("ariaFilterValue", "Filter Value") : r("ariaFilterToValue", "Filter to Value");
          o.setInputPlaceholder(e.getPlaceholderText(l, s)), o.setInputAriaLabel(u);
        }
      });
    }, t.prototype.setElementValue = function(e, r) {
      e instanceof vo && e.setValue(r != null ? String(r) : null, !0);
    }, t.prototype.setElementDisplayed = function(e, r) {
      e instanceof ge && be(e.getGui(), r);
    }, t.prototype.setElementDisabled = function(e, r) {
      e instanceof ge && Kn(e.getGui(), r);
    }, t.prototype.attachElementOnChange = function(e, r) {
      e instanceof vo && e.onValueChange(r);
    }, t.prototype.forEachInput = function(e) {
      var r = this;
      this.getConditionTypes().forEach(function(o, n) {
        r.forEachPositionTypeInput(n, o, e);
      });
    }, t.prototype.forEachPositionInput = function(e, r) {
      var o = this.getConditionType(e);
      this.forEachPositionTypeInput(e, o, r);
    }, t.prototype.forEachPositionTypeInput = function(e, r, o) {
      for (var n = this.getNumberOfInputs(r), s = this.getInputs(e), a = 0; a < s.length; a++) {
        var l = s[a];
        l != null && o(l, a, e, n);
      }
    }, t.prototype.isConditionDisabled = function(e, r) {
      return this.isReadOnly() ? !0 : e === 0 ? !1 : e > r + 1;
    }, t.prototype.isConditionBodyVisible = function(e) {
      var r = this.getConditionType(e), o = this.getNumberOfInputs(r);
      return o > 0;
    }, t.prototype.isConditionUiComplete = function(e) {
      if (e >= this.getNumConditions())
        return !1;
      var r = this.getConditionType(e);
      return !(r === t.EMPTY || this.getValues(e).some(function(o) {
        return o == null;
      }));
    }, t.prototype.getNumConditions = function() {
      return this.eTypes.length;
    }, t.prototype.getUiCompleteConditions = function() {
      for (var e = [], r = 0; r < this.getNumConditions(); r++)
        this.isConditionUiComplete(r) && e.push(this.createCondition(r));
      return e;
    }, t.prototype.createMissingConditionsAndOperators = function() {
      if (!this.isReadOnly())
        for (var e = this.getNumConditions(); e < this.numAlwaysVisibleConditions; e++)
          this.createJoinOperatorPanel(), this.createOption();
    }, t.prototype.resetUiToDefaults = function(e) {
      var r = this;
      return this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions), this.eTypes.forEach(function(o) {
        return r.resetType(o);
      }), this.eJoinOperatorsAnd.forEach(function(o, n) {
        return r.resetJoinOperatorAnd(o, n, r.joinOperatorId + n);
      }), this.eJoinOperatorsOr.forEach(function(o, n) {
        return r.resetJoinOperatorOr(o, n, r.joinOperatorId + n);
      }), this.joinOperatorId++, this.forEachInput(function(o) {
        return r.resetInput(o);
      }), this.resetPlaceholder(), this.createMissingConditionsAndOperators(), this.lastUiCompletePosition = null, e || this.onUiChanged(), nr.resolve();
    }, t.prototype.resetType = function(e) {
      var r = this.localeService.getLocaleTextFunc(), o = r("ariaFilteringOperator", "Filtering operator");
      e.setValue(this.optionsFactory.getDefaultOption(), !0).setAriaLabel(o).setDisabled(this.isReadOnly());
    }, t.prototype.resetJoinOperatorAnd = function(e, r, o) {
      this.resetJoinOperator(e, r, this.isDefaultOperator("AND"), this.translate("andCondition"), o);
    }, t.prototype.resetJoinOperatorOr = function(e, r, o) {
      this.resetJoinOperator(e, r, this.isDefaultOperator("OR"), this.translate("orCondition"), o);
    }, t.prototype.resetJoinOperator = function(e, r, o, n, s) {
      this.updateJoinOperatorDisabled(e.setValue(o, !0).setName("ag-simple-filter-and-or-" + this.getCompId() + "-" + s).setLabel(n), r);
    }, t.prototype.updateJoinOperatorsDisabled = function() {
      var e = this;
      this.eJoinOperatorsAnd.forEach(function(r, o) {
        return e.updateJoinOperatorDisabled(r, o);
      }), this.eJoinOperatorsOr.forEach(function(r, o) {
        return e.updateJoinOperatorDisabled(r, o);
      });
    }, t.prototype.updateJoinOperatorDisabled = function(e, r) {
      e.setDisabled(this.isReadOnly() || r > 0);
    }, t.prototype.resetInput = function(e) {
      this.setElementValue(e, null), this.setElementDisabled(e, this.isReadOnly());
    }, t.prototype.setConditionIntoUi = function(e, r) {
      var o = this, n = this.mapValuesFromModel(e);
      this.forEachInput(function(s, a, l, u) {
        l === r && o.setElementValue(s, n[a] != null ? n[a] : null);
      });
    }, t.prototype.setValueFromFloatingFilter = function(e) {
      var r = this;
      this.forEachInput(function(o, n, s, a) {
        r.setElementValue(o, n === 0 && s === 0 ? e : null);
      });
    }, t.prototype.isDefaultOperator = function(e) {
      return e === this.defaultJoinOperator;
    }, t.prototype.addChangedListeners = function(e, r) {
      var o = this;
      this.isReadOnly() || (e.onValueChange(this.listener), this.forEachPositionInput(r, function(n) {
        o.attachElementOnChange(n, o.listener);
      }));
    }, t.prototype.individualConditionPasses = function(e, r) {
      var o = this.getCellValue(e.node), n = this.mapValuesFromModel(r), s = this.optionsFactory.getCustomOption(r.type), a = this.evaluateCustomFilter(s, n, o);
      return a ?? (o == null ? this.evaluateNullValue(r.type) : this.evaluateNonNullValue(n, o, r, e));
    }, t.prototype.evaluateCustomFilter = function(e, r, o) {
      if (e != null) {
        var n = e.predicate;
        if (n != null && !r.some(function(s) {
          return s == null;
        }))
          return n(r, o);
      }
    }, t.prototype.isBlank = function(e) {
      return e == null || typeof e == "string" && e.trim().length === 0;
    }, t.EMPTY = "empty", t.BLANK = "blank", t.NOT_BLANK = "notBlank", t.EQUALS = "equals", t.NOT_EQUAL = "notEqual", t.LESS_THAN = "lessThan", t.LESS_THAN_OR_EQUAL = "lessThanOrEqual", t.GREATER_THAN = "greaterThan", t.GREATER_THAN_OR_EQUAL = "greaterThanOrEqual", t.IN_RANGE = "inRange", t.CONTAINS = "contains", t.NOT_CONTAINS = "notContains", t.STARTS_WITH = "startsWith", t.ENDS_WITH = "endsWith", t;
  }(Mi)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var fw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), St = (
  /** @class */
  function(i) {
    fw(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.setParams = function(e) {
      i.prototype.setParams.call(this, e), this.scalarFilterParams = e;
    }, t.prototype.evaluateNullValue = function(e) {
      switch (e) {
        case t.EQUALS:
        case t.NOT_EQUAL:
          if (this.scalarFilterParams.includeBlanksInEquals)
            return !0;
          break;
        case t.GREATER_THAN:
        case t.GREATER_THAN_OR_EQUAL:
          if (this.scalarFilterParams.includeBlanksInGreaterThan)
            return !0;
          break;
        case t.LESS_THAN:
        case t.LESS_THAN_OR_EQUAL:
          if (this.scalarFilterParams.includeBlanksInLessThan)
            return !0;
          break;
        case t.IN_RANGE:
          if (this.scalarFilterParams.includeBlanksInRange)
            return !0;
          break;
        case t.BLANK:
          return !0;
        case t.NOT_BLANK:
          return !1;
      }
      return !1;
    }, t.prototype.evaluateNonNullValue = function(e, r, o) {
      var n = this.comparator(), s = e[0] != null ? n(e[0], r) : 0;
      switch (o.type) {
        case t.EQUALS:
          return s === 0;
        case t.NOT_EQUAL:
          return s !== 0;
        case t.GREATER_THAN:
          return s > 0;
        case t.GREATER_THAN_OR_EQUAL:
          return s >= 0;
        case t.LESS_THAN:
          return s < 0;
        case t.LESS_THAN_OR_EQUAL:
          return s <= 0;
        case t.IN_RANGE: {
          var a = n(e[1], r);
          return this.scalarFilterParams.inRangeInclusive ? s >= 0 && a <= 0 : s > 0 && a < 0;
        }
        case t.BLANK:
          return this.isBlank(r);
        case t.NOT_BLANK:
          return !this.isBlank(r);
        default:
          return console.warn('AG Grid: Unexpected type of filter "' + o.type + '", it looks like the filter was configured with incorrect Filter Options'), !0;
      }
    }, t;
  }(Je)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ch = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), du = function() {
  return du = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, du.apply(this, arguments);
}, hw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Bp = 1e3, kp = 1 / 0, ph = (
  /** @class */
  function(i) {
    ch(t, i);
    function t(e, r, o) {
      var n = i.call(this, r, o) || this;
      return n.dateFilterParams = e, n;
    }
    return t.prototype.conditionToString = function(e, r) {
      var o = e.type, n = (r || {}).numberOfInputs, s = o == Je.IN_RANGE || n === 2, a = Bo(e.dateFrom), l = Bo(e.dateTo), u = this.dateFilterParams.inRangeFloatingFilterDateFormat;
      if (s) {
        var c = a !== null ? Bs(a, u) : "null", p = l !== null ? Bs(l, u) : "null";
        return c + "-" + p;
      }
      return a != null ? Bs(a, u) : "" + o;
    }, t;
  }(ic)
), sc = (
  /** @class */
  function(i) {
    ch(t, i);
    function t() {
      var e = i.call(this, "dateFilter") || this;
      return e.eConditionPanelsFrom = [], e.eConditionPanelsTo = [], e.dateConditionFromComps = [], e.dateConditionToComps = [], e.minValidYear = Bp, e.maxValidYear = kp, e;
    }
    return t.prototype.afterGuiAttached = function(e) {
      i.prototype.afterGuiAttached.call(this, e), this.dateConditionFromComps[0].afterGuiAttached(e);
    }, t.prototype.mapValuesFromModel = function(e) {
      var r = e || {}, o = r.dateFrom, n = r.dateTo, s = r.type;
      return [
        o && Bo(o) || null,
        n && Bo(n) || null
      ].slice(0, this.getNumberOfInputs(s));
    }, t.prototype.comparator = function() {
      return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
    }, t.prototype.defaultComparator = function(e, r) {
      var o = r;
      return r == null || o < e ? -1 : o > e ? 1 : 0;
    }, t.prototype.setParams = function(e) {
      this.dateFilterParams = e, i.prototype.setParams.call(this, e);
      var r = function(o, n) {
        if (e[o] != null)
          if (isNaN(e[o]))
            console.warn("AG Grid: DateFilter " + o + " is not a number");
          else
            return e[o] == null ? n : Number(e[o]);
        return n;
      };
      this.minValidYear = r("minValidYear", Bp), this.maxValidYear = r("maxValidYear", kp), this.minValidYear > this.maxValidYear && console.warn("AG Grid: DateFilter minValidYear should be <= maxValidYear"), this.filterModelFormatter = new ph(this.dateFilterParams, this.localeService, this.optionsFactory);
    }, t.prototype.createDateCompWrapper = function(e) {
      var r = this, o = new ih(this.getContext(), this.userComponentFactory, {
        onDateChanged: function() {
          return r.onUiChanged();
        },
        filterParams: this.dateFilterParams
      }, e);
      return this.addDestroyFunc(function() {
        return o.destroy();
      }), o;
    }, t.prototype.setElementValue = function(e, r) {
      e.setDate(r);
    }, t.prototype.setElementDisplayed = function(e, r) {
      e.setDisplayed(r);
    }, t.prototype.setElementDisabled = function(e, r) {
      e.setDisabled(r);
    }, t.prototype.getDefaultFilterOptions = function() {
      return t.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.createValueElement = function() {
      var e = document.createElement("div");
      return e.classList.add("ag-filter-body"), this.createFromToElement(e, this.eConditionPanelsFrom, this.dateConditionFromComps, "from"), this.createFromToElement(e, this.eConditionPanelsTo, this.dateConditionToComps, "to"), e;
    }, t.prototype.createFromToElement = function(e, r, o, n) {
      var s = document.createElement("div");
      s.classList.add("ag-filter-" + n), s.classList.add("ag-filter-date-" + n), r.push(s), e.appendChild(s), o.push(this.createDateCompWrapper(s));
    }, t.prototype.removeValueElements = function(e, r) {
      this.removeDateComps(this.dateConditionFromComps, e, r), this.removeDateComps(this.dateConditionToComps, e, r), this.removeItems(this.eConditionPanelsFrom, e, r), this.removeItems(this.eConditionPanelsTo, e, r);
    }, t.prototype.removeDateComps = function(e, r, o) {
      var n = this.removeItems(e, r, o);
      n.forEach(function(s) {
        return s.destroy();
      });
    }, t.prototype.isConditionUiComplete = function(e) {
      var r = this;
      if (!i.prototype.isConditionUiComplete.call(this, e))
        return !1;
      var o = function(s) {
        return s != null && s.getUTCFullYear() >= r.minValidYear && s.getUTCFullYear() <= r.maxValidYear;
      }, n = !0;
      return this.forEachInput(function(s, a, l, u) {
        l !== e || !n || a >= u || (n = n && o(s.getDate()));
      }), n;
    }, t.prototype.areSimpleModelsEqual = function(e, r) {
      return e.dateFrom === r.dateFrom && e.dateTo === r.dateTo && e.type === r.type;
    }, t.prototype.getFilterType = function() {
      return "date";
    }, t.prototype.createCondition = function(e) {
      var r = this.getConditionType(e), o = {}, n = this.getValues(e);
      return n.length > 0 && (o.dateFrom = Ai(n[0])), n.length > 1 && (o.dateTo = Ai(n[1])), du({ dateFrom: null, dateTo: null, filterType: this.getFilterType(), type: r }, o);
    }, t.prototype.resetPlaceholder = function() {
      var e = this.localeService.getLocaleTextFunc(), r = this.translate("dateFormatOoo"), o = e("ariaFilterValue", "Filter Value");
      this.forEachInput(function(n) {
        n.setInputPlaceholder(r), n.setInputAriaLabel(o);
      });
    }, t.prototype.getInputs = function(e) {
      return e >= this.dateConditionFromComps.length ? [null, null] : [this.dateConditionFromComps[e], this.dateConditionToComps[e]];
    }, t.prototype.getValues = function(e) {
      var r = [];
      return this.forEachPositionInput(e, function(o, n, s, a) {
        n < a && r.push(o.getDate());
      }), r;
    }, t.prototype.getModelAsString = function(e) {
      var r;
      return (r = this.filterModelFormatter.getModelAsString(e)) !== null && r !== void 0 ? r : "";
    }, t.DEFAULT_FILTER_OPTIONS = [
      St.EQUALS,
      St.GREATER_THAN,
      St.LESS_THAN,
      St.NOT_EQUAL,
      St.IN_RANGE,
      St.BLANK,
      St.NOT_BLANK
    ], hw([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), t;
  }(St)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var vw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), dh = (
  /** @class */
  function(i) {
    vw(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.getDefaultDebounceMs = function() {
      return 0;
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.prototype.isEventFromFloatingFilter = function(e) {
      return e && e.afterFloatingFilter;
    }, t.prototype.isEventFromDataChange = function(e) {
      return e == null ? void 0 : e.afterDataChange;
    }, t.prototype.getLastType = function() {
      return this.lastType;
    }, t.prototype.isReadOnly = function() {
      return this.readOnly;
    }, t.prototype.setLastTypeFromModel = function(e) {
      if (!e) {
        this.lastType = this.optionsFactory.getDefaultOption();
        return;
      }
      var r = e.operator, o;
      if (r) {
        var n = e;
        o = n.conditions[0];
      } else
        o = e;
      this.lastType = o.type;
    }, t.prototype.canWeEditAfterModelFromParentFilter = function(e) {
      if (!e)
        return this.isTypeEditable(this.lastType);
      var r = e.operator;
      if (r)
        return !1;
      var o = e;
      return this.isTypeEditable(o.type);
    }, t.prototype.init = function(e) {
      this.optionsFactory = new sh(), this.optionsFactory.init(e.filterParams, this.getDefaultFilterOptions()), this.lastType = this.optionsFactory.getDefaultOption(), this.readOnly = !!e.filterParams.readOnly;
      var r = this.isTypeEditable(this.lastType);
      this.setEditable(r);
    }, t.prototype.doesFilterHaveSingleInput = function(e) {
      var r = this.optionsFactory.getCustomOption(e), o = (r || {}).numberOfInputs;
      return o == null || o == 1;
    }, t.prototype.isTypeEditable = function(e) {
      var r = [
        Je.IN_RANGE,
        Je.EMPTY,
        Je.BLANK,
        Je.NOT_BLANK
      ];
      return !!e && !this.isReadOnly() && this.doesFilterHaveSingleInput(e) && r.indexOf(e) < 0;
    }, t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var gw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), vl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, yw = (
  /** @class */
  function(i) {
    gw(t, i);
    function t() {
      return i.call(
        this,
        /* html */
        `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eReadOnlyText"></ag-input-text-field>
                <div ref="eDateWrapper" style="display: flex;"></div>
            </div>`
      ) || this;
    }
    return t.prototype.getDefaultFilterOptions = function() {
      return sc.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.init = function(e) {
      i.prototype.init.call(this, e), this.params = e, this.filterParams = e.filterParams, this.createDateComponent();
      var r = this.localeService.getLocaleTextFunc();
      this.eReadOnlyText.setDisabled(!0).setInputAriaLabel(r("ariaDateFilterInput", "Date Filter Input")), this.filterModelFormatter = new ph(this.filterParams, this.localeService, this.optionsFactory);
    }, t.prototype.setEditable = function(e) {
      be(this.eDateWrapper, e), be(this.eReadOnlyText.getGui(), !e);
    }, t.prototype.onParentModelChanged = function(e, r) {
      if (!(this.isEventFromFloatingFilter(r) || this.isEventFromDataChange(r))) {
        i.prototype.setLastTypeFromModel.call(this, e);
        var o = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(e);
        if (this.setEditable(o), o) {
          if (e) {
            var n = e;
            this.dateComp.setDate(Bo(n.dateFrom));
          } else
            this.dateComp.setDate(null);
          this.eReadOnlyText.setValue("");
        } else
          this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(e)), this.dateComp.setDate(null);
      }
    }, t.prototype.onDateChanged = function() {
      var e = this, r = this.dateComp.getDate(), o = Ai(r);
      this.params.parentFilterInstance(function(n) {
        if (n) {
          var s = Bo(o);
          n.onFloatingFilterChanged(e.getLastType() || null, s);
        }
      });
    }, t.prototype.createDateComponent = function() {
      var e = this, r = Mi.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs()), o = {
        onDateChanged: ro(this.onDateChanged.bind(this), r),
        filterParams: this.params.column.getColDef().filterParams
      };
      this.dateComp = new ih(this.getContext(), this.userComponentFactory, o, this.eDateWrapper), this.addDestroyFunc(function() {
        return e.dateComp.destroy();
      });
    }, t.prototype.getFilterModelFormatter = function() {
      return this.filterModelFormatter;
    }, vl([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), vl([
      Y("eReadOnlyText")
    ], t.prototype, "eReadOnlyText", void 0), vl([
      Y("eDateWrapper")
    ], t.prototype, "eDateWrapper", void 0), t;
  }(dh)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var mw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, ww = (
  /** @class */
  function(i) {
    mw(t, i);
    function t() {
      return i.call(
        this,
        /* html */
        `
            <div class="ag-filter-filter">
                <ag-input-text-field class="ag-date-filter" ref="eDateInput"></ag-input-text-field>
            </div>`
      ) || this;
    }
    return t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      var r = this, o = this.gridOptionsService.getDocument(), n = this.eDateInput.getInputElement(), s = this.shouldUseBrowserDatePicker(e);
      s && (n.type = "date");
      var a = s && ao();
      this.addManagedListener(n, "mousedown", function() {
        r.eDateInput.isDisabled() || a || n.focus();
      }), this.addManagedListener(n, "input", function(p) {
        p.target === o.activeElement && (r.eDateInput.isDisabled() || e.onDateChanged());
      });
      var l = e.filterParams || {}, u = l.minValidYear, c = l.maxValidYear;
      u && (n.min = u + "-01-01"), c && (n.max = c + "-12-31");
    }, t.prototype.getDate = function() {
      return Bo(this.eDateInput.getValue());
    }, t.prototype.setDate = function(e) {
      this.eDateInput.setValue(Ai(e, !1));
    }, t.prototype.setInputPlaceholder = function(e) {
      this.eDateInput.setInputPlaceholder(e);
    }, t.prototype.setDisabled = function(e) {
      this.eDateInput.setDisabled(e);
    }, t.prototype.afterGuiAttached = function(e) {
      (!e || !e.suppressFocus) && this.eDateInput.getInputElement().focus();
    }, t.prototype.shouldUseBrowserDatePicker = function(e) {
      return e.filterParams && e.filterParams.browserDatePicker != null ? e.filterParams.browserDatePicker : Bi() || Wu() || ao() && ju() >= 14.1;
    }, Cw([
      Y("eDateInput")
    ], t.prototype, "eDateInput", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Sw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cn = (
  /** @class */
  function(i) {
    Sw(t, i);
    function t(e, r, o) {
      return r === void 0 && (r = "ag-text-field"), o === void 0 && (o = "text"), i.call(this, e, r, o) || this;
    }
    return t.prototype.postConstruct = function() {
      i.prototype.postConstruct.call(this), this.config.allowedCharPattern && this.preventDisallowedCharacters();
    }, t.prototype.setValue = function(e, r) {
      var o = i.prototype.setValue.call(this, e, r);
      return this.eInput.value !== e && (this.eInput.value = k(e) ? e : ""), o;
    }, t.prototype.preventDisallowedCharacters = function() {
      var e = new RegExp("[" + this.config.allowedCharPattern + "]"), r = function(o) {
        o.ctrlKey || o.metaKey || o.key && !e.test(o.key) && o.preventDefault();
      };
      this.addManagedListener(this.eInput, "keypress", r), this.addManagedListener(this.eInput, "paste", function(o) {
        var n, s = (n = o.clipboardData) === null || n === void 0 ? void 0 : n.getData("text");
        s && s.split("").some(function(a) {
          return !e.test(a);
        }) && o.preventDefault();
      });
    }, t;
  }(vo)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var _w = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xa = (
  /** @class */
  function(i) {
    _w(t, i);
    function t(e) {
      return i.call(this, e, "ag-number-field", "number") || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      i.prototype.postConstruct.call(this), this.addManagedListener(this.eInput, "blur", function() {
        var r = parseFloat(e.eInput.value), o = isNaN(r) ? "" : e.normalizeValue(r.toString());
        e.value !== o && e.setValue(o);
      }), this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this)), this.eInput.step = "any";
    }, t.prototype.onWheel = function(e) {
      document.activeElement === this.eInput && e.preventDefault();
    }, t.prototype.normalizeValue = function(e) {
      if (e === "")
        return "";
      this.precision && (e = this.adjustPrecision(e));
      var r = parseFloat(e);
      return this.min != null && r < this.min ? e = this.min.toString() : this.max != null && r > this.max && (e = this.max.toString()), e;
    }, t.prototype.adjustPrecision = function(e) {
      if (this.precision) {
        var r = parseFloat(e).toFixed(this.precision);
        e = parseFloat(r).toString();
      }
      return e;
    }, t.prototype.setMin = function(e) {
      return this.min === e ? this : (this.min = e, bi(this.eInput, "min", e), this);
    }, t.prototype.setMax = function(e) {
      return this.max === e ? this : (this.max = e, bi(this.eInput, "max", e), this);
    }, t.prototype.setPrecision = function(e) {
      return this.precision = e, this;
    }, t.prototype.setStep = function(e) {
      return this.step === e ? this : (this.step = e, bi(this.eInput, "step", e), this);
    }, t.prototype.setValue = function(e, r) {
      if (e != null) {
        e = this.adjustPrecision(e);
        var o = this.normalizeValue(e);
        if (e != o)
          return this;
      }
      return i.prototype.setValue.call(this, e, r);
    }, t;
  }(Cn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var fh = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), hh = (
  /** @class */
  function(i) {
    fh(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.conditionToString = function(e, r) {
      var o = (r || {}).numberOfInputs, n = e.type == Je.IN_RANGE || o === 2;
      return n ? e.filter + "-" + e.filterTo : e.filter != null ? "" + e.filter : "" + e.type;
    }, t;
  }(ic)
);
function vh(i) {
  var t = (i ?? {}).allowedCharPattern;
  return t || (Bi() ? null : "\\d\\-\\.");
}
var ac = (
  /** @class */
  function(i) {
    fh(t, i);
    function t() {
      var e = i.call(this, "numberFilter") || this;
      return e.eValuesFrom = [], e.eValuesTo = [], e;
    }
    return t.prototype.mapValuesFromModel = function(e) {
      var r = e || {}, o = r.filter, n = r.filterTo, s = r.type;
      return [
        this.processValue(o),
        this.processValue(n)
      ].slice(0, this.getNumberOfInputs(s));
    }, t.prototype.getDefaultDebounceMs = function() {
      return 500;
    }, t.prototype.comparator = function() {
      return function(e, r) {
        return e === r ? 0 : e < r ? 1 : -1;
      };
    }, t.prototype.setParams = function(e) {
      this.numberFilterParams = e, i.prototype.setParams.call(this, e), this.filterModelFormatter = new hh(this.localeService, this.optionsFactory);
    }, t.prototype.getDefaultFilterOptions = function() {
      return t.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.createValueElement = function() {
      var e = vh(this.numberFilterParams), r = document.createElement("div");
      return r.classList.add("ag-filter-body"), Dt(r, "presentation"), this.createFromToElement(r, this.eValuesFrom, "from", e), this.createFromToElement(r, this.eValuesTo, "to", e), r;
    }, t.prototype.createFromToElement = function(e, r, o, n) {
      var s = this.createManagedBean(n ? new Cn({ allowedCharPattern: n }) : new xa());
      s.addCssClass("ag-filter-" + o), s.addCssClass("ag-filter-filter"), r.push(s), e.appendChild(s.getGui());
    }, t.prototype.removeValueElements = function(e, r) {
      this.removeComponents(this.eValuesFrom, e, r), this.removeComponents(this.eValuesTo, e, r);
    }, t.prototype.getValues = function(e) {
      var r = this, o = [];
      return this.forEachPositionInput(e, function(n, s, a, l) {
        s < l && o.push(r.processValue(r.stringToFloat(n.getValue())));
      }), o;
    }, t.prototype.areSimpleModelsEqual = function(e, r) {
      return e.filter === r.filter && e.filterTo === r.filterTo && e.type === r.type;
    }, t.prototype.getFilterType = function() {
      return "number";
    }, t.prototype.processValue = function(e) {
      return e == null || isNaN(e) ? null : e;
    }, t.prototype.stringToFloat = function(e) {
      if (typeof e == "number")
        return e;
      var r = Go(e);
      return r != null && r.trim() === "" && (r = null), this.numberFilterParams.numberParser ? this.numberFilterParams.numberParser(r) : r == null || r.trim() === "-" ? null : parseFloat(r);
    }, t.prototype.createCondition = function(e) {
      var r = this.getConditionType(e), o = {
        filterType: this.getFilterType(),
        type: r
      }, n = this.getValues(e);
      return n.length > 0 && (o.filter = n[0]), n.length > 1 && (o.filterTo = n[1]), o;
    }, t.prototype.getInputs = function(e) {
      return e >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[e], this.eValuesTo[e]];
    }, t.prototype.getModelAsString = function(e) {
      var r;
      return (r = this.filterModelFormatter.getModelAsString(e)) !== null && r !== void 0 ? r : "";
    }, t.DEFAULT_FILTER_OPTIONS = [
      St.EQUALS,
      St.NOT_EQUAL,
      St.LESS_THAN,
      St.LESS_THAN_OR_EQUAL,
      St.GREATER_THAN,
      St.GREATER_THAN_OR_EQUAL,
      St.IN_RANGE,
      St.BLANK,
      St.NOT_BLANK
    ], t;
  }(St)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var gh = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Zs = function() {
  return Zs = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, Zs.apply(this, arguments);
}, yh = (
  /** @class */
  function(i) {
    gh(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.conditionToString = function(e, r) {
      var o = (r || {}).numberOfInputs, n = e.type == Je.IN_RANGE || o === 2;
      return n ? e.filter + "-" + e.filterTo : e.filter != null ? "" + e.filter : "" + e.type;
    }, t;
  }(ic)
), Fa = (
  /** @class */
  function(i) {
    gh(t, i);
    function t() {
      var e = i.call(this, "textFilter") || this;
      return e.eValuesFrom = [], e.eValuesTo = [], e;
    }
    return t.trimInput = function(e) {
      var r = e && e.trim();
      return r === "" ? e : r;
    }, t.prototype.getDefaultDebounceMs = function() {
      return 500;
    }, t.prototype.setParams = function(e) {
      this.textFilterParams = e, i.prototype.setParams.call(this, e), this.matcher = this.getTextMatcher(), this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? t.DEFAULT_FORMATTER : t.DEFAULT_LOWERCASE_FORMATTER), this.filterModelFormatter = new yh(this.localeService, this.optionsFactory);
    }, t.prototype.getTextMatcher = function() {
      var e = this.textFilterParams.textCustomComparator;
      return e ? (le.doOnce(function() {
        return console.warn("AG Grid - textCustomComparator is deprecated, use textMatcher instead.");
      }, "textCustomComparator.deprecated"), function(r) {
        var o = r.filterOption, n = r.value, s = r.filterText;
        return e(o, n, s);
      }) : this.textFilterParams.textMatcher || t.DEFAULT_MATCHER;
    }, t.prototype.createCondition = function(e) {
      var r = this.getConditionType(e), o = {
        filterType: this.getFilterType(),
        type: r
      }, n = this.getValues(e);
      return n.length > 0 && (o.filter = n[0]), n.length > 1 && (o.filterTo = n[1]), o;
    }, t.prototype.getFilterType = function() {
      return "text";
    }, t.prototype.areSimpleModelsEqual = function(e, r) {
      return e.filter === r.filter && e.filterTo === r.filterTo && e.type === r.type;
    }, t.prototype.getInputs = function(e) {
      return e >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[e], this.eValuesTo[e]];
    }, t.prototype.getValues = function(e) {
      var r = this, o = [];
      return this.forEachPositionInput(e, function(n, s, a, l) {
        if (s < l) {
          var u = Go(n.getValue()), c = (r.textFilterParams.trimInput ? t.trimInput(u) : u) || null;
          o.push(c), n.setValue(c, !0);
        }
      }), o;
    }, t.prototype.getDefaultFilterOptions = function() {
      return t.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.createValueElement = function() {
      var e = document.createElement("div");
      return e.classList.add("ag-filter-body"), Dt(e, "presentation"), this.createFromToElement(e, this.eValuesFrom, "from"), this.createFromToElement(e, this.eValuesTo, "to"), e;
    }, t.prototype.createFromToElement = function(e, r, o) {
      var n = this.createManagedBean(new Cn());
      n.addCssClass("ag-filter-" + o), n.addCssClass("ag-filter-filter"), r.push(n), e.appendChild(n.getGui());
    }, t.prototype.removeValueElements = function(e, r) {
      this.removeComponents(this.eValuesFrom, e, r), this.removeComponents(this.eValuesTo, e, r);
    }, t.prototype.mapValuesFromModel = function(e) {
      var r = e || {}, o = r.filter, n = r.filterTo, s = r.type;
      return [
        o || null,
        n || null
      ].slice(0, this.getNumberOfInputs(s));
    }, t.prototype.evaluateNullValue = function(e) {
      var r = [
        Je.NOT_EQUAL,
        Je.NOT_CONTAINS,
        Je.BLANK
      ];
      return e ? r.indexOf(e) >= 0 : !1;
    }, t.prototype.evaluateNonNullValue = function(e, r, o, n) {
      var s = this, a = e.map(function(_) {
        return s.formatter(_);
      }) || [], l = this.formatter(r), u = this.textFilterParams, c = u.api, p = u.colDef, d = u.column, h = u.columnApi, g = u.context, y = u.textFormatter;
      if (o.type === Je.BLANK)
        return this.isBlank(r);
      if (o.type === Je.NOT_BLANK)
        return !this.isBlank(r);
      var S = {
        api: c,
        colDef: p,
        column: d,
        columnApi: h,
        context: g,
        node: n.node,
        data: n.data,
        filterOption: o.type,
        value: l,
        textFormatter: y
      };
      return a.some(function(_) {
        return s.matcher(Zs(Zs({}, S), { filterText: _ }));
      });
    }, t.prototype.getModelAsString = function(e) {
      var r;
      return (r = this.filterModelFormatter.getModelAsString(e)) !== null && r !== void 0 ? r : "";
    }, t.DEFAULT_FILTER_OPTIONS = [
      Je.CONTAINS,
      Je.NOT_CONTAINS,
      Je.EQUALS,
      Je.NOT_EQUAL,
      Je.STARTS_WITH,
      Je.ENDS_WITH,
      Je.BLANK,
      Je.NOT_BLANK
    ], t.DEFAULT_FORMATTER = function(e) {
      return e;
    }, t.DEFAULT_LOWERCASE_FORMATTER = function(e) {
      return e == null ? null : e.toString().toLowerCase();
    }, t.DEFAULT_MATCHER = function(e) {
      var r = e.filterOption, o = e.value, n = e.filterText;
      if (n == null)
        return !1;
      switch (r) {
        case t.CONTAINS:
          return o.indexOf(n) >= 0;
        case t.NOT_CONTAINS:
          return o.indexOf(n) < 0;
        case t.EQUALS:
          return o === n;
        case t.NOT_EQUAL:
          return o != n;
        case t.STARTS_WITH:
          return o.indexOf(n) === 0;
        case t.ENDS_WITH:
          var s = o.lastIndexOf(n);
          return s >= 0 && s === o.length - n.length;
        default:
          return !1;
      }
    }, t;
  }(Je)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var mh = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ch = (
  /** @class */
  function(i) {
    mh(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.params = e, r;
    }
    return t.prototype.setupGui = function(e) {
      this.eFloatingFilterTextInput = this.createManagedBean(new Cn(this.params.config)), this.eFloatingFilterTextInput.setInputAriaLabel(this.params.ariaLabel), e.appendChild(this.eFloatingFilterTextInput.getGui());
    }, t.prototype.setEditable = function(e) {
      this.eFloatingFilterTextInput.setDisabled(!e);
    }, t.prototype.getValue = function() {
      return this.eFloatingFilterTextInput.getValue();
    }, t.prototype.setValue = function(e, r) {
      this.eFloatingFilterTextInput.setValue(e, r);
    }, t.prototype.addValueChangedListener = function(e) {
      var r = this.eFloatingFilterTextInput.getGui();
      this.addManagedListener(r, "input", e), this.addManagedListener(r, "keypress", e), this.addManagedListener(r, "keydown", e);
    }, t;
  }(j)
), wh = (
  /** @class */
  function(i) {
    mh(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.setTemplate(
        /* html */
        `
            <div class="ag-floating-filter-input" role="presentation" ref="eFloatingFilterInputContainer"></div>
        `
      );
    }, t.prototype.getDefaultDebounceMs = function() {
      return 500;
    }, t.prototype.onParentModelChanged = function(e, r) {
      this.isEventFromFloatingFilter(r) || this.isEventFromDataChange(r) || (this.setLastTypeFromModel(e), this.setEditable(this.canWeEditAfterModelFromParentFilter(e)), this.floatingFilterInputService.setValue(this.getFilterModelFormatter().getModelAsString(e)));
    }, t.prototype.init = function(e) {
      this.params = e;
      var r = this.columnModel.getDisplayNameForColumn(e.column, "header", !0), o = this.localeService.getLocaleTextFunc(), n = r + " " + o("ariaFilterInput", "Filter Input");
      if (this.floatingFilterInputService = this.createFloatingFilterInputService(n), this.floatingFilterInputService.setupGui(this.eFloatingFilterInputContainer), i.prototype.init.call(this, e), this.applyActive = Mi.isUseApplyButton(this.params.filterParams), !this.isReadOnly()) {
        var s = Mi.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs()), a = ro(this.syncUpWithParentFilter.bind(this), s);
        this.floatingFilterInputService.addValueChangedListener(a);
      }
    }, t.prototype.syncUpWithParentFilter = function(e) {
      var r = this, o = e.key === L.ENTER;
      if (!(this.applyActive && !o)) {
        var n = this.floatingFilterInputService.getValue();
        this.params.filterParams.trimInput && (n = Fa.trimInput(n), this.floatingFilterInputService.setValue(n, !0)), this.params.parentFilterInstance(function(s) {
          s && s.onFloatingFilterChanged(r.getLastType() || null, n || null);
        });
      }
    }, t.prototype.setEditable = function(e) {
      this.floatingFilterInputService.setEditable(e);
    }, gl([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), gl([
      Y("eFloatingFilterInputContainer")
    ], t.prototype, "eFloatingFilterInputContainer", void 0), gl([
      U
    ], t.prototype, "postConstruct", null), t;
  }(dh)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Sh = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ew = (
  /** @class */
  function(i) {
    Sh(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.params = e, r.numberInputActive = !0, r;
    }
    return t.prototype.setupGui = function(e) {
      this.eFloatingFilterNumberInput = this.createManagedBean(new xa()), this.eFloatingFilterTextInput = this.createManagedBean(new Cn()), this.eFloatingFilterTextInput.setDisabled(!0), this.eFloatingFilterNumberInput.setInputAriaLabel(this.params.ariaLabel), this.eFloatingFilterTextInput.setInputAriaLabel(this.params.ariaLabel), e.appendChild(this.eFloatingFilterNumberInput.getGui()), e.appendChild(this.eFloatingFilterTextInput.getGui());
    }, t.prototype.setEditable = function(e) {
      this.numberInputActive = e, this.eFloatingFilterNumberInput.setDisplayed(this.numberInputActive), this.eFloatingFilterTextInput.setDisplayed(!this.numberInputActive);
    }, t.prototype.getValue = function() {
      return this.getActiveInputElement().getValue();
    }, t.prototype.setValue = function(e, r) {
      this.getActiveInputElement().setValue(e, r);
    }, t.prototype.getActiveInputElement = function() {
      return this.numberInputActive ? this.eFloatingFilterNumberInput : this.eFloatingFilterTextInput;
    }, t.prototype.addValueChangedListener = function(e) {
      this.setupListeners(this.eFloatingFilterNumberInput.getGui(), e), this.setupListeners(this.eFloatingFilterTextInput.getGui(), e);
    }, t.prototype.setupListeners = function(e, r) {
      this.addManagedListener(e, "input", r), this.addManagedListener(e, "keypress", r), this.addManagedListener(e, "keydown", r);
    }, t;
  }(j)
), Rw = (
  /** @class */
  function(i) {
    Sh(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function(e) {
      i.prototype.init.call(this, e), this.filterModelFormatter = new hh(this.localeService, this.optionsFactory);
    }, t.prototype.getDefaultFilterOptions = function() {
      return ac.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.getFilterModelFormatter = function() {
      return this.filterModelFormatter;
    }, t.prototype.createFloatingFilterInputService = function(e) {
      var r = vh(this.params.filterParams);
      return r ? this.createManagedBean(new Ch({
        config: { allowedCharPattern: r },
        ariaLabel: e
      })) : this.createManagedBean(new Ew({ ariaLabel: e }));
    }, t;
  }(wh)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ow = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), _h = (
  /** @class */
  function(i) {
    Ow(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function(e) {
      i.prototype.init.call(this, e), this.filterModelFormatter = new yh(this.localeService, this.optionsFactory);
    }, t.prototype.getDefaultFilterOptions = function() {
      return Fa.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.getFilterModelFormatter = function() {
      return this.filterModelFormatter;
    }, t.prototype.createFloatingFilterInputService = function(e) {
      return this.createManagedBean(new Ch({
        ariaLabel: e
      }));
    }, t;
  }(wh)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var sr = (
  /** @class */
  function() {
    function i(t, e) {
      var r = this;
      e === void 0 && (e = !1), this.destroyFuncs = [], this.touching = !1, this.eventService = new mo(), this.eElement = t, this.preventMouseClick = e;
      var o = this.onTouchStart.bind(this), n = this.onTouchMove.bind(this), s = this.onTouchEnd.bind(this);
      this.eElement.addEventListener("touchstart", o, { passive: !0 }), this.eElement.addEventListener("touchmove", n, { passive: !0 }), this.eElement.addEventListener("touchend", s, { passive: !1 }), this.destroyFuncs.push(function() {
        r.eElement.removeEventListener("touchstart", o, { passive: !0 }), r.eElement.removeEventListener("touchmove", n, { passive: !0 }), r.eElement.removeEventListener("touchend", s, { passive: !1 });
      });
    }
    return i.prototype.getActiveTouch = function(t) {
      for (var e = 0; e < t.length; e++) {
        var r = t[e].identifier === this.touchStart.identifier;
        if (r)
          return t[e];
      }
      return null;
    }, i.prototype.addEventListener = function(t, e) {
      this.eventService.addEventListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      this.eventService.removeEventListener(t, e);
    }, i.prototype.onTouchStart = function(t) {
      var e = this;
      if (!this.touching) {
        this.touchStart = t.touches[0], this.touching = !0, this.moved = !1;
        var r = this.touchStart;
        window.setTimeout(function() {
          var o = e.touchStart === r;
          if (e.touching && o && !e.moved) {
            e.moved = !0;
            var n = {
              type: i.EVENT_LONG_TAP,
              touchStart: e.touchStart,
              touchEvent: t
            };
            e.eventService.dispatchEvent(n);
          }
        }, 500);
      }
    }, i.prototype.onTouchMove = function(t) {
      if (this.touching) {
        var e = this.getActiveTouch(t.touches);
        if (e) {
          var r = !ec(e, this.touchStart, 4);
          r && (this.moved = !0);
        }
      }
    }, i.prototype.onTouchEnd = function(t) {
      if (this.touching) {
        if (!this.moved) {
          var e = {
            type: i.EVENT_TAP,
            touchStart: this.touchStart
          };
          this.eventService.dispatchEvent(e), this.checkForDoubleTap();
        }
        this.preventMouseClick && t.cancelable && t.preventDefault(), this.touching = !1;
      }
    }, i.prototype.checkForDoubleTap = function() {
      var t = (/* @__PURE__ */ new Date()).getTime();
      if (this.lastTapTime && this.lastTapTime > 0) {
        var e = t - this.lastTapTime;
        if (e > i.DOUBLE_TAP_MILLIS) {
          var r = {
            type: i.EVENT_DOUBLE_TAP,
            touchStart: this.touchStart
          };
          this.eventService.dispatchEvent(r), this.lastTapTime = null;
        } else
          this.lastTapTime = t;
      } else
        this.lastTapTime = t;
    }, i.prototype.destroy = function() {
      this.destroyFuncs.forEach(function(t) {
        return t();
      });
    }, i.EVENT_TAP = "tap", i.EVENT_DOUBLE_TAP = "doubleTap", i.EVENT_LONG_TAP = "longTap", i.DOUBLE_TAP_MILLIS = 500, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var bw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yo = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ma = (
  /** @class */
  function(i) {
    bw(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return e || r.setTemplate(t.TEMPLATE), r;
    }
    return t.prototype.attachCustomElements = function(e, r, o, n, s) {
      this.eSortOrder = e, this.eSortAsc = r, this.eSortDesc = o, this.eSortMixed = n, this.eSortNone = s;
    }, t.prototype.setupSort = function(e, r) {
      var o = this;
      r === void 0 && (r = !1), this.column = e, this.suppressOrder = r, this.setupMultiSortIndicator();
      var n = !!this.column.getColDef().sortable;
      n && (this.addInIcon("sortAscending", this.eSortAsc, e), this.addInIcon("sortDescending", this.eSortDesc, e), this.addInIcon("sortUnSort", this.eSortNone, e), this.addManagedListener(this.eventService, m.EVENT_SORT_CHANGED, function() {
        return o.onSortChanged();
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, function() {
        return o.onSortChanged();
      }), this.onSortChanged());
    }, t.prototype.addInIcon = function(e, r, o) {
      if (r != null) {
        var n = ut(e, this.gridOptionsService, o);
        n && r.appendChild(n);
      }
    }, t.prototype.onSortChanged = function() {
      this.updateIcons(), this.suppressOrder || this.updateSortOrder();
    }, t.prototype.updateIcons = function() {
      var e = this.sortController.getDisplaySortForColumn(this.column);
      if (this.eSortAsc) {
        var r = e === "asc";
        be(this.eSortAsc, r, { skipAriaHidden: !0 });
      }
      if (this.eSortDesc) {
        var o = e === "desc";
        be(this.eSortDesc, o, { skipAriaHidden: !0 });
      }
      if (this.eSortNone) {
        var n = !this.column.getColDef().unSortIcon && !this.gridOptionsService.is("unSortIcon"), s = e == null;
        be(this.eSortNone, !n && s, { skipAriaHidden: !0 });
      }
    }, t.prototype.setupMultiSortIndicator = function() {
      var e = this;
      this.addInIcon("sortUnSort", this.eSortMixed, this.column);
      var r = this.column.getColDef().showRowGroup, o = this.gridOptionsService.isColumnsSortingCoupledToGroup();
      o && r && (this.addManagedListener(this.eventService, m.EVENT_SORT_CHANGED, function() {
        return e.updateMultiSortIndicator();
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, function() {
        return e.updateMultiSortIndicator();
      }), this.updateMultiSortIndicator());
    }, t.prototype.updateMultiSortIndicator = function() {
      if (this.eSortMixed) {
        var e = this.sortController.getDisplaySortForColumn(this.column) === "mixed";
        be(this.eSortMixed, e, { skipAriaHidden: !0 });
      }
    }, t.prototype.updateSortOrder = function() {
      var e = this, r;
      if (this.eSortOrder) {
        var o = this.sortController.getColumnsWithSortingOrdered(), n = (r = this.sortController.getDisplaySortIndexForColumn(this.column)) !== null && r !== void 0 ? r : -1, s = o.some(function(l) {
          var u;
          return (u = e.sortController.getDisplaySortIndexForColumn(l)) !== null && u !== void 0 ? u : -1 >= 1;
        }), a = n >= 0 && s;
        be(this.eSortOrder, a, { skipAriaHidden: !0 }), n >= 0 ? this.eSortOrder.innerHTML = (n + 1).toString() : pr(this.eSortOrder);
      }
    }, t.TEMPLATE = `<span class="ag-sort-indicator-container">
            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
        </span>`, Yo([
      Y("eSortOrder")
    ], t.prototype, "eSortOrder", void 0), Yo([
      Y("eSortAsc")
    ], t.prototype, "eSortAsc", void 0), Yo([
      Y("eSortDesc")
    ], t.prototype, "eSortDesc", void 0), Yo([
      Y("eSortMixed")
    ], t.prototype, "eSortMixed", void 0), Yo([
      Y("eSortNone")
    ], t.prototype, "eSortNone", void 0), Yo([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Yo([
      v("sortController")
    ], t.prototype, "sortController", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Tw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), lr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Pw = (
  /** @class */
  function(i) {
    Tw(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.lastMovingChanged = 0, e;
    }
    return t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.prototype.refresh = function(e) {
      return this.params = e, this.workOutTemplate() != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || this.workOutSort() != this.currentSort ? !1 : (this.setDisplayName(e), !0);
    }, t.prototype.workOutTemplate = function() {
      var e = lf(this.params.template, t.TEMPLATE);
      return e = e && e.trim ? e.trim() : e, e;
    }, t.prototype.init = function(e) {
      this.params = e, this.currentTemplate = this.workOutTemplate(), this.setTemplate(this.currentTemplate), this.setupTap(), this.setupIcons(e.column), this.setMenu(), this.setupSort(), this.setupFilterIcon(), this.setDisplayName(e);
    }, t.prototype.setDisplayName = function(e) {
      if (this.currentDisplayName != e.displayName) {
        this.currentDisplayName = e.displayName;
        var r = so(this.currentDisplayName);
        this.eText && (this.eText.innerHTML = r);
      }
    }, t.prototype.setupIcons = function(e) {
      this.addInIcon("menu", this.eMenu, e), this.addInIcon("filter", this.eFilter, e);
    }, t.prototype.addInIcon = function(e, r, o) {
      if (r != null) {
        var n = ut(e, this.gridOptionsService, o);
        n && r.appendChild(n);
      }
    }, t.prototype.setupTap = function() {
      var e = this, r = this.gridOptionsService;
      if (!r.is("suppressTouch")) {
        var o = new sr(this.getGui(), !0), n = r.is("suppressMenuHide"), s = n && k(this.eMenu), a = s ? new sr(this.eMenu, !0) : o;
        if (this.params.enableMenu) {
          var l = s ? "EVENT_TAP" : "EVENT_LONG_TAP", u = function(p) {
            r.api.showColumnMenuAfterMouseClick(e.params.column, p.touchStart);
          };
          this.addManagedListener(a, sr[l], u);
        }
        if (this.params.enableSorting) {
          var c = function(p) {
            var d = p.touchStart.target;
            n && e.eMenu.contains(d) || e.sortController.progressSort(e.params.column, !1, "uiColumnSorted");
          };
          this.addManagedListener(o, sr.EVENT_TAP, c);
        }
        this.addDestroyFunc(function() {
          return o.destroy();
        }), s && this.addDestroyFunc(function() {
          return a.destroy();
        });
      }
    }, t.prototype.workOutShowMenu = function() {
      var e = !this.gridOptionsService.is("suppressMenuHide"), r = jo() && e, o = this.params.enableMenu && !r;
      return o;
    }, t.prototype.setMenu = function() {
      var e = this;
      if (this.eMenu) {
        if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu) {
          go(this.eMenu);
          return;
        }
        var r = this.gridOptionsService.is("suppressMenuHide");
        this.addManagedListener(this.eMenu, "click", function() {
          return e.showMenu(e.eMenu);
        }), this.eMenu.classList.toggle("ag-header-menu-always-show", r);
      }
    }, t.prototype.showMenu = function(e) {
      e || (e = this.eMenu), this.menuFactory.showMenuAfterButtonClick(this.params.column, e, "columnMenu");
    }, t.prototype.workOutSort = function() {
      return this.params.enableSorting;
    }, t.prototype.setupSort = function() {
      var e = this;
      if (this.currentSort = this.params.enableSorting, this.eSortIndicator || (this.eSortIndicator = this.context.createBean(new Ma(!0)), this.eSortIndicator.attachCustomElements(this.eSortOrder, this.eSortAsc, this.eSortDesc, this.eSortMixed, this.eSortNone)), this.eSortIndicator.setupSort(this.params.column), !!this.currentSort) {
        var r = this.gridOptionsService.get("multiSortKey") === "ctrl";
        this.addManagedListener(this.params.column, $e.EVENT_MOVING_CHANGED, function() {
          e.lastMovingChanged = (/* @__PURE__ */ new Date()).getTime();
        }), this.eLabel && this.addManagedListener(this.eLabel, "click", function(n) {
          var s = e.params.column.isMoving(), a = (/* @__PURE__ */ new Date()).getTime(), l = a - e.lastMovingChanged < 50, u = s || l;
          if (!u) {
            var c = r ? n.ctrlKey || n.metaKey : n.shiftKey;
            e.params.progressSort(c);
          }
        });
        var o = function() {
          if (e.addOrRemoveCssClass("ag-header-cell-sorted-asc", e.params.column.isSortAscending()), e.addOrRemoveCssClass("ag-header-cell-sorted-desc", e.params.column.isSortDescending()), e.addOrRemoveCssClass("ag-header-cell-sorted-none", e.params.column.isSortNone()), e.params.column.getColDef().showRowGroup) {
            var n = e.columnModel.getSourceColumnsForGroupColumn(e.params.column), s = n == null ? void 0 : n.every(function(l) {
              return e.params.column.getSort() == l.getSort();
            }), a = !s;
            e.addOrRemoveCssClass("ag-header-cell-sorted-mixed", a);
          }
        };
        this.addManagedListener(this.eventService, m.EVENT_SORT_CHANGED, o), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, o);
      }
    }, t.prototype.setupFilterIcon = function() {
      this.eFilter && (this.addManagedListener(this.params.column, $e.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.onFilterChanged());
    }, t.prototype.onFilterChanged = function() {
      var e = this.params.column.isFilterActive();
      be(this.eFilter, e, { skipAriaHidden: !0 });
    }, t.TEMPLATE = `<div class="ag-cell-label-container" role="presentation">
            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
            <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span ref="eText" class="ag-header-cell-text"></span>
                <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                <ag-sort-indicator ref="eSortIndicator"></ag-sort-indicator>
            </div>
        </div>`, lr([
      v("sortController")
    ], t.prototype, "sortController", void 0), lr([
      v("menuFactory")
    ], t.prototype, "menuFactory", void 0), lr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), lr([
      Y("eFilter")
    ], t.prototype, "eFilter", void 0), lr([
      Y("eSortIndicator")
    ], t.prototype, "eSortIndicator", void 0), lr([
      Y("eMenu")
    ], t.prototype, "eMenu", void 0), lr([
      Y("eLabel")
    ], t.prototype, "eLabel", void 0), lr([
      Y("eText")
    ], t.prototype, "eText", void 0), lr([
      Y("eSortOrder")
    ], t.prototype, "eSortOrder", void 0), lr([
      Y("eSortAsc")
    ], t.prototype, "eSortAsc", void 0), lr([
      Y("eSortDesc")
    ], t.prototype, "eSortDesc", void 0), lr([
      Y("eSortMixed")
    ], t.prototype, "eSortMixed", void 0), lr([
      Y("eSortNone")
    ], t.prototype, "eSortNone", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Dw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), yl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Aw = (
  /** @class */
  function(i) {
    Dw(t, i);
    function t() {
      return i.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      this.params = e, this.checkWarnings(), this.setupLabel(), this.addGroupExpandIcon(), this.setupExpandIcons();
    }, t.prototype.checkWarnings = function() {
      var e = this.params;
      if (e.template) {
        var r = "AG Grid: A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)";
        Pe(function() {
          return console.warn(r);
        }, "HeaderGroupComp.templateNotSupported");
      }
    }, t.prototype.setupExpandIcons = function() {
      var e = this;
      this.addInIcon("columnGroupOpened", "agOpened"), this.addInIcon("columnGroupClosed", "agClosed");
      var r = function(s) {
        if (!oo(s)) {
          var a = !e.params.columnGroup.isExpanded();
          e.columnModel.setColumnGroupOpened(e.params.columnGroup.getProvidedColumnGroup(), a, "uiColumnExpanded");
        }
      };
      this.addTouchAndClickListeners(this.eCloseIcon, r), this.addTouchAndClickListeners(this.eOpenIcon, r);
      var o = function(s) {
        Un(s);
      };
      this.addManagedListener(this.eCloseIcon, "dblclick", o), this.addManagedListener(this.eOpenIcon, "dblclick", o), this.addManagedListener(this.getGui(), "dblclick", r), this.updateIconVisibility();
      var n = this.params.columnGroup.getProvidedColumnGroup();
      this.addManagedListener(n, et.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this)), this.addManagedListener(n, et.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
    }, t.prototype.addTouchAndClickListeners = function(e, r) {
      var o = new sr(e, !0);
      this.addManagedListener(o, sr.EVENT_TAP, r), this.addDestroyFunc(function() {
        return o.destroy();
      }), this.addManagedListener(e, "click", r);
    }, t.prototype.updateIconVisibility = function() {
      var e = this.params.columnGroup;
      if (e.isExpandable()) {
        var r = this.params.columnGroup.isExpanded();
        be(this.eOpenIcon, r), be(this.eCloseIcon, !r);
      } else
        be(this.eOpenIcon, !1), be(this.eCloseIcon, !1);
    }, t.prototype.addInIcon = function(e, r) {
      var o = ut(e, this.gridOptionsService, null);
      o && this.getRefElement(r).appendChild(o);
    }, t.prototype.addGroupExpandIcon = function() {
      if (!this.params.columnGroup.isExpandable()) {
        be(this.eOpenIcon, !1), be(this.eCloseIcon, !1);
        return;
      }
    }, t.prototype.setupLabel = function() {
      var e, r = this.params, o = r.displayName, n = r.columnGroup;
      if (k(o)) {
        var s = so(o);
        this.getRefElement("agLabel").innerHTML = s;
      }
      this.addOrRemoveCssClass("ag-sticky-label", !!(!((e = n.getColGroupDef()) === null || e === void 0) && e.stickyLabel));
    }, t.TEMPLATE = `<div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
            <span ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`, yl([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), yl([
      Y("agOpened")
    ], t.prototype, "eOpenIcon", void 0), yl([
      Y("agClosed")
    ], t.prototype, "eCloseIcon", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var xw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Xn = (
  /** @class */
  function(i) {
    xw(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.isPopup = function() {
      return !0;
    }, t.prototype.setParentComponent = function(e) {
      e.addCssClass("ag-has-popup"), i.prototype.setParentComponent.call(this, e);
    }, t.prototype.destroy = function() {
      var e = this.parentComponent, r = e && e.isAlive();
      r && e.getGui().classList.remove("ag-has-popup"), i.prototype.destroy.call(this);
    }, t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Fw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Mw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Eh = (
  /** @class */
  function(i) {
    Fw(t, i);
    function t() {
      return i.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      this.params = e, this.focusAfterAttached = e.cellStartedEdit, this.eTextArea.setMaxLength(e.maxLength || 200).setCols(e.cols || 60).setRows(e.rows || 10), k(e.value, !0) && this.eTextArea.setValue(e.value.toString(), !0), this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
    }, t.prototype.onKeyDown = function(e) {
      var r = e.key;
      (r === L.LEFT || r === L.UP || r === L.RIGHT || r === L.DOWN || e.shiftKey && r === L.ENTER) && e.stopPropagation();
    }, t.prototype.afterGuiAttached = function() {
      var e = this.localeService.getLocaleTextFunc();
      this.eTextArea.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), this.focusAfterAttached && this.eTextArea.getFocusableElement().focus();
    }, t.prototype.getValue = function() {
      return this.params.parseValue(this.eTextArea.getValue());
    }, t.TEMPLATE = `<div class="ag-large-text" tabindex="0">
            <ag-input-text-area ref="eTextArea" class="ag-large-text-input"></ag-input-text-area>
        </div>`, Mw([
      Y("eTextArea")
    ], t.prototype, "eTextArea", void 0), t;
  }(Xn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Iw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Rh = (
  /** @class */
  function(i) {
    Iw(t, i);
    function t() {
      var e = i.call(this, '<div class="ag-cell-edit-wrapper"><ag-select class="ag-cell-editor" ref="eSelect"></ag-select></div>') || this;
      return e.startedByEnter = !1, e;
    }
    return t.prototype.init = function(e) {
      var r = this;
      if (this.focusAfterAttached = e.cellStartedEdit, ue(e.values)) {
        console.warn("AG Grid: no values found for select cellEditor");
        return;
      }
      this.startedByEnter = e.eventKey != null ? e.eventKey === L.ENTER : !1;
      var o = !1;
      e.values.forEach(function(n) {
        var s = { value: n }, a = r.valueFormatterService.formatValue(e.column, null, n), l = a != null;
        s.text = l ? a : n, r.eSelect.addOption(s), o = o || e.value === n;
      }), o ? this.eSelect.setValue(e.value, !0) : e.values.length && this.eSelect.setValue(e.values[0], !0), this.gridOptionsService.get("editType") !== "fullRow" && this.addManagedListener(this.eSelect, Ii.EVENT_ITEM_SELECTED, function() {
        return e.stopEditing();
      });
    }, t.prototype.afterGuiAttached = function() {
      this.focusAfterAttached && this.eSelect.getFocusableElement().focus(), this.startedByEnter && this.eSelect.showPicker();
    }, t.prototype.focusIn = function() {
      this.eSelect.getFocusableElement().focus();
    }, t.prototype.getValue = function() {
      return this.eSelect.getValue();
    }, t.prototype.isPopup = function() {
      return !1;
    }, jp([
      v("valueFormatterService")
    ], t.prototype, "valueFormatterService", void 0), jp([
      Y("eSelect")
    ], t.prototype, "eSelect", void 0), t;
  }(Xn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Lw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Nw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, fu = (
  /** @class */
  function(i) {
    Lw(t, i);
    function t() {
      return i.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      this.params = e;
      var r = this.eInput, o;
      e.cellStartedEdit ? (this.focusAfterAttached = !0, e.eventKey === L.BACKSPACE || e.eventKey === L.DELETE ? o = "" : e.charPress ? o = e.charPress : (o = this.getStartValue(e), e.eventKey !== L.F2 && (this.highlightAllOnFocus = !0))) : (this.focusAfterAttached = !1, o = this.getStartValue(e)), o != null && r.setValue(o, !0), e.maxLength != null && r.setMaxLength(e.maxLength), this.addManagedListener(r.getGui(), "keydown", function(n) {
        var s = n.key;
        (s === L.PAGE_UP || s === L.PAGE_DOWN) && n.preventDefault();
      });
    }, t.prototype.afterGuiAttached = function() {
      var e = this.localeService.getLocaleTextFunc(), r = this.eInput;
      if (r.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), !!this.focusAfterAttached) {
        ao() || r.getFocusableElement().focus();
        var o = r.getInputElement();
        if (this.highlightAllOnFocus)
          o.select();
        else {
          var n = r.getValue(), s = k(n) && n.length || 0;
          s && o.setSelectionRange(s, s);
        }
      }
    }, t.prototype.focusIn = function() {
      var e = this.eInput, r = e.getFocusableElement(), o = e.getInputElement();
      r.focus(), o.select();
    }, t.prototype.getValue = function() {
      var e = this.eInput;
      return this.params.parseValue(e.getValue());
    }, t.prototype.getStartValue = function(e) {
      var r = e.useFormatter || e.column.getColDef().refData;
      return r ? e.formatValue(e.value) : e.value;
    }, t.prototype.isPopup = function() {
      return !1;
    }, t.TEMPLATE = `<div class="ag-cell-edit-wrapper">
            <ag-input-text-field class="ag-cell-editor" ref="eInput"></ag-input-text-field>
        </div>`, Nw([
      Y("eInput")
    ], t.prototype, "eInput", void 0), t;
  }(Xn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Gw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Hw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Vw = "↑", Bw = "↓", Oh = (
  /** @class */
  function(i) {
    Gw(t, i);
    function t() {
      var e = i.call(this, t.TEMPLATE) || this;
      return e.refreshCount = 0, e;
    }
    return t.prototype.init = function(e) {
      this.eValue = this.queryForHtmlElement(".ag-value-change-value"), this.eDelta = this.queryForHtmlElement(".ag-value-change-delta"), this.refresh(e);
    }, t.prototype.showDelta = function(e, r) {
      var o = Math.abs(r), n = e.formatValue(o), s = k(n) ? n : o, a = r >= 0;
      a ? this.eDelta.innerHTML = Vw + s : this.eDelta.innerHTML = Bw + s, this.eDelta.classList.toggle("ag-value-change-delta-up", a), this.eDelta.classList.toggle("ag-value-change-delta-down", !a);
    }, t.prototype.setTimerToRemoveDelta = function() {
      var e = this;
      this.refreshCount++;
      var r = this.refreshCount;
      window.setTimeout(function() {
        r === e.refreshCount && e.hideDeltaValue();
      }, 2e3);
    }, t.prototype.hideDeltaValue = function() {
      this.eValue.classList.remove("ag-value-change-value-highlight"), pr(this.eDelta);
    }, t.prototype.refresh = function(e) {
      var r = e.value;
      if (r === this.lastValue || (k(e.valueFormatted) ? this.eValue.innerHTML = e.valueFormatted : k(e.value) ? this.eValue.innerHTML = r : pr(this.eValue), this.filterManager.isSuppressFlashingCellsBecauseFiltering()))
        return !1;
      if (typeof r == "number" && typeof this.lastValue == "number") {
        var o = r - this.lastValue;
        this.showDelta(e, o);
      }
      return this.lastValue && this.eValue.classList.add("ag-value-change-value-highlight"), this.setTimerToRemoveDelta(), this.lastValue = r, !0;
    }, t.TEMPLATE = '<span><span class="ag-value-change-delta"></span><span class="ag-value-change-value"></span></span>', Hw([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var kw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jw = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, bh = (
  /** @class */
  function(i) {
    kw(t, i);
    function t() {
      var e = i.call(this, t.TEMPLATE) || this;
      return e.refreshCount = 0, e.eCurrent = e.queryForHtmlElement(".ag-value-slide-current"), e;
    }
    return t.prototype.init = function(e) {
      this.refresh(e);
    }, t.prototype.addSlideAnimation = function() {
      var e = this;
      this.refreshCount++;
      var r = this.refreshCount;
      this.ePrevious && this.getGui().removeChild(this.ePrevious), this.ePrevious = Lt('<span class="ag-value-slide-previous ag-value-slide-out"></span>'), this.ePrevious.innerHTML = this.eCurrent.innerHTML, this.getGui().insertBefore(this.ePrevious, this.eCurrent), window.setTimeout(function() {
        r === e.refreshCount && e.ePrevious.classList.add("ag-value-slide-out-end");
      }, 50), window.setTimeout(function() {
        r === e.refreshCount && (e.getGui().removeChild(e.ePrevious), e.ePrevious = null);
      }, 3e3);
    }, t.prototype.refresh = function(e) {
      var r = e.value;
      return ue(r) && (r = ""), r === this.lastValue || this.filterManager.isSuppressFlashingCellsBecauseFiltering() ? !1 : (this.addSlideAnimation(), this.lastValue = r, k(e.valueFormatted) ? this.eCurrent.innerHTML = e.valueFormatted : k(e.value) ? this.eCurrent.innerHTML = r : pr(this.eCurrent), !0);
    }, t.TEMPLATE = `<span>
            <span class="ag-value-slide-current"></span>
        </span>`, jw([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Vn = function() {
  return Vn = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, Vn.apply(this, arguments);
}, ye = (
  /** @class */
  function() {
    function i(t) {
      this.rowIndex = null, this.key = null, this.childrenMapped = {}, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = i.OBJECT_ID_SEQUENCE++, this.__autoHeights = {}, this.alreadyRendered = !1, this.highlighted = null, this.hovered = !1, this.selected = !1, this.beans = t;
    }
    return i.prototype.setData = function(t) {
      this.setDataCommon(t, !1);
    }, i.prototype.updateData = function(t) {
      this.setDataCommon(t, !0);
    }, i.prototype.setDataCommon = function(t, e) {
      var r = this.data;
      this.data = t, this.beans.valueCache.onDataChanged(), this.updateDataOnDetailNode(), this.checkRowSelectable(), this.resetQuickFilterAggregateText();
      var o = this.createDataChangedEvent(t, r, e);
      this.dispatchLocalEvent(o);
    }, i.prototype.updateDataOnDetailNode = function() {
      this.detailNode && (this.detailNode.data = this.data);
    }, i.prototype.createDataChangedEvent = function(t, e, r) {
      return {
        type: i.EVENT_DATA_CHANGED,
        node: this,
        oldData: e,
        newData: t,
        update: r
      };
    }, i.prototype.createLocalRowEvent = function(t) {
      return {
        type: t,
        node: this
      };
    }, i.prototype.getRowIndexString = function() {
      return this.rowPinned === "top" ? "t-" + this.rowIndex : this.rowPinned === "bottom" ? "b-" + this.rowIndex : this.rowIndex.toString();
    }, i.prototype.createDaemonNode = function() {
      var t = new i(this.beans);
      return t.id = this.id, t.data = this.data, t.__daemon = !0, t.selected = this.selected, t.level = this.level, t;
    }, i.prototype.setDataAndId = function(t, e) {
      var r = k(this.id) ? this.createDaemonNode() : null, o = this.data;
      this.data = t, this.updateDataOnDetailNode(), this.setId(e), this.beans.selectionService.syncInRowNode(this, r), this.checkRowSelectable();
      var n = this.createDataChangedEvent(t, o, !1);
      this.dispatchLocalEvent(n);
    }, i.prototype.checkRowSelectable = function() {
      var t = this.beans.gridOptionsService.get("isRowSelectable");
      this.setRowSelectable(t ? t(this) : !0);
    }, i.prototype.setRowSelectable = function(t) {
      if (this.selectable !== t) {
        this.selectable = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_SELECTABLE_CHANGED));
        var e = this.beans.gridOptionsService.is("groupSelectsChildren");
        if (e) {
          var r = this.calculateSelectedFromChildren();
          this.setSelectedParams({ newValue: r ?? !1, source: "selectableChanged" });
        }
      }
    }, i.prototype.setId = function(t) {
      var e = this.beans.gridOptionsService.getRowIdFunc();
      if (e)
        if (this.data) {
          var r = this.getGroupKeys(!0);
          this.id = e({
            data: this.data,
            parentKeys: r.length > 0 ? r : void 0,
            level: this.level
          }), this.id !== null && typeof this.id == "string" && this.id.startsWith(i.ID_PREFIX_ROW_GROUP) && console.error("AG Grid: Row IDs cannot start with " + i.ID_PREFIX_ROW_GROUP + ", this is a reserved prefix for AG Grid's row grouping feature."), this.id !== null && typeof this.id != "string" && (this.id = "" + this.id);
        } else
          this.id = void 0;
      else
        this.id = t;
    }, i.prototype.getGroupKeys = function(t) {
      t === void 0 && (t = !1);
      var e = [], r = this;
      for (t && (r = r.parent); r && r.level >= 0; )
        e.push(r.key), r = r.parent;
      return e.reverse(), e;
    }, i.prototype.isPixelInRange = function(t) {
      return !k(this.rowTop) || !k(this.rowHeight) ? !1 : t >= this.rowTop && t < this.rowTop + this.rowHeight;
    }, i.prototype.setFirstChild = function(t) {
      this.firstChild !== t && (this.firstChild = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_FIRST_CHILD_CHANGED)));
    }, i.prototype.setLastChild = function(t) {
      this.lastChild !== t && (this.lastChild = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_LAST_CHILD_CHANGED)));
    }, i.prototype.setChildIndex = function(t) {
      this.childIndex !== t && (this.childIndex = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_CHILD_INDEX_CHANGED)));
    }, i.prototype.setRowTop = function(t) {
      this.oldRowTop = this.rowTop, this.rowTop !== t && (this.rowTop = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_TOP_CHANGED)), this.setDisplayed(t !== null));
    }, i.prototype.clearRowTopAndRowIndex = function() {
      this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
    }, i.prototype.setDisplayed = function(t) {
      this.displayed !== t && (this.displayed = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_DISPLAYED_CHANGED)));
    }, i.prototype.setDragging = function(t) {
      this.dragging !== t && (this.dragging = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_DRAGGING_CHANGED)));
    }, i.prototype.setHighlighted = function(t) {
      t !== this.highlighted && (this.highlighted = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_HIGHLIGHT_CHANGED)));
    }, i.prototype.setHovered = function(t) {
      this.hovered !== t && (this.hovered = t);
    }, i.prototype.isHovered = function() {
      return this.hovered;
    }, i.prototype.setAllChildrenCount = function(t) {
      this.allChildrenCount !== t && (this.allChildrenCount = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_ALL_CHILDREN_COUNT_CHANGED)));
    }, i.prototype.setMaster = function(t) {
      this.master !== t && (this.master && !t && (this.expanded = !1), this.master = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_MASTER_CHANGED)));
    }, i.prototype.setGroup = function(t) {
      this.group !== t && (this.group && !t && (this.expanded = !1), this.group = t, this.updateHasChildren(), this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_GROUP_CHANGED)));
    }, i.prototype.setRowHeight = function(t, e) {
      e === void 0 && (e = !1), this.rowHeight = t, this.rowHeightEstimated = e, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_HEIGHT_CHANGED));
    }, i.prototype.setRowAutoHeight = function(t, e) {
      this.__autoHeights || (this.__autoHeights = {}), this.__autoHeights[e.getId()] = t, t != null && (this.checkAutoHeightsDebounced == null && (this.checkAutoHeightsDebounced = ro(this.checkAutoHeights.bind(this), 1)), this.checkAutoHeightsDebounced());
    }, i.prototype.checkAutoHeights = function() {
      var t = this, e = !1, r = !0, o = 0, n = this.__autoHeights;
      if (n != null) {
        var s = this.beans.columnModel.getAllDisplayedAutoHeightCols();
        if (s.forEach(function(l) {
          var u = n[l.getId()];
          if (u == null)
            if (t.beans.columnModel.isColSpanActive()) {
              var c = [];
              switch (l.getPinned()) {
                case "left":
                  c = t.beans.columnModel.getDisplayedLeftColumnsForRow(t);
                  break;
                case "right":
                  c = t.beans.columnModel.getDisplayedRightColumnsForRow(t);
                  break;
                case null:
                  c = t.beans.columnModel.getViewportCenterColumnsForRow(t);
                  break;
              }
              if (c.includes(l)) {
                e = !0;
                return;
              }
              u = -1;
            } else {
              e = !0;
              return;
            }
          else
            r = !1;
          u > o && (o = u);
        }), !e && ((r || o < 10) && (o = this.beans.gridOptionsService.getRowHeightForNode(this).height), o != this.rowHeight)) {
          this.setRowHeight(o);
          var a = this.beans.rowModel;
          a.onRowHeightChangedDebounced && a.onRowHeightChangedDebounced();
        }
      }
    }, i.prototype.setRowIndex = function(t) {
      this.rowIndex !== t && (this.rowIndex = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_ROW_INDEX_CHANGED)));
    }, i.prototype.setUiLevel = function(t) {
      this.uiLevel !== t && (this.uiLevel = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_UI_LEVEL_CHANGED)));
    }, i.prototype.setExpanded = function(t, e) {
      if (this.expanded !== t) {
        this.expanded = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_EXPANDED_CHANGED));
        var r = Object.assign({}, this.createGlobalRowEvent(m.EVENT_ROW_GROUP_OPENED), {
          expanded: t,
          event: e || null
        });
        this.beans.rowNodeEventThrottle.dispatchExpanded(r), this.beans.gridOptionsService.is("groupIncludeFooter") && this.beans.rowRenderer.refreshCells({ rowNodes: [this] });
      }
    }, i.prototype.createGlobalRowEvent = function(t) {
      return {
        type: t,
        node: this,
        data: this.data,
        rowIndex: this.rowIndex,
        rowPinned: this.rowPinned,
        context: this.beans.gridOptionsService.context,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi
      };
    }, i.prototype.dispatchLocalEvent = function(t) {
      this.eventService && this.eventService.dispatchEvent(t);
    }, i.prototype.setDataValue = function(t, e, r) {
      var o = this, n = function() {
        var u;
        return typeof t != "string" ? t : (u = o.beans.columnModel.getGridColumn(t)) !== null && u !== void 0 ? u : o.beans.columnModel.getPrimaryColumn(t);
      }, s = n(), a = this.getValueFromValueService(s);
      if (this.beans.gridOptionsService.is("readOnlyEdit"))
        return this.dispatchEventForSaveValueReadOnly(s, a, e, r), !1;
      var l = this.beans.valueService.setValue(this, s, e, r);
      return this.dispatchCellChangedEvent(s, e, a), this.checkRowSelectable(), l;
    }, i.prototype.getValueFromValueService = function(t) {
      var e = this.leafGroup && this.beans.columnModel.isPivotMode(), r = this.group && this.expanded && !this.footer && !e, o = this.beans.gridOptionsService.is("groupIncludeFooter"), n = this.beans.gridOptionsService.is("groupSuppressBlankHeader"), s = r && o && !n, a = this.beans.valueService.getValue(t, this, !1, s);
      return a;
    }, i.prototype.dispatchEventForSaveValueReadOnly = function(t, e, r, o) {
      var n = {
        type: m.EVENT_CELL_EDIT_REQUEST,
        event: null,
        rowIndex: this.rowIndex,
        rowPinned: this.rowPinned,
        column: t,
        colDef: t.getColDef(),
        context: this.beans.gridOptionsService.context,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi,
        data: this.data,
        node: this,
        oldValue: e,
        newValue: r,
        value: r,
        source: o
      };
      this.beans.eventService.dispatchEvent(n);
    }, i.prototype.setGroupValue = function(t, e) {
      var r = this.beans.columnModel.getGridColumn(t);
      ue(this.groupData) && (this.groupData = {});
      var o = r.getColId(), n = this.groupData[o];
      n !== e && (this.groupData[o] = e, this.dispatchCellChangedEvent(r, e, n));
    }, i.prototype.setAggData = function(t) {
      var e = this, r = Jd([this.aggData, t]), o = this.aggData;
      this.aggData = t, this.eventService && r.forEach(function(n) {
        var s = e.beans.columnModel.getGridColumn(n), a = e.aggData ? e.aggData[n] : void 0, l = o ? o[n] : void 0;
        e.dispatchCellChangedEvent(s, a, l);
      });
    }, i.prototype.updateHasChildren = function() {
      var t = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0, e = this.beans.gridOptionsService.isRowModelType("serverSide");
      if (e) {
        var r = this.beans.gridOptionsService.isTreeData(), o = this.beans.gridOptionsService.get("isServerSideGroup");
        t = !this.stub && !this.footer && (r ? !!o && o(this.data) : !!this.group);
      }
      t !== this.__hasChildren && (this.__hasChildren = !!t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(i.EVENT_HAS_CHILDREN_CHANGED)));
    }, i.prototype.hasChildren = function() {
      return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
    }, i.prototype.isEmptyRowGroupNode = function() {
      return this.group && cr(this.childrenAfterGroup);
    }, i.prototype.dispatchCellChangedEvent = function(t, e, r) {
      var o = {
        type: i.EVENT_CELL_CHANGED,
        node: this,
        column: t,
        newValue: e,
        oldValue: r
      };
      this.dispatchLocalEvent(o);
    }, i.prototype.resetQuickFilterAggregateText = function() {
      this.quickFilterAggregateText = null;
    }, i.prototype.isExpandable = function() {
      return !!(this.hasChildren() && !this.footer || this.master);
    }, i.prototype.isSelected = function() {
      return this.footer ? this.sibling.isSelected() : this.selected;
    }, i.prototype.depthFirstSearch = function(t) {
      this.childrenAfterGroup && this.childrenAfterGroup.forEach(function(e) {
        return e.depthFirstSearch(t);
      }), t(this);
    }, i.prototype.calculateSelectedFromChildren = function() {
      var t, e = !1, r = !1, o = !1;
      if (!(!((t = this.childrenAfterGroup) === null || t === void 0) && t.length))
        return this.selectable ? this.selected : null;
      for (var n = 0; n < this.childrenAfterGroup.length; n++) {
        var s = this.childrenAfterGroup[n], a = s.isSelected();
        if (!s.selectable) {
          var l = s.calculateSelectedFromChildren();
          if (l === null)
            continue;
          a = l;
        }
        switch (a) {
          case !0:
            e = !0;
            break;
          case !1:
            r = !0;
            break;
          default:
            o = !0;
            break;
        }
      }
      if (!(o || e && r))
        return e ? !0 : r ? !1 : this.selectable ? this.selected : null;
    }, i.prototype.setSelectedInitialValue = function(t) {
      this.selected = t;
    }, i.prototype.selectThisNode = function(t, e, r) {
      r === void 0 && (r = "api");
      var o = !this.selectable && t, n = this.selected === t;
      if (o || n)
        return !1;
      this.selected = t, this.eventService && this.dispatchLocalEvent(this.createLocalRowEvent(i.EVENT_ROW_SELECTED));
      var s = Vn(Vn({}, this.createGlobalRowEvent(m.EVENT_ROW_SELECTED)), { event: e || null, source: r });
      return this.beans.eventService.dispatchEvent(s), !0;
    }, i.prototype.setSelected = function(t, e, r, o) {
      e === void 0 && (e = !1), r === void 0 && (r = !1), o === void 0 && (o = "api"), this.setSelectedParams({
        newValue: t,
        clearSelection: e,
        suppressFinishActions: r,
        rangeSelect: !1,
        source: o
      });
    }, i.prototype.setSelectedParams = function(t) {
      return this.rowPinned ? (console.warn("AG Grid: cannot select pinned rows"), 0) : this.id === void 0 ? (console.warn("AG Grid: cannot select node until id for node is known"), 0) : this.beans.selectionService.setNodeSelected(Vn(Vn({}, t), { node: this.footer ? this.sibling : this }));
    }, i.prototype.isRowPinned = function() {
      return this.rowPinned === "top" || this.rowPinned === "bottom";
    }, i.prototype.isParentOfNode = function(t) {
      for (var e = this.parent; e; ) {
        if (e === t)
          return !0;
        e = e.parent;
      }
      return !1;
    }, i.prototype.addEventListener = function(t, e) {
      this.eventService || (this.eventService = new mo()), this.eventService.addEventListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      this.eventService && (this.eventService.removeEventListener(t, e), this.eventService.noRegisteredListenersExist() && (this.eventService = null));
    }, i.prototype.onMouseEnter = function() {
      this.dispatchLocalEvent(this.createLocalRowEvent(i.EVENT_MOUSE_ENTER));
    }, i.prototype.onMouseLeave = function() {
      this.dispatchLocalEvent(this.createLocalRowEvent(i.EVENT_MOUSE_LEAVE));
    }, i.prototype.getFirstChildOfFirstChild = function(t) {
      for (var e = this, r = !0, o = !1, n = null; r && !o; ) {
        var s = e.parent, a = k(s) && e.firstChild;
        a ? s.rowGroupColumn === t && (o = !0, n = s) : r = !1, e = s;
      }
      return o ? n : null;
    }, i.prototype.isFullWidthCell = function() {
      var t = this.getIsFullWidthCellFunc();
      return t ? t({ rowNode: this }) : !1;
    }, i.prototype.getIsFullWidthCellFunc = function() {
      var t = this.beans.gridOptionsService.getCallback("isFullWidthRow");
      if (t)
        return t;
      var e = this.beans.gridOptionsService.get("isFullWidthCell");
      if (e)
        return function(r) {
          return e(r.rowNode);
        };
    }, i.prototype.getRoute = function() {
      if (this.key != null) {
        for (var t = [], e = this; e.key != null; )
          t.push(e.key), e = e.parent;
        return t.reverse();
      }
    }, i.prototype.createFooter = function() {
      var t = this;
      if (!this.sibling) {
        var e = new i(this.beans);
        Object.keys(this).forEach(function(r) {
          e[r] = t[r];
        }), e.footer = !0, e.setRowTop(null), e.setRowIndex(null), e.oldRowTop = null, e.id = "rowGroupFooter_" + this.id, e.sibling = this, this.sibling = e;
      }
    }, i.ID_PREFIX_ROW_GROUP = "row-group-", i.ID_PREFIX_TOP_PINNED = "t-", i.ID_PREFIX_BOTTOM_PINNED = "b-", i.OBJECT_ID_SEQUENCE = 0, i.EVENT_ROW_SELECTED = "rowSelected", i.EVENT_DATA_CHANGED = "dataChanged", i.EVENT_CELL_CHANGED = "cellChanged", i.EVENT_ALL_CHILDREN_COUNT_CHANGED = "allChildrenCountChanged", i.EVENT_MASTER_CHANGED = "masterChanged", i.EVENT_GROUP_CHANGED = "groupChanged", i.EVENT_MOUSE_ENTER = "mouseEnter", i.EVENT_MOUSE_LEAVE = "mouseLeave", i.EVENT_HEIGHT_CHANGED = "heightChanged", i.EVENT_TOP_CHANGED = "topChanged", i.EVENT_DISPLAYED_CHANGED = "displayedChanged", i.EVENT_FIRST_CHILD_CHANGED = "firstChildChanged", i.EVENT_LAST_CHILD_CHANGED = "lastChildChanged", i.EVENT_CHILD_INDEX_CHANGED = "childIndexChanged", i.EVENT_ROW_INDEX_CHANGED = "rowIndexChanged", i.EVENT_EXPANDED_CHANGED = "expandedChanged", i.EVENT_HAS_CHILDREN_CHANGED = "hasChildrenChanged", i.EVENT_SELECTABLE_CHANGED = "selectableChanged", i.EVENT_UI_LEVEL_CHANGED = "uiLevelChanged", i.EVENT_HIGHLIGHT_CHANGED = "rowHighlightChanged", i.EVENT_DRAGGING_CHANGED = "draggingChanged", i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ww = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ea = function() {
  return ea = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ea.apply(this, arguments);
}, Wp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, lc = (
  /** @class */
  function(i) {
    Ww(t, i);
    function t() {
      return i.call(
        this,
        /* html*/
        `
            <div class="ag-selection-checkbox" role="presentation">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`
      ) || this;
    }
    return t.prototype.postConstruct = function() {
      this.eCheckbox.setPassive(!0);
    }, t.prototype.getCheckboxId = function() {
      return this.eCheckbox.getInputElement().id;
    }, t.prototype.onDataChanged = function() {
      this.onSelectionChanged();
    }, t.prototype.onSelectableChanged = function() {
      this.showOrHideSelect();
    }, t.prototype.onSelectionChanged = function() {
      var e = this.localeService.getLocaleTextFunc(), r = this.rowNode.isSelected(), o = r === void 0 ? e("ariaIndeterminate", "indeterminate") : r === !0 ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked"), n = e("ariaRowToggleSelection", "Press Space to toggle row selection");
      this.eCheckbox.setValue(r, !0), this.eCheckbox.setInputAriaLabel(n + " (" + o + ")");
    }, t.prototype.onCheckedClicked = function(e) {
      var r = this.gridOptionsService.is("groupSelectsFiltered"), o = this.rowNode.setSelectedParams({ newValue: !1, rangeSelect: e.shiftKey, groupSelectsFiltered: r, event: e, source: "checkboxSelected" });
      return o;
    }, t.prototype.onUncheckedClicked = function(e) {
      var r = this.gridOptionsService.is("groupSelectsFiltered"), o = this.rowNode.setSelectedParams({ newValue: !0, rangeSelect: e.shiftKey, groupSelectsFiltered: r, event: e, source: "checkboxSelected" });
      return o;
    }, t.prototype.init = function(e) {
      var r = this;
      this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListener(this.eCheckbox.getInputElement(), "dblclick", function(a) {
        Un(a);
      }), this.addManagedListener(this.eCheckbox.getInputElement(), "click", function(a) {
        Un(a);
        var l = r.eCheckbox.getValue();
        l ? r.onCheckedClicked(a) : r.onUncheckedClicked(a || {});
      }), this.addManagedListener(this.rowNode, ye.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_DATA_CHANGED, this.onDataChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
      var o = this.gridOptionsService.get("isRowSelectable"), n = o || typeof this.getIsVisible() == "function";
      if (n) {
        var s = this.showOrHideSelect.bind(this);
        this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, s), this.addManagedListener(this.rowNode, ye.EVENT_DATA_CHANGED, s), this.addManagedListener(this.rowNode, ye.EVENT_CELL_CHANGED, s), this.showOrHideSelect();
      }
      this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }, t.prototype.showOrHideSelect = function() {
      var e, r, o, n, s = this.rowNode.selectable, a = this.getIsVisible();
      if (s)
        if (typeof a == "function") {
          var l = (e = this.overrides) === null || e === void 0 ? void 0 : e.callbackParams, u = (r = this.column) === null || r === void 0 ? void 0 : r.createColumnFunctionCallbackParams(this.rowNode);
          s = u ? a(ea(ea({}, l), u)) : !1;
        } else
          s = a ?? !1;
      var c = (o = this.column) === null || o === void 0 ? void 0 : o.getColDef().showDisabledCheckboxes;
      if (c) {
        this.eCheckbox.setDisabled(!s), this.setVisible(!0), this.setDisplayed(!0);
        return;
      }
      if (!((n = this.overrides) === null || n === void 0) && n.removeHidden) {
        this.setDisplayed(s);
        return;
      }
      this.setVisible(s);
    }, t.prototype.getIsVisible = function() {
      var e, r;
      return this.overrides ? this.overrides.isVisible : (r = (e = this.column) === null || e === void 0 ? void 0 : e.getColDef()) === null || r === void 0 ? void 0 : r.checkboxSelection;
    }, Wp([
      Y("eCheckbox")
    ], t.prototype, "eCheckbox", void 0), Wp([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Uw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), qo = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, cs = function(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], r = 0;
  if (e)
    return e.call(i);
  if (i && typeof i.length == "number")
    return {
      next: function() {
        return i && r >= i.length && (i = void 0), { value: i && i[r++], done: !i };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, kt;
(function(i) {
  i[i.ToolPanel = 0] = "ToolPanel", i[i.HeaderCell = 1] = "HeaderCell", i[i.RowDrag = 2] = "RowDrag", i[i.ChartPanel = 3] = "ChartPanel";
})(kt || (kt = {}));
var vn;
(function(i) {
  i[i.Up = 0] = "Up", i[i.Down = 1] = "Down";
})(vn || (vn = {}));
var Gr;
(function(i) {
  i[i.Left = 0] = "Left", i[i.Right = 1] = "Right";
})(Gr || (Gr = {}));
var Tt = (
  /** @class */
  function(i) {
    Uw(t, i);
    function t() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.dragSourceAndParamsList = [], r.dropTargets = [], r;
    }
    e = t, t.prototype.init = function() {
      this.ePinnedIcon = Cr("columnMovePin", this.gridOptionsService, null), this.eHideIcon = Cr("columnMoveHide", this.gridOptionsService, null), this.eMoveIcon = Cr("columnMoveMove", this.gridOptionsService, null), this.eLeftIcon = Cr("columnMoveLeft", this.gridOptionsService, null), this.eRightIcon = Cr("columnMoveRight", this.gridOptionsService, null), this.eGroupIcon = Cr("columnMoveGroup", this.gridOptionsService, null), this.eAggregateIcon = Cr("columnMoveValue", this.gridOptionsService, null), this.ePivotIcon = Cr("columnMovePivot", this.gridOptionsService, null), this.eDropNotAllowedIcon = Cr("dropNotAllowed", this.gridOptionsService, null);
    }, t.prototype.addDragSource = function(r, o) {
      o === void 0 && (o = !1);
      var n = {
        eElement: r.eElement,
        dragStartPixels: r.dragStartPixels,
        onDragStart: this.onDragStart.bind(this, r),
        onDragStop: this.onDragStop.bind(this),
        onDragging: this.onDragging.bind(this)
      };
      this.dragSourceAndParamsList.push({ params: n, dragSource: r }), this.dragService.addDragSource(n, o);
    }, t.prototype.removeDragSource = function(r) {
      var o = this.dragSourceAndParamsList.find(function(n) {
        return n.dragSource === r;
      });
      o && (this.dragService.removeDragSource(o.params), Vt(this.dragSourceAndParamsList, o));
    }, t.prototype.clearDragSourceParamsList = function() {
      var r = this;
      this.dragSourceAndParamsList.forEach(function(o) {
        return r.dragService.removeDragSource(o.params);
      }), this.dragSourceAndParamsList.length = 0, this.dropTargets.length = 0;
    }, t.prototype.nudge = function() {
      this.dragging && this.onDragging(this.eventLastTime, !0);
    }, t.prototype.onDragStart = function(r, o) {
      this.dragging = !0, this.dragSource = r, this.eventLastTime = o, this.dragItem = this.dragSource.getDragItem(), this.lastDropTarget = this.dragSource.dragSourceDropTarget, this.dragSource.onDragStarted && this.dragSource.onDragStarted(), this.createGhost();
    }, t.prototype.onDragStop = function(r) {
      if (this.eventLastTime = null, this.dragging = !1, this.dragSource.onDragStopped && this.dragSource.onDragStopped(), this.lastDropTarget && this.lastDropTarget.onDragStop) {
        var o = this.createDropTargetEvent(this.lastDropTarget, r, null, null, !1);
        this.lastDropTarget.onDragStop(o);
      }
      this.lastDropTarget = null, this.dragItem = null, this.removeGhost();
    }, t.prototype.onDragging = function(r, o) {
      var n = this, s, a, l, u, c = this.getHorizontalDirection(r), p = this.getVerticalDirection(r);
      this.eventLastTime = r, this.positionGhost(r);
      var d = this.dropTargets.filter(function(y) {
        return n.isMouseOnDropTarget(r, y);
      }), h = this.findCurrentDropTarget(r, d);
      if (h !== this.lastDropTarget)
        this.leaveLastTargetIfExists(r, c, p, o), this.lastDropTarget !== null && h === null && ((a = (s = this.dragSource).onGridExit) === null || a === void 0 || a.call(s, this.dragItem)), this.lastDropTarget === null && h !== null && ((u = (l = this.dragSource).onGridEnter) === null || u === void 0 || u.call(l, this.dragItem)), this.enterDragTargetIfExists(h, r, c, p, o), this.lastDropTarget = h;
      else if (h && h.onDragging) {
        var g = this.createDropTargetEvent(h, r, c, p, o);
        h.onDragging(g);
      }
    }, t.prototype.getAllContainersFromDropTarget = function(r) {
      var o = r.getSecondaryContainers ? r.getSecondaryContainers() : null, n = [[r.getContainer()]];
      return o ? n.concat(o) : n;
    }, t.prototype.allContainersIntersect = function(r, o) {
      var n, s;
      try {
        for (var a = cs(o), l = a.next(); !l.done; l = a.next()) {
          var u = l.value, c = u.getBoundingClientRect();
          if (c.width === 0 || c.height === 0)
            return !1;
          var p = r.clientX >= c.left && r.clientX < c.right, d = r.clientY >= c.top && r.clientY < c.bottom;
          if (!p || !d)
            return !1;
        }
      } catch (h) {
        n = { error: h };
      } finally {
        try {
          l && !l.done && (s = a.return) && s.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return !0;
    }, t.prototype.isMouseOnDropTarget = function(r, o) {
      var n, s, a = this.getAllContainersFromDropTarget(o), l = !1;
      try {
        for (var u = cs(a), c = u.next(); !c.done; c = u.next()) {
          var p = c.value;
          if (this.allContainersIntersect(r, p)) {
            l = !0;
            break;
          }
        }
      } catch (d) {
        n = { error: d };
      } finally {
        try {
          c && !c.done && (s = u.return) && s.call(u);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return o.targetContainsSource && !o.getContainer().contains(this.dragSource.eElement) ? !1 : l && o.isInterestedIn(this.dragSource.type, this.dragSource.eElement);
    }, t.prototype.findCurrentDropTarget = function(r, o) {
      var n, s, a, l, u = o.length;
      if (u === 0)
        return null;
      if (u === 1)
        return o[0];
      var c = this.gridOptionsService.getRootNode(), p = c.elementsFromPoint(r.clientX, r.clientY);
      try {
        for (var d = cs(p), h = d.next(); !h.done; h = d.next()) {
          var g = h.value;
          try {
            for (var y = (a = void 0, cs(o)), S = y.next(); !S.done; S = y.next()) {
              var _ = S.value, w = cf(this.getAllContainersFromDropTarget(_));
              if (w.indexOf(g) !== -1)
                return _;
            }
          } catch (E) {
            a = { error: E };
          } finally {
            try {
              S && !S.done && (l = y.return) && l.call(y);
            } finally {
              if (a)
                throw a.error;
            }
          }
        }
      } catch (E) {
        n = { error: E };
      } finally {
        try {
          h && !h.done && (s = d.return) && s.call(d);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return null;
    }, t.prototype.enterDragTargetIfExists = function(r, o, n, s, a) {
      if (r) {
        if (r.onDragEnter) {
          var l = this.createDropTargetEvent(r, o, n, s, a);
          r.onDragEnter(l);
        }
        this.setGhostIcon(r.getIconName ? r.getIconName() : null);
      }
    }, t.prototype.leaveLastTargetIfExists = function(r, o, n, s) {
      if (this.lastDropTarget) {
        if (this.lastDropTarget.onDragLeave) {
          var a = this.createDropTargetEvent(this.lastDropTarget, r, o, n, s);
          this.lastDropTarget.onDragLeave(a);
        }
        this.setGhostIcon(null);
      }
    }, t.prototype.addDropTarget = function(r) {
      this.dropTargets.push(r);
    }, t.prototype.removeDropTarget = function(r) {
      this.dropTargets = this.dropTargets.filter(function(o) {
        return o.getContainer() !== r.getContainer();
      });
    }, t.prototype.hasExternalDropZones = function() {
      return this.dropTargets.some(function(r) {
        return r.external;
      });
    }, t.prototype.findExternalZone = function(r) {
      var o = this.dropTargets.filter(function(n) {
        return n.external;
      });
      return o.find(function(n) {
        return n.getContainer() === r.getContainer();
      }) || null;
    }, t.prototype.getHorizontalDirection = function(r) {
      var o = this.eventLastTime && this.eventLastTime.clientX, n = r.clientX;
      return o === n ? null : o > n ? Gr.Left : Gr.Right;
    }, t.prototype.getVerticalDirection = function(r) {
      var o = this.eventLastTime && this.eventLastTime.clientY, n = r.clientY;
      return o === n ? null : o > n ? vn.Up : vn.Down;
    }, t.prototype.createDropTargetEvent = function(r, o, n, s, a) {
      var l = r.getContainer(), u = l.getBoundingClientRect(), c = this, p = c.gridApi, d = c.columnApi, h = c.dragItem, g = c.dragSource, y = o.clientX - u.left, S = o.clientY - u.top;
      return { event: o, x: y, y: S, vDirection: s, hDirection: n, dragSource: g, fromNudge: a, dragItem: h, api: p, columnApi: d, dropZoneTarget: l };
    }, t.prototype.positionGhost = function(r) {
      var o = this.eGhost;
      if (o) {
        var n = o.getBoundingClientRect(), s = n.height, a = Bf() - 2, l = kf() - 2, u = r.pageY - s / 2, c = r.pageX - 10, p = this.gridOptionsService.getDocument(), d = p.defaultView || window, h = d.pageYOffset || p.documentElement.scrollTop, g = d.pageXOffset || p.documentElement.scrollLeft;
        a > 0 && c + o.clientWidth > a + g && (c = a + g - o.clientWidth), c < 0 && (c = 0), l > 0 && u + o.clientHeight > l + h && (u = l + h - o.clientHeight), u < 0 && (u = 0), o.style.left = c + "px", o.style.top = u + "px";
      }
    }, t.prototype.removeGhost = function() {
      this.eGhost && this.eGhostParent && this.eGhostParent.removeChild(this.eGhost), this.eGhost = null;
    }, t.prototype.createGhost = function() {
      this.eGhost = Lt(e.GHOST_TEMPLATE), this.mouseEventService.stampTopLevelGridCompWithGridInstance(this.eGhost);
      var r = this.environment.getTheme().theme;
      r && this.eGhost.classList.add(r), this.eGhostIcon = this.eGhost.querySelector(".ag-dnd-ghost-icon"), this.setGhostIcon(null);
      var o = this.eGhost.querySelector(".ag-dnd-ghost-label"), n = this.dragSource.dragItemName;
      Oa(n) && (n = n()), o.innerHTML = so(n) || "", this.eGhost.style.height = "25px", this.eGhost.style.top = "20px", this.eGhost.style.left = "20px";
      var s = this.gridOptionsService.getDocument(), a = null;
      try {
        a = s.fullscreenElement;
      } catch {
      } finally {
        if (!a) {
          var l = this.gridOptionsService.getRootNode(), u = l.querySelector("body");
          u ? a = u : l instanceof ShadowRoot ? a = l : a = l == null ? void 0 : l.documentElement;
        }
      }
      this.eGhostParent = a, this.eGhostParent ? this.eGhostParent.appendChild(this.eGhost) : console.warn("AG Grid: could not find document body, it is needed for dragging columns");
    }, t.prototype.setGhostIcon = function(r, o) {
      o === void 0 && (o = !1), pr(this.eGhostIcon);
      var n = null;
      switch (r || (r = this.dragSource.defaultIconName || e.ICON_NOT_ALLOWED), r) {
        case e.ICON_PINNED:
          n = this.ePinnedIcon;
          break;
        case e.ICON_MOVE:
          n = this.eMoveIcon;
          break;
        case e.ICON_LEFT:
          n = this.eLeftIcon;
          break;
        case e.ICON_RIGHT:
          n = this.eRightIcon;
          break;
        case e.ICON_GROUP:
          n = this.eGroupIcon;
          break;
        case e.ICON_AGGREGATE:
          n = this.eAggregateIcon;
          break;
        case e.ICON_PIVOT:
          n = this.ePivotIcon;
          break;
        case e.ICON_NOT_ALLOWED:
          n = this.eDropNotAllowedIcon;
          break;
        case e.ICON_HIDE:
          n = this.eHideIcon;
          break;
      }
      this.eGhostIcon.classList.toggle("ag-shake-left-to-right", o), !(n === this.eHideIcon && this.gridOptionsService.is("suppressDragLeaveHidesColumns")) && n && this.eGhostIcon.appendChild(n);
    };
    var e;
    return t.ICON_PINNED = "pinned", t.ICON_MOVE = "move", t.ICON_LEFT = "left", t.ICON_RIGHT = "right", t.ICON_GROUP = "group", t.ICON_AGGREGATE = "aggregate", t.ICON_PIVOT = "pivot", t.ICON_NOT_ALLOWED = "notAllowed", t.ICON_HIDE = "hide", t.GHOST_TEMPLATE = `<div class="ag-dnd-ghost ag-unselectable">
            <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>
            <div class="ag-dnd-ghost-label"></div>
        </div>`, qo([
      v("dragService")
    ], t.prototype, "dragService", void 0), qo([
      v("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), qo([
      v("columnApi")
    ], t.prototype, "columnApi", void 0), qo([
      v("gridApi")
    ], t.prototype, "gridApi", void 0), qo([
      U
    ], t.prototype, "init", null), qo([
      At
    ], t.prototype, "clearDragSourceParamsList", null), t = e = qo([
      te("dragAndDropService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ia = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ti = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, ta = (
  /** @class */
  function(i) {
    Ia(t, i);
    function t(e, r, o, n, s, a) {
      var l = i.call(this) || this;
      return l.cellValueFn = e, l.rowNode = r, l.column = o, l.customGui = n, l.dragStartPixels = s, l.suppressVisibilityChange = a, l.dragSource = null, l;
    }
    return t.prototype.isCustomGui = function() {
      return this.customGui != null;
    }, t.prototype.postConstruct = function() {
      if (this.customGui ? this.setDragElement(this.customGui, this.dragStartPixels) : (this.setTemplate(
        /* html */
        '<div class="ag-drag-handle ag-row-drag" aria-hidden="true"></div>'
      ), this.getGui().appendChild(ut("rowDrag", this.beans.gridOptionsService, null)), this.addDragSource()), this.checkCompatibility(), !this.suppressVisibilityChange) {
        var e = this.beans.gridOptionsService.is("rowDragManaged") ? new $w(this, this.beans, this.rowNode, this.column) : new zw(this, this.beans, this.rowNode, this.column);
        this.createManagedBean(e, this.beans.context);
      }
    }, t.prototype.setDragElement = function(e, r) {
      this.setTemplateFromElement(e), this.addDragSource(r);
    }, t.prototype.getSelectedNodes = function() {
      var e = this.beans.gridOptionsService.is("rowDragMultiRow");
      if (!e)
        return [this.rowNode];
      var r = this.beans.selectionService.getSelectedNodes();
      return r.indexOf(this.rowNode) !== -1 ? r : [this.rowNode];
    }, t.prototype.checkCompatibility = function() {
      var e = this.beans.gridOptionsService.is("rowDragManaged"), r = this.beans.gridOptionsService.isTreeData();
      r && e && Pe(function() {
        return console.warn("AG Grid: If using row drag with tree data, you cannot have rowDragManaged=true");
      }, "RowDragComp.managedAndTreeData");
    }, t.prototype.getDragItem = function() {
      return {
        rowNode: this.rowNode,
        rowNodes: this.getSelectedNodes(),
        columns: this.column ? [this.column] : void 0,
        defaultTextValue: this.cellValueFn()
      };
    }, t.prototype.getRowDragText = function(e) {
      if (e) {
        var r = e.getColDef();
        if (r.rowDragText)
          return r.rowDragText;
      }
      return this.gridOptionsService.get("rowDragText");
    }, t.prototype.addDragSource = function(e) {
      var r = this;
      e === void 0 && (e = 4), this.dragSource && this.removeDragSource();
      var o = this.getRowDragText(this.column), n = this.localeService.getLocaleTextFunc();
      this.dragSource = {
        type: kt.RowDrag,
        eElement: this.getGui(),
        dragItemName: function() {
          var s, a = r.getDragItem(), l = ((s = a.rowNodes) === null || s === void 0 ? void 0 : s.length) || 1;
          return o ? o(a, l) : l === 1 ? r.cellValueFn() : l + " " + n("rowDragRows", "rows");
        },
        getDragItem: function() {
          return r.getDragItem();
        },
        dragStartPixels: e,
        dragSourceDomDataKey: this.beans.gridOptionsService.getDomDataKey()
      }, this.beans.dragAndDropService.addDragSource(this.dragSource, !0);
    }, t.prototype.removeDragSource = function() {
      this.dragSource && this.beans.dragAndDropService.removeDragSource(this.dragSource), this.dragSource = null;
    }, Ti([
      v("beans")
    ], t.prototype, "beans", void 0), Ti([
      U
    ], t.prototype, "postConstruct", null), Ti([
      At
    ], t.prototype, "removeDragSource", null), t;
  }(ge)
), Th = (
  /** @class */
  function(i) {
    Ia(t, i);
    function t(e, r, o) {
      var n = i.call(this) || this;
      return n.parent = e, n.rowNode = r, n.column = o, n;
    }
    return t.prototype.setDisplayedOrVisible = function(e) {
      var r = { skipAriaHidden: !0 };
      if (e)
        this.parent.setDisplayed(!1, r);
      else {
        var o = !0, n = !1;
        this.column && (o = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui(), n = Oa(this.column.getColDef().rowDrag)), n ? (this.parent.setDisplayed(!0, r), this.parent.setVisible(o, r)) : (this.parent.setDisplayed(o, r), this.parent.setVisible(!0, r));
      }
    }, t;
  }(j)
), zw = (
  /** @class */
  function(i) {
    Ia(t, i);
    function t(e, r, o, n) {
      var s = i.call(this, e, o, n) || this;
      return s.beans = r, s;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, m.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this)), this.workOutVisibility();
    }, t.prototype.onSuppressRowDrag = function() {
      this.workOutVisibility();
    }, t.prototype.workOutVisibility = function() {
      var e = this.beans.gridOptionsService.is("suppressRowDrag");
      this.setDisplayedOrVisible(e);
    }, Ti([
      U
    ], t.prototype, "postConstruct", null), t;
  }(Th)
), $w = (
  /** @class */
  function(i) {
    Ia(t, i);
    function t(e, r, o, n) {
      var s = i.call(this, e, o, n) || this;
      return s.beans = r, s;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.beans.eventService, m.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, m.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, m.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.workOutVisibility();
    }, t.prototype.onSuppressRowDrag = function() {
      this.workOutVisibility();
    }, t.prototype.workOutVisibility = function() {
      var e = this.beans.ctrlsService.getGridBodyCtrl(), r = e.getRowDragFeature(), o = r && r.shouldPreventRowMove(), n = this.beans.gridOptionsService.is("suppressRowDrag"), s = this.beans.dragAndDropService.hasExternalDropZones(), a = o && !s || n;
      this.setDisplayedOrVisible(a);
    }, Ti([
      U
    ], t.prototype, "postConstruct", null), t;
  }(Th)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Kw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ra = function() {
  return ra = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ra.apply(this, arguments);
}, oi = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ph = (
  /** @class */
  function(i) {
    Kw(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function(e, r, o, n, s, a, l) {
      this.params = l, this.eGui = r, this.eCheckbox = o, this.eExpanded = n, this.eContracted = s, this.comp = e, this.compClass = a;
      var u = this.isTopLevelFooter(), c = this.isEmbeddedRowMismatch(), p = l.value == null && !l.node.master, d = !1;
      if (this.gridOptionsService.is("groupIncludeFooter") && this.gridOptionsService.is("groupHideOpenParents")) {
        var h = l.node;
        if (h.footer) {
          var g = l.colDef && l.colDef.showRowGroup, y = h.rowGroupColumn && h.rowGroupColumn.getColId();
          d = g !== y;
        }
      }
      this.cellIsBlank = u ? !1 : c || p && !l.node.master || d, !this.cellIsBlank && (this.setupShowingValueForOpenedParent(), this.findDisplayedGroupNode(), this.addFullWidthRowDraggerIfNeeded(), this.addExpandAndContract(), this.addCheckboxIfNeeded(), this.addValueElement(), this.setupIndent(), this.refreshAriaExpanded());
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this), this.expandListener = null;
    }, t.prototype.refreshAriaExpanded = function() {
      var e = this.params, r = e.node, o = e.eParentOfValue;
      if (this.expandListener && (this.expandListener = this.expandListener()), !this.isExpandable()) {
        xf(o);
        return;
      }
      var n = function() {
        Vr(o, !!r.expanded);
      };
      this.expandListener = this.addManagedListener(r, ye.EVENT_EXPANDED_CHANGED, n) || null, n();
    }, t.prototype.isTopLevelFooter = function() {
      if (!this.gridOptionsService.is("groupIncludeTotalFooter") || this.params.value != null || this.params.node.level != -1)
        return !1;
      var e = this.params.colDef, r = e == null;
      if (r || e.showRowGroup === !0)
        return !0;
      var o = this.columnModel.getRowGroupColumns();
      if (!o || o.length === 0)
        return !0;
      var n = o[0];
      return n.getId() === e.showRowGroup;
    }, t.prototype.isEmbeddedRowMismatch = function() {
      if (!this.params.fullWidth || !this.gridOptionsService.is("embedFullWidthRows"))
        return !1;
      var e = this.params.pinned === "left", r = this.params.pinned === "right", o = !e && !r;
      return this.gridOptionsService.is("enableRtl") ? this.columnModel.isPinningLeft() ? !r : !o : this.columnModel.isPinningLeft() ? !e : !o;
    }, t.prototype.findDisplayedGroupNode = function() {
      var e = this.params.column, r = this.params.node;
      if (this.showingValueForOpenedParent)
        for (var o = r.parent; o != null; ) {
          if (o.rowGroupColumn && e.isRowGroupDisplayed(o.rowGroupColumn.getId())) {
            this.displayedGroupNode = o;
            break;
          }
          o = o.parent;
        }
      ue(this.displayedGroupNode) && (this.displayedGroupNode = r);
    }, t.prototype.setupShowingValueForOpenedParent = function() {
      var e = this.params.node, r = this.params.column;
      if (!this.gridOptionsService.is("groupHideOpenParents")) {
        this.showingValueForOpenedParent = !1;
        return;
      }
      if (!e.groupData) {
        this.showingValueForOpenedParent = !1;
        return;
      }
      var o = e.rowGroupColumn != null;
      if (o) {
        var n = e.rowGroupColumn.getId(), s = r.isRowGroupDisplayed(n);
        if (s) {
          this.showingValueForOpenedParent = !1;
          return;
        }
      }
      var a = e.groupData[r.getId()] != null;
      this.showingValueForOpenedParent = a;
    }, t.prototype.addValueElement = function() {
      this.displayedGroupNode.footer ? this.addFooterValue() : (this.addGroupValue(), this.addChildCount());
    }, t.prototype.addGroupValue = function() {
      var e = this.adjustParamsWithDetailsFromRelatedColumn(), r = this.getInnerCompDetails(e), o = e.valueFormatted, n = e.value, s = o;
      if (s == null)
        if (n === "" && this.params.node.group) {
          var a = this.localeService.getLocaleTextFunc();
          s = a("blanks", "(Blanks)");
        } else
          s = n ?? null;
      this.comp.setInnerRenderer(r, s);
    }, t.prototype.adjustParamsWithDetailsFromRelatedColumn = function() {
      var e = this.displayedGroupNode.rowGroupColumn, r = this.params.column;
      if (!e)
        return this.params;
      var o = r != null;
      if (o) {
        var n = r.isRowGroupDisplayed(e.getId());
        if (!n)
          return this.params;
      }
      var s = this.params, a = this.params, l = a.value, u = a.node, c = this.valueFormatterService.formatValue(e, u, l), p = ra(ra({}, s), { valueFormatted: c });
      return p;
    }, t.prototype.addFooterValue = function() {
      var e = this.params.footerValueGetter, r = "";
      if (e) {
        var o = Au(this.params);
        o.value = this.params.value, typeof e == "function" ? r = e(o) : typeof e == "string" ? r = this.expressionService.evaluate(e, o) : console.warn("AG Grid: footerValueGetter should be either a function or a string (expression)");
      } else
        r = "Total " + (this.params.value != null ? this.params.value : "");
      var n = this.getInnerCompDetails(this.params);
      this.comp.setInnerRenderer(n, r);
    }, t.prototype.getInnerCompDetails = function(e) {
      var r = this;
      if (e.fullWidth)
        return this.userComponentFactory.getFullWidthGroupRowInnerCellRenderer(this.gridOptionsService.get("groupRowRendererParams"), e);
      var o = this.userComponentFactory.getInnerRendererDetails(e, e), n = function(c) {
        return c && c.componentClass == r.compClass;
      };
      if (o && !n(o))
        return o;
      var s = this.displayedGroupNode.rowGroupColumn, a = s ? s.getColDef() : void 0;
      if (a) {
        var l = this.userComponentFactory.getCellRendererDetails(a, e);
        if (l && !n(l))
          return l;
        if (n(l) && a.cellRendererParams && a.cellRendererParams.innerRenderer) {
          var u = this.userComponentFactory.getInnerRendererDetails(a.cellRendererParams, e);
          return u;
        }
      }
    }, t.prototype.addChildCount = function() {
      this.params.suppressCount || (this.addManagedListener(this.displayedGroupNode, ye.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this)), this.updateChildCount());
    }, t.prototype.updateChildCount = function() {
      var e = this.displayedGroupNode.allChildrenCount, r = this.isShowRowGroupForThisRow(), o = r && e != null && e >= 0, n = o ? "(" + e + ")" : "";
      this.comp.setChildCount(n);
    }, t.prototype.isShowRowGroupForThisRow = function() {
      if (this.gridOptionsService.isTreeData())
        return !0;
      var e = this.displayedGroupNode.rowGroupColumn;
      if (!e)
        return !1;
      var r = this.params.column, o = r == null || r.isRowGroupDisplayed(e.getId());
      return o;
    }, t.prototype.addExpandAndContract = function() {
      var e, r = this.params, o = ut("groupExpanded", this.gridOptionsService, null), n = ut("groupContracted", this.gridOptionsService, null);
      o && this.eExpanded.appendChild(o), n && this.eContracted.appendChild(n);
      var s = r.eGridCell, a = ((e = this.params.column) === null || e === void 0 ? void 0 : e.isCellEditable(r.node)) && this.gridOptionsService.is("enableGroupEdit");
      !a && this.isExpandable() && !r.suppressDoubleClickExpand && this.addManagedListener(s, "dblclick", this.onCellDblClicked.bind(this)), this.addManagedListener(this.eExpanded, "click", this.onExpandClicked.bind(this)), this.addManagedListener(this.eContracted, "click", this.onExpandClicked.bind(this)), this.addManagedListener(s, "keydown", this.onKeyDown.bind(this)), this.addManagedListener(r.node, ye.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this)), this.showExpandAndContractIcons();
      var l = this.onRowNodeIsExpandableChanged.bind(this);
      this.addManagedListener(this.displayedGroupNode, ye.EVENT_ALL_CHILDREN_COUNT_CHANGED, l), this.addManagedListener(this.displayedGroupNode, ye.EVENT_MASTER_CHANGED, l), this.addManagedListener(this.displayedGroupNode, ye.EVENT_GROUP_CHANGED, l), this.addManagedListener(this.displayedGroupNode, ye.EVENT_HAS_CHILDREN_CHANGED, l);
    }, t.prototype.onExpandClicked = function(e) {
      oo(e) || (Un(e), this.onExpandOrContract(e));
    }, t.prototype.onExpandOrContract = function(e) {
      var r = this.displayedGroupNode, o = !r.expanded;
      !o && r.sticky && this.scrollToStickyNode(r), r.setExpanded(o, e);
    }, t.prototype.scrollToStickyNode = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), o = r.getScrollFeature();
      o.setVerticalScrollPosition(e.rowTop - e.stickyRowTop);
    }, t.prototype.isExpandable = function() {
      if (this.showingValueForOpenedParent)
        return !0;
      var e = this.displayedGroupNode, r = this.columnModel.isPivotMode() && e.leafGroup, o = e.isExpandable() && !e.footer && !r;
      if (!o)
        return !1;
      var n = this.params.column, s = n != null && typeof n.getColDef().showRowGroup == "string";
      if (s) {
        var a = this.isShowRowGroupForThisRow();
        return a;
      }
      return !0;
    }, t.prototype.showExpandAndContractIcons = function() {
      var e = this, r = e.params, o = e.displayedGroupNode, n = e.columnModel, s = r.node, a = this.isExpandable();
      if (a) {
        var l = this.showingValueForOpenedParent ? !0 : s.expanded;
        this.comp.setExpandedDisplayed(l), this.comp.setContractedDisplayed(!l);
      } else
        this.comp.setExpandedDisplayed(!1), this.comp.setContractedDisplayed(!1);
      var u = n.isPivotMode(), c = u && o.leafGroup, p = a && !c, d = s.footer && s.level === -1;
      this.comp.addOrRemoveCssClass("ag-cell-expandable", p), this.comp.addOrRemoveCssClass("ag-row-group", p), u ? this.comp.addOrRemoveCssClass("ag-pivot-leaf-group", c) : d || this.comp.addOrRemoveCssClass("ag-row-group-leaf-indent", !p);
    }, t.prototype.onRowNodeIsExpandableChanged = function() {
      this.showExpandAndContractIcons(), this.setIndent(), this.refreshAriaExpanded();
    }, t.prototype.setupIndent = function() {
      var e = this.params.node, r = this.params.suppressPadding;
      r || (this.addManagedListener(e, ye.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this)), this.setIndent());
    }, t.prototype.setIndent = function() {
      if (!this.gridOptionsService.is("groupHideOpenParents")) {
        var e = this.params, r = e.node, o = !!e.colDef, n = this.gridOptionsService.isTreeData(), s = !o || n || e.colDef.showRowGroup === !0, a = s ? r.uiLevel : 0;
        this.indentClass && this.comp.addOrRemoveCssClass(this.indentClass, !1), this.indentClass = "ag-row-group-indent-" + a, this.comp.addOrRemoveCssClass(this.indentClass, !0);
      }
    }, t.prototype.addFullWidthRowDraggerIfNeeded = function() {
      var e = this;
      if (!(!this.params.fullWidth || !this.params.rowDrag)) {
        var r = new ta(function() {
          return e.params.value;
        }, this.params.node);
        this.createManagedBean(r, this.context), this.eGui.insertAdjacentElement("afterbegin", r.getGui());
      }
    }, t.prototype.isUserWantsSelected = function() {
      var e = this.params.checkbox;
      return typeof e == "function" || e === !0;
    }, t.prototype.addCheckboxIfNeeded = function() {
      var e = this, r = this.displayedGroupNode, o = this.isUserWantsSelected() && // footers cannot be selected
      !r.footer && // pinned rows cannot be selected
      !r.rowPinned && // details cannot be selected
      !r.detail;
      if (o) {
        var n = new lc();
        this.getContext().createBean(n), n.init({
          rowNode: r,
          column: this.params.column,
          overrides: {
            isVisible: this.params.checkbox,
            callbackParams: this.params,
            removeHidden: !0
          }
        }), this.eCheckbox.appendChild(n.getGui()), this.addDestroyFunc(function() {
          return e.getContext().destroyBean(n);
        });
      }
      this.comp.setCheckboxVisible(o);
    }, t.prototype.onKeyDown = function(e) {
      var r = e.key === L.ENTER;
      if (!(!r || this.params.suppressEnterExpand)) {
        var o = this.params.column && this.params.column.isCellEditable(this.params.node);
        o || this.onExpandOrContract(e);
      }
    }, t.prototype.onCellDblClicked = function(e) {
      if (!oo(e)) {
        var r = qs(this.eExpanded, e) || qs(this.eContracted, e);
        r || this.onExpandOrContract(e);
      }
    }, oi([
      v("expressionService")
    ], t.prototype, "expressionService", void 0), oi([
      v("valueFormatterService")
    ], t.prototype, "valueFormatterService", void 0), oi([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), oi([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), oi([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Yw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ni = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, hu = (
  /** @class */
  function(i) {
    Yw(t, i);
    function t() {
      return i.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      var r = this, o = {
        setInnerRenderer: function(l, u) {
          return r.setRenderDetails(l, u);
        },
        setChildCount: function(l) {
          return r.eChildCount.innerHTML = l;
        },
        addOrRemoveCssClass: function(l, u) {
          return r.addOrRemoveCssClass(l, u);
        },
        setContractedDisplayed: function(l) {
          return be(r.eContracted, l);
        },
        setExpandedDisplayed: function(l) {
          return be(r.eExpanded, l);
        },
        setCheckboxVisible: function(l) {
          return r.eCheckbox.classList.toggle("ag-invisible", !l);
        }
      }, n = this.createManagedBean(new Ph()), s = !e.colDef, a = this.getGui();
      n.init(o, a, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, e), s && Dt(a, "gridcell");
    }, t.prototype.setRenderDetails = function(e, r) {
      var o = this;
      if (e) {
        var n = e.newAgStackInstance();
        if (!n)
          return;
        n.then(function(s) {
          if (s) {
            var a = function() {
              return o.context.destroyBean(s);
            };
            o.isAlive() ? (o.eValue.appendChild(s.getGui()), o.addDestroyFunc(a)) : a();
          }
        });
      } else
        this.eValue.innerText = r;
    }, t.prototype.destroy = function() {
      this.getContext().destroyBean(this.innerCellRenderer), i.prototype.destroy.call(this);
    }, t.prototype.refresh = function() {
      return !1;
    }, t.TEMPLATE = `<span class="ag-cell-wrapper">
            <span class="ag-group-expanded" ref="eExpanded"></span>
            <span class="ag-group-contracted" ref="eContracted"></span>
            <span class="ag-group-checkbox ag-invisible" ref="eCheckbox"></span>
            <span class="ag-group-value" ref="eValue"></span>
            <span class="ag-group-child-count" ref="eChildCount"></span>
        </span>`, ni([
      Y("eExpanded")
    ], t.prototype, "eExpanded", void 0), ni([
      Y("eContracted")
    ], t.prototype, "eContracted", void 0), ni([
      Y("eCheckbox")
    ], t.prototype, "eCheckbox", void 0), ni([
      Y("eValue")
    ], t.prototype, "eValue", void 0), ni([
      Y("eChildCount")
    ], t.prototype, "eChildCount", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var qw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Up = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Xw = (
  /** @class */
  function(i) {
    qw(t, i);
    function t() {
      return i.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      e.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }, t.prototype.setupFailed = function() {
      var e = this.localeService.getLocaleTextFunc();
      this.eLoadingText.innerText = e("loadingError", "ERR");
    }, t.prototype.setupLoading = function() {
      var e = ut("groupLoading", this.gridOptionsService, null);
      e && this.eLoadingIcon.appendChild(e);
      var r = this.localeService.getLocaleTextFunc();
      this.eLoadingText.innerText = r("loadingOoo", "Loading");
    }, t.prototype.refresh = function(e) {
      return !1;
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.TEMPLATE = `<div class="ag-loading">
            <span class="ag-loading-icon" ref="eLoadingIcon"></span>
            <span class="ag-loading-text" ref="eLoadingText"></span>
        </div>`, Up([
      Y("eLoadingIcon")
    ], t.prototype, "eLoadingIcon", void 0), Up([
      Y("eLoadingText")
    ], t.prototype, "eLoadingText", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Qw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Jw = (
  /** @class */
  function(i) {
    Qw(t, i);
    function t() {
      return i.call(this) || this;
    }
    return t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      var r, o = (r = this.gridOptionsService.get("overlayLoadingTemplate")) !== null && r !== void 0 ? r : t.DEFAULT_LOADING_OVERLAY_TEMPLATE, n = this.localeService.getLocaleTextFunc(), s = o.replace("[LOADING...]", n("loadingOoo", "Loading..."));
      this.setTemplate(s);
    }, t.DEFAULT_LOADING_OVERLAY_TEMPLATE = '<span class="ag-overlay-loading-center">[LOADING...]</span>', t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Zw = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), eS = (
  /** @class */
  function(i) {
    Zw(t, i);
    function t() {
      return i.call(this) || this;
    }
    return t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      var r, o = (r = this.gridOptionsService.get("overlayNoRowsTemplate")) !== null && r !== void 0 ? r : t.DEFAULT_NO_ROWS_TEMPLATE, n = this.localeService.getLocaleTextFunc(), s = o.replace("[NO_ROWS_TO_SHOW]", n("noRowsToShow", "No Rows To Show"));
      this.setTemplate(s);
    }, t.DEFAULT_NO_ROWS_TEMPLATE = '<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>', t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var tS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rS = (
  /** @class */
  function(i) {
    tS(t, i);
    function t() {
      return i.call(
        this,
        /* html */
        '<div class="ag-tooltip"></div>'
      ) || this;
    }
    return t.prototype.init = function(e) {
      var r = e.value;
      this.getGui().innerHTML = so(r);
    }, t;
  }(Xn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var oS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ml = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, nS = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, iS = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(nS(arguments[t]));
  return i;
}, Dh = (
  /** @class */
  function(i) {
    oS(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.agGridDefaults = {
        //date
        agDateInput: ww,
        //header
        agColumnHeader: Pw,
        agColumnGroupHeader: Aw,
        agSortIndicator: Ma,
        //floating filters
        agTextColumnFloatingFilter: _h,
        agNumberColumnFloatingFilter: Rw,
        agDateColumnFloatingFilter: yw,
        agReadOnlyFloatingFilter: qC,
        // renderers
        agAnimateShowChangeCellRenderer: Oh,
        agAnimateSlideCellRenderer: bh,
        agGroupCellRenderer: hu,
        agGroupRowRenderer: hu,
        agLoadingCellRenderer: Xw,
        //editors
        agCellEditor: fu,
        agTextCellEditor: fu,
        agSelectCellEditor: Rh,
        agLargeTextCellEditor: Eh,
        //filter
        agTextColumnFilter: Fa,
        agNumberColumnFilter: ac,
        agDateColumnFilter: sc,
        //overlays
        agLoadingOverlay: Jw,
        agNoRowsOverlay: eS,
        // tooltips
        agTooltipComponent: rS
      }, e.enterpriseAgDefaultCompsModule = {
        agSetColumnFilter: re.SetFilterModule,
        agSetColumnFloatingFilter: re.SetFilterModule,
        agMultiColumnFilter: re.MultiFilterModule,
        agMultiColumnFloatingFilter: re.MultiFilterModule,
        agGroupColumnFilter: re.RowGroupingModule,
        agGroupColumnFloatingFilter: re.RowGroupingModule,
        agRichSelect: re.RichSelectModule,
        agRichSelectCellEditor: re.RichSelectModule,
        agDetailCellRenderer: re.MasterDetailModule,
        agSparklineCellRenderer: re.SparklinesModule
      }, e.deprecatedAgGridDefaults = {
        agPopupTextCellEditor: 'AG Grid: Since v27.1 The agPopupTextCellEditor is deprecated. Instead use { cellEditor: "agTextCellEditor", cellEditorPopup: true }',
        agPopupSelectCellEditor: 'AG Grid: Since v27.1 the agPopupSelectCellEditor is deprecated. Instead use { cellEditor: "agSelectCellEditor", cellEditorPopup: true }'
      }, e.jsComps = {}, e.fwComps = {}, e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.gridOptions.components != null && Ke(this.gridOptions.components, function(r, o) {
        return e.registerJsComponent(r, o);
      }), this.gridOptions.frameworkComponents != null && Ke(this.gridOptions.frameworkComponents, function(r, o) {
        return e.registerFwComponent(r, o);
      });
    }, t.prototype.registerDefaultComponent = function(e, r) {
      if (this.agGridDefaults[e]) {
        console.error("Trying to overwrite a default component. You should call registerComponent");
        return;
      }
      this.agGridDefaults[e] = r;
    }, t.prototype.registerJsComponent = function(e, r) {
      if (this.fwComps[e]) {
        console.error("Trying to register a component that you have already registered for frameworks: " + e);
        return;
      }
      this.jsComps[e] = r;
    }, t.prototype.registerFwComponent = function(e, r) {
      var o = "AG Grid: As of v27, registering components via grid property frameworkComponents is deprecated. Instead register both JavaScript AND Framework Components via the components property.";
      Pe(function() {
        return console.warn(o);
      }, "UserComponentRegistry.frameworkComponentsDeprecated"), this.fwComps[e] = r;
    }, t.prototype.retrieve = function(e, r) {
      var o = this, n = function(d, h) {
        return { componentFromFramework: h, component: d };
      }, s = this.getFrameworkOverrides().frameworkComponent(r, this.gridOptions.components);
      if (s != null)
        return n(s, !0);
      var a = this.fwComps[r];
      if (a)
        return n(a, !0);
      var l = this.jsComps[r];
      if (l) {
        var u = this.getFrameworkOverrides().isFrameworkComponent(l);
        return n(l, u);
      }
      var c = this.agGridDefaults[r];
      if (c)
        return n(c, !1);
      var p = this.enterpriseAgDefaultCompsModule[r];
      return p ? pe.assertRegistered(p, "AG Grid '" + e + "' component: " + r) : this.deprecatedAgGridDefaults[r] ? Pe(function() {
        return console.warn(o.deprecatedAgGridDefaults[r]);
      }, r) : Pe(function() {
        o.warnAboutMissingComponent(e, r);
      }, "MissingComp" + r), null;
    }, t.prototype.warnAboutMissingComponent = function(e, r) {
      var o = iS(Object.keys(this.agGridDefaults).filter(function(s) {
        return !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(s);
      }), Object.keys(this.jsComps), Object.keys(this.fwComps)), n = Mu(r, o, !0, 0.8);
      console.warn("AG Grid: Could not find '" + r + `' component. It was configured as "` + e + ": '" + r + `'" but it wasn't found in the list of registered components.`), n.length > 0 && console.warn("         Did you mean: [" + n.slice(0, 3) + "]?"), console.warn("If using a custom component check it has been registered as described in: https://ag-grid.com/javascript-data-grid/components/");
    }, ml([
      v("gridOptions")
    ], t.prototype, "gridOptions", void 0), ml([
      U
    ], t.prototype, "init", null), t = ml([
      te("userComponentRegistry")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var sS = {
  propertyName: "dateComponent",
  cellRenderer: !1
}, aS = {
  propertyName: "headerComponent",
  cellRenderer: !1
}, lS = {
  propertyName: "headerGroupComponent",
  cellRenderer: !1
}, zp = {
  propertyName: "cellRenderer",
  cellRenderer: !0
}, uS = {
  propertyName: "cellEditor",
  cellRenderer: !1
}, $p = {
  propertyName: "innerRenderer",
  cellRenderer: !0
}, cS = {
  propertyName: "loadingOverlayComponent",
  cellRenderer: !1
}, pS = {
  propertyName: "noRowsOverlayComponent",
  cellRenderer: !1
}, dS = {
  propertyName: "tooltipComponent",
  cellRenderer: !1
}, vu = {
  propertyName: "filter",
  cellRenderer: !1
}, fS = {
  propertyName: "floatingFilterComponent",
  cellRenderer: !1
}, hS = {
  propertyName: "toolPanel",
  cellRenderer: !1
}, vS = {
  propertyName: "statusPanel",
  cellRenderer: !1
}, gS = {
  propertyName: "fullWidthCellRenderer",
  cellRenderer: !0
}, yS = {
  propertyName: "loadingCellRenderer",
  cellRenderer: !0
}, mS = {
  propertyName: "groupRowRenderer",
  cellRenderer: !0
}, CS = {
  propertyName: "detailCellRenderer",
  cellRenderer: !0
};
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ah = (
  /** @class */
  function() {
    function i() {
    }
    return i.getFloatingFilterType = function(t) {
      return this.filterToFloatingFilterMapping[t];
    }, i.filterToFloatingFilterMapping = {
      set: "agSetColumnFloatingFilter",
      agSetColumnFilter: "agSetColumnFloatingFilter",
      multi: "agMultiColumnFloatingFilter",
      agMultiColumnFilter: "agMultiColumnFloatingFilter",
      group: "agGroupColumnFloatingFilter",
      agGroupColumnFilter: "agGroupColumnFloatingFilter",
      number: "agNumberColumnFloatingFilter",
      agNumberColumnFilter: "agNumberColumnFloatingFilter",
      date: "agDateColumnFloatingFilter",
      agDateColumnFilter: "agDateColumnFloatingFilter",
      text: "agTextColumnFloatingFilter",
      agTextColumnFilter: "agTextColumnFloatingFilter"
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var wS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Fn = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, xh = (
  /** @class */
  function(i) {
    wS(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.getHeaderCompDetails = function(e, r) {
      return this.getCompDetails(e, aS, "agColumnHeader", r);
    }, t.prototype.getHeaderGroupCompDetails = function(e) {
      var r = e.columnGroup.getColGroupDef();
      return this.getCompDetails(r, lS, "agColumnGroupHeader", e);
    }, t.prototype.getFullWidthCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, gS, null, e, !0);
    }, t.prototype.getFullWidthLoadingCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, yS, "agLoadingCellRenderer", e, !0);
    }, t.prototype.getFullWidthGroupCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, mS, "agGroupRowRenderer", e, !0);
    }, t.prototype.getFullWidthDetailCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, CS, "agDetailCellRenderer", e, !0);
    }, t.prototype.getInnerRendererDetails = function(e, r) {
      return this.getCompDetails(e, $p, null, r);
    }, t.prototype.getFullWidthGroupRowInnerCellRenderer = function(e, r) {
      return this.getCompDetails(e, $p, null, r);
    }, t.prototype.getCellRendererDetails = function(e, r) {
      return this.getCompDetails(e, zp, null, r);
    }, t.prototype.getCellEditorDetails = function(e, r) {
      return this.getCompDetails(e, uS, "agCellEditor", r, !0);
    }, t.prototype.getFilterDetails = function(e, r, o) {
      return this.getCompDetails(e, vu, o, r, !0);
    }, t.prototype.getDateCompDetails = function(e) {
      return this.getCompDetails(this.gridOptions, sS, "agDateInput", e, !0);
    }, t.prototype.getLoadingOverlayCompDetails = function(e) {
      return this.getCompDetails(this.gridOptions, cS, "agLoadingOverlay", e, !0);
    }, t.prototype.getNoRowsOverlayCompDetails = function(e) {
      return this.getCompDetails(this.gridOptions, pS, "agNoRowsOverlay", e, !0);
    }, t.prototype.getTooltipCompDetails = function(e) {
      return this.getCompDetails(e.colDef, dS, "agTooltipComponent", e, !0);
    }, t.prototype.getSetFilterCellRendererDetails = function(e, r) {
      return this.getCompDetails(e, zp, null, r);
    }, t.prototype.getFloatingFilterCompDetails = function(e, r, o) {
      return this.getCompDetails(e, fS, o, r);
    }, t.prototype.getToolPanelCompDetails = function(e, r) {
      return this.getCompDetails(e, hS, null, r, !0);
    }, t.prototype.getStatusPanelCompDetails = function(e, r) {
      return this.getCompDetails(e, vS, null, r, !0);
    }, t.prototype.getCompDetails = function(e, r, o, n, s) {
      var a = this;
      s === void 0 && (s = !1);
      var l = r.propertyName, u = r.cellRenderer, c = this.getCompKeys(e, r, n), p = c.compName, d = c.jsComp, h = c.fwComp, g = c.paramsFromSelector, y = c.popupFromSelector, S = c.popupPositionFromSelector, _ = function(D) {
        var B = a.userComponentRegistry.retrieve(l, D);
        B && (d = B.componentFromFramework ? void 0 : B.component, h = B.componentFromFramework ? B.component : void 0);
      };
      if (p != null && _(p), d == null && h == null && o != null && _(o), d && u && !this.agComponentUtils.doesImplementIComponent(d) && (d = this.agComponentUtils.adaptFunction(l, d)), !d && !h) {
        s && console.error("AG Grid: Could not find component " + p + ", did you forget to configure this component?");
        return;
      }
      var w = this.mergeParamsWithApplicationProvidedParams(e, r, n, g), E = d == null, R = d || h;
      return {
        componentFromFramework: E,
        componentClass: R,
        params: w,
        type: r,
        popupFromSelector: y,
        popupPositionFromSelector: S,
        newAgStackInstance: function() {
          return a.newAgStackInstance(R, E, w, r);
        }
      };
    }, t.prototype.getCompKeys = function(e, r, o) {
      var n = this, s = r.propertyName, a, l, u, c, p, d;
      if (e) {
        var h = e, g = h[s + "Selector"], y = g ? g(o) : null, S = function(w, E) {
          var R = function() {
            var B = "AG Grid: As of v27, the property " + s + "Framework is deprecated. The property " + s + " can now be used for JavaScript AND Framework Components.";
            Pe(function() {
              return console.warn(B);
            }, "UserComponentFactory." + s + "FrameworkDeprecated");
          };
          if (typeof w == "string")
            a = w;
          else if (typeof E == "string")
            R(), a = E;
          else if (w != null && w !== !0) {
            var D = n.getFrameworkOverrides().isFrameworkComponent(w);
            D ? u = w : l = w;
          } else
            E != null && (R(), u = E);
        };
        if (y) {
          if (y.frameworkComponent != null) {
            var _ = "AG Grid: As of v27, the return for " + s + "Selector has attributes [component, params] only. The attribute frameworkComponent is deprecated. You should now return back Framework Components using the 'component' attribute and the grid works out if it's a framework component or not.";
            Pe(function() {
              return console.warn(_);
            }, "UserComponentFactory." + s + "FrameworkSelectorDeprecated"), S(y.frameworkComponent, void 0);
          } else
            S(y.component, void 0);
          c = y.params, p = y.popup, d = y.popupPosition;
        } else
          S(h[s], h[s + "Framework"]);
      }
      return { compName: a, jsComp: l, fwComp: u, paramsFromSelector: c, popupFromSelector: p, popupPositionFromSelector: d };
    }, t.prototype.newAgStackInstance = function(e, r, o, n) {
      var s = n.propertyName, a = !r, l;
      if (a)
        l = new e();
      else {
        var u = this.componentMetadataProvider.retrieve(s);
        l = this.frameworkComponentWrapper.wrap(e, u.mandatoryMethodList, u.optionalMethodList, n);
      }
      var c = this.initComponent(l, o);
      return c == null ? nr.resolve(l) : c.then(function() {
        return l;
      });
    }, t.prototype.mergeParamsWithApplicationProvidedParams = function(e, r, o, n) {
      n === void 0 && (n = null);
      var s = {
        context: this.gridOptionsService.context,
        columnApi: this.gridOptionsService.columnApi,
        api: this.gridOptionsService.api
      };
      ir(s, o);
      var a = e, l = a && a[r.propertyName + "Params"];
      if (typeof l == "function") {
        var u = l(o);
        ir(s, u);
      } else
        typeof l == "object" && ir(s, l);
      return ir(s, n), s;
    }, t.prototype.initComponent = function(e, r) {
      if (this.context.createBean(e), e.init != null)
        return e.init(r);
    }, t.prototype.getDefaultFloatingFilterType = function(e) {
      if (e == null)
        return null;
      var r = null, o = this.getCompKeys(e, vu), n = o.compName, s = o.jsComp, a = o.fwComp;
      if (n)
        r = Ah.getFloatingFilterType(n);
      else {
        var l = s == null && a == null && e.filter === !0;
        if (l) {
          var u = pe.isRegistered(re.SetFilterModule);
          r = u ? "agSetColumnFloatingFilter" : "agTextColumnFloatingFilter";
        }
      }
      return r;
    }, Fn([
      v("gridOptions")
    ], t.prototype, "gridOptions", void 0), Fn([
      v("agComponentUtils")
    ], t.prototype, "agComponentUtils", void 0), Fn([
      v("componentMetadataProvider")
    ], t.prototype, "componentMetadataProvider", void 0), Fn([
      v("userComponentRegistry")
    ], t.prototype, "userComponentRegistry", void 0), Fn([
      Fe("frameworkComponentWrapper")
    ], t.prototype, "frameworkComponentWrapper", void 0), t = Fn([
      te("userComponentFactory")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Li;
(function(i) {
  i[i.SINGLE_SHEET = 0] = "SINGLE_SHEET", i[i.MULTI_SHEET = 1] = "MULTI_SHEET";
})(Li || (Li = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var SS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Fh = (
  /** @class */
  function(i) {
    SS(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.dragEndFunctions = [], e.dragSources = [], e;
    }
    return t.prototype.removeAllListeners = function() {
      this.dragSources.forEach(this.removeListener.bind(this)), this.dragSources.length = 0;
    }, t.prototype.removeListener = function(e) {
      var r = e.dragSource.eElement, o = e.mouseDownListener;
      if (r.removeEventListener("mousedown", o), e.touchEnabled) {
        var n = e.touchStartListener;
        r.removeEventListener("touchstart", n, { passive: !0 });
      }
    }, t.prototype.removeDragSource = function(e) {
      var r = this.dragSources.find(function(o) {
        return o.dragSource === e;
      });
      r && (this.removeListener(r), Vt(this.dragSources, r));
    }, t.prototype.isDragging = function() {
      return this.dragging;
    }, t.prototype.addDragSource = function(e, r) {
      var o = this;
      r === void 0 && (r = !1);
      var n = this.onMouseDown.bind(this, e);
      e.eElement.addEventListener("mousedown", n);
      var s = null, a = this.gridOptionsService.is("suppressTouch");
      r && !a && (s = function(l) {
        Ku(l.target) || (l.cancelable && (l.preventDefault(), l.stopPropagation()), o.onTouchStart(e, l));
      }, e.eElement.addEventListener("touchstart", s, { passive: !1 })), this.dragSources.push({
        dragSource: e,
        mouseDownListener: n,
        touchStartListener: s,
        touchEnabled: r
      });
    }, t.prototype.getStartTarget = function() {
      return this.startTarget;
    }, t.prototype.onTouchStart = function(e, r) {
      var o = this;
      this.currentDragParams = e, this.dragging = !1;
      var n = r.touches[0];
      this.touchLastTime = n, this.touchStart = n;
      var s = function(p) {
        return o.onTouchMove(p, e.eElement);
      }, a = function(p) {
        return o.onTouchUp(p, e.eElement);
      }, l = function(p) {
        p.cancelable && p.preventDefault();
      }, u = r.target, c = [
        // Prevents the page document from moving while we are dragging items around.
        // preventDefault needs to be called in the touchmove listener and never inside the
        // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
        { target: this.gridOptionsService.getRootNode(), type: "touchmove", listener: l, options: { passive: !1 } },
        { target: u, type: "touchmove", listener: s, options: { passive: !0 } },
        { target: u, type: "touchend", listener: a, options: { passive: !0 } },
        { target: u, type: "touchcancel", listener: a, options: { passive: !0 } }
      ];
      this.addTemporaryEvents(c), e.dragStartPixels === 0 && this.onCommonMove(n, this.touchStart, e.eElement);
    }, t.prototype.onMouseDown = function(e, r) {
      var o = this, n = r;
      if (!(e.skipMouseEvent && e.skipMouseEvent(r)) && !n._alreadyProcessedByDragService && (n._alreadyProcessedByDragService = !0, r.button === 0)) {
        this.currentDragParams = e, this.dragging = !1, this.mouseStartEvent = r, this.startTarget = r.target;
        var s = function(p) {
          return o.onMouseMove(p, e.eElement);
        }, a = function(p) {
          return o.onMouseUp(p, e.eElement);
        }, l = function(p) {
          return p.preventDefault();
        }, u = this.gridOptionsService.getRootNode(), c = [
          { target: u, type: "mousemove", listener: s },
          { target: u, type: "mouseup", listener: a },
          { target: u, type: "contextmenu", listener: l }
        ];
        this.addTemporaryEvents(c), e.dragStartPixels === 0 && this.onMouseMove(r, e.eElement);
      }
    }, t.prototype.addTemporaryEvents = function(e) {
      e.forEach(function(r) {
        var o = r.target, n = r.type, s = r.listener, a = r.options;
        o.addEventListener(n, s, a);
      }), this.dragEndFunctions.push(function() {
        e.forEach(function(r) {
          var o = r.target, n = r.type, s = r.listener, a = r.options;
          o.removeEventListener(n, s, a);
        });
      });
    }, t.prototype.isEventNearStartEvent = function(e, r) {
      var o = this.currentDragParams.dragStartPixels, n = k(o) ? o : 4;
      return ec(e, r, n);
    }, t.prototype.getFirstActiveTouch = function(e) {
      for (var r = 0; r < e.length; r++)
        if (e[r].identifier === this.touchStart.identifier)
          return e[r];
      return null;
    }, t.prototype.onCommonMove = function(e, r, o) {
      if (!this.dragging) {
        if (!this.dragging && this.isEventNearStartEvent(e, r))
          return;
        this.dragging = !0;
        var n = {
          type: m.EVENT_DRAG_STARTED,
          target: o
        };
        this.eventService.dispatchEvent(n), this.currentDragParams.onDragStart(r), this.currentDragParams.onDragging(r);
      }
      this.currentDragParams.onDragging(e);
    }, t.prototype.onTouchMove = function(e, r) {
      var o = this.getFirstActiveTouch(e.touches);
      o && this.onCommonMove(o, this.touchStart, r);
    }, t.prototype.onMouseMove = function(e, r) {
      (this.gridOptionsService.is("enableCellTextSelection") || ao()) && // The event type can be `mousedown` when `dragStartPixels=0`
      // we should only preventDefault on `mousemove`.
      e.type === "mousemove" && e.cancelable && this.mouseEventService.isEventFromThisGrid(e) && // we should not prevent mouseMove when above a form field
      // as that would prevent the text in the field from being selected
      !this.isOverFormFieldElement(e) && e.preventDefault(), this.onCommonMove(e, this.mouseStartEvent, r);
    }, t.prototype.isOverFormFieldElement = function(e) {
      var r = e.target, o = r == null ? void 0 : r.tagName.toLocaleLowerCase();
      return !!(o != null && o.match("^a$|textarea|input|select|button"));
    }, t.prototype.onTouchUp = function(e, r) {
      var o = this.getFirstActiveTouch(e.changedTouches);
      o || (o = this.touchLastTime), this.onUpCommon(o, r);
    }, t.prototype.onMouseUp = function(e, r) {
      this.onUpCommon(e, r);
    }, t.prototype.onUpCommon = function(e, r) {
      if (this.dragging) {
        this.dragging = !1, this.currentDragParams.onDragStop(e);
        var o = {
          type: m.EVENT_DRAG_STOPPED,
          target: r
        };
        this.eventService.dispatchEvent(o);
      }
      this.mouseStartEvent = null, this.startTarget = null, this.touchStart = null, this.touchLastTime = null, this.currentDragParams = null, this.dragEndFunctions.forEach(function(n) {
        return n();
      }), this.dragEndFunctions.length = 0;
    }, Cl([
      v("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), Cl([
      At
    ], t.prototype, "removeAllListeners", null), t = Cl([
      te("dragService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var no;
(function(i) {
  i[i.Above = 0] = "Above", i[i.Below = 1] = "Below";
})(no || (no = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var xe;
(function(i) {
  i.EVERYTHING = "group", i.FILTER = "filter", i.SORT = "sort", i.MAP = "map", i.AGGREGATE = "aggregate", i.FILTER_AGGREGATES = "filter_aggregates", i.PIVOT = "pivot", i.NOTHING = "nothing";
})(xe || (xe = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ae = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
};
function on(i) {
  var t = i, e = t != null && t.getFrameworkComponentInstance != null;
  return e ? t.getFrameworkComponentInstance() : i;
}
var Mh = (
  /** @class */
  function() {
    function i() {
      this.detailGridInfoMap = {}, this.destroyCalled = !1;
    }
    return i.prototype.registerOverlayWrapperComp = function(t) {
      this.overlayWrapperComp = t;
    }, i.prototype.registerSideBarComp = function(t) {
      this.sideBarComp = t;
    }, i.prototype.init = function() {
      var t = this;
      switch (this.rowModel.getType()) {
        case "clientSide":
          this.clientSideRowModel = this.rowModel;
          break;
        case "infinite":
          this.infiniteRowModel = this.rowModel;
          break;
        case "serverSide":
          this.serverSideRowModel = this.rowModel;
          break;
      }
      this.ctrlsService.whenReady(function() {
        t.gridBodyCtrl = t.ctrlsService.getGridBodyCtrl();
      });
    }, i.prototype.__getAlignedGridService = function() {
      return this.alignedGridsService;
    }, i.prototype.__getContext = function() {
      return this.context;
    }, i.prototype.getSetterMethod = function(t) {
      return "set" + t.charAt(0).toUpperCase() + t.substring(1);
    }, i.prototype.__setProperty = function(t, e) {
      this.gridOptionsService.set(t, e);
      var r = this.getSetterMethod(t), o = this;
      o[r] && o[r](e);
    }, i.prototype.addDetailGridInfo = function(t, e) {
      this.detailGridInfoMap[t] = e;
    }, i.prototype.removeDetailGridInfo = function(t) {
      this.detailGridInfoMap[t] = void 0;
    }, i.prototype.getDetailGridInfo = function(t) {
      return this.detailGridInfoMap[t];
    }, i.prototype.forEachDetailGridInfo = function(t) {
      var e = 0;
      Ke(this.detailGridInfoMap, function(r, o) {
        k(o) && (t(o, e), e++);
      });
    }, i.prototype.getDataAsCsv = function(t) {
      if (pe.assertRegistered(re.CsvExportModule, "api.getDataAsCsv"))
        return this.csvCreator.getDataAsCsv(t);
    }, i.prototype.exportDataAsCsv = function(t) {
      pe.assertRegistered(re.CsvExportModule, "api.exportDataAsCSv") && this.csvCreator.exportDataAsCsv(t);
    }, i.prototype.getExcelExportMode = function(t) {
      var e = this.gridOptionsService.get("defaultExcelExportParams"), r = Object.assign({ exportMode: "xlsx" }, e, t);
      return r.exportMode;
    }, i.prototype.assertNotExcelMultiSheet = function(t, e) {
      if (!pe.assertRegistered(re.ExcelExportModule, "api." + t))
        return !1;
      var r = this.getExcelExportMode(e);
      return this.excelCreator.getFactoryMode(r) === Li.MULTI_SHEET ? (console.warn("AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'"), !1) : !0;
    }, i.prototype.getDataAsExcel = function(t) {
      if (this.assertNotExcelMultiSheet("getDataAsExcel", t))
        return this.excelCreator.getDataAsExcel(t);
    }, i.prototype.exportDataAsExcel = function(t) {
      this.assertNotExcelMultiSheet("exportDataAsExcel", t) && this.excelCreator.exportDataAsExcel(t);
    }, i.prototype.getSheetDataForExcel = function(t) {
      if (pe.assertRegistered(re.ExcelExportModule, "api.getSheetDataForExcel")) {
        var e = this.getExcelExportMode(t);
        return this.excelCreator.setFactoryMode(Li.MULTI_SHEET, e), this.excelCreator.getSheetDataForExcel(t);
      }
    }, i.prototype.getMultipleSheetsAsExcel = function(t) {
      if (pe.assertRegistered(re.ExcelExportModule, "api.getMultipleSheetsAsExcel"))
        return this.excelCreator.getMultipleSheetsAsExcel(t);
    }, i.prototype.exportMultipleSheetsAsExcel = function(t) {
      if (pe.assertRegistered(re.ExcelExportModule, "api.exportMultipleSheetsAsExcel"))
        return this.excelCreator.exportMultipleSheetsAsExcel(t);
    }, i.prototype.setGridAriaProperty = function(t, e) {
      if (t) {
        var r = this.ctrlsService.getGridBodyCtrl().getGui(), o = "aria-" + t;
        e === null ? r.removeAttribute(o) : r.setAttribute(o, e);
      }
    }, i.prototype.logMissingRowModel = function(t) {
      for (var e = [], r = 1; r < arguments.length; r++)
        e[r - 1] = arguments[r];
      console.error("AG Grid: api." + t + " can only be called when gridOptions.rowModelType is " + e.join(" or "));
    }, i.prototype.setServerSideDatasource = function(t) {
      this.serverSideRowModel ? this.serverSideRowModel.setDatasource(t) : this.logMissingRowModel("setServerSideDatasource", "serverSide");
    }, i.prototype.setCacheBlockSize = function(t) {
      this.serverSideRowModel ? (this.gridOptionsService.set("cacheBlockSize", t), this.serverSideRowModel.resetRootStore()) : this.logMissingRowModel("setCacheBlockSize", "serverSide");
    }, i.prototype.setDatasource = function(t) {
      this.gridOptionsService.isRowModelType("infinite") ? this.rowModel.setDatasource(t) : this.logMissingRowModel("setDatasource", "infinite");
    }, i.prototype.setViewportDatasource = function(t) {
      this.gridOptionsService.isRowModelType("viewport") ? this.rowModel.setViewportDatasource(t) : this.logMissingRowModel("setViewportDatasource", "viewport");
    }, i.prototype.setRowData = function(t) {
      var e = this.immutableService == null;
      if (e) {
        this.logMissingRowModel("setRowData", "clientSide");
        return;
      }
      this.immutableService.isActive() ? this.immutableService.setRowData(t) : (this.selectionService.reset(), this.clientSideRowModel.setRowData(t));
    }, i.prototype.setPinnedTopRowData = function(t) {
      this.pinnedRowModel.setPinnedTopRowData(t);
    }, i.prototype.setPinnedBottomRowData = function(t) {
      this.pinnedRowModel.setPinnedBottomRowData(t);
    }, i.prototype.getPinnedTopRowCount = function() {
      return this.pinnedRowModel.getPinnedTopRowCount();
    }, i.prototype.getPinnedBottomRowCount = function() {
      return this.pinnedRowModel.getPinnedBottomRowCount();
    }, i.prototype.getPinnedTopRow = function(t) {
      return this.pinnedRowModel.getPinnedTopRow(t);
    }, i.prototype.getPinnedBottomRow = function(t) {
      return this.pinnedRowModel.getPinnedBottomRow(t);
    }, i.prototype.setColumnDefs = function(t, e) {
      e === void 0 && (e = "api"), this.columnModel.setColumnDefs(t, e), this.gridOptionsService.set("columnDefs", t, !0, { source: e });
    }, i.prototype.setAutoGroupColumnDef = function(t, e) {
      e === void 0 && (e = "api"), this.gridOptionsService.set("autoGroupColumnDef", t, !0, { source: e });
    }, i.prototype.setDefaultColDef = function(t, e) {
      e === void 0 && (e = "api"), this.gridOptionsService.set("defaultColDef", t, !0, { source: e });
    }, i.prototype.setColumnTypes = function(t, e) {
      e === void 0 && (e = "api"), this.gridOptionsService.set("columnTypes", t, !0, { source: e });
    }, i.prototype.expireValueCache = function() {
      this.valueCache.expire();
    }, i.prototype.getVerticalPixelRange = function() {
      return this.gridBodyCtrl.getScrollFeature().getVScrollPosition();
    }, i.prototype.getHorizontalPixelRange = function() {
      return this.gridBodyCtrl.getScrollFeature().getHScrollPosition();
    }, i.prototype.setAlwaysShowHorizontalScroll = function(t) {
      this.gridOptionsService.set("alwaysShowHorizontalScroll", t);
    }, i.prototype.setAlwaysShowVerticalScroll = function(t) {
      this.gridOptionsService.set("alwaysShowVerticalScroll", t);
    }, i.prototype.refreshCells = function(t) {
      t === void 0 && (t = {}), this.rowRenderer.refreshCells(t);
    }, i.prototype.flashCells = function(t) {
      t === void 0 && (t = {}), this.rowRenderer.flashCells(t);
    }, i.prototype.redrawRows = function(t) {
      t === void 0 && (t = {});
      var e = t ? t.rowNodes : void 0;
      this.rowRenderer.redrawRows(e);
    }, i.prototype.setFunctionsReadOnly = function(t) {
      this.gridOptionsService.set("functionsReadOnly", t);
    }, i.prototype.refreshHeader = function() {
      this.ctrlsService.getHeaderRowContainerCtrls().forEach(function(t) {
        return t.refresh();
      });
    }, i.prototype.isAnyFilterPresent = function() {
      return this.filterManager.isAnyFilterPresent();
    }, i.prototype.isColumnFilterPresent = function() {
      return this.filterManager.isColumnFilterPresent() || this.filterManager.isAggregateFilterPresent();
    }, i.prototype.isQuickFilterPresent = function() {
      return this.filterManager.isQuickFilterPresent();
    }, i.prototype.getModel = function() {
      return this.rowModel;
    }, i.prototype.setRowNodeExpanded = function(t, e, r) {
      t && (r && t.parent && t.parent.level !== -1 && this.setRowNodeExpanded(t.parent, e, r), t.setExpanded(e));
    }, i.prototype.onGroupExpandedOrCollapsed = function() {
      if (ue(this.clientSideRowModel)) {
        this.logMissingRowModel("onGroupExpandedOrCollapsed", "clientSide");
        return;
      }
      this.clientSideRowModel.refreshModel({ step: xe.MAP });
    }, i.prototype.refreshClientSideRowModel = function(t) {
      if (ue(this.clientSideRowModel)) {
        this.logMissingRowModel("refreshClientSideRowModel", "clientSide");
        return;
      }
      this.clientSideRowModel.refreshModel(t);
    }, i.prototype.isAnimationFrameQueueEmpty = function() {
      return this.animationFrameService.isQueueEmpty();
    }, i.prototype.flushAllAnimationFrames = function() {
      this.animationFrameService.flushAllFrames();
    }, i.prototype.getRowNode = function(t) {
      return this.rowModel.getRowNode(t);
    }, i.prototype.getSizesForCurrentTheme = function() {
      return {
        rowHeight: this.gridOptionsService.getRowHeightAsNumber(),
        headerHeight: this.columnModel.getHeaderHeight()
      };
    }, i.prototype.expandAll = function() {
      this.clientSideRowModel ? this.clientSideRowModel.expandOrCollapseAll(!0) : this.serverSideRowModel ? this.serverSideRowModel.expandAll(!0) : this.logMissingRowModel("expandAll", "clientSide", "serverSide");
    }, i.prototype.collapseAll = function() {
      this.clientSideRowModel ? this.clientSideRowModel.expandOrCollapseAll(!1) : this.serverSideRowModel ? this.serverSideRowModel.expandAll(!1) : this.logMissingRowModel("expandAll", "clientSide", "serverSide");
    }, i.prototype.addRenderedRowListener = function(t, e, r) {
      this.rowRenderer.addRenderedRowListener(t, e, r);
    }, i.prototype.getQuickFilter = function() {
      return this.gridOptionsService.get("quickFilterText");
    }, i.prototype.setQuickFilter = function(t) {
      this.gridOptionsService.set("quickFilterText", t);
    }, i.prototype.setExcludeHiddenColumnsFromQuickFilter = function(t) {
      this.gridOptionsService.set("excludeHiddenColumnsFromQuickFilter", t);
    }, i.prototype.selectAll = function(t) {
      t === void 0 && (t = "apiSelectAll"), this.selectionService.selectAllRowNodes({ source: t });
    }, i.prototype.deselectAll = function(t) {
      t === void 0 && (t = "apiSelectAll"), this.selectionService.deselectAllRowNodes({ source: t });
    }, i.prototype.selectAllFiltered = function(t) {
      t === void 0 && (t = "apiSelectAllFiltered"), this.selectionService.selectAllRowNodes({ source: t, justFiltered: !0 });
    }, i.prototype.deselectAllFiltered = function(t) {
      t === void 0 && (t = "apiSelectAllFiltered"), this.selectionService.deselectAllRowNodes({ source: t, justFiltered: !0 });
    }, i.prototype.getServerSideSelectionState = function() {
      return ue(this.serverSideRowModel) ? (this.logMissingRowModel("getServerSideSelectionState", "serverSide"), null) : this.selectionService.getServerSideSelectionState();
    }, i.prototype.setServerSideSelectionState = function(t) {
      if (ue(this.serverSideRowModel)) {
        this.logMissingRowModel("setServerSideSelectionState", "serverSide");
        return;
      }
      this.selectionService.setServerSideSelectionState(t);
    }, i.prototype.selectAllOnCurrentPage = function(t) {
      t === void 0 && (t = "apiSelectAllCurrentPage"), this.selectionService.selectAllRowNodes({ source: t, justCurrentPage: !0 });
    }, i.prototype.deselectAllOnCurrentPage = function(t) {
      t === void 0 && (t = "apiSelectAllCurrentPage"), this.selectionService.deselectAllRowNodes({ source: t, justCurrentPage: !0 });
    }, i.prototype.sizeColumnsToFit = function(t) {
      this.gridBodyCtrl.sizeColumnsToFit(t);
    }, i.prototype.showLoadingOverlay = function() {
      this.overlayWrapperComp.showLoadingOverlay();
    }, i.prototype.showNoRowsOverlay = function() {
      this.overlayWrapperComp.showNoRowsOverlay();
    }, i.prototype.hideOverlay = function() {
      this.overlayWrapperComp.hideOverlay();
    }, i.prototype.getSelectedNodes = function() {
      return this.selectionService.getSelectedNodes();
    }, i.prototype.getSelectedRows = function() {
      return this.selectionService.getSelectedRows();
    }, i.prototype.getBestCostNodeSelection = function() {
      if (ue(this.clientSideRowModel)) {
        this.logMissingRowModel("getBestCostNodeSelection", "clientSide");
        return;
      }
      return this.selectionService.getBestCostNodeSelection();
    }, i.prototype.getRenderedNodes = function() {
      return this.rowRenderer.getRenderedNodes();
    }, i.prototype.ensureColumnVisible = function(t, e) {
      e === void 0 && (e = "auto"), this.gridBodyCtrl.getScrollFeature().ensureColumnVisible(t, e);
    }, i.prototype.ensureIndexVisible = function(t, e) {
      this.gridBodyCtrl.getScrollFeature().ensureIndexVisible(t, e);
    }, i.prototype.ensureNodeVisible = function(t, e) {
      e === void 0 && (e = null), this.gridBodyCtrl.getScrollFeature().ensureNodeVisible(t, e);
    }, i.prototype.forEachLeafNode = function(t) {
      if (ue(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachLeafNode", "clientSide");
        return;
      }
      this.clientSideRowModel.forEachLeafNode(t);
    }, i.prototype.forEachNode = function(t, e) {
      this.rowModel.forEachNode(t, e);
    }, i.prototype.forEachNodeAfterFilter = function(t) {
      if (ue(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachNodeAfterFilter", "clientSide");
        return;
      }
      this.clientSideRowModel.forEachNodeAfterFilter(t);
    }, i.prototype.forEachNodeAfterFilterAndSort = function(t) {
      if (ue(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachNodeAfterFilterAndSort", "clientSide");
        return;
      }
      this.clientSideRowModel.forEachNodeAfterFilterAndSort(t);
    }, i.prototype.getFilterInstance = function(t, e) {
      var r = this.getFilterInstanceImpl(t, function(n) {
        if (e) {
          var s = on(n);
          e(s);
        }
      }), o = on(r);
      return o;
    }, i.prototype.getFilterInstanceImpl = function(t, e) {
      var r = this.columnModel.getPrimaryColumn(t);
      if (r) {
        var o = this.filterManager.getFilterComponent(r, "NO_UI"), n = o && o.resolveNow(null, function(s) {
          return s;
        });
        return n ? setTimeout(e, 0, n) : o && o.then(function(s) {
          e(s);
        }), n;
      }
    }, i.prototype.destroyFilter = function(t) {
      var e = this.columnModel.getPrimaryColumn(t);
      if (e)
        return this.filterManager.destroyFilter(e, "api");
    }, i.prototype.getStatusPanel = function(t) {
      if (pe.assertRegistered(re.StatusBarModule, "api.getStatusPanel")) {
        var e = this.statusBarService.getStatusPanel(t);
        return on(e);
      }
    }, i.prototype.getColumnDef = function(t) {
      var e = this.columnModel.getPrimaryColumn(t);
      return e ? e.getColDef() : null;
    }, i.prototype.getColumnDefs = function() {
      return this.columnModel.getColumnDefs();
    }, i.prototype.onFilterChanged = function() {
      this.filterManager.onFilterChanged();
    }, i.prototype.onSortChanged = function() {
      this.sortController.onSortChanged("api");
    }, i.prototype.setFilterModel = function(t) {
      this.filterManager.setFilterModel(t);
    }, i.prototype.getFilterModel = function() {
      return this.filterManager.getFilterModel();
    }, i.prototype.getFocusedCell = function() {
      return this.focusService.getFocusedCell();
    }, i.prototype.clearFocusedCell = function() {
      return this.focusService.clearFocusedCell();
    }, i.prototype.setFocusedCell = function(t, e, r) {
      this.focusService.setFocusedCell({ rowIndex: t, column: e, rowPinned: r, forceBrowserFocus: !0 });
    }, i.prototype.setSuppressRowDrag = function(t) {
      this.gridOptionsService.set("suppressRowDrag", t);
    }, i.prototype.setSuppressMoveWhenRowDragging = function(t) {
      this.gridOptionsService.set("suppressMoveWhenRowDragging", t);
    }, i.prototype.setSuppressRowClickSelection = function(t) {
      this.gridOptionsService.set("suppressRowClickSelection", t);
    }, i.prototype.addRowDropZone = function(t) {
      this.gridBodyCtrl.getRowDragFeature().addRowDropZone(t);
    }, i.prototype.removeRowDropZone = function(t) {
      var e = this.dragAndDropService.findExternalZone(t);
      e && this.dragAndDropService.removeDropTarget(e);
    }, i.prototype.getRowDropZoneParams = function(t) {
      return this.gridBodyCtrl.getRowDragFeature().getRowDropZone(t);
    }, i.prototype.setHeaderHeight = function(t) {
      this.gridOptionsService.set("headerHeight", t);
    }, i.prototype.setDomLayout = function(t) {
      if (!this.clientSideRowModel && t === "autoHeight" && !this.gridOptionsService.is("pagination")) {
        console.error("AG Grid: domLayout can only be set to 'autoHeight' when using the client side row model or when using pagination.");
        return;
      }
      this.gridOptionsService.set("domLayout", t);
    }, i.prototype.setEnableCellTextSelection = function(t) {
      this.gridBodyCtrl.setCellTextSelection(t);
    }, i.prototype.setFillHandleDirection = function(t) {
      this.gridOptionsService.set("fillHandleDirection", t);
    }, i.prototype.setGroupHeaderHeight = function(t) {
      this.gridOptionsService.set("groupHeaderHeight", t);
    }, i.prototype.setFloatingFiltersHeight = function(t) {
      this.gridOptionsService.set("floatingFiltersHeight", t);
    }, i.prototype.setPivotHeaderHeight = function(t) {
      this.gridOptionsService.set("pivotHeaderHeight", t);
    }, i.prototype.setPivotGroupHeaderHeight = function(t) {
      this.gridOptionsService.set("pivotGroupHeaderHeight", t);
    }, i.prototype.setPivotMode = function(t) {
      this.columnModel.setPivotMode(t);
    }, i.prototype.setAnimateRows = function(t) {
      this.gridOptionsService.set("animateRows", t);
    }, i.prototype.setIsExternalFilterPresent = function(t) {
      this.gridOptionsService.set("isExternalFilterPresent", t);
    }, i.prototype.setDoesExternalFilterPass = function(t) {
      this.gridOptionsService.set("doesExternalFilterPass", t);
    }, i.prototype.setNavigateToNextCell = function(t) {
      this.gridOptionsService.set("navigateToNextCell", t);
    }, i.prototype.setTabToNextCell = function(t) {
      this.gridOptionsService.set("tabToNextCell", t);
    }, i.prototype.setTabToNextHeader = function(t) {
      this.gridOptionsService.set("tabToNextHeader", t);
    }, i.prototype.setNavigateToNextHeader = function(t) {
      this.gridOptionsService.set("navigateToNextHeader", t);
    }, i.prototype.setRowGroupPanelShow = function(t) {
      this.gridOptionsService.set("rowGroupPanelShow", t);
    }, i.prototype.setGroupRowAggNodes = function(t) {
      bt("27.2", "setGroupRowAggNodes", "setGetGroupRowAgg"), this.gridOptionsService.set("groupRowAggNodes", t);
    }, i.prototype.setGetGroupRowAgg = function(t) {
      this.gridOptionsService.set("getGroupRowAgg", t);
    }, i.prototype.setGetBusinessKeyForNode = function(t) {
      this.gridOptionsService.set("getBusinessKeyForNode", t);
    }, i.prototype.setGetChildCount = function(t) {
      this.gridOptionsService.set("getChildCount", t);
    }, i.prototype.setProcessRowPostCreate = function(t) {
      this.gridOptionsService.set("processRowPostCreate", t);
    }, i.prototype.setGetRowNodeId = function(t) {
      bt("27.1", "setGetRowNodeId", "setGetRowId"), this.gridOptionsService.set("getRowNodeId", t);
    }, i.prototype.setGetRowId = function(t) {
      this.gridOptionsService.set("getRowId", t);
    }, i.prototype.setGetRowClass = function(t) {
      this.gridOptionsService.set("getRowClass", t);
    }, i.prototype.setIsFullWidthCell = function(t) {
      bt("27.2", "setIsFullWidthCell", "setIsFullWidthRow"), this.gridOptionsService.set("isFullWidthCell", t);
    }, i.prototype.setIsFullWidthRow = function(t) {
      this.gridOptionsService.set("isFullWidthRow", t);
    }, i.prototype.setIsRowSelectable = function(t) {
      this.gridOptionsService.set("isRowSelectable", t);
    }, i.prototype.setIsRowMaster = function(t) {
      this.gridOptionsService.set("isRowMaster", t);
    }, i.prototype.setPostSort = function(t) {
      bt("27.2", "setPostSort", "setPostSortRows"), this.gridOptionsService.set("postSort", t);
    }, i.prototype.setPostSortRows = function(t) {
      this.gridOptionsService.set("postSortRows", t);
    }, i.prototype.setGetDocument = function(t) {
      this.gridOptionsService.set("getDocument", t);
    }, i.prototype.setGetContextMenuItems = function(t) {
      this.gridOptionsService.set("getContextMenuItems", t);
    }, i.prototype.setGetMainMenuItems = function(t) {
      this.gridOptionsService.set("getMainMenuItems", t);
    }, i.prototype.setProcessCellForClipboard = function(t) {
      this.gridOptionsService.set("processCellForClipboard", t);
    }, i.prototype.setSendToClipboard = function(t) {
      this.gridOptionsService.set("sendToClipboard", t);
    }, i.prototype.setProcessCellFromClipboard = function(t) {
      this.gridOptionsService.set("processCellFromClipboard", t);
    }, i.prototype.setProcessSecondaryColDef = function(t) {
      bt("28.0", "setProcessSecondaryColDef", "setProcessPivotResultColDef"), this.setProcessPivotResultColDef(t);
    }, i.prototype.setProcessSecondaryColGroupDef = function(t) {
      bt("28.0", "setProcessSecondaryColGroupDef", "setProcessPivotResultColGroupDef"), this.setProcessPivotResultColGroupDef(t);
    }, i.prototype.setProcessPivotResultColDef = function(t) {
      this.gridOptionsService.set("processPivotResultColDef", t);
    }, i.prototype.setProcessPivotResultColGroupDef = function(t) {
      this.gridOptionsService.set("processPivotResultColGroupDef", t);
    }, i.prototype.setPostProcessPopup = function(t) {
      this.gridOptionsService.set("postProcessPopup", t);
    }, i.prototype.setDefaultGroupOrderComparator = function(t) {
      bt("27.2", "setDefaultGroupOrderComparator", "setInitialGroupOrderComparator"), this.gridOptionsService.set("defaultGroupOrderComparator", t);
    }, i.prototype.setInitialGroupOrderComparator = function(t) {
      this.gridOptionsService.set("initialGroupOrderComparator", t);
    }, i.prototype.setGetChartToolbarItems = function(t) {
      this.gridOptionsService.set("getChartToolbarItems", t);
    }, i.prototype.setPaginationNumberFormatter = function(t) {
      this.gridOptionsService.set("paginationNumberFormatter", t);
    }, i.prototype.setGetServerSideStoreParams = function(t) {
      bt("28.0", "setGetServerSideStoreParams", "setGetServerSideGroupLevelParams"), this.setGetServerSideGroupLevelParams(t);
    }, i.prototype.setGetServerSideGroupLevelParams = function(t) {
      this.gridOptionsService.set("getServerSideGroupLevelParams", t);
    }, i.prototype.setIsServerSideGroupOpenByDefault = function(t) {
      this.gridOptionsService.set("isServerSideGroupOpenByDefault", t);
    }, i.prototype.setIsApplyServerSideTransaction = function(t) {
      this.gridOptionsService.set("isApplyServerSideTransaction", t);
    }, i.prototype.setIsServerSideGroup = function(t) {
      this.gridOptionsService.set("isServerSideGroup", t);
    }, i.prototype.setGetServerSideGroupKey = function(t) {
      this.gridOptionsService.set("getServerSideGroupKey", t);
    }, i.prototype.setGetRowStyle = function(t) {
      this.gridOptionsService.set("getRowStyle", t);
    }, i.prototype.setGetRowHeight = function(t) {
      this.gridOptionsService.set("getRowHeight", t);
    }, i.prototype.assertSideBarLoaded = function(t) {
      return pe.assertRegistered(re.SideBarModule, "api." + t);
    }, i.prototype.isSideBarVisible = function() {
      return this.assertSideBarLoaded("isSideBarVisible") && this.sideBarComp.isDisplayed();
    }, i.prototype.setSideBarVisible = function(t) {
      this.assertSideBarLoaded("setSideBarVisible") && this.sideBarComp.setDisplayed(t);
    }, i.prototype.setSideBarPosition = function(t) {
      this.assertSideBarLoaded("setSideBarPosition") && this.sideBarComp.setSideBarPosition(t);
    }, i.prototype.openToolPanel = function(t) {
      this.assertSideBarLoaded("openToolPanel") && this.sideBarComp.openToolPanel(t, "api");
    }, i.prototype.closeToolPanel = function() {
      this.assertSideBarLoaded("closeToolPanel") && this.sideBarComp.close("api");
    }, i.prototype.getOpenedToolPanel = function() {
      return this.assertSideBarLoaded("getOpenedToolPanel") ? this.sideBarComp.openedItem() : null;
    }, i.prototype.refreshToolPanel = function() {
      this.assertSideBarLoaded("refreshToolPanel") && this.sideBarComp.refresh();
    }, i.prototype.isToolPanelShowing = function() {
      return this.assertSideBarLoaded("isToolPanelShowing") && this.sideBarComp.isToolPanelShowing();
    }, i.prototype.getToolPanelInstance = function(t) {
      if (this.assertSideBarLoaded("getToolPanelInstance")) {
        var e = this.sideBarComp.getToolPanelInstance(t);
        return on(e);
      }
    }, i.prototype.getSideBar = function() {
      if (this.assertSideBarLoaded("getSideBar"))
        return this.sideBarComp.getDef();
    }, i.prototype.setSideBar = function(t) {
      this.gridOptionsService.set("sideBar", t);
    }, i.prototype.setSuppressClipboardPaste = function(t) {
      this.gridOptionsService.set("suppressClipboardPaste", t);
    }, i.prototype.resetRowHeights = function() {
      if (k(this.clientSideRowModel)) {
        if (this.columnModel.isAutoRowHeightActive()) {
          console.warn("AG Grid: calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.");
          return;
        }
        this.clientSideRowModel.resetRowHeights();
      }
    }, i.prototype.setGroupRemoveSingleChildren = function(t) {
      this.gridOptionsService.set("groupRemoveSingleChildren", t);
    }, i.prototype.setGroupRemoveLowestSingleChildren = function(t) {
      this.gridOptionsService.set("groupRemoveLowestSingleChildren", t);
    }, i.prototype.setGroupDisplayType = function(t) {
      this.gridOptionsService.set("groupDisplayType", t);
    }, i.prototype.setRowClass = function(t) {
      this.gridOptionsService.set("rowClass", t);
    }, i.prototype.setDeltaSort = function(t) {
      this.gridOptionsService.set("deltaSort", t);
    }, i.prototype.setRowCount = function(t, e) {
      if (this.serverSideRowModel) {
        if (this.columnModel.isRowGroupEmpty()) {
          this.serverSideRowModel.setRowCount(t, e);
          return;
        }
        console.error("AG Grid: setRowCount cannot be used while using row grouping.");
        return;
      }
      if (this.infiniteRowModel) {
        this.infiniteRowModel.setRowCount(t, e);
        return;
      }
      this.logMissingRowModel("setRowCount", "infinite", "serverSide");
    }, i.prototype.onRowHeightChanged = function() {
      this.clientSideRowModel ? this.clientSideRowModel.onRowHeightChanged() : this.serverSideRowModel && this.serverSideRowModel.onRowHeightChanged();
    }, i.prototype.getValue = function(t, e) {
      var r = this.columnModel.getPrimaryColumn(t);
      return ue(r) && (r = this.columnModel.getGridColumn(t)), ue(r) ? null : this.valueService.getValue(r, e);
    }, i.prototype.addEventListener = function(t, e) {
      var r = this.gridOptionsService.useAsyncEvents();
      this.eventService.addEventListener(t, e, r);
    }, i.prototype.addGlobalListener = function(t) {
      var e = this.gridOptionsService.useAsyncEvents();
      this.eventService.addGlobalListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      var r = this.gridOptionsService.useAsyncEvents();
      this.eventService.removeEventListener(t, e, r);
    }, i.prototype.removeGlobalListener = function(t) {
      var e = this.gridOptionsService.useAsyncEvents();
      this.eventService.removeGlobalListener(t, e);
    }, i.prototype.dispatchEvent = function(t) {
      this.eventService.dispatchEvent(t);
    }, i.prototype.destroy = function() {
      if (!this.destroyCalled) {
        this.destroyCalled = !0;
        var t = this.ctrlsService.getGridCtrl();
        t && t.destroyGridUi(), this.context.destroy();
      }
    }, i.prototype.cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid = function() {
      setTimeout(Zd.bind(window, this, "Grid API"), 100);
    }, i.prototype.warnIfDestroyed = function(t) {
      return this.destroyCalled && console.warn("AG Grid: Grid API method " + t + " was called on a grid that was destroyed."), this.destroyCalled;
    }, i.prototype.resetQuickFilter = function() {
      this.warnIfDestroyed("resetQuickFilter") || this.filterManager.resetQuickFilterCache();
    }, i.prototype.getCellRanges = function() {
      return this.rangeService ? this.rangeService.getCellRanges() : (pe.assertRegistered(re.RangeSelectionModule, "api.getCellRanges"), null);
    }, i.prototype.addCellRange = function(t) {
      if (this.rangeService) {
        this.rangeService.addCellRange(t);
        return;
      }
      pe.assertRegistered(re.RangeSelectionModule, "api.addCellRange");
    }, i.prototype.clearRangeSelection = function() {
      this.rangeService && this.rangeService.removeAllCellRanges(), pe.assertRegistered(re.RangeSelectionModule, "gridApi.clearRangeSelection");
    }, i.prototype.undoCellEditing = function() {
      this.undoRedoService.undo("api");
    }, i.prototype.redoCellEditing = function() {
      this.undoRedoService.redo("api");
    }, i.prototype.getCurrentUndoSize = function() {
      return this.undoRedoService.getCurrentUndoStackSize();
    }, i.prototype.getCurrentRedoSize = function() {
      return this.undoRedoService.getCurrentRedoStackSize();
    }, i.prototype.getChartModels = function() {
      if (pe.assertRegistered(re.GridChartsModule, "api.getChartModels"))
        return this.chartService.getChartModels();
    }, i.prototype.getChartRef = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.getChartRef"))
        return this.chartService.getChartRef(t);
    }, i.prototype.getChartImageDataURL = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.getChartImageDataURL"))
        return this.chartService.getChartImageDataURL(t);
    }, i.prototype.downloadChart = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.downloadChart"))
        return this.chartService.downloadChart(t);
    }, i.prototype.openChartToolPanel = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.openChartToolPanel"))
        return this.chartService.openChartToolPanel(t);
    }, i.prototype.closeChartToolPanel = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.closeChartToolPanel"))
        return this.chartService.closeChartToolPanel(t.chartId);
    }, i.prototype.createRangeChart = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.createRangeChart"))
        return this.chartService.createRangeChart(t);
    }, i.prototype.createCrossFilterChart = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.createCrossFilterChart"))
        return this.chartService.createCrossFilterChart(t);
    }, i.prototype.restoreChart = function(t, e) {
      if (pe.assertRegistered(re.GridChartsModule, "api.restoreChart"))
        return this.chartService.restoreChart(t, e);
    }, i.prototype.createPivotChart = function(t) {
      if (pe.assertRegistered(re.GridChartsModule, "api.createPivotChart"))
        return this.chartService.createPivotChart(t);
    }, i.prototype.copyToClipboard = function(t) {
      pe.assertRegistered(re.ClipboardModule, "api.copyToClipboard") && this.clipboardService.copyToClipboard(t);
    }, i.prototype.cutToClipboard = function(t) {
      pe.assertRegistered(re.ClipboardModule, "api.cutToClipboard") && this.clipboardService.cutToClipboard(t);
    }, i.prototype.copySelectedRowsToClipboard = function(t) {
      pe.assertRegistered(re.ClipboardModule, "api.copySelectedRowsToClipboard") && this.clipboardService.copySelectedRowsToClipboard(t);
    }, i.prototype.copySelectedRangeToClipboard = function(t) {
      pe.assertRegistered(re.ClipboardModule, "api.copySelectedRangeToClipboard") && this.clipboardService.copySelectedRangeToClipboard(t);
    }, i.prototype.copySelectedRangeDown = function() {
      pe.assertRegistered(re.ClipboardModule, "api.copySelectedRangeDown") && this.clipboardService.copyRangeDown();
    }, i.prototype.showColumnMenuAfterButtonClick = function(t, e) {
      var r = this.columnModel.getGridColumn(t);
      this.menuFactory.showMenuAfterButtonClick(r, e, "columnMenu");
    }, i.prototype.showColumnMenuAfterMouseClick = function(t, e) {
      var r = this.columnModel.getGridColumn(t);
      if (r || (r = this.columnModel.getPrimaryColumn(t)), !r) {
        console.error("AG Grid: column '" + t + "' not found");
        return;
      }
      this.menuFactory.showMenuAfterMouseEvent(r, e);
    }, i.prototype.hidePopupMenu = function() {
      this.contextMenuFactory && this.contextMenuFactory.hideActiveMenu(), this.menuFactory.hideActiveMenu();
    }, i.prototype.setPopupParent = function(t) {
      this.gridOptionsService.set("popupParent", t);
    }, i.prototype.tabToNextCell = function(t) {
      return this.navigationService.tabToNextCell(!1, t);
    }, i.prototype.tabToPreviousCell = function(t) {
      return this.navigationService.tabToNextCell(!0, t);
    }, i.prototype.getCellRendererInstances = function(t) {
      t === void 0 && (t = {});
      var e = this.rowRenderer.getCellRendererInstances(t), r = e.map(on);
      return r;
    }, i.prototype.getCellEditorInstances = function(t) {
      t === void 0 && (t = {});
      var e = this.rowRenderer.getCellEditorInstances(t), r = e.map(on);
      return r;
    }, i.prototype.getEditingCells = function() {
      return this.rowRenderer.getEditingCells();
    }, i.prototype.stopEditing = function(t) {
      t === void 0 && (t = !1), this.rowRenderer.stopEditing(t);
    }, i.prototype.startEditingCell = function(t) {
      var e = this.columnModel.getGridColumn(t.colKey);
      if (!e) {
        console.warn("AG Grid: no column found for " + t.colKey);
        return;
      }
      var r = {
        rowIndex: t.rowIndex,
        rowPinned: t.rowPinned || null,
        column: e
      }, o = t.rowPinned == null;
      o && this.gridBodyCtrl.getScrollFeature().ensureIndexVisible(t.rowIndex);
      var n = this.navigationService.getCellByPosition(r);
      n && n.startRowOrCellEdit(t.key, t.charPress);
    }, i.prototype.addAggFunc = function(t, e) {
      this.aggFuncService && this.aggFuncService.addAggFunc(t, e);
    }, i.prototype.addAggFuncs = function(t) {
      this.aggFuncService && this.aggFuncService.addAggFuncs(t);
    }, i.prototype.clearAggFuncs = function() {
      this.aggFuncService && this.aggFuncService.clear();
    }, i.prototype.applyServerSideTransaction = function(t) {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("applyServerSideTransaction", "serverSide");
        return;
      }
      return this.serverSideTransactionManager.applyTransaction(t);
    }, i.prototype.applyServerSideTransactionAsync = function(t, e) {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("applyServerSideTransactionAsync", "serverSide");
        return;
      }
      return this.serverSideTransactionManager.applyTransactionAsync(t, e);
    }, i.prototype.retryServerSideLoads = function() {
      if (!this.serverSideRowModel) {
        this.logMissingRowModel("retryServerSideLoads", "serverSide");
        return;
      }
      this.serverSideRowModel.retryLoads();
    }, i.prototype.flushServerSideAsyncTransactions = function() {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("flushServerSideAsyncTransactions", "serverSide");
        return;
      }
      return this.serverSideTransactionManager.flushAsyncTransactions();
    }, i.prototype.applyTransaction = function(t) {
      if (!this.clientSideRowModel) {
        this.logMissingRowModel("applyTransaction", "clientSide");
        return;
      }
      var e = this.clientSideRowModel.updateRowData(t);
      return this.gridOptionsService.is("suppressChangeDetection") || this.rowRenderer.refreshCells(), e;
    }, i.prototype.applyTransactionAsync = function(t, e) {
      if (!this.clientSideRowModel) {
        this.logMissingRowModel("applyTransactionAsync", "clientSide");
        return;
      }
      this.clientSideRowModel.batchUpdateRowData(t, e);
    }, i.prototype.flushAsyncTransactions = function() {
      if (!this.clientSideRowModel) {
        this.logMissingRowModel("flushAsyncTransactions", "clientSide");
        return;
      }
      this.clientSideRowModel.flushAsyncTransactions();
    }, i.prototype.setSuppressModelUpdateAfterUpdateTransaction = function(t) {
      this.gridOptionsService.set("suppressModelUpdateAfterUpdateTransaction", t);
    }, i.prototype.refreshInfiniteCache = function() {
      this.infiniteRowModel ? this.infiniteRowModel.refreshCache() : this.logMissingRowModel("refreshInfiniteCache", "infinite");
    }, i.prototype.purgeInfiniteCache = function() {
      this.infiniteRowModel ? this.infiniteRowModel.purgeCache() : this.logMissingRowModel("purgeInfiniteCache", "infinite");
    }, i.prototype.refreshServerSide = function(t) {
      if (!this.serverSideRowModel) {
        this.logMissingRowModel("refreshServerSide", "serverSide");
        return;
      }
      this.serverSideRowModel.refreshStore(t);
    }, i.prototype.refreshServerSideStore = function(t) {
      return bt("28.0", "refreshServerSideStore", "refreshServerSide"), this.refreshServerSide(t);
    }, i.prototype.getServerSideStoreState = function() {
      return bt("28.0", "getServerSideStoreState", "getServerSideGroupLevelState"), this.getServerSideGroupLevelState();
    }, i.prototype.getServerSideGroupLevelState = function() {
      return this.serverSideRowModel ? this.serverSideRowModel.getStoreState() : (this.logMissingRowModel("getServerSideGroupLevelState", "serverSide"), []);
    }, i.prototype.getInfiniteRowCount = function() {
      if (this.infiniteRowModel)
        return this.infiniteRowModel.getRowCount();
      this.logMissingRowModel("getInfiniteRowCount", "infinite");
    }, i.prototype.isLastRowIndexKnown = function() {
      if (this.infiniteRowModel)
        return this.infiniteRowModel.isLastRowIndexKnown();
      this.logMissingRowModel("isLastRowIndexKnown", "infinite");
    }, i.prototype.getCacheBlockState = function() {
      return this.rowNodeBlockLoader.getBlockState();
    }, i.prototype.getFirstDisplayedRow = function() {
      return this.rowRenderer.getFirstVirtualRenderedRow();
    }, i.prototype.getLastDisplayedRow = function() {
      return this.rowRenderer.getLastVirtualRenderedRow();
    }, i.prototype.getDisplayedRowAtIndex = function(t) {
      return this.rowModel.getRow(t);
    }, i.prototype.getDisplayedRowCount = function() {
      return this.rowModel.getRowCount();
    }, i.prototype.setPagination = function(t) {
      if (!this.clientSideRowModel && this.gridOptionsService.get("domLayout") === "autoHeight" && !t) {
        console.error("AG Grid: Pagination cannot be disabled when using domLayout set to 'autoHeight' unless using the client-side row model.");
        return;
      }
      this.gridOptionsService.set("pagination", t);
    }, i.prototype.paginationIsLastPageFound = function() {
      return this.paginationProxy.isLastPageFound();
    }, i.prototype.paginationGetPageSize = function() {
      return this.paginationProxy.getPageSize();
    }, i.prototype.paginationSetPageSize = function(t) {
      this.gridOptionsService.set("paginationPageSize", t);
    }, i.prototype.paginationGetCurrentPage = function() {
      return this.paginationProxy.getCurrentPage();
    }, i.prototype.paginationGetTotalPages = function() {
      return this.paginationProxy.getTotalPages();
    }, i.prototype.paginationGetRowCount = function() {
      return this.paginationProxy.getMasterRowCount();
    }, i.prototype.paginationGoToNextPage = function() {
      this.paginationProxy.goToNextPage();
    }, i.prototype.paginationGoToPreviousPage = function() {
      this.paginationProxy.goToPreviousPage();
    }, i.prototype.paginationGoToFirstPage = function() {
      this.paginationProxy.goToFirstPage();
    }, i.prototype.paginationGoToLastPage = function() {
      this.paginationProxy.goToLastPage();
    }, i.prototype.paginationGoToPage = function(t) {
      this.paginationProxy.goToPage(t);
    }, Ae([
      Fe("immutableService")
    ], i.prototype, "immutableService", void 0), Ae([
      Fe("csvCreator")
    ], i.prototype, "csvCreator", void 0), Ae([
      Fe("excelCreator")
    ], i.prototype, "excelCreator", void 0), Ae([
      v("rowRenderer")
    ], i.prototype, "rowRenderer", void 0), Ae([
      v("navigationService")
    ], i.prototype, "navigationService", void 0), Ae([
      v("filterManager")
    ], i.prototype, "filterManager", void 0), Ae([
      v("columnModel")
    ], i.prototype, "columnModel", void 0), Ae([
      v("selectionService")
    ], i.prototype, "selectionService", void 0), Ae([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), Ae([
      v("valueService")
    ], i.prototype, "valueService", void 0), Ae([
      v("alignedGridsService")
    ], i.prototype, "alignedGridsService", void 0), Ae([
      v("eventService")
    ], i.prototype, "eventService", void 0), Ae([
      v("pinnedRowModel")
    ], i.prototype, "pinnedRowModel", void 0), Ae([
      v("context")
    ], i.prototype, "context", void 0), Ae([
      v("rowModel")
    ], i.prototype, "rowModel", void 0), Ae([
      v("sortController")
    ], i.prototype, "sortController", void 0), Ae([
      v("paginationProxy")
    ], i.prototype, "paginationProxy", void 0), Ae([
      v("focusService")
    ], i.prototype, "focusService", void 0), Ae([
      v("dragAndDropService")
    ], i.prototype, "dragAndDropService", void 0), Ae([
      Fe("rangeService")
    ], i.prototype, "rangeService", void 0), Ae([
      Fe("clipboardService")
    ], i.prototype, "clipboardService", void 0), Ae([
      Fe("aggFuncService")
    ], i.prototype, "aggFuncService", void 0), Ae([
      v("menuFactory")
    ], i.prototype, "menuFactory", void 0), Ae([
      Fe("contextMenuFactory")
    ], i.prototype, "contextMenuFactory", void 0), Ae([
      v("valueCache")
    ], i.prototype, "valueCache", void 0), Ae([
      v("animationFrameService")
    ], i.prototype, "animationFrameService", void 0), Ae([
      Fe("statusBarService")
    ], i.prototype, "statusBarService", void 0), Ae([
      Fe("chartService")
    ], i.prototype, "chartService", void 0), Ae([
      Fe("undoRedoService")
    ], i.prototype, "undoRedoService", void 0), Ae([
      Fe("rowNodeBlockLoader")
    ], i.prototype, "rowNodeBlockLoader", void 0), Ae([
      Fe("ssrmTransactionManager")
    ], i.prototype, "serverSideTransactionManager", void 0), Ae([
      v("ctrlsService")
    ], i.prototype, "ctrlsService", void 0), Ae([
      U
    ], i.prototype, "init", null), Ae([
      At
    ], i.prototype, "cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid", null), i = Ae([
      te("gridApi")
    ], i), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var _S = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), oa = function() {
  return oa = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, oa.apply(this, arguments);
}, Xo = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ih = (
  /** @class */
  function(i) {
    _S(t, i);
    function t() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.allColumnFilters = /* @__PURE__ */ new Map(), r.activeAggregateFilters = [], r.activeColumnFilters = [], r.quickFilter = null, r.quickFilterParts = null, r.processingFilterChange = !1, r;
    }
    e = t, t.prototype.init = function() {
      var r = this;
      this.addManagedListener(this.eventService, m.EVENT_GRID_COLUMNS_CHANGED, function() {
        return r.onColumnsChanged();
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_VALUE_CHANGED, function() {
        return r.refreshFiltersForAggregations();
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_CHANGED, function() {
        return r.refreshFiltersForAggregations();
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_MODE_CHANGED, function() {
        r.refreshFiltersForAggregations(), r.resetQuickFilterCache();
      }), this.addManagedListener(this.eventService, m.EVENT_NEW_COLUMNS_LOADED, function() {
        return r.resetQuickFilterCache();
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, function() {
        return r.resetQuickFilterCache();
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_VISIBLE, function() {
        r.gridOptionsService.is("excludeHiddenColumnsFromQuickFilter") && r.resetQuickFilterCache();
      }), this.addManagedPropertyListener("quickFilterText", function(o) {
        return r.setQuickFilter(o.currentValue);
      }), this.addManagedPropertyListener("excludeHiddenColumnsFromQuickFilter", function() {
        return r.onExcludeHiddenColumnsFromQuickFilterChanged();
      }), this.quickFilter = this.parseQuickFilter(this.gridOptionsService.get("quickFilterText")), this.setQuickFilterParts(), this.allowShowChangeAfterFilter = this.gridOptionsService.is("allowShowChangeAfterFilter"), this.externalFilterPresent = this.isExternalFilterPresentCallback();
    }, t.prototype.isExternalFilterPresentCallback = function() {
      var r = this.gridOptionsService.getCallback("isExternalFilterPresent");
      return typeof r == "function" ? r({}) : !1;
    }, t.prototype.doesExternalFilterPass = function(r) {
      var o = this.gridOptionsService.get("doesExternalFilterPass");
      return typeof o == "function" ? o(r) : !1;
    }, t.prototype.setQuickFilterParts = function() {
      this.quickFilterParts = this.quickFilter ? this.quickFilter.split(" ") : null;
    }, t.prototype.setFilterModel = function(r) {
      var o = this, n = [], s = this.getFilterModel();
      if (r) {
        var a = tc(Object.keys(r));
        this.allColumnFilters.forEach(function(l, u) {
          var c = r[u];
          n.push(o.setModelOnFilterWrapper(l.filterPromise, c)), a.delete(u);
        }), a.forEach(function(l) {
          var u = o.columnModel.getPrimaryColumn(l) || o.columnModel.getGridColumn(l);
          if (!u) {
            console.warn("AG Grid: setFilterModel() - no column found for colId: " + l);
            return;
          }
          if (!u.isFilterAllowed()) {
            console.warn("AG Grid: setFilterModel() - unable to fully apply model, filtering disabled for colId: " + l);
            return;
          }
          var c = o.getOrCreateFilterWrapper(u, "NO_UI");
          if (!c) {
            console.warn("AG-Grid: setFilterModel() - unable to fully apply model, unable to create filter for colId: " + l);
            return;
          }
          n.push(o.setModelOnFilterWrapper(c.filterPromise, r[l]));
        });
      } else
        this.allColumnFilters.forEach(function(l) {
          n.push(o.setModelOnFilterWrapper(l.filterPromise, null));
        });
      nr.all(n).then(function() {
        var l = o.getFilterModel(), u = [];
        o.allColumnFilters.forEach(function(c, p) {
          var d = s ? s[p] : null, h = l ? l[p] : null;
          le.jsonEquals(d, h) || u.push(c.column);
        }), u.length > 0 && o.onFilterChanged({ columns: u });
      });
    }, t.prototype.setModelOnFilterWrapper = function(r, o) {
      return new nr(function(n) {
        r.then(function(s) {
          typeof s.setModel != "function" && (console.warn("AG Grid: filter missing setModel method, which is needed for setFilterModel"), n()), (s.setModel(o) || nr.resolve()).then(function() {
            return n();
          });
        });
      });
    }, t.prototype.getFilterModel = function() {
      var r = {};
      return this.allColumnFilters.forEach(function(o, n) {
        var s = o.filterPromise, a = s.resolveNow(null, function(u) {
          return u;
        });
        if (a == null)
          return null;
        if (typeof a.getModel != "function") {
          console.warn("AG Grid: filter API missing getModel method, which is needed for getFilterModel");
          return;
        }
        var l = a.getModel();
        k(l) && (r[n] = l);
      }), r;
    }, t.prototype.isColumnFilterPresent = function() {
      return this.activeColumnFilters.length > 0;
    }, t.prototype.isAggregateFilterPresent = function() {
      return !!this.activeAggregateFilters.length;
    }, t.prototype.isExternalFilterPresent = function() {
      return this.externalFilterPresent;
    }, t.prototype.doAggregateFiltersPass = function(r, o) {
      return this.doColumnFiltersPass(r, o, !0);
    }, t.prototype.updateActiveFilters = function() {
      var r = this;
      this.activeColumnFilters.length = 0, this.activeAggregateFilters.length = 0;
      var o = function(a) {
        return a ? a.isFilterActive ? a.isFilterActive() : (console.warn("AG Grid: Filter is missing isFilterActive() method"), !1) : !1;
      }, n = !!this.gridOptionsService.getGroupAggFiltering(), s = function(a) {
        var l = !a.isPrimary();
        if (l)
          return !0;
        var u = !r.columnModel.isPivotActive(), c = a.isValueActive();
        return !c || !u ? !1 : r.columnModel.isPivotMode() ? !0 : n;
      };
      this.allColumnFilters.forEach(function(a) {
        if (a.filterPromise.resolveNow(!1, o)) {
          var l = a.filterPromise.resolveNow(null, function(u) {
            return u;
          });
          s(a.column) ? r.activeAggregateFilters.push(l) : r.activeColumnFilters.push(l);
        }
      });
    }, t.prototype.updateFilterFlagInColumns = function(r, o) {
      this.allColumnFilters.forEach(function(n) {
        var s = n.filterPromise.resolveNow(!1, function(a) {
          return a.isFilterActive();
        });
        n.column.setFilterActive(s, r, o);
      });
    }, t.prototype.isAnyFilterPresent = function() {
      return this.isQuickFilterPresent() || this.isColumnFilterPresent() || this.isAggregateFilterPresent() || this.isExternalFilterPresent();
    }, t.prototype.doColumnFiltersPass = function(r, o, n) {
      for (var s = r.data, a = r.aggData, l = n ? this.activeAggregateFilters : this.activeColumnFilters, u = n ? a : s, c = 0; c < l.length; c++) {
        var p = l[c];
        if (!(p == null || p === o)) {
          if (typeof p.doesFilterPass != "function")
            throw new Error("Filter is missing method doesFilterPass");
          if (!p.doesFilterPass({ node: r, data: u }))
            return !1;
        }
      }
      return !0;
    }, t.prototype.parseQuickFilter = function(r) {
      return k(r) ? this.gridOptionsService.isRowModelType("clientSide") ? r.toUpperCase() : (console.warn("AG Grid - Quick filtering only works with the Client-Side Row Model"), null) : null;
    }, t.prototype.setQuickFilter = function(r) {
      if (r != null && typeof r != "string") {
        console.warn("AG Grid - setQuickFilter() only supports string inputs, received: " + typeof r);
        return;
      }
      var o = this.parseQuickFilter(r);
      this.quickFilter !== o && (this.quickFilter = o, this.setQuickFilterParts(), this.onFilterChanged());
    }, t.prototype.resetQuickFilterCache = function() {
      this.rowModel.forEachNode(function(r) {
        return r.quickFilterAggregateText = null;
      });
    }, t.prototype.onExcludeHiddenColumnsFromQuickFilterChanged = function() {
      this.columnModel.refreshQuickFilterColumns(), this.resetQuickFilterCache(), this.isQuickFilterPresent() && this.onFilterChanged();
    }, t.prototype.refreshFiltersForAggregations = function() {
      var r = this.gridOptionsService.getGroupAggFiltering();
      r && this.onFilterChanged();
    }, t.prototype.callOnFilterChangedOutsideRenderCycle = function(r) {
      var o = this;
      r === void 0 && (r = {});
      var n = function() {
        return o.onFilterChanged(r);
      };
      this.rowRenderer.isRefreshInProgress() ? setTimeout(n, 0) : n();
    }, t.prototype.onFilterChanged = function(r) {
      r === void 0 && (r = {});
      var o = r.filterInstance, n = r.additionalEventAttributes, s = r.columns;
      this.updateDependantFilters(), this.updateActiveFilters(), this.updateFilterFlagInColumns("filterChanged", n), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.allColumnFilters.forEach(function(l) {
        l.filterPromise && l.filterPromise.then(function(u) {
          u && u !== o && u.onAnyFilterChanged && u.onAnyFilterChanged();
        });
      });
      var a = {
        type: m.EVENT_FILTER_CHANGED,
        columns: s || []
      };
      n && ir(a, n), this.processingFilterChange = !0, this.eventService.dispatchEvent(a), this.processingFilterChange = !1;
    }, t.prototype.isSuppressFlashingCellsBecauseFiltering = function() {
      return !this.allowShowChangeAfterFilter && this.processingFilterChange;
    }, t.prototype.isQuickFilterPresent = function() {
      return this.quickFilter !== null;
    }, t.prototype.doesRowPassOtherFilters = function(r, o) {
      return this.doesRowPassFilter({ rowNode: o, filterInstanceToSkip: r });
    }, t.prototype.doesRowPassQuickFilterNoCache = function(r, o) {
      var n = this, s = this.columnModel.getAllColumnsForQuickFilter();
      return s.some(function(a) {
        var l = n.getQuickFilterTextForColumn(a, r);
        return k(l) && l.indexOf(o) >= 0;
      });
    }, t.prototype.doesRowPassQuickFilterCache = function(r, o) {
      return r.quickFilterAggregateText || this.aggregateRowForQuickFilter(r), r.quickFilterAggregateText.indexOf(o) >= 0;
    }, t.prototype.doesRowPassQuickFilter = function(r) {
      var o = this, n = this.gridOptionsService.is("cacheQuickFilter");
      return this.quickFilterParts.every(function(s) {
        return n ? o.doesRowPassQuickFilterCache(r, s) : o.doesRowPassQuickFilterNoCache(r, s);
      });
    }, t.prototype.doesRowPassAggregateFilters = function(r) {
      return !(this.isAggregateFilterPresent() && !this.doAggregateFiltersPass(r.rowNode, r.filterInstanceToSkip));
    }, t.prototype.doesRowPassFilter = function(r) {
      return !(this.isQuickFilterPresent() && !this.doesRowPassQuickFilter(r.rowNode) || this.isExternalFilterPresent() && !this.doesExternalFilterPass(r.rowNode) || this.isColumnFilterPresent() && !this.doColumnFiltersPass(r.rowNode, r.filterInstanceToSkip));
    }, t.prototype.getQuickFilterTextForColumn = function(r, o) {
      var n = this.valueService.getValue(r, o, !0), s = r.getColDef();
      if (s.getQuickFilterText) {
        var a = {
          value: n,
          node: o,
          data: o.data,
          column: r,
          colDef: s,
          api: this.gridOptionsService.api,
          columnApi: this.gridOptionsService.columnApi,
          context: this.gridOptionsService.context
        };
        n = s.getQuickFilterText(a);
      }
      return k(n) ? n.toString().toUpperCase() : null;
    }, t.prototype.aggregateRowForQuickFilter = function(r) {
      var o = this, n = [], s = this.columnModel.getAllColumnsForQuickFilter();
      s.forEach(function(a) {
        var l = o.getQuickFilterTextForColumn(a, r);
        k(l) && n.push(l);
      }), r.quickFilterAggregateText = n.join(e.QUICK_FILTER_SEPARATOR);
    }, t.prototype.onNewRowsLoaded = function(r) {
      this.allColumnFilters.forEach(function(o) {
        o.filterPromise.then(function(n) {
          n.onNewRowsLoaded && n.onNewRowsLoaded();
        });
      }), this.updateFilterFlagInColumns(r, { afterDataChange: !0 }), this.updateActiveFilters();
    }, t.prototype.createValueGetter = function(r) {
      var o = this;
      return function(n) {
        var s = n.node;
        return o.valueService.getValue(r, s, !0);
      };
    }, t.prototype.getFilterComponent = function(r, o, n) {
      var s;
      if (n === void 0 && (n = !0), n)
        return ((s = this.getOrCreateFilterWrapper(r, o)) === null || s === void 0 ? void 0 : s.filterPromise) || null;
      var a = this.cachedFilter(r);
      return a ? a.filterPromise : null;
    }, t.prototype.isFilterActive = function(r) {
      var o = this.cachedFilter(r);
      return !!o && o.filterPromise.resolveNow(!1, function(n) {
        return n.isFilterActive();
      });
    }, t.prototype.getOrCreateFilterWrapper = function(r, o) {
      if (!r.isFilterAllowed())
        return null;
      var n = this.cachedFilter(r);
      return n ? o !== "NO_UI" && this.putIntoGui(n, o) : (n = this.createFilterWrapper(r, o), this.allColumnFilters.set(r.getColId(), n)), n;
    }, t.prototype.cachedFilter = function(r) {
      return this.allColumnFilters.get(r.getColId());
    }, t.prototype.createFilterInstance = function(r) {
      var o = this, n = pe.isRegistered(re.SetFilterModule) ? "agSetColumnFilter" : "agTextColumnFilter", s = r.getColDef(), a, l = oa(oa({}, this.createFilterParams(r, s)), { filterModifiedCallback: function() {
        var p = {
          type: m.EVENT_FILTER_MODIFIED,
          column: r,
          filterInstance: a
        };
        o.eventService.dispatchEvent(p);
      }, filterChangedCallback: function(p) {
        var d = { filterInstance: a, additionalEventAttributes: p, columns: [r] };
        o.callOnFilterChangedOutsideRenderCycle(d);
      }, doesRowPassOtherFilter: function(p) {
        return o.doesRowPassOtherFilters(a, p);
      } }), u = this.userComponentFactory.getFilterDetails(s, l, n);
      if (!u)
        return null;
      var c = u.newAgStackInstance();
      return c && c.then(function(p) {
        return a = p;
      }), c;
    }, t.prototype.createFilterParams = function(r, o) {
      var n = {
        column: r,
        colDef: Au(o),
        rowModel: this.rowModel,
        filterChangedCallback: function() {
        },
        filterModifiedCallback: function() {
        },
        valueGetter: this.createValueGetter(r),
        doesRowPassOtherFilter: function() {
          return !0;
        },
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context
      };
      return n;
    }, t.prototype.createFilterWrapper = function(r, o) {
      var n = {
        column: r,
        filterPromise: null,
        compiledElement: null,
        guiPromise: nr.resolve(null)
      };
      return n.filterPromise = this.createFilterInstance(r), n.filterPromise && this.putIntoGui(n, o), n;
    }, t.prototype.putIntoGui = function(r, o) {
      var n = this, s = document.createElement("div");
      s.className = "ag-filter", r.guiPromise = new nr(function(a) {
        r.filterPromise.then(function(l) {
          var u = l.getGui();
          k(u) || console.warn("AG Grid: getGui method from filter returned " + u + ", it should be a DOM element or an HTML template string."), typeof u == "string" && (u = Lt(u)), s.appendChild(u), a(s);
          var c = {
            type: m.EVENT_FILTER_OPENED,
            column: r.column,
            source: o,
            eGui: s
          };
          n.eventService.dispatchEvent(c);
        });
      });
    }, t.prototype.onColumnsChanged = function() {
      var r = this, o = [];
      this.allColumnFilters.forEach(function(n, s) {
        var a;
        n.column.isPrimary() ? a = r.columnModel.getPrimaryColumn(s) : a = r.columnModel.getGridColumn(s), !a && (o.push(n.column), r.disposeFilterWrapper(n, "columnChanged"));
      }), o.length > 0 ? this.onFilterChanged({ columns: o }) : this.updateDependantFilters();
    }, t.prototype.updateDependantFilters = function() {
      var r = this, o = this.columnModel.getGroupAutoColumns();
      o == null || o.forEach(function(n) {
        n.getColDef().filter === "agGroupColumnFilter" && r.getOrCreateFilterWrapper(n, "NO_UI");
      });
    }, t.prototype.isFilterAllowed = function(r) {
      var o, n, s = r.isFilterAllowed();
      if (!s)
        return !1;
      var a = this.allColumnFilters.get(r.getColId());
      return (n = (o = a == null ? void 0 : a.filterPromise) === null || o === void 0 ? void 0 : o.resolveNow(
        !0,
        // defer to filter component isFilterAllowed if it exists
        function(l) {
          var u, c;
          return typeof ((u = l) === null || u === void 0 ? void 0 : u.isFilterAllowed) == "function" ? (c = l) === null || c === void 0 ? void 0 : c.isFilterAllowed() : !0;
        }
      )) !== null && n !== void 0 ? n : !0;
    }, t.prototype.getFloatingFilterCompDetails = function(r, o) {
      var n = this, s = r.getColDef(), a = this.createFilterParams(r, s), l = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(s, vu, a), u = this.userComponentFactory.getDefaultFloatingFilterType(s);
      u == null && (u = "agReadOnlyFloatingFilter");
      var c = function(d) {
        var h = n.getFilterComponent(r, "NO_UI");
        h != null && h.then(function(g) {
          d(on(g));
        });
      }, p = {
        column: r,
        filterParams: l,
        currentParentModel: function() {
          return n.getCurrentFloatingFilterParentModel(r);
        },
        parentFilterInstance: c,
        showParentFilter: o,
        suppressFilterButton: !1
        // This one might be overridden from the colDef
      };
      return this.userComponentFactory.getFloatingFilterCompDetails(s, p, u);
    }, t.prototype.getCurrentFloatingFilterParentModel = function(r) {
      var o = this.getFilterComponent(r, "NO_UI", !1);
      return o ? o.resolveNow(null, function(n) {
        return n && n.getModel();
      }) : null;
    }, t.prototype.destroyFilter = function(r, o) {
      o === void 0 && (o = "api");
      var n = this.allColumnFilters.get(r.getColId());
      n && (this.disposeFilterWrapper(n, o), this.onFilterChanged({ columns: [r] }));
    }, t.prototype.disposeFilterWrapper = function(r, o) {
      var n = this;
      r.filterPromise.then(function(s) {
        (s.setModel(null) || nr.resolve()).then(function() {
          n.getContext().destroyBean(s), r.column.setFilterActive(!1, "filterDestroyed"), n.allColumnFilters.delete(r.column.getColId());
          var a = {
            type: m.EVENT_FILTER_DESTROYED,
            source: o,
            column: r.column
          };
          n.eventService.dispatchEvent(a);
        });
      });
    }, t.prototype.destroy = function() {
      var r = this;
      i.prototype.destroy.call(this), this.allColumnFilters.forEach(function(o) {
        return r.disposeFilterWrapper(o, "gridDestroyed");
      });
    };
    var e;
    return t.QUICK_FILTER_SEPARATOR = `
`, Xo([
      v("valueService")
    ], t.prototype, "valueService", void 0), Xo([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Xo([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Xo([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), Xo([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Xo([
      U
    ], t.prototype, "init", null), t = e = Xo([
      te("filterManager")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ES = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), uc = (
  /** @class */
  function(i) {
    ES(t, i);
    function t(e, r) {
      var o = i.call(this, e) || this;
      return o.ctrl = r, o;
    }
    return t.prototype.getCtrl = function() {
      return this.ctrl;
    }, t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var RS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ps = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Lh = (
  /** @class */
  function(i) {
    RS(t, i);
    function t(e) {
      return i.call(this, t.TEMPLATE, e) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), o = {
        addOrRemoveCssClass: function(n, s) {
          return e.addOrRemoveCssClass(n, s);
        },
        addOrRemoveBodyCssClass: function(n, s) {
          return e.eFloatingFilterBody.classList.toggle(n, s);
        },
        setButtonWrapperDisplayed: function(n) {
          return be(e.eButtonWrapper, n);
        },
        setCompDetails: function(n) {
          return e.setCompDetails(n);
        },
        getFloatingFilterComp: function() {
          return e.compPromise;
        },
        setWidth: function(n) {
          return r.style.width = n;
        },
        setMenuIcon: function(n) {
          return e.eButtonShowMainFilter.appendChild(n);
        }
      };
      this.ctrl.setComp(o, r, this.eButtonShowMainFilter, this.eFloatingFilterBody);
    }, t.prototype.setCompDetails = function(e) {
      var r = this;
      this.compPromise = e.newAgStackInstance(), this.compPromise.then(function(o) {
        return r.afterCompCreated(o);
      });
    }, t.prototype.afterCompCreated = function(e) {
      var r = this;
      e && (this.addDestroyFunc(function() {
        return r.context.destroyBean(e);
      }), this.isAlive() && (this.eFloatingFilterBody.appendChild(e.getGui()), e.afterGuiAttached && e.afterGuiAttached()));
    }, t.TEMPLATE = `<div class="ag-header-cell ag-floating-filter" role="gridcell" tabindex="-1">
            <div ref="eFloatingFilterBody" role="presentation"></div>
            <div class="ag-floating-filter-button ag-hidden" ref="eButtonWrapper" role="presentation">
                <button type="button" aria-label="Open Filter Menu" class="ag-floating-filter-button-button" ref="eButtonShowMainFilter" tabindex="-1"></button>
            </div>
        </div>`, ps([
      Y("eFloatingFilterBody")
    ], t.prototype, "eFloatingFilterBody", void 0), ps([
      Y("eButtonWrapper")
    ], t.prototype, "eButtonWrapper", void 0), ps([
      Y("eButtonShowMainFilter")
    ], t.prototype, "eButtonShowMainFilter", void 0), ps([
      U
    ], t.prototype, "postConstruct", null), t;
  }(uc)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var OS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), bS = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, lt;
(function(i) {
  i.AUTO_HEIGHT = "ag-layout-auto-height", i.NORMAL = "ag-layout-normal", i.PRINT = "ag-layout-print";
})(lt || (lt = {}));
var cc = (
  /** @class */
  function(i) {
    OS(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.view = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
    }, t.prototype.updateLayoutClasses = function() {
      var e = this.getDomLayout(), r = {
        autoHeight: e === "autoHeight",
        normal: e === "normal",
        print: e === "print"
      }, o = r.autoHeight ? lt.AUTO_HEIGHT : r.print ? lt.PRINT : lt.NORMAL;
      this.view.updateLayoutClasses(o, r);
    }, t.prototype.getDomLayout = function() {
      var e, r = (e = this.gridOptionsService.get("domLayout")) !== null && e !== void 0 ? e : "normal", o = ["normal", "print", "autoHeight"];
      return o.indexOf(r) === -1 ? (Pe(function() {
        return console.warn("AG Grid: " + r + " is not valid for DOM Layout, valid values are 'normal', 'autoHeight', 'print'.");
      }, "warn about dom layout values"), "normal") : r;
    }, bS([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var TS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), na = function() {
  return na = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, na.apply(this, arguments);
}, Po = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, PS = (
  /** @class */
  function(i) {
    TS(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.scrollLeft = -1, r.nextScrollTop = -1, r.scrollTop = -1, r.eBodyViewport = e, r.resetLastHScrollDebounced = ro(function() {
        return r.eLastHScroll = null;
      }, 500), r.resetLastVScrollDebounced = ro(function() {
        return r.eLastVScroll = null;
      }, 500), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.enableRtl = this.gridOptionsService.is("enableRtl"), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this)), this.ctrlsService.whenReady(function(r) {
        e.centerRowContainerCtrl = r.centerRowContainerCtrl, e.onDisplayedColumnsWidthChanged(), e.addScrollListener();
      });
    }, t.prototype.addScrollListener = function() {
      var e = this.ctrlsService.getFakeHScrollComp(), r = this.ctrlsService.getFakeVScrollComp();
      this.addManagedListener(this.centerRowContainerCtrl.getViewportElement(), "scroll", this.onHScroll.bind(this)), this.addManagedListener(e.getViewport(), "scroll", this.onFakeHScroll.bind(this));
      var o = this.gridOptionsService.is("debounceVerticalScrollbar"), n = o ? ro(this.onVScroll.bind(this), 100) : this.onVScroll.bind(this), s = o ? ro(this.onFakeVScroll.bind(this), 100) : this.onFakeVScroll.bind(this);
      this.addManagedListener(this.eBodyViewport, "scroll", n), this.addManagedListener(r.getViewport(), "scroll", s);
    }, t.prototype.onDisplayedColumnsWidthChanged = function() {
      this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }, t.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function(e) {
      var r = this.centerRowContainerCtrl == null;
      if (!r) {
        e === void 0 && (e = this.centerRowContainerCtrl.getCenterViewportScrollLeft());
        var o = this.enableRtl ? e : -e, n = this.ctrlsService.getTopCenterRowContainerCtrl(), s = this.ctrlsService.getStickyTopCenterRowContainerCtrl(), a = this.ctrlsService.getBottomCenterRowContainerCtrl(), l = this.ctrlsService.getFakeHScrollComp(), u = this.ctrlsService.getHeaderRowContainerCtrl();
        u.setHorizontalScroll(-o), a.setContainerTranslateX(o), n.setContainerTranslateX(o), s.setContainerTranslateX(o);
        var c = this.centerRowContainerCtrl.getViewportElement(), p = this.eLastHScroll === c, d = p ? l.getViewport() : this.centerRowContainerCtrl.getViewportElement();
        Qs(d, Math.abs(e), this.enableRtl);
      }
    }, t.prototype.isControllingHScroll = function(e) {
      return this.eLastHScroll ? e === this.eLastHScroll : (this.eLastHScroll = e, !0);
    }, t.prototype.isControllingVScroll = function(e) {
      return this.eLastVScroll ? e === this.eLastVScroll : (this.eLastVScroll = e, !0);
    }, t.prototype.onFakeHScroll = function() {
      var e = this.ctrlsService.getFakeHScrollComp().getViewport();
      this.isControllingHScroll(e) && this.onHScrollCommon(e);
    }, t.prototype.onHScroll = function() {
      var e = this.centerRowContainerCtrl.getViewportElement();
      this.isControllingHScroll(e) && this.onHScrollCommon(e);
    }, t.prototype.onHScrollCommon = function(e) {
      var r = this.centerRowContainerCtrl.getViewportElement(), o = r.scrollLeft;
      this.shouldBlockScrollUpdate("horizontal", o, !0) || (this.doHorizontalScroll(Math.round(Fi(e, this.enableRtl))), this.resetLastHScrollDebounced());
    }, t.prototype.onFakeVScroll = function() {
      var e = this.ctrlsService.getFakeVScrollComp().getViewport();
      this.isControllingVScroll(e) && this.onVScrollCommon(e);
    }, t.prototype.onVScroll = function() {
      this.isControllingVScroll(this.eBodyViewport) && this.onVScrollCommon(this.eBodyViewport);
    }, t.prototype.onVScrollCommon = function(e) {
      var r = e.scrollTop;
      if (!this.shouldBlockScrollUpdate("vertical", r, !0)) {
        if (this.animationFrameService.setScrollTop(r), this.nextScrollTop = r, e === this.eBodyViewport) {
          var o = this.ctrlsService.getFakeVScrollComp().getViewport();
          o.scrollTop = r;
        } else
          this.eBodyViewport.scrollTop = r;
        this.gridOptionsService.is("suppressAnimationFrame") ? this.scrollGridIfNeeded() : this.animationFrameService.schedule(), this.resetLastVScrollDebounced();
      }
    }, t.prototype.doHorizontalScroll = function(e) {
      var r = this.ctrlsService.getFakeHScrollComp().getViewport(), o = Fi(r, this.enableRtl);
      this.scrollLeft === e && e === o || (this.scrollLeft = e, this.fireScrollEvent("horizontal"), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.onHorizontalViewportChanged());
    }, t.prototype.fireScrollEvent = function(e) {
      var r = this, o = {
        type: m.EVENT_BODY_SCROLL,
        direction: e,
        left: this.scrollLeft,
        top: this.scrollTop
      };
      this.eventService.dispatchEvent(o), window.clearTimeout(this.scrollTimer), this.scrollTimer = void 0, this.scrollTimer = window.setTimeout(function() {
        var n = na(na({}, o), { type: m.EVENT_BODY_SCROLL_END });
        r.eventService.dispatchEvent(n);
      }, 100);
    }, t.prototype.shouldBlockScrollUpdate = function(e, r, o) {
      return o === void 0 && (o = !1), o && !jo() ? !1 : e === "vertical" ? this.shouldBlockVerticalScroll(r) : this.shouldBlockHorizontalScroll(r);
    }, t.prototype.shouldBlockVerticalScroll = function(e) {
      var r = ki(this.eBodyViewport), o = this.eBodyViewport.scrollHeight;
      return e < 0 || e + r > o;
    }, t.prototype.shouldBlockHorizontalScroll = function(e) {
      var r = this.centerRowContainerCtrl.getCenterWidth(), o = this.centerRowContainerCtrl.getViewportElement().scrollWidth;
      if (this.enableRtl && xi()) {
        if (e > 0)
          return !0;
      } else if (e < 0)
        return !0;
      return Math.abs(e) + r > o;
    }, t.prototype.redrawRowsAfterScroll = function() {
      this.fireScrollEvent("vertical");
    }, t.prototype.onHorizontalViewportChanged = function() {
      this.centerRowContainerCtrl.onHorizontalViewportChanged();
    }, t.prototype.checkScrollLeft = function() {
      this.scrollLeft !== this.centerRowContainerCtrl.getCenterViewportScrollLeft() && this.onHScrollCommon(this.centerRowContainerCtrl.getViewportElement());
    }, t.prototype.scrollGridIfNeeded = function() {
      var e = this.scrollTop != this.nextScrollTop;
      return e && (this.scrollTop = this.nextScrollTop, this.redrawRowsAfterScroll()), e;
    }, t.prototype.setHorizontalScrollPosition = function(e) {
      var r = 0, o = this.centerRowContainerCtrl.getViewportElement().scrollWidth - this.centerRowContainerCtrl.getCenterWidth();
      this.shouldBlockScrollUpdate("horizontal", e) && (this.enableRtl && xi() ? e = e > 0 ? 0 : o : e = Math.min(Math.max(e, r), o)), Qs(this.centerRowContainerCtrl.getViewportElement(), Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
    }, t.prototype.setVerticalScrollPosition = function(e) {
      this.eBodyViewport.scrollTop = e;
    }, t.prototype.getVScrollPosition = function() {
      var e = {
        top: this.eBodyViewport.scrollTop,
        bottom: this.eBodyViewport.scrollTop + this.eBodyViewport.offsetHeight
      };
      return e;
    }, t.prototype.getHScrollPosition = function() {
      return this.centerRowContainerCtrl.getHScrollPosition();
    }, t.prototype.isHorizontalScrollShowing = function() {
      return this.centerRowContainerCtrl.isHorizontalScrollShowing();
    }, t.prototype.scrollHorizontally = function(e) {
      var r = this.centerRowContainerCtrl.getViewportElement().scrollLeft;
      return this.setHorizontalScrollPosition(r + e), this.centerRowContainerCtrl.getViewportElement().scrollLeft - r;
    }, t.prototype.scrollToTop = function() {
      this.eBodyViewport.scrollTop = 0;
    }, t.prototype.ensureNodeVisible = function(e, r) {
      r === void 0 && (r = null);
      for (var o = this.rowModel.getRowCount(), n = -1, s = 0; s < o; s++) {
        var a = this.rowModel.getRow(s);
        if (typeof e == "function") {
          var l = e;
          if (a && l(a)) {
            n = s;
            break;
          }
        } else if (e === a || e === a.data) {
          n = s;
          break;
        }
      }
      n >= 0 && this.ensureIndexVisible(n, r);
    }, t.prototype.ensureIndexVisible = function(e, r) {
      if (!this.gridOptionsService.isDomLayout("print")) {
        var o = this.paginationProxy.getRowCount();
        if (typeof e != "number" || e < 0 || e >= o) {
          console.warn("AG Grid: Invalid row index for ensureIndexVisible: " + e);
          return;
        }
        var n = this.gridOptionsService.is("pagination"), s = n && !this.gridOptionsService.is("suppressPaginationPanel");
        s || this.paginationProxy.goToPageWithIndex(e);
        var a = this.ctrlsService.getGridBodyCtrl(), l = a.getStickyTopHeight(), u = this.paginationProxy.getRow(e), c;
        do {
          var p = u.rowTop, d = u.rowHeight, h = this.paginationProxy.getPixelOffset(), g = u.rowTop - h, y = g + u.rowHeight, S = this.getVScrollPosition(), _ = this.heightScaler.getDivStretchOffset(), w = S.top + _, E = S.bottom + _, R = E - w, D = this.heightScaler.getScrollPositionForPixel(g), B = this.heightScaler.getScrollPositionForPixel(y - R), H = Math.min((D + B) / 2, g), A = w + l > g, N = E < y, G = null;
          r === "top" ? G = D : r === "bottom" ? G = B : r === "middle" ? G = H : A ? G = D - l : N && (G = B), G !== null && (this.eBodyViewport.scrollTop = G, this.rowRenderer.redrawAfterScroll()), c = p !== u.rowTop || d !== u.rowHeight;
        } while (c);
        this.animationFrameService.flushAllFrames();
      }
    }, t.prototype.ensureColumnVisible = function(e, r) {
      r === void 0 && (r = "auto");
      var o = this.columnModel.getGridColumn(e);
      if (o && !o.isPinned() && this.columnModel.isColumnDisplayed(o)) {
        var n = this.getPositionedHorizontalScroll(o, r);
        n !== null && this.centerRowContainerCtrl.setCenterViewportScrollLeft(n), this.centerRowContainerCtrl.onHorizontalViewportChanged(), this.animationFrameService.flushAllFrames();
      }
    }, t.prototype.getPositionedHorizontalScroll = function(e, r) {
      var o = this.isColumnOutsideViewport(e), n = o.columnBeforeStart, s = o.columnAfterEnd, a = this.centerRowContainerCtrl.getCenterWidth() < e.getActualWidth(), l = this.centerRowContainerCtrl.getCenterWidth(), u = this.enableRtl, c = (u ? n : s) || a, p = u ? s : n;
      r !== "auto" && (c = r === "start", p = r === "end");
      var d = r === "middle";
      if (c || p || d) {
        var h = this.getColumnBounds(e), g = h.colLeft, y = h.colMiddle, S = h.colRight;
        return d ? y - l / 2 : c ? u ? S : g : u ? g - l : S - l;
      }
      return null;
    }, t.prototype.isColumnOutsideViewport = function(e) {
      var r = this.getViewportBounds(), o = r.start, n = r.end, s = this.getColumnBounds(e), a = s.colLeft, l = s.colRight, u = this.enableRtl, c = u ? o > l : n < l, p = u ? n < a : o > a;
      return { columnBeforeStart: c, columnAfterEnd: p };
    }, t.prototype.getColumnBounds = function(e) {
      var r = this.enableRtl, o = this.columnModel.getBodyContainerWidth(), n = e.getActualWidth(), s = e.getLeft(), a = r ? -1 : 1, l = r ? o - s : s, u = l + n * a, c = l + n / 2 * a;
      return { colLeft: l, colMiddle: c, colRight: u };
    }, t.prototype.getViewportBounds = function() {
      var e = this.centerRowContainerCtrl.getCenterWidth(), r = this.centerRowContainerCtrl.getCenterViewportScrollLeft(), o = r, n = e + r;
      return { start: o, end: n, width: e };
    }, Po([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Po([
      v("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), Po([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Po([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Po([
      v("rowContainerHeightService")
    ], t.prototype, "heightScaler", void 0), Po([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Po([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Po([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Nh = (
  /** @class */
  function() {
    function i(t) {
      this.tickingInterval = null, this.onScrollCallback = null, this.scrollContainer = t.scrollContainer, this.scrollHorizontally = t.scrollAxis.indexOf("x") !== -1, this.scrollVertically = t.scrollAxis.indexOf("y") !== -1, this.scrollByTick = t.scrollByTick != null ? t.scrollByTick : 20, t.onScrollCallback && (this.onScrollCallback = t.onScrollCallback), this.scrollVertically && (this.getVerticalPosition = t.getVerticalPosition, this.setVerticalPosition = t.setVerticalPosition), this.scrollHorizontally && (this.getHorizontalPosition = t.getHorizontalPosition, this.setHorizontalPosition = t.setHorizontalPosition), this.shouldSkipVerticalScroll = t.shouldSkipVerticalScroll || function() {
        return !1;
      }, this.shouldSkipHorizontalScroll = t.shouldSkipHorizontalScroll || function() {
        return !1;
      };
    }
    return i.prototype.check = function(t, e) {
      e === void 0 && (e = !1);
      var r = e || this.shouldSkipVerticalScroll();
      if (!(r && this.shouldSkipHorizontalScroll())) {
        var o = this.scrollContainer.getBoundingClientRect(), n = this.scrollByTick;
        this.tickLeft = t.clientX < o.left + n, this.tickRight = t.clientX > o.right - n, this.tickUp = t.clientY < o.top + n && !r, this.tickDown = t.clientY > o.bottom - n && !r, this.tickLeft || this.tickRight || this.tickUp || this.tickDown ? this.ensureTickingStarted() : this.ensureCleared();
      }
    }, i.prototype.ensureTickingStarted = function() {
      this.tickingInterval === null && (this.tickingInterval = window.setInterval(this.doTick.bind(this), 100), this.tickCount = 0);
    }, i.prototype.doTick = function() {
      this.tickCount++;
      var t;
      if (t = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40, this.scrollVertically) {
        var e = this.getVerticalPosition();
        this.tickUp && this.setVerticalPosition(e - t), this.tickDown && this.setVerticalPosition(e + t);
      }
      if (this.scrollHorizontally) {
        var r = this.getHorizontalPosition();
        this.tickLeft && this.setHorizontalPosition(r - t), this.tickRight && this.setHorizontalPosition(r + t);
      }
      this.onScrollCallback && this.onScrollCallback();
    }, i.prototype.ensureCleared = function() {
      this.tickingInterval && (window.clearInterval(this.tickingInterval), this.tickingInterval = null);
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var DS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gu = function() {
  return gu = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, gu.apply(this, arguments);
}, gr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, AS = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, xS = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(AS(arguments[t]));
  return i;
}, FS = (
  /** @class */
  function(i) {
    DS(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.isMultiRowDrag = !1, r.isGridSorted = !1, r.isGridFiltered = !1, r.isRowGroupActive = !1, r.eContainer = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.gridOptionsService.isRowModelType("clientSide") && (this.clientSideRowModel = this.rowModel);
      var r = function() {
        e.onSortChanged(), e.onFilterChanged(), e.onRowGroupChanged();
      };
      this.addManagedListener(this.eventService, m.EVENT_SORT_CHANGED, this.onSortChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_MODEL_UPDATED, function() {
        r();
      }), r(), this.ctrlsService.whenReady(function() {
        var o = e.ctrlsService.getGridBodyCtrl();
        e.autoScrollService = new Nh({
          scrollContainer: o.getBodyViewportElement(),
          scrollAxis: "y",
          getVerticalPosition: function() {
            return o.getScrollFeature().getVScrollPosition().top;
          },
          setVerticalPosition: function(n) {
            return o.getScrollFeature().setVerticalScrollPosition(n);
          },
          onScrollCallback: function() {
            e.onDragging(e.lastDraggingEvent);
          }
        });
      });
    }, t.prototype.onSortChanged = function() {
      this.isGridSorted = this.sortController.isSortActive();
    }, t.prototype.onFilterChanged = function() {
      this.isGridFiltered = this.filterManager.isAnyFilterPresent();
    }, t.prototype.onRowGroupChanged = function() {
      var e = this.columnModel.getRowGroupColumns();
      this.isRowGroupActive = !cr(e);
    }, t.prototype.getContainer = function() {
      return this.eContainer;
    }, t.prototype.isInterestedIn = function(e) {
      return e === kt.RowDrag;
    }, t.prototype.getIconName = function() {
      var e = this.gridOptionsService.is("rowDragManaged");
      return e && this.shouldPreventRowMove() ? Tt.ICON_NOT_ALLOWED : Tt.ICON_MOVE;
    }, t.prototype.shouldPreventRowMove = function() {
      return this.isGridSorted || this.isGridFiltered || this.isRowGroupActive;
    }, t.prototype.getRowNodes = function(e) {
      var r = this;
      if (!this.isFromThisGrid(e))
        return e.dragItem.rowNodes || [];
      var o = this.gridOptionsService.is("rowDragMultiRow"), n = xS(this.selectionService.getSelectedNodes()).sort(function(a, l) {
        return a.rowIndex == null || l.rowIndex == null ? 0 : r.getRowIndexNumber(a) - r.getRowIndexNumber(l);
      }), s = e.dragItem.rowNode;
      return o && n.indexOf(s) !== -1 ? (this.isMultiRowDrag = !0, n) : (this.isMultiRowDrag = !1, [s]);
    }, t.prototype.onDragEnter = function(e) {
      e.dragItem.rowNodes = this.getRowNodes(e), this.dispatchGridEvent(m.EVENT_ROW_DRAG_ENTER, e), this.getRowNodes(e).forEach(function(r) {
        r.setDragging(!0);
      }), this.onEnterOrDragging(e);
    }, t.prototype.onDragging = function(e) {
      this.onEnterOrDragging(e);
    }, t.prototype.isFromThisGrid = function(e) {
      var r = e.dragSource.dragSourceDomDataKey;
      return r === this.gridOptionsService.getDomDataKey();
    }, t.prototype.isDropZoneWithinThisGrid = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), o = r.getGui(), n = e.dropZoneTarget;
      return !o.contains(n);
    }, t.prototype.onEnterOrDragging = function(e) {
      this.dispatchGridEvent(m.EVENT_ROW_DRAG_MOVE, e), this.lastDraggingEvent = e;
      var r = this.mouseEventService.getNormalisedPosition(e).y, o = this.gridOptionsService.is("rowDragManaged");
      o && this.doManagedDrag(e, r), this.autoScrollService.check(e.event);
    }, t.prototype.doManagedDrag = function(e, r) {
      var o = this.isFromThisGrid(e), n = this.gridOptionsService.is("rowDragManaged"), s = e.dragItem.rowNodes;
      n && this.shouldPreventRowMove() || (this.gridOptionsService.is("suppressMoveWhenRowDragging") || !o ? this.isDropZoneWithinThisGrid(e) || this.clientSideRowModel.highlightRowAtPixel(s[0], r) : this.moveRows(s, r));
    }, t.prototype.getRowIndexNumber = function(e) {
      return parseInt(Ne(e.getRowIndexString().split("-")), 10);
    }, t.prototype.moveRowAndClearHighlight = function(e) {
      var r = this, o = this.clientSideRowModel.getLastHighlightedRowNode(), n = o && o.highlighted === no.Below, s = this.mouseEventService.getNormalisedPosition(e).y, a = e.dragItem.rowNodes, l = n ? 1 : 0;
      if (this.isFromThisGrid(e))
        a.forEach(function(p) {
          p.rowTop < s && (l -= 1);
        }), this.moveRows(a, s, l);
      else {
        var u = this.gridOptionsService.getRowIdFunc(), c = this.clientSideRowModel.getRowIndexAtPixel(s) + 1;
        this.clientSideRowModel.getHighlightPosition(s) === no.Above && c--, this.clientSideRowModel.updateRowData({
          add: a.map(function(p) {
            return p.data;
          }).filter(function(p) {
            return !r.clientSideRowModel.getRowNode(u ? u({ data: p, level: 0 }) : p.id);
          }),
          addIndex: c
        });
      }
      this.clearRowHighlight();
    }, t.prototype.clearRowHighlight = function() {
      this.clientSideRowModel.highlightRowAtPixel(null);
    }, t.prototype.moveRows = function(e, r, o) {
      o === void 0 && (o = 0);
      var n = this.clientSideRowModel.ensureRowsAtPixel(e, r, o);
      n && (this.focusService.clearFocusedCell(), this.rangeService && this.rangeService.removeAllCellRanges());
    }, t.prototype.addRowDropZone = function(e) {
      var r = this;
      if (!e.getContainer()) {
        Pe(function() {
          return console.warn("AG Grid: addRowDropZone - A container target needs to be provided");
        }, "add-drop-zone-empty-target");
        return;
      }
      if (this.dragAndDropService.findExternalZone(e)) {
        console.warn("AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.");
        return;
      }
      var o = {
        getContainer: e.getContainer
      };
      e.fromGrid ? (e.fromGrid = void 0, o = e) : (e.onDragEnter && (o.onDragEnter = function(n) {
        e.onDragEnter(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_ENTER, n));
      }), e.onDragLeave && (o.onDragLeave = function(n) {
        e.onDragLeave(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_LEAVE, n));
      }), e.onDragging && (o.onDragging = function(n) {
        e.onDragging(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_MOVE, n));
      }), e.onDragStop && (o.onDragStop = function(n) {
        e.onDragStop(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_END, n));
      })), this.dragAndDropService.addDropTarget(gu({ isInterestedIn: function(n) {
        return n === kt.RowDrag;
      }, getIconName: function() {
        return Tt.ICON_MOVE;
      }, external: !0 }, o));
    }, t.prototype.getRowDropZone = function(e) {
      var r = this, o = this.getContainer.bind(this), n = this.onDragEnter.bind(this), s = this.onDragLeave.bind(this), a = this.onDragging.bind(this), l = this.onDragStop.bind(this);
      return e ? {
        getContainer: o,
        onDragEnter: e.onDragEnter ? function(u) {
          n(u), e.onDragEnter(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_ENTER, u));
        } : n,
        onDragLeave: e.onDragLeave ? function(u) {
          s(u), e.onDragLeave(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_LEAVE, u));
        } : s,
        onDragging: e.onDragging ? function(u) {
          a(u), e.onDragging(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_MOVE, u));
        } : a,
        onDragStop: e.onDragStop ? function(u) {
          l(u), e.onDragStop(r.draggingToRowDragEvent(m.EVENT_ROW_DRAG_END, u));
        } : l,
        fromGrid: !0
        /* @private */
      } : {
        getContainer: o,
        onDragEnter: n,
        onDragLeave: s,
        onDragging: a,
        onDragStop: l,
        /* @private */
        fromGrid: !0
      };
    }, t.prototype.draggingToRowDragEvent = function(e, r) {
      var o = this.mouseEventService.getNormalisedPosition(r).y, n = o > this.paginationProxy.getCurrentPageHeight(), s = -1, a;
      n || (s = this.rowModel.getRowIndexAtPixel(o), a = this.rowModel.getRow(s));
      var l;
      switch (r.vDirection) {
        case vn.Down:
          l = "down";
          break;
        case vn.Up:
          l = "up";
          break;
        default:
          l = null;
          break;
      }
      var u = {
        type: e,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context,
        event: r.event,
        node: r.dragItem.rowNode,
        nodes: r.dragItem.rowNodes,
        overIndex: s,
        overNode: a,
        y: o,
        vDirection: l
      };
      return u;
    }, t.prototype.dispatchGridEvent = function(e, r) {
      var o = this.draggingToRowDragEvent(e, r);
      this.eventService.dispatchEvent(o);
    }, t.prototype.onDragLeave = function(e) {
      this.dispatchGridEvent(m.EVENT_ROW_DRAG_LEAVE, e), this.stopDragging(e), this.gridOptionsService.is("rowDragManaged") && this.clearRowHighlight(), this.isFromThisGrid(e) && (this.isMultiRowDrag = !1);
    }, t.prototype.onDragStop = function(e) {
      this.dispatchGridEvent(m.EVENT_ROW_DRAG_END, e), this.stopDragging(e), this.gridOptionsService.is("rowDragManaged") && (this.gridOptionsService.is("suppressMoveWhenRowDragging") || !this.isFromThisGrid(e)) && !this.isDropZoneWithinThisGrid(e) && this.moveRowAndClearHighlight(e);
    }, t.prototype.stopDragging = function(e) {
      this.autoScrollService.ensureCleared(), this.getRowNodes(e).forEach(function(r) {
        r.setDragging(!1);
      });
    }, gr([
      v("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), gr([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), gr([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), gr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), gr([
      v("focusService")
    ], t.prototype, "focusService", void 0), gr([
      v("sortController")
    ], t.prototype, "sortController", void 0), gr([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), gr([
      v("selectionService")
    ], t.prototype, "selectionService", void 0), gr([
      v("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), gr([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), gr([
      Fe("rangeService")
    ], t.prototype, "rangeService", void 0), gr([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var MS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), yr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, gn;
(function(i) {
  i.ANIMATION_ON = "ag-row-animation", i.ANIMATION_OFF = "ag-row-no-animation";
})(gn || (gn = {}));
var Gh = "ag-selectable", Hh = "ag-force-vertical-scroll", IS = "ag-column-moving", Vh = (
  /** @class */
  function(i) {
    MS(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.stickyTopHeight = 0, e;
    }
    return t.prototype.getScrollFeature = function() {
      return this.bodyScrollFeature;
    }, t.prototype.getBodyViewportElement = function() {
      return this.eBodyViewport;
    }, t.prototype.setComp = function(e, r, o, n, s, a) {
      this.comp = e, this.eGridBody = r, this.eBodyViewport = o, this.eTop = n, this.eBottom = s, this.eStickyTop = a, this.setCellTextSelection(this.gridOptionsService.is("enableCellTextSelection")), this.createManagedBean(new cc(this.comp)), this.bodyScrollFeature = this.createManagedBean(new PS(this.eBodyViewport)), this.addRowDragListener(), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([n, o, s, a]), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), this.ctrlsService.registerGridBodyCtrl(this);
    }, t.prototype.getComp = function() {
      return this.comp;
    }, t.prototype.addEventListeners = function() {
      this.addManagedListener(this.eventService, m.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }, t.prototype.addFocusListeners = function(e) {
      var r = this;
      e.forEach(function(o) {
        r.addManagedListener(o, "focusin", function(n) {
          var s = n.target, a = un(s, "ag-root", o);
          o.classList.toggle("ag-has-focus", !a);
        }), r.addManagedListener(o, "focusout", function(n) {
          var s = n.target, a = n.relatedTarget, l = o.contains(a), u = un(a, "ag-root", o), c = un(s, "ag-root", o);
          c || (!l || u) && o.classList.remove("ag-has-focus");
        });
      });
    }, t.prototype.setColumnMovingCss = function(e) {
      this.comp.setColumnMovingCss(IS, e);
    }, t.prototype.setCellTextSelection = function(e) {
      e === void 0 && (e = !1);
      var r = e ? Gh : null;
      this.comp.setCellSelectableCss(r, e);
    }, t.prototype.onScrollVisibilityChanged = function() {
      var e = this.scrollVisibleService.isVerticalScrollShowing();
      this.setVerticalScrollPaddingVisible(e), this.setStickyTopWidth(e);
      var r = e && this.gridOptionsService.getScrollbarWidth() || 0, o = kn() ? 16 : 0, n = "calc(100% + " + (r + o) + "px)";
      this.comp.setBodyViewportWidth(n);
    }, t.prototype.onGridColumnsChanged = function() {
      var e = this.columnModel.getAllGridColumns();
      this.comp.setColumnCount(e ? e.length : 0);
    }, t.prototype.disableBrowserDragging = function() {
      this.addManagedListener(this.eGridBody, "dragstart", function(e) {
        if (e.target instanceof HTMLImageElement)
          return e.preventDefault(), !1;
      });
    }, t.prototype.addStopEditingWhenGridLosesFocus = function() {
      var e = this;
      if (this.gridOptionsService.is("stopEditingWhenCellsLoseFocus")) {
        var r = function(n) {
          var s = n.relatedTarget;
          if (Xs(s) === null) {
            e.rowRenderer.stopEditing();
            return;
          }
          var a = (
            // see if click came from inside the viewports
            o.some(function(u) {
              return u.contains(s);
            }) && e.mouseEventService.isElementInThisGrid(s)
          );
          if (!a) {
            var l = e.popupService;
            a = l.getActivePopups().some(function(u) {
              return u.contains(s);
            }) || l.isElementWithinCustomPopup(s);
          }
          a || e.rowRenderer.stopEditing();
        }, o = [this.eBodyViewport, this.eBottom, this.eTop, this.eStickyTop];
        o.forEach(function(n) {
          return e.addManagedListener(n, "focusout", r);
        });
      }
    }, t.prototype.updateRowCount = function() {
      var e = this.headerNavigationService.getHeaderRowCount(), r = this.rowModel.isLastRowIndexKnown() ? this.rowModel.getRowCount() : -1, o = r === -1 ? -1 : e + r;
      this.comp.setRowCount(o);
    }, t.prototype.registerBodyViewportResizeListener = function(e) {
      this.comp.registerBodyViewportResizeListener(e);
    }, t.prototype.setVerticalScrollPaddingVisible = function(e) {
      var r = e ? "scroll" : "hidden";
      this.comp.setPinnedTopBottomOverflowY(r);
    }, t.prototype.isVerticalScrollShowing = function() {
      var e = this.gridOptionsService.is("alwaysShowVerticalScroll"), r = e ? Hh : null, o = this.gridOptionsService.isDomLayout("normal");
      return this.comp.setAlwaysVerticalScrollClass(r, e), e || o && qf(this.eBodyViewport);
    }, t.prototype.setupRowAnimationCssClass = function() {
      var e = this, r = function() {
        var o = e.gridOptionsService.isAnimateRows() && !e.rowContainerHeightService.isStretching(), n = o ? gn.ANIMATION_ON : gn.ANIMATION_OFF;
        e.comp.setRowAnimationCssOnBodyViewport(n, o);
      };
      r(), this.addManagedListener(this.eventService, m.EVENT_HEIGHT_SCALE_CHANGED, r), this.addManagedPropertyListener("animateRows", r);
    }, t.prototype.getGridBodyElement = function() {
      return this.eGridBody;
    }, t.prototype.addBodyViewportListener = function() {
      var e = this.onBodyViewportContextMenu.bind(this);
      this.addManagedListener(this.eBodyViewport, "contextmenu", e), this.mockContextMenuForIPad(e), this.addManagedListener(this.eBodyViewport, "wheel", this.onBodyViewportWheel.bind(this)), this.addManagedListener(this.eStickyTop, "wheel", this.onStickyTopWheel.bind(this)), this.addFullWidthContainerWheelListener();
    }, t.prototype.addFullWidthContainerWheelListener = function() {
      var e = this, r = this.eBodyViewport.querySelector(".ag-full-width-container"), o = this.eBodyViewport.querySelector(".ag-center-cols-viewport");
      r && o && this.addManagedListener(r, "wheel", function(n) {
        return e.onFullWidthContainerWheel(n, o);
      });
    }, t.prototype.onFullWidthContainerWheel = function(e, r) {
      !e.deltaX || Math.abs(e.deltaY) > Math.abs(e.deltaX) || (e.preventDefault(), r.scrollBy({ left: e.deltaX }));
    }, t.prototype.onBodyViewportContextMenu = function(e, r, o) {
      if (!(!e && !o)) {
        if (this.gridOptionsService.is("preventDefaultOnContextMenu")) {
          var n = e || o;
          n.preventDefault();
        }
        var s = (e || r).target;
        if (s === this.eBodyViewport || s === this.ctrlsService.getCenterRowContainerCtrl().getViewportElement()) {
          if (!this.contextMenuFactory)
            return;
          e ? this.contextMenuFactory.onContextMenu(e, null, null, null, null, this.eGridBody) : o && this.contextMenuFactory.onContextMenu(null, o, null, null, null, this.eGridBody);
        }
      }
    }, t.prototype.mockContextMenuForIPad = function(e) {
      if (jo()) {
        var r = new sr(this.eBodyViewport), o = function(n) {
          e(void 0, n.touchStart, n.touchEvent);
        };
        this.addManagedListener(r, sr.EVENT_LONG_TAP, o), this.addDestroyFunc(function() {
          return r.destroy();
        });
      }
    }, t.prototype.onBodyViewportWheel = function(e) {
      this.gridOptionsService.is("suppressScrollWhenPopupsAreOpen") && this.popupService.hasAnchoredPopup() && e.preventDefault();
    }, t.prototype.onStickyTopWheel = function(e) {
      e.preventDefault(), e.offsetY && this.scrollVertically(e.deltaY);
    }, t.prototype.getGui = function() {
      return this.eGridBody;
    }, t.prototype.scrollVertically = function(e) {
      var r = this.eBodyViewport.scrollTop;
      return this.bodyScrollFeature.setVerticalScrollPosition(r + e), this.eBodyViewport.scrollTop - r;
    }, t.prototype.addRowDragListener = function() {
      this.rowDragFeature = this.createManagedBean(new FS(this.eBodyViewport)), this.dragAndDropService.addDropTarget(this.rowDragFeature);
    }, t.prototype.getRowDragFeature = function() {
      return this.rowDragFeature;
    }, t.prototype.onPinnedRowDataChanged = function() {
      this.setFloatingHeights();
    }, t.prototype.setFloatingHeights = function() {
      var e = this.pinnedRowModel, r = e.getPinnedTopTotalHeight();
      r && (r += 1);
      var o = e.getPinnedBottomTotalHeight();
      o && (o += 1), this.comp.setTopHeight(r), this.comp.setBottomHeight(o), this.comp.setTopDisplay(r ? "inherit" : "none"), this.comp.setBottomDisplay(o ? "inherit" : "none"), this.setStickyTopOffsetTop();
    }, t.prototype.setStickyTopHeight = function(e) {
      e === void 0 && (e = 0), this.comp.setStickyTopHeight(e + "px"), this.stickyTopHeight = e;
    }, t.prototype.getStickyTopHeight = function() {
      return this.stickyTopHeight;
    }, t.prototype.setStickyTopWidth = function(e) {
      if (!e)
        this.comp.setStickyTopWidth("100%");
      else {
        var r = this.gridOptionsService.getScrollbarWidth();
        this.comp.setStickyTopWidth("calc(100% - " + r + "px)");
      }
    }, t.prototype.onHeaderHeightChanged = function() {
      this.setStickyTopOffsetTop();
    }, t.prototype.setStickyTopOffsetTop = function() {
      var e = this.ctrlsService.getGridHeaderCtrl(), r = e.getHeaderHeight(), o = this.pinnedRowModel.getPinnedTopTotalHeight(), n = 0;
      r > 0 && (n += r + 1), o > 0 && (n += o + 1), this.comp.setStickyTopTop(n + "px");
    }, t.prototype.sizeColumnsToFit = function(e, r) {
      var o = this, n = this.isVerticalScrollShowing(), s = n ? this.gridOptionsService.getScrollbarWidth() : 0, a = Pa(this.eGridBody), l = a - s;
      if (l > 0) {
        this.columnModel.sizeColumnsToFit(l, "sizeColumnsToFit", !1, e);
        return;
      }
      r === void 0 ? window.setTimeout(function() {
        o.sizeColumnsToFit(e, 100);
      }, 0) : r === 100 ? window.setTimeout(function() {
        o.sizeColumnsToFit(e, 500);
      }, 100) : r === 500 ? window.setTimeout(function() {
        o.sizeColumnsToFit(e, -1);
      }, 500) : console.warn("AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?");
    }, t.prototype.addScrollEventListener = function(e) {
      this.eBodyViewport.addEventListener("scroll", e, { passive: !0 });
    }, t.prototype.removeScrollEventListener = function(e) {
      this.eBodyViewport.removeEventListener("scroll", e);
    }, yr([
      v("rowContainerHeightService")
    ], t.prototype, "rowContainerHeightService", void 0), yr([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), yr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), yr([
      v("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), yr([
      Fe("contextMenuFactory")
    ], t.prototype, "contextMenuFactory", void 0), yr([
      v("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), yr([
      v("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), yr([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), yr([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), yr([
      v("popupService")
    ], t.prototype, "popupService", void 0), yr([
      v("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), yr([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ni;
(function(i) {
  i[i.FILL = 0] = "FILL", i[i.RANGE = 1] = "RANGE";
})(Ni || (Ni = {}));
var ln;
(function(i) {
  i[i.VALUE = 0] = "VALUE", i[i.DIMENSION = 1] = "DIMENSION";
})(ln || (ln = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ii = "ag-cell-range-selected", LS = "ag-cell-range-chart", NS = "ag-cell-range-single-cell", GS = "ag-cell-range-chart-category", HS = "ag-cell-range-handle", VS = "ag-cell-range-top", BS = "ag-cell-range-right", kS = "ag-cell-range-bottom", jS = "ag-cell-range-left", WS = (
  /** @class */
  function() {
    function i(t, e) {
      this.beans = t, this.cellCtrl = e;
    }
    return i.prototype.setComp = function(t, e) {
      this.cellComp = t, this.eGui = e, this.onRangeSelectionChanged();
    }, i.prototype.onRangeSelectionChanged = function() {
      this.cellComp && (this.rangeCount = this.beans.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition()), this.hasChartRange = this.getHasChartRange(), this.cellComp.addOrRemoveCssClass(ii, this.rangeCount !== 0), this.cellComp.addOrRemoveCssClass(ii + "-1", this.rangeCount === 1), this.cellComp.addOrRemoveCssClass(ii + "-2", this.rangeCount === 2), this.cellComp.addOrRemoveCssClass(ii + "-3", this.rangeCount === 3), this.cellComp.addOrRemoveCssClass(ii + "-4", this.rangeCount >= 4), this.cellComp.addOrRemoveCssClass(LS, this.hasChartRange), $n(this.eGui, this.rangeCount > 0 ? !0 : void 0), this.cellComp.addOrRemoveCssClass(NS, this.isSingleCell()), this.updateRangeBorders(), this.refreshHandle());
    }, i.prototype.updateRangeBorders = function() {
      var t = this.getRangeBorders(), e = this.isSingleCell(), r = !e && t.top, o = !e && t.right, n = !e && t.bottom, s = !e && t.left;
      this.cellComp.addOrRemoveCssClass(VS, r), this.cellComp.addOrRemoveCssClass(BS, o), this.cellComp.addOrRemoveCssClass(kS, n), this.cellComp.addOrRemoveCssClass(jS, s);
    }, i.prototype.isSingleCell = function() {
      var t = this.beans.rangeService;
      return this.rangeCount === 1 && t && !t.isMoreThanOneCell();
    }, i.prototype.getHasChartRange = function() {
      var t = this.beans.rangeService;
      if (!this.rangeCount || !t)
        return !1;
      var e = t.getCellRanges();
      return e.length > 0 && e.every(function(r) {
        return _r([ln.DIMENSION, ln.VALUE], r.type);
      });
    }, i.prototype.updateRangeBordersIfRangeCount = function() {
      this.rangeCount > 0 && (this.updateRangeBorders(), this.refreshHandle());
    }, i.prototype.getRangeBorders = function() {
      var t = this, e = this.beans.gridOptionsService.is("enableRtl"), r = !1, o = !1, n = !1, s = !1, a = this.cellCtrl.getCellPosition().column, l = this.beans, u = l.rangeService, c = l.columnModel, p, d;
      e ? (p = c.getDisplayedColAfter(a), d = c.getDisplayedColBefore(a)) : (p = c.getDisplayedColBefore(a), d = c.getDisplayedColAfter(a));
      var h = u.getCellRanges().filter(function(w) {
        return u.isCellInSpecificRange(t.cellCtrl.getCellPosition(), w);
      });
      p || (s = !0), d || (o = !0);
      for (var g = 0; g < h.length && !(r && o && n && s); g++) {
        var y = h[g], S = u.getRangeStartRow(y), _ = u.getRangeEndRow(y);
        !r && this.beans.rowPositionUtils.sameRow(S, this.cellCtrl.getCellPosition()) && (r = !0), !n && this.beans.rowPositionUtils.sameRow(_, this.cellCtrl.getCellPosition()) && (n = !0), !s && p && y.columns.indexOf(p) < 0 && (s = !0), !o && d && y.columns.indexOf(d) < 0 && (o = !0);
      }
      return { top: r, right: o, bottom: n, left: s };
    }, i.prototype.refreshHandle = function() {
      if (this.beans.rangeService) {
        var t = this.shouldHaveSelectionHandle();
        this.selectionHandle && !t && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), t && this.addSelectionHandle(), this.cellComp.addOrRemoveCssClass(HS, !!this.selectionHandle);
      }
    }, i.prototype.shouldHaveSelectionHandle = function() {
      var t = this.beans, e = t.gridOptionsService, r = t.rangeService, o = r.getCellRanges(), n = o.length;
      if (this.rangeCount < 1 || n < 1)
        return !1;
      var s = Ne(o), a = this.cellCtrl.getCellPosition(), l = e.is("enableFillHandle") && !this.cellCtrl.isSuppressFillHandle(), u = e.is("enableRangeHandle"), c = n === 1 && !this.cellCtrl.isEditing() && (l || u);
      if (this.hasChartRange) {
        var p = o[0].type === ln.DIMENSION, d = p && r.isCellInSpecificRange(a, o[0]);
        this.cellComp.addOrRemoveCssClass(GS, d), c = s.type === ln.VALUE;
      }
      return c && s.endRow != null && r.isContiguousRange(s) && r.isBottomRightCell(s, a);
    }, i.prototype.addSelectionHandle = function() {
      var t = this.beans, e = t.gridOptionsService, r = t.rangeService, o = Ne(r.getCellRanges()).type, n = e.is("enableFillHandle") && ue(o), s = n ? Ni.FILL : Ni.RANGE;
      this.selectionHandle && this.selectionHandle.getType() !== s && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), this.selectionHandle || (this.selectionHandle = this.beans.selectionHandleFactory.createSelectionHandle(s)), this.selectionHandle.refresh(this.cellCtrl);
    }, i.prototype.destroy = function() {
      this.beans.context.destroyBean(this.selectionHandle);
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var US = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zS = (
  /** @class */
  function(i) {
    US(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.cellCtrl = e, o.beans = r, o.column = e.getColumn(), o.rowNode = e.getRowNode(), o.setupColSpan(), o.setupRowSpan(), o;
    }
    return t.prototype.setupRowSpan = function() {
      this.rowSpan = this.column.getRowSpan(this.rowNode);
    }, t.prototype.setComp = function(e) {
      this.eGui = e, this.onLeftChanged(), this.onWidthChanged(), this.applyRowSpan();
    }, t.prototype.onDisplayColumnsChanged = function() {
      var e = this.getColSpanningList();
      No(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
    }, t.prototype.setupColSpan = function() {
      this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListener(this.beans.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this)), this.addManagedListener(this.beans.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this)));
    }, t.prototype.onWidthChanged = function() {
      if (this.eGui) {
        var e = this.getCellWidth();
        this.eGui.style.width = e + "px";
      }
    }, t.prototype.getCellWidth = function() {
      return this.colsSpanning ? this.colsSpanning.reduce(function(e, r) {
        return e + r.getActualWidth();
      }, 0) : this.column.getActualWidth();
    }, t.prototype.getColSpanningList = function() {
      var e = this.column.getColSpan(this.rowNode), r = [];
      if (e === 1)
        r.push(this.column);
      else
        for (var o = this.column, n = this.column.getPinned(), s = 0; o && s < e && (r.push(o), o = this.beans.columnModel.getDisplayedColAfter(o), !(!o || ue(o) || n !== o.getPinned())); s++)
          ;
      return r;
    }, t.prototype.onLeftChanged = function() {
      if (this.eGui) {
        var e = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eGui.style.left = e + "px";
      }
    }, t.prototype.getCellLeft = function() {
      var e;
      return this.beans.gridOptionsService.is("enableRtl") && this.colsSpanning ? e = Ne(this.colsSpanning) : e = this.column, e.getLeft();
    }, t.prototype.modifyLeftForPrintLayout = function(e) {
      if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === "left")
        return e;
      var r = this.beans.columnModel.getDisplayedColumnsLeftWidth();
      if (this.column.getPinned() === "right") {
        var o = this.beans.columnModel.getBodyContainerWidth();
        return r + o + (e || 0);
      }
      return r + (e || 0);
    }, t.prototype.applyRowSpan = function() {
      if (this.rowSpan !== 1) {
        var e = this.beans.gridOptionsService.getRowHeightAsNumber(), r = e * this.rowSpan;
        this.eGui.style.height = r + "px", this.eGui.style.zIndex = "1";
      }
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var $S = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), KS = (
  /** @class */
  function(i) {
    $S(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.staticClasses = [], o.cellCtrl = e, o.beans = r, o.column = e.getColumn(), o.rowNode = e.getRowNode(), o;
    }
    return t.prototype.setComp = function(e) {
      this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
    }, t.prototype.applyCellClassRules = function() {
      var e = this, r = this.column.getColDef(), o = {
        value: this.cellCtrl.getValue(),
        data: this.rowNode.data,
        node: this.rowNode,
        colDef: r,
        column: this.column,
        rowIndex: this.rowNode.rowIndex,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi,
        context: this.beans.gridOptionsService.context
      };
      this.beans.stylingService.processClassRules(r.cellClassRules, o, function(n) {
        return e.cellComp.addOrRemoveCssClass(n, !0);
      }, function(n) {
        return e.cellComp.addOrRemoveCssClass(n, !1);
      });
    }, t.prototype.applyUserStyles = function() {
      var e = this.column.getColDef();
      if (e.cellStyle) {
        var r;
        if (typeof e.cellStyle == "function") {
          var o = {
            column: this.column,
            value: this.cellCtrl.getValue(),
            colDef: e,
            data: this.rowNode.data,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            api: this.beans.gridOptionsService.api,
            columnApi: this.beans.gridOptionsService.columnApi,
            context: this.beans.gridOptionsService.context
          }, n = e.cellStyle;
          r = n(o);
        } else
          r = e.cellStyle;
        r && this.cellComp.setUserStyles(r);
      }
    }, t.prototype.applyClassesFromColDef = function() {
      var e = this, r = this.column.getColDef(), o = {
        value: this.cellCtrl.getValue(),
        data: this.rowNode.data,
        node: this.rowNode,
        column: this.column,
        colDef: r,
        rowIndex: this.rowNode.rowIndex,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi,
        context: this.beans.gridOptionsService.context
      };
      this.staticClasses.length && this.staticClasses.forEach(function(n) {
        return e.cellComp.addOrRemoveCssClass(n, !1);
      }), this.staticClasses = this.beans.stylingService.getStaticCellClasses(r, o), this.staticClasses.length && this.staticClasses.forEach(function(n) {
        return e.cellComp.addOrRemoveCssClass(n, !0);
      });
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var YS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pc = (
  /** @class */
  function(i) {
    YS(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.ctrl = e, o.beans = r, o;
    }
    return t.prototype.setComp = function(e) {
      this.comp = e, this.setupTooltip();
    }, t.prototype.setupTooltip = function() {
      this.browserTooltips = this.beans.gridOptionsService.is("enableBrowserTooltips"), this.updateTooltipText(), this.browserTooltips ? this.comp.setTitle(this.tooltip != null ? this.tooltip : void 0) : this.createTooltipFeatureIfNeeded();
    }, t.prototype.updateTooltipText = function() {
      this.tooltip = this.ctrl.getTooltipValue();
    }, t.prototype.createTooltipFeatureIfNeeded = function() {
      var e = this;
      if (this.genericTooltipFeature == null) {
        var r = {
          getTooltipParams: function() {
            return e.getTooltipParams();
          },
          getGui: function() {
            return e.ctrl.getGui();
          }
        };
        this.genericTooltipFeature = this.createManagedBean(new Aa(r), this.beans.context);
      }
    }, t.prototype.refreshToolTip = function() {
      this.updateTooltipText(), this.browserTooltips && this.comp.setTitle(this.tooltip != null ? this.tooltip : void 0);
    }, t.prototype.getTooltipParams = function() {
      var e = this.ctrl, r = e.getColumn ? e.getColumn() : void 0, o = e.getColDef ? e.getColDef() : void 0, n = e.getRowNode ? e.getRowNode() : void 0;
      return {
        location: e.getLocation(),
        colDef: o,
        column: r,
        rowIndex: e.getRowIndex ? e.getRowIndex() : void 0,
        node: n,
        data: n ? n.data : void 0,
        value: this.getTooltipText(),
        valueFormatted: e.getValueFormatted ? e.getValueFormatted() : void 0
      };
    }, t.prototype.getTooltipText = function() {
      return this.tooltip;
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var he = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, dc = (
  /** @class */
  function() {
    function i() {
    }
    return i.prototype.postConstruct = function() {
      this.doingMasterDetail = this.gridOptionsService.isMasterDetail(), this.gridOptionsService.isRowModelType("clientSide") && (this.clientSideRowModel = this.rowModel), this.gridOptionsService.isRowModelType("serverSide") && (this.serverSideRowModel = this.rowModel);
    }, he([
      v("resizeObserverService")
    ], i.prototype, "resizeObserverService", void 0), he([
      v("paginationProxy")
    ], i.prototype, "paginationProxy", void 0), he([
      v("context")
    ], i.prototype, "context", void 0), he([
      v("columnApi")
    ], i.prototype, "columnApi", void 0), he([
      v("gridApi")
    ], i.prototype, "gridApi", void 0), he([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), he([
      v("expressionService")
    ], i.prototype, "expressionService", void 0), he([
      v("environment")
    ], i.prototype, "environment", void 0), he([
      v("rowRenderer")
    ], i.prototype, "rowRenderer", void 0), he([
      v("templateService")
    ], i.prototype, "templateService", void 0), he([
      v("valueService")
    ], i.prototype, "valueService", void 0), he([
      v("eventService")
    ], i.prototype, "eventService", void 0), he([
      v("columnModel")
    ], i.prototype, "columnModel", void 0), he([
      v("headerNavigationService")
    ], i.prototype, "headerNavigationService", void 0), he([
      v("navigationService")
    ], i.prototype, "navigationService", void 0), he([
      v("columnAnimationService")
    ], i.prototype, "columnAnimationService", void 0), he([
      Fe("rangeService")
    ], i.prototype, "rangeService", void 0), he([
      v("focusService")
    ], i.prototype, "focusService", void 0), he([
      Fe("contextMenuFactory")
    ], i.prototype, "contextMenuFactory", void 0), he([
      v("popupService")
    ], i.prototype, "popupService", void 0), he([
      v("valueFormatterService")
    ], i.prototype, "valueFormatterService", void 0), he([
      v("stylingService")
    ], i.prototype, "stylingService", void 0), he([
      v("columnHoverService")
    ], i.prototype, "columnHoverService", void 0), he([
      v("userComponentFactory")
    ], i.prototype, "userComponentFactory", void 0), he([
      v("userComponentRegistry")
    ], i.prototype, "userComponentRegistry", void 0), he([
      v("animationFrameService")
    ], i.prototype, "animationFrameService", void 0), he([
      v("dragService")
    ], i.prototype, "dragService", void 0), he([
      v("dragAndDropService")
    ], i.prototype, "dragAndDropService", void 0), he([
      v("sortController")
    ], i.prototype, "sortController", void 0), he([
      v("filterManager")
    ], i.prototype, "filterManager", void 0), he([
      v("rowContainerHeightService")
    ], i.prototype, "rowContainerHeightService", void 0), he([
      v("frameworkOverrides")
    ], i.prototype, "frameworkOverrides", void 0), he([
      v("cellPositionUtils")
    ], i.prototype, "cellPositionUtils", void 0), he([
      v("rowPositionUtils")
    ], i.prototype, "rowPositionUtils", void 0), he([
      v("selectionService")
    ], i.prototype, "selectionService", void 0), he([
      Fe("selectionHandleFactory")
    ], i.prototype, "selectionHandleFactory", void 0), he([
      v("rowCssClassCalculator")
    ], i.prototype, "rowCssClassCalculator", void 0), he([
      v("rowModel")
    ], i.prototype, "rowModel", void 0), he([
      v("ctrlsService")
    ], i.prototype, "ctrlsService", void 0), he([
      v("ctrlsFactory")
    ], i.prototype, "ctrlsFactory", void 0), he([
      v("agStackComponentsRegistry")
    ], i.prototype, "agStackComponentsRegistry", void 0), he([
      v("valueCache")
    ], i.prototype, "valueCache", void 0), he([
      v("rowNodeEventThrottle")
    ], i.prototype, "rowNodeEventThrottle", void 0), he([
      v("localeService")
    ], i.prototype, "localeService", void 0), he([
      U
    ], i.prototype, "postConstruct", null), i = he([
      te("beans")
    ], i), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var qS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), XS = (
  /** @class */
  function(i) {
    qS(t, i);
    function t(e, r, o) {
      var n = i.call(this) || this;
      return n.cellCtrl = e, n.beans = r, n.column = o, n;
    }
    return t.prototype.onMouseEvent = function(e, r) {
      if (!oo(r))
        switch (e) {
          case "click":
            this.onCellClicked(r);
            break;
          case "mousedown":
          case "touchstart":
            this.onMouseDown(r);
            break;
          case "dblclick":
            this.onCellDoubleClicked(r);
            break;
          case "mouseout":
            this.onMouseOut(r);
            break;
          case "mouseover":
            this.onMouseOver(r);
            break;
        }
    }, t.prototype.onCellClicked = function(e) {
      if (this.isDoubleClickOnIPad()) {
        this.onCellDoubleClicked(e), e.preventDefault();
        return;
      }
      var r = this.beans, o = r.eventService, n = r.rangeService, s = r.gridOptionsService, a = e.ctrlKey || e.metaKey;
      n && a && n.getCellRangeCount(this.cellCtrl.getCellPosition()) > 1 && n.intersectLastRange(!0);
      var l = this.cellCtrl.createEvent(e, m.EVENT_CELL_CLICKED);
      o.dispatchEvent(l);
      var u = this.column.getColDef();
      u.onCellClicked && window.setTimeout(function() {
        return u.onCellClicked(l);
      }, 0);
      var c = (s.is("singleClickEdit") || u.singleClickEdit) && !s.is("suppressClickEdit");
      c && this.cellCtrl.startRowOrCellEdit();
    }, t.prototype.isDoubleClickOnIPad = function() {
      if (!jo() || Fu("dblclick"))
        return !1;
      var e = (/* @__PURE__ */ new Date()).getTime(), r = e - this.lastIPadMouseClickEvent < 200;
      return this.lastIPadMouseClickEvent = e, r;
    }, t.prototype.onCellDoubleClicked = function(e) {
      var r = this.column.getColDef(), o = this.cellCtrl.createEvent(e, m.EVENT_CELL_DOUBLE_CLICKED);
      this.beans.eventService.dispatchEvent(o), typeof r.onCellDoubleClicked == "function" && window.setTimeout(function() {
        return r.onCellDoubleClicked(o);
      }, 0);
      var n = !this.beans.gridOptionsService.is("singleClickEdit") && !this.beans.gridOptionsService.is("suppressClickEdit");
      n && this.cellCtrl.startRowOrCellEdit(null, null, e);
    }, t.prototype.onMouseDown = function(e) {
      var r = e.ctrlKey, o = e.metaKey, n = e.shiftKey, s = e.target, a = this.beans, l = a.eventService, u = a.rangeService;
      if (!this.isRightClickInExistingRange(e)) {
        var c = u && u.getCellRanges().length != 0;
        if (!n || !c) {
          var p = ao() && !this.cellCtrl.isEditing() && !Ku(s);
          this.cellCtrl.focusCell(p);
        }
        if (n && c && e.preventDefault(), !this.containsWidget(s)) {
          if (u) {
            var d = this.cellCtrl.getCellPosition();
            if (n)
              u.extendLatestRangeToCell(d);
            else {
              var h = r || o;
              u.setRangeToCell(d, h);
            }
          }
          l.dispatchEvent(this.cellCtrl.createEvent(e, m.EVENT_CELL_MOUSE_DOWN));
        }
      }
    }, t.prototype.isRightClickInExistingRange = function(e) {
      var r = this.beans.rangeService;
      if (r) {
        var o = r.isCellInAnyRange(this.cellCtrl.getCellPosition());
        if (o && e.button === 2)
          return !0;
      }
      return !1;
    }, t.prototype.containsWidget = function(e) {
      return un(e, "ag-selection-checkbox", 3);
    }, t.prototype.onMouseOut = function(e) {
      if (!this.mouseStayingInsideCell(e)) {
        var r = this.cellCtrl.createEvent(e, m.EVENT_CELL_MOUSE_OUT);
        this.beans.eventService.dispatchEvent(r), this.beans.columnHoverService.clearMouseOver();
      }
    }, t.prototype.onMouseOver = function(e) {
      if (!this.mouseStayingInsideCell(e)) {
        var r = this.cellCtrl.createEvent(e, m.EVENT_CELL_MOUSE_OVER);
        this.beans.eventService.dispatchEvent(r), this.beans.columnHoverService.setMouseOver([this.column]);
      }
    }, t.prototype.mouseStayingInsideCell = function(e) {
      if (!e.target || !e.relatedTarget)
        return !1;
      var r = this.cellCtrl.getGui(), o = r.contains(e.target), n = r.contains(e.relatedTarget);
      return o && n;
    }, t.prototype.destroy = function() {
    }, t;
  }(dc)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var QS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), JS = (
  /** @class */
  function(i) {
    QS(t, i);
    function t(e, r, o, n, s) {
      var a = i.call(this) || this;
      return a.cellCtrl = e, a.beans = r, a.rowNode = n, a.rowCtrl = s, a;
    }
    return t.prototype.setComp = function(e) {
      this.eGui = e;
    }, t.prototype.onKeyDown = function(e) {
      var r = e.key;
      switch (r) {
        case L.ENTER:
          this.onEnterKeyDown(e);
          break;
        case L.F2:
          this.onF2KeyDown(e);
          break;
        case L.ESCAPE:
          this.onEscapeKeyDown(e);
          break;
        case L.TAB:
          this.onTabKeyDown(e);
          break;
        case L.BACKSPACE:
        case L.DELETE:
          this.onBackspaceOrDeleteKeyPressed(r, e);
          break;
        case L.DOWN:
        case L.UP:
        case L.RIGHT:
        case L.LEFT:
          this.onNavigationKeyPressed(e, r);
          break;
      }
    }, t.prototype.onNavigationKeyPressed = function(e, r) {
      this.cellCtrl.isEditing() || (e.shiftKey && this.cellCtrl.isRangeSelectionEnabled() ? this.onShiftRangeSelect(e) : this.beans.navigationService.navigateToNextCell(e, r, this.cellCtrl.getCellPosition(), !0), e.preventDefault());
    }, t.prototype.onShiftRangeSelect = function(e) {
      if (this.beans.rangeService) {
        var r = this.beans.rangeService.extendLatestRangeInDirection(e);
        r && this.beans.navigationService.ensureCellVisible(r);
      }
    }, t.prototype.onTabKeyDown = function(e) {
      this.beans.navigationService.onTabKeyDown(this.cellCtrl, e);
    }, t.prototype.onBackspaceOrDeleteKeyPressed = function(e, r) {
      var o = this, n = o.cellCtrl, s = o.beans, a = o.rowNode, l = s.gridOptionsService, u = s.rangeService, c = s.eventService;
      n.isEditing() || (c.dispatchEvent({ type: m.EVENT_KEY_SHORTCUT_CHANGED_CELL_START }), rh(e, l.is("enableCellEditingOnBackspace")) ? u && l.isEnableRangeSelection() ? u.clearCellRangeCellValues() : n.isCellEditable() && a.setDataValue(n.getColumn(), null, "cellClear") : n.startRowOrCellEdit(e, void 0, r), c.dispatchEvent({ type: m.EVENT_KEY_SHORTCUT_CHANGED_CELL_END }));
    }, t.prototype.onEnterKeyDown = function(e) {
      this.cellCtrl.isEditing() || this.rowCtrl.isEditing() ? this.cellCtrl.stopEditingAndFocus() : this.beans.gridOptionsService.is("enterMovesDown") ? this.beans.navigationService.navigateToNextCell(null, L.DOWN, this.cellCtrl.getCellPosition(), !1) : (this.cellCtrl.startRowOrCellEdit(L.ENTER, void 0, e), this.cellCtrl.isEditing() && e.preventDefault());
    }, t.prototype.onF2KeyDown = function(e) {
      this.cellCtrl.isEditing() || this.cellCtrl.startRowOrCellEdit(L.F2, void 0, e);
    }, t.prototype.onEscapeKeyDown = function(e) {
      this.cellCtrl.isEditing() && (this.cellCtrl.stopRowOrCellEdit(!0), this.cellCtrl.focusCell(!0));
    }, t.prototype.onKeyPress = function(e) {
      var r = e.target, o = r !== this.eGui;
      if (!(o || this.cellCtrl.isEditing())) {
        var n = String.fromCharCode(e.charCode);
        n === " " ? this.onSpaceKeyPressed(e) : Zf(e) && (this.cellCtrl.startRowOrCellEdit(null, n, e), e.preventDefault());
      }
    }, t.prototype.onSpaceKeyPressed = function(e) {
      var r = this.beans.gridOptionsService;
      if (!this.cellCtrl.isEditing() && r.isRowSelection()) {
        var o = this.rowNode.isSelected(), n = !o;
        if (n || !r.is("suppressRowDeselection")) {
          var s = this.beans.gridOptionsService.is("groupSelectsFiltered"), a = this.rowNode.setSelectedParams({
            newValue: n,
            rangeSelect: e.shiftKey,
            groupSelectsFiltered: s,
            event: e,
            source: "spacePressed"
          });
          o === void 0 && a === 0 && this.rowNode.setSelectedParams({
            newValue: !1,
            rangeSelect: e.shiftKey,
            groupSelectsFiltered: s,
            event: e,
            source: "spacePressed"
          });
        }
      }
      e.preventDefault();
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this);
    }, t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ZS = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), e_ = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, t_ = (
  /** @class */
  function(i) {
    ZS(t, i);
    function t(e, r, o, n) {
      var s = i.call(this, '<div class="ag-drag-handle ag-row-drag" draggable="true"></div>') || this;
      return s.rowNode = e, s.column = r, s.beans = o, s.eCell = n, s;
    }
    return t.prototype.postConstruct = function() {
      var e = this.getGui();
      e.appendChild(ut("rowDrag", this.beans.gridOptionsService, null)), this.addGuiEventListener("mousedown", function(r) {
        r.stopPropagation();
      }), this.addDragSource(), this.checkVisibility();
    }, t.prototype.addDragSource = function() {
      this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }, t.prototype.onDragStart = function(e) {
      var r = this, o = this.column.getColDef().dndSourceOnRowDrag;
      e.dataTransfer.setDragImage(this.eCell, 0, 0);
      var n = function() {
        try {
          var a = JSON.stringify(r.rowNode.data);
          e.dataTransfer.setData("application/json", a), e.dataTransfer.setData("text/plain", a);
        } catch {
        }
      };
      if (o) {
        var s = {
          rowNode: this.rowNode,
          dragEvent: e,
          api: this.gridOptionsService.api,
          columnApi: this.gridOptionsService.columnApi,
          context: this.gridOptionsService.context
        };
        o(s);
      } else
        n();
    }, t.prototype.checkVisibility = function() {
      var e = this.column.isDndSource(this.rowNode);
      this.setDisplayed(e);
    }, e_([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var r_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ia = function() {
  return ia = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ia.apply(this, arguments);
}, o_ = "ag-cell", n_ = "ag-cell-auto-height", i_ = "ag-cell-normal-height", s_ = "ag-cell-focus", a_ = "ag-cell-first-right-pinned", l_ = "ag-cell-last-left-pinned", u_ = "ag-cell-not-inline-editing", c_ = "ag-column-hover", p_ = "ag-cell-wrap-text", d_ = 0, Ho = (
  /** @class */
  function(i) {
    r_(t, i);
    function t(e, r, o, n) {
      var s = i.call(this) || this;
      return s.cellRangeFeature = null, s.cellPositionFeature = null, s.cellCustomStyleFeature = null, s.tooltipFeature = null, s.cellMouseListenerFeature = null, s.cellKeyboardListenerFeature = null, s.suppressRefreshCell = !1, s.onCellCompAttachedFuncs = [], s.column = e, s.rowNode = r, s.beans = o, s.rowCtrl = n, s.instanceId = e.getId() + "-" + d_++, s.createCellPosition(), s.addFeatures(), s;
    }
    return t.prototype.addFeatures = function() {
      var e = this;
      this.cellPositionFeature = new zS(this, this.beans), this.addDestroyFunc(function() {
        var o;
        (o = e.cellPositionFeature) === null || o === void 0 || o.destroy(), e.cellPositionFeature = null;
      }), this.cellCustomStyleFeature = new KS(this, this.beans), this.addDestroyFunc(function() {
        var o;
        (o = e.cellCustomStyleFeature) === null || o === void 0 || o.destroy(), e.cellCustomStyleFeature = null;
      }), this.cellMouseListenerFeature = new XS(this, this.beans, this.column), this.addDestroyFunc(function() {
        var o;
        (o = e.cellMouseListenerFeature) === null || o === void 0 || o.destroy(), e.cellMouseListenerFeature = null;
      }), this.cellKeyboardListenerFeature = new JS(this, this.beans, this.column, this.rowNode, this.rowCtrl), this.addDestroyFunc(function() {
        var o;
        (o = e.cellKeyboardListenerFeature) === null || o === void 0 || o.destroy(), e.cellKeyboardListenerFeature = null;
      });
      var r = this.beans.rangeService && this.beans.gridOptionsService.isEnableRangeSelection();
      r && (this.cellRangeFeature = new WS(this.beans, this), this.addDestroyFunc(function() {
        var o;
        (o = e.cellRangeFeature) === null || o === void 0 || o.destroy(), e.cellRangeFeature = null;
      })), this.column.isTooltipEnabled() && this.addTooltipFeature();
    }, t.prototype.addTooltipFeature = function() {
      var e = this, r = function() {
        var n = e.column.getColDef(), s = e.rowNode.data;
        if (n.tooltipField && k(s))
          return $s(s, n.tooltipField, e.column.isTooltipFieldContainsDots());
        var a = n.tooltipValueGetter;
        return a ? a({
          location: "cell",
          api: e.beans.gridOptionsService.api,
          columnApi: e.beans.gridOptionsService.columnApi,
          context: e.beans.gridOptionsService.context,
          colDef: e.column.getColDef(),
          column: e.column,
          rowIndex: e.cellPosition.rowIndex,
          node: e.rowNode,
          data: e.rowNode.data,
          value: e.value,
          valueFormatted: e.valueFormatted
        }) : null;
      }, o = {
        getColumn: function() {
          return e.column;
        },
        getColDef: function() {
          return e.column.getColDef();
        },
        getRowIndex: function() {
          return e.cellPosition.rowIndex;
        },
        getRowNode: function() {
          return e.rowNode;
        },
        getGui: function() {
          return e.getGui();
        },
        getLocation: function() {
          return "cell";
        },
        getTooltipValue: r,
        // this makes no sense, why is the cell formatted value passed to the tooltip???
        getValueFormatted: function() {
          return e.valueFormatted;
        }
      };
      this.tooltipFeature = new pc(o, this.beans), this.addDestroyFunc(function() {
        var n;
        (n = e.tooltipFeature) === null || n === void 0 || n.destroy(), e.tooltipFeature = null;
      });
    }, t.prototype.setComp = function(e, r, o, n, s) {
      var a, l, u, c;
      this.cellComp = e, this.eGui = r, this.printLayout = n, this.updateAndFormatValue(!0), this.addDomData(), this.onCellFocused(), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), o && this.setupAutoHeight(o), this.setAriaColIndex(), this.beans.gridOptionsService.is("suppressCellFocus") || this.cellComp.setTabIndex(-1);
      var p = so(this.column.getId());
      this.cellComp.setColId(p), this.cellComp.setRole("gridcell"), (a = this.cellPositionFeature) === null || a === void 0 || a.setComp(r), (l = this.cellCustomStyleFeature) === null || l === void 0 || l.setComp(e), (u = this.tooltipFeature) === null || u === void 0 || u.setComp(e), (c = this.cellKeyboardListenerFeature) === null || c === void 0 || c.setComp(this.eGui), this.cellRangeFeature && this.cellRangeFeature.setComp(e, r), s && this.isCellEditable() ? this.startEditing() : this.showValue(), this.onCellCompAttachedFuncs.length && (this.onCellCompAttachedFuncs.forEach(function(d) {
        return d();
      }), this.onCellCompAttachedFuncs = []);
    }, t.prototype.setupAutoHeight = function(e) {
      var r = this;
      if (this.column.isAutoHeight()) {
        var o = e.parentElement, n = this.beans.gridOptionsService.getRowHeightForNode(this.rowNode).height, s = function(u) {
          if (!r.editing && r.isAlive()) {
            var c = mn(o), p = c.paddingTop, d = c.paddingBottom, h = c.borderBottomWidth, g = c.borderTopWidth, y = p + d + h + g, S = e.offsetHeight, _ = S + y;
            if (u < 5) {
              var w = r.beans.gridOptionsService.getDocument(), E = !w || !w.contains(e), R = _ == 0;
              if (E || R) {
                r.beans.frameworkOverrides.setTimeout(function() {
                  return s(u + 1);
                }, 0);
                return;
              }
            }
            var D = Math.max(_, n);
            r.rowNode.setRowAutoHeight(D, r.column);
          }
        }, a = function() {
          return s(0);
        };
        a();
        var l = this.beans.resizeObserverService.observeResize(e, a);
        this.addDestroyFunc(function() {
          l(), r.rowNode.setRowAutoHeight(void 0, r.column);
        });
      }
    }, t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.showValue = function(e) {
      e === void 0 && (e = !1);
      var r = this.valueFormatted != null ? this.valueFormatted : this.value, o = this.createCellRendererParams(), n = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), o);
      this.cellComp.setRenderDetails(n, r, e), this.refreshHandle();
    }, t.prototype.setupControlComps = function() {
      var e = this.column.getColDef();
      this.includeSelection = this.isIncludeControl(e.checkboxSelection), this.includeRowDrag = this.isIncludeControl(e.rowDrag), this.includeDndSource = this.isIncludeControl(e.dndSource), this.cellComp.setIncludeSelection(this.includeSelection), this.cellComp.setIncludeDndSource(this.includeDndSource), this.cellComp.setIncludeRowDrag(this.includeRowDrag);
    }, t.prototype.isForceWrapper = function() {
      var e = this.beans.gridOptionsService.is("enableCellTextSelection") || this.column.isAutoHeight();
      return e;
    }, t.prototype.isIncludeControl = function(e) {
      var r = this.rowNode.rowPinned != null, o = typeof e == "function", n = r ? !1 : o || e === !0;
      return n;
    }, t.prototype.refreshShouldDestroy = function() {
      var e = this.column.getColDef(), r = this.includeSelection != this.isIncludeControl(e.checkboxSelection), o = this.includeRowDrag != this.isIncludeControl(e.rowDrag), n = this.includeDndSource != this.isIncludeControl(e.dndSource);
      return r || o || n;
    }, t.prototype.startEditing = function(e, r, o, n) {
      var s = this;
      if (e === void 0 && (e = null), r === void 0 && (r = null), o === void 0 && (o = !1), n === void 0 && (n = null), !(!this.isCellEditable() || this.editing)) {
        if (!this.cellComp) {
          this.onCellCompAttachedFuncs.push(function() {
            s.startEditing(e, r, o, n);
          });
          return;
        }
        var a = this.createCellEditorParams(e, r, o), l = this.column.getColDef(), u = this.beans.userComponentFactory.getCellEditorDetails(l, a), c = (u == null ? void 0 : u.popupFromSelector) != null ? u.popupFromSelector : !!l.cellEditorPopup, p = (u == null ? void 0 : u.popupPositionFromSelector) != null ? u.popupPositionFromSelector : l.cellEditorPopupPosition;
        this.setEditing(!0), this.cellComp.setEditDetails(u, c, p);
        var d = this.createEvent(n, m.EVENT_CELL_EDITING_STARTED);
        this.beans.eventService.dispatchEvent(d);
      }
    }, t.prototype.setEditing = function(e) {
      this.editing !== e && (this.editing = e, this.refreshHandle());
    }, t.prototype.stopRowOrCellEdit = function(e) {
      e === void 0 && (e = !1), this.beans.gridOptionsService.get("editType") === "fullRow" ? this.rowCtrl.stopRowEditing(e) : this.stopEditing(e);
    }, t.prototype.onPopupEditorClosed = function() {
      this.isEditing() && this.stopEditingAndFocus();
    }, t.prototype.takeValueFromCellEditor = function(e) {
      var r = { newValueExists: !1 };
      if (e)
        return r;
      var o = this.cellComp.getCellEditor();
      if (!o)
        return r;
      var n = o.isCancelAfterEnd && o.isCancelAfterEnd();
      if (n)
        return r;
      var s = o.getValue();
      return {
        newValue: s,
        newValueExists: !0
      };
    }, t.prototype.saveNewValue = function(e, r) {
      if (r === e)
        return !1;
      this.suppressRefreshCell = !0;
      var o = this.rowNode.setDataValue(this.column, r, "edit");
      return this.suppressRefreshCell = !1, o;
    }, t.prototype.stopEditing = function(e) {
      if (e === void 0 && (e = !1), !this.editing)
        return !1;
      var r = this.takeValueFromCellEditor(e), o = r.newValue, n = r.newValueExists, s = this.rowNode.getValueFromValueService(this.column), a = !1;
      return n && (a = this.saveNewValue(s, o)), this.setEditing(!1), this.cellComp.setEditDetails(), this.updateAndFormatValue(), this.refreshCell({ forceRefresh: !0, suppressFlash: !0 }), this.dispatchEditingStoppedEvent(s, o, !e && !!a), a;
    }, t.prototype.dispatchEditingStoppedEvent = function(e, r, o) {
      var n = ia(ia({}, this.createEvent(null, m.EVENT_CELL_EDITING_STOPPED)), {
        oldValue: e,
        newValue: r,
        valueChanged: o
      });
      this.beans.eventService.dispatchEvent(n);
    }, t.prototype.createCellEditorParams = function(e, r, o) {
      return {
        value: this.rowNode.getValueFromValueService(this.column),
        eventKey: e,
        charPress: r,
        column: this.column,
        colDef: this.column.getColDef(),
        rowIndex: this.getCellPosition().rowIndex,
        node: this.rowNode,
        data: this.rowNode.data,
        api: this.beans.gridOptionsService.api,
        cellStartedEdit: o,
        columnApi: this.beans.gridOptionsService.columnApi,
        context: this.beans.gridOptionsService.context,
        onKeyDown: this.onKeyDown.bind(this),
        stopEditing: this.stopEditingAndFocus.bind(this),
        eGridCell: this.getGui(),
        parseValue: this.parseValue.bind(this),
        formatValue: this.formatValue.bind(this)
      };
    }, t.prototype.createCellRendererParams = function() {
      var e = this, r = {
        value: this.value,
        valueFormatted: this.valueFormatted,
        getValue: function() {
          return e.rowNode.getValueFromValueService(e.column);
        },
        setValue: function(o) {
          return e.beans.valueService.setValue(e.rowNode, e.column, o);
        },
        formatValue: this.formatValue.bind(this),
        data: this.rowNode.data,
        node: this.rowNode,
        pinned: this.column.getPinned(),
        colDef: this.column.getColDef(),
        column: this.column,
        rowIndex: this.getCellPosition().rowIndex,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi,
        context: this.beans.gridOptionsService.context,
        refreshCell: this.refreshCell.bind(this),
        eGridCell: this.getGui(),
        eParentOfValue: this.cellComp.getParentOfValue(),
        registerRowDragger: function(o, n, s, a) {
          return e.registerRowDragger(o, n, a);
        }
      };
      return r;
    }, t.prototype.parseValue = function(e) {
      var r = this.column.getColDef(), o = {
        node: this.rowNode,
        data: this.rowNode.data,
        oldValue: this.getValue(),
        newValue: e,
        colDef: r,
        column: this.column,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi,
        context: this.beans.gridOptionsService.context
      }, n = r.valueParser;
      return k(n) ? typeof n == "function" ? n(o) : this.beans.expressionService.evaluate(n, o) : e;
    }, t.prototype.setFocusOutOnEditor = function() {
      if (this.editing) {
        var e = this.cellComp.getCellEditor();
        e && e.focusOut && e.focusOut();
      }
    }, t.prototype.setFocusInOnEditor = function() {
      if (this.editing) {
        var e = this.cellComp.getCellEditor();
        e && e.focusIn ? e.focusIn() : this.focusCell(!0);
      }
    }, t.prototype.onCellChanged = function(e) {
      if (this.cellComp) {
        var r = e.column === this.column;
        r && this.refreshCell({});
      }
    }, t.prototype.refreshCell = function(e) {
      var r, o, n;
      if (!(this.suppressRefreshCell || this.editing) && this.cellComp) {
        var s = this.column.getColDef(), a = e != null && !!e.newData, l = e != null && !!e.suppressFlash || !!s.suppressCellFlash, u = s.field == null && s.valueGetter == null && s.showRowGroup == null, c = e && e.forceRefresh || u || a, p = this.updateAndFormatValue(), d = c || p;
        if (d) {
          this.showValue(a);
          var h = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering(), g = !l && !h && (this.beans.gridOptionsService.is("enableCellChangeFlash") || s.enableCellChangeFlash);
          g && this.flashCell(), (r = this.cellCustomStyleFeature) === null || r === void 0 || r.applyUserStyles(), (o = this.cellCustomStyleFeature) === null || o === void 0 || o.applyClassesFromColDef();
        }
        this.refreshToolTip(), (n = this.cellCustomStyleFeature) === null || n === void 0 || n.applyCellClassRules();
      }
    }, t.prototype.stopEditingAndFocus = function(e) {
      e === void 0 && (e = !1), this.stopRowOrCellEdit(), this.focusCell(!0), e || this.navigateAfterEdit();
    }, t.prototype.navigateAfterEdit = function() {
      var e = this.beans.gridOptionsService.get("editType") === "fullRow";
      if (!e) {
        var r = this.beans.gridOptionsService.is("enterMovesDownAfterEdit");
        r && this.beans.navigationService.navigateToNextCell(null, L.DOWN, this.getCellPosition(), !1);
      }
    }, t.prototype.flashCell = function(e) {
      var r = e && e.flashDelay, o = e && e.fadeDelay;
      this.animateCell("data-changed", r, o);
    }, t.prototype.animateCell = function(e, r, o) {
      var n = this, s, a, l = "ag-cell-" + e, u = "ag-cell-" + e + "-animation", c = this.beans.gridOptionsService;
      r || (r = (s = c.getNum("cellFlashDelay")) !== null && s !== void 0 ? s : 500), k(o) || (o = (a = c.getNum("cellFadeDelay")) !== null && a !== void 0 ? a : 1e3), this.cellComp.addOrRemoveCssClass(l, !0), this.cellComp.addOrRemoveCssClass(u, !1), window.setTimeout(function() {
        n.isAlive() && (n.cellComp.addOrRemoveCssClass(l, !1), n.cellComp.addOrRemoveCssClass(u, !0), n.eGui.style.transition = "background-color " + o + "ms", window.setTimeout(function() {
          n.isAlive() && (n.cellComp.addOrRemoveCssClass(u, !1), n.eGui.style.transition = "");
        }, o));
      }, r);
    }, t.prototype.onFlashCells = function(e) {
      if (this.cellComp) {
        var r = this.beans.cellPositionUtils.createId(this.getCellPosition()), o = e.cells[r];
        o && this.animateCell("highlight");
      }
    }, t.prototype.isCellEditable = function() {
      return this.column.isCellEditable(this.rowNode);
    }, t.prototype.isSuppressFillHandle = function() {
      return this.column.isSuppressFillHandle();
    }, t.prototype.formatValue = function(e) {
      var r = this.callValueFormatter(e);
      return r ?? e;
    }, t.prototype.callValueFormatter = function(e) {
      return this.beans.valueFormatterService.formatValue(this.column, this.rowNode, e);
    }, t.prototype.updateAndFormatValue = function(e) {
      e === void 0 && (e = !1);
      var r = this.value, o = this.valueFormatted;
      this.value = this.rowNode.getValueFromValueService(this.column), this.valueFormatted = this.callValueFormatter(this.value);
      var n = e ? !0 : !this.valuesAreEqual(r, this.value) || this.valueFormatted != o;
      return n;
    }, t.prototype.valuesAreEqual = function(e, r) {
      var o = this.column.getColDef();
      return o.equals ? o.equals(e, r) : e === r;
    }, t.prototype.getComp = function() {
      return this.cellComp;
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getValueFormatted = function() {
      return this.valueFormatted;
    }, t.prototype.addDomData = function() {
      var e = this, r = this.getGui();
      this.beans.gridOptionsService.setDomData(r, t.DOM_DATA_KEY_CELL_CTRL, this), this.addDestroyFunc(function() {
        return e.beans.gridOptionsService.setDomData(r, t.DOM_DATA_KEY_CELL_CTRL, null);
      });
    }, t.prototype.createEvent = function(e, r) {
      var o = {
        type: r,
        node: this.rowNode,
        data: this.rowNode.data,
        value: this.value,
        column: this.column,
        colDef: this.column.getColDef(),
        context: this.beans.gridOptionsService.context,
        api: this.beans.gridApi,
        columnApi: this.beans.columnApi,
        rowPinned: this.rowNode.rowPinned,
        event: e,
        rowIndex: this.rowNode.rowIndex
      };
      return o;
    }, t.prototype.onKeyPress = function(e) {
      var r;
      (r = this.cellKeyboardListenerFeature) === null || r === void 0 || r.onKeyPress(e);
    }, t.prototype.onKeyDown = function(e) {
      var r;
      (r = this.cellKeyboardListenerFeature) === null || r === void 0 || r.onKeyDown(e);
    }, t.prototype.onMouseEvent = function(e, r) {
      var o;
      (o = this.cellMouseListenerFeature) === null || o === void 0 || o.onMouseEvent(e, r);
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.refreshToolTip = function() {
      var e;
      (e = this.tooltipFeature) === null || e === void 0 || e.refreshToolTip();
    }, t.prototype.getColSpanningList = function() {
      return this.cellPositionFeature.getColSpanningList();
    }, t.prototype.onLeftChanged = function() {
      var e;
      this.cellComp && ((e = this.cellPositionFeature) === null || e === void 0 || e.onLeftChanged());
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.eGui && this.setAriaColIndex();
    }, t.prototype.setAriaColIndex = function() {
      var e = this.beans.columnModel.getAriaColumnIndex(this.column);
      ku(this.getGui(), e);
    }, t.prototype.isSuppressNavigable = function() {
      return this.column.isSuppressNavigable(this.rowNode);
    }, t.prototype.onWidthChanged = function() {
      var e;
      return (e = this.cellPositionFeature) === null || e === void 0 ? void 0 : e.onWidthChanged();
    }, t.prototype.getColumn = function() {
      return this.column;
    }, t.prototype.getRowNode = function() {
      return this.rowNode;
    }, t.prototype.getBeans = function() {
      return this.beans;
    }, t.prototype.isPrintLayout = function() {
      return this.printLayout;
    }, t.prototype.appendChild = function(e) {
      this.eGui.appendChild(e);
    }, t.prototype.refreshHandle = function() {
      this.cellRangeFeature && this.cellRangeFeature.refreshHandle();
    }, t.prototype.getCellPosition = function() {
      return this.cellPosition;
    }, t.prototype.isEditing = function() {
      return this.editing;
    }, t.prototype.startRowOrCellEdit = function(e, r, o) {
      o === void 0 && (o = null), this.cellComp && (this.beans.gridOptionsService.get("editType") === "fullRow" ? this.rowCtrl.startRowEditing(e, r, this) : this.startEditing(e, r, !0, o));
    }, t.prototype.getRowCtrl = function() {
      return this.rowCtrl;
    }, t.prototype.getRowPosition = function() {
      return {
        rowIndex: this.cellPosition.rowIndex,
        rowPinned: this.cellPosition.rowPinned
      };
    }, t.prototype.updateRangeBordersIfRangeCount = function() {
      this.cellComp && this.cellRangeFeature && this.cellRangeFeature.updateRangeBordersIfRangeCount();
    }, t.prototype.onRangeSelectionChanged = function() {
      this.cellComp && this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
    }, t.prototype.isRangeSelectionEnabled = function() {
      return this.cellRangeFeature != null;
    }, t.prototype.focusCell = function(e) {
      e === void 0 && (e = !1), this.beans.focusService.setFocusedCell({
        rowIndex: this.getCellPosition().rowIndex,
        column: this.column,
        rowPinned: this.rowNode.rowPinned,
        forceBrowserFocus: e
      });
    }, t.prototype.onRowIndexChanged = function() {
      this.createCellPosition(), this.onCellFocused(), this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
    }, t.prototype.onFirstRightPinnedChanged = function() {
      if (this.cellComp) {
        var e = this.column.isFirstRightPinned();
        this.cellComp.addOrRemoveCssClass(a_, e);
      }
    }, t.prototype.onLastLeftPinnedChanged = function() {
      if (this.cellComp) {
        var e = this.column.isLastLeftPinned();
        this.cellComp.addOrRemoveCssClass(l_, e);
      }
    }, t.prototype.onCellFocused = function(e) {
      if (!(!this.cellComp || this.beans.gridOptionsService.is("suppressCellFocus"))) {
        var r = this.beans.focusService.isCellFocused(this.cellPosition);
        if (this.cellComp.addOrRemoveCssClass(s_, r), r && e && e.forceBrowserFocus) {
          var o = this.cellComp.getFocusableElement();
          o.focus({ preventScroll: !!e.preventScrollOnBrowserFocus });
        }
        var n = this.beans.gridOptionsService.get("editType") === "fullRow";
        !r && !n && this.editing && this.stopRowOrCellEdit();
      }
    }, t.prototype.createCellPosition = function() {
      this.cellPosition = {
        rowIndex: this.rowNode.rowIndex,
        rowPinned: Go(this.rowNode.rowPinned),
        column: this.column
      };
    }, t.prototype.applyStaticCssClasses = function() {
      this.cellComp.addOrRemoveCssClass(o_, !0), this.cellComp.addOrRemoveCssClass(u_, !0);
      var e = this.column.isAutoHeight() == !0;
      this.cellComp.addOrRemoveCssClass(n_, e), this.cellComp.addOrRemoveCssClass(i_, !e);
    }, t.prototype.onColumnHover = function() {
      if (this.cellComp && this.beans.gridOptionsService.is("columnHoverHighlight")) {
        var e = this.beans.columnHoverService.isHovered(this.column);
        this.cellComp.addOrRemoveCssClass(c_, e);
      }
    }, t.prototype.onColDefChanged = function() {
      this.cellComp && (this.setWrapText(), this.editing || this.refreshCell({ forceRefresh: !0, suppressFlash: !0 }));
    }, t.prototype.setWrapText = function() {
      var e = this.column.getColDef().wrapText == !0;
      this.cellComp.addOrRemoveCssClass(p_, e);
    }, t.prototype.dispatchCellContextMenuEvent = function(e) {
      var r = this.column.getColDef(), o = this.createEvent(e, m.EVENT_CELL_CONTEXT_MENU);
      this.beans.eventService.dispatchEvent(o), r.onCellContextMenu && window.setTimeout(function() {
        return r.onCellContextMenu(o);
      }, 0);
    }, t.prototype.getCellRenderer = function() {
      return this.cellComp ? this.cellComp.getCellRenderer() : null;
    }, t.prototype.getCellEditor = function() {
      return this.cellComp ? this.cellComp.getCellEditor() : null;
    }, t.prototype.destroy = function() {
      this.onCellCompAttachedFuncs = [], i.prototype.destroy.call(this);
    }, t.prototype.createSelectionCheckbox = function() {
      var e = new lc();
      return this.beans.context.createBean(e), e.init({ rowNode: this.rowNode, column: this.column }), e;
    }, t.prototype.createDndSource = function() {
      var e = new t_(this.rowNode, this.column, this.beans, this.eGui);
      return this.beans.context.createBean(e), e;
    }, t.prototype.registerRowDragger = function(e, r, o) {
      var n = this;
      if (this.customRowDragComp) {
        this.customRowDragComp.setDragElement(e, r);
        return;
      }
      var s = this.createRowDragComp(e, r, o);
      s && (this.customRowDragComp = s, this.addDestroyFunc(function() {
        n.beans.context.destroyBean(s), n.customRowDragComp = null;
      }));
    }, t.prototype.createRowDragComp = function(e, r, o) {
      var n = this, s = this.beans.gridOptionsService.is("pagination"), a = this.beans.gridOptionsService.is("rowDragManaged"), l = this.beans.gridOptionsService.isRowModelType("clientSide");
      if (a) {
        if (!l) {
          Pe(function() {
            return console.warn("AG Grid: managed row dragging is only allowed in the Client Side Row Model");
          }, "CellComp.addRowDragging");
          return;
        }
        if (s) {
          Pe(function() {
            return console.warn("AG Grid: managed row dragging is not possible when doing pagination");
          }, "CellComp.addRowDragging");
          return;
        }
      }
      var u = new ta(function() {
        return n.value;
      }, this.rowNode, this.column, e, r, o);
      return this.beans.context.createBean(u), u;
    }, t.DOM_DATA_KEY_CELL_CTRL = "cellCtrl", t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var f_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), h_ = function(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], r = 0;
  if (e)
    return e.call(i);
  if (i && typeof i.length == "number")
    return {
      next: function() {
        return i && r >= i.length && (i = void 0), { value: i && i[r++], done: !i };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, v_ = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, g_ = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(v_(arguments[t]));
  return i;
}, or;
(function(i) {
  i.Normal = "Normal", i.FullWidth = "FullWidth", i.FullWidthLoading = "FullWidthLoading", i.FullWidthGroup = "FullWidthGroup", i.FullWidthDetail = "FullWidthDetail";
})(or || (or = {}));
var y_ = 0, Vo = (
  /** @class */
  function(i) {
    f_(t, i);
    function t(e, r, o, n, s) {
      var a = i.call(this) || this;
      return a.allRowGuis = [], a.active = !0, a.centerCellCtrls = { list: [], map: {} }, a.leftCellCtrls = { list: [], map: {} }, a.rightCellCtrls = { list: [], map: {} }, a.slideInAnimation = {
        left: !1,
        center: !1,
        right: !1,
        fullWidth: !1
      }, a.fadeInAnimation = {
        left: !1,
        center: !1,
        right: !1,
        fullWidth: !1
      }, a.lastMouseDownOnDragger = !1, a.updateColumnListsPending = !1, a.businessKeySanitised = null, a.beans = r, a.rowNode = e, a.paginationPage = a.beans.paginationProxy.getCurrentPage(), a.useAnimationFrameForCreate = n, a.printLayout = s, a.instanceId = e.id + "-" + y_++, a.setAnimateFlags(o), a.initRowBusinessKey(), a.rowFocused = a.beans.focusService.isRowFocused(a.rowNode.rowIndex, a.rowNode.rowPinned), a.rowLevel = a.beans.rowCssClassCalculator.calculateRowLevel(a.rowNode), a.setRowType(), a.addListeners(), a;
    }
    return t.prototype.initRowBusinessKey = function() {
      var e = this.beans.gridOptionsService.get("getBusinessKeyForNode");
      if (typeof e == "function") {
        var r = e(this.rowNode);
        this.businessKeySanitised = so(r);
      }
    }, t.prototype.isSticky = function() {
      return this.rowNode.sticky;
    }, t.prototype.getBeans = function() {
      return this.beans;
    }, t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.setComp = function(e, r, o) {
      var n = { rowComp: e, element: r, containerType: o };
      this.allRowGuis.push(n), o === It.LEFT ? this.leftGui = n : o === It.RIGHT ? this.rightGui = n : o === It.FULL_WIDTH ? this.fullWidthGui = n : this.centerGui = n, this.initialiseRowComp(n), this.rowType !== "FullWidthLoading" && !this.rowNode.rowPinned && this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
    }, t.prototype.unsetComp = function(e) {
      this.allRowGuis = this.allRowGuis.filter(function(r) {
        return r.containerType !== e;
      }), e === It.LEFT ? this.leftGui = void 0 : e === It.RIGHT ? this.rightGui = void 0 : e === It.FULL_WIDTH && (this.fullWidthGui = void 0);
    }, t.prototype.isCacheable = function() {
      return this.rowType === or.FullWidthDetail && this.beans.gridOptionsService.is("keepDetailRows");
    }, t.prototype.setCached = function(e) {
      var r = e ? "none" : "";
      this.allRowGuis.forEach(function(o) {
        return o.element.style.display = r;
      });
    }, t.prototype.initialiseRowComp = function(e) {
      var r = this, o = this.beans.gridOptionsService;
      this.onRowHeightChanged(e), this.updateRowIndexes(e), this.setFocusedClasses(e), this.setStylesFromGridOptions(e), o.isRowSelection() && this.rowNode.selectable && this.onRowSelected(e), this.updateColumnLists(!this.useAnimationFrameForCreate);
      var n = e.rowComp;
      n.setRole("row");
      var s = this.getInitialRowClasses(e.containerType);
      s.forEach(function(l) {
        return n.addOrRemoveCssClass(l, !0);
      }), this.executeSlideAndFadeAnimations(e), this.rowNode.group && Vr(e.element, this.rowNode.expanded == !0);
      var a = so(this.rowNode.id);
      a != null && n.setRowId(a), this.businessKeySanitised != null && n.setRowBusinessKey(this.businessKeySanitised), this.isFullWidth() && !this.beans.gridOptionsService.is("suppressCellFocus") && n.setTabIndex(-1), o.setDomData(e.element, t.DOM_DATA_KEY_ROW_CTRL, this), this.addDestroyFunc(function() {
        return o.setDomData(e.element, t.DOM_DATA_KEY_ROW_CTRL, null);
      }), this.useAnimationFrameForCreate ? this.beans.animationFrameService.createTask(this.addHoverFunctionality.bind(this, e.element), this.rowNode.rowIndex, "createTasksP2") : this.addHoverFunctionality(e.element), this.isFullWidth() && this.setupFullWidth(e), o.is("rowDragEntireRow") && this.addRowDraggerToRow(e), this.useAnimationFrameForCreate && this.beans.animationFrameService.addDestroyTask(function() {
        r.isAlive() && e.rowComp.addOrRemoveCssClass("ag-after-created", !0);
      }), this.executeProcessRowPostCreateFunc();
    }, t.prototype.executeSlideAndFadeAnimations = function(e) {
      var r = this, o = e.containerType, n = this.slideInAnimation[o];
      n && (Ql(function() {
        r.onTopChanged();
      }), this.slideInAnimation[o] = !1);
      var s = this.fadeInAnimation[o];
      s && (Ql(function() {
        e.rowComp.addOrRemoveCssClass("ag-opacity-zero", !1);
      }), this.fadeInAnimation[o] = !1);
    }, t.prototype.addRowDraggerToRow = function(e) {
      if (this.beans.gridOptionsService.isEnableRangeSelection()) {
        Pe(function() {
          console.warn("AG Grid: Setting `rowDragEntireRow: true` in the gridOptions doesn't work with `enableRangeSelection: true`");
        }, "rowDragAndRangeSelectionEnabled");
        return;
      }
      var r = this.beans.localeService.getLocaleTextFunc(), o = new ta(function() {
        return "1 " + r("rowDragRow", "row");
      }, this.rowNode, void 0, e.element, void 0, !0);
      this.createManagedBean(o, this.beans.context);
    }, t.prototype.setupFullWidth = function(e) {
      var r = this.getPinnedForContainer(e.containerType), o = this.createFullWidthParams(e.element, r);
      if (!(this.rowType == or.FullWidthDetail && !pe.assertRegistered(re.MasterDetailModule, "cell renderer 'agDetailCellRenderer' (for master detail)"))) {
        var n;
        switch (this.rowType) {
          case or.FullWidthDetail:
            n = this.beans.userComponentFactory.getFullWidthDetailCellRendererDetails(o);
            break;
          case or.FullWidthGroup:
            n = this.beans.userComponentFactory.getFullWidthGroupCellRendererDetails(o);
            break;
          case or.FullWidthLoading:
            n = this.beans.userComponentFactory.getFullWidthLoadingCellRendererDetails(o);
            break;
          default:
            n = this.beans.userComponentFactory.getFullWidthCellRendererDetails(o);
            break;
        }
        e.rowComp.showFullWidth(n);
      }
    }, t.prototype.isPrintLayout = function() {
      return this.printLayout;
    }, t.prototype.getFullWidthCellRenderer = function() {
      var e, r;
      return (r = (e = this.fullWidthGui) === null || e === void 0 ? void 0 : e.rowComp) === null || r === void 0 ? void 0 : r.getFullWidthCellRenderer();
    }, t.prototype.getCellElement = function(e) {
      var r = this.getCellCtrl(e);
      return r ? r.getGui() : null;
    }, t.prototype.executeProcessRowPostCreateFunc = function() {
      var e, r = this.beans.gridOptionsService.getCallback("processRowPostCreate");
      if (!(!r || !this.areAllContainersReady())) {
        var o = {
          eRow: (e = this.centerGui) === null || e === void 0 ? void 0 : e.element,
          ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
          ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
          node: this.rowNode,
          rowIndex: this.rowNode.rowIndex,
          addRenderedRowListener: this.addEventListener.bind(this)
        };
        r(o);
      }
    }, t.prototype.areAllContainersReady = function() {
      var e = !!this.leftGui || !this.beans.columnModel.isPinningLeft(), r = !!this.centerGui, o = !!this.rightGui || !this.beans.columnModel.isPinningRight();
      return e && r && o;
    }, t.prototype.setRowType = function() {
      var e = this.rowNode.stub, r = this.rowNode.isFullWidthCell(), o = this.beans.doingMasterDetail && this.rowNode.detail, n = this.beans.columnModel.isPivotMode(), s = !!this.rowNode.group && !this.rowNode.footer, a = s && this.beans.gridOptionsService.isGroupUseEntireRow(n);
      e ? this.rowType = or.FullWidthLoading : o ? this.rowType = or.FullWidthDetail : r ? this.rowType = or.FullWidth : a ? this.rowType = or.FullWidthGroup : this.rowType = or.Normal;
    }, t.prototype.updateColumnLists = function(e, r) {
      var o = this;
      if (e === void 0 && (e = !1), r === void 0 && (r = !1), !this.isFullWidth()) {
        var n = e || this.beans.gridOptionsService.is("suppressAnimationFrame") || this.printLayout;
        if (n) {
          this.updateColumnListsImpl(r);
          return;
        }
        this.updateColumnListsPending || (this.beans.animationFrameService.createTask(function() {
          o.active && o.updateColumnListsImpl(!0);
        }, this.rowNode.rowIndex, "createTasksP1"), this.updateColumnListsPending = !0);
      }
    }, t.prototype.createCellCtrls = function(e, r, o) {
      var n = this;
      o === void 0 && (o = null);
      var s = {
        list: [],
        map: {}
      }, a = function(l, u) {
        s.list.push(u), s.map[l] = u;
      };
      return r.forEach(function(l) {
        var u = l.getInstanceId(), c = e.map[u];
        c || (c = new Ho(l, n.rowNode, n.beans, n)), a(u, c);
      }), e.list.forEach(function(l) {
        var u = s.map[l.getColumn().getInstanceId()] != null;
        if (!u) {
          var c = !n.isCellEligibleToBeRemoved(l, o);
          if (c) {
            a(l.getColumn().getInstanceId(), l);
            return;
          }
          l.destroy();
        }
      }), s;
    }, t.prototype.updateColumnListsImpl = function(e) {
      var r = this;
      e === void 0 && (e = !1), this.updateColumnListsPending = !1;
      var o = this.beans.columnModel;
      if (this.printLayout)
        this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, o.getAllDisplayedColumns()), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
      else {
        var n = o.getViewportCenterColumnsForRow(this.rowNode);
        this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, n);
        var s = o.getDisplayedLeftColumnsForRow(this.rowNode);
        this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, s, "left");
        var a = o.getDisplayedRightColumnsForRow(this.rowNode);
        this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, a, "right");
      }
      this.allRowGuis.forEach(function(l) {
        var u = l.containerType === It.LEFT ? r.leftCellCtrls : l.containerType === It.RIGHT ? r.rightCellCtrls : r.centerCellCtrls;
        l.rowComp.setCellCtrls(u.list, e);
      });
    }, t.prototype.isCellEligibleToBeRemoved = function(e, r) {
      var o = !0, n = !1, s = e.getColumn();
      if (s.getPinned() != r)
        return o;
      var a = e.isEditing(), l = this.beans.focusService.isCellFocused(e.getCellPosition()), u = a || l;
      if (u) {
        var c = e.getColumn(), p = this.beans.columnModel.getAllDisplayedColumns(), d = p.indexOf(c) >= 0;
        return d ? n : o;
      }
      return o;
    }, t.prototype.setAnimateFlags = function(e) {
      if (!(this.isSticky() || !e)) {
        var r = k(this.rowNode.oldRowTop), o = this.beans.columnModel.isPinningLeft(), n = this.beans.columnModel.isPinningRight();
        r ? (this.slideInAnimation.center = !0, this.slideInAnimation.left = o, this.slideInAnimation.right = n) : (this.fadeInAnimation.center = !0, this.fadeInAnimation.left = o, this.fadeInAnimation.right = n);
      }
    }, t.prototype.isEditing = function() {
      return this.editingRow;
    }, t.prototype.stopRowEditing = function(e) {
      this.stopEditing(e);
    }, t.prototype.isFullWidth = function() {
      return this.rowType !== or.Normal;
    }, t.prototype.getRowType = function() {
      return this.rowType;
    }, t.prototype.refreshFullWidth = function() {
      var e = this, r = function(u, c) {
        if (!u)
          return !0;
        var p = u.rowComp.getFullWidthCellRenderer();
        if (!p || !p.refresh)
          return !1;
        var d = e.createFullWidthParams(u.element, c), h = p.refresh(d);
        return h;
      }, o = r(this.fullWidthGui, null), n = r(this.centerGui, null), s = r(this.leftGui, "left"), a = r(this.rightGui, "right"), l = o && n && s && a;
      return l;
    }, t.prototype.addListeners = function() {
      var e = this;
      this.addManagedListener(this.rowNode, ye.EVENT_HEIGHT_CHANGED, function() {
        return e.onRowHeightChanged();
      }), this.addManagedListener(this.rowNode, ye.EVENT_ROW_SELECTED, function() {
        return e.onRowSelected();
      }), this.addManagedListener(this.rowNode, ye.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_TOP_CHANGED, this.onTopChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_CELL_CHANGED, this.onRowNodeCellChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_DRAGGING_CHANGED, this.onRowNodeDraggingChanged.bind(this)), this.addManagedListener(this.rowNode, ye.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
      var r = this.beans.eventService;
      this.addManagedListener(r, m.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this)), this.addManagedListener(r, m.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this)), this.addManagedListener(r, m.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(r, m.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this)), this.addManagedListener(r, m.EVENT_CELL_FOCUSED, this.onCellFocused.bind(this)), this.addManagedListener(r, m.EVENT_CELL_FOCUS_CLEARED, this.onCellFocusCleared.bind(this)), this.addManagedListener(r, m.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this)), this.addManagedListener(r, m.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this)), this.addManagedListener(r, m.EVENT_COLUMN_MOVED, this.onColumnMoved.bind(this)), this.addListenersForCellComps();
    }, t.prototype.onColumnMoved = function() {
      this.updateColumnLists();
    }, t.prototype.addListenersForCellComps = function() {
      var e = this;
      this.addManagedListener(this.rowNode, ye.EVENT_ROW_INDEX_CHANGED, function() {
        e.getAllCellCtrls().forEach(function(r) {
          return r.onRowIndexChanged();
        });
      }), this.addManagedListener(this.rowNode, ye.EVENT_CELL_CHANGED, function(r) {
        e.getAllCellCtrls().forEach(function(o) {
          return o.onCellChanged(r);
        });
      });
    }, t.prototype.onRowNodeDataChanged = function(e) {
      if (this.rowNode.detailNode && this.beans.rowRenderer.refreshFullWidthRow(this.rowNode.detailNode), this.isFullWidth()) {
        this.beans.rowRenderer.refreshFullWidthRow(this.rowNode);
        return;
      }
      this.getAllCellCtrls().forEach(function(r) {
        return r.refreshCell({
          suppressFlash: !e.update,
          newData: !e.update
        });
      }), this.onRowSelected(), this.postProcessCss();
    }, t.prototype.onRowNodeCellChanged = function() {
      this.postProcessCss();
    }, t.prototype.postProcessCss = function() {
      this.setStylesFromGridOptions(), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), this.postProcessRowDragging();
    }, t.prototype.onRowNodeHighlightChanged = function() {
      var e = this.rowNode.highlighted;
      this.allRowGuis.forEach(function(r) {
        var o = e === no.Above, n = e === no.Below;
        r.rowComp.addOrRemoveCssClass("ag-row-highlight-above", o), r.rowComp.addOrRemoveCssClass("ag-row-highlight-below", n);
      });
    }, t.prototype.onRowNodeDraggingChanged = function() {
      this.postProcessRowDragging();
    }, t.prototype.postProcessRowDragging = function() {
      var e = this.rowNode.dragging;
      this.allRowGuis.forEach(function(r) {
        return r.rowComp.addOrRemoveCssClass("ag-row-dragging", e);
      });
    }, t.prototype.updateExpandedCss = function() {
      var e = this.rowNode.isExpandable(), r = this.rowNode.expanded == !0;
      this.allRowGuis.forEach(function(o) {
        o.rowComp.addOrRemoveCssClass("ag-row-group", e), o.rowComp.addOrRemoveCssClass("ag-row-group-expanded", e && r), o.rowComp.addOrRemoveCssClass("ag-row-group-contracted", e && !r), Vr(o.element, e && r);
      });
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.updateColumnLists(!0), this.beans.columnModel.wasAutoRowHeightEverActive() && this.rowNode.checkAutoHeights();
    }, t.prototype.onVirtualColumnsChanged = function() {
      this.updateColumnLists(!1, !0);
    }, t.prototype.getRowPosition = function() {
      return {
        rowPinned: Go(this.rowNode.rowPinned),
        rowIndex: this.rowNode.rowIndex
      };
    }, t.prototype.onKeyboardNavigate = function(e) {
      var r = this.allRowGuis.find(function(u) {
        return u.element.contains(e.target);
      }), o = r ? r.element : null, n = o === e.target;
      if (n) {
        var s = this.rowNode, a = this.beans.focusService.getFocusedCell(), l = {
          rowIndex: s.rowIndex,
          rowPinned: s.rowPinned,
          column: a && a.column
        };
        this.beans.navigationService.navigateToNextCell(e, e.key, l, !0), e.preventDefault();
      }
    }, t.prototype.onTabKeyDown = function(e) {
      if (!(e.defaultPrevented || oo(e))) {
        var r = this.allRowGuis.find(function(a) {
          return a.element.contains(e.target);
        }), o = r ? r.element : null, n = o === e.target, s = null;
        n || (s = this.beans.focusService.findNextFocusableElement(o, !1, e.shiftKey)), (this.isFullWidth() && n || !s) && this.beans.navigationService.onTabKeyDown(this, e);
      }
    }, t.prototype.onFullWidthRowFocused = function(e) {
      var r, o = this.rowNode, n = e ? this.isFullWidth() && e.rowIndex === o.rowIndex && e.rowPinned == o.rowPinned : !1, s = this.fullWidthGui ? this.fullWidthGui.element : (r = this.centerGui) === null || r === void 0 ? void 0 : r.element;
      s && (s.classList.toggle("ag-full-width-focus", n), n && s.focus({ preventScroll: !0 }));
    }, t.prototype.refreshCell = function(e) {
      this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, e), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, e), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, e), this.updateColumnLists();
    }, t.prototype.removeCellCtrl = function(e, r) {
      var o = {
        list: [],
        map: {}
      };
      return e.list.forEach(function(n) {
        n !== r && (o.list.push(n), o.map[n.getInstanceId()] = n);
      }), o;
    }, t.prototype.onMouseEvent = function(e, r) {
      switch (e) {
        case "dblclick":
          this.onRowDblClick(r);
          break;
        case "click":
          this.onRowClick(r);
          break;
        case "touchstart":
        case "mousedown":
          this.onRowMouseDown(r);
          break;
      }
    }, t.prototype.createRowEvent = function(e, r) {
      return {
        type: e,
        node: this.rowNode,
        data: this.rowNode.data,
        rowIndex: this.rowNode.rowIndex,
        rowPinned: this.rowNode.rowPinned,
        context: this.beans.gridOptionsService.context,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi,
        event: r
      };
    }, t.prototype.createRowEventWithSource = function(e, r) {
      var o = this.createRowEvent(e, r);
      return o.source = this, o;
    }, t.prototype.onRowDblClick = function(e) {
      if (!oo(e)) {
        var r = this.createRowEventWithSource(m.EVENT_ROW_DOUBLE_CLICKED, e);
        this.beans.eventService.dispatchEvent(r);
      }
    }, t.prototype.onRowMouseDown = function(e) {
      if (this.lastMouseDownOnDragger = un(e.target, "ag-row-drag", 3), !!this.isFullWidth()) {
        var r = this.rowNode, o = this.beans.columnModel;
        this.beans.rangeService && this.beans.rangeService.removeAllCellRanges(), this.beans.focusService.setFocusedCell({
          rowIndex: r.rowIndex,
          column: o.getAllDisplayedColumns()[0],
          rowPinned: r.rowPinned,
          forceBrowserFocus: !0
        });
      }
    }, t.prototype.onRowClick = function(e) {
      var r = oo(e) || this.lastMouseDownOnDragger;
      if (!r) {
        var o = this.createRowEventWithSource(m.EVENT_ROW_CLICKED, e);
        this.beans.eventService.dispatchEvent(o);
        var n = e.ctrlKey || e.metaKey, s = e.shiftKey, a = this.beans.gridOptionsService.is("groupSelectsChildren");
        if (
          // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
          // so return if it's a group row
          !(a && this.rowNode.group || // this is needed so we don't unselect other rows when we click this row, eg if this row is not selectable,
          // and we click it, the selection should not change (ie any currently selected row should stay selected)
          !this.rowNode.selectable || // we also don't allow selection of pinned rows
          this.rowNode.rowPinned || // if no selection method enabled, do nothing
          !this.beans.gridOptionsService.isRowSelection() || // if click selection suppressed, do nothing
          this.beans.gridOptionsService.is("suppressRowClickSelection"))
        ) {
          var l = this.beans.gridOptionsService.is("rowMultiSelectWithClick"), u = !this.beans.gridOptionsService.is("suppressRowDeselection"), c = "rowClicked";
          if (this.rowNode.isSelected())
            l ? this.rowNode.setSelectedParams({ newValue: !1, event: e, source: c }) : n ? u && this.rowNode.setSelectedParams({ newValue: !1, event: e, source: c }) : this.rowNode.setSelectedParams({ newValue: !0, clearSelection: !s, rangeSelect: s, event: e, source: c });
          else {
            var p = l ? !1 : !n;
            this.rowNode.setSelectedParams({ newValue: !0, clearSelection: p, rangeSelect: s, event: e, source: c });
          }
        }
      }
    }, t.prototype.setupDetailRowAutoHeight = function(e) {
      var r = this;
      if (this.rowType === or.FullWidthDetail && this.beans.gridOptionsService.is("detailRowAutoHeight")) {
        var o = function() {
          var s = e.clientHeight;
          if (s != null && s > 0) {
            var a = function() {
              r.rowNode.setRowHeight(s), r.beans.clientSideRowModel ? r.beans.clientSideRowModel.onRowHeightChanged() : r.beans.serverSideRowModel && r.beans.serverSideRowModel.onRowHeightChanged();
            };
            r.beans.frameworkOverrides.setTimeout(a, 0);
          }
        }, n = this.beans.resizeObserverService.observeResize(e, o);
        this.addDestroyFunc(n), o();
      }
    }, t.prototype.createFullWidthParams = function(e, r) {
      var o = this, n = {
        fullWidth: !0,
        data: this.rowNode.data,
        node: this.rowNode,
        value: this.rowNode.key,
        valueFormatted: this.rowNode.key,
        rowIndex: this.rowNode.rowIndex,
        api: this.beans.gridOptionsService.api,
        columnApi: this.beans.gridOptionsService.columnApi,
        context: this.beans.gridOptionsService.context,
        // these need to be taken out, as part of 'afterAttached' now
        eGridCell: e,
        eParentOfValue: e,
        pinned: r,
        addRenderedRowListener: this.addEventListener.bind(this),
        registerRowDragger: function(s, a, l, u) {
          return o.addFullWidthRowDragging(s, a, l, u);
        }
      };
      return n;
    }, t.prototype.addFullWidthRowDragging = function(e, r, o, n) {
      if (o === void 0 && (o = ""), !!this.isFullWidth()) {
        var s = new ta(function() {
          return o;
        }, this.rowNode, void 0, e, r, n);
        this.createManagedBean(s, this.beans.context);
      }
    }, t.prototype.onUiLevelChanged = function() {
      var e = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
      if (this.rowLevel != e) {
        var r = "ag-row-level-" + e, o = "ag-row-level-" + this.rowLevel;
        this.allRowGuis.forEach(function(n) {
          n.rowComp.addOrRemoveCssClass(r, !0), n.rowComp.addOrRemoveCssClass(o, !1);
        });
      }
      this.rowLevel = e;
    }, t.prototype.isFirstRowOnPage = function() {
      return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
    }, t.prototype.isLastRowOnPage = function() {
      return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
    }, t.prototype.onModelUpdated = function() {
      this.refreshFirstAndLastRowStyles();
    }, t.prototype.refreshFirstAndLastRowStyles = function() {
      var e = this.isFirstRowOnPage(), r = this.isLastRowOnPage();
      this.firstRowOnPage !== e && (this.firstRowOnPage = e, this.allRowGuis.forEach(function(o) {
        return o.rowComp.addOrRemoveCssClass("ag-row-first", e);
      })), this.lastRowOnPage !== r && (this.lastRowOnPage = r, this.allRowGuis.forEach(function(o) {
        return o.rowComp.addOrRemoveCssClass("ag-row-last", r);
      }));
    }, t.prototype.stopEditing = function(e) {
      var r, o;
      if (e === void 0 && (e = !1), !this.stoppingRowEdit) {
        var n = this.getAllCellCtrls(), s = this.editingRow;
        this.stoppingRowEdit = !0;
        var a = !1;
        try {
          for (var l = h_(n), u = l.next(); !u.done; u = l.next()) {
            var c = u.value, p = c.stopEditing(e);
            s && !e && !a && p && (a = !0);
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            u && !u.done && (o = l.return) && o.call(l);
          } finally {
            if (r)
              throw r.error;
          }
        }
        if (a) {
          var d = this.createRowEvent(m.EVENT_ROW_VALUE_CHANGED);
          this.beans.eventService.dispatchEvent(d);
        }
        s && this.setEditingRow(!1), this.stoppingRowEdit = !1;
      }
    }, t.prototype.setInlineEditingCss = function(e) {
      this.allRowGuis.forEach(function(r) {
        r.rowComp.addOrRemoveCssClass("ag-row-inline-editing", e), r.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !e);
      });
    }, t.prototype.setEditingRow = function(e) {
      this.editingRow = e, this.allRowGuis.forEach(function(o) {
        return o.rowComp.addOrRemoveCssClass("ag-row-editing", e);
      });
      var r = e ? this.createRowEvent(m.EVENT_ROW_EDITING_STARTED) : this.createRowEvent(m.EVENT_ROW_EDITING_STOPPED);
      this.beans.eventService.dispatchEvent(r);
    }, t.prototype.startRowEditing = function(e, r, o, n) {
      if (e === void 0 && (e = null), r === void 0 && (r = null), o === void 0 && (o = null), n === void 0 && (n = null), !this.editingRow) {
        var s = this.getAllCellCtrls().reduce(function(a, l) {
          var u = l === o;
          return u ? l.startEditing(e, r, u, n) : l.startEditing(null, null, u, n), a ? !0 : l.isEditing();
        }, !1);
        s && this.setEditingRow(!0);
      }
    }, t.prototype.getAllCellCtrls = function() {
      if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0)
        return this.centerCellCtrls.list;
      var e = g_(this.centerCellCtrls.list, this.leftCellCtrls.list, this.rightCellCtrls.list);
      return e;
    }, t.prototype.postProcessClassesFromGridOptions = function() {
      var e = this, r = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode);
      !r || !r.length || r.forEach(function(o) {
        e.allRowGuis.forEach(function(n) {
          return n.rowComp.addOrRemoveCssClass(o, !0);
        });
      });
    }, t.prototype.postProcessRowClassRules = function() {
      var e = this;
      this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, function(r) {
        e.allRowGuis.forEach(function(o) {
          return o.rowComp.addOrRemoveCssClass(r, !0);
        });
      }, function(r) {
        e.allRowGuis.forEach(function(o) {
          return o.rowComp.addOrRemoveCssClass(r, !1);
        });
      });
    }, t.prototype.setStylesFromGridOptions = function(e) {
      var r = this.processStylesFromGridOptions();
      this.forEachGui(e, function(o) {
        return o.rowComp.setUserStyles(r);
      });
    }, t.prototype.getPinnedForContainer = function(e) {
      var r = e === It.LEFT ? "left" : e === It.RIGHT ? "right" : null;
      return r;
    }, t.prototype.getInitialRowClasses = function(e) {
      var r = this.getPinnedForContainer(e), o = {
        rowNode: this.rowNode,
        rowFocused: this.rowFocused,
        fadeRowIn: this.fadeInAnimation[e],
        rowIsEven: this.rowNode.rowIndex % 2 === 0,
        rowLevel: this.rowLevel,
        fullWidthRow: this.isFullWidth(),
        firstRowOnPage: this.isFirstRowOnPage(),
        lastRowOnPage: this.isLastRowOnPage(),
        printLayout: this.printLayout,
        expandable: this.rowNode.isExpandable(),
        pinned: r
      };
      return this.beans.rowCssClassCalculator.getInitialRowClasses(o);
    }, t.prototype.processStylesFromGridOptions = function() {
      var e = this.beans.gridOptionsService.get("rowStyle");
      if (e && typeof e == "function") {
        console.warn("AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead");
        return;
      }
      var r = this.beans.gridOptionsService.getCallback("getRowStyle"), o;
      if (r) {
        var n = {
          data: this.rowNode.data,
          node: this.rowNode,
          rowIndex: this.rowNode.rowIndex
        };
        o = r(n);
      }
      return Object.assign({}, e, o);
    }, t.prototype.onRowSelected = function(e) {
      var r = this, o = !!this.rowNode.isSelected();
      this.forEachGui(e, function(n) {
        n.rowComp.addOrRemoveCssClass("ag-row-selected", o), $n(n.element, o ? !0 : void 0);
        var s = r.createAriaLabel();
        yn(n.element, s ?? "");
      });
    }, t.prototype.createAriaLabel = function() {
      var e = this.rowNode.isSelected();
      if (!(e && this.beans.gridOptionsService.is("suppressRowDeselection"))) {
        var r = this.beans.localeService.getLocaleTextFunc(), o = r(e ? "ariaRowDeselect" : "ariaRowSelect", "Press SPACE to " + (e ? "deselect" : "select") + " this row.");
        return o;
      }
    }, t.prototype.isUseAnimationFrameForCreate = function() {
      return this.useAnimationFrameForCreate;
    }, t.prototype.addHoverFunctionality = function(e) {
      var r = this;
      this.active && (this.addManagedListener(e, "mouseenter", function() {
        return r.rowNode.onMouseEnter();
      }), this.addManagedListener(e, "mouseleave", function() {
        return r.rowNode.onMouseLeave();
      }), this.addManagedListener(this.rowNode, ye.EVENT_MOUSE_ENTER, function() {
        !r.beans.dragService.isDragging() && !r.beans.gridOptionsService.is("suppressRowHoverHighlight") && (e.classList.add("ag-row-hover"), r.rowNode.setHovered(!0));
      }), this.addManagedListener(this.rowNode, ye.EVENT_MOUSE_LEAVE, function() {
        e.classList.remove("ag-row-hover"), r.rowNode.setHovered(!1);
      }));
    }, t.prototype.roundRowTopToBounds = function(e) {
      var r = this.beans.ctrlsService.getGridBodyCtrl(), o = r.getScrollFeature().getVScrollPosition(), n = this.applyPaginationOffset(o.top, !0) - 100, s = this.applyPaginationOffset(o.bottom, !0) + 100;
      return Math.min(Math.max(n, e), s);
    }, t.prototype.getFrameworkOverrides = function() {
      return this.beans.frameworkOverrides;
    }, t.prototype.forEachGui = function(e, r) {
      var o = e ? [e] : this.allRowGuis;
      o.forEach(r);
    }, t.prototype.onRowHeightChanged = function(e) {
      if (this.rowNode.rowHeight != null) {
        var r = this.rowNode.rowHeight, o = this.beans.environment.getDefaultRowHeight(), n = this.beans.gridOptionsService.isGetRowHeightFunction(), s = n ? this.beans.gridOptionsService.getRowHeightForNode(this.rowNode).height : void 0, a = s ? Math.min(o, s) - 2 + "px" : void 0;
        this.forEachGui(e, function(l) {
          l.element.style.height = r + "px", a && l.element.style.setProperty("--ag-line-height", a);
        });
      }
    }, t.prototype.addEventListener = function(e, r) {
      i.prototype.addEventListener.call(this, e, r);
    }, t.prototype.removeEventListener = function(e, r) {
      i.prototype.removeEventListener.call(this, e, r);
    }, t.prototype.destroyFirstPass = function() {
      this.active = !1, this.beans.gridOptionsService.isAnimateRows() && this.setupRemoveAnimation(), this.rowNode.setHovered(!1);
      var e = this.createRowEvent(m.EVENT_VIRTUAL_ROW_REMOVED);
      this.dispatchEvent(e), this.beans.eventService.dispatchEvent(e), i.prototype.destroy.call(this);
    }, t.prototype.setupRemoveAnimation = function() {
      if (!this.isSticky()) {
        var e = this.rowNode.rowTop != null;
        if (e) {
          var r = this.roundRowTopToBounds(this.rowNode.rowTop);
          this.setRowTop(r);
        } else
          this.allRowGuis.forEach(function(o) {
            return o.rowComp.addOrRemoveCssClass("ag-opacity-zero", !0);
          });
      }
    }, t.prototype.destroySecondPass = function() {
      this.allRowGuis.length = 0;
      var e = function(r) {
        return r.list.forEach(function(o) {
          return o.destroy();
        }), { list: [], map: {} };
      };
      this.centerCellCtrls = e(this.centerCellCtrls), this.leftCellCtrls = e(this.leftCellCtrls), this.rightCellCtrls = e(this.rightCellCtrls);
    }, t.prototype.setFocusedClasses = function(e) {
      var r = this;
      this.forEachGui(e, function(o) {
        o.rowComp.addOrRemoveCssClass("ag-row-focus", r.rowFocused), o.rowComp.addOrRemoveCssClass("ag-row-no-focus", !r.rowFocused);
      });
    }, t.prototype.onCellFocused = function() {
      this.onCellFocusChanged();
    }, t.prototype.onCellFocusCleared = function() {
      this.onCellFocusChanged();
    }, t.prototype.onCellFocusChanged = function() {
      var e = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
      e !== this.rowFocused && (this.rowFocused = e, this.setFocusedClasses()), !e && this.editingRow && this.stopEditing(!1);
    }, t.prototype.onPaginationChanged = function() {
      var e = this.beans.paginationProxy.getCurrentPage();
      this.paginationPage !== e && (this.paginationPage = e, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
    }, t.prototype.onTopChanged = function() {
      this.setRowTop(this.rowNode.rowTop);
    }, t.prototype.onPaginationPixelOffsetChanged = function() {
      this.onTopChanged();
    }, t.prototype.applyPaginationOffset = function(e, r) {
      if (r === void 0 && (r = !1), this.rowNode.isRowPinned())
        return e;
      var o = this.beans.paginationProxy.getPixelOffset(), n = r ? 1 : -1;
      return e + o * n;
    }, t.prototype.setRowTop = function(e) {
      if (!this.printLayout && k(e)) {
        var r = this.applyPaginationOffset(e), o = this.rowNode.isRowPinned() ? r : this.beans.rowContainerHeightService.getRealPixelPosition(r), n = o + "px";
        this.setRowTopStyle(n);
      }
    }, t.prototype.getInitialRowTop = function(e) {
      var r = this.beans.gridOptionsService.is("suppressRowTransform");
      return r ? this.getInitialRowTopShared(e) : void 0;
    }, t.prototype.getInitialTransform = function(e) {
      var r = this.beans.gridOptionsService.is("suppressRowTransform");
      return r ? void 0 : "translateY(" + this.getInitialRowTopShared(e) + ")";
    }, t.prototype.getInitialRowTopShared = function(e) {
      if (this.printLayout)
        return "";
      var r;
      if (this.isSticky())
        r = this.rowNode.stickyRowTop;
      else {
        var o = this.slideInAnimation[e] ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop, n = this.applyPaginationOffset(o);
        r = this.rowNode.isRowPinned() ? n : this.beans.rowContainerHeightService.getRealPixelPosition(n);
      }
      return r + "px";
    }, t.prototype.setRowTopStyle = function(e) {
      var r = this.beans.gridOptionsService.is("suppressRowTransform");
      this.allRowGuis.forEach(function(o) {
        return r ? o.rowComp.setTop(e) : o.rowComp.setTransform("translateY(" + e + ")");
      });
    }, t.prototype.getRowNode = function() {
      return this.rowNode;
    }, t.prototype.getCellCtrl = function(e) {
      var r = null;
      return this.getAllCellCtrls().forEach(function(o) {
        o.getColumn() == e && (r = o);
      }), r != null || this.getAllCellCtrls().forEach(function(o) {
        o.getColSpanningList().indexOf(e) >= 0 && (r = o);
      }), r;
    }, t.prototype.onRowIndexChanged = function() {
      this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
    }, t.prototype.updateRowIndexes = function(e) {
      var r = this.rowNode.getRowIndexString(), o = this.beans.headerNavigationService.getHeaderRowCount(), n = this.rowNode.rowIndex % 2 === 0, s = o + this.rowNode.rowIndex + 1;
      this.forEachGui(e, function(a) {
        a.rowComp.setRowIndex(r), a.rowComp.addOrRemoveCssClass("ag-row-even", n), a.rowComp.addOrRemoveCssClass("ag-row-odd", !n), Bu(a.element, s);
      });
    }, t.prototype.getPinnedLeftRowElement = function() {
      return this.leftGui ? this.leftGui.element : void 0;
    }, t.prototype.getPinnedRightRowElement = function() {
      return this.rightGui ? this.rightGui.element : void 0;
    }, t.prototype.getBodyRowElement = function() {
      return this.centerGui ? this.centerGui.element : void 0;
    }, t.prototype.getFullWidthRowElement = function() {
      return this.fullWidthGui ? this.fullWidthGui.element : void 0;
    }, t.DOM_DATA_KEY_ROW_CTRL = "renderedRow", t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var m_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ur = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, C_ = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, w_ = (
  /** @class */
  function(i) {
    m_(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.element = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addMouseListeners(), this.mockContextMenuForIPad(), this.addKeyboardEvents();
    }, t.prototype.addKeyboardEvents = function() {
      var e = this, r = ["keydown", "keypress"];
      r.forEach(function(o) {
        var n = e.processKeyboardEvent.bind(e, o);
        e.addManagedListener(e.element, o, n);
      });
    }, t.prototype.addMouseListeners = function() {
      var e = this, r = Fu("touchstart") ? "touchstart" : "mousedown", o = ["dblclick", "contextmenu", "mouseover", "mouseout", "click", r];
      o.forEach(function(n) {
        var s = e.processMouseEvent.bind(e, n);
        e.addManagedListener(e.element, n, s);
      });
    }, t.prototype.processMouseEvent = function(e, r) {
      if (!(!this.mouseEventService.isEventFromThisGrid(r) || oo(r))) {
        var o = this.getRowForEvent(r), n = this.mouseEventService.getRenderedCellForEvent(r);
        e === "contextmenu" ? this.handleContextMenuMouseEvent(r, null, o, n) : (n && n.onMouseEvent(e, r), o && o.onMouseEvent(e, r));
      }
    }, t.prototype.mockContextMenuForIPad = function() {
      var e = this;
      if (jo()) {
        var r = new sr(this.element), o = function(n) {
          var s = e.getRowForEvent(n.touchEvent), a = e.mouseEventService.getRenderedCellForEvent(n.touchEvent);
          e.handleContextMenuMouseEvent(null, n.touchEvent, s, a);
        };
        this.addManagedListener(r, sr.EVENT_LONG_TAP, o), this.addDestroyFunc(function() {
          return r.destroy();
        });
      }
    }, t.prototype.getRowForEvent = function(e) {
      for (var r = e.target; r; ) {
        var o = this.gridOptionsService.getDomData(r, Vo.DOM_DATA_KEY_ROW_CTRL);
        if (o)
          return o;
        r = r.parentElement;
      }
      return null;
    }, t.prototype.handleContextMenuMouseEvent = function(e, r, o, n) {
      var s = o ? o.getRowNode() : null, a = n ? n.getColumn() : null, l = null;
      if (a) {
        var u = e || r;
        n.dispatchCellContextMenuEvent(u), l = this.valueService.getValue(a, s);
      }
      var c = this.ctrlsService.getGridBodyCtrl(), p = n ? n.getGui() : c.getGridBodyElement();
      this.contextMenuFactory && this.contextMenuFactory.onContextMenu(e, r, s, a, l, p);
    }, t.prototype.processKeyboardEvent = function(e, r) {
      var o = Ys(this.gridOptionsService, r.target, Ho.DOM_DATA_KEY_CELL_CTRL), n = Ys(this.gridOptionsService, r.target, Vo.DOM_DATA_KEY_ROW_CTRL);
      r.defaultPrevented || (o ? this.processCellKeyboardEvent(o, e, r) : n && n.isFullWidth() && this.processFullWidthRowKeyboardEvent(n, e, r));
    }, t.prototype.processCellKeyboardEvent = function(e, r, o) {
      var n = e.getRowNode(), s = e.getColumn(), a = e.isEditing(), l = !Js(this.gridOptionsService, o, n, s, a);
      if (l)
        switch (r) {
          case "keydown":
            var u = !a && this.navigationService.handlePageScrollingKey(o);
            u || e.onKeyDown(o), this.doGridOperations(o, e.isEditing());
            break;
          case "keypress":
            e.onKeyPress(o);
            break;
        }
      if (r === "keydown") {
        var c = e.createEvent(o, m.EVENT_CELL_KEY_DOWN);
        this.eventService.dispatchEvent(c);
      }
      if (r === "keypress") {
        var p = e.createEvent(o, m.EVENT_CELL_KEY_PRESS);
        this.eventService.dispatchEvent(p);
      }
    }, t.prototype.processFullWidthRowKeyboardEvent = function(e, r, o) {
      var n = e.getRowNode(), s = this.focusService.getFocusedCell(), a = s && s.column, l = !Js(this.gridOptionsService, o, n, a, !1);
      if (l) {
        var u = o.key;
        if (r === "keydown")
          switch (u) {
            case L.PAGE_HOME:
            case L.PAGE_END:
              this.navigationService.handlePageScrollingKey(o);
              break;
            case L.UP:
            case L.DOWN:
              e.onKeyboardNavigate(o);
              break;
            case L.TAB:
              e.onTabKeyDown(o);
              break;
          }
      }
      if (r === "keydown") {
        var c = e.createRowEvent(m.EVENT_CELL_KEY_DOWN, o);
        this.eventService.dispatchEvent(c);
      }
      if (r === "keypress") {
        var p = e.createRowEvent(m.EVENT_CELL_KEY_PRESS, o);
        this.eventService.dispatchEvent(p);
      }
    }, t.prototype.doGridOperations = function(e, r) {
      if (!(!e.ctrlKey && !e.metaKey) && !r && this.mouseEventService.isEventFromThisGrid(e)) {
        var o = th(e);
        if (o === L.A)
          return this.onCtrlAndA(e);
        if (o === L.C)
          return this.onCtrlAndC(e);
        if (o === L.X)
          return this.onCtrlAndX(e);
        if (o === L.V)
          return this.onCtrlAndV();
        if (o === L.D)
          return this.onCtrlAndD(e);
        if (o === L.Z)
          return this.onCtrlAndZ(e);
        if (o === L.Y)
          return this.onCtrlAndY();
      }
    }, t.prototype.onCtrlAndA = function(e) {
      var r = this, o = r.pinnedRowModel, n = r.paginationProxy, s = r.rangeService;
      if (s && n.isRowsToRender()) {
        var a = C_([
          o.isEmpty("top"),
          o.isEmpty("bottom")
        ], 2), l = a[0], u = a[1], c = l ? null : "top", p = void 0, d = void 0;
        u ? (p = null, d = this.paginationProxy.getRowCount() - 1) : (p = "bottom", d = o.getPinnedBottomRowData().length - 1);
        var h = this.columnModel.getAllDisplayedColumns();
        if (cr(h))
          return;
        s.setCellRange({
          rowStartIndex: 0,
          rowStartPinned: c,
          rowEndIndex: d,
          rowEndPinned: p,
          columnStart: h[0],
          columnEnd: Ne(h)
        });
      }
      e.preventDefault();
    }, t.prototype.onCtrlAndC = function(e) {
      !this.clipboardService || this.gridOptionsService.is("enableCellTextSelection") || (this.clipboardService.copyToClipboard(), e.preventDefault());
    }, t.prototype.onCtrlAndX = function(e) {
      !this.clipboardService || this.gridOptionsService.is("enableCellTextSelection") || this.gridOptionsService.is("suppressCutToClipboard") || (this.clipboardService.cutToClipboard(), e.preventDefault());
    }, t.prototype.onCtrlAndV = function() {
      pe.isRegistered(re.ClipboardModule) && !this.gridOptionsService.is("suppressClipboardPaste") && this.clipboardService.pasteFromClipboard();
    }, t.prototype.onCtrlAndD = function(e) {
      pe.isRegistered(re.ClipboardModule) && !this.gridOptionsService.is("suppressClipboardPaste") && this.clipboardService.copyRangeDown(), e.preventDefault();
    }, t.prototype.onCtrlAndZ = function(e) {
      this.gridOptionsService.is("undoRedoCellEditing") && (e.preventDefault(), e.shiftKey ? this.undoRedoService.redo("ui") : this.undoRedoService.undo("ui"));
    }, t.prototype.onCtrlAndY = function() {
      this.undoRedoService.redo("ui");
    }, ur([
      v("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), ur([
      v("valueService")
    ], t.prototype, "valueService", void 0), ur([
      Fe("contextMenuFactory")
    ], t.prototype, "contextMenuFactory", void 0), ur([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), ur([
      v("navigationService")
    ], t.prototype, "navigationService", void 0), ur([
      v("focusService")
    ], t.prototype, "focusService", void 0), ur([
      v("undoRedoService")
    ], t.prototype, "undoRedoService", void 0), ur([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), ur([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), ur([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), ur([
      Fe("rangeService")
    ], t.prototype, "rangeService", void 0), ur([
      Fe("clipboardService")
    ], t.prototype, "clipboardService", void 0), ur([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var S_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ds = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, __ = (
  /** @class */
  function(i) {
    S_(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.centerContainerCtrl = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function() {
        e.gridBodyCtrl = e.ctrlsService.getGridBodyCtrl(), e.listenForResize();
      }), this.addManagedListener(this.eventService, m.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this));
    }, t.prototype.listenForResize = function() {
      var e = this, r = function() {
        return e.onCenterViewportResized();
      };
      this.centerContainerCtrl.registerViewportResizeListener(r), this.gridBodyCtrl.registerBodyViewportResizeListener(r);
    }, t.prototype.onScrollbarWidthChanged = function() {
      this.checkViewportAndScrolls();
    }, t.prototype.onCenterViewportResized = function() {
      if (this.centerContainerCtrl.isViewportVisible()) {
        this.checkViewportAndScrolls();
        var e = this.centerContainerCtrl.getCenterWidth();
        e !== this.centerWidth && (this.centerWidth = e, this.columnModel.refreshFlexedColumns({ viewportWidth: this.centerWidth, updateBodyWidths: !0, fireResizedEvent: !0 }));
      } else
        this.bodyHeight = 0;
    }, t.prototype.checkViewportAndScrolls = function() {
      this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.getScrollFeature().checkScrollLeft();
    }, t.prototype.getBodyHeight = function() {
      return this.bodyHeight;
    }, t.prototype.checkBodyHeight = function() {
      var e = this.gridBodyCtrl.getBodyViewportElement(), r = ki(e);
      if (this.bodyHeight !== r) {
        this.bodyHeight = r;
        var o = {
          type: m.EVENT_BODY_HEIGHT_CHANGED
        };
        this.eventService.dispatchEvent(o);
      }
    }, t.prototype.updateScrollVisibleService = function() {
      this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }, t.prototype.updateScrollVisibleServiceImpl = function() {
      var e = {
        horizontalScrollShowing: this.isHorizontalScrollShowing(),
        verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
      };
      this.scrollVisibleService.setScrollsVisible(e);
    }, t.prototype.isHorizontalScrollShowing = function() {
      return this.centerContainerCtrl.isHorizontalScrollShowing();
    }, t.prototype.onHorizontalViewportChanged = function() {
      var e = this.centerContainerCtrl.getCenterWidth(), r = this.centerContainerCtrl.getViewportScrollLeft();
      this.columnModel.setViewportPosition(e, r);
    }, ds([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), ds([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), ds([
      v("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), ds([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var E_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Kp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, R_ = (
  /** @class */
  function(i) {
    E_(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.element = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, m.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
    }, t.prototype.onPinnedLeftWidthChanged = function() {
      var e = this.pinnedWidthService.getPinnedLeftWidth(), r = e > 0;
      be(this.element, r), Er(this.element, e);
    }, t.prototype.getWidth = function() {
      return this.pinnedWidthService.getPinnedLeftWidth();
    }, Kp([
      v("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), Kp([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var O_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, b_ = (
  /** @class */
  function(i) {
    O_(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.element = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, m.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
    }, t.prototype.onPinnedRightWidthChanged = function() {
      var e = this.pinnedWidthService.getPinnedRightWidth(), r = e > 0;
      be(this.element, r), Er(this.element, e);
    }, t.prototype.getWidth = function() {
      return this.pinnedWidthService.getPinnedRightWidth();
    }, Yp([
      v("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), Yp([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var T_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), qp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Bh = (
  /** @class */
  function(i) {
    T_(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.eContainer = e, o.eWrapper = r, o;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, m.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
    }, t.prototype.onHeightChanged = function() {
      var e = this.maxDivHeightScaler.getUiContainerHeight(), r = e != null ? e + "px" : "";
      this.eContainer.style.height = r, this.eWrapper && (this.eWrapper.style.height = r);
    }, qp([
      v("rowContainerHeightService")
    ], t.prototype, "maxDivHeightScaler", void 0), qp([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var P_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), wl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, D_ = (
  /** @class */
  function(i) {
    P_(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.eContainer = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      if (!(!this.gridOptionsService.isEnableRangeSelection() || // no range selection if no property
      ue(this.rangeService))) {
        var r = {
          eElement: this.eContainer,
          onDragStart: this.rangeService.onDragStart.bind(this.rangeService),
          onDragStop: this.rangeService.onDragStop.bind(this.rangeService),
          onDragging: this.rangeService.onDragging.bind(this.rangeService)
        };
        this.dragService.addDragSource(r), this.addDestroyFunc(function() {
          return e.dragService.removeDragSource(r);
        });
      }
    }, wl([
      Fe("rangeService")
    ], t.prototype, "rangeService", void 0), wl([
      v("dragService")
    ], t.prototype, "dragService", void 0), wl([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var A_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Sl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, fc = (
  /** @class */
  function(i) {
    A_(t, i);
    function t(e, r) {
      r === void 0 && (r = !1);
      var o = i.call(this) || this;
      return o.callback = e, o.addSpacer = r, o;
    }
    return t.prototype.postConstruct = function() {
      var e = this.setWidth.bind(this);
      this.addManagedPropertyListener("domLayout", e), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_LEFT_PINNED_WIDTH_CHANGED, e), this.addSpacer && (this.addManagedListener(this.eventService, m.EVENT_RIGHT_PINNED_WIDTH_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_SCROLL_VISIBILITY_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_SCROLLBAR_WIDTH_CHANGED, e)), this.setWidth();
    }, t.prototype.setWidth = function() {
      var e = this.columnModel, r = this.gridOptionsService.isDomLayout("print"), o = e.getBodyContainerWidth(), n = e.getDisplayedColumnsLeftWidth(), s = e.getDisplayedColumnsRightWidth(), a;
      if (r)
        a = o + n + s;
      else if (a = o, this.addSpacer) {
        var l = this.gridOptionsService.is("enableRtl") ? n : s;
        l === 0 && this.scrollVisibleService.isVerticalScrollShowing() && (a += this.gridOptionsService.getScrollbarWidth());
      }
      this.callback(a);
    }, Sl([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Sl([
      v("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Sl([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var x_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Qo = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, F_ = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, M_ = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(F_(arguments[t]));
  return i;
}, M;
(function(i) {
  i.LEFT = "left", i.RIGHT = "right", i.CENTER = "center", i.FULL_WIDTH = "fullWidth", i.TOP_LEFT = "topLeft", i.TOP_RIGHT = "topRight", i.TOP_CENTER = "topCenter", i.TOP_FULL_WIDTH = "topFullWidth", i.STICKY_TOP_LEFT = "stickyTopLeft", i.STICKY_TOP_RIGHT = "stickyTopRight", i.STICKY_TOP_CENTER = "stickyTopCenter", i.STICKY_TOP_FULL_WIDTH = "stickyTopFullWidth", i.BOTTOM_LEFT = "bottomLeft", i.BOTTOM_RIGHT = "bottomRight", i.BOTTOM_CENTER = "bottomCenter", i.BOTTOM_FULL_WIDTH = "bottomFullWidth";
})(M || (M = {}));
var It;
(function(i) {
  i.LEFT = "left", i.RIGHT = "right", i.CENTER = "center", i.FULL_WIDTH = "fullWidth";
})(It || (It = {}));
function kh(i) {
  switch (i) {
    case M.CENTER:
    case M.TOP_CENTER:
    case M.STICKY_TOP_CENTER:
    case M.BOTTOM_CENTER:
      return It.CENTER;
    case M.LEFT:
    case M.TOP_LEFT:
    case M.STICKY_TOP_LEFT:
    case M.BOTTOM_LEFT:
      return It.LEFT;
    case M.RIGHT:
    case M.TOP_RIGHT:
    case M.STICKY_TOP_RIGHT:
    case M.BOTTOM_RIGHT:
      return It.RIGHT;
    case M.FULL_WIDTH:
    case M.TOP_FULL_WIDTH:
    case M.STICKY_TOP_FULL_WIDTH:
    case M.BOTTOM_FULL_WIDTH:
      return It.FULL_WIDTH;
    default:
      throw Error("Invalid Row Container Type");
  }
}
var I_ = ho([
  [M.CENTER, "ag-center-cols-container"],
  [M.LEFT, "ag-pinned-left-cols-container"],
  [M.RIGHT, "ag-pinned-right-cols-container"],
  [M.FULL_WIDTH, "ag-full-width-container"],
  [M.TOP_CENTER, "ag-floating-top-container"],
  [M.TOP_LEFT, "ag-pinned-left-floating-top"],
  [M.TOP_RIGHT, "ag-pinned-right-floating-top"],
  [M.TOP_FULL_WIDTH, "ag-floating-top-full-width-container"],
  [M.STICKY_TOP_CENTER, "ag-sticky-top-container"],
  [M.STICKY_TOP_LEFT, "ag-pinned-left-sticky-top"],
  [M.STICKY_TOP_RIGHT, "ag-pinned-right-sticky-top"],
  [M.STICKY_TOP_FULL_WIDTH, "ag-sticky-top-full-width-container"],
  [M.BOTTOM_CENTER, "ag-floating-bottom-container"],
  [M.BOTTOM_LEFT, "ag-pinned-left-floating-bottom"],
  [M.BOTTOM_RIGHT, "ag-pinned-right-floating-bottom"],
  [M.BOTTOM_FULL_WIDTH, "ag-floating-bottom-full-width-container"]
]), L_ = ho([
  [M.CENTER, "ag-center-cols-viewport"],
  [M.TOP_CENTER, "ag-floating-top-viewport"],
  [M.STICKY_TOP_CENTER, "ag-sticky-top-viewport"],
  [M.BOTTOM_CENTER, "ag-floating-bottom-viewport"]
]), N_ = ho([
  [M.CENTER, "ag-center-cols-clipper"]
]), hc = (
  /** @class */
  function(i) {
    x_(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.visible = !0, r.EMPTY_CTRLS = [], r.name = e, r.isFullWithContainer = r.name === M.TOP_FULL_WIDTH || r.name === M.STICKY_TOP_FULL_WIDTH || r.name === M.BOTTOM_FULL_WIDTH || r.name === M.FULL_WIDTH, r;
    }
    return t.getRowContainerCssClasses = function(e) {
      var r = I_.get(e), o = L_.get(e), n = N_.get(e);
      return { container: r, viewport: o, wrapper: n };
    }, t.getPinned = function(e) {
      switch (e) {
        case M.BOTTOM_LEFT:
        case M.TOP_LEFT:
        case M.STICKY_TOP_LEFT:
        case M.LEFT:
          return "left";
        case M.BOTTOM_RIGHT:
        case M.TOP_RIGHT:
        case M.STICKY_TOP_RIGHT:
        case M.RIGHT:
          return "right";
        default:
          return null;
      }
    }, t.prototype.postConstruct = function() {
      var e = this;
      this.enableRtl = this.gridOptionsService.is("enableRtl"), this.embedFullWidthRows = this.gridOptionsService.is("embedFullWidthRows"), this.forContainers([M.CENTER], function() {
        return e.viewportSizeFeature = e.createManagedBean(new __(e));
      });
    }, t.prototype.registerWithCtrlsService = function() {
      switch (this.name) {
        case M.CENTER:
          this.ctrlsService.registerCenterRowContainerCtrl(this);
          break;
        case M.LEFT:
          this.ctrlsService.registerLeftRowContainerCtrl(this);
          break;
        case M.RIGHT:
          this.ctrlsService.registerRightRowContainerCtrl(this);
          break;
        case M.TOP_CENTER:
          this.ctrlsService.registerTopCenterRowContainerCtrl(this);
          break;
        case M.TOP_LEFT:
          this.ctrlsService.registerTopLeftRowContainerCon(this);
          break;
        case M.TOP_RIGHT:
          this.ctrlsService.registerTopRightRowContainerCtrl(this);
          break;
        case M.STICKY_TOP_CENTER:
          this.ctrlsService.registerStickyTopCenterRowContainerCtrl(this);
          break;
        case M.STICKY_TOP_LEFT:
          this.ctrlsService.registerStickyTopLeftRowContainerCon(this);
          break;
        case M.STICKY_TOP_RIGHT:
          this.ctrlsService.registerStickyTopRightRowContainerCtrl(this);
          break;
        case M.BOTTOM_CENTER:
          this.ctrlsService.registerBottomCenterRowContainerCtrl(this);
          break;
        case M.BOTTOM_LEFT:
          this.ctrlsService.registerBottomLeftRowContainerCtrl(this);
          break;
        case M.BOTTOM_RIGHT:
          this.ctrlsService.registerBottomRightRowContainerCtrl(this);
          break;
      }
    }, t.prototype.forContainers = function(e, r) {
      e.indexOf(this.name) >= 0 && r();
    }, t.prototype.getContainerElement = function() {
      return this.eContainer;
    }, t.prototype.getViewportSizeFeature = function() {
      return this.viewportSizeFeature;
    }, t.prototype.setComp = function(e, r, o, n) {
      var s = this;
      this.comp = e, this.eContainer = r, this.eViewport = o, this.eWrapper = n, this.createManagedBean(new w_(this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder(), this.stopHScrollOnPinnedRows();
      var a = [M.TOP_CENTER, M.TOP_LEFT, M.TOP_RIGHT], l = [M.STICKY_TOP_CENTER, M.STICKY_TOP_LEFT, M.STICKY_TOP_RIGHT], u = [M.BOTTOM_CENTER, M.BOTTOM_LEFT, M.BOTTOM_RIGHT], c = [M.CENTER, M.LEFT, M.RIGHT], p = M_(a, u, c, l), d = [M.CENTER, M.LEFT, M.RIGHT, M.FULL_WIDTH], h = [M.CENTER, M.TOP_CENTER, M.STICKY_TOP_CENTER, M.BOTTOM_CENTER], g = [M.LEFT, M.BOTTOM_LEFT, M.TOP_LEFT, M.STICKY_TOP_LEFT], y = [M.RIGHT, M.BOTTOM_RIGHT, M.TOP_RIGHT, M.STICKY_TOP_RIGHT];
      this.forContainers(g, function() {
        s.pinnedWidthFeature = s.createManagedBean(new R_(s.eContainer)), s.addManagedListener(s.eventService, m.EVENT_LEFT_PINNED_WIDTH_CHANGED, function() {
          return s.onPinnedWidthChanged();
        });
      }), this.forContainers(y, function() {
        s.pinnedWidthFeature = s.createManagedBean(new b_(s.eContainer)), s.addManagedListener(s.eventService, m.EVENT_RIGHT_PINNED_WIDTH_CHANGED, function() {
          return s.onPinnedWidthChanged();
        });
      }), this.forContainers(d, function() {
        return s.createManagedBean(new Bh(s.eContainer, s.eWrapper));
      }), this.forContainers(p, function() {
        return s.createManagedBean(new D_(s.eContainer));
      }), this.forContainers(h, function() {
        return s.createManagedBean(new fc(function(S) {
          return s.comp.setContainerWidth(S + "px");
        }));
      }), kn() && (this.forContainers([M.CENTER], function() {
        var S = s.enableRtl ? m.EVENT_LEFT_PINNED_WIDTH_CHANGED : m.EVENT_RIGHT_PINNED_WIDTH_CHANGED;
        s.addManagedListener(s.eventService, S, function() {
          return s.refreshPaddingForFakeScrollbar();
        });
      }), this.refreshPaddingForFakeScrollbar()), this.addListeners(), this.registerWithCtrlsService();
    }, t.prototype.refreshPaddingForFakeScrollbar = function() {
      var e = this, r = e.enableRtl, o = e.columnModel, n = e.name, s = e.eWrapper, a = e.eContainer, l = r ? M.LEFT : M.RIGHT;
      this.forContainers([M.CENTER, l], function() {
        var u = o.getContainerWidth(l), c = r ? "marginLeft" : "marginRight";
        n === M.CENTER ? s.style[c] = u ? "0px" : "16px" : a.style[c] = u ? "16px" : "0px";
      });
    }, t.prototype.addListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_SCROLL_VISIBILITY_CHANGED, function() {
        return e.onScrollVisibilityChanged();
      }), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, function() {
        return e.onDisplayedColumnsChanged();
      }), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function() {
        return e.onDisplayedColumnsWidthChanged();
      }), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_ROWS_CHANGED, function(r) {
        return e.onDisplayedRowsChanged(r.afterScroll);
      }), this.onScrollVisibilityChanged(), this.onDisplayedColumnsChanged(), this.onDisplayedColumnsWidthChanged(), this.onDisplayedRowsChanged();
    }, t.prototype.listenOnDomOrder = function() {
      var e = this, r = [M.STICKY_TOP_CENTER, M.STICKY_TOP_LEFT, M.STICKY_TOP_RIGHT, M.STICKY_TOP_FULL_WIDTH], o = r.indexOf(this.name) >= 0;
      if (o) {
        this.comp.setDomOrder(!0);
        return;
      }
      var n = function() {
        var s = e.gridOptionsService.is("ensureDomOrder"), a = e.gridOptionsService.isDomLayout("print");
        e.comp.setDomOrder(s || a);
      };
      this.addManagedPropertyListener("domLayout", n), n();
    }, t.prototype.stopHScrollOnPinnedRows = function() {
      var e = this;
      this.forContainers([M.TOP_CENTER, M.STICKY_TOP_CENTER, M.BOTTOM_CENTER], function() {
        var r = function() {
          return e.eViewport.scrollLeft = 0;
        };
        e.addManagedListener(e.eViewport, "scroll", r);
      });
    }, t.prototype.onDisplayedColumnsChanged = function() {
      var e = this;
      this.forContainers([M.CENTER], function() {
        return e.onHorizontalViewportChanged();
      });
    }, t.prototype.onDisplayedColumnsWidthChanged = function() {
      var e = this;
      this.forContainers([M.CENTER], function() {
        return e.onHorizontalViewportChanged();
      });
    }, t.prototype.onScrollVisibilityChanged = function() {
      var e = this.gridOptionsService.getScrollbarWidth() || 0;
      if (this.name === M.CENTER) {
        var r = this.scrollVisibleService.isHorizontalScrollShowing(), o = r ? e : 0, n = o == 0 ? "100%" : "calc(100% + " + o + "px)";
        this.comp.setViewportHeight(n);
      }
      if (this.name === M.FULL_WIDTH) {
        var s = kn() ? 16 : 0, n = "calc(100% - " + s + "px)";
        this.eContainer.style.setProperty("width", n);
      }
    }, t.prototype.addPreventScrollWhileDragging = function() {
      var e = this, r = function(o) {
        e.dragService.isDragging() && o.cancelable && o.preventDefault();
      };
      this.eContainer.addEventListener("touchmove", r, { passive: !1 }), this.addDestroyFunc(function() {
        return e.eContainer.removeEventListener("touchmove", r);
      });
    }, t.prototype.onHorizontalViewportChanged = function() {
      var e = this.getCenterWidth(), r = this.getCenterViewportScrollLeft();
      this.columnModel.setViewportPosition(e, r);
    }, t.prototype.getCenterWidth = function() {
      return Pa(this.eViewport);
    }, t.prototype.getCenterViewportScrollLeft = function() {
      return Fi(this.eViewport, this.enableRtl);
    }, t.prototype.registerViewportResizeListener = function(e) {
      var r = this.resizeObserverService.observeResize(this.eViewport, e);
      this.addDestroyFunc(function() {
        return r();
      });
    }, t.prototype.isViewportVisible = function() {
      return qn(this.eViewport);
    }, t.prototype.getViewportScrollLeft = function() {
      return Fi(this.eViewport, this.enableRtl);
    }, t.prototype.isHorizontalScrollShowing = function() {
      var e = this.gridOptionsService.is("alwaysShowHorizontalScroll");
      return e || Yf(this.eViewport);
    }, t.prototype.getViewportElement = function() {
      return this.eViewport;
    }, t.prototype.setContainerTranslateX = function(e) {
      this.eContainer.style.transform = "translateX(" + e + "px)";
    }, t.prototype.getHScrollPosition = function() {
      var e = {
        left: this.eViewport.scrollLeft,
        right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
      };
      return e;
    }, t.prototype.setCenterViewportScrollLeft = function(e) {
      Qs(this.eViewport, e, this.enableRtl);
    }, t.prototype.isContainerVisible = function() {
      var e = t.getPinned(this.name);
      return !e || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }, t.prototype.onPinnedWidthChanged = function() {
      var e = this.isContainerVisible();
      this.visible != e && (this.visible = e, this.onDisplayedRowsChanged()), kn() && this.refreshPaddingForFakeScrollbar();
    }, t.prototype.onDisplayedRowsChanged = function(e) {
      var r = this;
      if (e === void 0 && (e = !1), this.visible) {
        var o = this.gridOptionsService.isDomLayout("print"), n = function(a) {
          var l = a.isFullWidth(), u = r.embedFullWidthRows || o, c = r.isFullWithContainer ? !u && l : u || !l;
          return c;
        }, s = this.getRowCtrls().filter(n);
        this.comp.setRowCtrls(s, e);
      } else
        this.comp.setRowCtrls(this.EMPTY_CTRLS, !1);
    }, t.prototype.getRowCtrls = function() {
      switch (this.name) {
        case M.TOP_CENTER:
        case M.TOP_LEFT:
        case M.TOP_RIGHT:
        case M.TOP_FULL_WIDTH:
          return this.rowRenderer.getTopRowCtrls();
        case M.STICKY_TOP_CENTER:
        case M.STICKY_TOP_LEFT:
        case M.STICKY_TOP_RIGHT:
        case M.STICKY_TOP_FULL_WIDTH:
          return this.rowRenderer.getStickyTopRowCtrls();
        case M.BOTTOM_CENTER:
        case M.BOTTOM_LEFT:
        case M.BOTTOM_RIGHT:
        case M.BOTTOM_FULL_WIDTH:
          return this.rowRenderer.getBottomRowCtrls();
        default:
          return this.rowRenderer.getRowCtrls();
      }
    }, Qo([
      v("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Qo([
      v("dragService")
    ], t.prototype, "dragService", void 0), Qo([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Qo([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Qo([
      v("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Qo([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Qo([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var G_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, H_ = (
  /* html */
  `<div class="ag-root ag-unselectable" role="treegrid">
        <ag-header-root ref="gridHeader"></ag-header-root>
        <div class="ag-floating-top" ref="eTop" role="presentation">
            <ag-row-container ref="topLeftContainer" name="` + M.TOP_LEFT + `"></ag-row-container>
            <ag-row-container ref="topCenterContainer" name="` + M.TOP_CENTER + `"></ag-row-container>
            <ag-row-container ref="topRightContainer" name="` + M.TOP_RIGHT + `"></ag-row-container>
            <ag-row-container ref="topFullWidthContainer" name="` + M.TOP_FULL_WIDTH + `"></ag-row-container>
        </div>
        <div class="ag-body" ref="eBody" role="presentation">
            <div class="ag-body-clipper" ref="eBodyClipper" role="presentation">
                <div class="ag-body-viewport" ref="eBodyViewport" role="presentation">
                    <ag-row-container ref="leftContainer" name="` + M.LEFT + `"></ag-row-container>
                    <ag-row-container ref="centerContainer" name="` + M.CENTER + `"></ag-row-container>
                    <ag-row-container ref="rightContainer" name="` + M.RIGHT + `"></ag-row-container>
                    <ag-row-container ref="fullWidthContainer" name="` + M.FULL_WIDTH + `"></ag-row-container>
                </div>
            </div>
            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>
        </div>
        <div class="ag-sticky-top" ref="eStickyTop" role="presentation">
            <ag-row-container ref="stickyTopLeftContainer" name="` + M.STICKY_TOP_LEFT + `"></ag-row-container>
            <ag-row-container ref="stickyTopCenterContainer" name="` + M.STICKY_TOP_CENTER + `"></ag-row-container>
            <ag-row-container ref="stickyTopRightContainer" name="` + M.STICKY_TOP_RIGHT + `"></ag-row-container>
            <ag-row-container ref="stickyTopFullWidthContainer" name="` + M.STICKY_TOP_FULL_WIDTH + `"></ag-row-container>
        </div>
        <div class="ag-floating-bottom" ref="eBottom" role="presentation">
            <ag-row-container ref="bottomLeftContainer" name="` + M.BOTTOM_LEFT + `"></ag-row-container>
            <ag-row-container ref="bottomCenterContainer" name="` + M.BOTTOM_CENTER + `"></ag-row-container>
            <ag-row-container ref="bottomRightContainer" name="` + M.BOTTOM_RIGHT + `"></ag-row-container>
            <ag-row-container ref="bottomFullWidthContainer" name="` + M.BOTTOM_FULL_WIDTH + `"></ag-row-container>
        </div>
        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>
        <ag-overlay-wrapper></ag-overlay-wrapper>
    </div>`
), jh = (
  /** @class */
  function(i) {
    G_(t, i);
    function t() {
      return i.call(this, H_) || this;
    }
    return t.prototype.init = function() {
      var e = this, r = function(n, s) {
        var a = n + "px";
        s.style.minHeight = a, s.style.height = a;
      }, o = {
        setRowAnimationCssOnBodyViewport: function(n, s) {
          return e.setRowAnimationCssOnBodyViewport(n, s);
        },
        setColumnCount: function(n) {
          return If(e.getGui(), n);
        },
        setRowCount: function(n) {
          return Mf(e.getGui(), n);
        },
        setTopHeight: function(n) {
          return r(n, e.eTop);
        },
        setBottomHeight: function(n) {
          return r(n, e.eBottom);
        },
        setTopDisplay: function(n) {
          return e.eTop.style.display = n;
        },
        setBottomDisplay: function(n) {
          return e.eBottom.style.display = n;
        },
        setStickyTopHeight: function(n) {
          return e.eStickyTop.style.height = n;
        },
        setStickyTopTop: function(n) {
          return e.eStickyTop.style.top = n;
        },
        setStickyTopWidth: function(n) {
          return e.eStickyTop.style.width = n;
        },
        setColumnMovingCss: function(n, s) {
          return e.addOrRemoveCssClass(n, s);
        },
        updateLayoutClasses: function(n, s) {
          var a = [
            e.eBodyViewport.classList,
            e.eBodyClipper.classList,
            e.eBody.classList
          ];
          a.forEach(function(l) {
            l.toggle(lt.AUTO_HEIGHT, s.autoHeight), l.toggle(lt.NORMAL, s.normal), l.toggle(lt.PRINT, s.print);
          }), e.addOrRemoveCssClass(lt.AUTO_HEIGHT, s.autoHeight), e.addOrRemoveCssClass(lt.NORMAL, s.normal), e.addOrRemoveCssClass(lt.PRINT, s.print);
        },
        setAlwaysVerticalScrollClass: function(n, s) {
          return e.eBodyViewport.classList.toggle(Hh, s);
        },
        registerBodyViewportResizeListener: function(n) {
          var s = e.resizeObserverService.observeResize(e.eBodyViewport, n);
          e.addDestroyFunc(function() {
            return s();
          });
        },
        setPinnedTopBottomOverflowY: function(n) {
          return e.eTop.style.overflowY = e.eBottom.style.overflowY = n;
        },
        setCellSelectableCss: function(n, s) {
          [e.eTop, e.eBodyViewport, e.eBottom].forEach(function(a) {
            return a.classList.toggle(Gh, s);
          });
        },
        setBodyViewportWidth: function(n) {
          return e.eBodyViewport.style.width = n;
        }
      };
      this.ctrl = this.createManagedBean(new Vh()), this.ctrl.setComp(o, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop), (this.rangeService || this.gridOptionsService.get("rowSelection") === "multiple") && Ff(this.getGui(), !0);
    }, t.prototype.setRowAnimationCssOnBodyViewport = function(e, r) {
      var o = this.eBodyViewport.classList;
      o.toggle(gn.ANIMATION_ON, r), o.toggle(gn.ANIMATION_OFF, !r);
    }, t.prototype.getFloatingTopBottom = function() {
      return [this.eTop, this.eBottom];
    }, Yr([
      v("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Yr([
      Fe("rangeService")
    ], t.prototype, "rangeService", void 0), Yr([
      Y("eBodyViewport")
    ], t.prototype, "eBodyViewport", void 0), Yr([
      Y("eStickyTop")
    ], t.prototype, "eStickyTop", void 0), Yr([
      Y("eTop")
    ], t.prototype, "eTop", void 0), Yr([
      Y("eBottom")
    ], t.prototype, "eBottom", void 0), Yr([
      Y("gridHeader")
    ], t.prototype, "headerRootComp", void 0), Yr([
      Y("eBodyClipper")
    ], t.prototype, "eBodyClipper", void 0), Yr([
      Y("eBody")
    ], t.prototype, "eBody", void 0), Yr([
      U
    ], t.prototype, "init", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var V_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), _l = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Wh = (
  /** @class */
  function(i) {
    V_(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.update();
    }, t.prototype.onDisplayedColumnsWidthChanged = function() {
      this.update();
    }, t.prototype.update = function() {
      this.updateImpl(), setTimeout(this.updateImpl.bind(this), 500);
    }, t.prototype.updateImpl = function() {
      var e = this.ctrlsService.getCenterRowContainerCtrl();
      if (e) {
        var r = {
          horizontalScrollShowing: e.isHorizontalScrollShowing(),
          verticalScrollShowing: this.isVerticalScrollShowing()
        };
        this.setScrollsVisible(r);
      }
    }, t.prototype.setScrollsVisible = function(e) {
      var r = this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing;
      if (r) {
        this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing;
        var o = {
          type: m.EVENT_SCROLL_VISIBILITY_CHANGED
        };
        this.eventService.dispatchEvent(o);
      }
    }, t.prototype.isHorizontalScrollShowing = function() {
      return this.horizontalScrollShowing;
    }, t.prototype.isVerticalScrollShowing = function() {
      return this.verticalScrollShowing;
    }, _l([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), _l([
      U
    ], t.prototype, "postConstruct", null), t = _l([
      te("scrollVisibleService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var B_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Xp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Uh = (
  /** @class */
  function(i) {
    B_(t, i);
    function t() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.gridInstanceId = e.gridInstanceSequence.next(), r;
    }
    e = t, t.prototype.stampTopLevelGridCompWithGridInstance = function(r) {
      r[e.GRID_DOM_KEY] = this.gridInstanceId;
    }, t.prototype.getRenderedCellForEvent = function(r) {
      return Ys(this.gridOptionsService, r.target, Ho.DOM_DATA_KEY_CELL_CTRL);
    }, t.prototype.isEventFromThisGrid = function(r) {
      var o = this.isElementInThisGrid(r.target);
      return o;
    }, t.prototype.isElementInThisGrid = function(r) {
      for (var o = r; o; ) {
        var n = o[e.GRID_DOM_KEY];
        if (k(n)) {
          var s = n === this.gridInstanceId;
          return s;
        }
        o = o.parentElement;
      }
      return !1;
    }, t.prototype.getCellPositionForEvent = function(r) {
      var o = this.getRenderedCellForEvent(r);
      return o ? o.getCellPosition() : null;
    }, t.prototype.getNormalisedPosition = function(r) {
      var o = this.gridOptionsService.isDomLayout("normal"), n = r, s, a;
      if (n.clientX != null || n.clientY != null ? (s = n.clientX, a = n.clientY) : (s = n.x, a = n.y), o) {
        var l = this.ctrlsService.getGridBodyCtrl(), u = l.getScrollFeature().getVScrollPosition(), c = l.getScrollFeature().getHScrollPosition();
        s += c.left, a += u.top;
      }
      return { x: s, y: a };
    };
    var e;
    return t.gridInstanceSequence = new fn(), t.GRID_DOM_KEY = "__ag_grid_instance", Xp([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = e = Xp([
      te("mouseEventService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var k_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), sa = function() {
  return sa = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, sa.apply(this, arguments);
}, tr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, zh = (
  /** @class */
  function(i) {
    k_(t, i);
    function t() {
      var e = i.call(this) || this;
      return e.onPageDown = Jl(e.onPageDown, 100), e.onPageUp = Jl(e.onPageUp, 100), e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.gridBodyCon = r.gridBodyCtrl;
      });
    }, t.prototype.handlePageScrollingKey = function(e) {
      var r = e.key, o = e.altKey, n = e.ctrlKey || e.metaKey, s = !!this.rangeService && e.shiftKey, a = this.mouseEventService.getCellPositionForEvent(e), l = !1;
      switch (r) {
        case L.PAGE_HOME:
        case L.PAGE_END:
          !n && !o && (this.onHomeOrEndKey(r), l = !0);
          break;
        case L.LEFT:
        case L.RIGHT:
        case L.UP:
        case L.DOWN:
          if (!a)
            return !1;
          n && !o && !s && (this.onCtrlUpDownLeftRight(r, a), l = !0);
          break;
        case L.PAGE_DOWN:
          if (!a)
            return !1;
          !n && !o && (this.onPageDown(a), l = !0);
          break;
        case L.PAGE_UP:
          if (!a)
            return !1;
          !n && !o && (this.onPageUp(a), l = !0);
          break;
      }
      return l && e.preventDefault(), l;
    }, t.prototype.navigateTo = function(e) {
      var r = e.scrollIndex, o = e.scrollType, n = e.scrollColumn, s = e.focusIndex, a = e.focusColumn;
      if (k(n) && !n.isPinned() && this.gridBodyCon.getScrollFeature().ensureColumnVisible(n), k(r) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(r, o), e.isAsync || this.gridBodyCon.getScrollFeature().ensureIndexVisible(s), this.focusService.setFocusedCell({ rowIndex: s, column: a, rowPinned: null, forceBrowserFocus: !0 }), this.rangeService) {
        var l = { rowIndex: s, rowPinned: null, column: a };
        this.rangeService.setRangeToCell(l);
      }
    }, t.prototype.onPageDown = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), o = r.getScrollFeature().getVScrollPosition(), n = this.getViewportHeight(), s = this.paginationProxy.getPixelOffset(), a = o.top + n, l = this.paginationProxy.getRowIndexAtPixel(a + s);
      this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, l) : this.navigateToNextPage(e, l);
    }, t.prototype.onPageUp = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), o = r.getScrollFeature().getVScrollPosition(), n = this.paginationProxy.getPixelOffset(), s = o.top, a = this.paginationProxy.getRowIndexAtPixel(s + n);
      this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, a, !0) : this.navigateToNextPage(e, a, !0);
    }, t.prototype.navigateToNextPage = function(e, r, o) {
      o === void 0 && (o = !1);
      var n = this.getViewportHeight(), s = this.paginationProxy.getPageFirstRow(), a = this.paginationProxy.getPageLastRow(), l = this.paginationProxy.getPixelOffset(), u = this.paginationProxy.getRow(e.rowIndex), c = o ? (u == null ? void 0 : u.rowHeight) - n - l : n - l, p = (u == null ? void 0 : u.rowTop) + c, d = this.paginationProxy.getRowIndexAtPixel(p + l);
      if (d === e.rowIndex) {
        var h = o ? -1 : 1;
        r = d = e.rowIndex + h;
      }
      var g;
      o ? (g = "bottom", d < s && (d = s), r < s && (r = s)) : (g = "top", d > a && (d = a), r > a && (r = a)), this.isRowTallerThanView(d) && (r = d, g = "top"), this.navigateTo({
        scrollIndex: r,
        scrollType: g,
        scrollColumn: null,
        focusIndex: d,
        focusColumn: e.column
      });
    }, t.prototype.navigateToNextPageWithAutoHeight = function(e, r, o) {
      var n = this;
      o === void 0 && (o = !1), this.navigateTo({
        scrollIndex: r,
        scrollType: o ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: r,
        focusColumn: e.column
      }), setTimeout(function() {
        var s = n.getNextFocusIndexForAutoHeight(e, o);
        n.navigateTo({
          scrollIndex: r,
          scrollType: o ? "bottom" : "top",
          scrollColumn: null,
          focusIndex: s,
          focusColumn: e.column,
          isAsync: !0
        });
      }, 50);
    }, t.prototype.getNextFocusIndexForAutoHeight = function(e, r) {
      var o;
      r === void 0 && (r = !1);
      for (var n = r ? -1 : 1, s = this.getViewportHeight(), a = this.paginationProxy.getPageLastRow(), l = 0, u = e.rowIndex; u >= 0 && u <= a; ) {
        var c = this.paginationProxy.getRow(u);
        if (c) {
          var p = (o = c.rowHeight) !== null && o !== void 0 ? o : 0;
          if (l + p > s)
            break;
          l += p;
        }
        u += n;
      }
      return Math.max(0, Math.min(u, a));
    }, t.prototype.getViewportHeight = function() {
      var e = this.ctrlsService.getGridBodyCtrl(), r = e.getScrollFeature().getVScrollPosition(), o = this.gridOptionsService.getScrollbarWidth(), n = r.bottom - r.top;
      return this.ctrlsService.getCenterRowContainerCtrl().isHorizontalScrollShowing() && (n -= o), n;
    }, t.prototype.isRowTallerThanView = function(e) {
      var r = this.paginationProxy.getRow(e);
      if (!r)
        return !1;
      var o = r.rowHeight;
      return typeof o != "number" ? !1 : o > this.getViewportHeight();
    }, t.prototype.onCtrlUpDownLeftRight = function(e, r) {
      var o = this.cellNavigationService.getNextCellToFocus(e, r, !0), n = o.rowIndex, s = o.column;
      this.navigateTo({
        scrollIndex: n,
        scrollType: null,
        scrollColumn: s,
        focusIndex: n,
        focusColumn: s
      });
    }, t.prototype.onHomeOrEndKey = function(e) {
      var r = e === L.PAGE_HOME, o = this.columnModel.getAllDisplayedColumns(), n = r ? o[0] : Ne(o), s = r ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
      this.navigateTo({
        scrollIndex: s,
        scrollType: null,
        scrollColumn: n,
        focusIndex: s,
        focusColumn: n
      });
    }, t.prototype.onTabKeyDown = function(e, r) {
      var o = r.shiftKey, n = this.tabToNextCellCommon(e, o, r);
      if (n) {
        r.preventDefault();
        return;
      }
      if (o) {
        var s = e.getRowPosition(), a = s.rowIndex, l = s.rowPinned, u = l ? a === 0 : a === this.paginationProxy.getPageFirstRow();
        u && (this.gridOptionsService.getNum("headerHeight") === 0 ? this.focusService.focusNextGridCoreContainer(!0, !0) : (r.preventDefault(), this.focusService.focusLastHeader(r)));
      } else
        e instanceof Ho && e.focusCell(!0), this.focusService.focusNextGridCoreContainer(o) && r.preventDefault();
    }, t.prototype.tabToNextCell = function(e, r) {
      var o = this.focusService.getFocusedCell();
      if (!o)
        return !1;
      var n = this.getCellByPosition(o);
      return !n && (n = this.rowRenderer.getRowByPosition(o), !n || !n.isFullWidth()) ? !1 : this.tabToNextCellCommon(n, e, r);
    }, t.prototype.tabToNextCellCommon = function(e, r, o) {
      var n = e.isEditing();
      if (!n && e instanceof Ho) {
        var s = e, a = s.getRowCtrl();
        a && (n = a.isEditing());
      }
      var l;
      return n ? this.gridOptionsService.get("editType") === "fullRow" ? l = this.moveToNextEditingRow(e, r, o) : l = this.moveToNextEditingCell(e, r, o) : l = this.moveToNextCellNotEditing(e, r), l || !!this.focusService.getFocusedHeader();
    }, t.prototype.moveToNextEditingCell = function(e, r, o) {
      o === void 0 && (o = null);
      var n = e.getCellPosition();
      e.getGui().focus(), e.stopEditing();
      var s = this.findNextCellToFocusOn(n, r, !0);
      return s == null ? !1 : (s.startEditing(null, null, !0, o), s.focusCell(!1), !0);
    }, t.prototype.moveToNextEditingRow = function(e, r, o) {
      o === void 0 && (o = null);
      var n = e.getCellPosition(), s = this.findNextCellToFocusOn(n, r, !0);
      if (s == null)
        return !1;
      var a = s.getCellPosition(), l = this.isCellEditable(n), u = this.isCellEditable(a), c = a && n.rowIndex === a.rowIndex && n.rowPinned === a.rowPinned;
      if (l && e.setFocusOutOnEditor(), !c) {
        var p = e.getRowCtrl();
        p.stopEditing();
        var d = s.getRowCtrl();
        d.startRowEditing(void 0, void 0, void 0, o);
      }
      return u ? (s.setFocusInOnEditor(), s.focusCell()) : s.focusCell(!0), !0;
    }, t.prototype.moveToNextCellNotEditing = function(e, r) {
      var o = this.columnModel.getAllDisplayedColumns(), n;
      e instanceof Vo ? n = sa(sa({}, e.getRowPosition()), { column: r ? o[0] : Ne(o) }) : n = e.getCellPosition();
      var s = this.findNextCellToFocusOn(n, r, !1);
      if (s instanceof Ho)
        s.focusCell(!0);
      else if (s)
        return this.tryToFocusFullWidthRow(s.getRowPosition(), r);
      return k(s);
    }, t.prototype.findNextCellToFocusOn = function(e, r, o) {
      for (var n = e; ; ) {
        e !== n && (e = n), r || (n = this.getLastCellOfColSpan(n)), n = this.cellNavigationService.getNextTabbedCell(n, r);
        var s = this.gridOptionsService.getCallback("tabToNextCell");
        if (k(s)) {
          var a = {
            backwards: r,
            editing: o,
            previousCellPosition: e,
            nextCellPosition: n || null
          }, l = s(a);
          k(l) ? (l.floating && (Pe(function() {
            console.warn("AG Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?");
          }, "no floating in userCell"), l.rowPinned = l.floating), n = {
            rowIndex: l.rowIndex,
            column: l.column,
            rowPinned: l.rowPinned
          }) : n = null;
        }
        if (!n)
          return null;
        if (n.rowIndex < 0) {
          var u = this.headerNavigationService.getHeaderRowCount();
          return this.focusService.focusHeaderPosition({
            headerPosition: {
              headerRowIndex: u + n.rowIndex,
              column: n.column
            }
          }), null;
        }
        var c = this.gridOptionsService.get("editType") === "fullRow";
        if (o && !c) {
          var p = this.isCellEditable(n);
          if (!p)
            continue;
        }
        this.ensureCellVisible(n);
        var d = this.getCellByPosition(n);
        if (!d) {
          var h = this.rowRenderer.getRowByPosition(n);
          if (!h || !h.isFullWidth() || o)
            continue;
          return h;
        }
        if (!d.isSuppressNavigable())
          return this.rangeService && this.rangeService.setRangeToCell(n), d;
      }
    }, t.prototype.isCellEditable = function(e) {
      var r = this.lookupRowNodeForCell(e);
      return r ? e.column.isCellEditable(r) : !1;
    }, t.prototype.getCellByPosition = function(e) {
      var r = this.rowRenderer.getRowByPosition(e);
      return r ? r.getCellCtrl(e.column) : null;
    }, t.prototype.lookupRowNodeForCell = function(e) {
      return e.rowPinned === "top" ? this.pinnedRowModel.getPinnedTopRow(e.rowIndex) : e.rowPinned === "bottom" ? this.pinnedRowModel.getPinnedBottomRow(e.rowIndex) : this.paginationProxy.getRow(e.rowIndex);
    }, t.prototype.navigateToNextCell = function(e, r, o, n) {
      for (var s = o, a = !1; s && (s === o || !this.isValidNavigateCell(s)); )
        this.gridOptionsService.is("enableRtl") ? r === L.LEFT && (s = this.getLastCellOfColSpan(s)) : r === L.RIGHT && (s = this.getLastCellOfColSpan(s)), s = this.cellNavigationService.getNextCellToFocus(r, s), a = ue(s);
      if (a && e && e.key === L.UP && (s = {
        rowIndex: -1,
        rowPinned: null,
        column: o.column
      }), n) {
        var l = this.gridOptionsService.getCallback("navigateToNextCell");
        if (k(l)) {
          var u = {
            key: r,
            previousCellPosition: o,
            nextCellPosition: s || null,
            event: e
          }, c = l(u);
          k(c) ? (c.floating && (Pe(function() {
            console.warn("AG Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?");
          }, "no floating in userCell"), c.rowPinned = c.floating), s = {
            rowPinned: c.rowPinned,
            rowIndex: c.rowIndex,
            column: c.column
          }) : s = null;
        }
      }
      if (s) {
        if (s.rowIndex < 0) {
          var p = this.headerNavigationService.getHeaderRowCount();
          this.focusService.focusHeaderPosition({
            headerPosition: { headerRowIndex: p + s.rowIndex, column: o.column },
            event: e || void 0
          });
          return;
        }
        var d = this.getNormalisedPosition(s);
        d ? this.focusPosition(d) : this.tryToFocusFullWidthRow(s);
      }
    }, t.prototype.getNormalisedPosition = function(e) {
      this.ensureCellVisible(e);
      var r = this.getCellByPosition(e);
      return r ? (e = r.getCellPosition(), this.ensureCellVisible(e), e) : null;
    }, t.prototype.tryToFocusFullWidthRow = function(e, r) {
      r === void 0 && (r = !1);
      var o = this.columnModel.getAllDisplayedColumns(), n = this.rowRenderer.getRowByPosition(e);
      if (!n || !n.isFullWidth())
        return !1;
      var s = this.focusService.getFocusedCell(), a = {
        rowIndex: e.rowIndex,
        rowPinned: e.rowPinned,
        column: e.column || (r ? Ne(o) : o[0])
      };
      this.focusPosition(a);
      var l = s != null ? this.rowPositionUtils.before(a, s) : !1, u = {
        type: m.EVENT_FULL_WIDTH_ROW_FOCUSED,
        rowIndex: a.rowIndex,
        rowPinned: a.rowPinned,
        column: a.column,
        isFullWidthCell: !0,
        floating: a.rowPinned,
        fromBelow: l
      };
      return this.eventService.dispatchEvent(u), !0;
    }, t.prototype.focusPosition = function(e) {
      this.focusService.setFocusedCell({
        rowIndex: e.rowIndex,
        column: e.column,
        rowPinned: e.rowPinned,
        forceBrowserFocus: !0
      }), this.rangeService && this.rangeService.setRangeToCell(e);
    }, t.prototype.isValidNavigateCell = function(e) {
      var r = this.rowPositionUtils.getRowNode(e);
      return !!r;
    }, t.prototype.getLastCellOfColSpan = function(e) {
      var r = this.getCellByPosition(e);
      if (!r)
        return e;
      var o = r.getColSpanningList();
      return o.length === 1 ? e : {
        rowIndex: e.rowIndex,
        column: Ne(o),
        rowPinned: e.rowPinned
      };
    }, t.prototype.ensureCellVisible = function(e) {
      var r = this.gridOptionsService.is("groupRowsSticky"), o = this.rowModel.getRow(e.rowIndex), n = r && (o == null ? void 0 : o.sticky);
      !n && ue(e.rowPinned) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(e.rowIndex), e.column.isPinned() || this.gridBodyCon.getScrollFeature().ensureColumnVisible(e.column);
    }, tr([
      v("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), tr([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), tr([
      v("focusService")
    ], t.prototype, "focusService", void 0), tr([
      Fe("rangeService")
    ], t.prototype, "rangeService", void 0), tr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), tr([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), tr([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), tr([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), tr([
      v("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), tr([
      v("rowPositionUtils")
    ], t.prototype, "rowPositionUtils", void 0), tr([
      v("cellNavigationService")
    ], t.prototype, "cellNavigationService", void 0), tr([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), tr([
      U
    ], t.prototype, "postConstruct", null), t = tr([
      te("navigationService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var j_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), W_ = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, $h = (
  /** @class */
  function(i) {
    j_(t, i);
    function t(e) {
      var r = i.call(
        this,
        /* html */
        '<div class="ag-popup-editor" tabindex="-1"/>'
      ) || this;
      return r.params = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.gridOptionsService.setDomData(this.getGui(), t.DOM_KEY_POPUP_EDITOR_WRAPPER, !0), this.addKeyDownListener();
    }, t.prototype.addKeyDownListener = function() {
      var e = this, r = this.getGui(), o = this.params, n = function(s) {
        Js(e.gridOptionsService, s, o.node, o.column, !0) || o.onKeyDown(s);
      };
      this.addManagedListener(r, "keydown", n);
    }, t.DOM_KEY_POPUP_EDITOR_WRAPPER = "popupEditorWrapper", W_([
      U
    ], t.prototype, "postConstruct", null), t;
  }(Xn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var U_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Kh = (
  /** @class */
  function(i) {
    U_(t, i);
    function t(e, r, o, n, s) {
      var a = i.call(this) || this;
      a.rendererVersion = 0, a.editorVersion = 0, a.beans = e, a.column = r.getColumn(), a.rowNode = r.getRowNode(), a.rowCtrl = r.getRowCtrl(), a.eRow = n, a.setTemplate(
        /* html */
        '<div comp-id="' + a.getCompId() + '"/>'
      );
      var l = a.getGui();
      a.forceWrapper = r.isForceWrapper(), a.refreshWrapper(!1);
      var u = function(p, d, h) {
        var g = h || l;
        d != null && d != "" ? g.setAttribute(p, d) : g.removeAttribute(p);
      }, c = {
        addOrRemoveCssClass: function(p, d) {
          return a.addOrRemoveCssClass(p, d);
        },
        setUserStyles: function(p) {
          return Qu(l, p);
        },
        getFocusableElement: function() {
          return a.getFocusableElement();
        },
        setTabIndex: function(p) {
          return u("tabindex", p.toString());
        },
        setRole: function(p) {
          return Dt(l, p);
        },
        setColId: function(p) {
          return u("col-id", p);
        },
        setTitle: function(p) {
          return u("title", p);
        },
        setIncludeSelection: function(p) {
          return a.includeSelection = p;
        },
        setIncludeRowDrag: function(p) {
          return a.includeRowDrag = p;
        },
        setIncludeDndSource: function(p) {
          return a.includeDndSource = p;
        },
        setRenderDetails: function(p, d, h) {
          return a.setRenderDetails(p, d, h);
        },
        setEditDetails: function(p, d, h) {
          return a.setEditDetails(p, d, h);
        },
        getCellEditor: function() {
          return a.cellEditor || null;
        },
        getCellRenderer: function() {
          return a.cellRenderer || null;
        },
        getParentOfValue: function() {
          return a.getParentOfValue();
        }
      };
      return a.cellCtrl = r, r.setComp(c, a.getGui(), a.eCellWrapper, o, s), a;
    }
    return t.prototype.getParentOfValue = function() {
      return this.eCellValue ? this.eCellValue : this.eCellWrapper ? this.eCellWrapper : this.getGui();
    }, t.prototype.setRenderDetails = function(e, r, o) {
      var n = this.cellEditor && !this.cellEditorPopupWrapper;
      if (!n) {
        this.firstRender = this.firstRender == null;
        var s = this.refreshWrapper(!1);
        if (this.refreshEditStyles(!1), e) {
          var a = o || s, l = a ? !1 : this.refreshCellRenderer(e);
          l || (this.destroyRenderer(), this.createCellRendererInstance(e));
        } else
          this.destroyRenderer(), this.insertValueWithoutCellRenderer(r);
      }
    }, t.prototype.setEditDetails = function(e, r, o) {
      e ? this.createCellEditorInstance(e, r, o) : this.destroyEditor();
    }, t.prototype.removeControls = function() {
      this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp), this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
    }, t.prototype.refreshWrapper = function(e) {
      var r = this.includeRowDrag || this.includeDndSource || this.includeSelection, o = r || this.forceWrapper, n = o && this.eCellWrapper == null;
      n && (this.eCellWrapper = Lt(
        /* html */
        '<div class="ag-cell-wrapper" role="presentation"></div>'
      ), this.getGui().appendChild(this.eCellWrapper));
      var s = !o && this.eCellWrapper != null;
      s && (go(this.eCellWrapper), this.eCellWrapper = void 0), this.addOrRemoveCssClass("ag-cell-value", !o);
      var a = !e && o, l = a && this.eCellValue == null;
      l && (this.eCellValue = Lt(
        /* html */
        '<span class="ag-cell-value" role="presentation"></span>'
      ), this.eCellWrapper.appendChild(this.eCellValue));
      var u = !a && this.eCellValue != null;
      u && (go(this.eCellValue), this.eCellValue = void 0);
      var c = n || s || l || u;
      return c && this.removeControls(), e || r && this.addControls(), c;
    }, t.prototype.addControls = function() {
      this.includeRowDrag && this.rowDraggingComp == null && (this.rowDraggingComp = this.cellCtrl.createRowDragComp(), this.rowDraggingComp && this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue)), this.includeDndSource && this.dndSourceComp == null && (this.dndSourceComp = this.cellCtrl.createDndSource(), this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue)), this.includeSelection && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox(), this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue));
    }, t.prototype.createCellEditorInstance = function(e, r, o) {
      var n = this, s = this.editorVersion, a = e.newAgStackInstance();
      if (a) {
        var l = e.params;
        a.then(function(c) {
          return n.afterCellEditorCreated(s, c, l, r, o);
        });
        var u = ue(this.cellEditor);
        u && l.cellStartedEdit && this.cellCtrl.focusCell(!0);
      }
    }, t.prototype.insertValueWithoutCellRenderer = function(e) {
      var r = this.getParentOfValue();
      pr(r);
      var o = e != null ? so(e) : null;
      o != null && (r.innerHTML = o);
    }, t.prototype.destroyEditorAndRenderer = function() {
      this.destroyRenderer(), this.destroyEditor();
    }, t.prototype.destroyRenderer = function() {
      var e = this.beans.context;
      this.cellRenderer = e.destroyBean(this.cellRenderer), go(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
    }, t.prototype.destroyEditor = function() {
      var e = this.beans.context;
      this.hideEditorPopup && this.hideEditorPopup(), this.hideEditorPopup = void 0, this.cellEditor = e.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = e.destroyBean(this.cellEditorPopupWrapper), go(this.cellEditorGui), this.cellEditorGui = null, this.editorVersion++;
    }, t.prototype.refreshCellRenderer = function(e) {
      if (this.cellRenderer == null || this.cellRenderer.refresh == null || this.cellRendererClass !== e.componentClass)
        return !1;
      var r = this.cellRenderer.refresh(e.params);
      return r === !0 || r === void 0;
    }, t.prototype.createCellRendererInstance = function(e) {
      var r = this, o = this.beans.gridOptionsService.is("suppressAnimationFrame"), n = !o, s = this.rendererVersion, a = e.componentClass, l = function() {
        var u = r.rendererVersion !== s || !r.isAlive();
        if (!u) {
          var c = e.newAgStackInstance(), p = r.afterCellRendererCreated.bind(r, s, a);
          c && c.then(p);
        }
      };
      n && this.firstRender ? this.beans.animationFrameService.createTask(l, this.rowNode.rowIndex, "createTasksP2") : l();
    }, t.prototype.getCtrl = function() {
      return this.cellCtrl;
    }, t.prototype.getRowCtrl = function() {
      return this.rowCtrl;
    }, t.prototype.getCellRenderer = function() {
      return this.cellRenderer;
    }, t.prototype.getCellEditor = function() {
      return this.cellEditor;
    }, t.prototype.afterCellRendererCreated = function(e, r, o) {
      var n = !this.isAlive() || e !== this.rendererVersion;
      if (n) {
        this.beans.context.destroyBean(o);
        return;
      }
      if (this.cellRenderer = o, this.cellRendererClass = r, this.cellRendererGui = this.cellRenderer.getGui(), this.cellRendererGui != null) {
        var s = this.getParentOfValue();
        pr(s), s.appendChild(this.cellRendererGui);
      }
    }, t.prototype.afterCellEditorCreated = function(e, r, o, n, s) {
      var a = e !== this.editorVersion;
      if (a) {
        this.beans.context.destroyBean(r);
        return;
      }
      var l = r.isCancelBeforeStart && r.isCancelBeforeStart();
      if (l) {
        this.beans.context.destroyBean(r), this.cellCtrl.stopEditing(!0);
        return;
      }
      if (!r.getGui) {
        console.warn("AG Grid: cellEditor for column " + this.column.getId() + " is missing getGui() method"), this.beans.context.destroyBean(r);
        return;
      }
      this.cellEditor = r, this.cellEditorGui = r.getGui();
      var u = n || r.isPopup !== void 0 && r.isPopup();
      u ? this.addPopupCellEditor(o, s) : this.addInCellEditor(), this.refreshEditStyles(!0, u), r.afterGuiAttached && r.afterGuiAttached();
    }, t.prototype.refreshEditStyles = function(e, r) {
      var o;
      this.addOrRemoveCssClass("ag-cell-inline-editing", e && !r), this.addOrRemoveCssClass("ag-cell-popup-editing", e && !!r), this.addOrRemoveCssClass("ag-cell-not-inline-editing", !e || !!r), (o = this.rowCtrl) === null || o === void 0 || o.setInlineEditingCss(e);
    }, t.prototype.addInCellEditor = function() {
      var e = this.getGui(), r = this.beans.gridOptionsService.getDocument();
      if (e.contains(r.activeElement) && e.focus(), this.destroyRenderer(), this.refreshWrapper(!0), this.clearParentOfValue(), this.cellEditorGui) {
        var o = this.getParentOfValue();
        o.appendChild(this.cellEditorGui);
      }
    }, t.prototype.addPopupCellEditor = function(e, r) {
      var o = this;
      this.beans.gridOptionsService.get("editType") === "fullRow" && console.warn("AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.");
      var n = this.cellEditor;
      this.cellEditorPopupWrapper = this.beans.context.createBean(new $h(e));
      var s = this.cellEditorPopupWrapper.getGui();
      this.cellEditorGui && s.appendChild(this.cellEditorGui);
      var a = this.beans.popupService, l = this.beans.gridOptionsService.is("stopEditingWhenCellsLoseFocus"), u = r ?? (n.getPopupPosition ? n.getPopupPosition() : "over"), c = this.beans.gridOptionsService.is("enableRtl"), p = {
        ePopup: s,
        column: this.column,
        rowNode: this.rowNode,
        type: "popupCellEditor",
        eventSource: this.getGui(),
        position: u,
        alignSide: c ? "right" : "left",
        keepWithinBounds: !0
      }, d = a.positionPopupByComponent.bind(a, p), h = this.beans.localeService.getLocaleTextFunc(), g = a.addPopup({
        modal: l,
        eChild: s,
        closeOnEsc: !0,
        closedCallback: function() {
          o.cellCtrl.onPopupEditorClosed();
        },
        anchorToElement: this.getGui(),
        positionCallback: d,
        ariaLabel: h("ariaLabelCellEditor", "Cell Editor")
      });
      g && (this.hideEditorPopup = g.hideFunc);
    }, t.prototype.detach = function() {
      this.eRow.removeChild(this.getGui());
    }, t.prototype.destroy = function() {
      this.cellCtrl.stopEditing(), this.destroyEditorAndRenderer(), this.removeControls(), i.prototype.destroy.call(this);
    }, t.prototype.clearParentOfValue = function() {
      var e = this.getGui(), r = this.beans.gridOptionsService.getDocument();
      e.contains(r.activeElement) && Ta() && e.focus({ preventScroll: !0 }), pr(this.getParentOfValue());
    }, t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var z_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $_ = (
  /** @class */
  function(i) {
    z_(t, i);
    function t(e, r, o) {
      var n = i.call(this) || this;
      n.cellComps = {}, n.beans = r, n.rowCtrl = e, n.setTemplate(
        /* html */
        '<div comp-id="' + n.getCompId() + '" style="' + n.getInitialStyle(o) + '"/>'
      );
      var s = n.getGui(), a = s.style, l = {
        setDomOrder: function(u) {
          return n.domOrder = u;
        },
        setCellCtrls: function(u) {
          return n.setCellCtrls(u);
        },
        showFullWidth: function(u) {
          return n.showFullWidth(u);
        },
        getFullWidthCellRenderer: function() {
          return n.getFullWidthCellRenderer();
        },
        addOrRemoveCssClass: function(u, c) {
          return n.addOrRemoveCssClass(u, c);
        },
        setUserStyles: function(u) {
          return Qu(s, u);
        },
        setTop: function(u) {
          return a.top = u;
        },
        setTransform: function(u) {
          return a.transform = u;
        },
        setRowIndex: function(u) {
          return s.setAttribute("row-index", u);
        },
        setRole: function(u) {
          return Dt(s, u);
        },
        setRowId: function(u) {
          return s.setAttribute("row-id", u);
        },
        setRowBusinessKey: function(u) {
          return s.setAttribute("row-business-key", u);
        },
        setTabIndex: function(u) {
          return s.setAttribute("tabindex", u.toString());
        }
      };
      return e.setComp(l, n.getGui(), o), n.addDestroyFunc(function() {
        e.unsetComp(o);
      }), n;
    }
    return t.prototype.getInitialStyle = function(e) {
      var r = this.rowCtrl.getInitialTransform(e), o = this.rowCtrl.getInitialRowTop(e);
      return r ? "transform: " + r : "top: " + o;
    }, t.prototype.showFullWidth = function(e) {
      var r = this, o = function(s) {
        if (r.isAlive()) {
          var a = s.getGui();
          r.getGui().appendChild(a), r.rowCtrl.setupDetailRowAutoHeight(a), r.setFullWidthRowComp(s);
        } else
          r.beans.context.destroyBean(s);
      }, n = e.newAgStackInstance();
      n && n.then(o);
    }, t.prototype.setCellCtrls = function(e) {
      var r = this, o = Object.assign({}, this.cellComps);
      e.forEach(function(s) {
        var a = s.getInstanceId(), l = r.cellComps[a];
        l == null ? r.newCellComp(s) : o[a] = null;
      });
      var n = io(o).filter(function(s) {
        return s != null;
      });
      this.destroyCells(n), this.ensureDomOrder(e);
    }, t.prototype.ensureDomOrder = function(e) {
      var r = this;
      if (this.domOrder) {
        var o = [];
        e.forEach(function(n) {
          var s = r.cellComps[n.getInstanceId()];
          s && o.push(s.getGui());
        }), Xu(this.getGui(), o);
      }
    }, t.prototype.newCellComp = function(e) {
      var r = new Kh(this.beans, e, this.rowCtrl.isPrintLayout(), this.getGui(), this.rowCtrl.isEditing());
      this.cellComps[e.getInstanceId()] = r, this.getGui().appendChild(r.getGui());
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this), this.destroyAllCells();
    }, t.prototype.destroyAllCells = function() {
      var e = io(this.cellComps).filter(function(r) {
        return r != null;
      });
      this.destroyCells(e);
    }, t.prototype.setFullWidthRowComp = function(e) {
      var r = this;
      this.fullWidthCellRenderer && console.error("AG Grid - should not be setting fullWidthRowComponent twice"), this.fullWidthCellRenderer = e, this.addDestroyFunc(function() {
        r.fullWidthCellRenderer = r.beans.context.destroyBean(r.fullWidthCellRenderer);
      });
    }, t.prototype.getFullWidthCellRenderer = function() {
      return this.fullWidthCellRenderer;
    }, t.prototype.destroyCells = function(e) {
      var r = this;
      e.forEach(function(o) {
        if (o) {
          var n = o.getCtrl().getInstanceId();
          r.cellComps[n] === o && (o.detach(), o.destroy(), r.cellComps[n] = null);
        }
      });
    }, t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var K_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), yu = function() {
  return yu = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, yu.apply(this, arguments);
}, Mn = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
};
function Y_() {
  var i = ge.elementGettingCreated.getAttribute("name"), t = hc.getRowContainerCssClasses(i), e, r = i === M.CENTER, o = i === M.TOP_CENTER || i === M.STICKY_TOP_CENTER || i === M.BOTTOM_CENTER;
  return r ? e = /* html */
  '<div class="' + t.wrapper + `" ref="eWrapper" role="presentation">
                <div class="` + t.viewport + `" ref="eViewport" role="presentation">
                    <div class="` + t.container + `" ref="eContainer"></div>
                </div>
            </div>` : o ? e = /* html */
  '<div class="' + t.viewport + `" ref="eViewport" role="presentation">
                <div class="` + t.container + `" ref="eContainer"></div>
            </div>` : e = /* html */
  '<div class="' + t.container + '" ref="eContainer"></div>', e;
}
var Yh = (
  /** @class */
  function(i) {
    K_(t, i);
    function t() {
      var e = i.call(this, Y_()) || this;
      return e.rowComps = {}, e.name = ge.elementGettingCreated.getAttribute("name"), e.type = kh(e.name), e;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = {
        setViewportHeight: function(n) {
          return e.eViewport.style.height = n;
        },
        setRowCtrls: function(n) {
          return e.setRowCtrls(n);
        },
        setDomOrder: function(n) {
          e.domOrder = n;
        },
        setContainerWidth: function(n) {
          return e.eContainer.style.width = n;
        }
      }, o = this.createManagedBean(new hc(this.name));
      o.setComp(r, this.eContainer, this.eViewport, this.eWrapper);
    }, t.prototype.preDestroy = function() {
      this.setRowCtrls([]);
    }, t.prototype.setRowCtrls = function(e) {
      var r = this, o = yu({}, this.rowComps);
      this.rowComps = {}, this.lastPlacedElement = null;
      var n = function(s) {
        var a = s.getInstanceId(), l = o[a];
        if (l)
          r.rowComps[a] = l, delete o[a], r.ensureDomOrder(l.getGui());
        else {
          var u = new $_(s, r.beans, r.type);
          r.rowComps[a] = u, r.appendRow(u.getGui());
        }
      };
      e.forEach(n), io(o).forEach(function(s) {
        r.eContainer.removeChild(s.getGui()), s.destroy();
      }), Dt(this.eContainer, e.length ? "rowgroup" : "presentation");
    }, t.prototype.appendRow = function(e) {
      this.domOrder ? Kf(this.eContainer, e, this.lastPlacedElement) : this.eContainer.appendChild(e), this.lastPlacedElement = e;
    }, t.prototype.ensureDomOrder = function(e) {
      this.domOrder && (qu(this.eContainer, e, this.lastPlacedElement), this.lastPlacedElement = e);
    }, Mn([
      v("beans")
    ], t.prototype, "beans", void 0), Mn([
      Y("eViewport")
    ], t.prototype, "eViewport", void 0), Mn([
      Y("eContainer")
    ], t.prototype, "eContainer", void 0), Mn([
      Y("eWrapper")
    ], t.prototype, "eWrapper", void 0), Mn([
      U
    ], t.prototype, "postConstruct", null), Mn([
      At
    ], t.prototype, "preDestroy", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Qp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, qh = (
  /** @class */
  function() {
    function i(t) {
      this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [], this.pinned = t;
    }
    return i.prototype.onDragEnter = function(t) {
      var e = this;
      if (this.clearColumnsList(), !this.gridOptionsService.is("functionsReadOnly")) {
        var r = t.dragItem.columns;
        r && r.forEach(function(o) {
          o.isPrimary() && (o.isAnyFunctionActive() || (o.isAllowValue() ? e.columnsToAggregate.push(o) : o.isAllowRowGroup() ? e.columnsToGroup.push(o) : o.isAllowPivot() && e.columnsToPivot.push(o)));
        });
      }
    }, i.prototype.getIconName = function() {
      var t = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
      return t > 0 ? this.pinned ? Tt.ICON_PINNED : Tt.ICON_MOVE : null;
    }, i.prototype.onDragLeave = function(t) {
      this.clearColumnsList();
    }, i.prototype.clearColumnsList = function() {
      this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
    }, i.prototype.onDragging = function(t) {
    }, i.prototype.onDragStop = function(t) {
      this.columnsToAggregate.length > 0 && this.columnModel.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop"), this.columnsToGroup.length > 0 && this.columnModel.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop"), this.columnsToPivot.length > 0 && this.columnModel.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }, Qp([
      v("columnModel")
    ], i.prototype, "columnModel", void 0), Qp([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var si = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, q_ = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, Xh = (
  /** @class */
  function() {
    function i(t, e) {
      this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.pinned = t, this.eContainer = e, this.centerContainer = !k(t);
    }
    return i.prototype.init = function() {
      var t = this;
      this.ctrlsService.whenReady(function() {
        t.gridBodyCon = t.ctrlsService.getGridBodyCtrl();
      });
    }, i.prototype.getIconName = function() {
      return this.pinned ? Tt.ICON_PINNED : Tt.ICON_MOVE;
    }, i.prototype.onDragEnter = function(t) {
      var e = t.dragItem.columns, r = t.dragSource.type === kt.ToolPanel;
      if (r)
        this.setColumnsVisible(e, !0, "uiColumnDragged");
      else {
        var o = t.dragItem.visibleState, n = (e || []).filter(function(s) {
          return o[s.getId()];
        });
        this.setColumnsVisible(n, !0, "uiColumnDragged");
      }
      this.setColumnsPinned(e, this.pinned, "uiColumnDragged"), this.onDragging(t, !0, !0);
    }, i.prototype.onDragLeave = function() {
      this.ensureIntervalCleared(), this.lastMovedInfo = null;
    }, i.prototype.setColumnsVisible = function(t, e, r) {
      if (r === void 0 && (r = "api"), t) {
        var o = t.filter(function(n) {
          return !n.getColDef().lockVisible;
        });
        this.columnModel.setColumnsVisible(o, e, r);
      }
    }, i.prototype.setColumnsPinned = function(t, e, r) {
      if (r === void 0 && (r = "api"), t) {
        var o = t.filter(function(n) {
          return !n.getColDef().lockPinned;
        });
        this.columnModel.setColumnsPinned(o, e, r);
      }
    }, i.prototype.onDragStop = function() {
      this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
    }, i.prototype.normaliseX = function(t) {
      if (this.gridOptionsService.is("enableRtl")) {
        var e = this.eContainer.clientWidth;
        t = e - t;
      }
      return this.centerContainer && (t += this.ctrlsService.getCenterRowContainerCtrl().getCenterViewportScrollLeft()), t;
    }, i.prototype.checkCenterForScrolling = function(t) {
      if (this.centerContainer) {
        var e = this.ctrlsService.getCenterRowContainerCtrl().getCenterViewportScrollLeft(), r = e + this.ctrlsService.getCenterRowContainerCtrl().getCenterWidth();
        this.gridOptionsService.is("enableRtl") ? (this.needToMoveRight = t < e + 50, this.needToMoveLeft = t > r - 50) : (this.needToMoveLeft = t < e + 50, this.needToMoveRight = t > r - 50), this.needToMoveLeft || this.needToMoveRight ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
      }
    }, i.prototype.onDragging = function(t, e, r, o) {
      var n = this, s;
      if (t === void 0 && (t = this.lastDraggingEvent), e === void 0 && (e = !1), r === void 0 && (r = !1), o === void 0 && (o = !1), o) {
        if (this.lastMovedInfo) {
          var a = this.lastMovedInfo, l = a.columns, u = a.toIndex;
          this.moveColumns(l, u, "uiColumnMoved", !0);
        }
        return;
      }
      if (this.lastDraggingEvent = t, !ue(t.hDirection)) {
        var c = this.normaliseX(t.x);
        e || this.checkCenterForScrolling(c);
        var p = this.normaliseDirection(t.hDirection), d = t.dragSource.type, h = ((s = t.dragSource.getDragItem().columns) === null || s === void 0 ? void 0 : s.filter(function(g) {
          return g.getColDef().lockPinned ? g.getPinned() == n.pinned : !0;
        })) || [];
        this.attemptMoveColumns({ dragSourceType: d, allMovingColumns: h, hDirection: p, mouseX: c, fromEnter: e, fakeEvent: r });
      }
    }, i.prototype.normaliseDirection = function(t) {
      if (this.gridOptionsService.is("enableRtl"))
        switch (t) {
          case Gr.Left:
            return Gr.Right;
          case Gr.Right:
            return Gr.Left;
          default:
            console.error("AG Grid: Unknown direction " + t);
        }
      else
        return t;
    }, i.prototype.attemptMoveColumns = function(t) {
      var e = t.dragSourceType, r = t.hDirection, o = t.mouseX, n = t.fromEnter, s = t.fakeEvent, a = r === Gr.Left, l = r === Gr.Right, u = t.allMovingColumns;
      if (e === kt.HeaderCell) {
        var c = [];
        u.forEach(function(A) {
          for (var N = null, G = A.getParent(); G != null && G.getDisplayedLeafColumns().length === 1; )
            N = G, G = G.getParent();
          N != null ? N.getLeafColumns().forEach(function(W) {
            c.includes(W) || c.push(W);
          }) : c.includes(A) || c.push(A);
        }), u = c;
      }
      var p = u.slice();
      this.columnModel.sortColumnsLikeGridColumns(p);
      var d = this.calculateValidMoves(p, l, o), h = this.calculateOldIndex(p);
      if (d.length !== 0) {
        var g = d[0], y = h !== null && !n;
        if (e == kt.HeaderCell && (y = h !== null), !(y && !s && (a && g >= h || l && g <= h))) {
          for (var S = this.columnModel.getAllDisplayedColumns(), _ = [], w = null, E = 0; E < d.length; E++) {
            var R = d[E], D = this.columnModel.getProposedColumnOrder(p, R);
            if (this.columnModel.doesOrderPassRules(D)) {
              var B = D.filter(function(A) {
                return S.includes(A);
              });
              if (w === null)
                w = B;
              else if (!le.areEqual(B, w))
                break;
              var H = this.groupFragCount(D);
              _.push({ move: R, fragCount: H });
            }
          }
          _.length !== 0 && (_.sort(function(A, N) {
            return A.fragCount - N.fragCount;
          }), this.moveColumns(u, _[0].move, "uiColumnMoved", !1));
        }
      }
    }, i.prototype.calculateOldIndex = function(t) {
      var e = this.columnModel.getAllGridColumns(), r = uf(t.map(function(l) {
        return e.indexOf(l);
      })), o = r[0], n = Ne(r), s = n - o, a = s !== r.length - 1;
      return a ? null : o;
    }, i.prototype.moveColumns = function(t, e, r, o) {
      this.columnModel.moveColumns(t, e, r, o), this.lastMovedInfo = o ? null : { columns: t, toIndex: e };
    }, i.prototype.groupFragCount = function(t) {
      function e(s) {
        for (var a = [], l = s.getOriginalParent(); l != null; )
          a.push(l), l = l.getOriginalParent();
        return a;
      }
      for (var r = 0, o = function(s) {
        var a, l = e(t[s]), u = e(t[s + 1]);
        a = q_(l.length > u.length ? [l, u] : [u, l], 2), l = a[0], u = a[1], l.forEach(function(c) {
          u.indexOf(c) === -1 && r++;
        });
      }, n = 0; n < t.length - 1; n++)
        o(n);
      return r;
    }, i.prototype.calculateValidMoves = function(t, e, r) {
      var o = this.gridOptionsService.is("suppressMovableColumns") || t.some(function(H) {
        return H.getColDef().suppressMovable;
      });
      if (o)
        return [];
      var n = this.columnModel.getDisplayedColumns(this.pinned), s = this.columnModel.getAllGridColumns(), a = n.filter(function(H) {
        return _r(t, H);
      }), l = n.filter(function(H) {
        return !_r(t, H);
      }), u = s.filter(function(H) {
        return !_r(t, H);
      }), c = 0, p = r;
      if (e) {
        var d = 0;
        a.forEach(function(H) {
          return d += H.getActualWidth();
        }), p -= d;
      }
      if (p > 0) {
        for (var h = 0; h < l.length; h++) {
          var g = l[h];
          if (p -= g.getActualWidth(), p < 0)
            break;
          c++;
        }
        e && c++;
      }
      var y;
      if (c > 0) {
        var S = l[c - 1];
        y = u.indexOf(S) + 1;
      } else
        y = u.indexOf(l[0]), y === -1 && (y = 0);
      var _ = [y], w = function(H, A) {
        return H - A;
      };
      if (e) {
        for (var E = y + 1, R = s.length - 1; E <= R; )
          _.push(E), E++;
        _.sort(w);
      } else {
        for (var E = y, R = s.length - 1, D = s[E]; E <= R && this.isColumnHidden(n, D); )
          E++, _.push(E), D = s[E];
        E = y - 1;
        for (var B = 0; E >= B; )
          _.push(E), E--;
        _.sort(w).reverse();
      }
      return _;
    }, i.prototype.isColumnHidden = function(t, e) {
      return t.indexOf(e) < 0;
    }, i.prototype.ensureIntervalStarted = function() {
      this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100), this.needToMoveLeft ? this.dragAndDropService.setGhostIcon(Tt.ICON_LEFT, !0) : this.dragAndDropService.setGhostIcon(Tt.ICON_RIGHT, !0));
    }, i.prototype.ensureIntervalCleared = function() {
      this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.dragAndDropService.setGhostIcon(Tt.ICON_MOVE));
    }, i.prototype.moveInterval = function() {
      var t;
      this.intervalCount++, t = 10 + this.intervalCount * 5, t > 100 && (t = 100);
      var e = null, r = this.gridBodyCon.getScrollFeature();
      if (this.needToMoveLeft ? e = r.scrollHorizontally(-t) : this.needToMoveRight && (e = r.scrollHorizontally(t)), e !== 0)
        this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
      else {
        this.failedMoveAttempts++;
        var o = this.lastDraggingEvent.dragItem.columns, n = o.filter(function(a) {
          return !a.getColDef().lockPinned;
        });
        if (n.length > 0 && (this.dragAndDropService.setGhostIcon(Tt.ICON_PINNED), this.failedMoveAttempts > 7)) {
          var s = this.needToMoveLeft ? "left" : "right";
          this.setColumnsPinned(n, s, "uiColumnDragged"), this.dragAndDropService.nudge();
        }
      }
    }, si([
      v("columnModel")
    ], i.prototype, "columnModel", void 0), si([
      v("dragAndDropService")
    ], i.prototype, "dragAndDropService", void 0), si([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), si([
      v("ctrlsService")
    ], i.prototype, "ctrlsService", void 0), si([
      U
    ], i.prototype, "init", null), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var X_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ai = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Qh = (
  /** @class */
  function(i) {
    X_(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.pinned = e, o.eContainer = r, o;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        switch (e.pinned) {
          case "left":
            e.eSecondaryContainers = [
              [r.gridBodyCtrl.getBodyViewportElement(), r.leftRowContainerCtrl.getContainerElement()],
              [r.bottomLeftRowContainerCtrl.getContainerElement()],
              [r.topLeftRowContainerCtrl.getContainerElement()]
            ];
            break;
          case "right":
            e.eSecondaryContainers = [
              [r.gridBodyCtrl.getBodyViewportElement(), r.rightRowContainerCtrl.getContainerElement()],
              [r.bottomRightRowContainerCtrl.getContainerElement()],
              [r.topRightRowContainerCtrl.getContainerElement()]
            ];
            break;
          default:
            e.eSecondaryContainers = [
              [r.gridBodyCtrl.getBodyViewportElement(), r.centerRowContainerCtrl.getViewportElement()],
              [r.bottomCenterRowContainerCtrl.getViewportElement()],
              [r.topCenterRowContainerCtrl.getViewportElement()]
            ];
            break;
        }
      });
    }, t.prototype.isInterestedIn = function(e) {
      return e === kt.HeaderCell || e === kt.ToolPanel && this.gridOptionsService.is("allowDragFromColumnsToolPanel");
    }, t.prototype.getSecondaryContainers = function() {
      return this.eSecondaryContainers;
    }, t.prototype.getContainer = function() {
      return this.eContainer;
    }, t.prototype.init = function() {
      this.moveColumnFeature = this.createManagedBean(new Xh(this.pinned, this.eContainer)), this.bodyDropPivotTarget = this.createManagedBean(new qh(this.pinned)), this.dragAndDropService.addDropTarget(this);
    }, t.prototype.getIconName = function() {
      return this.currentDropListener.getIconName();
    }, t.prototype.isDropColumnInPivotMode = function(e) {
      return this.columnModel.isPivotMode() && e.dragSource.type === kt.ToolPanel;
    }, t.prototype.onDragEnter = function(e) {
      this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
    }, t.prototype.onDragLeave = function(e) {
      this.currentDropListener.onDragLeave(e);
    }, t.prototype.onDragging = function(e) {
      this.currentDropListener.onDragging(e);
    }, t.prototype.onDragStop = function(e) {
      this.currentDropListener.onDragStop(e);
    }, ai([
      v("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), ai([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), ai([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), ai([
      U
    ], t.prototype, "postConstruct", null), ai([
      U
    ], t.prototype, "init", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Q_ = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, J_ = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(Q_(arguments[t]));
  return i;
}, vc = (
  /** @class */
  function() {
    function i() {
    }
    return i.getHeaderClassesFromColDef = function(t, e, r, o) {
      return ue(t) ? [] : this.getColumnClassesFromCollDef(t.headerClass, t, e, r, o);
    }, i.getToolPanelClassesFromColDef = function(t, e, r, o) {
      return ue(t) ? [] : this.getColumnClassesFromCollDef(t.toolPanelClass, t, e, r, o);
    }, i.getClassParams = function(t, e, r, o) {
      return {
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: t,
        column: r,
        columnGroup: o,
        api: e.api,
        columnApi: e.columnApi,
        context: e.context
      };
    }, i.getColumnClassesFromCollDef = function(t, e, r, o, n) {
      if (ue(t))
        return [];
      var s;
      if (typeof t == "function") {
        var a = this.getClassParams(e, r, o, n);
        s = t(a);
      } else
        s = t;
      return typeof s == "string" ? [s] : Array.isArray(s) ? J_(s) : [];
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Z_ = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, eE = (
  /** @class */
  function(i) {
    Z_(t, i);
    function t(e) {
      var r = i.call(this, t.TEMPLATE, e) || this;
      return r.headerCompVersion = 0, r.column = e.getColumnGroupChild(), r.pinned = e.getPinned(), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), o = function(a, l, u) {
        var c = u || r;
        l != null && l != "" ? c.setAttribute(a, l) : c.removeAttribute(a);
      }, n = {
        setWidth: function(a) {
          return r.style.width = a;
        },
        addOrRemoveCssClass: function(a, l) {
          return e.addOrRemoveCssClass(a, l);
        },
        setColId: function(a) {
          return o("col-id", a);
        },
        setTitle: function(a) {
          return o("title", a);
        },
        setAriaDescription: function(a) {
          return Pf(r, a);
        },
        setAriaSort: function(a) {
          return a ? Nf(r, a) : Gf(r);
        },
        setUserCompDetails: function(a) {
          return e.setUserCompDetails(a);
        },
        getUserCompInstance: function() {
          return e.headerComp;
        }
      };
      this.ctrl.setComp(n, this.getGui(), this.eResize, this.eHeaderCompWrapper);
      var s = this.ctrl.getSelectAllGui();
      this.eResize.insertAdjacentElement("afterend", s);
    }, t.prototype.destroyHeaderComp = function() {
      this.headerComp && (this.eHeaderCompWrapper.removeChild(this.headerCompGui), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
    }, t.prototype.setUserCompDetails = function(e) {
      var r = this;
      this.headerCompVersion++;
      var o = this.headerCompVersion;
      e.newAgStackInstance().then(function(n) {
        return r.afterCompCreated(o, n);
      });
    }, t.prototype.afterCompCreated = function(e, r) {
      if (e != this.headerCompVersion || !this.isAlive()) {
        this.destroyBean(r);
        return;
      }
      this.destroyHeaderComp(), this.headerComp = r, this.headerCompGui = r.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui());
    }, t.TEMPLATE = `<div class="ag-header-cell" role="columnheader" tabindex="-1">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
            <div ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
        </div>`, fs([
      Y("eResize")
    ], t.prototype, "eResize", void 0), fs([
      Y("eHeaderCompWrapper")
    ], t.prototype, "eHeaderCompWrapper", void 0), fs([
      U
    ], t.prototype, "postConstruct", null), fs([
      At
    ], t.prototype, "destroyHeaderComp", null), t;
  }(uc)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var tE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), El = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, rE = (
  /** @class */
  function(i) {
    tE(t, i);
    function t(e) {
      return i.call(this, t.TEMPLATE, e) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), o = function(s, a) {
        return a != null ? r.setAttribute(s, a) : r.removeAttribute(s);
      }, n = {
        addOrRemoveCssClass: function(s, a) {
          return e.addOrRemoveCssClass(s, a);
        },
        setResizableDisplayed: function(s) {
          return be(e.eResize, s);
        },
        setWidth: function(s) {
          return r.style.width = s;
        },
        setColId: function(s) {
          return r.setAttribute("col-id", s);
        },
        setAriaExpanded: function(s) {
          return o("aria-expanded", s);
        },
        setTitle: function(s) {
          return o("title", s);
        },
        setUserCompDetails: function(s) {
          return e.setUserCompDetails(s);
        }
      };
      this.ctrl.setComp(n, r, this.eResize);
    }, t.prototype.setUserCompDetails = function(e) {
      var r = this;
      e.newAgStackInstance().then(function(o) {
        return r.afterHeaderCompCreated(o);
      });
    }, t.prototype.afterHeaderCompCreated = function(e) {
      var r = this, o = function() {
        return r.destroyBean(e);
      };
      if (!this.isAlive()) {
        o();
        return;
      }
      this.getGui().appendChild(e.getGui()), this.addDestroyFunc(o), this.ctrl.setDragSource(e.getGui());
    }, t.TEMPLATE = `<div class="ag-header-group-cell" role="columnheader" tabindex="-1">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
        </div>`, El([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), El([
      Y("eResize")
    ], t.prototype, "eResize", void 0), El([
      U
    ], t.prototype, "postConstruct", null), t;
  }(uc)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var oE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Jp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Pt;
(function(i) {
  i.COLUMN_GROUP = "group", i.COLUMN = "column", i.FLOATING_FILTER = "filter";
})(Pt || (Pt = {}));
var Jh = (
  /** @class */
  function(i) {
    oE(t, i);
    function t(e) {
      var r = i.call(this) || this;
      r.headerComps = {};
      var o = e.getType() == Pt.COLUMN_GROUP ? "ag-header-row-column-group" : e.getType() == Pt.FLOATING_FILTER ? "ag-header-row-column-filter" : "ag-header-row-column";
      return r.setTemplate(
        /* html */
        '<div class="ag-header-row ' + o + '" role="row"></div>'
      ), r.ctrl = e, r;
    }
    return t.prototype.init = function() {
      var e = this, r = {
        setTransform: function(o) {
          return e.getGui().style.transform = o;
        },
        setHeight: function(o) {
          return e.getGui().style.height = o;
        },
        setTop: function(o) {
          return e.getGui().style.top = o;
        },
        setHeaderCtrls: function(o) {
          return e.setHeaderCtrls(o);
        },
        setWidth: function(o) {
          return e.getGui().style.width = o;
        },
        setAriaRowIndex: function(o) {
          return Bu(e.getGui(), o);
        }
      };
      this.ctrl.setComp(r);
    }, t.prototype.destroyHeaderCtrls = function() {
      this.setHeaderCtrls([]);
    }, t.prototype.setHeaderCtrls = function(e) {
      var r = this;
      if (this.isAlive()) {
        var o = this.headerComps;
        this.headerComps = {}, e.forEach(function(u) {
          var c = u.getInstanceId(), p = o[c];
          delete o[c], p == null && (p = r.createHeaderComp(u), r.getGui().appendChild(p.getGui())), r.headerComps[c] = p;
        }), Ke(o, function(u, c) {
          r.getGui().removeChild(c.getGui()), r.destroyBean(c);
        });
        var n = this.gridOptionsService.is("ensureDomOrder"), s = this.gridOptionsService.isDomLayout("print");
        if (n || s) {
          var a = io(this.headerComps);
          a.sort(function(u, c) {
            var p = u.getCtrl().getColumnGroupChild().getLeft(), d = c.getCtrl().getColumnGroupChild().getLeft();
            return p - d;
          });
          var l = a.map(function(u) {
            return u.getGui();
          });
          Xu(this.getGui(), l);
        }
      }
    }, t.prototype.createHeaderComp = function(e) {
      var r;
      switch (this.ctrl.getType()) {
        case Pt.COLUMN_GROUP:
          r = new rE(e);
          break;
        case Pt.FLOATING_FILTER:
          r = new Lh(e);
          break;
        default:
          r = new eE(e);
          break;
      }
      return this.createBean(r), r.setParentComponent(this), r;
    }, Jp([
      U
    ], t.prototype, "init", null), Jp([
      At
    ], t.prototype, "destroyHeaderCtrls", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var nE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Rl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, iE = 0, Ui = (
  /** @class */
  function(i) {
    nE(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.lastFocusEvent = null, o.columnGroupChild = e, o.parentRowCtrl = r, o.instanceId = e.getUniqueId() + "-" + iE++, o;
    }
    return t.prototype.shouldStopEventPropagation = function(e) {
      var r = this.focusService.getFocusedHeader(), o = r.headerRowIndex, n = r.column;
      return eh(this.gridOptionsService, e, o, n);
    }, t.prototype.getWrapperHasFocus = function() {
      var e = this.gridOptionsService.getDocument(), r = e.activeElement;
      return r === this.eGui;
    }, t.prototype.setGui = function(e) {
      this.eGui = e, this.addDomData();
    }, t.prototype.handleKeyDown = function(e) {
      var r = this.getWrapperHasFocus();
      switch (e.key) {
        case L.PAGE_DOWN:
        case L.PAGE_UP:
        case L.PAGE_HOME:
        case L.PAGE_END:
          r && e.preventDefault();
      }
    }, t.prototype.addDomData = function() {
      var e = this, r = t.DOM_DATA_KEY_HEADER_CTRL;
      this.gridOptionsService.setDomData(this.eGui, r, this), this.addDestroyFunc(function() {
        return e.gridOptionsService.setDomData(e.eGui, r, null);
      });
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.focus = function(e) {
      return this.eGui ? (this.lastFocusEvent = e || null, this.eGui.focus(), !0) : !1;
    }, t.prototype.getRowIndex = function() {
      return this.parentRowCtrl.getRowIndex();
    }, t.prototype.getParentRowCtrl = function() {
      return this.parentRowCtrl;
    }, t.prototype.getPinned = function() {
      return this.parentRowCtrl.getPinned();
    }, t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.getColumnGroupChild = function() {
      return this.columnGroupChild;
    }, t.DOM_DATA_KEY_HEADER_CTRL = "headerCtrl", Rl([
      v("focusService")
    ], t.prototype, "focusService", void 0), Rl([
      v("beans")
    ], t.prototype, "beans", void 0), Rl([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var sE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), aE = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, La = (
  /** @class */
  function(i) {
    sE(t, i);
    function t(e, r, o, n) {
      var s = i.call(this) || this;
      return s.columnOrGroup = e, s.eCell = r, s.ariaEl = s.eCell.querySelector("[role=columnheader]") || s.eCell, s.colsSpanning = n, s.beans = o, s;
    }
    return t.prototype.setColsSpanning = function(e) {
      this.colsSpanning = e, this.onLeftChanged();
    }, t.prototype.getColumnOrGroup = function() {
      return this.beans.gridOptionsService.is("enableRtl") && this.colsSpanning ? Ne(this.colsSpanning) : this.columnOrGroup;
    }, t.prototype.postConstruct = function() {
      this.addManagedListener(this.columnOrGroup, $e.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this)), this.setLeftFirstTime(), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this)), this.addManagedPropertyListener("domLayout", this.onLeftChanged.bind(this));
    }, t.prototype.setLeftFirstTime = function() {
      var e = this.beans.gridOptionsService.is("suppressColumnMoveAnimation"), r = k(this.columnOrGroup.getOldLeft()), o = this.beans.columnAnimationService.isActive() && r && !e;
      o ? this.animateInLeft() : this.onLeftChanged();
    }, t.prototype.animateInLeft = function() {
      var e = this, r = this.getColumnOrGroup(), o = r.getLeft(), n = r.getOldLeft(), s = this.modifyLeftForPrintLayout(r, n), a = this.modifyLeftForPrintLayout(r, o);
      this.setLeft(s), this.actualLeft = a, this.beans.columnAnimationService.executeNextVMTurn(function() {
        e.actualLeft === a && e.setLeft(a);
      });
    }, t.prototype.onLeftChanged = function() {
      var e = this.getColumnOrGroup(), r = e.getLeft();
      this.actualLeft = this.modifyLeftForPrintLayout(e, r), this.setLeft(this.actualLeft);
    }, t.prototype.modifyLeftForPrintLayout = function(e, r) {
      var o = this.beans.gridOptionsService.isDomLayout("print");
      if (!o || e.getPinned() === "left")
        return r;
      var n = this.beans.columnModel.getDisplayedColumnsLeftWidth();
      if (e.getPinned() === "right") {
        var s = this.beans.columnModel.getBodyContainerWidth();
        return n + s + r;
      }
      return n + r;
    }, t.prototype.setLeft = function(e) {
      k(e) && (this.eCell.style.left = e + "px");
      var r;
      if (this.columnOrGroup instanceof $e)
        r = this.columnOrGroup;
      else {
        var o = this.columnOrGroup, n = o.getLeafColumns();
        if (!n.length)
          return;
        n.length > 1 && Lf(this.ariaEl, n.length), r = n[0];
      }
      var s = this.beans.columnModel.getAriaColumnIndex(r);
      ku(this.ariaEl, s);
    }, aE([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var lE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Zp = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, gc = (
  /** @class */
  function(i) {
    lE(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.columns = e, o.element = r, o;
    }
    return t.prototype.postConstruct = function() {
      this.gridOptionsService.is("columnHoverHighlight") && this.addMouseHoverListeners();
    }, t.prototype.addMouseHoverListeners = function() {
      this.addManagedListener(this.element, "mouseout", this.onMouseOut.bind(this)), this.addManagedListener(this.element, "mouseover", this.onMouseOver.bind(this));
    }, t.prototype.onMouseOut = function() {
      this.columnHoverService.clearMouseOver();
    }, t.prototype.onMouseOver = function() {
      this.columnHoverService.setMouseOver(this.columns);
    }, Zp([
      v("columnHoverService")
    ], t.prototype, "columnHoverService", void 0), Zp([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var uE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ol = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Zh = (
  /** @class */
  function(i) {
    uE(t, i);
    function t(e, r) {
      var o = i.call(this, e, r) || this;
      return o.column = e, o;
    }
    return t.prototype.setComp = function(e, r, o, n) {
      i.prototype.setGui.call(this, r), this.comp = e, this.eButtonShowMainFilter = o, this.eFloatingFilterBody = n;
      var s = this.column.getColDef(), a = !!s.filter || !!s.filterFramework, l = !!s.floatingFilter;
      this.active = a && l, this.setupWidth(), this.setupLeft(), this.setupHover(), this.setupFocus(), this.setupUserComp(), this.setupSyncWithFilter(), this.setupUi(), this.addManagedListener(this.eButtonShowMainFilter, "click", this.showParentFilter.bind(this)), this.active && this.addManagedListener(this.column, $e.EVENT_FILTER_CHANGED, this.updateFilterButton.bind(this));
    }, t.prototype.setupUi = function() {
      if (this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active), !!this.active) {
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);
        var e = ut("filter", this.gridOptionsService, this.column);
        e && this.eButtonShowMainFilter.appendChild(e);
      }
    }, t.prototype.setupFocus = function() {
      this.createManagedBean(new wo(this.eGui, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      }));
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this.gridOptionsService.getDocument(), o = r.activeElement, n = o === this.eGui;
      if (!n) {
        var s = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);
        if (s) {
          this.beans.headerNavigationService.scrollToColumn(this.column), e.preventDefault(), s.focus();
          return;
        }
        var a = this.findNextColumnWithFloatingFilter(e.shiftKey);
        a && this.focusService.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: this.getParentRowCtrl().getRowIndex(),
            column: a
          },
          event: e
        }) && e.preventDefault();
      }
    }, t.prototype.findNextColumnWithFloatingFilter = function(e) {
      var r = this.beans.columnModel, o = this.column;
      do
        if (o = e ? r.getDisplayedColBefore(o) : r.getDisplayedColAfter(o), !o)
          break;
      while (!o.getColDef().filter || !o.getColDef().floatingFilter);
      return o;
    }, t.prototype.handleKeyDown = function(e) {
      i.prototype.handleKeyDown.call(this, e);
      var r = this.getWrapperHasFocus();
      switch (e.key) {
        case L.UP:
        case L.DOWN:
          r || e.preventDefault();
        case L.LEFT:
        case L.RIGHT:
          if (r)
            return;
          e.stopPropagation();
        case L.ENTER:
          r && this.focusService.focusInto(this.eGui) && e.preventDefault();
          break;
        case L.ESCAPE:
          r || this.eGui.focus();
      }
    }, t.prototype.onFocusIn = function(e) {
      var r = this.eGui.contains(e.relatedTarget);
      if (!r) {
        var o = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter"), n = !!e.relatedTarget && un(e.relatedTarget, "ag-floating-filter");
        if (o && n && e.target === this.eGui) {
          var s = this.lastFocusEvent, a = !!(s && s.key === L.TAB);
          if (s && a) {
            var l = s.shiftKey;
            this.focusService.focusInto(this.eGui, l);
          }
        }
        var u = this.getRowIndex();
        this.beans.focusService.setFocusedHeader(u, this.column);
      }
    }, t.prototype.setupHover = function() {
      var e = this;
      this.createManagedBean(new gc([this.column], this.eGui));
      var r = function() {
        if (e.gridOptionsService.is("columnHoverHighlight")) {
          var o = e.columnHoverService.isHovered(e.column);
          e.comp.addOrRemoveCssClass("ag-column-hover", o);
        }
      };
      this.addManagedListener(this.eventService, m.EVENT_COLUMN_HOVER_CHANGED, r), r();
    }, t.prototype.setupLeft = function() {
      var e = new La(this.column, this.eGui, this.beans);
      this.createManagedBean(e);
    }, t.prototype.setupUserComp = function() {
      var e = this;
      if (this.active) {
        var r = this.column.getColDef();
        this.suppressFilterButton = r.floatingFilterComponentParams ? !!r.floatingFilterComponentParams.suppressFilterButton : !1;
        var o = this.filterManager.getFloatingFilterCompDetails(this.column, function() {
          return e.showParentFilter();
        });
        o && this.comp.setCompDetails(o);
      }
    }, t.prototype.showParentFilter = function() {
      var e = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
      this.menuFactory.showMenuAfterButtonClick(this.column, e, "floatingFilter", "filterMenuTab", ["filterMenuTab"]);
    }, t.prototype.setupSyncWithFilter = function() {
      var e = this;
      if (this.active) {
        var r = function(o) {
          var n = e.comp.getFloatingFilterComp();
          if (n) {
            var s = e.filterManager.getCurrentFloatingFilterParentModel(e.column);
            n.then(function(a) {
              a && a.onParentModelChanged(s, o);
            });
          }
        };
        this.addManagedListener(this.column, $e.EVENT_FILTER_CHANGED, r), this.filterManager.isFilterActive(this.column) && r(null);
      }
    }, t.prototype.setupWidth = function() {
      var e = this, r = function() {
        var o = e.column.getActualWidth() + "px";
        e.comp.setWidth(o);
      };
      this.addManagedListener(this.column, $e.EVENT_WIDTH_CHANGED, r), r();
    }, t.prototype.updateFilterButton = function() {
      !this.suppressFilterButton && this.comp && this.comp.setButtonWrapperDisplayed(this.filterManager.isFilterAllowed(this.column));
    }, Ol([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), Ol([
      v("columnHoverService")
    ], t.prototype, "columnHoverService", void 0), Ol([
      v("menuFactory")
    ], t.prototype, "menuFactory", void 0), t;
  }(Ui)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var cE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), bl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, pE = (
  /** @class */
  function(i) {
    cE(t, i);
    function t(e, r, o, n, s) {
      var a = i.call(this) || this;
      return a.pinned = e, a.column = r, a.eResize = o, a.comp = n, a.ctrl = s, a;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.column.getColDef(), o = [], n, s, a = function() {
        if (be(e.eResize, n), !!n) {
          var c = e.horizontalResizeService.addResizeBar({
            eResizeBar: e.eResize,
            onResizeStart: e.onResizeStart.bind(e),
            onResizing: e.onResizing.bind(e, !1),
            onResizeEnd: e.onResizing.bind(e, !0)
          });
          if (o.push(c), s) {
            var p = e.gridOptionsService.is("skipHeaderOnAutoSize"), d = function() {
              e.columnModel.autoSizeColumn(e.column, p, "uiColumnResized");
            };
            e.eResize.addEventListener("dblclick", d);
            var h = new sr(e.eResize);
            h.addEventListener(sr.EVENT_DOUBLE_TAP, d), e.addDestroyFunc(function() {
              e.eResize.removeEventListener("dblclick", d), h.removeEventListener(sr.EVENT_DOUBLE_TAP, d), h.destroy();
            });
          }
        }
      }, l = function() {
        o.forEach(function(c) {
          return c();
        }), o.length = 0;
      }, u = function() {
        var c = e.column.isResizable(), p = !e.gridOptionsService.is("suppressAutoSize") && !r.suppressAutoSize, d = c !== n || p !== s;
        d && (n = c, s = p, l(), a());
      };
      u(), this.addDestroyFunc(l), this.ctrl.addRefreshFunction(u);
    }, t.prototype.onResizing = function(e, r) {
      var o = this.normaliseResizeAmount(r), n = [{ key: this.column, newWidth: this.resizeStartWidth + o }];
      this.columnModel.setColumnWidths(n, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.comp.addOrRemoveCssClass("ag-column-resizing", !1);
    }, t.prototype.onResizeStart = function(e) {
      this.resizeStartWidth = this.column.getActualWidth(), this.resizeWithShiftKey = e, this.comp.addOrRemoveCssClass("ag-column-resizing", !0);
    }, t.prototype.normaliseResizeAmount = function(e) {
      var r = e, o = this.pinned !== "left", n = this.pinned === "right";
      return this.gridOptionsService.is("enableRtl") ? o && (r *= -1) : n && (r *= -1), r;
    }, bl([
      v("horizontalResizeService")
    ], t.prototype, "horizontalResizeService", void 0), bl([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), bl([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var dE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), hs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, fE = (
  /** @class */
  function(i) {
    dE(t, i);
    function t(e) {
      var r = i.call(this) || this;
      r.cbSelectAllVisible = !1, r.processingEventFromCheckbox = !1, r.column = e;
      var o = e.getColDef();
      return r.filteredOnly = !!(o != null && o.headerCheckboxSelectionFilteredOnly), r.currentPageOnly = !!(o != null && o.headerCheckboxSelectionCurrentPageOnly), r;
    }
    return t.prototype.onSpaceKeyPressed = function(e) {
      var r = this.cbSelectAll, o = this.gridOptionsService.getDocument();
      r.isDisplayed() && !r.getGui().contains(o.activeElement) && (e.preventDefault(), r.setValue(!r.getValue()));
    }, t.prototype.getCheckboxGui = function() {
      return this.cbSelectAll.getGui();
    }, t.prototype.setComp = function(e) {
      this.headerCellCtrl = e, this.cbSelectAll = this.createManagedBean(new Yn()), this.cbSelectAll.addCssClass("ag-header-select-all"), Dt(this.cbSelectAll.getGui(), "presentation"), this.showOrHideSelectAll(), this.addManagedListener(this.eventService, m.EVENT_NEW_COLUMNS_LOADED, this.showOrHideSelectAll.bind(this)), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelectAll.bind(this)), this.addManagedListener(this.eventService, m.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_PAGINATION_CHANGED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this)), this.addManagedListener(this.cbSelectAll, Yn.EVENT_CHANGED, this.onCbSelectAll.bind(this)), ba(this.cbSelectAll.getGui(), !0), this.cbSelectAll.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
    }, t.prototype.showOrHideSelectAll = function() {
      this.cbSelectAllVisible = this.isCheckboxSelection(), this.cbSelectAll.setDisplayed(this.cbSelectAllVisible, { skipAriaHidden: !0 }), this.cbSelectAllVisible && (this.checkRightRowModelType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel();
    }, t.prototype.onModelChanged = function() {
      this.cbSelectAllVisible && this.updateStateOfCheckbox();
    }, t.prototype.onSelectionChanged = function() {
      this.cbSelectAllVisible && this.updateStateOfCheckbox();
    }, t.prototype.updateStateOfCheckbox = function() {
      if (!this.processingEventFromCheckbox) {
        this.processingEventFromCheckbox = !0;
        var e = this.selectionService.getSelectAllState(this.filteredOnly, this.currentPageOnly);
        this.cbSelectAll.setValue(e), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
      }
    }, t.prototype.refreshSelectAllLabel = function() {
      if (!this.cbSelectAllVisible)
        this.headerCellCtrl.setAriaDescriptionProperty("selectAll", null), this.cbSelectAll.setInputAriaLabel(null);
      else {
        var e = this.localeService.getLocaleTextFunc(), r = this.cbSelectAll.getValue(), o = r ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked"), n = e("ariaRowSelectAll", "Press Space to toggle all rows selection");
        this.headerCellCtrl.setAriaDescriptionProperty("selectAll", n + " (" + o + ")"), this.cbSelectAll.setInputAriaLabel(n + " (" + o + ")");
      }
      this.headerCellCtrl.refreshAriaDescription();
    }, t.prototype.checkRightRowModelType = function(e) {
      var r = this.rowModel.getType(), o = r === "clientSide" || r === "serverSide";
      return o ? !0 : (console.warn("AG Grid: " + e + " is only available if using 'clientSide' or 'serverSide' rowModelType, you are using " + r + "."), !1);
    }, t.prototype.onCbSelectAll = function() {
      if (!this.processingEventFromCheckbox && this.cbSelectAllVisible) {
        var e = this.cbSelectAll.getValue(), r = "uiSelectAll";
        this.currentPageOnly ? r = "uiSelectAllCurrentPage" : this.filteredOnly && (r = "uiSelectAllFiltered");
        var o = {
          source: r,
          justFiltered: this.filteredOnly,
          justCurrentPage: this.currentPageOnly
        };
        e ? this.selectionService.selectAllRowNodes(o) : this.selectionService.deselectAllRowNodes(o);
      }
    }, t.prototype.isCheckboxSelection = function() {
      var e = this.column.getColDef().headerCheckboxSelection;
      if (typeof e == "function") {
        var r = e, o = {
          column: this.column,
          colDef: this.column.getColDef(),
          columnApi: this.columnApi,
          api: this.gridApi,
          context: this.gridOptionsService.context
        };
        e = r(o);
      }
      return e ? this.checkRightRowModelType("headerCheckboxSelection") : !1;
    }, hs([
      v("gridApi")
    ], t.prototype, "gridApi", void 0), hs([
      v("columnApi")
    ], t.prototype, "columnApi", void 0), hs([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), hs([
      v("selectionService")
    ], t.prototype, "selectionService", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var hE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fo = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, ev = (
  /** @class */
  function(i) {
    hE(t, i);
    function t(e, r) {
      var o = i.call(this, e, r) || this;
      return o.refreshFunctions = [], o.userHeaderClasses = /* @__PURE__ */ new Set(), o.ariaDescriptionProperties = /* @__PURE__ */ new Map(), o.column = e, o;
    }
    return t.prototype.setComp = function(e, r, o, n) {
      var s = this;
      i.prototype.setGui.call(this, r), this.comp = e, this.updateState(), this.setupWidth(), this.setupMovingCss(), this.setupMenuClass(), this.setupSortableClass(), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight(n), this.addColumnHoverListener(), this.setupFilterCss(), this.setupColId(), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(), this.setupSelectAll(), this.setupUserComp(), this.refreshAria(), this.createManagedBean(new pE(this.getPinned(), this.column, o, e, this)), this.createManagedBean(new gc([this.column], r)), this.createManagedBean(new La(this.column, r, this.beans)), this.createManagedBean(new wo(r, {
        shouldStopEventPropagation: function(a) {
          return s.shouldStopEventPropagation(a);
        },
        onTabKeyDown: function() {
          return null;
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })), this.addManagedListener(this.column, $e.EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }, t.prototype.setupUserComp = function() {
      var e = this.lookupUserCompDetails();
      this.setCompDetails(e);
    }, t.prototype.setCompDetails = function(e) {
      this.userCompDetails = e, this.comp.setUserCompDetails(e);
    }, t.prototype.lookupUserCompDetails = function() {
      var e = this.createParams(), r = this.column.getColDef();
      return this.userComponentFactory.getHeaderCompDetails(r, e);
    }, t.prototype.createParams = function() {
      var e = this, r = this.column.getColDef(), o = {
        column: this.column,
        displayName: this.displayName,
        enableSorting: r.sortable,
        enableMenu: this.menuEnabled,
        showColumnMenu: function(n) {
          e.gridApi.showColumnMenuAfterButtonClick(e.column, n);
        },
        progressSort: function(n) {
          e.sortController.progressSort(e.column, !!n, "uiColumnSorted");
        },
        setSort: function(n, s) {
          e.sortController.setSortForColumn(e.column, n, !!s, "uiColumnSorted");
        },
        api: this.gridApi,
        columnApi: this.columnApi,
        context: this.gridOptionsService.context,
        eGridHeader: this.getGui()
      };
      return o;
    }, t.prototype.setupSelectAll = function() {
      this.selectAllFeature = this.createManagedBean(new fE(this.column)), this.selectAllFeature.setComp(this);
    }, t.prototype.getSelectAllGui = function() {
      return this.selectAllFeature.getCheckboxGui();
    }, t.prototype.handleKeyDown = function(e) {
      i.prototype.handleKeyDown.call(this, e), e.key === L.SPACE && this.selectAllFeature.onSpaceKeyPressed(e), e.key === L.ENTER && this.onEnterKeyPressed(e);
    }, t.prototype.onEnterKeyPressed = function(e) {
      var r = this.comp.getUserCompInstance();
      if (r) {
        if (e.ctrlKey || e.metaKey)
          this.menuEnabled && r.showMenu && (e.preventDefault(), r.showMenu());
        else if (this.sortable) {
          var o = e.shiftKey;
          this.sortController.progressSort(this.column, o, "uiColumnSorted");
        }
      }
    }, t.prototype.isMenuEnabled = function() {
      return this.menuEnabled;
    }, t.prototype.onFocusIn = function(e) {
      if (!this.getGui().contains(e.relatedTarget)) {
        var r = this.getRowIndex();
        this.focusService.setFocusedHeader(r, this.column);
      }
      this.setActiveHeader(!0);
    }, t.prototype.onFocusOut = function(e) {
      this.getGui().contains(e.relatedTarget) || this.setActiveHeader(!1);
    }, t.prototype.setupTooltip = function() {
      var e = this, r = {
        getColumn: function() {
          return e.column;
        },
        getColDef: function() {
          return e.column.getColDef();
        },
        getGui: function() {
          return e.eGui;
        },
        getLocation: function() {
          return "header";
        },
        getTooltipValue: function() {
          var n = e.column.getColDef().headerTooltip;
          return n;
        }
      }, o = this.createManagedBean(new pc(r, this.beans));
      o.setComp(this.comp), this.refreshFunctions.push(function() {
        return o.refreshToolTip();
      });
    }, t.prototype.setupClassesFromColDef = function() {
      var e = this, r = function() {
        var o = e.column.getColDef(), n = vc.getHeaderClassesFromColDef(o, e.gridOptionsService, e.column, null), s = e.userHeaderClasses;
        e.userHeaderClasses = new Set(n), n.forEach(function(a) {
          s.has(a) ? s.delete(a) : e.comp.addOrRemoveCssClass(a, !0);
        }), s.forEach(function(a) {
          return e.comp.addOrRemoveCssClass(a, !1);
        });
      };
      this.refreshFunctions.push(r), r();
    }, t.prototype.setDragSource = function(e) {
      var r = this;
      if (this.dragSourceElement = e, this.removeDragSource(), !!e && this.draggable) {
        var o = !this.gridOptionsService.is("suppressDragLeaveHidesColumns");
        this.moveDragSource = {
          type: kt.HeaderCell,
          eElement: e,
          defaultIconName: o ? Tt.ICON_HIDE : Tt.ICON_NOT_ALLOWED,
          getDragItem: function() {
            return r.createDragItem();
          },
          dragItemName: this.displayName,
          onDragStarted: function() {
            return r.column.setMoving(!0, "uiColumnMoved");
          },
          onDragStopped: function() {
            return r.column.setMoving(!1, "uiColumnMoved");
          },
          onGridEnter: function(n) {
            var s;
            if (o) {
              var a = ((s = n == null ? void 0 : n.columns) === null || s === void 0 ? void 0 : s.filter(function(l) {
                return !l.getColDef().lockVisible;
              })) || [];
              r.columnModel.setColumnsVisible(a, !0, "uiColumnMoved");
            }
          },
          onGridExit: function(n) {
            var s;
            if (o) {
              var a = ((s = n == null ? void 0 : n.columns) === null || s === void 0 ? void 0 : s.filter(function(l) {
                return !l.getColDef().lockVisible;
              })) || [];
              r.columnModel.setColumnsVisible(a, !1, "uiColumnMoved");
            }
          }
        }, this.dragAndDropService.addDragSource(this.moveDragSource, !0);
      }
    }, t.prototype.createDragItem = function() {
      var e = {};
      return e[this.column.getId()] = this.column.isVisible(), {
        columns: [this.column],
        visibleState: e
      };
    }, t.prototype.removeDragSource = function() {
      this.moveDragSource && (this.dragAndDropService.removeDragSource(this.moveDragSource), this.moveDragSource = void 0);
    }, t.prototype.onColDefChanged = function() {
      this.refresh();
    }, t.prototype.updateState = function() {
      var e = this.column.getColDef();
      this.menuEnabled = this.menuFactory.isMenuEnabled(this.column) && !e.suppressMenu, this.sortable = e.sortable, this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
    }, t.prototype.addRefreshFunction = function(e) {
      this.refreshFunctions.push(e);
    }, t.prototype.refresh = function() {
      this.updateState(), this.refreshHeaderComp(), this.refreshAria(), this.refreshFunctions.forEach(function(e) {
        return e();
      });
    }, t.prototype.refreshHeaderComp = function() {
      var e = this.lookupUserCompDetails(), r = this.comp.getUserCompInstance(), o = r != null && this.userCompDetails.componentClass == e.componentClass, n = o ? this.attemptHeaderCompRefresh(e.params) : !1;
      n ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
    }, t.prototype.attemptHeaderCompRefresh = function(e) {
      var r = this.comp.getUserCompInstance();
      if (!r || !r.refresh)
        return !1;
      var o = r.refresh(e);
      return o;
    }, t.prototype.calculateDisplayName = function() {
      return this.columnModel.getDisplayNameForColumn(this.column, "header", !0);
    }, t.prototype.checkDisplayName = function() {
      this.displayName !== this.calculateDisplayName() && this.refresh();
    }, t.prototype.workOutDraggable = function() {
      var e = this.column.getColDef(), r = this.gridOptionsService.is("suppressMovableColumns"), o = !r && !e.suppressMovable && !e.lockPosition;
      return !!o || !!e.enableRowGroup || !!e.enablePivot;
    }, t.prototype.onColumnRowGroupChanged = function() {
      this.checkDisplayName();
    }, t.prototype.onColumnPivotChanged = function() {
      this.checkDisplayName();
    }, t.prototype.onColumnValueChanged = function() {
      this.checkDisplayName();
    }, t.prototype.setupWidth = function() {
      var e = this, r = function() {
        var o = e.column.getActualWidth();
        e.comp.setWidth(o + "px");
      };
      this.addManagedListener(this.column, $e.EVENT_WIDTH_CHANGED, r), r();
    }, t.prototype.setupMovingCss = function() {
      var e = this, r = function() {
        e.comp.addOrRemoveCssClass("ag-header-cell-moving", e.column.isMoving());
      };
      this.addManagedListener(this.column, $e.EVENT_MOVING_CHANGED, r), r();
    }, t.prototype.setupMenuClass = function() {
      var e = this, r = function() {
        e.comp.addOrRemoveCssClass("ag-column-menu-visible", e.column.isMenuVisible());
      };
      this.addManagedListener(this.column, $e.EVENT_MENU_VISIBLE_CHANGED, r), r();
    }, t.prototype.setupSortableClass = function() {
      var e = this, r = function() {
        e.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!e.sortable);
      };
      r(), this.addRefreshFunction(r), this.addManagedListener(this.eventService, $e.EVENT_SORT_CHANGED, this.refreshAriaSort.bind(this));
    }, t.prototype.setupWrapTextClass = function() {
      var e = this, r = function() {
        var o = !!e.column.getColDef().wrapHeaderText;
        e.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", o);
      };
      r(), this.addRefreshFunction(r);
    }, t.prototype.onHeaderHeightChanged = function() {
      this.refreshSpanHeaderHeight();
    }, t.prototype.refreshSpanHeaderHeight = function() {
      var e = this, r = e.eGui, o = e.column, n = e.comp, s = e.columnModel, a = e.gridOptionsService;
      if (o.isSpanHeaderHeight()) {
        var l = this.getColumnGroupPaddingInfo(), u = l.numberOfParents, c = l.isSpanningTotal;
        if (n.addOrRemoveCssClass("ag-header-span-height", u > 0), u !== 0) {
          n.addOrRemoveCssClass("ag-header-span-total", c);
          var p = a.is("pivotMode"), d = p ? s.getPivotGroupHeaderHeight() : s.getGroupHeaderHeight(), h = s.getColumnHeaderRowHeight(), g = u * d;
          r.style.setProperty("top", -g + "px"), r.style.setProperty("height", h + g + "px");
        }
      }
    }, t.prototype.getColumnGroupPaddingInfo = function() {
      var e = this.column.getParent();
      if (!e || !e.isPadding())
        return { numberOfParents: 0, isSpanningTotal: !1 };
      for (var r = e.getPaddingLevel() + 1, o = !0; e; ) {
        if (!e.isPadding()) {
          o = !1;
          break;
        }
        e = e.getParent();
      }
      return { numberOfParents: r, isSpanningTotal: o };
    }, t.prototype.setupAutoHeight = function(e) {
      var r = this, o = function(c) {
        if (r.isAlive()) {
          var p = mn(r.getGui()), d = p.paddingTop, h = p.paddingBottom, g = p.borderBottomWidth, y = p.borderTopWidth, S = d + h + g + y, _ = e.offsetHeight, w = _ + S;
          if (c < 5) {
            var E = r.beans.gridOptionsService.getDocument(), R = !E || !E.contains(e), D = w == 0;
            if (R || D) {
              r.beans.frameworkOverrides.setTimeout(function() {
                return o(c + 1);
              }, 0);
              return;
            }
          }
          r.columnModel.setColumnHeaderHeight(r.column, w);
        }
      }, n = !1, s, a = function() {
        var c = r.column.isSpanHeaderHeight(), p = r.column.isAutoHeaderHeight();
        if (c) {
          if (u(), p) {
            var d = "AG Grid: The properties `spanHeaderHeight` and `autoHeaderHeight` cannot be used together in the same column.";
            Pe(function() {
              return console.warn(d);
            }, "HeaderCellCtrl.spanHeaderHeightAndAutoHeaderHeight");
          }
          return;
        }
        p && !n && l(), !p && n && u();
      }, l = function() {
        n = !0, o(0), r.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !0), s = r.resizeObserverService.observeResize(e, function() {
          return o(0);
        });
      }, u = function() {
        n = !1, s && s(), r.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !1), s = void 0;
      };
      a(), this.addDestroyFunc(function() {
        return u();
      }), this.addManagedListener(this.column, $e.EVENT_WIDTH_CHANGED, function() {
        return n && o(0);
      }), this.addManagedListener(this.eventService, $e.EVENT_SORT_CHANGED, function() {
        n && r.beans.frameworkOverrides.setTimeout(function() {
          return o(0);
        });
      }), this.addRefreshFunction(a);
    }, t.prototype.refreshAriaSort = function() {
      if (this.sortable) {
        var e = this.localeService.getLocaleTextFunc(), r = this.sortController.getDisplaySortForColumn(this.column) || null;
        this.comp.setAriaSort(Of(r)), this.setAriaDescriptionProperty("sort", e("ariaSortableColumn", "Press ENTER to sort."));
      } else
        this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
    }, t.prototype.refreshAriaMenu = function() {
      if (this.menuEnabled) {
        var e = this.localeService.getLocaleTextFunc();
        this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press CTRL ENTER to open column menu."));
      } else
        this.setAriaDescriptionProperty("menu", null);
    }, t.prototype.setAriaDescriptionProperty = function(e, r) {
      r != null ? this.ariaDescriptionProperties.set(e, r) : this.ariaDescriptionProperties.delete(e);
    }, t.prototype.refreshAriaDescription = function() {
      var e = Array.from(this.ariaDescriptionProperties.values());
      this.comp.setAriaDescription(e.length ? e.join(" ") : void 0);
    }, t.prototype.refreshAria = function() {
      this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaDescription();
    }, t.prototype.addColumnHoverListener = function() {
      var e = this, r = function() {
        if (e.gridOptionsService.is("columnHoverHighlight")) {
          var o = e.columnHoverService.isHovered(e.column);
          e.comp.addOrRemoveCssClass("ag-column-hover", o);
        }
      };
      this.addManagedListener(this.eventService, m.EVENT_COLUMN_HOVER_CHANGED, r), r();
    }, t.prototype.setupFilterCss = function() {
      var e = this, r = function() {
        e.comp.addOrRemoveCssClass("ag-header-cell-filtered", e.column.isFilterActive());
      };
      this.addManagedListener(this.column, $e.EVENT_FILTER_ACTIVE_CHANGED, r), r();
    }, t.prototype.setupColId = function() {
      this.comp.setColId(this.column.getColId());
    }, t.prototype.addActiveHeaderMouseListeners = function() {
      var e = this, r = function(o) {
        return e.setActiveHeader(o.type === "mouseenter");
      };
      this.addManagedListener(this.getGui(), "mouseenter", r), this.addManagedListener(this.getGui(), "mouseleave", r);
    }, t.prototype.setActiveHeader = function(e) {
      this.comp.addOrRemoveCssClass("ag-header-active", e);
    }, fo([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), fo([
      v("columnHoverService")
    ], t.prototype, "columnHoverService", void 0), fo([
      v("sortController")
    ], t.prototype, "sortController", void 0), fo([
      v("menuFactory")
    ], t.prototype, "menuFactory", void 0), fo([
      v("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), fo([
      v("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), fo([
      v("gridApi")
    ], t.prototype, "gridApi", void 0), fo([
      v("columnApi")
    ], t.prototype, "columnApi", void 0), fo([
      At
    ], t.prototype, "removeDragSource", null), t;
  }(Ui)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var vE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), vs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, gE = (
  /** @class */
  function(i) {
    vE(t, i);
    function t(e, r, o, n) {
      var s = i.call(this) || this;
      return s.eResize = r, s.comp = e, s.pinned = o, s.columnGroup = n, s;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      if (!this.columnGroup.isResizable()) {
        this.comp.setResizableDisplayed(!1);
        return;
      }
      var r = this.horizontalResizeService.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, !1),
        onResizeEnd: this.onResizing.bind(this, !0)
      });
      if (this.addDestroyFunc(r), !this.gridOptionsService.is("suppressAutoSize")) {
        var o = this.gridOptionsService.is("skipHeaderOnAutoSize");
        this.eResize.addEventListener("dblclick", function() {
          var n = [], s = e.columnGroup.getDisplayedLeafColumns();
          s.forEach(function(a) {
            a.getColDef().suppressAutoSize || n.push(a.getColId());
          }), n.length > 0 && e.columnModel.autoSizeColumns({
            columns: n,
            skipHeader: o,
            stopAtGroup: e.columnGroup,
            source: "uiColumnResized"
          }), e.resizeLeafColumnsToFit("uiColumnResized");
        });
      }
    }, t.prototype.onResizeStart = function(e) {
      var r = this;
      this.calculateInitialValues();
      var o = null;
      if (e && (o = this.columnModel.getDisplayedGroupAfter(this.columnGroup)), o) {
        var n = o.getDisplayedLeafColumns();
        this.resizeTakeFromCols = n.filter(function(s) {
          return s.isResizable();
        }), this.resizeTakeFromStartWidth = 0, this.resizeTakeFromCols.forEach(function(s) {
          return r.resizeTakeFromStartWidth += s.getActualWidth();
        }), this.resizeTakeFromRatios = [], this.resizeTakeFromCols.forEach(function(s) {
          return r.resizeTakeFromRatios.push(s.getActualWidth() / r.resizeTakeFromStartWidth);
        });
      } else
        this.resizeTakeFromCols = null, this.resizeTakeFromStartWidth = null, this.resizeTakeFromRatios = null;
      this.comp.addOrRemoveCssClass("ag-column-resizing", !0);
    }, t.prototype.onResizing = function(e, r, o) {
      o === void 0 && (o = "uiColumnResized");
      var n = this.normaliseDragChange(r), s = this.resizeStartWidth + n;
      this.resizeColumns(s, o, e);
    }, t.prototype.resizeLeafColumnsToFit = function(e) {
      var r = this.autoWidthCalculator.getPreferredWidthForColumnGroup(this.columnGroup);
      this.calculateInitialValues(), r > this.resizeStartWidth && this.resizeColumns(r, e, !0);
    }, t.prototype.resizeColumns = function(e, r, o) {
      o === void 0 && (o = !0);
      var n = [];
      if (n.push({
        columns: this.resizeCols,
        ratios: this.resizeRatios,
        width: e
      }), this.resizeTakeFromCols) {
        var s = e - this.resizeStartWidth;
        n.push({
          columns: this.resizeTakeFromCols,
          ratios: this.resizeTakeFromRatios,
          width: this.resizeTakeFromStartWidth - s
        });
      }
      this.columnModel.resizeColumnSets({
        resizeSets: n,
        finished: o,
        source: r
      }), o && this.comp.addOrRemoveCssClass("ag-column-resizing", !1);
    }, t.prototype.calculateInitialValues = function() {
      var e = this, r = this.columnGroup.getDisplayedLeafColumns();
      this.resizeCols = r.filter(function(o) {
        return o.isResizable();
      }), this.resizeStartWidth = 0, this.resizeCols.forEach(function(o) {
        return e.resizeStartWidth += o.getActualWidth();
      }), this.resizeRatios = [], this.resizeCols.forEach(function(o) {
        return e.resizeRatios.push(o.getActualWidth() / e.resizeStartWidth);
      });
    }, t.prototype.normaliseDragChange = function(e) {
      var r = e;
      return this.gridOptionsService.is("enableRtl") ? this.pinned !== "left" && (r *= -1) : this.pinned === "right" && (r *= -1), r;
    }, vs([
      v("horizontalResizeService")
    ], t.prototype, "horizontalResizeService", void 0), vs([
      v("autoWidthCalculator")
    ], t.prototype, "autoWidthCalculator", void 0), vs([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), vs([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var yE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), mE = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, CE = (
  /** @class */
  function(i) {
    yE(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.removeChildListenersFuncs = [], o.columnGroup = r, o.comp = e, o;
    }
    return t.prototype.postConstruct = function() {
      this.addListenersToChildrenColumns(), this.addManagedListener(this.columnGroup, qt.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this)), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }, t.prototype.addListenersToChildrenColumns = function() {
      var e = this;
      this.removeListenersOnChildrenColumns();
      var r = this.onWidthChanged.bind(this);
      this.columnGroup.getLeafColumns().forEach(function(o) {
        o.addEventListener("widthChanged", r), o.addEventListener("visibleChanged", r), e.removeChildListenersFuncs.push(function() {
          o.removeEventListener("widthChanged", r), o.removeEventListener("visibleChanged", r);
        });
      });
    }, t.prototype.removeListenersOnChildrenColumns = function() {
      this.removeChildListenersFuncs.forEach(function(e) {
        return e();
      }), this.removeChildListenersFuncs = [];
    }, t.prototype.onDisplayedChildrenChanged = function() {
      this.addListenersToChildrenColumns(), this.onWidthChanged();
    }, t.prototype.onWidthChanged = function() {
      var e = this.columnGroup.getActualWidth();
      this.comp.setWidth(e + "px"), this.comp.addOrRemoveCssClass("ag-hidden", e === 0);
    }, mE([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var wE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, tv = (
  /** @class */
  function(i) {
    wE(t, i);
    function t(e, r) {
      var o = i.call(this, e, r) || this;
      return o.columnGroup = e, o;
    }
    return t.prototype.setComp = function(e, r, o) {
      i.prototype.setGui.call(this, r), this.comp = e, this.displayName = this.columnModel.getDisplayNameForColumnGroup(this.columnGroup, "header"), this.addClasses(), this.addAttributes(), this.setupMovingCss(), this.setupExpandable(), this.setupTooltip(), this.setupUserComp();
      var n = this.getParentRowCtrl().getPinned(), s = this.columnGroup.getProvidedColumnGroup().getLeafColumns();
      this.createManagedBean(new gc(s, r)), this.createManagedBean(new La(this.columnGroup, r, this.beans)), this.createManagedBean(new CE(e, this.columnGroup)), this.groupResizeFeature = this.createManagedBean(new gE(e, o, n, this.columnGroup)), this.createManagedBean(new wo(r, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: function() {
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      }));
    }, t.prototype.resizeLeafColumnsToFit = function(e) {
      var r, o;
      (r = this.groupResizeFeature) === null || r === void 0 || r.onResizeStart(!1), (o = this.groupResizeFeature) === null || o === void 0 || o.resizeLeafColumnsToFit(e);
    }, t.prototype.setupUserComp = function() {
      var e = this, r = this.displayName, o = {
        displayName: this.displayName,
        columnGroup: this.columnGroup,
        setExpanded: function(u) {
          e.columnModel.setColumnGroupOpened(e.columnGroup.getProvidedColumnGroup(), u, "gridInitializing");
        },
        api: this.gridApi,
        columnApi: this.columnApi,
        context: this.gridOptionsService.context
      };
      if (!r) {
        for (var n = this.columnGroup, s = n.getLeafColumns(); n.getParent() && n.getParent().getLeafColumns().length === s.length; )
          n = n.getParent();
        var a = n.getColGroupDef();
        a && (r = a.headerName), r || (r = s ? this.columnModel.getDisplayNameForColumn(s[0], "header", !0) : "");
      }
      var l = this.userComponentFactory.getHeaderGroupCompDetails(o);
      this.comp.setUserCompDetails(l);
    }, t.prototype.setupTooltip = function() {
      var e = this, r = this.columnGroup.getColGroupDef(), o = {
        getColumn: function() {
          return e.columnGroup;
        },
        getGui: function() {
          return e.eGui;
        },
        getLocation: function() {
          return "headerGroup";
        },
        getTooltipValue: function() {
          return r && r.headerTooltip;
        }
      };
      r && (o.getColDef = function() {
        return r;
      });
      var n = this.createManagedBean(new pc(o, this.beans));
      n.setComp(this.comp);
    }, t.prototype.setupExpandable = function() {
      var e = this.columnGroup.getProvidedColumnGroup();
      this.refreshExpanded(), this.addManagedListener(e, et.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this)), this.addManagedListener(e, et.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
    }, t.prototype.refreshExpanded = function() {
      var e = this.columnGroup;
      this.expandable = e.isExpandable();
      var r = e.isExpanded();
      this.expandable ? this.comp.setAriaExpanded(r ? "true" : "false") : this.comp.setAriaExpanded(void 0);
    }, t.prototype.addAttributes = function() {
      this.comp.setColId(this.columnGroup.getUniqueId());
    }, t.prototype.addClasses = function() {
      var e = this, r = this.columnGroup.getColGroupDef(), o = vc.getHeaderClassesFromColDef(r, this.gridOptionsService, null, this.columnGroup);
      if (this.columnGroup.isPadding()) {
        o.push("ag-header-group-cell-no-group");
        var n = this.columnGroup.getLeafColumns();
        n.every(function(s) {
          return s.isSpanHeaderHeight();
        }) && o.push("ag-header-span-height");
      } else
        o.push("ag-header-group-cell-with-group");
      o.forEach(function(s) {
        return e.comp.addOrRemoveCssClass(s, !0);
      });
    }, t.prototype.setupMovingCss = function() {
      var e = this, r = this.columnGroup.getProvidedColumnGroup(), o = r.getLeafColumns(), n = function() {
        return e.comp.addOrRemoveCssClass("ag-header-cell-moving", e.columnGroup.isMoving());
      };
      o.forEach(function(s) {
        e.addManagedListener(s, $e.EVENT_MOVING_CHANGED, n);
      }), n();
    }, t.prototype.onFocusIn = function(e) {
      if (!this.eGui.contains(e.relatedTarget)) {
        var r = this.getRowIndex();
        this.beans.focusService.setFocusedHeader(r, this.columnGroup);
      }
    }, t.prototype.handleKeyDown = function(e) {
      i.prototype.handleKeyDown.call(this, e);
      var r = this.getWrapperHasFocus();
      if (!(!this.expandable || !r) && e.key === L.ENTER) {
        var o = this.columnGroup, n = !o.isExpanded();
        this.columnModel.setColumnGroupOpened(o.getProvidedColumnGroup(), n, "uiColumnExpanded");
      }
    }, t.prototype.setDragSource = function(e) {
      var r = this;
      if (!this.isSuppressMoving()) {
        var o = this.columnGroup.getProvidedColumnGroup().getLeafColumns(), n = !this.gridOptionsService.is("suppressDragLeaveHidesColumns"), s = {
          type: kt.HeaderCell,
          eElement: e,
          defaultIconName: n ? Tt.ICON_HIDE : Tt.ICON_NOT_ALLOWED,
          dragItemName: this.displayName,
          // we add in the original group leaf columns, so we move both visible and non-visible items
          getDragItem: this.getDragItemForGroup.bind(this),
          onDragStarted: function() {
            return o.forEach(function(a) {
              return a.setMoving(!0, "uiColumnDragged");
            });
          },
          onDragStopped: function() {
            return o.forEach(function(a) {
              return a.setMoving(!1, "uiColumnDragged");
            });
          },
          onGridEnter: function(a) {
            var l;
            if (n) {
              var u = ((l = a == null ? void 0 : a.columns) === null || l === void 0 ? void 0 : l.filter(function(c) {
                return !c.getColDef().lockVisible;
              })) || [];
              r.columnModel.setColumnsVisible(u, !0, "uiColumnMoved");
            }
          },
          onGridExit: function(a) {
            var l;
            if (n) {
              var u = ((l = a == null ? void 0 : a.columns) === null || l === void 0 ? void 0 : l.filter(function(c) {
                return !c.getColDef().lockVisible;
              })) || [];
              r.columnModel.setColumnsVisible(u, !1, "uiColumnMoved");
            }
          }
        };
        this.dragAndDropService.addDragSource(s, !0), this.addDestroyFunc(function() {
          return r.dragAndDropService.removeDragSource(s);
        });
      }
    }, t.prototype.getDragItemForGroup = function() {
      var e = this.columnGroup.getProvidedColumnGroup().getLeafColumns(), r = {};
      e.forEach(function(n) {
        return r[n.getId()] = n.isVisible();
      });
      var o = [];
      return this.columnModel.getAllDisplayedColumns().forEach(function(n) {
        e.indexOf(n) >= 0 && (o.push(n), Vt(e, n));
      }), e.forEach(function(n) {
        return o.push(n);
      }), {
        columns: o,
        visibleState: r
      };
    }, t.prototype.isSuppressMoving = function() {
      var e = !1;
      this.columnGroup.getLeafColumns().forEach(function(o) {
        (o.getColDef().suppressMovable || o.getColDef().lockPosition) && (e = !0);
      });
      var r = e || this.gridOptionsService.is("suppressMovableColumns");
      return r;
    }, gs([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), gs([
      v("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), gs([
      v("gridApi")
    ], t.prototype, "gridApi", void 0), gs([
      v("columnApi")
    ], t.prototype, "columnApi", void 0), t;
  }(Ui)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var SE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ed = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, _E = 0, ks = (
  /** @class */
  function(i) {
    SE(t, i);
    function t(e, r, o) {
      var n = i.call(this) || this;
      return n.instanceId = _E++, n.headerCellCtrls = {}, n.rowIndex = e, n.pinned = r, n.type = o, n;
    }
    return t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.setComp = function(e) {
      this.comp = e, this.onRowHeightChanged(), this.onVirtualColumnsChanged(), this.setWidth(), this.addEventListeners(), ao() && this.comp.setTransform("translateZ(0)"), e.setAriaRowIndex(this.rowIndex + 1);
    }, t.prototype.addEventListeners = function() {
      this.addManagedListener(this.eventService, m.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this)), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_GRID_STYLES_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this)), this.addManagedPropertyListener("headerHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("pivotHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("groupHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("pivotGroupHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("floatingFiltersHeight", this.onRowHeightChanged.bind(this));
    }, t.prototype.getHeaderCellCtrl = function(e) {
      return Vi(this.headerCellCtrls).find(function(r) {
        return r.getColumnGroupChild() === e;
      });
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
    }, t.prototype.getType = function() {
      return this.type;
    }, t.prototype.onColumnResized = function() {
      this.setWidth();
    }, t.prototype.setWidth = function() {
      var e = this.getWidthForRow();
      this.comp.setWidth(e + "px");
    }, t.prototype.getWidthForRow = function() {
      var e = this.gridOptionsService.isDomLayout("print");
      if (e) {
        var r = this.pinned != null;
        return r ? 0 : this.columnModel.getContainerWidth("right") + this.columnModel.getContainerWidth("left") + this.columnModel.getContainerWidth(null);
      }
      return this.columnModel.getContainerWidth(this.pinned);
    }, t.prototype.onRowHeightChanged = function() {
      var e = this.columnModel.getHeaderRowCount(), r = [], o = 0;
      this.columnModel.hasFloatingFilters() && (e++, o = 1);
      for (var n = this.columnModel.getColumnGroupHeaderRowHeight(), s = this.columnModel.getColumnHeaderRowHeight(), a = 1 + o, l = e - a, u = 0; u < l; u++)
        r.push(n);
      r.push(s);
      for (var u = 0; u < o; u++)
        r.push(this.columnModel.getFloatingFiltersHeight());
      for (var c = 0, u = 0; u < this.rowIndex; u++)
        c += r[u];
      var p = r[this.rowIndex] + "px";
      this.comp.setTop(c + "px"), this.comp.setHeight(p);
    }, t.prototype.getPinned = function() {
      return this.pinned;
    }, t.prototype.getRowIndex = function() {
      return this.rowIndex;
    }, t.prototype.onVirtualColumnsChanged = function() {
      var e = this, r = this.headerCellCtrls;
      this.headerCellCtrls = {};
      var o = this.getColumnsInViewport();
      o.forEach(function(a) {
        if (!a.isEmptyGroup()) {
          var l = a.getUniqueId(), u = r[l];
          delete r[l];
          var c = u && u.getColumnGroupChild() != a;
          if (c && (e.destroyBean(u), u = void 0), u == null)
            switch (e.type) {
              case Pt.FLOATING_FILTER:
                u = e.createBean(new Zh(a, e));
                break;
              case Pt.COLUMN_GROUP:
                u = e.createBean(new tv(a, e));
                break;
              default:
                u = e.createBean(new ev(a, e));
                break;
            }
          e.headerCellCtrls[l] = u;
        }
      });
      var n = function(a) {
        var l = e.focusService.isHeaderWrapperFocused(a);
        if (!l)
          return !1;
        var u = e.columnModel.isDisplayed(a.getColumnGroupChild());
        return u;
      };
      Ke(r, function(a, l) {
        var u = n(l);
        u ? e.headerCellCtrls[a] = l : e.destroyBean(l);
      });
      var s = io(this.headerCellCtrls);
      this.comp.setHeaderCtrls(s);
    }, t.prototype.getColumnsInViewport = function() {
      var e = this.gridOptionsService.isDomLayout("print");
      return e ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
    }, t.prototype.getColumnsInViewportPrintLayout = function() {
      var e = this;
      if (this.pinned != null)
        return [];
      var r = [], o = this.getActualDepth();
      return ["left", null, "right"].forEach(function(n) {
        var s = e.columnModel.getVirtualHeaderGroupRow(n, o);
        r = r.concat(s);
      }), r;
    }, t.prototype.getActualDepth = function() {
      return this.type == Pt.FLOATING_FILTER ? this.rowIndex - 1 : this.rowIndex;
    }, t.prototype.getColumnsInViewportNormalLayout = function() {
      return this.columnModel.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
    }, t.prototype.focusHeader = function(e, r) {
      var o = io(this.headerCellCtrls), n = o.find(function(s) {
        return s.getColumnGroupChild() == e;
      });
      return n ? (n.focus(r), !0) : !1;
    }, t.prototype.destroy = function() {
      var e = this;
      Ke(this.headerCellCtrls, function(r, o) {
        e.destroyBean(o);
      }), this.headerCellCtrls = {}, i.prototype.destroy.call(this);
    }, ed([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), ed([
      v("focusService")
    ], t.prototype, "focusService", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var EE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), li = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, RE = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, OE = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(RE(arguments[t]));
  return i;
}, rv = (
  /** @class */
  function(i) {
    EE(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.hidden = !1, r.groupsRowCtrls = [], r.pinned = e, r;
    }
    return t.prototype.setComp = function(e, r) {
      this.comp = e, this.eViewport = r, this.setupCenterWidth(), this.setupPinnedWidth(), this.setupDragAndDrop(this.eViewport), this.addManagedListener(this.eventService, m.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this)), this.ctrlsService.registerHeaderContainer(this, this.pinned), this.columnModel.isReady() && this.refresh();
    }, t.prototype.setupDragAndDrop = function(e) {
      var r = new Qh(this.pinned, e);
      this.createManagedBean(r);
    }, t.prototype.refresh = function(e) {
      var r = this;
      e === void 0 && (e = !1);
      var o = new fn(), n = this.focusService.getFocusHeaderToUseAfterRefresh(), s = function() {
        var c = r.columnModel.getHeaderRowCount() - 1;
        r.groupsRowCtrls = r.destroyBeans(r.groupsRowCtrls);
        for (var p = 0; p < c; p++) {
          var d = r.createBean(new ks(o.next(), r.pinned, Pt.COLUMN_GROUP));
          r.groupsRowCtrls.push(d);
        }
      }, a = function() {
        var c = o.next(), p = !r.hidden && (r.columnsRowCtrl == null || !e || r.columnsRowCtrl.getRowIndex() !== c), d = p || r.hidden;
        d && (r.columnsRowCtrl = r.destroyBean(r.columnsRowCtrl)), p && (r.columnsRowCtrl = r.createBean(new ks(c, r.pinned, Pt.COLUMN)));
      }, l = function() {
        var c = r.columnModel.hasFloatingFilters() && !r.hidden, p = function() {
          r.filtersRowCtrl = r.destroyBean(r.filtersRowCtrl);
        };
        if (!c) {
          p();
          return;
        }
        var d = o.next();
        if (r.filtersRowCtrl) {
          var h = r.filtersRowCtrl.getRowIndex() !== d;
          (!e || h) && p();
        }
        r.filtersRowCtrl || (r.filtersRowCtrl = r.createBean(new ks(d, r.pinned, Pt.FLOATING_FILTER)));
      };
      s(), a(), l();
      var u = this.getAllCtrls();
      this.comp.setCtrls(u), this.restoreFocusOnHeader(n);
    }, t.prototype.restoreFocusOnHeader = function(e) {
      e == null || e.column.getPinned() != this.pinned || this.focusService.focusHeaderPosition({ headerPosition: e });
    }, t.prototype.getAllCtrls = function() {
      var e = OE(this.groupsRowCtrls);
      return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
    }, t.prototype.onGridColumnsChanged = function() {
      this.refresh(!0);
    }, t.prototype.setupCenterWidth = function() {
      var e = this;
      this.pinned == null && this.createManagedBean(new fc(function(r) {
        return e.comp.setCenterWidth(r + "px");
      }, !0));
    }, t.prototype.setHorizontalScroll = function(e) {
      this.comp.setViewportScrollLeft(e);
    }, t.prototype.setupPinnedWidth = function() {
      var e = this;
      if (this.pinned != null) {
        var r = this.pinned === "left", o = this.pinned === "right";
        this.hidden = !0;
        var n = function() {
          var s = r ? e.pinnedWidthService.getPinnedLeftWidth() : e.pinnedWidthService.getPinnedRightWidth();
          if (s != null) {
            var a = s == 0, l = e.hidden !== a, u = e.gridOptionsService.is("enableRtl"), c = e.gridOptionsService.getScrollbarWidth(), p = e.scrollVisibleService.isVerticalScrollShowing() && (u && r || !u && o), d = p ? s + c : s;
            e.comp.setPinnedContainerWidth(d + "px"), e.comp.setDisplayed(!a), l && (e.hidden = a, e.refresh());
          }
        };
        this.addManagedListener(this.eventService, m.EVENT_LEFT_PINNED_WIDTH_CHANGED, n), this.addManagedListener(this.eventService, m.EVENT_RIGHT_PINNED_WIDTH_CHANGED, n), this.addManagedListener(this.eventService, m.EVENT_SCROLL_VISIBILITY_CHANGED, n), this.addManagedListener(this.eventService, m.EVENT_SCROLLBAR_WIDTH_CHANGED, n);
      }
    }, t.prototype.getHeaderCtrlForColumn = function(e) {
      if (e instanceof $e)
        return this.columnsRowCtrl ? this.columnsRowCtrl.getHeaderCellCtrl(e) : void 0;
      if (this.groupsRowCtrls.length !== 0)
        for (var r = 0; r < this.groupsRowCtrls.length; r++) {
          var o = this.groupsRowCtrls[r].getHeaderCellCtrl(e);
          if (o)
            return o;
        }
    }, t.prototype.getHtmlElementForColumnHeader = function(e) {
      var r = this.getHeaderCtrlForColumn(e);
      return r ? r.getGui() : null;
    }, t.prototype.getRowType = function(e) {
      var r = this.getAllCtrls(), o = r[e];
      return o ? o.getType() : void 0;
    }, t.prototype.focusHeader = function(e, r, o) {
      var n = this.getAllCtrls(), s = n[e];
      return s ? s.focusHeader(r, o) : !1;
    }, t.prototype.getRowCount = function() {
      return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }, t.prototype.destroy = function() {
      this.filtersRowCtrl && (this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl)), this.columnsRowCtrl && (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl)), this.groupsRowCtrls && this.groupsRowCtrls.length && (this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls)), i.prototype.destroy.call(this);
    }, li([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), li([
      v("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), li([
      v("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), li([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), li([
      v("focusService")
    ], t.prototype, "focusService", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var bE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Tl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, js = (
  /** @class */
  function(i) {
    bE(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.headerRowComps = {}, r.rowCompsList = [], r.pinned = e, r;
    }
    return t.prototype.init = function() {
      var e = this;
      this.selectAndSetTemplate();
      var r = {
        setDisplayed: function(n) {
          return e.setDisplayed(n);
        },
        setCtrls: function(n) {
          return e.setCtrls(n);
        },
        // only gets called for center section
        setCenterWidth: function(n) {
          return e.eCenterContainer.style.width = n;
        },
        setViewportScrollLeft: function(n) {
          return e.getGui().scrollLeft = n;
        },
        // only gets called for pinned sections
        setPinnedContainerWidth: function(n) {
          var s = e.getGui();
          s.style.width = n, s.style.maxWidth = n, s.style.minWidth = n;
        }
      }, o = this.createManagedBean(new rv(this.pinned));
      o.setComp(r, this.getGui());
    }, t.prototype.selectAndSetTemplate = function() {
      var e = this.pinned == "left", r = this.pinned == "right", o = e ? t.PINNED_LEFT_TEMPLATE : r ? t.PINNED_RIGHT_TEMPLATE : t.CENTER_TEMPLATE;
      this.setTemplate(o), this.eRowContainer = this.eCenterContainer ? this.eCenterContainer : this.getGui();
    }, t.prototype.destroyRowComps = function() {
      this.setCtrls([]);
    }, t.prototype.destroyRowComp = function(e) {
      this.destroyBean(e), this.eRowContainer.removeChild(e.getGui());
    }, t.prototype.setCtrls = function(e) {
      var r = this, o = this.headerRowComps;
      this.headerRowComps = {}, this.rowCompsList = [];
      var n, s = function(a) {
        var l = a.getGui(), u = l.parentElement != r.eRowContainer;
        u && r.eRowContainer.appendChild(l), n && qu(r.eRowContainer, l, n), n = l;
      };
      e.forEach(function(a) {
        var l = a.getInstanceId(), u = o[l];
        delete o[l];
        var c = u || r.createBean(new Jh(a));
        r.headerRowComps[l] = c, r.rowCompsList.push(c), s(c);
      }), io(o).forEach(function(a) {
        return r.destroyRowComp(a);
      });
    }, t.PINNED_LEFT_TEMPLATE = '<div class="ag-pinned-left-header" role="presentation"></div>', t.PINNED_RIGHT_TEMPLATE = '<div class="ag-pinned-right-header" role="presentation"></div>', t.CENTER_TEMPLATE = `<div class="ag-header-viewport" role="presentation">
            <div class="ag-header-container" ref="eCenterContainer" role="rowgroup"></div>
        </div>`, Tl([
      Y("eCenterContainer")
    ], t.prototype, "eCenterContainer", void 0), Tl([
      U
    ], t.prototype, "init", null), Tl([
      At
    ], t.prototype, "destroyRowComps", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var TE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ui = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Hr;
(function(i) {
  i[i.UP = 0] = "UP", i[i.DOWN = 1] = "DOWN", i[i.LEFT = 2] = "LEFT", i[i.RIGHT = 3] = "RIGHT";
})(Hr || (Hr = {}));
var ov = (
  /** @class */
  function(i) {
    TE(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.gridBodyCon = r.gridBodyCtrl;
      });
    }, t.prototype.getHeaderRowCount = function() {
      var e = this.ctrlsService.getHeaderRowContainerCtrl();
      return e ? e.getRowCount() : 0;
    }, t.prototype.navigateVertically = function(e, r, o) {
      if (r || (r = this.focusService.getFocusedHeader()), !r)
        return !1;
      var n = r.headerRowIndex, s = r.column, a = this.getHeaderRowCount(), l = e === Hr.UP, u = l ? this.headerPositionUtils.getColumnVisibleParent(s, n) : this.headerPositionUtils.getColumnVisibleChild(s, n), c = u.nextRow, p = u.nextFocusColumn, d = !1;
      return c < 0 && (c = 0, p = s, d = !0), c >= a && (c = -1), !d && !p ? !1 : this.focusService.focusHeaderPosition({
        headerPosition: { headerRowIndex: c, column: p },
        allowUserOverride: !0,
        event: o
      });
    }, t.prototype.navigateHorizontally = function(e, r, o) {
      r === void 0 && (r = !1);
      var n = this.focusService.getFocusedHeader(), s = e === Hr.LEFT, a = this.gridOptionsService.is("enableRtl"), l, u;
      return s !== a ? (u = "Before", l = this.headerPositionUtils.findHeader(n, u)) : (u = "After", l = this.headerPositionUtils.findHeader(n, u)), l || !r ? this.focusService.focusHeaderPosition({
        headerPosition: l,
        direction: u,
        fromTab: r,
        allowUserOverride: !0,
        event: o
      }) : this.focusNextHeaderRow(n, u, o);
    }, t.prototype.focusNextHeaderRow = function(e, r, o) {
      var n = e.headerRowIndex, s = null, a;
      return r === "Before" ? n > 0 && (a = n - 1, s = this.headerPositionUtils.findColAtEdgeForHeaderRow(a, "end")) : (a = n + 1, s = this.headerPositionUtils.findColAtEdgeForHeaderRow(a, "start")), this.focusService.focusHeaderPosition({
        headerPosition: s,
        direction: r,
        fromTab: !0,
        allowUserOverride: !0,
        event: o
      });
    }, t.prototype.scrollToColumn = function(e, r) {
      if (r === void 0 && (r = "After"), !e.getPinned()) {
        var o;
        if (e instanceof qt) {
          var n = e.getDisplayedLeafColumns();
          o = r === "Before" ? Ne(n) : n[0];
        } else
          o = e;
        this.gridBodyCon.getScrollFeature().ensureColumnVisible(o);
      }
    }, ui([
      v("focusService")
    ], t.prototype, "focusService", void 0), ui([
      v("headerPositionUtils")
    ], t.prototype, "headerPositionUtils", void 0), ui([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), ui([
      U
    ], t.prototype, "postConstruct", null), t = ui([
      te("headerNavigationService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var PE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ys = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, nv = (
  /** @class */
  function(i) {
    PE(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.setComp = function(e, r, o) {
      this.comp = e, this.eGui = r, this.createManagedBean(new wo(o, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.onPivotModeChanged(), this.setupHeaderHeight(), this.ctrlsService.registerGridHeaderCtrl(this);
    }, t.prototype.setupHeaderHeight = function() {
      var e = this.setHeaderHeight.bind(this);
      e(), this.addManagedPropertyListener("headerHeight", e), this.addManagedPropertyListener("pivotHeaderHeight", e), this.addManagedPropertyListener("groupHeaderHeight", e), this.addManagedPropertyListener("pivotGroupHeaderHeight", e), this.addManagedPropertyListener("floatingFiltersHeight", e), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_GRID_STYLES_CHANGED, e);
    }, t.prototype.getHeaderHeight = function() {
      return this.headerHeight;
    }, t.prototype.setHeaderHeight = function() {
      var e = this.columnModel, r = 0, o = e.getHeaderRowCount(), n, s = e.hasFloatingFilters();
      s && (o++, r = 1);
      var a = this.columnModel.getColumnGroupHeaderRowHeight(), l = this.columnModel.getColumnHeaderRowHeight(), u = 1 + r, c = o - u;
      if (n = r * e.getFloatingFiltersHeight(), n += c * a, n += l, this.headerHeight !== n) {
        this.headerHeight = n;
        var p = n + 1 + "px";
        this.comp.setHeightAndMinHeight(p), this.eventService.dispatchEvent({
          type: m.EVENT_HEADER_HEIGHT_CHANGED
        });
      }
    }, t.prototype.onPivotModeChanged = function() {
      var e = this.columnModel.isPivotMode();
      this.comp.addOrRemoveCssClass("ag-pivot-on", e), this.comp.addOrRemoveCssClass("ag-pivot-off", !e);
    }, t.prototype.onDisplayedColumnsChanged = function() {
      var e = this.columnModel.getAllDisplayedColumns(), r = e.some(function(o) {
        return o.isSpanHeaderHeight();
      });
      this.comp.addOrRemoveCssClass("ag-header-allow-overflow", r);
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this.gridOptionsService.is("enableRtl"), o = e.shiftKey !== r ? Hr.LEFT : Hr.RIGHT;
      (this.headerNavigationService.navigateHorizontally(o, !0, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) && e.preventDefault();
    }, t.prototype.handleKeyDown = function(e) {
      var r = null;
      switch (e.key) {
        case L.LEFT:
          r = Hr.LEFT;
        case L.RIGHT:
          k(r) || (r = Hr.RIGHT), this.headerNavigationService.navigateHorizontally(r, !1, e);
          break;
        case L.UP:
          r = Hr.UP;
        case L.DOWN:
          k(r) || (r = Hr.DOWN), this.headerNavigationService.navigateVertically(r, null, e) && e.preventDefault();
          break;
        default:
          return;
      }
    }, t.prototype.onFocusOut = function(e) {
      var r = this.gridOptionsService.getDocument(), o = e.relatedTarget;
      !o && this.eGui.contains(r.activeElement) || this.eGui.contains(o) || this.focusService.clearFocusedHeader();
    }, ys([
      v("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), ys([
      v("focusService")
    ], t.prototype, "focusService", void 0), ys([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), ys([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var DE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), AE = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, iv = (
  /** @class */
  function(i) {
    DE(t, i);
    function t() {
      return i.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = {
        addOrRemoveCssClass: function(s, a) {
          return e.addOrRemoveCssClass(s, a);
        },
        setHeightAndMinHeight: function(s) {
          e.getGui().style.height = s, e.getGui().style.minHeight = s;
        }
      }, o = this.createManagedBean(new nv());
      o.setComp(r, this.getGui(), this.getFocusableElement());
      var n = function(s) {
        e.createManagedBean(s), e.appendChild(s);
      };
      n(new js("left")), n(new js(null)), n(new js("right"));
    }, t.TEMPLATE = '<div class="ag-header" role="presentation"/>', AE([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var xE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Pl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, sv = (
  /** @class */
  function(i) {
    xE(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.addResizeBar = function(e) {
      var r = this, o = {
        dragStartPixels: e.dragStartPixels || 0,
        eElement: e.eResizeBar,
        onDragStart: this.onDragStart.bind(this, e),
        onDragStop: this.onDragStop.bind(this, e),
        onDragging: this.onDragging.bind(this, e)
      };
      this.dragService.addDragSource(o, !0);
      var n = function() {
        return r.dragService.removeDragSource(o);
      };
      return n;
    }, t.prototype.onDragStart = function(e, r) {
      this.dragStartX = r.clientX, this.setResizeIcons();
      var o = r instanceof MouseEvent && r.shiftKey === !0;
      e.onResizeStart(o);
    }, t.prototype.setResizeIcons = function() {
      var e = this.ctrlsService.getGridCtrl();
      e.setResizeCursor(!0), e.disableUserSelect(!0);
    }, t.prototype.onDragStop = function(e, r) {
      e.onResizeEnd(this.resizeAmount), this.resetIcons();
    }, t.prototype.resetIcons = function() {
      var e = this.ctrlsService.getGridCtrl();
      e.setResizeCursor(!1), e.disableUserSelect(!1);
    }, t.prototype.onDragging = function(e, r) {
      this.resizeAmount = r.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
    }, Pl([
      v("dragService")
    ], t.prototype, "dragService", void 0), Pl([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = Pl([
      te("horizontalResizeService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var FE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ci = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, av = (
  /** @class */
  function(i) {
    FE(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.hideActiveMenu = function() {
      this.hidePopup && this.hidePopup();
    }, t.prototype.showMenuAfterMouseEvent = function(e, r) {
      var o = this;
      this.showPopup(e, function(n) {
        o.popupService.positionPopupUnderMouseEvent({
          column: e,
          type: "columnMenu",
          mouseEvent: r,
          ePopup: n
        });
      }, "columnMenu", r.target);
    }, t.prototype.showMenuAfterButtonClick = function(e, r, o) {
      var n = this;
      this.showPopup(e, function(s) {
        n.popupService.positionPopupByComponent({
          type: o,
          eventSource: r,
          ePopup: s,
          keepWithinBounds: !0,
          position: "under",
          column: e
        });
      }, o, r);
    }, t.prototype.showPopup = function(e, r, o, n) {
      var s = this, a = this.filterManager.getOrCreateFilterWrapper(e, "COLUMN_MENU");
      if (!a)
        throw new Error("AG Grid - unable to show popup filter, filter instantiation failed");
      var l = document.createElement("div");
      Dt(l, "presentation"), l.classList.add("ag-menu"), this.tabListener = this.addManagedListener(l, "keydown", function(y) {
        return s.trapFocusWithin(y, l);
      }), a.guiPromise.then(function(y) {
        return l.appendChild(y);
      });
      var u, c = function() {
        var y;
        return (y = a.filterPromise) === null || y === void 0 ? void 0 : y.then(function(S) {
          var _;
          return (_ = S == null ? void 0 : S.afterGuiDetached) === null || _ === void 0 ? void 0 : _.call(S);
        });
      }, p = n || this.ctrlsService.getGridBodyCtrl().getGui(), d = function(y) {
        e.setMenuVisible(!1, "contextMenu");
        var S = y instanceof KeyboardEvent;
        if (s.tabListener && (s.tabListener = s.tabListener()), S && n && qn(n)) {
          var _ = s.focusService.findTabbableParent(n);
          _ && _.focus();
        }
        c();
      }, h = this.localeService.getLocaleTextFunc(), g = this.popupService.addPopup({
        modal: !0,
        eChild: l,
        closeOnEsc: !0,
        closedCallback: d,
        positionCallback: function() {
          return r(l);
        },
        anchorToElement: p,
        ariaLabel: h("ariaLabelColumnMenu", "Column Menu")
      });
      g && (this.hidePopup = u = g.hideFunc), a.filterPromise.then(function(y) {
        r(l), y.afterGuiAttached && y.afterGuiAttached({ container: o, hidePopup: u });
      }), e.setMenuVisible(!0, "contextMenu");
    }, t.prototype.trapFocusWithin = function(e, r) {
      e.key !== L.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(r, !1, e.shiftKey) || (e.preventDefault(), this.focusService.focusInto(r, e.shiftKey));
    }, t.prototype.isMenuEnabled = function(e) {
      return e.isFilterAllowed() && e.getMenuTabs(["filterMenuTab"]).includes("filterMenuTab");
    }, ci([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), ci([
      v("popupService")
    ], t.prototype, "popupService", void 0), ci([
      v("focusService")
    ], t.prototype, "focusService", void 0), ci([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = ci([
      te("menuFactory")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ME = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ms = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, IE = (
  /** @class */
  function(i) {
    ME(t, i);
    function t(e) {
      var r = i.call(this, t.getTemplate(e.cssClass)) || this;
      return r.items = [], r.tabbedItemScrollMap = /* @__PURE__ */ new Map(), r.params = e, e.items && e.items.forEach(function(o) {
        return r.addItem(o);
      }), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.createManagedBean(new wo(this.getFocusableElement(), {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this)
      })), this.addDestroyFunc(function() {
        var r, o, n;
        return (n = (o = (r = e.activeItem) === null || r === void 0 ? void 0 : r.tabbedItem) === null || o === void 0 ? void 0 : o.afterDetachedCallback) === null || n === void 0 ? void 0 : n.call(o);
      });
    }, t.getTemplate = function(e) {
      return (
        /* html */
        '<div class="ag-tabs ' + e + `">
            <div ref="eHeader" role="tablist" class="ag-tabs-header ` + (e ? e + "-header" : "") + `"></div>
            <div ref="eBody" role="presentation" class="ag-tabs-body ` + (e ? e + "-body" : "") + `"></div>
        </div>`
      );
    }, t.prototype.handleKeyDown = function(e) {
      var r = this.gridOptionsService.getDocument();
      switch (e.key) {
        case L.RIGHT:
        case L.LEFT:
          if (!this.eHeader.contains(r.activeElement))
            return;
          var o = e.key === L.RIGHT, n = this.gridOptionsService.is("enableRtl"), s = this.items.indexOf(this.activeItem), a = o !== n ? Math.min(s + 1, this.items.length - 1) : Math.max(s - 1, 0);
          if (s === a)
            return;
          e.preventDefault();
          var l = this.items[a];
          this.showItemWrapper(l), l.eHeaderButton.focus();
          break;
        case L.UP:
        case L.DOWN:
          e.stopPropagation();
          break;
      }
    }, t.prototype.onTabKeyDown = function(e) {
      if (!e.defaultPrevented) {
        var r = this, o = r.focusService, n = r.eHeader, s = r.eBody, a = r.activeItem, l = this.gridOptionsService.getDocument(), u = l.activeElement, c = e.target;
        if (e.preventDefault(), n.contains(u)) {
          o.focusInto(s, e.shiftKey);
          return;
        }
        var p = null;
        o.isTargetUnderManagedComponent(s, c) && (e.shiftKey && (p = this.focusService.findFocusableElementBeforeTabGuard(s, c)), p || (p = a.eHeaderButton)), !p && s.contains(u) && (p = o.findNextFocusableElement(s, !1, e.shiftKey), p || (p = a.eHeaderButton)), p && p.focus();
      }
    }, t.prototype.setAfterAttachedParams = function(e) {
      this.afterAttachedParams = e;
    }, t.prototype.showFirstItem = function() {
      this.items.length > 0 && this.showItemWrapper(this.items[0]);
    }, t.prototype.addItem = function(e) {
      var r = document.createElement("span");
      Dt(r, "tab"), r.setAttribute("tabIndex", "-1"), r.appendChild(e.title), r.classList.add("ag-tab"), this.eHeader.appendChild(r), yn(r, e.titleLabel);
      var o = {
        tabbedItem: e,
        eHeaderButton: r
      };
      this.items.push(o), r.addEventListener("click", this.showItemWrapper.bind(this, o));
    }, t.prototype.showItem = function(e) {
      var r = this.items.find(function(o) {
        return o.tabbedItem === e;
      });
      r && this.showItemWrapper(r);
    }, t.prototype.showItemWrapper = function(e) {
      var r = this, o, n, s = e.tabbedItem, a = e.eHeaderButton;
      if (this.params.onItemClicked && this.params.onItemClicked({ item: s }), this.activeItem === e) {
        of(this.params.onActiveItemClicked);
        return;
      }
      this.lastScrollListener && (this.lastScrollListener = this.lastScrollListener()), pr(this.eBody), s.bodyPromise.then(function(l) {
        r.eBody.appendChild(l);
        var u = !r.focusService.isKeyboardMode();
        if (r.focusService.focusInto(r.eBody, !1, u), s.afterAttachedCallback && s.afterAttachedCallback(r.afterAttachedParams), r.params.keepScrollPosition) {
          var c = s.getScrollableContainer && s.getScrollableContainer() || l;
          r.lastScrollListener = r.addManagedListener(c, "scroll", function() {
            r.tabbedItemScrollMap.set(s.name, c.scrollTop);
          });
          var p = r.tabbedItemScrollMap.get(s.name);
          p !== void 0 && setTimeout(function() {
            c.scrollTop = p;
          }, 0);
        }
      }), this.activeItem && (this.activeItem.eHeaderButton.classList.remove("ag-tab-selected"), (n = (o = this.activeItem.tabbedItem).afterDetachedCallback) === null || n === void 0 || n.call(o)), a.classList.add("ag-tab-selected"), this.activeItem = e;
    }, ms([
      v("focusService")
    ], t.prototype, "focusService", void 0), ms([
      Y("eHeader")
    ], t.prototype, "eHeader", void 0), ms([
      Y("eBody")
    ], t.prototype, "eBody", void 0), ms([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
function LE(i) {
  return Pe(function() {
    return console.warn("AG Grid: Since v29 simpleHttpRequest has been deprecated as it was only meant for use in internal AG Grid documentation examples. Please use the browser fetch api directly.");
  }, "simpleHttpRequest"), new nr(function(t) {
    var e = new XMLHttpRequest();
    e.open("GET", i.url), e.send(), e.onreadystatechange = function() {
      e.readyState === 4 && e.status === 200 && t(JSON.parse(e.responseText));
    };
  });
}
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var NE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), GE = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, HE = 50, lv = (
  /** @class */
  function(i) {
    NE(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.polyfillFunctions = [], e;
    }
    return t.prototype.observeResize = function(e, r) {
      var o = this, n = this.gridOptionsService.getDocument(), s = n.defaultView || window, a = function() {
        var p = new s.ResizeObserver(r);
        return p.observe(e), function() {
          return p.disconnect();
        };
      }, l = function() {
        var p = lu(e), d = au(e), h = !0, g = function() {
          if (h) {
            var y = lu(e), S = au(e), _ = y !== p || S !== d;
            _ && (p = y, d = S, r()), o.doNextPolyfillTurn(g);
          }
        };
        return g(), function() {
          return h = !1;
        };
      }, u = this.gridOptionsService.is("suppressBrowserResizeObserver"), c = !!s.ResizeObserver;
      return c && !u ? a() : l();
    }, t.prototype.doNextPolyfillTurn = function(e) {
      this.polyfillFunctions.push(e), this.schedulePolyfill();
    }, t.prototype.schedulePolyfill = function() {
      var e = this;
      if (!this.polyfillScheduled) {
        var r = function() {
          var o = e.polyfillFunctions;
          e.polyfillScheduled = !1, e.polyfillFunctions = [], o.forEach(function(n) {
            return n();
          });
        };
        this.polyfillScheduled = !0, this.getFrameworkOverrides().setTimeout(r, HE);
      }
    }, t = GE([
      te("resizeObserverService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var VE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, uv = (
  /** @class */
  function(i) {
    VE(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.createTasksP1 = { list: [], sorted: !1 }, e.createTasksP2 = { list: [], sorted: !1 }, e.destroyTasks = [], e.ticking = !1, e.scrollGoingDown = !0, e.lastPage = 0, e.lastScrollTop = 0, e.taskCount = 0, e.cancelledTasks = /* @__PURE__ */ new Set(), e;
    }
    return t.prototype.setScrollTop = function(e) {
      var r = this.gridOptionsService.is("pagination");
      if (this.scrollGoingDown = e >= this.lastScrollTop, r && e === 0) {
        var o = this.paginationProxy.getCurrentPage();
        o !== this.lastPage && (this.lastPage = o, this.scrollGoingDown = !0);
      }
      this.lastScrollTop = e;
    }, t.prototype.init = function() {
      this.useAnimationFrame = !this.gridOptionsService.is("suppressAnimationFrame");
    }, t.prototype.isOn = function() {
      return this.useAnimationFrame;
    }, t.prototype.verifyAnimationFrameOn = function(e) {
      this.useAnimationFrame === !1 && console.warn("AG Grid: AnimationFrameService." + e + " called but animation frames are off");
    }, t.prototype.createTask = function(e, r, o) {
      this.verifyAnimationFrameOn(o);
      var n = { task: e, index: r, createOrder: ++this.taskCount };
      this.addTaskToList(this[o], n), this.schedule();
    }, t.prototype.cancelTask = function(e) {
      this.cancelledTasks.add(e);
    }, t.prototype.addTaskToList = function(e, r) {
      e.list.push(r), e.sorted = !1;
    }, t.prototype.sortTaskList = function(e) {
      if (!e.sorted) {
        var r = this.scrollGoingDown ? 1 : -1;
        e.list.sort(function(o, n) {
          return o.index !== n.index ? r * (n.index - o.index) : n.createOrder - o.createOrder;
        }), e.sorted = !0;
      }
    }, t.prototype.addDestroyTask = function(e) {
      this.verifyAnimationFrameOn("createTasksP3"), this.destroyTasks.push(e), this.schedule();
    }, t.prototype.executeFrame = function(e) {
      this.verifyAnimationFrameOn("executeFrame");
      for (var r = this.createTasksP1, o = r.list, n = this.createTasksP2, s = n.list, a = this.destroyTasks, l = (/* @__PURE__ */ new Date()).getTime(), u = (/* @__PURE__ */ new Date()).getTime() - l, c = e <= 0, p = this.ctrlsService.getGridBodyCtrl(); c || u < e; ) {
        var d = p.getScrollFeature().scrollGridIfNeeded();
        if (!d) {
          var h = void 0;
          if (o.length)
            this.sortTaskList(r), h = o.pop().task;
          else if (s.length)
            this.sortTaskList(n), h = s.pop().task;
          else if (a.length)
            h = a.pop();
          else {
            this.cancelledTasks.clear();
            break;
          }
          this.cancelledTasks.has(h) || h();
        }
        u = (/* @__PURE__ */ new Date()).getTime() - l;
      }
      o.length || s.length || a.length ? this.requestFrame() : this.stopTicking();
    }, t.prototype.stopTicking = function() {
      this.ticking = !1;
    }, t.prototype.flushAllFrames = function() {
      this.useAnimationFrame && this.executeFrame(-1);
    }, t.prototype.schedule = function() {
      this.useAnimationFrame && (this.ticking || (this.ticking = !0, this.requestFrame()));
    }, t.prototype.requestFrame = function() {
      var e = this.executeFrame.bind(this, 60), r = this.gridOptionsService.getDocument(), o = r.defaultView || window;
      o.requestAnimationFrame ? o.requestAnimationFrame(e) : o.webkitRequestAnimationFrame ? o.webkitRequestAnimationFrame(e) : o.setTimeout(e, 0);
    }, t.prototype.isQueueEmpty = function() {
      return !this.ticking;
    }, t.prototype.debounce = function(e) {
      var r = this, o = !1;
      return function() {
        if (!r.isOn()) {
          r.getFrameworkOverrides().setTimeout(e, 0);
          return;
        }
        o || (o = !0, r.addDestroyTask(function() {
          o = !1, e();
        }));
      };
    }, Cs([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Cs([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Cs([
      U
    ], t.prototype, "init", null), t = Cs([
      te("animationFrameService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var BE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pi = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, cv = (
  /** @class */
  function(i) {
    BE(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.centerRowContainerCtrl = r.centerRowContainerCtrl;
      });
    }, t.prototype.getPreferredWidthForColumn = function(e, r) {
      var o = this.getHeaderCellForColumn(e);
      if (!o)
        return -1;
      var n = this.rowRenderer.getAllCellsForColumn(e);
      return r || n.push(o), this.addElementsToContainerAndGetWidth(n);
    }, t.prototype.getPreferredWidthForColumnGroup = function(e) {
      var r = this.getHeaderCellForColumn(e);
      return r ? this.addElementsToContainerAndGetWidth([r]) : -1;
    }, t.prototype.addElementsToContainerAndGetWidth = function(e) {
      var r = this, o = document.createElement("form");
      o.style.position = "fixed";
      var n = this.centerRowContainerCtrl.getContainerElement();
      n.appendChild(o), e.forEach(function(l) {
        return r.cloneItemIntoDummy(l, o);
      });
      var s = o.offsetWidth;
      n.removeChild(o);
      var a = this.getAutoSizePadding();
      return s + a;
    }, t.prototype.getAutoSizePadding = function() {
      var e = this.gridOptionsService.getNum("autoSizePadding");
      return e != null && e >= 0 ? e : 20;
    }, t.prototype.getHeaderCellForColumn = function(e) {
      var r = null;
      return this.ctrlsService.getHeaderRowContainerCtrls().forEach(function(o) {
        var n = o.getHtmlElementForColumnHeader(e);
        n != null && (r = n);
      }), r;
    }, t.prototype.cloneItemIntoDummy = function(e, r) {
      var o = e.cloneNode(!0);
      o.style.width = "", o.style.position = "static", o.style.left = "";
      var n = document.createElement("div"), s = n.classList, a = ["ag-header-cell", "ag-header-group-cell"].some(function(d) {
        return o.classList.contains(d);
      });
      a ? (s.add("ag-header", "ag-header-row"), n.style.position = "static") : s.add("ag-row");
      for (var l = e.parentElement; l; ) {
        var u = ["ag-header-row", "ag-row"].some(function(d) {
          return l.classList.contains(d);
        });
        if (u) {
          for (var c = 0; c < l.classList.length; c++) {
            var p = l.classList[c];
            p != "ag-row-position-absolute" && s.add(p);
          }
          break;
        }
        l = l.parentElement;
      }
      n.appendChild(o), r.appendChild(n);
    }, pi([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), pi([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), pi([
      v("rowCssClassCalculator")
    ], t.prototype, "rowCssClassCalculator", void 0), pi([
      U
    ], t.prototype, "postConstruct", null), t = pi([
      te("autoWidthCalculator")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var kE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ws = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, jE = function(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], r = 0;
  if (e)
    return e.call(i);
  if (i && typeof i.length == "number")
    return {
      next: function() {
        return i && r >= i.length && (i = void 0), { value: i && i[r++], done: !i };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, WE = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, UE = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(WE(arguments[t]));
  return i;
}, zE = (
  /** @class */
  function(i) {
    kE(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.createRowCon = e, o.destroyRowCtrls = r, o.stickyRowCtrls = [], o.containerHeight = 0, o;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.isClientSide = this.rowModel.getType() === "clientSide", this.ctrlsService.whenReady(function(r) {
        e.gridBodyCtrl = r.gridBodyCtrl;
      });
    }, t.prototype.getStickyRowCtrls = function() {
      return this.stickyRowCtrls;
    }, t.prototype.checkStickyRows = function() {
      var e = this, r = 0;
      if (!this.gridOptionsService.is("groupRowsSticky")) {
        this.refreshNodesAndContainerHeight([], r);
        return;
      }
      for (var o = [], n = this.rowRenderer.getFirstVisibleVerticalPixel(), s = function(h) {
        var g, y, S;
        o.push(h);
        var _;
        if (e.isClientSide) {
          for (var w = h; w.expanded; )
            if (w.master)
              w = w.detailNode;
            else if (w.childrenAfterSort) {
              if (w.childrenAfterSort.length === 0)
                break;
              w = Ne(w.childrenAfterSort);
            }
          _ = w.rowTop + w.rowHeight;
        } else {
          var E = (g = h.childStore) === null || g === void 0 ? void 0 : g.getStoreBounds();
          _ = ((y = E == null ? void 0 : E.heightPx) !== null && y !== void 0 ? y : 0) + ((S = E == null ? void 0 : E.topPx) !== null && S !== void 0 ? S : 0);
        }
        var R = n + r + h.rowHeight;
        _ < R ? h.stickyRowTop = r + (_ - R) : h.stickyRowTop = r, r = 0, o.forEach(function(D) {
          var B = D.stickyRowTop + D.rowHeight;
          r < B && (r = B);
        });
      }; ; ) {
        var a = n + r, l = this.rowModel.getRowIndexAtPixel(a), u = this.rowModel.getRow(l);
        if (u == null || u.level < 0)
          break;
        for (var c = [], p = u.parent; p.level >= 0; )
          c.push(p), p = p.parent;
        var d = c.reverse().find(function(h) {
          return o.indexOf(h) < 0 && h.displayed;
        });
        if (d) {
          s(d);
          continue;
        }
        if (u.isExpandable() && u.expanded && u.rowTop < a) {
          s(u);
          continue;
        }
        break;
      }
      this.refreshNodesAndContainerHeight(o, r);
    }, t.prototype.refreshStickyNode = function(e) {
      for (var r = [], o = 0; o < this.stickyRowCtrls.length; o++) {
        var n = this.stickyRowCtrls[o].getRowNode();
        n !== e && r.push(n);
      }
      this.refreshNodesAndContainerHeight(r, this.containerHeight), this.checkStickyRows();
    }, t.prototype.refreshNodesAndContainerHeight = function(e, r) {
      var o, n, s, a = this, l = this.stickyRowCtrls.filter(function(y) {
        return e.indexOf(y.getRowNode()) === -1;
      }), u = e.filter(function(y) {
        return a.stickyRowCtrls.findIndex(function(S) {
          return S.getRowNode() === y;
        }) === -1;
      }), c = {};
      l.forEach(function(y) {
        c[y.getRowNode().id] = y, a.stickyRowCtrls = a.stickyRowCtrls.filter(function(S) {
          return S !== y;
        });
      });
      try {
        for (var p = jE(Object.values(c)), d = p.next(); !d.done; d = p.next()) {
          var h = d.value;
          h.getRowNode().sticky = !1;
        }
      } catch (y) {
        o = { error: y };
      } finally {
        try {
          d && !d.done && (n = p.return) && n.call(p);
        } finally {
          if (o)
            throw o.error;
        }
      }
      this.destroyRowCtrls(c, !1);
      var g = u.map(function(y) {
        return y.sticky = !0, a.createRowCon(y, !1, !1);
      });
      (s = this.stickyRowCtrls).push.apply(s, UE(g)), this.stickyRowCtrls.forEach(function(y) {
        return y.setRowTop(y.getRowNode().stickyRowTop);
      }), this.stickyRowCtrls.sort(function(y, S) {
        return S.getRowNode().rowIndex - y.getRowNode().rowIndex;
      }), this.containerHeight !== r && (this.containerHeight = r, this.gridBodyCtrl.setStickyTopHeight(r));
    }, ws([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), ws([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), ws([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), ws([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var $E = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Fr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, KE = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, Dl = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(KE(arguments[t]));
  return i;
}, YE = function(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], r = 0;
  if (e)
    return e.call(i);
  if (i && typeof i.length == "number")
    return {
      next: function() {
        return i && r >= i.length && (i = void 0), { value: i && i[r++], done: !i };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qE = 10, pv = (
  /** @class */
  function(i) {
    $E(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.destroyFuncsForColumnListeners = [], e.rowCtrlsByRowIndex = {}, e.zombieRowCtrls = {}, e.allRowCtrls = [], e.topRowCtrls = [], e.bottomRowCtrls = [], e.refreshInProgress = !1, e.dataFirstRenderedFired = !1, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function() {
        e.gridBodyCtrl = e.ctrlsService.getGridBodyCtrl(), e.initialise();
      });
    }, t.prototype.initialise = function() {
      if (this.addManagedListener(this.eventService, m.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this)), this.addManagedListener(this.eventService, m.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_BODY_SCROLL, this.onBodyScroll.bind(this)), this.addManagedListener(this.eventService, m.EVENT_BODY_HEIGHT_CHANGED, this.redrawAfterScroll.bind(this)), this.addManagedPropertyListener("domLayout", this.onDomLayoutChanged.bind(this)), this.addManagedPropertyListener("rowClass", this.redrawRows.bind(this)), this.gridOptionsService.is("groupRowsSticky")) {
        var e = this.rowModel.getType();
        e != "clientSide" && e != "serverSide" ? Pe(function() {
          return console.warn("AG Grid: The feature Sticky Row Groups only works with the Client Side or Server Side Row Model");
        }, "rowRenderer.stickyWorksWithCsrmOnly") : this.stickyRowFeature = this.createManagedBean(new zE(this.createRowCon.bind(this), this.destroyRowCtrls.bind(this)));
      }
      this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = this.gridOptionsService.isDomLayout("print"), this.embedFullWidthRows = this.printLayout || this.gridOptionsService.is("embedFullWidthRows"), this.redrawAfterModelUpdate();
    }, t.prototype.initialiseCache = function() {
      if (this.gridOptionsService.is("keepDetailRows")) {
        var e = this.getKeepDetailRowsCount(), r = e ?? 3;
        this.cachedRowCtrls = new XE(r);
      }
    }, t.prototype.getKeepDetailRowsCount = function() {
      var e = this.gridOptionsService.getNum("keepDetailRowsCount");
      return k(e) && e > 0 ? e : qE;
    }, t.prototype.getRowCtrls = function() {
      return this.allRowCtrls;
    }, t.prototype.getStickyTopRowCtrls = function() {
      return this.stickyRowFeature ? this.stickyRowFeature.getStickyRowCtrls() : [];
    }, t.prototype.updateAllRowCtrls = function() {
      var e = io(this.rowCtrlsByRowIndex), r = this.gridOptionsService.is("ensureDomOrder"), o = this.gridOptionsService.isDomLayout("print");
      (r || o) && e.sort(function(a, l) {
        return a.getRowNode().rowIndex - l.getRowNode.rowIndex;
      });
      var n = io(this.zombieRowCtrls), s = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];
      this.allRowCtrls = Dl(e, n, s);
    }, t.prototype.onCellFocusChanged = function(e) {
      this.getAllCellCtrls().forEach(function(r) {
        return r.onCellFocused(e);
      }), this.getFullWidthRowCtrls().forEach(function(r) {
        return r.onFullWidthRowFocused(e);
      });
    }, t.prototype.registerCellEventListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_CELL_FOCUSED, function(o) {
        e.onCellFocusChanged(o);
      }), this.addManagedListener(this.eventService, m.EVENT_CELL_FOCUS_CLEARED, function() {
        e.onCellFocusChanged();
      }), this.addManagedListener(this.eventService, m.EVENT_FLASH_CELLS, function(o) {
        e.getAllCellCtrls().forEach(function(n) {
          return n.onFlashCells(o);
        });
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_HOVER_CHANGED, function() {
        e.getAllCellCtrls().forEach(function(o) {
          return o.onColumnHover();
        });
      }), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, function() {
        e.getAllCellCtrls().forEach(function(o) {
          return o.onDisplayedColumnsChanged();
        });
      }), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function() {
        e.printLayout && e.getAllCellCtrls().forEach(function(o) {
          return o.onLeftChanged();
        });
      });
      var r = this.gridOptionsService.isEnableRangeSelection();
      r && (this.addManagedListener(this.eventService, m.EVENT_RANGE_SELECTION_CHANGED, function() {
        e.getAllCellCtrls().forEach(function(o) {
          return o.onRangeSelectionChanged();
        });
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_MOVED, function() {
        e.getAllCellCtrls().forEach(function(o) {
          return o.updateRangeBordersIfRangeCount();
        });
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PINNED, function() {
        e.getAllCellCtrls().forEach(function(o) {
          return o.updateRangeBordersIfRangeCount();
        });
      }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_VISIBLE, function() {
        e.getAllCellCtrls().forEach(function(o) {
          return o.updateRangeBordersIfRangeCount();
        });
      })), this.refreshListenersToColumnsForCellComps(), this.addManagedListener(this.eventService, m.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this)), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }, t.prototype.removeGridColumnListeners = function() {
      this.destroyFuncsForColumnListeners.forEach(function(e) {
        return e();
      }), this.destroyFuncsForColumnListeners.length = 0;
    }, t.prototype.refreshListenersToColumnsForCellComps = function() {
      var e = this;
      this.removeGridColumnListeners();
      var r = this.columnModel.getAllGridColumns();
      r && r.forEach(function(o) {
        var n = function(p) {
          e.getAllCellCtrls().forEach(function(d) {
            d.getColumn() === o && p(d);
          });
        }, s = function() {
          n(function(p) {
            return p.onLeftChanged();
          });
        }, a = function() {
          n(function(p) {
            return p.onWidthChanged();
          });
        }, l = function() {
          n(function(p) {
            return p.onFirstRightPinnedChanged();
          });
        }, u = function() {
          n(function(p) {
            return p.onLastLeftPinnedChanged();
          });
        }, c = function() {
          n(function(p) {
            return p.onColDefChanged();
          });
        };
        o.addEventListener("leftChanged", s), o.addEventListener("widthChanged", a), o.addEventListener("firstRightPinnedChanged", l), o.addEventListener("lastLeftPinnedChanged", u), o.addEventListener("colDefChanged", c), e.destroyFuncsForColumnListeners.push(function() {
          o.removeEventListener("leftChanged", s), o.removeEventListener("widthChanged", a), o.removeEventListener("firstRightPinnedChanged", l), o.removeEventListener("lastLeftPinnedChanged", u), o.removeEventListener("colDefChanged", c);
        });
      });
    }, t.prototype.onDomLayoutChanged = function() {
      var e = this.gridOptionsService.isDomLayout("print"), r = e || this.gridOptionsService.is("embedFullWidthRows"), o = r !== this.embedFullWidthRows || this.printLayout !== e;
      this.printLayout = e, this.embedFullWidthRows = r, o && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
    }, t.prototype.datasourceChanged = function() {
      this.firstRenderedRow = 0, this.lastRenderedRow = -1;
      var e = Object.keys(this.rowCtrlsByRowIndex);
      this.removeRowCtrls(e);
    }, t.prototype.onPageLoaded = function(e) {
      var r = {
        recycleRows: e.keepRenderedRows,
        animate: e.animate,
        newData: e.newData,
        newPage: e.newPage,
        // because this is a model updated event (not pinned rows), we
        // can skip updating the pinned rows. this is needed so that if user
        // is doing transaction updates, the pinned rows are not getting constantly
        // trashed - or editing cells in pinned rows are not refreshed and put into read mode
        onlyBody: !0
      };
      this.redrawAfterModelUpdate(r);
    }, t.prototype.getAllCellsForColumn = function(e) {
      var r = [];
      return this.getAllRowCtrls().forEach(function(o) {
        var n = o.getCellElement(e);
        n && r.push(n);
      }), r;
    }, t.prototype.refreshFloatingRowComps = function() {
      this.refreshFloatingRows(this.topRowCtrls, this.pinnedRowModel.getPinnedTopRowData()), this.refreshFloatingRows(this.bottomRowCtrls, this.pinnedRowModel.getPinnedBottomRowData());
    }, t.prototype.getTopRowCtrls = function() {
      return this.topRowCtrls;
    }, t.prototype.getBottomRowCtrls = function() {
      return this.bottomRowCtrls;
    }, t.prototype.refreshFloatingRows = function(e, r) {
      var o = this;
      e.forEach(function(n) {
        n.destroyFirstPass(), n.destroySecondPass();
      }), e.length = 0, r && r.forEach(function(n) {
        var s = new Vo(n, o.beans, !1, !1, o.printLayout);
        e.push(s);
      });
    }, t.prototype.onPinnedRowDataChanged = function() {
      var e = {
        recycleRows: !0
      };
      this.redrawAfterModelUpdate(e);
    }, t.prototype.getRenderedIndexesForRowNodes = function(e) {
      var r = [];
      return ue(e) || Ke(this.rowCtrlsByRowIndex, function(o, n) {
        var s = n.getRowNode();
        e.indexOf(s) >= 0 && r.push(o);
      }), r;
    }, t.prototype.redrawRows = function(e) {
      var r = e != null && e.length > 0;
      if (r) {
        var o = this.getRenderedIndexesForRowNodes(e);
        this.removeRowCtrls(o);
      }
      this.redrawAfterModelUpdate({
        recycleRows: r
      });
    }, t.prototype.getCellToRestoreFocusToAfterRefresh = function(e) {
      var r = e != null && e.suppressKeepFocus ? null : this.focusService.getFocusCellToUseAfterRefresh();
      if (r == null)
        return null;
      var o = this.gridOptionsService.getDocument(), n = o.activeElement, s = this.gridOptionsService.getDomData(n, Ho.DOM_DATA_KEY_CELL_CTRL), a = this.gridOptionsService.getDomData(n, Vo.DOM_DATA_KEY_ROW_CTRL), l = s || a;
      return l ? r : null;
    }, t.prototype.redrawAfterModelUpdate = function(e) {
      e === void 0 && (e = {}), this.getLockOnRefresh();
      var r = this.getCellToRestoreFocusToAfterRefresh(e);
      this.updateContainerHeights(), this.scrollToTopIfNewData(e);
      var o = !e.domLayoutChanged && !!e.recycleRows, n = e.animate && this.gridOptionsService.isAnimateRows(), s = o ? this.recycleRows() : null;
      o || this.removeAllRowComps(), this.redraw(s, n), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(), this.dispatchDisplayedRowsChanged(), r != null && this.restoreFocusedCell(r), this.releaseLockOnRefresh();
    }, t.prototype.scrollToTopIfNewData = function(e) {
      var r = e.newData || e.newPage, o = this.gridOptionsService.is("suppressScrollOnNewData");
      r && !o && this.gridBodyCtrl.getScrollFeature().scrollToTop();
    }, t.prototype.updateContainerHeights = function() {
      if (this.printLayout) {
        this.rowContainerHeightService.setModelHeight(null);
        return;
      }
      var e = this.paginationProxy.getCurrentPageHeight();
      e === 0 && (e = 1), this.rowContainerHeightService.setModelHeight(e);
    }, t.prototype.getLockOnRefresh = function() {
      if (this.refreshInProgress)
        throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace.");
      this.refreshInProgress = !0;
    }, t.prototype.releaseLockOnRefresh = function() {
      this.refreshInProgress = !1;
    }, t.prototype.isRefreshInProgress = function() {
      return this.refreshInProgress;
    }, t.prototype.restoreFocusedCell = function(e) {
      e && this.onCellFocusChanged({
        rowIndex: e.rowIndex,
        column: e.column,
        rowPinned: e.rowPinned,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !0,
        api: this.beans.gridApi,
        columnApi: this.beans.columnApi,
        context: this.beans.gridOptionsService.context,
        type: "mock"
      });
    }, t.prototype.stopEditing = function(e) {
      e === void 0 && (e = !1), this.getAllRowCtrls().forEach(function(r) {
        r.stopEditing(e);
      });
    }, t.prototype.getAllCellCtrls = function() {
      for (var e = [], r = this.getAllRowCtrls(), o = r.length, n = 0; n < o; n++)
        for (var s = r[n].getAllCellCtrls(), a = s.length, l = 0; l < a; l++)
          e.push(s[l]);
      return e;
    }, t.prototype.getAllRowCtrls = function() {
      var e, r, o = this.stickyRowFeature && this.stickyRowFeature.getStickyRowCtrls() || [], n = Dl(this.topRowCtrls, this.bottomRowCtrls, o);
      try {
        for (var s = YE(Object.keys(this.rowCtrlsByRowIndex)), a = s.next(); !a.done; a = s.next()) {
          var l = a.value;
          n.push(this.rowCtrlsByRowIndex[l]);
        }
      } catch (u) {
        e = { error: u };
      } finally {
        try {
          a && !a.done && (r = s.return) && r.call(s);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return n;
    }, t.prototype.addRenderedRowListener = function(e, r, o) {
      var n = this.rowCtrlsByRowIndex[r];
      n && n.addEventListener(e, o);
    }, t.prototype.flashCells = function(e) {
      e === void 0 && (e = {});
      var r = e.flashDelay, o = e.fadeDelay;
      this.getCellCtrls(e.rowNodes, e.columns).forEach(function(n) {
        return n.flashCell({ flashDelay: r, fadeDelay: o });
      });
    }, t.prototype.refreshCells = function(e) {
      e === void 0 && (e = {});
      var r = {
        forceRefresh: e.force,
        newData: !1,
        suppressFlash: e.suppressFlash
      };
      this.getCellCtrls(e.rowNodes, e.columns).forEach(function(o) {
        if (o.refreshShouldDestroy()) {
          var n = o.getRowCtrl();
          n && n.refreshCell(o);
        } else
          o.refreshCell(r);
      }), this.getFullWidthRowCtrls(e.rowNodes).forEach(function(o) {
        o.refreshFullWidth();
      });
    }, t.prototype.getCellRendererInstances = function(e) {
      var r = this, o, n = this.getCellCtrls(e.rowNodes, e.columns).map(function(l) {
        return l.getCellRenderer();
      }).filter(function(l) {
        return l != null;
      });
      if (!((o = e.columns) === null || o === void 0) && o.length)
        return n;
      var s = [], a = this.mapRowNodes(e.rowNodes);
      return this.getAllRowCtrls().forEach(function(l) {
        if (!(a && !r.isRowInMap(l.getRowNode(), a)) && l.isFullWidth()) {
          var u = l.getFullWidthCellRenderer();
          u && s.push(u);
        }
      }), Dl(s, n);
    }, t.prototype.getCellEditorInstances = function(e) {
      var r = [];
      return this.getCellCtrls(e.rowNodes, e.columns).forEach(function(o) {
        var n = o.getCellEditor();
        n && r.push(n);
      }), r;
    }, t.prototype.getEditingCells = function() {
      var e = [];
      return this.getAllCellCtrls().forEach(function(r) {
        if (r.isEditing()) {
          var o = r.getCellPosition();
          e.push(o);
        }
      }), e;
    }, t.prototype.mapRowNodes = function(e) {
      if (e) {
        var r = {
          top: {},
          bottom: {},
          normal: {}
        };
        return e.forEach(function(o) {
          var n = o.id;
          o.rowPinned === "top" ? r.top[n] = o : o.rowPinned === "bottom" ? r.bottom[n] = o : r.normal[n] = o;
        }), r;
      }
    }, t.prototype.isRowInMap = function(e, r) {
      var o = e.id, n = e.rowPinned;
      return n === "bottom" ? r.bottom[o] != null : n === "top" ? r.top[o] != null : r.normal[o] != null;
    }, t.prototype.getCellCtrls = function(e, r) {
      var o = this, n = this.mapRowNodes(e), s = [], a;
      k(r) && (a = {}, r.forEach(function(u) {
        var c = o.columnModel.getGridColumn(u);
        k(c) && (a[c.getId()] = !0);
      }));
      var l = function(u) {
        var c = u.getRowNode();
        n != null && !o.isRowInMap(c, n) || u.getAllCellCtrls().forEach(function(p) {
          var d = p.getColumn().getId(), h = a && !a[d];
          h || s.push(p);
        });
      };
      return this.getAllRowCtrls().forEach(function(u) {
        return l(u);
      }), s;
    }, t.prototype.destroy = function() {
      this.removeAllRowComps(), i.prototype.destroy.call(this);
    }, t.prototype.removeAllRowComps = function() {
      var e = Object.keys(this.rowCtrlsByRowIndex);
      this.removeRowCtrls(e);
    }, t.prototype.recycleRows = function() {
      var e = [];
      Ke(this.rowCtrlsByRowIndex, function(o, n) {
        var s = n.getRowNode().id == null;
        s && e.push(o);
      }), this.removeRowCtrls(e);
      var r = {};
      return Ke(this.rowCtrlsByRowIndex, function(o, n) {
        var s = n.getRowNode();
        r[s.id] = n;
      }), this.rowCtrlsByRowIndex = {}, r;
    }, t.prototype.removeRowCtrls = function(e) {
      var r = this;
      e.forEach(function(o) {
        var n = r.rowCtrlsByRowIndex[o];
        n && (n.destroyFirstPass(), n.destroySecondPass()), delete r.rowCtrlsByRowIndex[o];
      });
    }, t.prototype.onBodyScroll = function(e) {
      e.direction === "vertical" && this.redrawAfterScroll();
    }, t.prototype.redrawAfterScroll = function() {
      var e;
      if (this.stickyRowFeature && Ta() && (e = this.getCellToRestoreFocusToAfterRefresh() || void 0), this.getLockOnRefresh(), this.redraw(null, !1, !0), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(!0), e != null) {
        var r = this.getCellToRestoreFocusToAfterRefresh();
        e != null && r == null && (this.animationFrameService.flushAllFrames(), this.restoreFocusedCell(e));
      }
    }, t.prototype.removeRowCompsNotToDraw = function(e) {
      var r = {};
      e.forEach(function(s) {
        return r[s] = !0;
      });
      var o = Object.keys(this.rowCtrlsByRowIndex), n = o.filter(function(s) {
        return !r[s];
      });
      this.removeRowCtrls(n);
    }, t.prototype.calculateIndexesToDraw = function(e) {
      var r = this, o = Uf(this.firstRenderedRow, this.lastRenderedRow), n = function(s, a) {
        var l = a.getRowNode().rowIndex;
        l != null && (l < r.firstRenderedRow || l > r.lastRenderedRow) && r.doNotUnVirtualiseRow(a) && o.push(l);
      };
      return Ke(this.rowCtrlsByRowIndex, n), Ke(e, n), o.sort(function(s, a) {
        return s - a;
      }), o = o.filter(function(s) {
        var a = r.paginationProxy.getRow(s);
        return a && !a.sticky;
      }), o;
    }, t.prototype.redraw = function(e, r, o) {
      var n = this;
      r === void 0 && (r = !1), o === void 0 && (o = !1), this.rowContainerHeightService.updateOffset(), this.workOutFirstAndLastRowsToRender(), this.stickyRowFeature && this.stickyRowFeature.checkStickyRows();
      var s = this.calculateIndexesToDraw(e);
      if (this.removeRowCompsNotToDraw(s), this.printLayout && (r = !1), s.forEach(function(l) {
        var u = n.createOrUpdateRowCtrl(l, e, r, o);
        k(u);
      }), e) {
        var a = o && !this.gridOptionsService.is("suppressAnimationFrame") && !this.printLayout;
        a ? this.beans.animationFrameService.addDestroyTask(function() {
          n.destroyRowCtrls(e, r), n.updateAllRowCtrls(), n.dispatchDisplayedRowsChanged();
        }) : this.destroyRowCtrls(e, r);
      }
      this.updateAllRowCtrls();
    }, t.prototype.dispatchDisplayedRowsChanged = function(e) {
      e === void 0 && (e = !1);
      var r = { type: m.EVENT_DISPLAYED_ROWS_CHANGED, afterScroll: e };
      this.eventService.dispatchEvent(r);
    }, t.prototype.onDisplayedColumnsChanged = function() {
      var e = this.columnModel.isPinningLeft(), r = this.columnModel.isPinningRight(), o = this.pinningLeft !== e || r !== this.pinningRight;
      o && (this.pinningLeft = e, this.pinningRight = r, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
    }, t.prototype.redrawFullWidthEmbeddedRows = function() {
      var e = [];
      this.getFullWidthRowCtrls().forEach(function(r) {
        var o = r.getRowNode().rowIndex;
        e.push(o.toString());
      }), this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redrawAfterScroll();
    }, t.prototype.getFullWidthRowCtrls = function(e) {
      var r = this, o = this.mapRowNodes(e);
      return this.getAllRowCtrls().filter(function(n) {
        if (!n.isFullWidth())
          return !1;
        var s = n.getRowNode();
        return !(o != null && !r.isRowInMap(s, o));
      });
    }, t.prototype.refreshFullWidthRow = function(e) {
      var r = this.getFullWidthRowCtrls().find(function(n) {
        return n.getRowNode() === e;
      });
      if (r) {
        var o = r.refreshFullWidth();
        o || (e.sticky ? this.stickyRowFeature.refreshStickyNode(e) : this.removeRowCtrls([e.rowIndex]), this.redrawAfterScroll());
      }
    }, t.prototype.createOrUpdateRowCtrl = function(e, r, o, n) {
      var s, a = this.rowCtrlsByRowIndex[e];
      a || (s = this.paginationProxy.getRow(e), k(s) && k(r) && r[s.id] && s.alreadyRendered && (a = r[s.id], r[s.id] = null));
      var l = !a;
      if (l)
        if (s || (s = this.paginationProxy.getRow(e)), k(s))
          a = this.createRowCon(s, o, n);
        else
          return;
      return s && (s.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = a, a;
    }, t.prototype.destroyRowCtrls = function(e, r) {
      var o = this, n = [];
      Ke(e, function(s, a) {
        if (a) {
          if (o.cachedRowCtrls && a.isCacheable()) {
            o.cachedRowCtrls.addRow(a);
            return;
          }
          a.destroyFirstPass(), r ? (o.zombieRowCtrls[a.getInstanceId()] = a, n.push(function() {
            a.destroySecondPass(), delete o.zombieRowCtrls[a.getInstanceId()];
          })) : a.destroySecondPass();
        }
      }), r && (n.push(function() {
        o.updateAllRowCtrls(), o.dispatchDisplayedRowsChanged();
      }), ef(n));
    }, t.prototype.getRowBuffer = function() {
      var e = this.gridOptionsService.getNum("rowBuffer");
      return typeof e == "number" ? e < 0 && (Pe(function() {
        return console.warn("AG Grid: rowBuffer should not be negative");
      }, "warn rowBuffer negative"), e = 0, this.gridOptionsService.set("rowBuffer", 0)) : e = 10, e;
    }, t.prototype.getRowBufferInPixels = function() {
      var e = this.getRowBuffer(), r = this.gridOptionsService.getRowHeightAsNumber();
      return e * r;
    }, t.prototype.workOutFirstAndLastRowsToRender = function() {
      var e, r;
      if (!this.paginationProxy.isRowsToRender())
        e = 0, r = -1;
      else if (this.printLayout)
        e = this.paginationProxy.getPageFirstRow(), r = this.paginationProxy.getPageLastRow();
      else {
        var o = this.getRowBufferInPixels(), n = this.ctrlsService.getGridBodyCtrl(), s = this.gridOptionsService.is("suppressRowVirtualisation"), a = !1, l = void 0, u = void 0;
        do {
          var c = this.paginationProxy.getPixelOffset(), p = this.paginationProxy.getCurrentPagePixelRange(), d = p.pageFirstPixel, h = p.pageLastPixel, g = this.rowContainerHeightService.getDivStretchOffset(), y = n.getScrollFeature().getVScrollPosition(), S = y.top, _ = y.bottom;
          s ? (l = d + g, u = h + g) : (l = Math.max(S + c - o, d) + g, u = Math.min(_ + c + o, h) + g), this.firstVisibleVPixel = Math.max(S + c, d) + g, a = this.ensureAllRowsInRangeHaveHeightsCalculated(l, u);
        } while (a);
        var w = this.paginationProxy.getRowIndexAtPixel(l), E = this.paginationProxy.getRowIndexAtPixel(u), R = this.paginationProxy.getPageFirstRow(), D = this.paginationProxy.getPageLastRow();
        w < R && (w = R), E > D && (E = D), e = w, r = E;
      }
      var B = this.gridOptionsService.isDomLayout("normal"), H = this.gridOptionsService.is("suppressMaxRenderedRowRestriction"), A = Math.max(this.getRowBuffer(), 500);
      B && !H && r - e > A && (r = e + A);
      var N = e !== this.firstRenderedRow, G = r !== this.lastRenderedRow;
      if (N || G) {
        this.firstRenderedRow = e, this.lastRenderedRow = r;
        var W = {
          type: m.EVENT_VIEWPORT_CHANGED,
          firstRow: e,
          lastRow: r
        };
        this.eventService.dispatchEvent(W);
      }
    }, t.prototype.dispatchFirstDataRenderedEvent = function() {
      var e = this;
      if (!this.dataFirstRenderedFired) {
        this.dataFirstRenderedFired = !0;
        var r = {
          type: m.EVENT_FIRST_DATA_RENDERED,
          firstRow: this.firstRenderedRow,
          lastRow: this.lastRenderedRow
        };
        window.requestAnimationFrame(function() {
          e.beans.eventService.dispatchEvent(r);
        });
      }
    }, t.prototype.ensureAllRowsInRangeHaveHeightsCalculated = function(e, r) {
      var o = this.paginationProxy.ensureRowHeightsValid(e, r, -1, -1);
      return o && this.updateContainerHeights(), o;
    }, t.prototype.getFirstVisibleVerticalPixel = function() {
      return this.firstVisibleVPixel;
    }, t.prototype.getFirstVirtualRenderedRow = function() {
      return this.firstRenderedRow;
    }, t.prototype.getLastVirtualRenderedRow = function() {
      return this.lastRenderedRow;
    }, t.prototype.doNotUnVirtualiseRow = function(e) {
      var r = !1, o = !0, n = e.getRowNode(), s = this.focusService.isRowNodeFocused(n), a = e.isEditing(), l = n.detail, u = s || a || l;
      if (!u)
        return r;
      var c = this.paginationProxy.isRowPresent(n);
      return c ? o : r;
    }, t.prototype.createRowCon = function(e, r, o) {
      var n = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(e) : null;
      if (n)
        return n;
      var s = this.gridOptionsService.is("suppressAnimationFrame"), a = o && !s && !this.printLayout, l = new Vo(e, this.beans, r, a, this.printLayout);
      return l;
    }, t.prototype.getRenderedNodes = function() {
      var e = this.rowCtrlsByRowIndex;
      return Object.keys(e).map(function(r) {
        return e[r].getRowNode();
      });
    }, t.prototype.getRowByPosition = function(e) {
      var r, o = e.rowIndex;
      switch (e.rowPinned) {
        case "top":
          r = this.topRowCtrls[o];
          break;
        case "bottom":
          r = this.bottomRowCtrls[o];
          break;
        default:
          r = this.rowCtrlsByRowIndex[o], r || (r = this.getStickyTopRowCtrls().find(function(n) {
            return n.getRowNode().rowIndex === o;
          }) || null);
          break;
      }
      return r;
    }, t.prototype.getRowNode = function(e) {
      switch (e.rowPinned) {
        case "top":
          return this.pinnedRowModel.getPinnedTopRowData()[e.rowIndex];
        case "bottom":
          return this.pinnedRowModel.getPinnedBottomRowData()[e.rowIndex];
        default:
          return this.rowModel.getRow(e.rowIndex);
      }
    }, t.prototype.isRangeInRenderedViewport = function(e, r) {
      var o = e == null || r == null;
      if (o)
        return !1;
      var n = e > this.lastRenderedRow, s = r < this.firstRenderedRow, a = !s && !n;
      return a;
    }, Fr([
      v("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), Fr([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Fr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Fr([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Fr([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Fr([
      v("focusService")
    ], t.prototype, "focusService", void 0), Fr([
      v("beans")
    ], t.prototype, "beans", void 0), Fr([
      v("rowContainerHeightService")
    ], t.prototype, "rowContainerHeightService", void 0), Fr([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Fr([
      U
    ], t.prototype, "postConstruct", null), t = Fr([
      te("rowRenderer")
    ], t), t;
  }(j)
), XE = (
  /** @class */
  function() {
    function i(t) {
      this.entriesMap = {}, this.entriesList = [], this.maxCount = t;
    }
    return i.prototype.addRow = function(t) {
      if (this.entriesMap[t.getRowNode().id] = t, this.entriesList.push(t), t.setCached(!0), this.entriesList.length > this.maxCount) {
        var e = this.entriesList[0];
        e.destroyFirstPass(), e.destroySecondPass(), this.removeFromCache(e);
      }
    }, i.prototype.getRow = function(t) {
      if (t == null || t.id == null)
        return null;
      var e = this.entriesMap[t.id];
      if (!e)
        return null;
      this.removeFromCache(e), e.setCached(!1);
      var r = e.getRowNode() != t;
      return r ? null : e;
    }, i.prototype.removeFromCache = function(t) {
      var e = t.getRowNode().id;
      delete this.entriesMap[e], Vt(this.entriesList, t);
    }, i.prototype.getEntries = function() {
      return this.entriesList;
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var QE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), td = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, dv = (
  /** @class */
  function(i) {
    QE(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.formatValue = function(e, r, o, n, s) {
      s === void 0 && (s = !0);
      var a = null, l, u = e.getColDef();
      if (n ? l = n : s && (l = u.valueFormatter), l) {
        var c = {
          value: o,
          node: r,
          data: r ? r.data : null,
          colDef: u,
          column: e,
          api: this.gridOptionsService.api,
          columnApi: this.gridOptionsService.columnApi,
          context: this.gridOptionsService.context
        };
        typeof l == "function" ? a = l(c) : a = this.expressionService.evaluate(l, c);
      } else if (u.refData)
        return u.refData[o] || "";
      return a == null && Array.isArray(o) && (a = o.join(", ")), a;
    }, td([
      v("expressionService")
    ], t.prototype, "expressionService", void 0), t = td([
      te("valueFormatterService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var JE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Al = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, fv = (
  /** @class */
  function(i) {
    JE(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      this.setPinnedTopRowData(this.gridOptionsService.get("pinnedTopRowData")), this.setPinnedBottomRowData(this.gridOptionsService.get("pinnedBottomRowData"));
    }, t.prototype.isEmpty = function(e) {
      var r = e === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
      return cr(r);
    }, t.prototype.isRowsToRender = function(e) {
      return !this.isEmpty(e);
    }, t.prototype.getRowAtPixel = function(e, r) {
      var o = r === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
      if (cr(o))
        return 0;
      for (var n = 0; n < o.length; n++) {
        var s = o[n], a = s.rowTop + s.rowHeight - 1;
        if (a >= e)
          return n;
      }
      return o.length - 1;
    }, t.prototype.setPinnedTopRowData = function(e) {
      this.pinnedTopRows = this.createNodesFromData(e, !0);
      var r = {
        type: m.EVENT_PINNED_ROW_DATA_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.setPinnedBottomRowData = function(e) {
      this.pinnedBottomRows = this.createNodesFromData(e, !1);
      var r = {
        type: m.EVENT_PINNED_ROW_DATA_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.createNodesFromData = function(e, r) {
      var o = this, n = [];
      if (e) {
        var s = 0;
        e.forEach(function(a, l) {
          var u = new ye(o.beans);
          u.data = a;
          var c = r ? ye.ID_PREFIX_TOP_PINNED : ye.ID_PREFIX_BOTTOM_PINNED;
          u.id = c + l, u.rowPinned = r ? "top" : "bottom", u.setRowTop(s), u.setRowHeight(o.gridOptionsService.getRowHeightForNode(u).height), u.setRowIndex(l), s += u.rowHeight, n.push(u);
        });
      }
      return n;
    }, t.prototype.getPinnedTopRowData = function() {
      return this.pinnedTopRows;
    }, t.prototype.getPinnedBottomRowData = function() {
      return this.pinnedBottomRows;
    }, t.prototype.getPinnedTopTotalHeight = function() {
      return this.getTotalHeight(this.pinnedTopRows);
    }, t.prototype.getPinnedTopRowCount = function() {
      return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
    }, t.prototype.getPinnedBottomRowCount = function() {
      return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
    }, t.prototype.getPinnedTopRow = function(e) {
      return this.pinnedTopRows[e];
    }, t.prototype.getPinnedBottomRow = function(e) {
      return this.pinnedBottomRows[e];
    }, t.prototype.forEachPinnedTopRow = function(e) {
      cr(this.pinnedTopRows) || this.pinnedTopRows.forEach(e);
    }, t.prototype.forEachPinnedBottomRow = function(e) {
      cr(this.pinnedBottomRows) || this.pinnedBottomRows.forEach(e);
    }, t.prototype.getPinnedBottomTotalHeight = function() {
      return this.getTotalHeight(this.pinnedBottomRows);
    }, t.prototype.getTotalHeight = function(e) {
      if (!e || e.length === 0)
        return 0;
      var r = Ne(e);
      return r.rowTop + r.rowHeight;
    }, Al([
      v("beans")
    ], t.prototype, "beans", void 0), Al([
      U
    ], t.prototype, "init", null), t = Al([
      te("pinnedRowModel")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var mu;
(function(i) {
  i.Applied = "Applied", i.StoreNotFound = "StoreNotFound", i.StoreLoading = "StoreLoading", i.StoreWaitingToLoad = "StoreWaitingToLoad", i.StoreLoadingFailed = "StoreLoadingFailed", i.StoreWrongType = "StoreWrongType", i.Cancelled = "Cancelled";
})(mu || (mu = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Na = (
  /** @class */
  function() {
    function i(t, e) {
      this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = t, this.pathRoot = {
        rowNode: e,
        children: null
      }, this.mapToItems[e.id] = this.pathRoot;
    }
    return i.prototype.setInactive = function() {
      this.active = !1;
    }, i.prototype.isActive = function() {
      return this.active;
    }, i.prototype.depthFirstSearchChangedPath = function(t, e) {
      if (t.children)
        for (var r = 0; r < t.children.length; r++)
          this.depthFirstSearchChangedPath(t.children[r], e);
      e(t.rowNode);
    }, i.prototype.depthFirstSearchEverything = function(t, e, r) {
      if (t.childrenAfterGroup)
        for (var o = 0; o < t.childrenAfterGroup.length; o++) {
          var n = t.childrenAfterGroup[o];
          n.childrenAfterGroup ? this.depthFirstSearchEverything(t.childrenAfterGroup[o], e, r) : r && e(n);
        }
      e(t);
    }, i.prototype.forEachChangedNodeDepthFirst = function(t, e, r) {
      e === void 0 && (e = !1), r === void 0 && (r = !1), this.active && !r ? this.depthFirstSearchChangedPath(this.pathRoot, t) : this.depthFirstSearchEverything(this.pathRoot.rowNode, t, e);
    }, i.prototype.executeFromRootNode = function(t) {
      t(this.pathRoot.rowNode);
    }, i.prototype.createPathItems = function(t) {
      for (var e = t, r = 0; !this.mapToItems[e.id]; ) {
        var o = {
          rowNode: e,
          children: null
        };
        this.mapToItems[e.id] = o, r++, e = e.parent;
      }
      return r;
    }, i.prototype.populateColumnsMap = function(t, e) {
      var r = this;
      if (!(!this.keepingColumns || !e))
        for (var o = t; o; )
          this.nodeIdsToColumns[o.id] || (this.nodeIdsToColumns[o.id] = {}), e.forEach(function(n) {
            return r.nodeIdsToColumns[o.id][n.getId()] = !0;
          }), o = o.parent;
    }, i.prototype.linkPathItems = function(t, e) {
      for (var r = t, o = 0; o < e; o++) {
        var n = this.mapToItems[r.id], s = this.mapToItems[r.parent.id];
        s.children || (s.children = []), s.children.push(n), r = r.parent;
      }
    }, i.prototype.addParentNode = function(t, e) {
      if (!(!t || t.isRowPinned())) {
        var r = this.createPathItems(t);
        this.linkPathItems(t, r), this.populateColumnsMap(t, e);
      }
    }, i.prototype.canSkip = function(t) {
      return this.active && !this.mapToItems[t.id];
    }, i.prototype.getValueColumnsForNode = function(t, e) {
      if (!this.keepingColumns)
        return e;
      var r = this.nodeIdsToColumns[t.id], o = e.filter(function(n) {
        return r[n.getId()];
      });
      return o;
    }, i.prototype.getNotValueColumnsForNode = function(t, e) {
      if (!this.keepingColumns)
        return null;
      var r = this.nodeIdsToColumns[t.id], o = e.filter(function(n) {
        return !r[n.getId()];
      });
      return o;
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ZE = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), aa = (
  /** @class */
  function(i) {
    ZE(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.state = t.STATE_WAITING_TO_LOAD, r.version = 0, r.id = e, r;
    }
    return t.prototype.getId = function() {
      return this.id;
    }, t.prototype.load = function() {
      this.state = t.STATE_LOADING, this.loadFromDatasource();
    }, t.prototype.getVersion = function() {
      return this.version;
    }, t.prototype.setStateWaitingToLoad = function() {
      this.version++, this.state = t.STATE_WAITING_TO_LOAD;
    }, t.prototype.getState = function() {
      return this.state;
    }, t.prototype.pageLoadFailed = function(e) {
      var r = this.isRequestMostRecentAndLive(e);
      r && (this.state = t.STATE_FAILED, this.processServerFail()), this.dispatchLoadCompleted(!1);
    }, t.prototype.success = function(e, r) {
      this.successCommon(e, r);
    }, t.prototype.pageLoaded = function(e, r, o) {
      this.successCommon(e, { rowData: r, rowCount: o });
    }, t.prototype.isRequestMostRecentAndLive = function(e) {
      var r = e === this.version, o = this.isAlive();
      return r && o;
    }, t.prototype.successCommon = function(e, r) {
      this.dispatchLoadCompleted();
      var o = this.isRequestMostRecentAndLive(e);
      o && (this.state = t.STATE_LOADED, this.processServerResult(r));
    }, t.prototype.dispatchLoadCompleted = function(e) {
      e === void 0 && (e = !0);
      var r = {
        type: t.EVENT_LOAD_COMPLETE,
        success: e,
        block: this
      };
      this.dispatchEvent(r);
    }, t.EVENT_LOAD_COMPLETE = "loadComplete", t.STATE_WAITING_TO_LOAD = "needsLoading", t.STATE_LOADING = "loading", t.STATE_LOADED = "loaded", t.STATE_FAILED = "failed", t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var eR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ss = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, tR = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, hv = (
  /** @class */
  function(i) {
    eR(t, i);
    function t() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.activeBlockLoadsCount = 0, r.blocks = [], r.active = !0, r;
    }
    e = t, t.prototype.postConstruct = function() {
      this.maxConcurrentRequests = this.getMaxConcurrentDatasourceRequests();
      var r = this.gridOptionsService.getNum("blockLoadDebounceMillis");
      r && r > 0 && (this.checkBlockToLoadDebounce = le.debounce(this.performCheckBlocksToLoad.bind(this), r));
    }, t.prototype.setBeans = function(r) {
      this.logger = r.create("RowNodeBlockLoader");
    }, t.prototype.getMaxConcurrentDatasourceRequests = function() {
      var r = this.gridOptionsService.getNum("maxConcurrentDatasourceRequests");
      if (r == null)
        return 2;
      if (!(r <= 0))
        return r;
    }, t.prototype.addBlock = function(r) {
      this.blocks.push(r), r.addEventListener(aa.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this)), this.checkBlockToLoad();
    }, t.prototype.removeBlock = function(r) {
      le.removeFromArray(this.blocks, r);
    }, t.prototype.destroy = function() {
      i.prototype.destroy.call(this), this.active = !1;
    }, t.prototype.loadComplete = function() {
      this.activeBlockLoadsCount--, this.checkBlockToLoad(), this.dispatchEvent({ type: e.BLOCK_LOADED_EVENT }), this.activeBlockLoadsCount == 0 && this.dispatchEvent({ type: e.BLOCK_LOADER_FINISHED_EVENT });
    }, t.prototype.checkBlockToLoad = function() {
      this.checkBlockToLoadDebounce ? this.checkBlockToLoadDebounce() : this.performCheckBlocksToLoad();
    }, t.prototype.performCheckBlocksToLoad = function() {
      if (this.active) {
        if (this.printCacheStatus(), this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
          this.logger.log("checkBlockToLoad: max loads exceeded");
          return;
        }
        var r = this.getAvailableLoadingCount(), o = this.blocks.filter(function(n) {
          return n.getState() === aa.STATE_WAITING_TO_LOAD;
        }).slice(0, r);
        this.registerLoads(o.length), o.forEach(function(n) {
          return n.load();
        }), this.printCacheStatus();
      }
    }, t.prototype.getBlockState = function() {
      if (this.gridOptionsService.isRowModelType("serverSide")) {
        var r = this.rowModel;
        return r.getBlockStates();
      }
      var o = {};
      return this.blocks.forEach(function(n) {
        var s = n.getBlockStateJson(), a = s.id, l = s.state;
        o[a] = l;
      }), o;
    }, t.prototype.printCacheStatus = function() {
      this.logger.isLogging() && this.logger.log("printCacheStatus: activePageLoadsCount = " + this.activeBlockLoadsCount + "," + (" blocks = " + JSON.stringify(this.getBlockState())));
    }, t.prototype.isLoading = function() {
      return this.activeBlockLoadsCount > 0;
    }, t.prototype.registerLoads = function(r) {
      this.activeBlockLoadsCount += r;
    }, t.prototype.getAvailableLoadingCount = function() {
      return this.maxConcurrentRequests !== void 0 ? this.maxConcurrentRequests - this.activeBlockLoadsCount : void 0;
    };
    var e;
    return t.BLOCK_LOADED_EVENT = "blockLoaded", t.BLOCK_LOADER_FINISHED_EVENT = "blockLoaderFinished", Ss([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Ss([
      U
    ], t.prototype, "postConstruct", null), Ss([
      tR(0, Bt("loggerFactory"))
    ], t.prototype, "setBeans", null), t = e = Ss([
      te("rowNodeBlockLoader")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var rR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, vv = (
  /** @class */
  function(i) {
    rR(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.currentPage = 0, e.topDisplayedRowIndex = 0, e.bottomDisplayedRowIndex = 0, e.pixelOffset = 0, e.masterRowCount = 0, e;
    }
    return t.prototype.postConstruct = function() {
      this.active = this.gridOptionsService.is("pagination"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedListener(this.eventService, m.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this)), this.addManagedPropertyListener("pagination", this.onPaginationPageSizeChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPaginationPageSizeChanged.bind(this)), this.onModelUpdated();
    }, t.prototype.ensureRowHeightsValid = function(e, r, o, n) {
      var s = this.rowModel.ensureRowHeightsValid(e, r, this.getPageFirstRow(), this.getPageLastRow());
      return s && this.calculatePages(), s;
    }, t.prototype.isPaginateChildRows = function() {
      var e = this.gridOptionsService.is("groupRemoveSingleChildren") || this.gridOptionsService.is("groupRemoveLowestSingleChildren");
      return e ? !0 : this.gridOptionsService.is("paginateChildRows");
    }, t.prototype.onModelUpdated = function(e) {
      this.calculatePages();
      var r = {
        type: m.EVENT_PAGINATION_CHANGED,
        animate: e ? e.animate : !1,
        newData: e ? e.newData : !1,
        newPage: e ? e.newPage : !1,
        keepRenderedRows: e ? e.keepRenderedRows : !1
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.onPaginationPageSizeChanged = function() {
      this.active = this.gridOptionsService.is("pagination"), this.calculatePages();
      var e = {
        type: m.EVENT_PAGINATION_CHANGED,
        animate: !1,
        newData: !1,
        newPage: !1,
        // important to keep rendered rows, otherwise every time grid is resized,
        // we would destroy all the rows.
        keepRenderedRows: !0
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.goToPage = function(e) {
      if (!(!this.active || this.currentPage === e || typeof this.currentPage != "number")) {
        this.currentPage = e;
        var r = {
          type: m.EVENT_MODEL_UPDATED,
          animate: !1,
          keepRenderedRows: !1,
          newData: !1,
          newPage: !0
        };
        this.onModelUpdated(r);
      }
    }, t.prototype.getPixelOffset = function() {
      return this.pixelOffset;
    }, t.prototype.getRow = function(e) {
      return this.rowModel.getRow(e);
    }, t.prototype.getRowNode = function(e) {
      return this.rowModel.getRowNode(e);
    }, t.prototype.getRowIndexAtPixel = function(e) {
      return this.rowModel.getRowIndexAtPixel(e);
    }, t.prototype.getCurrentPageHeight = function() {
      return ue(this.topRowBounds) || ue(this.bottomRowBounds) ? 0 : Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
    }, t.prototype.getCurrentPagePixelRange = function() {
      var e = this.topRowBounds ? this.topRowBounds.rowTop : 0, r = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
      return { pageFirstPixel: e, pageLastPixel: r };
    }, t.prototype.isRowPresent = function(e) {
      if (!this.rowModel.isRowPresent(e))
        return !1;
      var r = e.rowIndex >= this.topDisplayedRowIndex && e.rowIndex <= this.bottomDisplayedRowIndex;
      return r;
    }, t.prototype.isEmpty = function() {
      return this.rowModel.isEmpty();
    }, t.prototype.isRowsToRender = function() {
      return this.rowModel.isRowsToRender();
    }, t.prototype.forEachNode = function(e) {
      return this.rowModel.forEachNode(e);
    }, t.prototype.forEachNodeOnPage = function(e) {
      for (var r = this.getPageFirstRow(), o = this.getPageLastRow(), n = r; n <= o; n++) {
        var s = this.getRow(n);
        s && e(s);
      }
    }, t.prototype.getType = function() {
      return this.rowModel.getType();
    }, t.prototype.getRowBounds = function(e) {
      var r = this.rowModel.getRowBounds(e);
      return r.rowIndex = e, r;
    }, t.prototype.getPageFirstRow = function() {
      return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
    }, t.prototype.getPageLastRow = function() {
      return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
    }, t.prototype.getRowCount = function() {
      return this.rowModel.getRowCount();
    }, t.prototype.getPageForIndex = function(e) {
      return Math.floor(e / this.pageSize);
    }, t.prototype.goToPageWithIndex = function(e) {
      if (this.active) {
        var r = this.getPageForIndex(e);
        this.goToPage(r);
      }
    }, t.prototype.isRowInPage = function(e) {
      if (!this.active)
        return !0;
      var r = this.getPageForIndex(e.rowIndex);
      return r === this.currentPage;
    }, t.prototype.isLastPageFound = function() {
      return this.rowModel.isLastRowIndexKnown();
    }, t.prototype.getCurrentPage = function() {
      return this.currentPage;
    }, t.prototype.goToNextPage = function() {
      this.goToPage(this.currentPage + 1);
    }, t.prototype.goToPreviousPage = function() {
      this.goToPage(this.currentPage - 1);
    }, t.prototype.goToFirstPage = function() {
      this.goToPage(0);
    }, t.prototype.goToLastPage = function() {
      var e = this.rowModel.getRowCount(), r = Math.floor(e / this.pageSize);
      this.goToPage(r);
    }, t.prototype.getPageSize = function() {
      return this.pageSize;
    }, t.prototype.getTotalPages = function() {
      return this.totalPages;
    }, t.prototype.setPageSize = function() {
      this.pageSize = this.gridOptionsService.getNum("paginationPageSize"), (this.pageSize == null || this.pageSize < 1) && (this.pageSize = 100);
    }, t.prototype.calculatePages = function() {
      this.active ? (this.setPageSize(), this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly()) : this.calculatedPagesNotActive(), this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex), this.topRowBounds && (this.topRowBounds.rowIndex = this.topDisplayedRowIndex), this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex), this.bottomRowBounds && (this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex), this.setPixelOffset(k(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
    }, t.prototype.setPixelOffset = function(e) {
      this.pixelOffset !== e && (this.pixelOffset = e, this.eventService.dispatchEvent({ type: m.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED }));
    }, t.prototype.setZeroRows = function() {
      this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
    }, t.prototype.adjustCurrentPageIfInvalid = function() {
      this.currentPage >= this.totalPages && (this.currentPage = this.totalPages - 1), (!isFinite(this.currentPage) || isNaN(this.currentPage) || this.currentPage < 0) && (this.currentPage = 0);
    }, t.prototype.calculatePagesMasterRowsOnly = function() {
      if (this.masterRowCount = this.rowModel.getTopLevelRowCount(), this.masterRowCount <= 0) {
        this.setZeroRows();
        return;
      }
      var e = this.masterRowCount - 1;
      this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid();
      var r = this.pageSize * this.currentPage, o = this.pageSize * (this.currentPage + 1) - 1;
      if (o > e && (o = e), this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(r), o === e)
        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
      else {
        var n = this.rowModel.getTopLevelRowDisplayedIndex(o + 1);
        this.bottomDisplayedRowIndex = n - 1;
      }
    }, t.prototype.getMasterRowCount = function() {
      return this.masterRowCount;
    }, t.prototype.calculatePagesAllRows = function() {
      if (this.masterRowCount = this.rowModel.getRowCount(), this.masterRowCount === 0) {
        this.setZeroRows();
        return;
      }
      var e = this.masterRowCount - 1;
      this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = this.pageSize * this.currentPage, this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1, this.bottomDisplayedRowIndex > e && (this.bottomDisplayedRowIndex = e);
    }, t.prototype.calculatedPagesNotActive = function() {
      this.pageSize = this.rowModel.getRowCount(), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    }, xl([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), xl([
      U
    ], t.prototype, "postConstruct", null), t = xl([
      te("paginationProxy")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var oR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rd = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, gv = (
  /** @class */
  function(i) {
    oR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.processAllCellClasses = function(e, r, o, n) {
      this.processClassRules(e.cellClassRules, r, o, n), this.processStaticCellClasses(e, r, o);
    }, t.prototype.processClassRules = function(e, r, o, n) {
      if (e != null) {
        for (var s = Object.keys(e), a = {}, l = {}, u = function(d) {
          var h = s[d], g = e[h], y;
          typeof g == "string" ? y = c.expressionService.evaluate(g, r) : typeof g == "function" && (y = g(r)), h.split(" ").forEach(function(S) {
            S == null || S.trim() == "" || (y ? a[S] = !0 : l[S] = !0);
          });
        }, c = this, p = 0; p < s.length; p++)
          u(p);
        n && Object.keys(l).forEach(n), Object.keys(a).forEach(o);
      }
    }, t.prototype.getStaticCellClasses = function(e, r) {
      var o = e.cellClass;
      if (!o)
        return [];
      var n;
      if (typeof o == "function") {
        var s = o;
        n = s(r);
      } else
        n = o;
      return typeof n == "string" && (n = [n]), n || [];
    }, t.prototype.processStaticCellClasses = function(e, r, o) {
      var n = this.getStaticCellClasses(e, r);
      n.forEach(function(s) {
        o(s);
      });
    }, rd([
      v("expressionService")
    ], t.prototype, "expressionService", void 0), t = rd([
      te("stylingService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var nR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), yv = (
  /** @class */
  function(i) {
    nR(t, i);
    function t(e) {
      return i.call(this, e, "ag-toggle-button") || this;
    }
    return t.prototype.setValue = function(e, r) {
      return i.prototype.setValue.call(this, e, r), this.addOrRemoveCssClass("ag-selected", this.getValue()), this;
    }, t;
  }(Yn)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var iR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), mv = (
  /** @class */
  function(i) {
    iR(t, i);
    function t(e) {
      return i.call(this, e, "ag-text-area", null, "textarea") || this;
    }
    return t.prototype.setValue = function(e, r) {
      var o = i.prototype.setValue.call(this, e, r);
      return this.eInput.value = e, o;
    }, t.prototype.setCols = function(e) {
      return this.eInput.cols = e, this;
    }, t.prototype.setRows = function(e) {
      return this.eInput.rows = e, this;
    }, t;
  }(vo)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var sR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cv = (
  /** @class */
  function(i) {
    sR(t, i);
    function t(e) {
      return i.call(this, e, "ag-range-field", "range") || this;
    }
    return t.prototype.postConstruct = function() {
      i.prototype.postConstruct.call(this);
      var e = this.config, r = e.min, o = e.max, n = e.step;
      r != null && this.setMinValue(r), o != null && this.setMaxValue(o), this.setStep(n || 1);
    }, t.prototype.addInputListeners = function() {
      var e = this;
      this.addManagedListener(this.eInput, "input", function(r) {
        var o = r.target.value;
        e.setValue(o);
      });
    }, t.prototype.setMinValue = function(e) {
      return this.min = e, this.eInput.setAttribute("min", e.toString()), this;
    }, t.prototype.setMaxValue = function(e) {
      return this.max = e, this.eInput.setAttribute("max", e.toString()), this;
    }, t.prototype.setStep = function(e) {
      return this.eInput.setAttribute("step", e.toString()), this;
    }, t.prototype.setValue = function(e, r) {
      this.min != null && (e = Math.max(parseFloat(e), this.min).toString()), this.max != null && (e = Math.min(parseFloat(e), this.max).toString());
      var o = i.prototype.setValue.call(this, e, r);
      return this.eInput.value = e, o;
    }, t;
  }(vo)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var aR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), _s = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, wv = (
  /** @class */
  function(i) {
    aR(t, i);
    function t(e) {
      var r = i.call(this, e, t.TEMPLATE) || this;
      return r.labelAlignment = "top", r;
    }
    return t.prototype.init = function() {
      this.eSlider.addCssClass("ag-slider-field");
    }, t.prototype.onValueChange = function(e) {
      var r = this, o = hn.EVENT_CHANGED;
      return this.addManagedListener(this.eText, o, function() {
        var n = parseFloat(r.eText.getValue());
        r.eSlider.setValue(n.toString(), !0), e(n || 0);
      }), this.addManagedListener(this.eSlider, o, function() {
        var n = r.eSlider.getValue();
        r.eText.setValue(n, !0), e(parseFloat(n));
      }), this;
    }, t.prototype.setSliderWidth = function(e) {
      return this.eSlider.setWidth(e), this;
    }, t.prototype.setTextFieldWidth = function(e) {
      return this.eText.setWidth(e), this;
    }, t.prototype.setMinValue = function(e) {
      return this.eSlider.setMinValue(e), this.eText.setMin(e), this;
    }, t.prototype.setMaxValue = function(e) {
      return this.eSlider.setMaxValue(e), this.eText.setMax(e), this;
    }, t.prototype.getValue = function() {
      return this.eText.getValue();
    }, t.prototype.setValue = function(e) {
      return this.getValue() === e ? this : (this.eText.setValue(e, !0), this.eSlider.setValue(e, !0), this.dispatchEvent({ type: hn.EVENT_CHANGED }), this);
    }, t.prototype.setStep = function(e) {
      return this.eSlider.setStep(e), this.eText.setStep(e), this;
    }, t.TEMPLATE = `<div class="ag-slider">
            <label ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range ref="eSlider"></ag-input-range>
                <ag-input-number-field ref="eText"></ag-input-number-field>
            </div>
        </div>`, _s([
      Y("eLabel")
    ], t.prototype, "eLabel", void 0), _s([
      Y("eSlider")
    ], t.prototype, "eSlider", void 0), _s([
      Y("eText")
    ], t.prototype, "eText", void 0), _s([
      U
    ], t.prototype, "init", null), t;
  }(oc)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var lR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Do = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Sv = (
  /** @class */
  function(i) {
    lR(t, i);
    function t(e) {
      e === void 0 && (e = {});
      var r = i.call(this, t.getTemplate(e)) || this;
      r.suppressEnabledCheckbox = !0, r.suppressOpenCloseIcons = !1;
      var o = e.title, n = e.enabled, s = e.items, a = e.suppressEnabledCheckbox, l = e.suppressOpenCloseIcons;
      return r.title = o, r.cssIdentifier = e.cssIdentifier || "default", r.enabled = n ?? !0, r.items = s || [], r.alignItems = e.alignItems || "center", a != null && (r.suppressEnabledCheckbox = a), l != null && (r.suppressOpenCloseIcons = l), r;
    }
    return t.getTemplate = function(e) {
      var r = e.cssIdentifier || "default", o = e.direction || "vertical";
      return (
        /* html */
        '<div class="ag-group ag-' + r + `-group" role="presentation">
            <div class="ag-group-title-bar ag-` + r + `-group-title-bar ag-unselectable" ref="eTitleBar" role="button">
                <span class="ag-group-title-bar-icon ag-` + r + `-group-title-bar-icon" ref="eGroupOpenedIcon" role="presentation"></span>
                <span class="ag-group-title-bar-icon ag-` + r + `-group-title-bar-icon" ref="eGroupClosedIcon" role="presentation"></span>
                <span ref="eTitle" class="ag-group-title ag-` + r + `-group-title"></span>
            </div>
            <div ref="eToolbar" class="ag-group-toolbar ag-` + r + `-group-toolbar">
                <ag-checkbox ref="cbGroupEnabled"></ag-checkbox>
            </div>
            <div ref="eContainer" class="ag-group-container ag-group-container-` + o + " ag-" + r + `-group-container"></div>
        </div>`
      );
    }, t.prototype.postConstruct = function() {
      if (this.items.length) {
        var e = this.items;
        this.items = [], this.addItems(e);
      }
      var r = this.localeService.getLocaleTextFunc();
      this.cbGroupEnabled.setLabel(r("enabled", "Enabled")), this.title && this.setTitle(this.title), this.enabled && this.setEnabled(this.enabled), this.setAlignItems(this.alignItems), this.hideEnabledCheckbox(this.suppressEnabledCheckbox), this.hideOpenCloseIcons(this.suppressOpenCloseIcons), this.setupExpandContract(), this.refreshAriaStatus(), this.refreshChildDisplay();
    }, t.prototype.setupExpandContract = function() {
      var e = this;
      this.eGroupClosedIcon.appendChild(Cr("columnSelectClosed", this.gridOptionsService, null)), this.eGroupOpenedIcon.appendChild(Cr("columnSelectOpen", this.gridOptionsService, null)), this.addManagedListener(this.eTitleBar, "click", function() {
        return e.toggleGroupExpand();
      }), this.addManagedListener(this.eTitleBar, "keydown", function(r) {
        switch (r.key) {
          case L.ENTER:
          case L.SPACE:
            r.preventDefault(), e.toggleGroupExpand();
            break;
          case L.RIGHT:
          case L.LEFT:
            r.preventDefault(), e.toggleGroupExpand(r.key === L.RIGHT);
            break;
        }
      });
    }, t.prototype.refreshAriaStatus = function() {
      this.suppressOpenCloseIcons || Vr(this.eTitleBar, this.expanded);
    }, t.prototype.refreshChildDisplay = function() {
      var e = !this.suppressOpenCloseIcons;
      be(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox), be(this.eGroupOpenedIcon, e && this.expanded), be(this.eGroupClosedIcon, e && !this.expanded);
    }, t.prototype.isExpanded = function() {
      return this.expanded;
    }, t.prototype.setAlignItems = function(e) {
      this.alignItems !== e && this.removeCssClass("ag-group-item-alignment-" + this.alignItems), this.alignItems = e;
      var r = "ag-group-item-alignment-" + this.alignItems;
      return this.addCssClass(r), this;
    }, t.prototype.toggleGroupExpand = function(e) {
      return this.suppressOpenCloseIcons ? (this.expanded = !0, this.refreshChildDisplay(), be(this.eContainer, !0), this) : (e = e ?? !this.expanded, this.expanded === e ? this : (this.expanded = e, this.refreshAriaStatus(), this.refreshChildDisplay(), be(this.eContainer, e), this.dispatchEvent({ type: this.expanded ? t.EVENT_EXPANDED : t.EVENT_COLLAPSED }), this));
    }, t.prototype.addItems = function(e) {
      var r = this;
      e.forEach(function(o) {
        return r.addItem(o);
      });
    }, t.prototype.addItem = function(e) {
      var r = this.eContainer, o = e instanceof ge ? e.getGui() : e;
      o.classList.add("ag-group-item", "ag-" + this.cssIdentifier + "-group-item"), r.appendChild(o), this.items.push(o);
    }, t.prototype.hideItem = function(e, r) {
      var o = this.items[r];
      be(o, !e);
    }, t.prototype.setTitle = function(e) {
      return this.eTitle.innerText = e, this;
    }, t.prototype.addCssClassToTitleBar = function(e) {
      this.eTitleBar.classList.add(e);
    }, t.prototype.setEnabled = function(e, r) {
      return this.enabled = e, this.refreshDisabledStyles(), this.toggleGroupExpand(e), r || this.cbGroupEnabled.setValue(e), this;
    }, t.prototype.isEnabled = function() {
      return this.enabled;
    }, t.prototype.onEnableChange = function(e) {
      var r = this;
      return this.cbGroupEnabled.onValueChange(function(o) {
        r.setEnabled(o, !0), e(o);
      }), this;
    }, t.prototype.hideEnabledCheckbox = function(e) {
      return this.suppressEnabledCheckbox = e, this.refreshChildDisplay(), this.refreshDisabledStyles(), this;
    }, t.prototype.hideOpenCloseIcons = function(e) {
      return this.suppressOpenCloseIcons = e, e && this.toggleGroupExpand(!0), this;
    }, t.prototype.refreshDisabledStyles = function() {
      this.addOrRemoveCssClass("ag-disabled", !this.enabled), this.suppressEnabledCheckbox && !this.enabled ? (this.eTitleBar.classList.add("ag-disabled-group-title-bar"), this.eTitleBar.removeAttribute("tabindex")) : (this.eTitleBar.classList.remove("ag-disabled-group-title-bar"), this.eTitleBar.setAttribute("tabindex", "0")), this.eContainer.classList.toggle("ag-disabled-group-container", !this.enabled);
    }, t.EVENT_EXPANDED = "expanded", t.EVENT_COLLAPSED = "collapsed", Do([
      Y("eTitleBar")
    ], t.prototype, "eTitleBar", void 0), Do([
      Y("eGroupOpenedIcon")
    ], t.prototype, "eGroupOpenedIcon", void 0), Do([
      Y("eGroupClosedIcon")
    ], t.prototype, "eGroupClosedIcon", void 0), Do([
      Y("eToolbar")
    ], t.prototype, "eToolbar", void 0), Do([
      Y("cbGroupEnabled")
    ], t.prototype, "cbGroupEnabled", void 0), Do([
      Y("eTitle")
    ], t.prototype, "eTitle", void 0), Do([
      Y("eContainer")
    ], t.prototype, "eContainer", void 0), Do([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var uR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), od = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, pn;
(function(i) {
  i.TAB_GUARD = "ag-tab-guard", i.TAB_GUARD_TOP = "ag-tab-guard-top", i.TAB_GUARD_BOTTOM = "ag-tab-guard-bottom";
})(pn || (pn = {}));
var _v = (
  /** @class */
  function(i) {
    uR(t, i);
    function t(e) {
      var r = i.call(this) || this;
      r.skipTabGuardFocus = !1;
      var o = e.comp, n = e.eTopGuard, s = e.eBottomGuard, a = e.focusInnerElement, l = e.onFocusIn, u = e.onFocusOut, c = e.shouldStopEventPropagation, p = e.onTabKeyDown, d = e.handleKeyDown, h = e.eFocusableElement;
      return r.comp = o, r.eTopGuard = n, r.eBottomGuard = s, r.providedFocusInnerElement = a, r.eFocusableElement = h, r.providedFocusIn = l, r.providedFocusOut = u, r.providedShouldStopEventPropagation = c, r.providedOnTabKeyDown = p, r.providedHandleKeyDown = d, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.createManagedBean(new wo(this.eFocusableElement, {
        shouldStopEventPropagation: function() {
          return e.shouldStopEventPropagation();
        },
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        },
        onFocusIn: function(r) {
          return e.onFocusIn(r);
        },
        onFocusOut: function(r) {
          return e.onFocusOut(r);
        }
      })), this.activateTabGuards(), [this.eTopGuard, this.eBottomGuard].forEach(function(r) {
        return e.addManagedListener(r, "focus", e.onFocus.bind(e));
      });
    }, t.prototype.handleKeyDown = function(e) {
      this.providedHandleKeyDown && this.providedHandleKeyDown(e);
    }, t.prototype.tabGuardsAreActive = function() {
      return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }, t.prototype.shouldStopEventPropagation = function() {
      return this.providedShouldStopEventPropagation ? this.providedShouldStopEventPropagation() : !1;
    }, t.prototype.activateTabGuards = function() {
      this.comp.setTabIndex(this.getGridTabIndex());
    }, t.prototype.deactivateTabGuards = function() {
      this.comp.setTabIndex();
    }, t.prototype.onFocus = function(e) {
      if (this.skipTabGuardFocus) {
        this.skipTabGuardFocus = !1;
        return;
      }
      var r = e.target === this.eBottomGuard;
      this.providedFocusInnerElement ? this.providedFocusInnerElement(r) : this.focusInnerElement(r);
    }, t.prototype.onFocusIn = function(e) {
      this.providedFocusIn && this.providedFocusIn(e) || this.deactivateTabGuards();
    }, t.prototype.onFocusOut = function(e) {
      this.providedFocusOut && this.providedFocusOut(e) || this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards();
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this;
      if (this.providedOnTabKeyDown) {
        this.providedOnTabKeyDown(e);
        return;
      }
      if (!e.defaultPrevented) {
        var o = this.tabGuardsAreActive();
        o && this.deactivateTabGuards();
        var n = this.getNextFocusableElement(e.shiftKey);
        o && setTimeout(function() {
          return r.activateTabGuards();
        }, 0), n && (n.focus(), e.preventDefault());
      }
    }, t.prototype.getGridTabIndex = function() {
      return (this.gridOptionsService.getNum("tabIndex") || 0).toString();
    }, t.prototype.focusInnerElement = function(e) {
      e === void 0 && (e = !1);
      var r = this.focusService.findFocusableElements(this.eFocusableElement);
      this.tabGuardsAreActive() && (r.splice(0, 1), r.splice(r.length - 1, 1)), r.length && r[e ? r.length - 1 : 0].focus({ preventScroll: !0 });
    }, t.prototype.getNextFocusableElement = function(e) {
      return this.focusService.findNextFocusableElement(this.eFocusableElement, !1, e);
    }, t.prototype.forceFocusOutOfContainer = function(e) {
      e === void 0 && (e = !1);
      var r = e ? this.eTopGuard : this.eBottomGuard;
      this.activateTabGuards(), this.skipTabGuardFocus = !0, r.focus();
    }, od([
      v("focusService")
    ], t.prototype, "focusService", void 0), od([
      U
    ], t.prototype, "postConstruct", null), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var cR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pR = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, dR = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(pR(arguments[t]));
  return i;
}, zi = (
  /** @class */
  function(i) {
    cR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.initialiseTabGuard = function(e) {
      this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.getFocusableElement();
      var r = [this.eTopGuard, this.eBottomGuard], o = {
        setTabIndex: function(n) {
          r.forEach(function(s) {
            return n != null ? s.setAttribute("tabIndex", n) : s.removeAttribute("tabIndex");
          });
        }
      };
      this.addTabGuards(this.eTopGuard, this.eBottomGuard), this.tabGuardCtrl = this.createManagedBean(new _v({
        comp: o,
        eTopGuard: this.eTopGuard,
        eBottomGuard: this.eBottomGuard,
        eFocusableElement: this.eFocusableElement,
        onFocusIn: e.onFocusIn,
        onFocusOut: e.onFocusOut,
        focusInnerElement: e.focusInnerElement,
        handleKeyDown: e.handleKeyDown,
        onTabKeyDown: e.onTabKeyDown,
        shouldStopEventPropagation: e.shouldStopEventPropagation
      }));
    }, t.prototype.createTabGuard = function(e) {
      var r = document.createElement("div"), o = e === "top" ? pn.TAB_GUARD_TOP : pn.TAB_GUARD_BOTTOM;
      return r.classList.add(pn.TAB_GUARD, o), Dt(r, "presentation"), r;
    }, t.prototype.addTabGuards = function(e, r) {
      this.eFocusableElement.insertAdjacentElement("afterbegin", e), this.eFocusableElement.insertAdjacentElement("beforeend", r);
    }, t.prototype.removeAllChildrenExceptTabGuards = function() {
      var e = [this.eTopGuard, this.eBottomGuard];
      pr(this.getFocusableElement()), this.addTabGuards.apply(this, dR(e));
    }, t.prototype.forceFocusOutOfContainer = function(e) {
      e === void 0 && (e = !1), this.tabGuardCtrl.forceFocusOutOfContainer(e);
    }, t.prototype.appendChild = function(e, r) {
      Wi(e) || (e = e.getGui());
      var o = this.eBottomGuard;
      o ? o.insertAdjacentElement("beforebegin", e) : i.prototype.appendChild.call(this, e, r);
    }, t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var fR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), la = function() {
  return la = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, la.apply(this, arguments);
}, nd = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ev = (
  /** @class */
  function(i) {
    fR(t, i);
    function t(e) {
      e === void 0 && (e = 1);
      var r = i.call(
        this,
        /* html */
        '<div class="ag-menu-list" role="tree"></div>'
      ) || this;
      return r.level = e, r.menuItems = [], r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.initialiseTabGuard({
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        }
      });
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this.getParentComponent(), o = r && r.getGui(), n = o && o.classList.contains("ag-focus-managed");
      n || e.preventDefault(), e.shiftKey && this.closeIfIsChild(e);
    }, t.prototype.handleKeyDown = function(e) {
      switch (e.key) {
        case L.UP:
        case L.RIGHT:
        case L.DOWN:
        case L.LEFT:
          e.preventDefault(), this.handleNavKey(e.key);
          break;
        case L.ESCAPE:
          var r = this.findTopMenu();
          r && this.focusService.focusInto(r.getGui());
          break;
      }
    }, t.prototype.clearActiveItem = function() {
      this.activeMenuItem && (this.activeMenuItem.deactivate(), this.activeMenuItem = null);
    }, t.prototype.addMenuItems = function(e) {
      var r = this;
      e != null && e.forEach(function(o) {
        o === "separator" ? r.addSeparator() : typeof o == "string" ? console.warn("AG Grid: unrecognised menu item " + o) : r.addItem(o);
      });
    }, t.prototype.addItem = function(e) {
      var r = this, o = this.createManagedBean(new Hn(la(la({}, e), { isAnotherSubMenuOpen: function() {
        return r.menuItems.some(function(n) {
          return n.isSubMenuOpen();
        });
      } })));
      o.setParentComponent(this), Af(o.getGui(), this.level), this.menuItems.push(o), this.appendChild(o.getGui()), this.addManagedListener(o, Hn.EVENT_MENU_ITEM_SELECTED, function(n) {
        r.dispatchEvent(n);
      }), this.addManagedListener(o, Hn.EVENT_MENU_ITEM_ACTIVATED, function(n) {
        r.activeMenuItem && r.activeMenuItem !== n.menuItem && r.activeMenuItem.deactivate(), r.activeMenuItem = n.menuItem;
      });
    }, t.prototype.activateFirstItem = function() {
      var e = this.menuItems.filter(function(r) {
        return !r.isDisabled();
      })[0];
      e && e.activate();
    }, t.prototype.addSeparator = function() {
      var e = (
        /* html */
        `
            <div class="ag-menu-separator" aria-hidden="true">
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
            </div>`
      );
      this.appendChild(Lt(e));
    }, t.prototype.findTopMenu = function() {
      var e = this.getParentComponent();
      if (!e && this instanceof t)
        return this;
      for (; ; ) {
        var r = e && e.getParentComponent && e.getParentComponent();
        if (!r || !(r instanceof t || r instanceof Hn))
          break;
        e = r;
      }
      return e instanceof t ? e : void 0;
    }, t.prototype.handleNavKey = function(e) {
      switch (e) {
        case L.UP:
        case L.DOWN:
          var r = this.findNextItem(e === L.UP);
          r && r !== this.activeMenuItem && r.activate();
          return;
      }
      var o = this.gridOptionsService.is("enableRtl") ? L.RIGHT : L.LEFT;
      e === o ? this.closeIfIsChild() : this.openChild();
    }, t.prototype.closeIfIsChild = function(e) {
      var r = this.getParentComponent();
      r && r instanceof Hn && (e && e.preventDefault(), r.closeSubMenu(), r.getGui().focus());
    }, t.prototype.openChild = function() {
      this.activeMenuItem && this.activeMenuItem.openSubMenu(!0);
    }, t.prototype.findNextItem = function(e) {
      var r = this.menuItems.filter(function(l) {
        return !l.isDisabled();
      });
      if (r.length) {
        if (!this.activeMenuItem)
          return e ? Ne(r) : r[0];
        e && r.reverse();
        for (var o, n = !1, s = 0; s < r.length; s++) {
          var a = r[s];
          if (!n) {
            a === this.activeMenuItem && (n = !0);
            continue;
          }
          o = a;
          break;
        }
        return o || this.activeMenuItem;
      }
    }, t.prototype.destroy = function() {
      this.clearActiveItem(), i.prototype.destroy.call(this);
    }, nd([
      v("focusService")
    ], t.prototype, "focusService", void 0), nd([
      U
    ], t.prototype, "postConstruct", null), t;
  }(zi)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var hR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), vR = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Rv = (
  /** @class */
  function(i) {
    hR(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.wrappedComponent = e, r.setTemplateFromElement(e.getGui()), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.initialiseTabGuard({
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        }
      });
    }, t.prototype.handleKeyDown = function(e) {
      e.key === L.ESCAPE && this.closePanel();
    }, t.prototype.onTabKeyDown = function(e) {
      e.defaultPrevented || (this.closePanel(), e.preventDefault());
    }, t.prototype.closePanel = function() {
      var e = this.parentComponent;
      e.closeSubMenu(), setTimeout(function() {
        return e.getGui().focus();
      }, 0);
    }, vR([
      U
    ], t.prototype, "postConstruct", null), t;
  }(zi)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var gR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), id = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Hn = (
  /** @class */
  function(i) {
    gR(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.params = e, r.isActive = !1, r.subMenuIsOpen = !1, r.setTemplate(
        /* html */
        '<div class="' + r.getClassName() + '" tabindex="-1" role="treeitem"></div>'
      ), r;
    }
    return t.prototype.init = function() {
      var e = this;
      this.addIcon(), this.addName(), this.addShortcut(), this.addSubMenu(), this.addTooltip();
      var r = this.getGui();
      this.params.disabled ? (this.addCssClass(this.getClassName("disabled")), Gu(r, !0)) : (this.addGuiEventListener("click", function(o) {
        return e.onItemSelected(o);
      }), this.addGuiEventListener("keydown", function(o) {
        (o.key === L.ENTER || o.key === L.SPACE) && (o.preventDefault(), e.onItemSelected(o));
      }), this.addGuiEventListener("mousedown", function(o) {
        o.stopPropagation(), o.preventDefault();
      }), this.addGuiEventListener("mouseenter", function() {
        return e.onMouseEnter();
      }), this.addGuiEventListener("mouseleave", function() {
        return e.onMouseLeave();
      })), this.params.cssClasses && this.params.cssClasses.forEach(function(o) {
        return e.addCssClass(o);
      });
    }, t.prototype.isDisabled = function() {
      return !!this.params.disabled;
    }, t.prototype.openSubMenu = function(e) {
      var r = this;
      if (e === void 0 && (e = !1), this.closeSubMenu(), !!this.params.subMenu) {
        var o = Lt(
          /* html */
          '<div class="ag-menu" role="presentation"></div>'
        ), n;
        if (this.params.subMenu instanceof Array) {
          var s = bf(this.getGui()), a = isNaN(s) ? 1 : s + 1, l = this.createBean(new Ev(a));
          l.setParentComponent(this), l.addMenuItems(this.params.subMenu), o.appendChild(l.getGui()), this.addManagedListener(l, t.EVENT_MENU_ITEM_SELECTED, function(w) {
            return r.dispatchEvent(w);
          }), l.addGuiEventListener("mouseenter", function() {
            return r.cancelDeactivate();
          }), n = function() {
            return r.destroyBean(l);
          }, e && setTimeout(function() {
            return l.activateFirstItem();
          }, 0);
        } else {
          var u = this.params.subMenu, c = this.createBean(new Rv(u));
          c.setParentComponent(this);
          var p = c.getGui(), d = "mouseenter", h = function() {
            return r.cancelDeactivate();
          };
          p.addEventListener(d, h), n = function() {
            return p.removeEventListener(d, h);
          }, o.appendChild(p), u.afterGuiAttached && setTimeout(function() {
            return u.afterGuiAttached();
          }, 0);
        }
        var g = this.getGui(), y = this.popupService.positionPopupForMenu.bind(this.popupService, { eventSource: g, ePopup: o }), S = this.localeService.getLocaleTextFunc(), _ = this.popupService.addPopup({
          modal: !0,
          eChild: o,
          positionCallback: y,
          anchorToElement: g,
          ariaLabel: S("ariaLabelSubMenu", "SubMenu")
        });
        this.subMenuIsOpen = !0, Vr(g, !0), this.hideSubMenu = function() {
          _ && _.hideFunc(), r.subMenuIsOpen = !1, Vr(g, !1), n();
        };
      }
    }, t.prototype.closeSubMenu = function() {
      this.hideSubMenu && (this.hideSubMenu(), this.hideSubMenu = null, Vr(this.getGui(), !1));
    }, t.prototype.isSubMenuOpen = function() {
      return this.subMenuIsOpen;
    }, t.prototype.activate = function(e) {
      var r = this;
      this.cancelActivate(), !this.params.disabled && (this.isActive = !0, this.addCssClass(this.getClassName("active")), this.getGui().focus(), e && this.params.subMenu && window.setTimeout(function() {
        r.isAlive() && r.isActive && r.openSubMenu();
      }, 300), this.onItemActivated());
    }, t.prototype.deactivate = function() {
      this.cancelDeactivate(), this.removeCssClass(this.getClassName("active")), this.isActive = !1, this.subMenuIsOpen && this.hideSubMenu();
    }, t.prototype.addIcon = function() {
      if (!(!this.params.checked && !this.params.icon && this.params.isCompact)) {
        var e = Lt(
          /* html */
          '<span ref="eIcon" class="' + this.getClassName("part") + " " + this.getClassName("icon") + '" role="presentation"></span>'
        );
        this.params.checked ? e.appendChild(ut("check", this.gridOptionsService)) : this.params.icon && (Wi(this.params.icon) ? e.appendChild(this.params.icon) : typeof this.params.icon == "string" ? e.innerHTML = this.params.icon : console.warn("AG Grid: menu item icon must be DOM node or string")), this.getGui().appendChild(e);
      }
    }, t.prototype.addName = function() {
      if (!(!this.params.name && this.params.isCompact)) {
        var e = Lt(
          /* html */
          '<span ref="eName" class="' + this.getClassName("part") + " " + this.getClassName("text") + '">' + (this.params.name || "") + "</span>"
        );
        this.getGui().appendChild(e);
      }
    }, t.prototype.addTooltip = function() {
      this.params.tooltip && (this.tooltip = this.params.tooltip, this.gridOptionsService.is("enableBrowserTooltips") ? this.getGui().setAttribute("title", this.tooltip) : this.createManagedBean(new Aa(this)));
    }, t.prototype.getTooltipParams = function() {
      return {
        location: "menu",
        value: this.tooltip
      };
    }, t.prototype.addShortcut = function() {
      if (!(!this.params.shortcut && this.params.isCompact)) {
        var e = Lt(
          /* html */
          '<span ref="eShortcut" class="' + this.getClassName("part") + " " + this.getClassName("shortcut") + '">' + (this.params.shortcut || "") + "</span>"
        );
        this.getGui().appendChild(e);
      }
    }, t.prototype.addSubMenu = function() {
      if (!(!this.params.subMenu && this.params.isCompact)) {
        var e = Lt(
          /* html */
          '<span ref="ePopupPointer" class="' + this.getClassName("part") + " " + this.getClassName("popup-pointer") + '"></span>'
        ), r = this.getGui();
        if (this.params.subMenu) {
          var o = this.gridOptionsService.is("enableRtl") ? "smallLeft" : "smallRight";
          Vr(r, !1), e.appendChild(ut(o, this.gridOptionsService));
        }
        r.appendChild(e);
      }
    }, t.prototype.onItemSelected = function(e) {
      if (this.params.action ? this.params.action() : this.openSubMenu(e && e.type === "keydown"), !(this.params.subMenu && !this.params.action)) {
        var r = {
          type: t.EVENT_MENU_ITEM_SELECTED,
          action: this.params.action,
          checked: this.params.checked,
          cssClasses: this.params.cssClasses,
          disabled: this.params.disabled,
          icon: this.params.icon,
          name: this.params.name,
          shortcut: this.params.shortcut,
          subMenu: this.params.subMenu,
          tooltip: this.params.tooltip,
          event: e
        };
        this.dispatchEvent(r);
      }
    }, t.prototype.onItemActivated = function() {
      var e = {
        type: t.EVENT_MENU_ITEM_ACTIVATED,
        menuItem: this
      };
      this.dispatchEvent(e);
    }, t.prototype.cancelActivate = function() {
      this.activateTimeoutId && (window.clearTimeout(this.activateTimeoutId), this.activateTimeoutId = 0);
    }, t.prototype.cancelDeactivate = function() {
      this.deactivateTimeoutId && (window.clearTimeout(this.deactivateTimeoutId), this.deactivateTimeoutId = 0);
    }, t.prototype.onMouseEnter = function() {
      var e = this;
      this.cancelDeactivate(), this.params.isAnotherSubMenuOpen() ? this.activateTimeoutId = window.setTimeout(function() {
        return e.activate(!0);
      }, t.ACTIVATION_DELAY) : this.activate(!0);
    }, t.prototype.onMouseLeave = function() {
      var e = this;
      this.cancelActivate(), this.isSubMenuOpen() ? this.deactivateTimeoutId = window.setTimeout(function() {
        return e.deactivate();
      }, t.ACTIVATION_DELAY) : this.deactivate();
    }, t.prototype.getClassName = function(e) {
      var r = this.params.isCompact ? "ag-compact-menu-option" : "ag-menu-option";
      return e ? r + "-" + e : r;
    }, t.EVENT_MENU_ITEM_SELECTED = "menuItemSelected", t.EVENT_MENU_ITEM_ACTIVATED = "menuItemActivated", t.ACTIVATION_DELAY = 80, id([
      v("popupService")
    ], t.prototype, "popupService", void 0), id([
      U
    ], t.prototype, "init", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var yR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), di = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, yc = (
  /** @class */
  function(i) {
    yR(t, i);
    function t(e) {
      var r = i.call(this, t.getTemplate(e)) || this;
      return r.closable = !0, r.config = e, r;
    }
    return t.getTemplate = function(e) {
      var r = e && e.cssIdentifier || "default";
      return (
        /* html */
        '<div class="ag-panel ag-' + r + `-panel" tabindex="-1">
            <div ref="eTitleBar" class="ag-panel-title-bar ag-` + r + `-panel-title-bar ag-unselectable">
                <span ref="eTitle" class="ag-panel-title-bar-title ag-` + r + `-panel-title-bar-title"></span>
                <div ref="eTitleBarButtons" class="ag-panel-title-bar-buttons ag-` + r + `-panel-title-bar-buttons"></div>
            </div>
            <div ref="eContentWrapper" class="ag-panel-content-wrapper ag-` + r + `-panel-content-wrapper"></div>
        </div>`
      );
    }, t.prototype.postConstruct = function() {
      var e = this, r = this.config, o = r.component, n = r.closable, s = r.hideTitleBar, a = r.title, l = r.minWidth, u = l === void 0 ? 250 : l, c = r.width, p = r.minHeight, d = p === void 0 ? 250 : p, h = r.height, g = r.centered, y = r.popup, S = r.x, _ = r.y;
      this.positionableFeature = new rc(this.getGui(), {
        minWidth: u,
        width: c,
        minHeight: d,
        height: h,
        centered: g,
        x: S,
        y: _,
        popup: y,
        calculateTopBuffer: function() {
          return e.positionableFeature.getHeight() - e.getBodyHeight();
        }
      }), this.createManagedBean(this.positionableFeature);
      var w = this.getGui();
      o && this.setBodyComponent(o), s ? be(this.eTitleBar, !1) : (a && this.setTitle(a), this.setClosable(n ?? this.closable)), this.addManagedListener(this.eTitleBar, "mousedown", function(E) {
        var R = e.gridOptionsService.getDocument();
        if (w.contains(E.relatedTarget) || w.contains(R.activeElement) || e.eTitleBarButtons.contains(E.target)) {
          E.preventDefault();
          return;
        }
        var D = e.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");
        D && D.focus();
      }), !(y && this.positionableFeature.isPositioned()) && (this.renderComponent && this.renderComponent(), this.positionableFeature.initialisePosition(), this.eContentWrapper.style.height = "0");
    }, t.prototype.renderComponent = function() {
      var e = this, r = this.getGui();
      r.focus(), this.close = function() {
        r.parentElement.removeChild(r), e.destroy();
      };
    }, t.prototype.getHeight = function() {
      return this.positionableFeature.getHeight();
    }, t.prototype.setHeight = function(e) {
      this.positionableFeature.setHeight(e);
    }, t.prototype.getWidth = function() {
      return this.positionableFeature.getWidth();
    }, t.prototype.setWidth = function(e) {
      this.positionableFeature.setWidth(e);
    }, t.prototype.setClosable = function(e) {
      if (e !== this.closable && (this.closable = e), e) {
        var r = this.closeButtonComp = new ge(t.CLOSE_BTN_TEMPLATE);
        this.getContext().createBean(r);
        var o = r.getGui(), n = ut("close", this.gridOptionsService);
        n.classList.add("ag-panel-title-bar-button-icon"), o.appendChild(n), this.addTitleBarButton(r), r.addManagedListener(o, "click", this.onBtClose.bind(this));
      } else if (this.closeButtonComp) {
        var o = this.closeButtonComp.getGui();
        o.parentElement.removeChild(o), this.closeButtonComp = this.destroyBean(this.closeButtonComp);
      }
    }, t.prototype.setBodyComponent = function(e) {
      e.setParentComponent(this), this.eContentWrapper.appendChild(e.getGui());
    }, t.prototype.addTitleBarButton = function(e, r) {
      var o = this.eTitleBarButtons, n = o.children, s = n.length;
      r == null && (r = s), r = Math.max(0, Math.min(r, s)), e.addCssClass("ag-panel-title-bar-button");
      var a = e.getGui();
      r === 0 ? o.insertAdjacentElement("afterbegin", a) : r === s ? o.insertAdjacentElement("beforeend", a) : n[r - 1].insertAdjacentElement("afterend", a), e.setParentComponent(this);
    }, t.prototype.getBodyHeight = function() {
      return ki(this.eContentWrapper);
    }, t.prototype.getBodyWidth = function() {
      return Pa(this.eContentWrapper);
    }, t.prototype.setTitle = function(e) {
      this.eTitle.innerText = e;
    }, t.prototype.onBtClose = function() {
      this.close();
    }, t.prototype.destroy = function() {
      this.closeButtonComp && (this.closeButtonComp = this.destroyBean(this.closeButtonComp));
      var e = this.getGui();
      e && e.offsetParent && this.close(), i.prototype.destroy.call(this);
    }, t.CLOSE_BTN_TEMPLATE = '<div class="ag-button"></div>', di([
      Y("eContentWrapper")
    ], t.prototype, "eContentWrapper", void 0), di([
      Y("eTitleBar")
    ], t.prototype, "eTitleBar", void 0), di([
      Y("eTitleBarButtons")
    ], t.prototype, "eTitleBarButtons", void 0), di([
      Y("eTitle")
    ], t.prototype, "eTitle", void 0), di([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var mR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ua = function() {
  return ua = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ua.apply(this, arguments);
}, CR = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ov = (
  /** @class */
  function(i) {
    mR(t, i);
    function t(e) {
      var r = i.call(this, ua(ua({}, e), { popup: !0 })) || this;
      return r.isMaximizable = !1, r.isMaximized = !1, r.maximizeListeners = [], r.resizeListenerDestroy = null, r.lastPosition = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), o = this.config, n = o.movable, s = o.resizable, a = o.maximizable;
      this.addCssClass("ag-dialog"), i.prototype.postConstruct.call(this), this.addManagedListener(r, "focusin", function(l) {
        r.contains(l.relatedTarget) || e.popupService.bringPopupToFront(r);
      }), n && this.setMovable(n), a && this.setMaximizable(a), s && this.setResizable(s);
    }, t.prototype.renderComponent = function() {
      var e = this.getGui(), r = this.config, o = r.alwaysOnTop, n = r.modal, s = r.title, a = this.localeService.getLocaleTextFunc(), l = this.popupService.addPopup({
        modal: n,
        eChild: e,
        closeOnEsc: !0,
        closedCallback: this.destroy.bind(this),
        alwaysOnTop: o,
        ariaLabel: s || a("ariaLabelDialog", "Dialog")
      });
      l && (this.close = l.hideFunc);
    }, t.prototype.toggleMaximize = function() {
      var e = this.positionableFeature.getPosition();
      if (this.isMaximized) {
        var r = this.lastPosition, o = r.x, n = r.y, s = r.width, a = r.height;
        this.setWidth(s), this.setHeight(a), this.positionableFeature.offsetElement(o, n);
      } else
        this.lastPosition.width = this.getWidth(), this.lastPosition.height = this.getHeight(), this.lastPosition.x = e.x, this.lastPosition.y = e.y, this.positionableFeature.offsetElement(0, 0), this.setHeight("100%"), this.setWidth("100%");
      this.isMaximized = !this.isMaximized, this.refreshMaximizeIcon();
    }, t.prototype.refreshMaximizeIcon = function() {
      be(this.maximizeIcon, !this.isMaximized), be(this.minimizeIcon, this.isMaximized);
    }, t.prototype.clearMaximizebleListeners = function() {
      this.maximizeListeners.length && (this.maximizeListeners.forEach(function(e) {
        return e();
      }), this.maximizeListeners.length = 0), this.resizeListenerDestroy && (this.resizeListenerDestroy(), this.resizeListenerDestroy = null);
    }, t.prototype.destroy = function() {
      this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp), this.clearMaximizebleListeners(), i.prototype.destroy.call(this);
    }, t.prototype.setResizable = function(e) {
      this.positionableFeature.setResizable(e);
    }, t.prototype.setMovable = function(e) {
      this.positionableFeature.setMovable(e, this.eTitleBar);
    }, t.prototype.setMaximizable = function(e) {
      var r = this;
      if (!e) {
        this.clearMaximizebleListeners(), this.maximizeButtonComp && (this.destroyBean(this.maximizeButtonComp), this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0);
        return;
      }
      var o = this.eTitleBar;
      if (!(!o || e === this.isMaximizable)) {
        var n = this.buildMaximizeAndMinimizeElements();
        this.refreshMaximizeIcon(), n.addManagedListener(n.getGui(), "click", this.toggleMaximize.bind(this)), this.addTitleBarButton(n, 0), this.maximizeListeners.push(this.addManagedListener(o, "dblclick", this.toggleMaximize.bind(this))), this.resizeListenerDestroy = this.addManagedListener(this, "resize", function() {
          r.isMaximized = !1, r.refreshMaximizeIcon();
        });
      }
    }, t.prototype.buildMaximizeAndMinimizeElements = function() {
      var e = this.maximizeButtonComp = this.createBean(new ge(
        /* html */
        '<div class="ag-dialog-button"></span>'
      )), r = e.getGui();
      return this.maximizeIcon = ut("maximize", this.gridOptionsService), r.appendChild(this.maximizeIcon), this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon"), this.minimizeIcon = ut("minimize", this.gridOptionsService), r.appendChild(this.minimizeIcon), this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon"), e;
    }, CR([
      v("popupService")
    ], t.prototype, "popupService", void 0), t;
  }(yc)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var wR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Pi = function() {
  return Pi = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, Pi.apply(this, arguments);
}, qr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, SR = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, _R = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(SR(arguments[t]));
  return i;
}, Wn = (
  /** @class */
  function(i) {
    wR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    e = t, t.addKeyboardModeEvents = function(r, o) {
      var n = e.instancesMonitored.get(r);
      n && n.length > 0 ? n.indexOf(o) === -1 && n.push(o) : (e.instancesMonitored.set(r, [o]), r.addEventListener("keydown", e.toggleKeyboardMode), r.addEventListener("mousedown", e.toggleKeyboardMode));
    }, t.removeKeyboardModeEvents = function(r, o) {
      var n = e.instancesMonitored.get(r), s = [];
      n && n.length && (s = _R(n).filter(function(a) {
        return a !== o;
      }), e.instancesMonitored.set(r, s)), s.length === 0 && (r.removeEventListener("keydown", e.toggleKeyboardMode), r.removeEventListener("mousedown", e.toggleKeyboardMode));
    }, t.toggleKeyboardMode = function(r) {
      var o = e.keyboardModeActive, n = r.type === "keydown";
      if (!(n && (r.ctrlKey || r.metaKey || r.altKey)) && !(o && n || !o && !n)) {
        e.keyboardModeActive = n;
        var s = r.target.ownerDocument;
        if (s) {
          var a = e.instancesMonitored.get(s);
          a && a.forEach(function(l) {
            l.dispatchEvent({ type: n ? m.EVENT_KEYBOARD_FOCUS : m.EVENT_MOUSE_FOCUS });
          });
        }
      }
    }, t.prototype.init = function() {
      var r = this, o = this.clearFocusedCell.bind(this);
      this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_MODE_CHANGED, o), this.addManagedListener(this.eventService, m.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_GROUP_OPENED, o), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, o), this.ctrlsService.whenReady(function(n) {
        r.gridCtrl = n.gridCtrl;
        var s = r.gridOptionsService.getDocument();
        e.addKeyboardModeEvents(s, r.gridCtrl), r.addDestroyFunc(function() {
          return r.unregisterGridCompController(r.gridCtrl);
        });
      });
    }, t.prototype.unregisterGridCompController = function(r) {
      var o = this.gridOptionsService.getDocument();
      e.removeKeyboardModeEvents(o, r);
    }, t.prototype.onColumnEverythingChanged = function() {
      if (this.focusedCellPosition) {
        var r = this.focusedCellPosition.column, o = this.columnModel.getGridColumn(r.getId());
        r !== o && this.clearFocusedCell();
      }
    }, t.prototype.isKeyboardMode = function() {
      return e.keyboardModeActive;
    }, t.prototype.getFocusCellToUseAfterRefresh = function() {
      var r = this.gridOptionsService.getDocument();
      return this.gridOptionsService.is("suppressFocusAfterRefresh") || !this.focusedCellPosition || this.isDomDataMissingInHierarchy(r.activeElement, Vo.DOM_DATA_KEY_ROW_CTRL) ? null : this.focusedCellPosition;
    }, t.prototype.getFocusHeaderToUseAfterRefresh = function() {
      var r = this.gridOptionsService.getDocument();
      return this.gridOptionsService.is("suppressFocusAfterRefresh") || !this.focusedHeaderPosition || this.isDomDataMissingInHierarchy(r.activeElement, Ui.DOM_DATA_KEY_HEADER_CTRL) ? null : this.focusedHeaderPosition;
    }, t.prototype.isDomDataMissingInHierarchy = function(r, o) {
      for (var n = r; n; ) {
        var s = this.gridOptionsService.getDomData(n, o);
        if (s)
          return !1;
        n = n.parentNode;
      }
      return !0;
    }, t.prototype.getFocusedCell = function() {
      return this.focusedCellPosition;
    }, t.prototype.getFocusEventParams = function() {
      var r = this.focusedCellPosition, o = r.rowIndex, n = r.rowPinned, s = r.column, a = {
        rowIndex: o,
        rowPinned: n,
        column: s,
        isFullWidthCell: !1
      }, l = this.rowRenderer.getRowByPosition({ rowIndex: o, rowPinned: n });
      return l && (a.isFullWidthCell = l.isFullWidth()), a;
    }, t.prototype.clearFocusedCell = function() {
      if (this.focusedCellPosition != null) {
        var r = Pi({ type: m.EVENT_CELL_FOCUS_CLEARED }, this.getFocusEventParams());
        this.focusedCellPosition = null, this.eventService.dispatchEvent(r);
      }
    }, t.prototype.setFocusedCell = function(r) {
      var o = r.column, n = r.rowIndex, s = r.rowPinned, a = r.forceBrowserFocus, l = a === void 0 ? !1 : a, u = r.preventScrollOnBrowserFocus, c = u === void 0 ? !1 : u, p = this.columnModel.getGridColumn(o);
      if (!p) {
        this.focusedCellPosition = null;
        return;
      }
      this.focusedCellPosition = p ? {
        rowIndex: n,
        rowPinned: Go(s),
        column: p
      } : null;
      var d = Pi(Pi({ type: m.EVENT_CELL_FOCUSED }, this.getFocusEventParams()), {
        forceBrowserFocus: l,
        preventScrollOnBrowserFocus: c,
        floating: null
      });
      this.eventService.dispatchEvent(d);
    }, t.prototype.isCellFocused = function(r) {
      return this.focusedCellPosition == null ? !1 : this.focusedCellPosition.column === r.column && this.isRowFocused(r.rowIndex, r.rowPinned);
    }, t.prototype.isRowNodeFocused = function(r) {
      return this.isRowFocused(r.rowIndex, r.rowPinned);
    }, t.prototype.isHeaderWrapperFocused = function(r) {
      if (this.focusedHeaderPosition == null)
        return !1;
      var o = r.getColumnGroupChild(), n = r.getRowIndex(), s = r.getPinned(), a = this.focusedHeaderPosition, l = a.column, u = a.headerRowIndex;
      return o === l && n === u && s == l.getPinned();
    }, t.prototype.clearFocusedHeader = function() {
      this.focusedHeaderPosition = null;
    }, t.prototype.getFocusedHeader = function() {
      return this.focusedHeaderPosition;
    }, t.prototype.setFocusedHeader = function(r, o) {
      this.focusedHeaderPosition = { headerRowIndex: r, column: o };
    }, t.prototype.focusHeaderPosition = function(r) {
      var o = r.direction, n = r.fromTab, s = r.allowUserOverride, a = r.event, l = r.headerPosition;
      if (s) {
        var u = this.getFocusedHeader(), c = this.headerNavigationService.getHeaderRowCount();
        if (n) {
          var p = this.gridOptionsService.getCallback("tabToNextHeader");
          if (p) {
            var d = {
              backwards: o === "Before",
              previousHeaderPosition: u,
              nextHeaderPosition: l,
              headerRowCount: c
            };
            l = p(d);
          }
        } else {
          var p = this.gridOptionsService.getCallback("navigateToNextHeader");
          if (p && a) {
            var h = {
              key: a.key,
              previousHeaderPosition: u,
              nextHeaderPosition: l,
              headerRowCount: c,
              event: a
            };
            l = p(h);
          }
        }
      }
      if (!l)
        return !1;
      if (l.headerRowIndex === -1)
        return this.focusGridView(l.column);
      this.headerNavigationService.scrollToColumn(l.column, o);
      var g = this.ctrlsService.getHeaderRowContainerCtrl(l.column.getPinned()), y = g.focusHeader(l.headerRowIndex, l.column, a);
      return y;
    }, t.prototype.focusFirstHeader = function() {
      var r = this.columnModel.getAllDisplayedColumns()[0];
      return r ? (r.getParent() && (r = this.columnModel.getColumnGroupAtLevel(r, 0)), this.focusHeaderPosition({
        headerPosition: { headerRowIndex: 0, column: r }
      })) : !1;
    }, t.prototype.focusLastHeader = function(r) {
      var o = this.headerNavigationService.getHeaderRowCount() - 1, n = Ne(this.columnModel.getAllDisplayedColumns());
      return this.focusHeaderPosition({
        headerPosition: { headerRowIndex: o, column: n },
        event: r
      });
    }, t.prototype.isAnyCellFocused = function() {
      return !!this.focusedCellPosition;
    }, t.prototype.isRowFocused = function(r, o) {
      return this.focusedCellPosition == null ? !1 : this.focusedCellPosition.rowIndex === r && this.focusedCellPosition.rowPinned === Go(o);
    }, t.prototype.findFocusableElements = function(r, o, n) {
      n === void 0 && (n = !1);
      var s = zf, a = $u;
      o && (a += ", " + o), n && (a += ', [tabindex="-1"]');
      var l = Array.prototype.slice.apply(r.querySelectorAll(s)), u = Array.prototype.slice.apply(r.querySelectorAll(a));
      if (!u.length)
        return l;
      var c = function(p, d) {
        return p.filter(function(h) {
          return d.indexOf(h) === -1;
        });
      };
      return c(l, u);
    }, t.prototype.focusInto = function(r, o, n) {
      o === void 0 && (o = !1), n === void 0 && (n = !1);
      var s = this.findFocusableElements(r, null, n), a = o ? Ne(s) : s[0];
      return a ? (a.focus({ preventScroll: !0 }), !0) : !1;
    }, t.prototype.findFocusableElementBeforeTabGuard = function(r, o) {
      if (!o)
        return null;
      var n = this.findFocusableElements(r), s = n.indexOf(o);
      if (s === -1)
        return null;
      for (var a = -1, l = s - 1; l >= 0; l--)
        if (n[l].classList.contains(pn.TAB_GUARD_TOP)) {
          a = l;
          break;
        }
      return a <= 0 ? null : n[a - 1];
    }, t.prototype.findNextFocusableElement = function(r, o, n) {
      r === void 0 && (r = this.eGridDiv);
      var s = this.findFocusableElements(r, o ? ':not([tabindex="-1"])' : null), a = this.gridOptionsService.getDocument(), l = a.activeElement, u;
      o ? u = s.findIndex(function(p) {
        return p.contains(l);
      }) : u = s.indexOf(l);
      var c = u + (n ? -1 : 1);
      return c < 0 || c >= s.length ? null : s[c];
    }, t.prototype.isTargetUnderManagedComponent = function(r, o) {
      if (!o)
        return !1;
      var n = r.querySelectorAll("." + wo.FOCUS_MANAGED_CLASS);
      if (!n.length)
        return !1;
      for (var s = 0; s < n.length; s++)
        if (n[s].contains(o))
          return !0;
      return !1;
    }, t.prototype.findTabbableParent = function(r, o) {
      o === void 0 && (o = 5);
      for (var n = 0; r && Xs(r) === null && ++n <= o; )
        r = r.parentElement;
      return Xs(r) === null ? null : r;
    }, t.prototype.focusGridView = function(r, o) {
      if (this.gridOptionsService.is("suppressCellFocus"))
        return o ? this.focusLastHeader() : this.focusNextGridCoreContainer(!1);
      var n = o ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();
      if (!n)
        return !1;
      var s = n.rowIndex, a = n.rowPinned, l = this.getFocusedHeader();
      if (!r && l && (r = l.column), s == null || !r)
        return !1;
      if (this.navigationService.ensureCellVisible({ rowIndex: s, column: r, rowPinned: a }), this.setFocusedCell({
        rowIndex: s,
        column: r,
        rowPinned: Go(a),
        forceBrowserFocus: !0
      }), this.rangeService) {
        var u = { rowIndex: s, rowPinned: a, column: r };
        this.rangeService.setRangeToCell(u);
      }
      return !0;
    }, t.prototype.focusNextGridCoreContainer = function(r, o) {
      return o === void 0 && (o = !1), !o && this.gridCtrl.focusNextInnerContainer(r) ? !0 : ((o || !r && !this.gridCtrl.isDetailGrid()) && this.gridCtrl.forceFocusOutOfContainer(r), !1);
    };
    var e;
    return t.AG_KEYBOARD_FOCUS = "ag-keyboard-focus", t.keyboardModeActive = !1, t.instancesMonitored = /* @__PURE__ */ new Map(), qr([
      v("eGridDiv")
    ], t.prototype, "eGridDiv", void 0), qr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), qr([
      v("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), qr([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), qr([
      v("rowPositionUtils")
    ], t.prototype, "rowPositionUtils", void 0), qr([
      Fe("rangeService")
    ], t.prototype, "rangeService", void 0), qr([
      v("navigationService")
    ], t.prototype, "navigationService", void 0), qr([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), qr([
      U
    ], t.prototype, "init", null), t = e = qr([
      te("focusService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ER = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fi = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, RR = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, OR = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(RR(arguments[t]));
  return i;
}, Lo;
(function(i) {
  i[i.vertical = 0] = "vertical", i[i.horizontal = 1] = "horizontal";
})(Lo || (Lo = {}));
var bR = 0, bv = (
  /** @class */
  function(i) {
    ER(t, i);
    function t() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.popupList = [], r;
    }
    e = t, t.prototype.postConstruct = function() {
      var r = this;
      this.ctrlsService.whenReady(function(o) {
        r.gridCtrl = o.gridCtrl, r.addManagedListener(r.gridCtrl, m.EVENT_KEYBOARD_FOCUS, function() {
          r.popupList.forEach(function(n) {
            return n.element.classList.add(Wn.AG_KEYBOARD_FOCUS);
          });
        }), r.addManagedListener(r.gridCtrl, m.EVENT_MOUSE_FOCUS, function() {
          r.popupList.forEach(function(n) {
            return n.element.classList.remove(Wn.AG_KEYBOARD_FOCUS);
          });
        });
      });
    }, t.prototype.getPopupParent = function() {
      var r = this.gridOptionsService.get("popupParent");
      return r || this.gridCtrl.getGui();
    }, t.prototype.positionPopupForMenu = function(r) {
      var o = r.eventSource.getBoundingClientRect(), n = this.getParentRect(), s = this.keepXYWithinBounds(r.ePopup, o.top - n.top, Lo.vertical), a = r.ePopup.clientWidth > 0 ? r.ePopup.clientWidth : 200;
      r.ePopup.style.minWidth = a + "px";
      var l = n.right - n.left, u = l - a, c;
      this.gridOptionsService.is("enableRtl") ? (c = d(), c < 0 && (c = p()), c > u && (c = 0)) : (c = p(), c > u && (c = d()), c < 0 && (c = 0)), r.ePopup.style.left = c + "px", r.ePopup.style.top = s + "px";
      function p() {
        return o.right - n.left - 2;
      }
      function d() {
        return o.left - n.left - a;
      }
    }, t.prototype.positionPopupUnderMouseEvent = function(r) {
      var o = this, n = r.ePopup, s = r.nudgeX, a = r.nudgeY, l = r.skipObserver;
      this.positionPopup({
        ePopup: n,
        nudgeX: s,
        nudgeY: a,
        keepWithinBounds: !0,
        skipObserver: l,
        updatePosition: function() {
          return o.calculatePointerAlign(r.mouseEvent);
        },
        postProcessCallback: function() {
          return o.callPostProcessPopup(r.type, r.ePopup, null, r.mouseEvent, r.column, r.rowNode);
        }
      });
    }, t.prototype.calculatePointerAlign = function(r) {
      var o = this.getParentRect();
      return {
        x: r.clientX - o.left,
        y: r.clientY - o.top
      };
    }, t.prototype.positionPopupByComponent = function(r) {
      var o = this, n = r.eventSource.getBoundingClientRect(), s = r.alignSide || "left", a = r.position || "over", l = this.getParentRect(), u = function() {
        var c = n.left - l.left;
        s === "right" && (c -= r.ePopup.offsetWidth - n.width);
        var p = a === "over" ? n.top - l.top : n.top - l.top + n.height;
        return { x: c, y: p };
      };
      this.positionPopup({
        ePopup: r.ePopup,
        nudgeX: r.nudgeX,
        nudgeY: r.nudgeY,
        keepWithinBounds: r.keepWithinBounds,
        updatePosition: u,
        postProcessCallback: function() {
          return o.callPostProcessPopup(r.type, r.ePopup, r.eventSource, null, r.column, r.rowNode);
        }
      });
    }, t.prototype.callPostProcessPopup = function(r, o, n, s, a, l) {
      var u = this.gridOptionsService.getCallback("postProcessPopup");
      if (u) {
        var c = {
          column: a,
          rowNode: l,
          ePopup: o,
          type: r,
          eventSource: n,
          mouseEvent: s
        };
        u(c);
      }
    }, t.prototype.positionPopup = function(r) {
      var o = this, n = r.ePopup, s = r.keepWithinBounds, a = r.nudgeX, l = r.nudgeY, u = r.skipObserver, c = r.updatePosition, p = { width: 0, height: 0 }, d = function(g) {
        g === void 0 && (g = !1);
        var y = c(), S = y.x, _ = y.y;
        g && n.clientWidth === p.width && n.clientHeight === p.height || (p.width = n.clientWidth, p.height = n.clientHeight, a && (S += a), l && (_ += l), s && (S = o.keepXYWithinBounds(n, S, Lo.horizontal), _ = o.keepXYWithinBounds(n, _, Lo.vertical)), n.style.left = S + "px", n.style.top = _ + "px", r.postProcessCallback && r.postProcessCallback());
      };
      if (d(), !u) {
        var h = this.resizeObserverService.observeResize(n, function() {
          return d(!0);
        });
        setTimeout(function() {
          return h();
        }, e.WAIT_FOR_POPUP_CONTENT_RESIZE);
      }
    }, t.prototype.getActivePopups = function() {
      return this.popupList.map(function(r) {
        return r.element;
      });
    }, t.prototype.getPopupList = function() {
      return this.popupList;
    }, t.prototype.getParentRect = function() {
      var r = this.gridOptionsService.getDocument(), o = this.getPopupParent();
      o === r.body ? o = r.documentElement : getComputedStyle(o).position === "static" && (o = o.offsetParent);
      var n = getComputedStyle(o), s = o.getBoundingClientRect();
      return {
        top: s.top + parseFloat(n.borderTopWidth) || 0,
        left: s.left + parseFloat(n.borderLeftWidth) || 0,
        right: s.right + parseFloat(n.borderRightWidth) || 0,
        bottom: s.bottom + parseFloat(n.borderBottomWidth) || 0
      };
    }, t.prototype.keepXYWithinBounds = function(r, o, n) {
      var s = n === Lo.vertical, a = s ? "clientHeight" : "clientWidth", l = s ? "top" : "left", u = s ? "offsetHeight" : "offsetWidth", c = s ? "scrollTop" : "scrollLeft", p = this.gridOptionsService.getDocument(), d = p.documentElement, h = this.getPopupParent(), g = h.getBoundingClientRect(), y = p.documentElement.getBoundingClientRect(), S = h === p.body, _ = r[u], w = s ? Yu : Da, E = S ? w(d) + d[c] : h[a];
      S && (E -= Math.abs(y[l] - g[l]));
      var R = E - _;
      return Math.min(Math.max(o, 0), Math.abs(R));
    }, t.prototype.keepPopupPositionedRelativeTo = function(r) {
      var o = this, n = this.getPopupParent(), s = n.getBoundingClientRect(), a = r.element.getBoundingClientRect(), l = s.top - a.top, u = s.left - a.left, c = l, p = u, d = r.ePopup.style.top, h = parseInt(d.substring(0, d.length - 1), 10), g = r.ePopup.style.left, y = parseInt(g.substring(0, g.length - 1), 10);
      return new nr(function(S) {
        o.getFrameworkOverrides().setInterval(function() {
          var _ = n.getBoundingClientRect(), w = r.element.getBoundingClientRect(), E = w.top == 0 && w.left == 0 && w.height == 0 && w.width == 0;
          if (E) {
            r.hidePopup();
            return;
          }
          var R = _.top - w.top;
          if (R != c) {
            var D = o.keepXYWithinBounds(r.ePopup, h + l - R, Lo.vertical);
            r.ePopup.style.top = D + "px";
          }
          c = R;
          var B = _.left - w.left;
          if (B != p) {
            var H = o.keepXYWithinBounds(r.ePopup, y + u - B, Lo.horizontal);
            r.ePopup.style.left = H + "px";
          }
          p = B;
        }, 200).then(function(_) {
          var w = function() {
            _ != null && window.clearInterval(_);
          };
          S(w);
        });
      });
    }, t.prototype.addPopup = function(r) {
      var o, n = this, s = r.modal, a = r.eChild, l = r.closeOnEsc, u = r.closedCallback, c = r.click, p = r.alwaysOnTop, d = r.afterGuiAttached, h = r.positionCallback, g = r.anchorToElement, y = r.ariaLabel, S = this.gridOptionsService.getDocument(), _ = new nr(function(J) {
        return J(function() {
        });
      });
      if (!S)
        return console.warn("AG Grid: could not find the document, document is empty"), { hideFunc: function() {
        }, stopAnchoringPromise: _ };
      var w = this.popupList.findIndex(function(J) {
        return J.element === a;
      });
      if (w !== -1) {
        var E = this.popupList[w];
        return { hideFunc: E.hideFunc, stopAnchoringPromise: E.stopAnchoringPromise };
      }
      var R = this.getPopupParent();
      a.style.top == null && (a.style.top = "0px"), a.style.left == null && (a.style.left = "0px");
      var D = document.createElement("div"), B = this.environment.getTheme().allThemes;
      B.length && (o = D.classList).add.apply(o, OR(B)), D.classList.add("ag-popup"), a.classList.add(this.gridOptionsService.is("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child"), a.hasAttribute("role") || Dt(a, "dialog"), yn(a, y), this.focusService.isKeyboardMode() && a.classList.add(Wn.AG_KEYBOARD_FOCUS), D.appendChild(a), R.appendChild(D), p ? this.setAlwaysOnTop(D, !0) : this.bringPopupToFront(D);
      var H = !1, A = function(J) {
        if (D.contains(S.activeElement)) {
          var de = J.key;
          de === L.ESCAPE && W({ keyboardEvent: J });
        }
      }, N = function(J) {
        return W({ mouseEvent: J });
      }, G = function(J) {
        return W({ touchEvent: J });
      }, W = function(J) {
        J === void 0 && (J = {});
        var de = J.mouseEvent, ve = J.touchEvent, oe = J.keyboardEvent;
        // we don't hide popup if the event was on the child, or any
        // children of this child
        n.isEventFromCurrentPopup({ mouseEvent: de, touchEvent: ve }, a) || // if the event to close is actually the open event, then ignore it
        n.isEventSameChainAsOriginalEvent({ originalMouseEvent: c, mouseEvent: de, touchEvent: ve }) || // this method should only be called once. the client can have different
        // paths, each one wanting to close, so this method may be called multiple times.
        H || (H = !0, R.removeChild(D), S.removeEventListener("keydown", A), S.removeEventListener("mousedown", N), S.removeEventListener("touchstart", G), S.removeEventListener("contextmenu", N), n.eventService.removeEventListener(m.EVENT_DRAG_STARTED, N), u && u(de || ve || oe), n.popupList = n.popupList.filter(function(ne) {
          return ne.element !== a;
        }), _ && _.then(function(ne) {
          return ne && ne();
        }));
      };
      return d && d({ hidePopup: W }), window.setTimeout(function() {
        l && S.addEventListener("keydown", A), s && (S.addEventListener("mousedown", N), n.eventService.addEventListener(m.EVENT_DRAG_STARTED, N), S.addEventListener("touchstart", G), S.addEventListener("contextmenu", N));
      }, 0), h && h(), g && (_ = this.keepPopupPositionedRelativeTo({
        element: g,
        ePopup: a,
        hidePopup: W
      })), this.popupList.push({
        element: a,
        wrapper: D,
        hideFunc: W,
        stopAnchoringPromise: _,
        instanceId: bR++,
        isAnchored: !!g
      }), {
        hideFunc: W,
        stopAnchoringPromise: _
      };
    }, t.prototype.hasAnchoredPopup = function() {
      return this.popupList.some(function(r) {
        return r.isAnchored;
      });
    }, t.prototype.isEventFromCurrentPopup = function(r, o) {
      var n = r.mouseEvent, s = r.touchEvent, a = n || s;
      if (!a)
        return !1;
      var l = this.popupList.findIndex(function(p) {
        return p.element === o;
      });
      if (l === -1)
        return !1;
      for (var u = l; u < this.popupList.length; u++) {
        var c = this.popupList[u];
        if (qs(c.element, a))
          return !0;
      }
      return this.isElementWithinCustomPopup(a.target);
    }, t.prototype.isElementWithinCustomPopup = function(r) {
      for (var o = this.gridOptionsService.getDocument(); r && r !== o.body; ) {
        if (r.classList.contains("ag-custom-component-popup") || r.parentElement === null)
          return !0;
        r = r.parentElement;
      }
      return !1;
    }, t.prototype.isEventSameChainAsOriginalEvent = function(r) {
      var o = r.originalMouseEvent, n = r.mouseEvent, s = r.touchEvent, a = null;
      if (n ? a = n : s && (a = s.touches[0]), a && o) {
        var l = n ? n.screenX : 0, u = n ? n.screenY : 0, c = Math.abs(o.screenX - l) < 5, p = Math.abs(o.screenY - u) < 5;
        if (c && p)
          return !0;
      }
      return !1;
    }, t.prototype.getWrapper = function(r) {
      for (; !r.classList.contains("ag-popup") && r.parentElement; )
        r = r.parentElement;
      return r.classList.contains("ag-popup") ? r : null;
    }, t.prototype.setAlwaysOnTop = function(r, o) {
      var n = this.getWrapper(r);
      n && (n.classList.toggle("ag-always-on-top", !!o), o && this.bringPopupToFront(n));
    }, t.prototype.bringPopupToFront = function(r) {
      var o = this.getPopupParent(), n = Array.prototype.slice.call(o.querySelectorAll(".ag-popup")), s = n.length, a = Array.prototype.slice.call(o.querySelectorAll(".ag-popup.ag-always-on-top")), l = a.length, u = this.getWrapper(r);
      if (!(!u || s <= 1 || !o.contains(r))) {
        var c = n.indexOf(u), p = u.querySelectorAll("div"), d = [];
        if (p.forEach(function(S) {
          S.scrollTop !== 0 && d.push([S, S.scrollTop]);
        }), l) {
          var h = u.classList.contains("ag-always-on-top");
          h ? c !== s - 1 && Ne(a).insertAdjacentElement("afterend", u) : c !== s - l - 1 && a[0].insertAdjacentElement("beforebegin", u);
        } else
          c !== s - 1 && Ne(n).insertAdjacentElement("afterend", u);
        for (; d.length; ) {
          var g = d.pop();
          g[0].scrollTop = g[1];
        }
        var y = {
          type: "popupToFront",
          api: this.gridOptionsService.api,
          columnApi: this.gridOptionsService.columnApi,
          eWrapper: u
        };
        this.eventService.dispatchEvent(y);
      }
    };
    var e;
    return t.WAIT_FOR_POPUP_CONTENT_RESIZE = 200, fi([
      v("focusService")
    ], t.prototype, "focusService", void 0), fi([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), fi([
      v("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), fi([
      U
    ], t.prototype, "postConstruct", null), t = e = fi([
      te("popupService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var TR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Fl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, PR = (
  /** @class */
  function(i) {
    TR(t, i);
    function t(e, r, o) {
      e === void 0 && (e = "default"), r === void 0 && (r = "listbox");
      var n = i.call(this, t.getTemplate(e)) || this;
      return n.cssIdentifier = e, n.ariaRole = r, n.listName = o, n.renderedRows = /* @__PURE__ */ new Map(), n.rowHeight = 20, n;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.addScrollListener(), this.rowHeight = this.getItemHeight(), this.addResizeObserver(), this.initialiseTabGuard({
        onFocusIn: function(r) {
          return e.onFocusIn(r);
        },
        onFocusOut: function(r) {
          return e.onFocusOut(r);
        },
        focusInnerElement: function(r) {
          return e.focusInnerElement(r);
        },
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        }
      }), this.setAriaProperties(), this.addManagedListener(this.eventService, m.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanged.bind(this));
    }, t.prototype.onGridStylesChanged = function() {
      this.rowHeight = this.getItemHeight(), this.refresh();
    }, t.prototype.setAriaProperties = function() {
      var e = this.localeService.getLocaleTextFunc(), r = e("ariaDefaultListName", this.listName || "List"), o = this.eContainer;
      Dt(o, this.ariaRole), yn(o, r);
    }, t.prototype.addResizeObserver = function() {
      var e = this, r = function() {
        return e.drawVirtualRows();
      }, o = this.resizeObserverService.observeResize(this.getGui(), r);
      this.addDestroyFunc(o);
    }, t.prototype.focusInnerElement = function(e) {
      this.focusRow(e ? this.model.getRowCount() - 1 : 0);
    }, t.prototype.onFocusIn = function(e) {
      var r = e.target;
      return r.classList.contains("ag-virtual-list-item") && (this.lastFocusedRowIndex = Tf(r) - 1), !1;
    }, t.prototype.onFocusOut = function(e) {
      return this.getFocusableElement().contains(e.relatedTarget) || (this.lastFocusedRowIndex = null), !1;
    }, t.prototype.handleKeyDown = function(e) {
      switch (e.key) {
        case L.UP:
        case L.DOWN:
          this.navigate(e.key === L.UP) && e.preventDefault();
          break;
      }
    }, t.prototype.onTabKeyDown = function(e) {
      this.navigate(e.shiftKey) ? e.preventDefault() : this.forceFocusOutOfContainer(e.shiftKey);
    }, t.prototype.navigate = function(e) {
      if (this.lastFocusedRowIndex == null)
        return !1;
      var r = this.lastFocusedRowIndex + (e ? -1 : 1);
      return r < 0 || r >= this.model.getRowCount() ? !1 : (this.focusRow(r), !0);
    }, t.prototype.getLastFocusedRow = function() {
      return this.lastFocusedRowIndex;
    }, t.prototype.focusRow = function(e) {
      var r = this;
      this.ensureIndexVisible(e), window.setTimeout(function() {
        if (r.isAlive()) {
          var o = r.renderedRows.get(e);
          o && o.eDiv.focus();
        }
      }, 10);
    }, t.prototype.getComponentAt = function(e) {
      var r = this.renderedRows.get(e);
      return r && r.rowComponent;
    }, t.prototype.forEachRenderedRow = function(e) {
      this.renderedRows.forEach(function(r, o) {
        return e(r.rowComponent, o);
      });
    }, t.getTemplate = function(e) {
      return (
        /* html */
        `
            <div class="ag-virtual-list-viewport ag-` + e + `-virtual-list-viewport" role="presentation">
                <div class="ag-virtual-list-container ag-` + e + `-virtual-list-container" ref="eContainer"></div>
            </div>`
      );
    }, t.prototype.getItemHeight = function() {
      return this.environment.getListItemHeight();
    }, t.prototype.ensureIndexVisible = function(e) {
      var r = this.model.getRowCount();
      if (typeof e != "number" || e < 0 || e >= r) {
        console.warn("AG Grid: invalid row index for ensureIndexVisible: " + e);
        return;
      }
      var o = e * this.rowHeight, n = o + this.rowHeight, s = this.getGui(), a = s.scrollTop, l = s.offsetHeight, u = a + l, c = a > o, p = u < n;
      if (c)
        s.scrollTop = o;
      else if (p) {
        var d = n - l;
        s.scrollTop = d;
      }
    }, t.prototype.setComponentCreator = function(e) {
      this.componentCreator = e;
    }, t.prototype.setComponentUpdater = function(e) {
      this.componentUpdater = e;
    }, t.prototype.getRowHeight = function() {
      return this.rowHeight;
    }, t.prototype.getScrollTop = function() {
      return this.getGui().scrollTop;
    }, t.prototype.setRowHeight = function(e) {
      this.rowHeight = e, this.refresh();
    }, t.prototype.refresh = function(e) {
      var r = this;
      if (!(this.model == null || !this.isAlive())) {
        var o = this.model.getRowCount();
        this.eContainer.style.height = o * this.rowHeight + "px", rf(function() {
          return r.eContainer.clientHeight >= o * r.rowHeight;
        }, function() {
          r.isAlive() && (r.canSoftRefresh(e) ? r.drawVirtualRows(!0) : (r.clearVirtualRows(), r.drawVirtualRows()));
        });
      }
    }, t.prototype.canSoftRefresh = function(e) {
      return !!(e && this.renderedRows.size && typeof this.model.areRowsEqual == "function" && this.componentUpdater);
    }, t.prototype.clearVirtualRows = function() {
      var e = this;
      this.renderedRows.forEach(function(r, o) {
        return e.removeRow(o);
      });
    }, t.prototype.drawVirtualRows = function(e) {
      if (this.isAlive()) {
        var r = this.getGui(), o = r.scrollTop, n = o + r.offsetHeight, s = Math.floor(o / this.rowHeight), a = Math.floor(n / this.rowHeight);
        this.ensureRowsRendered(s, a, e);
      }
    }, t.prototype.ensureRowsRendered = function(e, r, o) {
      var n = this;
      this.renderedRows.forEach(function(a, l) {
        (l < e || l > r) && l !== n.lastFocusedRowIndex && n.removeRow(l);
      }), o && this.refreshRows();
      for (var s = e; s <= r; s++)
        this.renderedRows.has(s) || s < this.model.getRowCount() && this.insertRow(s);
    }, t.prototype.insertRow = function(e) {
      var r = this, o = this.model.getRow(e), n = document.createElement("div");
      if (n.classList.add("ag-virtual-list-item", "ag-" + this.cssIdentifier + "-virtual-list-item"), Dt(n, this.ariaRole === "tree" ? "treeitem" : "option"), Hu(n, this.model.getRowCount()), Vu(n, e + 1), n.setAttribute("tabindex", "-1"), typeof this.model.isRowSelected == "function") {
        var s = this.model.isRowSelected(e);
        $n(n, !!s), Hf(n, s);
      }
      n.style.height = this.rowHeight + "px", n.style.top = this.rowHeight * e + "px";
      var a = this.componentCreator(o, n);
      a.addGuiEventListener("focusin", function() {
        return r.lastFocusedRowIndex = e;
      }), n.appendChild(a.getGui()), this.renderedRows.has(e - 1) ? this.renderedRows.get(e - 1).eDiv.insertAdjacentElement("afterend", n) : this.renderedRows.has(e + 1) ? this.renderedRows.get(e + 1).eDiv.insertAdjacentElement("beforebegin", n) : this.eContainer.appendChild(n), this.renderedRows.set(e, { rowComponent: a, eDiv: n, value: o });
    }, t.prototype.removeRow = function(e) {
      var r = this.renderedRows.get(e);
      this.eContainer.removeChild(r.eDiv), this.destroyBean(r.rowComponent), this.renderedRows.delete(e);
    }, t.prototype.refreshRows = function() {
      var e = this, r = this.model.getRowCount();
      this.renderedRows.forEach(function(o, n) {
        var s, a;
        if (n >= r)
          e.removeRow(n);
        else {
          var l = e.model.getRow(n);
          !((a = (s = e.model).areRowsEqual) === null || a === void 0) && a.call(s, o.value, l) ? e.componentUpdater(l, o.rowComponent) : e.removeRow(n);
        }
      });
    }, t.prototype.addScrollListener = function() {
      var e = this;
      this.addGuiEventListener("scroll", function() {
        return e.drawVirtualRows();
      }, { passive: !0 });
    }, t.prototype.setModel = function(e) {
      this.model = e;
    }, t.prototype.destroy = function() {
      this.isAlive() && (this.clearVirtualRows(), i.prototype.destroy.call(this));
    }, Fl([
      v("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Fl([
      Y("eContainer")
    ], t.prototype, "eContainer", void 0), Fl([
      U
    ], t.prototype, "postConstruct", null), t;
  }(zi)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var DR = ["mouseover", "mouseout", "mouseenter", "mouseleave"], AR = ["touchstart", "touchend", "touchmove", "touchcancel"], Tv = (
  /** @class */
  function() {
    function i() {
      this.isOutsideAngular = function(t) {
        return _r(DR, t);
      };
    }
    return i.prototype.setTimeout = function(t, e) {
      window.setTimeout(t, e);
    }, i.prototype.setInterval = function(t, e) {
      return new nr(function(r) {
        r(window.setInterval(t, e));
      });
    }, i.prototype.addEventListener = function(t, e, r, o) {
      var n = _r(AR, e);
      t.addEventListener(e, r, { capture: !!o, passive: n });
    }, i.prototype.dispatchEvent = function(t, e, r) {
      e();
    }, i.prototype.frameworkComponent = function(t) {
      return null;
    }, i.prototype.isFrameworkComponent = function(t) {
      return !1;
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var xR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), In = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, FR = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, MR = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(FR(arguments[t]));
  return i;
}, Pv = (
  /** @class */
  function(i) {
    xR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.getNextCellToFocus = function(e, r, o) {
      return o === void 0 && (o = !1), o ? this.getNextCellToFocusWithCtrlPressed(e, r) : this.getNextCellToFocusWithoutCtrlPressed(e, r);
    }, t.prototype.getNextCellToFocusWithCtrlPressed = function(e, r) {
      var o = e === L.UP, n = e === L.DOWN, s = e === L.LEFT, a, l;
      if (o || n)
        l = o ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow(), a = r.column;
      else {
        var u = this.columnModel.getAllDisplayedColumns(), c = this.gridOptionsService.is("enableRtl");
        l = r.rowIndex, a = s !== c ? u[0] : Ne(u);
      }
      return {
        rowIndex: l,
        rowPinned: null,
        column: a
      };
    }, t.prototype.getNextCellToFocusWithoutCtrlPressed = function(e, r) {
      for (var o = r, n = !1; !n; ) {
        switch (e) {
          case L.UP:
            o = this.getCellAbove(o);
            break;
          case L.DOWN:
            o = this.getCellBelow(o);
            break;
          case L.RIGHT:
            this.gridOptionsService.is("enableRtl") ? o = this.getCellToLeft(o) : o = this.getCellToRight(o);
            break;
          case L.LEFT:
            this.gridOptionsService.is("enableRtl") ? o = this.getCellToRight(o) : o = this.getCellToLeft(o);
            break;
          default:
            o = null, console.warn("AG Grid: unknown key for navigation " + e);
            break;
        }
        o ? n = this.isCellGoodToFocusOn(o) : n = !0;
      }
      return o;
    }, t.prototype.isCellGoodToFocusOn = function(e) {
      var r = e.column, o;
      switch (e.rowPinned) {
        case "top":
          o = this.pinnedRowModel.getPinnedTopRow(e.rowIndex);
          break;
        case "bottom":
          o = this.pinnedRowModel.getPinnedBottomRow(e.rowIndex);
          break;
        default:
          o = this.rowModel.getRow(e.rowIndex);
          break;
      }
      if (!o)
        return !1;
      var n = r.isSuppressNavigable(o);
      return !n;
    }, t.prototype.getCellToLeft = function(e) {
      if (!e)
        return null;
      var r = this.columnModel.getDisplayedColBefore(e.column);
      return r ? {
        rowIndex: e.rowIndex,
        column: r,
        rowPinned: e.rowPinned
      } : null;
    }, t.prototype.getCellToRight = function(e) {
      if (!e)
        return null;
      var r = this.columnModel.getDisplayedColAfter(e.column);
      return r ? {
        rowIndex: e.rowIndex,
        column: r,
        rowPinned: e.rowPinned
      } : null;
    }, t.prototype.getRowBelow = function(e) {
      var r = e.rowIndex, o = e.rowPinned;
      if (this.isLastRowInContainer(e))
        switch (o) {
          case "bottom":
            return null;
          case "top":
            return this.rowModel.isRowsToRender() ? { rowIndex: this.paginationProxy.getPageFirstRow(), rowPinned: null } : this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
          default:
            return this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
        }
      var n = this.rowModel.getRow(e.rowIndex), s = this.getNextStickyPosition(n);
      return s || { rowIndex: r + 1, rowPinned: o };
    }, t.prototype.getNextStickyPosition = function(e, r) {
      if (!(!this.gridOptionsService.is("groupRowsSticky") || !e || !e.sticky)) {
        var o = MR(this.rowRenderer.getStickyTopRowCtrls()).sort(function(l, u) {
          return l.getRowNode().rowIndex - u.getRowNode().rowIndex;
        }), n = r ? -1 : 1, s = o.findIndex(function(l) {
          return l.getRowNode().rowIndex === e.rowIndex;
        }), a = o[s + n];
        if (a)
          return { rowIndex: a.getRowNode().rowIndex, rowPinned: null };
      }
    }, t.prototype.getCellBelow = function(e) {
      if (!e)
        return null;
      var r = this.getRowBelow(e);
      return r ? {
        rowIndex: r.rowIndex,
        column: e.column,
        rowPinned: r.rowPinned
      } : null;
    }, t.prototype.isLastRowInContainer = function(e) {
      var r = e.rowPinned, o = e.rowIndex;
      if (r === "top") {
        var n = this.pinnedRowModel.getPinnedTopRowData().length - 1;
        return n <= o;
      }
      if (r === "bottom") {
        var s = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
        return s <= o;
      }
      var a = this.paginationProxy.getPageLastRow();
      return a <= o;
    }, t.prototype.getRowAbove = function(e) {
      var r = e.rowIndex, o = e.rowPinned, n = o ? r === 0 : r === this.paginationProxy.getPageFirstRow();
      if (n)
        return o === "top" ? null : o ? this.rowModel.isRowsToRender() ? this.getLastBodyCell() : this.pinnedRowModel.isRowsToRender("top") ? this.getLastFloatingTopRow() : null : this.pinnedRowModel.isRowsToRender("top") ? this.getLastFloatingTopRow() : null;
      var s = this.rowModel.getRow(e.rowIndex), a = this.getNextStickyPosition(s, !0);
      return a || { rowIndex: r - 1, rowPinned: o };
    }, t.prototype.getCellAbove = function(e) {
      if (!e)
        return null;
      var r = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
      return r ? {
        rowIndex: r.rowIndex,
        column: e.column,
        rowPinned: r.rowPinned
      } : null;
    }, t.prototype.getLastBodyCell = function() {
      var e = this.paginationProxy.getPageLastRow();
      return { rowIndex: e, rowPinned: null };
    }, t.prototype.getLastFloatingTopRow = function() {
      var e = this.pinnedRowModel.getPinnedTopRowData().length - 1;
      return { rowIndex: e, rowPinned: "top" };
    }, t.prototype.getNextTabbedCell = function(e, r) {
      return r ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
    }, t.prototype.getNextTabbedCellForwards = function(e) {
      var r = this.columnModel.getAllDisplayedColumns(), o = e.rowIndex, n = e.rowPinned, s = this.columnModel.getDisplayedColAfter(e.column);
      if (!s) {
        s = r[0];
        var a = this.getRowBelow(e);
        if (ue(a) || !a.rowPinned && !this.paginationProxy.isRowInPage(a))
          return null;
        o = a ? a.rowIndex : null, n = a ? a.rowPinned : null;
      }
      return { rowIndex: o, column: s, rowPinned: n };
    }, t.prototype.getNextTabbedCellBackwards = function(e) {
      var r = this.columnModel.getAllDisplayedColumns(), o = e.rowIndex, n = e.rowPinned, s = this.columnModel.getDisplayedColBefore(e.column);
      if (!s) {
        s = Ne(r);
        var a = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
        if (ue(a) || !a.rowPinned && !this.paginationProxy.isRowInPage(a))
          return null;
        o = a ? a.rowIndex : null, n = a ? a.rowPinned : null;
      }
      return { rowIndex: o, column: s, rowPinned: n };
    }, In([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), In([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), In([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), In([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), In([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), t = In([
      te("cellNavigationService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var IR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), hi = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, LR = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, Dv = (
  /** @class */
  function(i) {
    IR(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.consuming = !1, e;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("AlignedGridsService");
    }, t.prototype.init = function() {
      this.addManagedListener(this.eventService, m.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, m.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
    }, t.prototype.fireEvent = function(e) {
      if (!this.consuming) {
        var r = this.gridOptionsService.get("alignedGrids");
        r && r.forEach(function(o) {
          if (o.api) {
            var n = o.api.__getAlignedGridService();
            e(n);
          }
        });
      }
    }, t.prototype.onEvent = function(e) {
      this.consuming = !0, e(), this.consuming = !1;
    }, t.prototype.fireColumnEvent = function(e) {
      this.fireEvent(function(r) {
        r.onColumnEvent(e);
      });
    }, t.prototype.fireScrollEvent = function(e) {
      e.direction === "horizontal" && this.fireEvent(function(r) {
        r.onScrollEvent(e);
      });
    }, t.prototype.onScrollEvent = function(e) {
      var r = this;
      this.onEvent(function() {
        var o = r.ctrlsService.getGridBodyCtrl();
        o.getScrollFeature().setHorizontalScrollPosition(e.left);
      });
    }, t.prototype.getMasterColumns = function(e) {
      var r = [];
      return e.columns ? e.columns.forEach(function(o) {
        r.push(o);
      }) : e.column && r.push(e.column), r;
    }, t.prototype.getColumnIds = function(e) {
      var r = [];
      return e.columns ? e.columns.forEach(function(o) {
        r.push(o.getColId());
      }) : e.column && r.push(e.column.getColId()), r;
    }, t.prototype.onColumnEvent = function(e) {
      var r = this;
      this.onEvent(function() {
        switch (e.type) {
          case m.EVENT_COLUMN_MOVED:
          case m.EVENT_COLUMN_VISIBLE:
          case m.EVENT_COLUMN_PINNED:
          case m.EVENT_COLUMN_RESIZED:
            var o = e;
            r.processColumnEvent(o);
            break;
          case m.EVENT_COLUMN_GROUP_OPENED:
            var n = e;
            r.processGroupOpenedEvent(n);
            break;
          case m.EVENT_COLUMN_PIVOT_CHANGED:
            console.warn("AG Grid: pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.");
            break;
        }
      });
    }, t.prototype.processGroupOpenedEvent = function(e) {
      var r = e.columnGroup, o = null;
      if (r) {
        var n = r.getGroupId();
        o = this.columnModel.getProvidedColumnGroup(n);
      }
      r && !o || (this.logger.log("onColumnEvent-> processing " + e + " expanded = " + r.isExpanded()), this.columnModel.setColumnGroupOpened(o, r.isExpanded(), "alignedGridChanged"));
    }, t.prototype.processColumnEvent = function(e) {
      var r = this, o, n = e.column, s = null;
      if (n && (s = this.columnModel.getPrimaryColumn(n.getColId())), !(n && !s)) {
        var a = this.getMasterColumns(e);
        switch (e.type) {
          case m.EVENT_COLUMN_MOVED:
            {
              var l = e, u = e.columnApi.getColumnState(), c = u.map(function(w) {
                return { colId: w.colId };
              });
              this.columnModel.applyColumnState({ state: c, applyOrder: !0 }, "alignedGridChanged"), this.logger.log("onColumnEvent-> processing " + e.type + " toIndex = " + l.toIndex);
            }
            break;
          case m.EVENT_COLUMN_VISIBLE:
            {
              var p = e, u = e.columnApi.getColumnState(), c = u.map(function(R) {
                return { colId: R.colId, hide: R.hide };
              });
              this.columnModel.applyColumnState({ state: c }, "alignedGridChanged"), this.logger.log("onColumnEvent-> processing " + e.type + " visible = " + p.visible);
            }
            break;
          case m.EVENT_COLUMN_PINNED:
            {
              var d = e, u = e.columnApi.getColumnState(), c = u.map(function(R) {
                return { colId: R.colId, pinned: R.pinned };
              });
              this.columnModel.applyColumnState({ state: c }, "alignedGridChanged"), this.logger.log("onColumnEvent-> processing " + e.type + " pinned = " + d.pinned);
            }
            break;
          case m.EVENT_COLUMN_RESIZED:
            var h = e, g = {};
            a.forEach(function(w) {
              r.logger.log("onColumnEvent-> processing " + e.type + " actualWidth = " + w.getActualWidth()), g[w.getId()] = { key: w.getColId(), newWidth: w.getActualWidth() };
            }), (o = h.flexColumns) === null || o === void 0 || o.forEach(function(w) {
              g[w.getId()] && delete g[w.getId()];
            }), this.columnModel.setColumnWidths(Object.values(g), !1, h.finished, "alignedGridChanged");
            break;
        }
        var y = this.ctrlsService.getGridBodyCtrl(), S = y.isVerticalScrollShowing(), _ = this.gridOptionsService.get("alignedGrids");
        _ && _.forEach(function(w) {
          w.api && w.api.setAlwaysShowVerticalScroll(S);
        });
      }
    }, hi([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), hi([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), hi([
      LR(0, Bt("loggerFactory"))
    ], t.prototype, "setBeans", null), hi([
      U
    ], t.prototype, "init", null), t = hi([
      te("alignedGridsService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var NR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ca = function() {
  return ca = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ca.apply(this, arguments);
}, vi = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, GR = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, HR = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, VR = (
  /** @class */
  function(i) {
    NR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("selectionService"), this.reset();
    }, t.prototype.init = function() {
      var e = this;
      this.groupSelectsChildren = this.gridOptionsService.is("groupSelectsChildren"), this.addManagedPropertyListener("groupSelectsChildren", function(r) {
        return e.groupSelectsChildren = r.currentValue;
      }), this.rowSelection = this.gridOptionsService.get("rowSelection"), this.addManagedPropertyListener("rowSelection", function(r) {
        return e.rowSelection = r.currentValue;
      }), this.addManagedListener(this.eventService, m.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    }, t.prototype.isMultiselect = function() {
      return this.rowSelection === "multiple";
    }, t.prototype.setNodeSelected = function(e) {
      var r, o = e.newValue, n = e.clearSelection, s = e.suppressFinishActions, a = e.rangeSelect;
      e.event;
      var l = e.node, u = e.source, c = u === void 0 ? "api" : u, p = this.groupSelectsChildren && e.groupSelectsFiltered === !0;
      if (l.id === void 0)
        return console.warn("AG Grid: cannot select node until id for node is known"), 0;
      if (l.rowPinned)
        return console.warn("AG Grid: cannot select pinned rows"), 0;
      if (l.footer)
        return this.setNodeSelected(ca(ca({}, e), { node: l.sibling }));
      var d = this.getLastSelectedNode();
      if (a && d) {
        var h = d !== l;
        if (h && this.isMultiselect()) {
          var g = this.selectRange(l, d, e.newValue, c);
          return this.setLastSelectedNode(l), g;
        }
      }
      var y = p && l.group, S = 0;
      if (!y) {
        var _ = l.selectThisNode(o, e.event, c);
        _ && S++;
      }
      if (this.groupSelectsChildren && (!((r = l.childrenAfterGroup) === null || r === void 0) && r.length) && (S += this.selectChildren(l, o, p, c)), !s) {
        var w = o && (n || !this.isMultiselect());
        if (w && (S += this.clearOtherNodes(l, c)), S > 0) {
          this.updateGroupsFromChildrenSelections(c);
          var E = {
            type: m.EVENT_SELECTION_CHANGED,
            source: c
          };
          this.eventService.dispatchEvent(E);
        }
        o && this.setLastSelectedNode(l);
      }
      return S;
    }, t.prototype.selectRange = function(e, r, o, n) {
      var s = this;
      o === void 0 && (o = !0);
      var a = this.rowModel.getNodesInRangeForSelection(e, r), l = 0;
      a.forEach(function(c) {
        if (!(c.group && s.groupSelectsChildren || o === !1 && e === c)) {
          var p = c.selectThisNode(o, void 0, n);
          p && l++;
        }
      }), this.updateGroupsFromChildrenSelections(n);
      var u = {
        type: m.EVENT_SELECTION_CHANGED,
        source: n
      };
      return this.eventService.dispatchEvent(u), l;
    }, t.prototype.selectChildren = function(e, r, o, n) {
      var s = o ? e.childrenAfterAggFilter : e.childrenAfterGroup;
      if (le.missing(s))
        return 0;
      for (var a = 0, l = 0; l < s.length; l++)
        a += s[l].setSelectedParams({
          newValue: r,
          clearSelection: !1,
          suppressFinishActions: !0,
          groupSelectsFiltered: o,
          source: n
        });
      return a;
    }, t.prototype.setLastSelectedNode = function(e) {
      this.lastSelectedNode = e;
    }, t.prototype.getLastSelectedNode = function() {
      return this.lastSelectedNode;
    }, t.prototype.getSelectedNodes = function() {
      var e = [];
      return Ke(this.selectedNodes, function(r, o) {
        o && e.push(o);
      }), e;
    }, t.prototype.getSelectedRows = function() {
      var e = [];
      return Ke(this.selectedNodes, function(r, o) {
        o && o.data && e.push(o.data);
      }), e;
    }, t.prototype.getSelectionCount = function() {
      return Object.values(this.selectedNodes).length;
    }, t.prototype.filterFromSelection = function(e) {
      var r = {};
      Object.entries(this.selectedNodes).forEach(function(o) {
        var n = HR(o, 2), s = n[0], a = n[1], l = a && e(a);
        l && (r[s] = a);
      }), this.selectedNodes = r;
    }, t.prototype.updateGroupsFromChildrenSelections = function(e, r) {
      if (!this.groupSelectsChildren || this.rowModel.getType() !== "clientSide")
        return !1;
      var o = this.rowModel, n = o.getRootNode();
      r || (r = new Na(!0, n), r.setInactive());
      var s = !1;
      return r.forEachChangedNodeDepthFirst(function(a) {
        if (a !== n) {
          var l = a.calculateSelectedFromChildren();
          s = a.selectThisNode(l === null ? !1 : l, void 0, e) || s;
        }
      }), s;
    }, t.prototype.clearOtherNodes = function(e, r) {
      var o = this, n = {}, s = 0;
      return Ke(this.selectedNodes, function(a, l) {
        if (l && l.id !== e.id) {
          var u = o.selectedNodes[l.id];
          s += u.setSelectedParams({
            newValue: !1,
            clearSelection: !1,
            suppressFinishActions: !0,
            source: r
          }), o.groupSelectsChildren && l.parent && (n[l.parent.id] = l.parent);
        }
      }), Ke(n, function(a, l) {
        var u = l.calculateSelectedFromChildren();
        l.selectThisNode(u === null ? !1 : u, void 0, r);
      }), s;
    }, t.prototype.onRowSelected = function(e) {
      var r = e.node;
      this.groupSelectsChildren && r.group || (r.isSelected() ? this.selectedNodes[r.id] = r : delete this.selectedNodes[r.id]);
    }, t.prototype.syncInRowNode = function(e, r) {
      this.syncInOldRowNode(e, r), this.syncInNewRowNode(e);
    }, t.prototype.syncInOldRowNode = function(e, r) {
      var o = k(r) && e.id !== r.id;
      if (o && r) {
        var n = r.id, s = this.selectedNodes[n] == e;
        s && (this.selectedNodes[r.id] = r);
      }
    }, t.prototype.syncInNewRowNode = function(e) {
      k(this.selectedNodes[e.id]) ? (e.setSelectedInitialValue(!0), this.selectedNodes[e.id] = e) : e.setSelectedInitialValue(!1);
    }, t.prototype.reset = function() {
      this.logger.log("reset"), this.selectedNodes = {}, this.lastSelectedNode = null;
    }, t.prototype.getBestCostNodeSelection = function() {
      if (this.rowModel.getType() !== "clientSide")
        return;
      var e = this.rowModel, r = e.getTopLevelNodes();
      if (r === null)
        return;
      var o = [];
      function n(s) {
        for (var a = 0, l = s.length; a < l; a++) {
          var u = s[a];
          if (u.isSelected())
            o.push(u);
          else {
            var c = u;
            c.group && c.children && n(c.children);
          }
        }
      }
      return n(r), o;
    }, t.prototype.isEmpty = function() {
      var e = 0;
      return Ke(this.selectedNodes, function(r, o) {
        o && e++;
      }), e === 0;
    }, t.prototype.deselectAllRowNodes = function(e) {
      var r = function(u) {
        return u.selectThisNode(!1, void 0, n);
      }, o = this.rowModel.getType() === "clientSide", n = e.source, s = e.justFiltered, a = e.justCurrentPage;
      if (a || s) {
        if (!o) {
          console.error("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
          return;
        }
        this.getNodesToSelect(s, a).forEach(r);
      } else
        Ke(this.selectedNodes, function(u, c) {
          c && r(c);
        }), this.reset();
      o && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(n);
      var l = {
        type: m.EVENT_SELECTION_CHANGED,
        source: n
      };
      this.eventService.dispatchEvent(l);
    }, t.prototype.getSelectAllState = function(e, r) {
      var o = this, n = 0, s = 0, a = function(l) {
        o.groupSelectsChildren && l.group || (l.isSelected() ? n++ : l.selectable && s++);
      };
      return this.getNodesToSelect(e, r).forEach(a), n === 0 && s === 0 ? !1 : n > 0 && s > 0 ? null : n > 0;
    }, t.prototype.getNodesToSelect = function(e, r) {
      var o = this;
      if (e === void 0 && (e = !1), r === void 0 && (r = !1), this.rowModel.getType() !== "clientSide")
        throw new Error("selectAll only available when rowModelType='clientSide', ie not " + this.rowModel.getType());
      var n = [];
      if (r)
        return this.paginationProxy.forEachNodeOnPage(function(a) {
          if (!a.group) {
            n.push(a);
            return;
          }
          if (!a.expanded) {
            var l = function(u) {
              var c;
              n.push(u), !((c = u.childrenAfterFilter) === null || c === void 0) && c.length && u.childrenAfterFilter.forEach(l);
            };
            l(a);
            return;
          }
          o.groupSelectsChildren || n.push(a);
        }), n;
      var s = this.rowModel;
      return e ? (s.forEachNodeAfterFilter(function(a) {
        n.push(a);
      }), n) : (s.forEachNode(function(a) {
        n.push(a);
      }), n);
    }, t.prototype.selectAllRowNodes = function(e) {
      if (this.rowModel.getType() !== "clientSide")
        throw new Error("selectAll only available when rowModelType='clientSide', ie not " + this.rowModel.getType());
      var r = e.source, o = e.justFiltered, n = e.justCurrentPage, s = function(l) {
        return l.selectThisNode(!0, void 0, r);
      };
      this.getNodesToSelect(o, n).forEach(s), this.rowModel.getType() === "clientSide" && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(r);
      var a = {
        type: m.EVENT_SELECTION_CHANGED,
        source: r
      };
      this.eventService.dispatchEvent(a);
    }, t.prototype.getServerSideSelectionState = function() {
      return null;
    }, t.prototype.setServerSideSelectionState = function(e) {
    }, vi([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), vi([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), vi([
      GR(0, Bt("loggerFactory"))
    ], t.prototype, "setBeans", null), vi([
      U
    ], t.prototype, "init", null), t = vi([
      te("selectionService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Ml = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Av = (
  /** @class */
  function() {
    function i() {
    }
    return i.prototype.sizeColumnsToFit = function(t) {
      typeof t > "u" && console.error("AG Grid: missing parameter to columnApi.sizeColumnsToFit(gridWidth)"), this.columnModel.sizeColumnsToFit(t, "api");
    }, i.prototype.setColumnGroupOpened = function(t, e) {
      this.columnModel.setColumnGroupOpened(t, e, "api");
    }, i.prototype.getColumnGroup = function(t, e) {
      return this.columnModel.getColumnGroup(t, e);
    }, i.prototype.getProvidedColumnGroup = function(t) {
      return this.columnModel.getProvidedColumnGroup(t);
    }, i.prototype.getDisplayNameForColumn = function(t, e) {
      return this.columnModel.getDisplayNameForColumn(t, e) || "";
    }, i.prototype.getDisplayNameForColumnGroup = function(t, e) {
      return this.columnModel.getDisplayNameForColumnGroup(t, e) || "";
    }, i.prototype.getColumn = function(t) {
      return this.columnModel.getPrimaryColumn(t);
    }, i.prototype.getColumns = function() {
      return this.columnModel.getAllPrimaryColumns();
    }, i.prototype.applyColumnState = function(t) {
      return this.columnModel.applyColumnState(t, "api");
    }, i.prototype.getColumnState = function() {
      return this.columnModel.getColumnState();
    }, i.prototype.resetColumnState = function() {
      this.columnModel.resetColumnState("api");
    }, i.prototype.getColumnGroupState = function() {
      return this.columnModel.getColumnGroupState();
    }, i.prototype.setColumnGroupState = function(t) {
      this.columnModel.setColumnGroupState(t, "api");
    }, i.prototype.resetColumnGroupState = function() {
      this.columnModel.resetColumnGroupState("api");
    }, i.prototype.isPinning = function() {
      return this.columnModel.isPinningLeft() || this.columnModel.isPinningRight();
    }, i.prototype.isPinningLeft = function() {
      return this.columnModel.isPinningLeft();
    }, i.prototype.isPinningRight = function() {
      return this.columnModel.isPinningRight();
    }, i.prototype.getDisplayedColAfter = function(t) {
      return this.columnModel.getDisplayedColAfter(t);
    }, i.prototype.getDisplayedColBefore = function(t) {
      return this.columnModel.getDisplayedColBefore(t);
    }, i.prototype.setColumnVisible = function(t, e) {
      this.columnModel.setColumnVisible(t, e, "api");
    }, i.prototype.setColumnsVisible = function(t, e) {
      this.columnModel.setColumnsVisible(t, e, "api");
    }, i.prototype.setColumnPinned = function(t, e) {
      this.columnModel.setColumnPinned(t, e, "api");
    }, i.prototype.setColumnsPinned = function(t, e) {
      this.columnModel.setColumnsPinned(t, e, "api");
    }, i.prototype.getAllGridColumns = function() {
      return this.columnModel.getAllGridColumns();
    }, i.prototype.getDisplayedLeftColumns = function() {
      return this.columnModel.getDisplayedLeftColumns();
    }, i.prototype.getDisplayedCenterColumns = function() {
      return this.columnModel.getDisplayedCenterColumns();
    }, i.prototype.getDisplayedRightColumns = function() {
      return this.columnModel.getDisplayedRightColumns();
    }, i.prototype.getAllDisplayedColumns = function() {
      return this.columnModel.getAllDisplayedColumns();
    }, i.prototype.getAllDisplayedVirtualColumns = function() {
      return this.columnModel.getViewportColumns();
    }, i.prototype.moveColumn = function(t, e) {
      this.columnModel.moveColumn(t, e, "api");
    }, i.prototype.moveColumnByIndex = function(t, e) {
      this.columnModel.moveColumnByIndex(t, e, "api");
    }, i.prototype.moveColumns = function(t, e) {
      this.columnModel.moveColumns(t, e, "api");
    }, i.prototype.moveRowGroupColumn = function(t, e) {
      this.columnModel.moveRowGroupColumn(t, e);
    }, i.prototype.setColumnAggFunc = function(t, e) {
      this.columnModel.setColumnAggFunc(t, e);
    }, i.prototype.setColumnWidth = function(t, e, r, o) {
      r === void 0 && (r = !0), this.columnModel.setColumnWidths([{ key: t, newWidth: e }], !1, r, o);
    }, i.prototype.setColumnWidths = function(t, e, r) {
      e === void 0 && (e = !0), this.columnModel.setColumnWidths(t, !1, e, r);
    }, i.prototype.setPivotMode = function(t) {
      this.columnModel.setPivotMode(t);
    }, i.prototype.isPivotMode = function() {
      return this.columnModel.isPivotMode();
    }, i.prototype.getPivotResultColumn = function(t, e) {
      return this.columnModel.getSecondaryPivotColumn(t, e);
    }, i.prototype.setValueColumns = function(t) {
      this.columnModel.setValueColumns(t, "api");
    }, i.prototype.getValueColumns = function() {
      return this.columnModel.getValueColumns();
    }, i.prototype.removeValueColumn = function(t) {
      this.columnModel.removeValueColumn(t, "api");
    }, i.prototype.removeValueColumns = function(t) {
      this.columnModel.removeValueColumns(t, "api");
    }, i.prototype.addValueColumn = function(t) {
      this.columnModel.addValueColumn(t, "api");
    }, i.prototype.addValueColumns = function(t) {
      this.columnModel.addValueColumns(t, "api");
    }, i.prototype.setRowGroupColumns = function(t) {
      this.columnModel.setRowGroupColumns(t, "api");
    }, i.prototype.removeRowGroupColumn = function(t) {
      this.columnModel.removeRowGroupColumn(t, "api");
    }, i.prototype.removeRowGroupColumns = function(t) {
      this.columnModel.removeRowGroupColumns(t, "api");
    }, i.prototype.addRowGroupColumn = function(t) {
      this.columnModel.addRowGroupColumn(t, "api");
    }, i.prototype.addRowGroupColumns = function(t) {
      this.columnModel.addRowGroupColumns(t, "api");
    }, i.prototype.getRowGroupColumns = function() {
      return this.columnModel.getRowGroupColumns();
    }, i.prototype.setPivotColumns = function(t) {
      this.columnModel.setPivotColumns(t, "api");
    }, i.prototype.removePivotColumn = function(t) {
      this.columnModel.removePivotColumn(t, "api");
    }, i.prototype.removePivotColumns = function(t) {
      this.columnModel.removePivotColumns(t, "api");
    }, i.prototype.addPivotColumn = function(t) {
      this.columnModel.addPivotColumn(t, "api");
    }, i.prototype.addPivotColumns = function(t) {
      this.columnModel.addPivotColumns(t, "api");
    }, i.prototype.getPivotColumns = function() {
      return this.columnModel.getPivotColumns();
    }, i.prototype.getLeftDisplayedColumnGroups = function() {
      return this.columnModel.getDisplayedTreeLeft();
    }, i.prototype.getCenterDisplayedColumnGroups = function() {
      return this.columnModel.getDisplayedTreeCentre();
    }, i.prototype.getRightDisplayedColumnGroups = function() {
      return this.columnModel.getDisplayedTreeRight();
    }, i.prototype.getAllDisplayedColumnGroups = function() {
      return this.columnModel.getAllDisplayedTrees();
    }, i.prototype.autoSizeColumn = function(t, e) {
      return this.columnModel.autoSizeColumn(t, e, "api");
    }, i.prototype.autoSizeColumns = function(t, e) {
      this.columnModel.autoSizeColumns({ columns: t, skipHeader: e });
    }, i.prototype.autoSizeAllColumns = function(t) {
      this.columnModel.autoSizeAllColumns(t, "api");
    }, i.prototype.setPivotResultColumns = function(t) {
      this.columnModel.setSecondaryColumns(t, "api");
    }, i.prototype.getPivotResultColumns = function() {
      return this.columnModel.getSecondaryColumns();
    }, i.prototype.cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid = function() {
      setTimeout(le.removeAllReferences.bind(window, this, "Column API"), 100);
    }, i.prototype.getAllColumns = function() {
      return bt("28.0", "getAllColumns", "getColumns"), this.getColumns();
    }, i.prototype.getOriginalColumnGroup = function(t) {
      return bt("27.0", "getOriginalColumnGroup", "getProvidedColumnGroup"), this.columnModel.getProvidedColumnGroup(t);
    }, i.prototype.getPrimaryColumns = function() {
      return bt("28.0", "getPrimaryColumns", "getColumns"), this.getColumns();
    }, i.prototype.getSecondaryColumns = function() {
      return bt("28.0", "getSecondaryColumns", "getPivotResultColumns"), this.getPivotResultColumns();
    }, i.prototype.setSecondaryColumns = function(t) {
      bt("28.0", "setSecondaryColumns", "setPivotResultColumns"), this.setPivotResultColumns(t);
    }, i.prototype.getSecondaryPivotColumn = function(t, e) {
      return bt("28.0", "getSecondaryPivotColumn", "getPivotResultColumn"), this.getPivotResultColumn(t, e);
    }, Ml([
      v("columnModel")
    ], i.prototype, "columnModel", void 0), Ml([
      At
    ], i.prototype, "cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid", null), i = Ml([
      te("columnApi")
    ], i), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var BR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gi = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, xv = (
  /** @class */
  function(i) {
    BR(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.initialised = !1, e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.cellExpressions = this.gridOptionsService.is("enableCellExpressions"), this.isTreeData = this.gridOptionsService.is("treeData"), this.initialised = !0, this.eventService.addEventListener(m.EVENT_CELL_VALUE_CHANGED, function(r) {
        return e.callColumnCellValueChangedHandler(r);
      }, this.gridOptionsService.useAsyncEvents()), this.addManagedPropertyListener("treeData", function(r) {
        return e.isTreeData = r.currentValue;
      });
    }, t.prototype.getValue = function(e, r, o, n) {
      if (o === void 0 && (o = !1), n === void 0 && (n = !1), this.initialised || this.init(), !!r) {
        var s = e.getColDef(), a = s.field, l = e.getColId(), u = r.data, c, p = r.groupData && r.groupData[l] !== void 0, d = !n && r.aggData && r.aggData[l] !== void 0;
        if (o && s.filterValueGetter ? c = this.executeFilterValueGetter(s.filterValueGetter, u, e, r) : this.isTreeData && d ? c = r.aggData[l] : this.isTreeData && s.valueGetter ? c = this.executeValueGetter(s.valueGetter, u, e, r) : this.isTreeData && a && u ? c = $s(u, a, e.isFieldContainsDots()) : p ? c = r.groupData[l] : d ? c = r.aggData[l] : s.valueGetter ? c = this.executeValueGetter(s.valueGetter, u, e, r) : a && u && (c = $s(u, a, e.isFieldContainsDots())), this.cellExpressions && typeof c == "string" && c.indexOf("=") === 0) {
          var h = c.substring(1);
          c = this.executeValueGetter(h, u, e, r);
        }
        if (c == null) {
          var g = this.getOpenedGroup(r, e);
          if (g != null)
            return g;
        }
        return c;
      }
    }, t.prototype.getOpenedGroup = function(e, r) {
      if (this.gridOptionsService.is("showOpenedGroup")) {
        var o = r.getColDef();
        if (o.showRowGroup)
          for (var n = r.getColDef().showRowGroup, s = e.parent; s != null; ) {
            if (s.rowGroupColumn && (n === !0 || n === s.rowGroupColumn.getColId()))
              return s.key;
            s = s.parent;
          }
      }
    }, t.prototype.setValue = function(e, r, o, n) {
      var s = this.columnModel.getPrimaryColumn(r);
      if (!e || !s)
        return !1;
      ue(e.data) && (e.data = {});
      var a = s.getColDef(), l = a.field, u = a.valueSetter;
      if (ue(l) && ue(u))
        return console.warn("AG Grid: you need either field or valueSetter set on colDef for editing to work"), !1;
      var c = {
        node: e,
        data: e.data,
        oldValue: this.getValue(s, e),
        newValue: o,
        colDef: s.getColDef(),
        column: s,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context
      };
      c.newValue = o;
      var p;
      if (k(u) ? typeof u == "function" ? p = u(c) : p = this.expressionService.evaluate(u, c) : p = this.setValueUsingField(e.data, l, o, s.isFieldContainsDots()), p === void 0 && (p = !0), !p)
        return !1;
      e.resetQuickFilterAggregateText(), this.valueCache.onDataChanged(), c.newValue = this.getValue(s, e);
      var d = {
        type: m.EVENT_CELL_VALUE_CHANGED,
        event: null,
        rowIndex: e.rowIndex,
        rowPinned: e.rowPinned,
        column: c.column,
        api: c.api,
        columnApi: c.columnApi,
        colDef: c.colDef,
        context: c.context,
        data: e.data,
        node: e,
        oldValue: c.oldValue,
        newValue: c.newValue,
        value: c.newValue,
        source: n
      };
      return this.eventService.dispatchEvent(d), !0;
    }, t.prototype.callColumnCellValueChangedHandler = function(e) {
      var r = e.colDef.onCellValueChanged;
      typeof r == "function" && r({
        node: e.node,
        data: e.data,
        oldValue: e.oldValue,
        newValue: e.newValue,
        colDef: e.colDef,
        column: e.column,
        api: e.api,
        columnApi: e.columnApi,
        context: e.context
      });
    }, t.prototype.setValueUsingField = function(e, r, o, n) {
      if (!r)
        return !1;
      var s = !1;
      if (!n)
        s = e[r] == o, s || (e[r] = o);
      else
        for (var a = r.split("."), l = e; a.length > 0 && l; ) {
          var u = a.shift();
          a.length === 0 ? (s = l[u] == o, s || (l[u] = o)) : l = l[u];
        }
      return !s;
    }, t.prototype.executeFilterValueGetter = function(e, r, o, n) {
      var s = {
        data: r,
        node: n,
        column: o,
        colDef: o.getColDef(),
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context,
        getValue: this.getValueCallback.bind(this, n)
      };
      return typeof e == "function" ? e(s) : this.expressionService.evaluate(e, s);
    }, t.prototype.executeValueGetter = function(e, r, o, n) {
      var s = o.getColId(), a = this.valueCache.getValue(n, s);
      if (a !== void 0)
        return a;
      var l = {
        data: r,
        node: n,
        column: o,
        colDef: o.getColDef(),
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context,
        getValue: this.getValueCallback.bind(this, n)
      }, u;
      return typeof e == "function" ? u = e(l) : u = this.expressionService.evaluate(e, l), this.valueCache.setValue(n, s, u), u;
    }, t.prototype.getValueCallback = function(e, r) {
      var o = this.columnModel.getPrimaryColumn(r);
      return o ? this.getValue(o, e) : null;
    }, t.prototype.getKeyForNode = function(e, r) {
      var o = this.getValue(e, r), n = e.getColDef().keyCreator, s = o;
      if (n) {
        var a = {
          value: o,
          colDef: e.getColDef(),
          column: e,
          node: r,
          data: r.data,
          api: this.gridOptionsService.api,
          columnApi: this.gridOptionsService.columnApi,
          context: this.gridOptionsService.context
        };
        s = n(a);
      }
      return typeof s == "string" || s == null || (s = String(s), s === "[object Object]" && Pe(function() {
        console.warn("AG Grid: a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key");
      }, "getKeyForNode - warn about [object,object]")), s;
    }, gi([
      v("expressionService")
    ], t.prototype, "expressionService", void 0), gi([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), gi([
      v("valueCache")
    ], t.prototype, "valueCache", void 0), gi([
      U
    ], t.prototype, "init", null), t = gi([
      te("valueService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var kR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), sd = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, jR = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, Fv = (
  /** @class */
  function(i) {
    kR(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.expressionToFunctionCache = {}, e;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("ExpressionService");
    }, t.prototype.evaluate = function(e, r) {
      if (typeof e == "string")
        return this.evaluateExpression(e, r);
      console.error("AG Grid: value should be either a string or a function", e);
    }, t.prototype.evaluateExpression = function(e, r) {
      try {
        var o = this.createExpressionFunction(e), n = o(r.value, r.context, r.oldValue, r.newValue, r.value, r.node, r.data, r.colDef, r.rowIndex, r.api, r.columnApi, r.getValue, r.column, r.columnGroup);
        return n;
      } catch (s) {
        return console.log("Processing of the expression failed"), console.log("Expression = " + e), console.log("Params =", r), console.log("Exception = " + s), null;
      }
    }, t.prototype.createExpressionFunction = function(e) {
      if (this.expressionToFunctionCache[e])
        return this.expressionToFunctionCache[e];
      var r = this.createFunctionBody(e), o = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup", r);
      return this.expressionToFunctionCache[e] = o, o;
    }, t.prototype.createFunctionBody = function(e) {
      return e.indexOf("return") >= 0 ? e : "return " + e + ";";
    }, sd([
      jR(0, Bt("loggerFactory"))
    ], t.prototype, "setBeans", null), t = sd([
      te("expressionService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var WR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), UR = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Mv = (
  /** @class */
  function(i) {
    WR(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.templateCache = {}, e.waitingCallbacks = {}, e;
    }
    return t.prototype.getTemplate = function(e, r) {
      var o = this.templateCache[e];
      if (o)
        return o;
      var n = this.waitingCallbacks[e], s = this;
      if (!n) {
        n = [], this.waitingCallbacks[e] = n;
        var a = new XMLHttpRequest();
        a.onload = function() {
          s.handleHttpResult(this, e);
        }, a.open("GET", e), a.send();
      }
      return r && n.push(r), null;
    }, t.prototype.handleHttpResult = function(e, r) {
      if (e.status !== 200 || e.response === null) {
        console.warn("AG Grid: Unable to get template error " + e.status + " - " + r);
        return;
      }
      this.templateCache[r] = e.response || e.responseText;
      for (var o = this.waitingCallbacks[r], n = 0; n < o.length; n++) {
        var s = o[n];
        s();
      }
    }, t = UR([
      te("templateService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var zR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ad = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, $R = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, Iv = (
  /** @class */
  function(i) {
    zR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.setBeans = function(e) {
      this.logging = e.is("debug");
    }, t.prototype.create = function(e) {
      return new pa(e, this.isLogging.bind(this));
    }, t.prototype.isLogging = function() {
      return this.logging;
    }, ad([
      $R(0, Bt("gridOptionsService"))
    ], t.prototype, "setBeans", null), t = ad([
      te("loggerFactory")
    ], t), t;
  }(j)
), pa = (
  /** @class */
  function() {
    function i(t, e) {
      this.name = t, this.isLoggingFunc = e;
    }
    return i.prototype.isLogging = function() {
      return this.isLoggingFunc();
    }, i.prototype.log = function(t) {
      this.isLoggingFunc() && console.log("AG Grid." + this.name + ": " + t);
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var KR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ln = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Lv = (
  /** @class */
  function(i) {
    KR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.setComp = function(e, r, o) {
      var n = this;
      this.view = e, this.eGridHostDiv = r, this.eGui = o, this.dragAndDropService.addDropTarget({
        getContainer: function() {
          return n.eGui;
        },
        isInterestedIn: function(a) {
          return a === kt.HeaderCell || a === kt.ToolPanel;
        },
        getIconName: function() {
          return Tt.ICON_NOT_ALLOWED;
        }
      }), this.mouseEventService.stampTopLevelGridCompWithGridInstance(r), this.createManagedBean(new cc(this.view)), this.addRtlSupport(), this.addManagedListener(this, m.EVENT_KEYBOARD_FOCUS, function() {
        n.view.addOrRemoveKeyboardFocusClass(!0);
      }), this.addManagedListener(this, m.EVENT_MOUSE_FOCUS, function() {
        n.view.addOrRemoveKeyboardFocusClass(!1);
      });
      var s = this.resizeObserverService.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
      this.addDestroyFunc(function() {
        return s();
      }), this.ctrlsService.registerGridCtrl(this);
    }, t.prototype.isDetailGrid = function() {
      var e, r = this.focusService.findTabbableParent(this.getGui());
      return ((e = r == null ? void 0 : r.getAttribute("row-id")) === null || e === void 0 ? void 0 : e.startsWith("detail")) || !1;
    }, t.prototype.showDropZones = function() {
      return pe.isRegistered(re.RowGroupingModule);
    }, t.prototype.showSideBar = function() {
      return pe.isRegistered(re.SideBarModule);
    }, t.prototype.showStatusBar = function() {
      return pe.isRegistered(re.StatusBarModule);
    }, t.prototype.showWatermark = function() {
      return pe.isRegistered(re.EnterpriseCoreModule);
    }, t.prototype.onGridSizeChanged = function() {
      var e = {
        type: m.EVENT_GRID_SIZE_CHANGED,
        clientWidth: this.eGridHostDiv.clientWidth,
        clientHeight: this.eGridHostDiv.clientHeight
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.addRtlSupport = function() {
      var e = this.gridOptionsService.is("enableRtl") ? "ag-rtl" : "ag-ltr";
      this.view.setRtlClass(e);
    }, t.prototype.destroyGridUi = function() {
      this.view.destroyGridUi();
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.setResizeCursor = function(e) {
      this.view.setCursor(e ? "ew-resize" : null);
    }, t.prototype.disableUserSelect = function(e) {
      this.view.setUserSelect(e ? "none" : null);
    }, t.prototype.focusNextInnerContainer = function(e) {
      var r = this.gridOptionsService.getDocument(), o = this.view.getFocusableContainers(), n = o.findIndex(function(a) {
        return a.contains(r.activeElement);
      }), s = n + (e ? -1 : 1);
      return s <= 0 || s >= o.length ? !1 : this.focusService.focusInto(o[s]);
    }, t.prototype.focusInnerElement = function(e) {
      var r = this.view.getFocusableContainers(), o = this.columnModel.getAllDisplayedColumns();
      if (e) {
        if (r.length > 1)
          return this.focusService.focusInto(Ne(r), !0);
        var n = Ne(o);
        if (this.focusService.focusGridView(n, !0))
          return !0;
      }
      return this.gridOptionsService.getNum("headerHeight") === 0 ? this.focusService.focusGridView(o[0]) : this.focusService.focusFirstHeader();
    }, t.prototype.forceFocusOutOfContainer = function(e) {
      e === void 0 && (e = !1), this.view.forceFocusOutOfContainer(e);
    }, Ln([
      v("focusService")
    ], t.prototype, "focusService", void 0), Ln([
      v("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Ln([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Ln([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ln([
      v("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), Ln([
      v("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var YR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), yi = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Nv = (
  /** @class */
  function(i) {
    YR(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.eGridDiv = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.logger = this.loggerFactory.create("GridComp");
      var r = {
        destroyGridUi: function() {
          return e.destroyBean(e);
        },
        setRtlClass: function(n) {
          return e.addCssClass(n);
        },
        addOrRemoveKeyboardFocusClass: function(n) {
          return e.addOrRemoveCssClass(Wn.AG_KEYBOARD_FOCUS, n);
        },
        forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
        updateLayoutClasses: this.updateLayoutClasses.bind(this),
        getFocusableContainers: this.getFocusableContainers.bind(this),
        setUserSelect: function(n) {
          e.getGui().style.userSelect = n ?? "", e.getGui().style.webkitUserSelect = n ?? "";
        },
        setCursor: function(n) {
          e.getGui().style.cursor = n ?? "";
        }
      };
      this.ctrl = this.createManagedBean(new Lv());
      var o = this.createTemplate();
      this.setTemplate(o), this.ctrl.setComp(r, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({
        // we want to override the default behaviour to do nothing for onTabKeyDown
        onTabKeyDown: function() {
        },
        focusInnerElement: function(n) {
          return e.ctrl.focusInnerElement(n);
        }
      });
    }, t.prototype.insertGridIntoDom = function() {
      var e = this, r = this.getGui();
      this.eGridDiv.appendChild(r), this.addDestroyFunc(function() {
        e.eGridDiv.removeChild(r), e.logger.log("Grid removed from DOM");
      });
    }, t.prototype.updateLayoutClasses = function(e, r) {
      var o = this.eRootWrapperBody.classList;
      o.toggle(lt.AUTO_HEIGHT, r.autoHeight), o.toggle(lt.NORMAL, r.normal), o.toggle(lt.PRINT, r.print), this.addOrRemoveCssClass(lt.AUTO_HEIGHT, r.autoHeight), this.addOrRemoveCssClass(lt.NORMAL, r.normal), this.addOrRemoveCssClass(lt.PRINT, r.print);
    }, t.prototype.createTemplate = function() {
      var e = this.ctrl.showDropZones() ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "", r = this.ctrl.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : "", o = this.ctrl.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : "", n = this.ctrl.showWatermark() ? "<ag-watermark></ag-watermark>" : "", s = (
        /* html */
        `<div class="ag-root-wrapper" role="presentation">
                ` + e + `
                <div class="ag-root-wrapper-body" ref="rootWrapperBody" role="presentation">
                    <ag-grid-body ref="gridBody"></ag-grid-body>
                    ` + r + `
                </div>
                ` + o + `
                <ag-pagination></ag-pagination>
                ` + n + `
            </div>`
      );
      return s;
    }, t.prototype.getFocusableElement = function() {
      return this.eRootWrapperBody;
    }, t.prototype.getFocusableContainers = function() {
      var e = [
        this.gridBodyComp.getGui()
      ];
      return this.sideBarComp && e.push(this.sideBarComp.getGui()), e.filter(function(r) {
        return qn(r);
      });
    }, yi([
      v("loggerFactory")
    ], t.prototype, "loggerFactory", void 0), yi([
      Y("gridBody")
    ], t.prototype, "gridBodyComp", void 0), yi([
      Y("sideBar")
    ], t.prototype, "sideBarComp", void 0), yi([
      Y("rootWrapperBody")
    ], t.prototype, "eRootWrapperBody", void 0), yi([
      U
    ], t.prototype, "postConstruct", null), t;
  }(zi)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var qR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ld = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Ws = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, mi = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(Ws(arguments[t]));
  return i;
}, Gv = (
  /** @class */
  function(i) {
    qR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    e = t, t.prototype.progressSort = function(r, o, n) {
      var s = this.getNextSortDirection(r);
      this.setSortForColumn(r, s, o, n);
    }, t.prototype.setSortForColumn = function(r, o, n, s) {
      o !== "asc" && o !== "desc" && (o = null);
      var a = this.gridOptionsService.isColumnsSortingCoupledToGroup(), l = [r];
      if (a && r.getColDef().showRowGroup) {
        r.getColDef().field || (l = []);
        var u = this.columnModel.getSourceColumnsForGroupColumn(r), c = u == null ? void 0 : u.filter(function(d) {
          return d.getColDef().sortable;
        });
        c && (l = mi(l, c));
      }
      l.forEach(function(d) {
        return d.setSort(o, s);
      });
      var p = (n || this.gridOptionsService.is("alwaysMultiSort")) && !this.gridOptionsService.is("suppressMultiSort");
      p || this.clearSortBarTheseColumns(l, s), this.updateSortIndex(r), this.dispatchSortChangedEvents(s);
    }, t.prototype.updateSortIndex = function(r) {
      var o = this.gridOptionsService.isColumnsSortingCoupledToGroup(), n = this.columnModel.getGroupDisplayColumnForGroup(r.getId()), s = o && n || r, a = this.getColumnsWithSortingOrdered(!0);
      this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach(function(c) {
        return c.setSortIndex(null);
      });
      var l = a.filter(function(c) {
        return c !== s;
      }), u = s.getSort() ? mi(l, [s]) : l;
      u.forEach(function(c, p) {
        return c.setSortIndex(p);
      });
    }, t.prototype.onSortChanged = function(r) {
      this.dispatchSortChangedEvents(r);
    }, t.prototype.isSortActive = function() {
      var r = this.columnModel.getPrimaryAndSecondaryAndAutoColumns(), o = r.filter(function(n) {
        return !!n.getSort();
      });
      return o && o.length > 0;
    }, t.prototype.dispatchSortChangedEvents = function(r) {
      var o = {
        type: m.EVENT_SORT_CHANGED,
        source: r
      };
      this.eventService.dispatchEvent(o);
    }, t.prototype.clearSortBarTheseColumns = function(r, o) {
      this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach(function(n) {
        r.includes(n) || n.setSort(void 0, o);
      });
    }, t.prototype.getNextSortDirection = function(r) {
      var o;
      if (r.getColDef().sortingOrder ? o = r.getColDef().sortingOrder : this.gridOptionsService.get("sortingOrder") ? o = this.gridOptionsService.get("sortingOrder") : o = e.DEFAULT_SORTING_ORDER, !Array.isArray(o) || o.length <= 0)
        return console.warn("AG Grid: sortingOrder must be an array with at least one element, currently it's " + o), null;
      var n = r.getColDef().field ? r.getSort() : this.getDisplaySortForColumn(r), s = o[0];
      if (n !== "mixed") {
        var a = o.indexOf(n), l = a < 0, u = a == o.length - 1;
        l || u ? s = o[0] : s = o[a + 1];
      }
      return e.DEFAULT_SORTING_ORDER.indexOf(s) < 0 ? (console.warn("AG Grid: invalid sort type " + s), null) : s;
    }, t.prototype.getIndexedSortMap = function(r) {
      var o = this;
      r === void 0 && (r = !1);
      var n = this.columnModel.getPrimaryAndSecondaryAndAutoColumns().filter(function(c) {
        return !!c.getSort();
      });
      !r && this.columnModel.isPivotMode() && (n = n.filter(function(c) {
        return !!c.getAggFunc() || !c.isPrimary() || o.columnModel.getGroupDisplayColumnForGroup(c.getId());
      }));
      var s = this.columnModel.getRowGroupColumns().filter(function(c) {
        return !!c.getSort();
      }), a = this.gridOptionsService.isColumnsSortingCoupledToGroup() && !!s.length;
      a && (n = mi(new Set(
        // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        n.map(function(c) {
          var p;
          return (p = o.columnModel.getGroupDisplayColumnForGroup(c.getId())) !== null && p !== void 0 ? p : c;
        })
      )));
      var l = {};
      n.forEach(function(c, p) {
        return l[c.getId()] = p;
      }), n.sort(function(c, p) {
        var d = c.getSortIndex(), h = p.getSortIndex();
        if (d != null && h != null)
          return d - h;
        if (d == null && h == null) {
          var g = l[c.getId()], y = l[p.getId()];
          return g > y ? 1 : -1;
        } else
          return h == null ? -1 : 1;
      });
      var u = /* @__PURE__ */ new Map();
      return n.forEach(function(c, p) {
        return u.set(c, p);
      }), a && s.forEach(function(c) {
        var p = o.columnModel.getGroupDisplayColumnForGroup(c.getId());
        u.set(c, u.get(p));
      }), u;
    }, t.prototype.getColumnsWithSortingOrdered = function(r) {
      return r === void 0 && (r = !1), mi(this.getIndexedSortMap(r).entries()).sort(function(o, n) {
        var s = Ws(o, 2);
        s[0];
        var a = s[1], l = Ws(n, 2);
        l[0];
        var u = l[1];
        return a - u;
      }).map(function(o) {
        var n = Ws(o, 1), s = n[0];
        return s;
      });
    }, t.prototype.getSortModel = function() {
      return this.getColumnsWithSortingOrdered(!0).map(function(r) {
        return {
          sort: r.getSort(),
          colId: r.getId()
        };
      });
    }, t.prototype.getSortOptions = function() {
      return this.getColumnsWithSortingOrdered().map(function(r) {
        return {
          sort: r.getSort(),
          column: r
        };
      });
    }, t.prototype.canColumnDisplayMixedSort = function(r) {
      var o = this.gridOptionsService.isColumnsSortingCoupledToGroup(), n = !!r.getColDef().showRowGroup;
      return o && n;
    }, t.prototype.getDisplaySortForColumn = function(r) {
      var o = this.columnModel.getSourceColumnsForGroupColumn(r);
      if (!this.canColumnDisplayMixedSort(r) || !(o != null && o.length))
        return r.getSort();
      var n = !!r.getColDef().field, s = n ? mi([r], o) : o, a = s[0].getSort(), l = s.every(function(u) {
        return u.getSort() == a;
      });
      return l ? a : "mixed";
    }, t.prototype.getDisplaySortIndexForColumn = function(r) {
      return this.getIndexedSortMap().get(r);
    };
    var e;
    return t.DEFAULT_SORTING_ORDER = ["asc", "desc", null], ld([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), t = e = ld([
      te("sortController")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var XR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), QR = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, JR = (
  /** @class */
  function(i) {
    XR(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.setMouseOver = function(e) {
      this.selectedColumns = e;
      var r = {
        type: m.EVENT_COLUMN_HOVER_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.clearMouseOver = function() {
      this.selectedColumns = null;
      var e = {
        type: m.EVENT_COLUMN_HOVER_CHANGED
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.isHovered = function(e) {
      return !!this.selectedColumns && this.selectedColumns.indexOf(e) >= 0;
    }, t = QR([
      te("columnHoverService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ZR = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Il = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, eO = (
  /** @class */
  function(i) {
    ZR(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.executeNextFuncs = [], e.executeLaterFuncs = [], e.active = !1, e.animationThreadCount = 0, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        return e.gridBodyCtrl = r.gridBodyCtrl;
      });
    }, t.prototype.isActive = function() {
      return this.active;
    }, t.prototype.start = function() {
      this.active || this.gridOptionsService.is("suppressColumnMoveAnimation") || this.gridOptionsService.is("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0);
    }, t.prototype.finish = function() {
      this.active && (this.flush(), this.active = !1);
    }, t.prototype.executeNextVMTurn = function(e) {
      this.active ? this.executeNextFuncs.push(e) : e();
    }, t.prototype.executeLaterVMTurn = function(e) {
      this.active ? this.executeLaterFuncs.push(e) : e();
    }, t.prototype.ensureAnimationCssClassPresent = function() {
      var e = this;
      this.animationThreadCount++;
      var r = this.animationThreadCount;
      this.gridBodyCtrl.setColumnMovingCss(!0), this.executeLaterFuncs.push(function() {
        e.animationThreadCount === r && e.gridBodyCtrl.setColumnMovingCss(!1);
      });
    }, t.prototype.flush = function() {
      var e = this.executeNextFuncs;
      this.executeNextFuncs = [];
      var r = this.executeLaterFuncs;
      this.executeLaterFuncs = [], !(e.length === 0 && r.length === 0) && (window.setTimeout(function() {
        return e.forEach(function(o) {
          return o();
        });
      }, 0), window.setTimeout(function() {
        return r.forEach(function(o) {
          return o();
        });
      }, 300));
    }, Il([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Il([
      U
    ], t.prototype, "postConstruct", null), t = Il([
      te("columnAnimationService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var tO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ll = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, rO = (
  /** @class */
  function(i) {
    tO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.centerRowContainerCon = r.centerRowContainerCtrl, e.addManagedListener(e.eventService, m.EVENT_BODY_HEIGHT_CHANGED, e.checkPageSize.bind(e)), e.addManagedListener(e.eventService, m.EVENT_SCROLL_VISIBILITY_CHANGED, e.checkPageSize.bind(e)), e.checkPageSize();
      });
    }, t.prototype.notActive = function() {
      return !this.gridOptionsService.is("paginationAutoPageSize") || this.centerRowContainerCon == null;
    }, t.prototype.checkPageSize = function() {
      var e = this;
      if (!this.notActive()) {
        var r = this.centerRowContainerCon.getViewportSizeFeature().getBodyHeight();
        if (r > 0) {
          var o = function() {
            var n = e.gridOptionsService.getRowHeightAsNumber(), s = Math.floor(r / n);
            e.gridOptionsService.set("paginationPageSize", s);
          };
          this.isBodyRendered ? ro(function() {
            return o();
          }, 50)() : (o(), this.isBodyRendered = !0);
        } else
          this.isBodyRendered = !1;
      }
    }, Ll([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ll([
      U
    ], t.prototype, "postConstruct", null), t = Ll([
      te("paginationAutoPageSizeService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var oO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ud = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Hv = (
  /** @class */
  function(i) {
    oO(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.cacheVersion = 0, e;
    }
    return t.prototype.init = function() {
      this.active = this.gridOptionsService.is("valueCache"), this.neverExpires = this.gridOptionsService.is("valueCacheNeverExpires");
    }, t.prototype.onDataChanged = function() {
      this.neverExpires || this.expire();
    }, t.prototype.expire = function() {
      this.cacheVersion++;
    }, t.prototype.setValue = function(e, r, o) {
      this.active && (e.__cacheVersion !== this.cacheVersion && (e.__cacheVersion = this.cacheVersion, e.__cacheData = {}), e.__cacheData[r] = o);
    }, t.prototype.getValue = function(e, r) {
      if (!(!this.active || e.__cacheVersion !== this.cacheVersion))
        return e.__cacheData[r];
    }, ud([
      U
    ], t.prototype, "init", null), t = ud([
      te("valueCache")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var nO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Es = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, iO = "paste", sO = (
  /** @class */
  function(i) {
    nO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel), this.addManagedListener(this.eventService, m.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
    }, t.prototype.onCellValueChanged = function(e) {
      e.source !== iO && this.doChangeDetection(e.node, e.column);
    }, t.prototype.doChangeDetection = function(e, r) {
      if (!this.gridOptionsService.is("suppressChangeDetection")) {
        if (this.clientSideRowModel && !e.isRowPinned()) {
          var o = this.gridOptionsService.is("aggregateOnlyChangedColumns"), n = new Na(o, this.clientSideRowModel.getRootNode());
          n.addParentNode(e.parent, [r]), this.clientSideRowModel.doAggregate(n);
        }
        this.rowRenderer.refreshCells();
      }
    }, Es([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Es([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Es([
      U
    ], t.prototype, "init", null), t = Es([
      te("changeDetectionService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var aO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), cd = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, lO = (
  /** @class */
  function(i) {
    aO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.adaptFunction = function(e, r) {
      var o = this.componentMetadataProvider.retrieve(e);
      return o && o.functionAdapter ? o.functionAdapter(r) : null;
    }, t.prototype.adaptCellRendererFunction = function(e) {
      var r = (
        /** @class */
        function() {
          function o() {
          }
          return o.prototype.refresh = function(n) {
            return !1;
          }, o.prototype.getGui = function() {
            return this.eGui;
          }, o.prototype.init = function(n) {
            var s = e(n), a = typeof s;
            if (a === "string" || a === "number" || a === "boolean") {
              this.eGui = Lt("<span>" + s + "</span>");
              return;
            }
            if (s == null) {
              this.eGui = Lt("<span></span>");
              return;
            }
            this.eGui = s;
          }, o;
        }()
      );
      return r;
    }, t.prototype.doesImplementIComponent = function(e) {
      return e ? e.prototype && "getGui" in e.prototype : !1;
    }, cd([
      v("componentMetadataProvider")
    ], t.prototype, "componentMetadataProvider", void 0), t = cd([
      te("agComponentUtils")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var uO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Nl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, cO = (
  /** @class */
  function(i) {
    uO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.componentMetaData = {
        dateComponent: {
          mandatoryMethodList: ["getDate", "setDate"],
          optionalMethodList: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel"]
        },
        detailCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        headerComponent: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        headerGroupComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        loadingCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        loadingOverlayComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        noRowsOverlayComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        floatingFilterComponent: {
          mandatoryMethodList: ["onParentModelChanged"],
          optionalMethodList: ["afterGuiAttached"]
        },
        floatingFilterWrapperComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        cellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        cellEditor: {
          mandatoryMethodList: ["getValue"],
          optionalMethodList: ["isPopup", "isCancelBeforeStart", "isCancelAfterEnd", "getPopupPosition", "focusIn", "focusOut", "afterGuiAttached"]
        },
        innerRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        fullWidthCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        groupRowRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        filter: {
          mandatoryMethodList: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
          optionalMethodList: ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onFloatingFilterChanged", "onAnyFilterChanged"]
        },
        filterComponent: {
          mandatoryMethodList: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
          optionalMethodList: ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onFloatingFilterChanged", "onAnyFilterChanged"]
        },
        statusPanel: {
          mandatoryMethodList: [],
          optionalMethodList: ["afterGuiAttached"]
        },
        toolPanel: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "afterGuiAttached"]
        },
        tooltipComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        }
      };
    }, t.prototype.retrieve = function(e) {
      return this.componentMetaData[e];
    }, Nl([
      v("agComponentUtils")
    ], t.prototype, "agComponentUtils", void 0), Nl([
      U
    ], t.prototype, "postConstruct", null), t = Nl([
      te("componentMetadataProvider")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var pO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Gl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, dO = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, fO = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(dO(arguments[t]));
  return i;
}, hO = 25, pd = 10, Hl = 8, vO = 4, Vl = 4, Bl = 6, gO = {
  // this item is required for custom themes
  "ag-theme-custom": {
    headerHeight: 25,
    headerCellMinWidth: 24,
    listItemHeight: vO * 5,
    rowHeight: 25,
    chartMenuPanelWidth: 220
  },
  "ag-theme-material": {
    headerHeight: Hl * 7,
    headerCellMinWidth: 48,
    listItemHeight: Hl * 4,
    rowHeight: Hl * 6,
    chartMenuPanelWidth: 240
  },
  "ag-theme-balham": {
    headerHeight: Vl * 8,
    headerCellMinWidth: 24,
    listItemHeight: Vl * 6,
    rowHeight: Vl * 7,
    chartMenuPanelWidth: 220
  },
  "ag-theme-alpine": {
    headerHeight: Bl * 8,
    headerCellMinWidth: 36,
    listItemHeight: Bl * 4,
    rowHeight: Bl * 7,
    chartMenuPanelWidth: 240
  }
}, dd = {
  headerHeight: ["ag-header-row"],
  headerCellMinWidth: ["ag-header-cell"],
  listItemHeight: ["ag-virtual-list-item"],
  rowHeight: ["ag-row"],
  chartMenuPanelWidth: ["ag-chart-docked-container"]
}, Vv = (
  /** @class */
  function(i) {
    pO(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.calculatedSizes = {}, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r, o = (r = this.getTheme().el) !== null && r !== void 0 ? r : this.eGridDiv;
      this.mutationObserver = new MutationObserver(function() {
        e.calculatedSizes = {}, e.fireGridStylesChangedEvent();
      }), this.mutationObserver.observe(o || this.eGridDiv, {
        attributes: !0,
        attributeFilter: ["class"]
      });
    }, t.prototype.fireGridStylesChangedEvent = function() {
      var e = {
        type: m.EVENT_GRID_STYLES_CHANGED
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.getSassVariable = function(e) {
      var r = this.getTheme(), o = r.themeFamily, n = r.el;
      if (!(!o || o.indexOf("ag-theme") !== 0)) {
        this.calculatedSizes || (this.calculatedSizes = {}), this.calculatedSizes[o] || (this.calculatedSizes[o] = {});
        var s = this.calculatedSizes[o][e];
        return s ?? (this.calculatedSizes[o][e] = this.calculateValueForSassProperty(e, o, n), this.calculatedSizes[o][e]);
      }
    }, t.prototype.calculateValueForSassProperty = function(e, r, o) {
      var n, s = "ag-theme-" + (r.match("material") ? "material" : r.match("balham") ? "balham" : r.match("alpine") ? "alpine" : "custom"), a = gO[s][e], l = this.gridOptionsService.getDocument();
      if (o || (o = this.eGridDiv), !dd[e])
        return a;
      var u = dd[e], c = l.createElement("div"), p = Array.from(o.classList);
      (n = c.classList).add.apply(n, fO([r], p)), c.style.position = "absolute";
      var d = u.reduce(function(y, S) {
        var _ = l.createElement("div");
        return _.style.position = "static", _.classList.add(S), y.appendChild(_), _;
      }, c), h = 0;
      if (l.body) {
        l.body.appendChild(c);
        var g = e.toLowerCase().indexOf("height") !== -1 ? "height" : "width";
        h = parseInt(window.getComputedStyle(d)[g], 10), l.body.removeChild(c);
      }
      return h || a;
    }, t.prototype.isThemeDark = function() {
      var e = this.getTheme().theme;
      return !!e && e.indexOf("dark") >= 0;
    }, t.prototype.chartMenuPanelWidth = function() {
      return this.getSassVariable("chartMenuPanelWidth");
    }, t.prototype.getTheme = function() {
      for (var e = /\bag-(material|(?:theme-([\w\-]*)))\b/g, r = this.eGridDiv, o = null, n = []; r; )
        if (o = e.exec(r.className), !o)
          r = r.parentElement || void 0;
        else {
          var s = r.className.match(e);
          s && (n = s);
          break;
        }
      if (!o)
        return { allThemes: n };
      var a = o[0];
      return { theme: a, el: r, themeFamily: a.replace(/-dark$/, ""), allThemes: n };
    }, t.prototype.getFromTheme = function(e, r) {
      var o;
      return (o = this.getSassVariable(r)) !== null && o !== void 0 ? o : e;
    }, t.prototype.getDefaultRowHeight = function() {
      return this.getFromTheme(hO, "rowHeight");
    }, t.prototype.getListItemHeight = function() {
      return this.getFromTheme(20, "listItemHeight");
    }, t.prototype.setRowHeightVariable = function(e) {
      var r = this.eGridDiv.style.getPropertyValue("--ag-line-height").trim(), o = e + "px";
      r != o && this.eGridDiv.style.setProperty("--ag-line-height", o);
    }, t.prototype.getMinColWidth = function() {
      var e = this.getFromTheme(null, "headerCellMinWidth");
      return k(e) ? Math.max(e, pd) : pd;
    }, t.prototype.destroy = function() {
      this.calculatedSizes = null, this.mutationObserver && this.mutationObserver.disconnect(), i.prototype.destroy.call(this);
    }, Gl([
      v("eGridDiv")
    ], t.prototype, "eGridDiv", void 0), Gl([
      U
    ], t.prototype, "postConstruct", null), t = Gl([
      te("environment")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var yO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Rs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, mO = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, CO = (
  /** @class */
  function(i) {
    yO(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.scrollY = 0, e.uiBodyHeight = 0, e;
    }
    return t.prototype.agWire = function(e) {
      this.logger = e.create("RowContainerHeightService");
    }, t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, m.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this)), this.maxDivHeight = Vf(), this.logger.log("maxDivHeight = " + this.maxDivHeight);
    }, t.prototype.isStretching = function() {
      return this.stretching;
    }, t.prototype.getDivStretchOffset = function() {
      return this.divStretchOffset;
    }, t.prototype.updateOffset = function() {
      if (this.stretching) {
        var e = this.ctrlsService.getGridBodyCtrl(), r = e.getScrollFeature().getVScrollPosition().top, o = this.getUiBodyHeight(), n = r !== this.scrollY || o !== this.uiBodyHeight;
        n && (this.scrollY = r, this.uiBodyHeight = o, this.calculateOffset());
      }
    }, t.prototype.calculateOffset = function() {
      this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
      var e = this.scrollY / this.maxScrollY, r = e * this.pixelsToShave;
      this.logger.log("Div Stretch Offset = " + r + " (" + this.pixelsToShave + " * " + e + ")"), this.setDivStretchOffset(r);
    }, t.prototype.setUiContainerHeight = function(e) {
      e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventService.dispatchEvent({ type: m.EVENT_ROW_CONTAINER_HEIGHT_CHANGED }));
    }, t.prototype.clearOffset = function() {
      this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
    }, t.prototype.setDivStretchOffset = function(e) {
      var r = typeof e == "number" ? Math.floor(e) : null;
      this.divStretchOffset !== r && (this.divStretchOffset = r, this.eventService.dispatchEvent({ type: m.EVENT_HEIGHT_SCALE_CHANGED }));
    }, t.prototype.setModelHeight = function(e) {
      this.modelHeight = e, this.stretching = e != null && this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
    }, t.prototype.getUiContainerHeight = function() {
      return this.uiContainerHeight;
    }, t.prototype.getRealPixelPosition = function(e) {
      return e - this.divStretchOffset;
    }, t.prototype.getUiBodyHeight = function() {
      var e = this.ctrlsService.getGridBodyCtrl(), r = e.getScrollFeature().getVScrollPosition();
      return r.bottom - r.top;
    }, t.prototype.getScrollPositionForPixel = function(e) {
      if (this.pixelsToShave <= 0)
        return e;
      var r = this.modelHeight - this.getUiBodyHeight(), o = e / r, n = this.maxScrollY * o;
      return n;
    }, Rs([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Rs([
      mO(0, Bt("loggerFactory"))
    ], t.prototype, "agWire", null), Rs([
      U
    ], t.prototype, "postConstruct", null), t = Rs([
      te("rowContainerHeightService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var wO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fd = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Bv = (
  /** @class */
  function(i) {
    wO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      this.groupSelectsChildren = this.gridOptionsService.is("groupSelectsChildren"), this.isRowSelectableFunc = this.gridOptionsService.get("isRowSelectable");
    }, t.prototype.updateSelectableAfterGrouping = function(e) {
      if (this.isRowSelectableFunc) {
        var r = function(o) {
          return o.childrenAfterGroup;
        };
        this.recurseDown(e.childrenAfterGroup, r);
      }
    }, t.prototype.recurseDown = function(e, r) {
      var o = this;
      e && e.forEach(function(n) {
        if (n.group) {
          n.hasChildren() && o.recurseDown(r(n), r);
          var s;
          if (o.groupSelectsChildren) {
            var a = (r(n) || []).find(function(l) {
              return l.selectable === !0;
            });
            s = k(a);
          } else
            s = o.isRowSelectableFunc ? o.isRowSelectableFunc(n) : !1;
          n.setRowSelectable(s);
        }
      });
    }, fd([
      U
    ], t.prototype, "init", null), t = fd([
      te("selectableService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var SO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), mr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, _O = (
  /** @class */
  function(i) {
    SO(t, i);
    function t() {
      var e = i.call(this) || this;
      return e.previousAndFirstButtonsDisabled = !1, e.nextButtonDisabled = !1, e.lastButtonDisabled = !1, e.areListenersSetup = !1, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this.gridOptionsService.is("enableRtl");
      this.setTemplate(this.getTemplate()), this.btFirst.insertAdjacentElement("afterbegin", ut(e ? "last" : "first", this.gridOptionsService)), this.btPrevious.insertAdjacentElement("afterbegin", ut(e ? "next" : "previous", this.gridOptionsService)), this.btNext.insertAdjacentElement("afterbegin", ut(e ? "previous" : "next", this.gridOptionsService)), this.btLast.insertAdjacentElement("afterbegin", ut(e ? "first" : "last", this.gridOptionsService)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.onPaginationChanged();
    }, t.prototype.onPaginationChanged = function() {
      var e = this.gridOptionsService.is("pagination"), r = e && !this.gridOptionsService.is("suppressPaginationPanel");
      this.setDisplayed(r), r && (this.setupListeners(), this.enableOrDisableButtons(), this.updateRowLabels(), this.setCurrentPageLabel(), this.setTotalLabels());
    }, t.prototype.setupListeners = function() {
      var e = this;
      this.areListenersSetup || (this.addManagedListener(this.eventService, m.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this)), [
        { el: this.btFirst, fn: this.onBtFirst.bind(this) },
        { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
        { el: this.btNext, fn: this.onBtNext.bind(this) },
        { el: this.btLast, fn: this.onBtLast.bind(this) }
      ].forEach(function(r) {
        var o = r.el, n = r.fn;
        e.addManagedListener(o, "click", n), e.addManagedListener(o, "keydown", function(s) {
          (s.key === L.ENTER || s.key === L.SPACE) && (s.preventDefault(), n());
        });
      }), this.areListenersSetup = !0);
    }, t.prototype.onBtFirst = function() {
      this.previousAndFirstButtonsDisabled || this.paginationProxy.goToFirstPage();
    }, t.prototype.setCurrentPageLabel = function() {
      var e = this.paginationProxy.getTotalPages() > 0, r = this.paginationProxy.getCurrentPage(), o = e ? r + 1 : 0;
      this.lbCurrent.innerHTML = this.formatNumber(o);
    }, t.prototype.formatNumber = function(e) {
      var r = this.gridOptionsService.getCallback("paginationNumberFormatter");
      if (r) {
        var o = { value: e };
        return r(o);
      }
      var n = this.localeService.getLocaleTextFunc(), s = n("thousandSeparator", ","), a = n("decimalSeparator", ".");
      return zu(e, s, a);
    }, t.prototype.getTemplate = function() {
      var e = this.localeService.getLocaleTextFunc(), r = e("page", "Page"), o = e("to", "to"), n = e("of", "of"), s = e("firstPage", "First Page"), a = e("previousPage", "Previous Page"), l = e("nextPage", "Next Page"), u = e("lastPage", "Last Page"), c = this.getCompId();
      return (
        /* html */
        '<div class="ag-paging-panel ag-unselectable" id="ag-' + c + `">
                <span class="ag-paging-row-summary-panel" role="status">
                    <span id="ag-` + c + `-first-row" ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-` + c + '-to">' + o + `</span>
                    <span id="ag-` + c + `-last-row" ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-` + c + '-of">' + n + `</span>
                    <span id="ag-` + c + `-row-count" ref="lbRecordCount" class="ag-paging-row-summary-panel-number"></span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div ref="btFirst" class="ag-paging-button" role="button" aria-label="` + s + `"></div>
                    <div ref="btPrevious" class="ag-paging-button" role="button" aria-label="` + a + `"></div>
                    <span class="ag-paging-description" role="status">
                        <span id="ag-` + c + '-start-page">' + r + `</span>
                        <span id="ag-` + c + `-start-page-number" ref="lbCurrent" class="ag-paging-number"></span>
                        <span id="ag-` + c + '-of-page">' + n + `</span>
                        <span id="ag-` + c + `-of-page-number" ref="lbTotal" class="ag-paging-number"></span>
                    </span>
                    <div ref="btNext" class="ag-paging-button" role="button" aria-label="` + l + `"></div>
                    <div ref="btLast" class="ag-paging-button" role="button" aria-label="` + u + `"></div>
                </span>
            </div>`
      );
    }, t.prototype.onBtNext = function() {
      this.nextButtonDisabled || this.paginationProxy.goToNextPage();
    }, t.prototype.onBtPrevious = function() {
      this.previousAndFirstButtonsDisabled || this.paginationProxy.goToPreviousPage();
    }, t.prototype.onBtLast = function() {
      this.lastButtonDisabled || this.paginationProxy.goToLastPage();
    }, t.prototype.enableOrDisableButtons = function() {
      var e = this.paginationProxy.getCurrentPage(), r = this.paginationProxy.isLastPageFound(), o = this.paginationProxy.getTotalPages();
      this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
      var n = this.isZeroPagesToDisplay(), s = r && e === o - 1;
      this.nextButtonDisabled = s || n, this.lastButtonDisabled = !r || n || e === o - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }, t.prototype.toggleButtonDisabled = function(e, r) {
      Gu(e, r), e.classList.toggle("ag-disabled", r), r ? e.removeAttribute("tabindex") : e.setAttribute("tabindex", "0");
    }, t.prototype.updateRowLabels = function() {
      var e = this.paginationProxy.getCurrentPage(), r = this.paginationProxy.getPageSize(), o = this.paginationProxy.isLastPageFound(), n = this.paginationProxy.isLastPageFound() ? this.paginationProxy.getMasterRowCount() : null, s, a;
      if (this.isZeroPagesToDisplay() ? s = a = 0 : (s = r * e + 1, a = s + r - 1, o && a > n && (a = n)), this.lbFirstRowOnPage.innerHTML = this.formatNumber(s), this.rowNodeBlockLoader.isLoading()) {
        var l = this.localeService.getLocaleTextFunc();
        this.lbLastRowOnPage.innerHTML = l("pageLastRowUnknown", "?");
      } else
        this.lbLastRowOnPage.innerHTML = this.formatNumber(a);
    }, t.prototype.isZeroPagesToDisplay = function() {
      var e = this.paginationProxy.isLastPageFound(), r = this.paginationProxy.getTotalPages();
      return e && r === 0;
    }, t.prototype.setTotalLabels = function() {
      var e = this.paginationProxy.isLastPageFound(), r = this.paginationProxy.getTotalPages(), o = e ? this.paginationProxy.getMasterRowCount() : null;
      if (o === 1) {
        var n = this.paginationProxy.getRow(0), s = n && n.group && !(n.groupData || n.aggData);
        if (s) {
          this.setTotalLabelsToZero();
          return;
        }
      }
      if (e)
        this.lbTotal.innerHTML = this.formatNumber(r), this.lbRecordCount.innerHTML = this.formatNumber(o);
      else {
        var a = this.localeService.getLocaleTextFunc()("more", "more");
        this.lbTotal.innerHTML = a, this.lbRecordCount.innerHTML = a;
      }
    }, t.prototype.setTotalLabelsToZero = function() {
      this.lbFirstRowOnPage.innerHTML = this.formatNumber(0), this.lbCurrent.innerHTML = this.formatNumber(0), this.lbLastRowOnPage.innerHTML = this.formatNumber(0), this.lbTotal.innerHTML = this.formatNumber(0), this.lbRecordCount.innerHTML = this.formatNumber(0);
    }, mr([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), mr([
      v("rowNodeBlockLoader")
    ], t.prototype, "rowNodeBlockLoader", void 0), mr([
      Y("btFirst")
    ], t.prototype, "btFirst", void 0), mr([
      Y("btPrevious")
    ], t.prototype, "btPrevious", void 0), mr([
      Y("btNext")
    ], t.prototype, "btNext", void 0), mr([
      Y("btLast")
    ], t.prototype, "btLast", void 0), mr([
      Y("lbRecordCount")
    ], t.prototype, "lbRecordCount", void 0), mr([
      Y("lbFirstRowOnPage")
    ], t.prototype, "lbFirstRowOnPage", void 0), mr([
      Y("lbLastRowOnPage")
    ], t.prototype, "lbLastRowOnPage", void 0), mr([
      Y("lbCurrent")
    ], t.prototype, "lbCurrent", void 0), mr([
      Y("lbTotal")
    ], t.prototype, "lbTotal", void 0), mr([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var EO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Nn = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Bn;
(function(i) {
  i[i.Loading = 0] = "Loading", i[i.NoRows = 1] = "NoRows";
})(Bn || (Bn = {}));
var RO = (
  /** @class */
  function(i) {
    EO(t, i);
    function t() {
      var e = i.call(this, t.TEMPLATE) || this;
      return e.inProgress = !1, e.destroyRequested = !1, e.manuallyDisplayed = !1, e;
    }
    return t.prototype.updateLayoutClasses = function(e, r) {
      var o = this.eOverlayWrapper.classList;
      o.toggle(lt.AUTO_HEIGHT, r.autoHeight), o.toggle(lt.NORMAL, r.normal), o.toggle(lt.PRINT, r.print);
    }, t.prototype.postConstruct = function() {
      this.createManagedBean(new cc(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.addManagedListener(this.eventService, m.EVENT_ROW_DATA_UPDATED, this.onRowDataUpdated.bind(this)), this.addManagedListener(this.eventService, m.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this)), this.gridOptionsService.isRowModelType("clientSide") && !this.gridOptionsService.get("rowData") && this.showLoadingOverlay(), this.gridApi.registerOverlayWrapperComp(this);
    }, t.prototype.setWrapperTypeClass = function(e) {
      var r = this.eOverlayWrapper.classList;
      r.toggle("ag-overlay-loading-wrapper", e === Bn.Loading), r.toggle("ag-overlay-no-rows-wrapper", e === Bn.NoRows);
    }, t.prototype.showLoadingOverlay = function() {
      if (!this.gridOptionsService.is("suppressLoadingOverlay")) {
        var e = {}, r = this.userComponentFactory.getLoadingOverlayCompDetails(e), o = r.newAgStackInstance();
        this.showOverlay(o, Bn.Loading);
      }
    }, t.prototype.showNoRowsOverlay = function() {
      if (!this.gridOptionsService.is("suppressNoRowsOverlay")) {
        var e = {}, r = this.userComponentFactory.getNoRowsOverlayCompDetails(e), o = r.newAgStackInstance();
        this.showOverlay(o, Bn.NoRows);
      }
    }, t.prototype.showOverlay = function(e, r) {
      var o = this;
      this.inProgress || (this.setWrapperTypeClass(r), this.destroyActiveOverlay(), this.inProgress = !0, e && e.then(function(n) {
        o.inProgress = !1, o.eOverlayWrapper.appendChild(n.getGui()), o.activeOverlay = n, o.destroyRequested && (o.destroyRequested = !1, o.destroyActiveOverlay());
      }), this.manuallyDisplayed = this.columnModel.isReady() && !this.paginationProxy.isEmpty(), this.setDisplayed(!0, { skipAriaHidden: !0 }));
    }, t.prototype.destroyActiveOverlay = function() {
      if (this.inProgress) {
        this.destroyRequested = !0;
        return;
      }
      this.activeOverlay && (this.activeOverlay = this.getContext().destroyBean(this.activeOverlay), pr(this.eOverlayWrapper));
    }, t.prototype.hideOverlay = function() {
      this.manuallyDisplayed = !1, this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
    }, t.prototype.destroy = function() {
      this.destroyActiveOverlay(), i.prototype.destroy.call(this);
    }, t.prototype.showOrHideOverlay = function() {
      var e = this.paginationProxy.isEmpty(), r = this.gridOptionsService.is("suppressNoRowsOverlay");
      e && !r ? this.showNoRowsOverlay() : this.hideOverlay();
    }, t.prototype.onRowDataUpdated = function() {
      this.showOrHideOverlay();
    }, t.prototype.onNewColumnsLoaded = function() {
      this.columnModel.isReady() && !this.paginationProxy.isEmpty() && !this.manuallyDisplayed && this.hideOverlay();
    }, t.TEMPLATE = `
        <div class="ag-overlay" aria-hidden="true">
            <div class="ag-overlay-panel">
                <div class="ag-overlay-wrapper" ref="eOverlayWrapper"></div>
            </div>
        </div>`, Nn([
      v("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), Nn([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Nn([
      v("gridApi")
    ], t.prototype, "gridApi", void 0), Nn([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Nn([
      Y("eOverlayWrapper")
    ], t.prototype, "eOverlayWrapper", void 0), Nn([
      U
    ], t.prototype, "postConstruct", null), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var OO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Os = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, kv = (
  /** @class */
  function(i) {
    OO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.getFirstRow = function() {
      var e = 0, r;
      return this.pinnedRowModel.getPinnedTopRowCount() ? r = "top" : this.rowModel.getRowCount() ? (r = null, e = this.paginationProxy.getPageFirstRow()) : this.pinnedRowModel.getPinnedBottomRowCount() && (r = "bottom"), r === void 0 ? null : { rowIndex: e, rowPinned: r };
    }, t.prototype.getLastRow = function() {
      var e, r = null, o = this.pinnedRowModel.getPinnedBottomRowCount(), n = this.pinnedRowModel.getPinnedTopRowCount();
      return o ? (r = "bottom", e = o - 1) : this.rowModel.getRowCount() ? (r = null, e = this.paginationProxy.getPageLastRow()) : n && (r = "top", e = n - 1), e === void 0 ? null : { rowIndex: e, rowPinned: r };
    }, t.prototype.getRowNode = function(e) {
      switch (e.rowPinned) {
        case "top":
          return this.pinnedRowModel.getPinnedTopRowData()[e.rowIndex];
        case "bottom":
          return this.pinnedRowModel.getPinnedBottomRowData()[e.rowIndex];
        default:
          return this.rowModel.getRow(e.rowIndex);
      }
    }, t.prototype.sameRow = function(e, r) {
      return !e && !r ? !0 : e && !r || !e && r ? !1 : e.rowIndex === r.rowIndex && e.rowPinned == r.rowPinned;
    }, t.prototype.before = function(e, r) {
      switch (e.rowPinned) {
        case "top":
          if (r.rowPinned !== "top")
            return !0;
          break;
        case "bottom":
          if (r.rowPinned !== "bottom")
            return !1;
          break;
        default:
          if (k(r.rowPinned))
            return r.rowPinned !== "top";
          break;
      }
      return e.rowIndex < r.rowIndex;
    }, t.prototype.rowMax = function(e) {
      var r = this, o;
      return e.forEach(function(n) {
        (o === void 0 || r.before(o, n)) && (o = n);
      }), o;
    }, t.prototype.rowMin = function(e) {
      var r = this, o;
      return e.forEach(function(n) {
        (o === void 0 || r.before(n, o)) && (o = n);
      }), o;
    }, Os([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Os([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Os([
      v("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), t = Os([
      te("rowPositionUtils")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var bO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), TO = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, jv = (
  /** @class */
  function(i) {
    bO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.createId = function(e) {
      var r = e.rowIndex, o = e.rowPinned, n = e.column;
      return this.createIdFromValues({ rowIndex: r, column: n, rowPinned: o });
    }, t.prototype.createIdFromValues = function(e) {
      var r = e.rowIndex, o = e.rowPinned, n = e.column;
      return r + "." + (o ?? "null") + "." + n.getId();
    }, t.prototype.equals = function(e, r) {
      var o = e.column === r.column, n = e.rowPinned === r.rowPinned, s = e.rowIndex === r.rowIndex;
      return o && n && s;
    }, t = TO([
      te("cellPositionUtils")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var PO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ei = (
  /** @class */
  /* @__PURE__ */ function() {
    function i(t) {
      this.cellValueChanges = t;
    }
    return i;
  }()
), kl = (
  /** @class */
  function(i) {
    PO(t, i);
    function t(e, r, o, n) {
      var s = i.call(this, e) || this;
      return s.initialRange = r, s.finalRange = o, s.ranges = n, s;
    }
    return t;
  }(Ei)
), hd = (
  /** @class */
  function() {
    function i(t) {
      this.actionStack = [], this.maxStackSize = t || i.DEFAULT_STACK_SIZE, this.actionStack = new Array(this.maxStackSize);
    }
    return i.prototype.pop = function() {
      return this.actionStack.pop();
    }, i.prototype.push = function(t) {
      var e = t.cellValueChanges && t.cellValueChanges.length > 0;
      e && (this.actionStack.length === this.maxStackSize && this.actionStack.shift(), this.actionStack.push(t));
    }, i.prototype.clear = function() {
      this.actionStack = [];
    }, i.prototype.getCurrentStackSize = function() {
      return this.actionStack.length;
    }, i.DEFAULT_STACK_SIZE = 10, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var DO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), da = function() {
  return da = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, da.apply(this, arguments);
}, Xr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, AO = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, xO = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(AO(arguments[t]));
  return i;
}, FO = (
  /** @class */
  function(i) {
    DO(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.cellValueChanges = [], e.activeCellEdit = null, e.activeRowEdit = null, e.isPasting = !1, e.isRangeInAction = !1, e.onCellValueChanged = function(r) {
        var o = { column: r.column, rowIndex: r.rowIndex, rowPinned: r.rowPinned }, n = e.activeCellEdit !== null && e.cellPositionUtils.equals(e.activeCellEdit, o), s = e.activeRowEdit !== null && e.rowPositionUtils.sameRow(e.activeRowEdit, o), a = n || s || e.isPasting || e.isRangeInAction;
        if (a) {
          var l = r.rowPinned, u = r.rowIndex, c = r.column, p = r.oldValue, d = r.value, h = {
            rowPinned: l,
            rowIndex: u,
            columnId: c.getColId(),
            newValue: d,
            oldValue: p
          };
          e.cellValueChanges.push(h);
        }
      }, e.clearStacks = function() {
        e.undoStack.clear(), e.redoStack.clear();
      }, e;
    }
    return t.prototype.init = function() {
      var e = this;
      if (this.gridOptionsService.is("undoRedoCellEditing")) {
        var r = this.gridOptionsService.getNum("undoRedoCellEditingLimit");
        r <= 0 || (this.undoStack = new hd(r), this.redoStack = new hd(r), this.addRowEditingListeners(), this.addCellEditingListeners(), this.addPasteListeners(), this.addFillListeners(), this.addCellKeyListeners(), this.addManagedListener(this.eventService, m.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged), this.addManagedListener(this.eventService, m.EVENT_MODEL_UPDATED, function(o) {
          o.keepUndoRedoStack || e.clearStacks();
        }), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks), this.addManagedListener(this.eventService, m.EVENT_NEW_COLUMNS_LOADED, this.clearStacks), this.addManagedListener(this.eventService, m.EVENT_COLUMN_GROUP_OPENED, this.clearStacks), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks), this.addManagedListener(this.eventService, m.EVENT_COLUMN_MOVED, this.clearStacks), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PINNED, this.clearStacks), this.addManagedListener(this.eventService, m.EVENT_COLUMN_VISIBLE, this.clearStacks), this.addManagedListener(this.eventService, m.EVENT_ROW_DRAG_END, this.clearStacks), this.ctrlsService.whenReady(function() {
          e.gridBodyCtrl = e.ctrlsService.getGridBodyCtrl();
        }));
      }
    }, t.prototype.getCurrentUndoStackSize = function() {
      return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
    }, t.prototype.getCurrentRedoStackSize = function() {
      return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
    }, t.prototype.undo = function(e) {
      var r = {
        type: m.EVENT_UNDO_STARTED,
        source: e
      };
      this.eventService.dispatchEvent(r);
      var o = this.undoRedo(this.undoStack, this.redoStack, "initialRange", "oldValue", "undo"), n = {
        type: m.EVENT_UNDO_ENDED,
        source: e,
        operationPerformed: o
      };
      this.eventService.dispatchEvent(n);
    }, t.prototype.redo = function(e) {
      var r = {
        type: m.EVENT_REDO_STARTED,
        source: e
      };
      this.eventService.dispatchEvent(r);
      var o = this.undoRedo(this.redoStack, this.undoStack, "finalRange", "newValue", "redo"), n = {
        type: m.EVENT_REDO_ENDED,
        source: e,
        operationPerformed: o
      };
      this.eventService.dispatchEvent(n);
    }, t.prototype.undoRedo = function(e, r, o, n, s) {
      if (!e)
        return !1;
      var a = e.pop();
      return !a || !a.cellValueChanges ? !1 : (this.processAction(a, function(l) {
        return l[n];
      }, s), a instanceof kl ? this.processRange(a.ranges || [a[o]]) : this.processCell(a.cellValueChanges), r.push(a), !0);
    }, t.prototype.processAction = function(e, r, o) {
      var n = this;
      e.cellValueChanges.forEach(function(s) {
        var a = s.rowIndex, l = s.rowPinned, u = s.columnId, c = { rowIndex: a, rowPinned: l }, p = n.getRowNode(c);
        p.displayed && p.setDataValue(u, r(s), o);
      });
    }, t.prototype.processRange = function(e) {
      var r = this, o;
      this.rangeService.removeAllCellRanges(!0), e.forEach(function(n, s) {
        if (n) {
          var a = n.startRow, l = n.endRow;
          s === e.length - 1 && (o = {
            rowPinned: a.rowPinned,
            rowIndex: a.rowIndex,
            columnId: n.startColumn.getColId()
          }, r.setLastFocusedCell(o));
          var u = {
            rowStartIndex: a.rowIndex,
            rowStartPinned: a.rowPinned,
            rowEndIndex: l.rowIndex,
            rowEndPinned: l.rowPinned,
            columnStart: n.startColumn,
            columns: n.columns
          };
          r.rangeService.addCellRange(u);
        }
      });
    }, t.prototype.processCell = function(e) {
      var r = e[0], o = r.rowIndex, n = r.rowPinned, s = { rowIndex: o, rowPinned: n }, a = this.getRowNode(s), l = {
        rowPinned: r.rowPinned,
        rowIndex: a.rowIndex,
        columnId: r.columnId
      };
      this.setLastFocusedCell(l, !!this.rangeService);
    }, t.prototype.setLastFocusedCell = function(e, r) {
      var o = e.rowIndex, n = e.columnId, s = e.rowPinned, a = this.gridBodyCtrl.getScrollFeature(), l = this.columnModel.getGridColumn(n);
      if (l) {
        a.ensureIndexVisible(o), a.ensureColumnVisible(l);
        var u = { rowIndex: o, column: l, rowPinned: s };
        this.focusService.setFocusedCell(da(da({}, u), { forceBrowserFocus: !0 })), r && this.rangeService.setRangeToCell(u);
      }
    }, t.prototype.addRowEditingListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_ROW_EDITING_STARTED, function(r) {
        e.activeRowEdit = { rowIndex: r.rowIndex, rowPinned: r.rowPinned };
      }), this.addManagedListener(this.eventService, m.EVENT_ROW_EDITING_STOPPED, function() {
        var r = new Ei(e.cellValueChanges);
        e.pushActionsToUndoStack(r), e.activeRowEdit = null;
      });
    }, t.prototype.addCellEditingListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_CELL_EDITING_STARTED, function(r) {
        e.activeCellEdit = { column: r.column, rowIndex: r.rowIndex, rowPinned: r.rowPinned };
      }), this.addManagedListener(this.eventService, m.EVENT_CELL_EDITING_STOPPED, function(r) {
        e.activeCellEdit = null;
        var o = r.valueChanged && !e.activeRowEdit && !e.isPasting && !e.isRangeInAction;
        if (o) {
          var n = new Ei(e.cellValueChanges);
          e.pushActionsToUndoStack(n);
        }
      });
    }, t.prototype.addPasteListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_PASTE_START, function() {
        e.isPasting = !0;
      }), this.addManagedListener(this.eventService, m.EVENT_PASTE_END, function() {
        var r = new Ei(e.cellValueChanges);
        e.pushActionsToUndoStack(r), e.isPasting = !1;
      });
    }, t.prototype.addFillListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_FILL_START, function() {
        e.isRangeInAction = !0;
      }), this.addManagedListener(this.eventService, m.EVENT_FILL_END, function(r) {
        var o = new kl(e.cellValueChanges, r.initialRange, r.finalRange);
        e.pushActionsToUndoStack(o), e.isRangeInAction = !1;
      });
    }, t.prototype.addCellKeyListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_KEY_SHORTCUT_CHANGED_CELL_START, function() {
        e.isRangeInAction = !0;
      }), this.addManagedListener(this.eventService, m.EVENT_KEY_SHORTCUT_CHANGED_CELL_END, function() {
        var r;
        e.rangeService && e.gridOptionsService.isEnableRangeSelection() ? r = new kl(e.cellValueChanges, void 0, void 0, xO(e.rangeService.getCellRanges())) : r = new Ei(e.cellValueChanges), e.pushActionsToUndoStack(r), e.isRangeInAction = !1;
      });
    }, t.prototype.pushActionsToUndoStack = function(e) {
      this.undoStack.push(e), this.cellValueChanges = [], this.redoStack.clear();
    }, t.prototype.getRowNode = function(e) {
      switch (e.rowPinned) {
        case "top":
          return this.pinnedRowModel.getPinnedTopRowData()[e.rowIndex];
        case "bottom":
          return this.pinnedRowModel.getPinnedBottomRowData()[e.rowIndex];
        default:
          return this.rowModel.getRow(e.rowIndex);
      }
    }, Xr([
      v("focusService")
    ], t.prototype, "focusService", void 0), Xr([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Xr([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Xr([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Xr([
      v("cellPositionUtils")
    ], t.prototype, "cellPositionUtils", void 0), Xr([
      v("rowPositionUtils")
    ], t.prototype, "rowPositionUtils", void 0), Xr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Xr([
      Fe("rangeService")
    ], t.prototype, "rangeService", void 0), Xr([
      U
    ], t.prototype, "init", null), t = Xr([
      te("undoRedoService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var MO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Wv = (
  /** @class */
  function(i) {
    MO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.findHeader = function(e, r) {
      var o, n, s;
      if (e.column instanceof qt ? (n = "getDisplayedGroup" + r, o = this.columnModel[n](e.column)) : (s = "getDisplayedCol" + r, o = this.columnModel[s](e.column)), !!o) {
        var a = e.headerRowIndex, l = this.getHeaderRowType(a);
        if (l === Pt.COLUMN_GROUP) {
          var u = o;
          if (u.isPadding() && this.isAnyChildSpanningHeaderHeight(u)) {
            var c = this.getColumnVisibleChild(u, a, r), p = c.nextFocusColumn, d = c.nextRow;
            p && (o = p, a = d);
          }
        }
        return {
          column: o,
          headerRowIndex: a
        };
      }
    }, t.prototype.isAnyChildSpanningHeaderHeight = function(e) {
      return e ? e.getLeafColumns().some(function(r) {
        return r.isSpanHeaderHeight();
      }) : !1;
    }, t.prototype.getColumnVisibleParent = function(e, r) {
      var o = this.getHeaderRowType(r), n = o === Pt.FLOATING_FILTER, s = o === Pt.COLUMN, a = n ? e : e.getParent(), l = r - 1;
      if (s && this.isAnyChildSpanningHeaderHeight(e.getParent())) {
        for (; a && a.isPadding(); )
          a = a.getParent(), l--;
        l < 0 && (a = e, l = r);
      }
      return { nextFocusColumn: a, nextRow: l };
    }, t.prototype.getColumnVisibleChild = function(e, r, o) {
      o === void 0 && (o = "After");
      var n = this.getHeaderRowType(r), s = e, a = r + 1;
      if (n === Pt.COLUMN_GROUP) {
        var l = e.getLeafColumns(), u = o === "After" ? l[0] : Ne(l);
        if (this.isAnyChildSpanningHeaderHeight(u.getParent())) {
          s = u;
          for (var c = u.getParent(); c && c !== e; )
            c = c.getParent(), a++;
        } else
          s = e.getDisplayedChildren()[0];
      }
      return { nextFocusColumn: s, nextRow: a };
    }, t.prototype.getHeaderRowType = function(e) {
      var r = this.ctrlsService.getHeaderRowContainerCtrl();
      if (r)
        return r.getRowType(e);
    }, t.prototype.findColAtEdgeForHeaderRow = function(e, r) {
      var o = this.columnModel.getAllDisplayedColumns(), n = o[r === "start" ? 0 : o.length - 1];
      if (n) {
        var s = this.ctrlsService.getHeaderRowContainerCtrl(n.getPinned()), a = s.getRowType(e);
        if (a == Pt.COLUMN_GROUP) {
          var l = this.columnModel.getColumnGroupAtLevel(n, e);
          return {
            headerRowIndex: e,
            column: l
          };
        }
        return {
          // if type==null, means the header level didn't exist
          headerRowIndex: a == null ? -1 : e,
          column: n
        };
      }
    }, jl([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), jl([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = jl([
      te("headerPositionUtils")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var IO = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, LO = (
  /** @class */
  function() {
    function i() {
    }
    return i.prototype.buildColumnDefs = function(t, e, r) {
      var o = this, n = [], s = {};
      return t.forEach(function(a) {
        for (var l = o.createDefFromColumn(a, e, r), u = !0, c = l, p = a.getOriginalParent(); p; ) {
          var d = null;
          if (p.isPadding()) {
            p = p.getOriginalParent();
            continue;
          }
          var h = s[p.getGroupId()];
          if (h) {
            h.children.push(c), u = !1;
            break;
          }
          d = o.createDefFromGroup(p), d && (d.children = [c], s[d.groupId] = d, c = d, p = p.getOriginalParent());
        }
        u && n.push(c);
      }), n;
    }, i.prototype.createDefFromGroup = function(t) {
      var e = zs(t.getColGroupDef(), ["children"]);
      return e && (e.groupId = t.getGroupId()), e;
    }, i.prototype.createDefFromColumn = function(t, e, r) {
      var o = zs(t.getColDef());
      return o.colId = t.getColId(), o.width = t.getActualWidth(), o.rowGroup = t.isRowGroupActive(), o.rowGroupIndex = t.isRowGroupActive() ? e.indexOf(t) : null, o.pivot = t.isPivotActive(), o.pivotIndex = t.isPivotActive() ? r.indexOf(t) : null, o.aggFunc = t.isValueActive() ? t.getAggFunc() : null, o.hide = t.isVisible() ? void 0 : !0, o.pinned = t.isPinned() ? t.getPinned() : null, o.sort = t.getSort() ? t.getSort() : null, o.sortIndex = t.getSortIndex() != null ? t.getSortIndex() : null, o;
    }, i = IO([
      te("columnDefFactory")
    ], i), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Wl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, NO = (
  /** @class */
  function() {
    function i() {
    }
    return i.prototype.getInitialRowClasses = function(t) {
      var e = [];
      return k(t.extraCssClass) && e.push(t.extraCssClass), e.push("ag-row"), e.push(t.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), t.fadeRowIn && e.push("ag-opacity-zero"), e.push(t.rowIsEven ? "ag-row-even" : "ag-row-odd"), t.rowNode.isRowPinned() && e.push("ag-row-pinned"), t.rowNode.isSelected() && e.push("ag-row-selected"), t.rowNode.footer && e.push("ag-row-footer"), e.push("ag-row-level-" + t.rowLevel), t.rowNode.stub && e.push("ag-row-loading"), t.fullWidthRow && e.push("ag-full-width-row"), t.expandable && (e.push("ag-row-group"), e.push(t.rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted")), t.rowNode.dragging && e.push("ag-row-dragging"), tu(e, this.processClassesFromGridOptions(t.rowNode)), tu(e, this.preProcessRowClassRules(t.rowNode)), e.push(t.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), t.firstRowOnPage && e.push("ag-row-first"), t.lastRowOnPage && e.push("ag-row-last"), t.fullWidthRow && (t.pinned === "left" && e.push("ag-cell-last-left-pinned"), t.pinned === "right" && e.push("ag-cell-first-right-pinned")), e;
    }, i.prototype.processClassesFromGridOptions = function(t) {
      var e = [], r = function(l) {
        typeof l == "string" ? e.push(l) : Array.isArray(l) && l.forEach(function(u) {
          return e.push(u);
        });
      }, o = this.gridOptionsService.get("rowClass");
      if (o) {
        if (typeof o == "function")
          return console.warn("AG Grid: rowClass should not be a function, please use getRowClass instead"), [];
        r(o);
      }
      var n = this.gridOptionsService.getCallback("getRowClass");
      if (n) {
        var s = {
          data: t.data,
          node: t,
          rowIndex: t.rowIndex
        }, a = n(s);
        r(a);
      }
      return e;
    }, i.prototype.preProcessRowClassRules = function(t) {
      var e = [];
      return this.processRowClassRules(t, function(r) {
        e.push(r);
      }, function(r) {
      }), e;
    }, i.prototype.processRowClassRules = function(t, e, r) {
      var o = {
        data: t.data,
        node: t,
        rowIndex: t.rowIndex,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context
      };
      this.stylingService.processClassRules(this.gridOptionsService.get("rowClassRules"), o, e, r);
    }, i.prototype.calculateRowLevel = function(t) {
      return t.group ? t.level : t.parent ? t.parent.level + 1 : 0;
    }, Wl([
      v("stylingService")
    ], i.prototype, "stylingService", void 0), Wl([
      v("gridOptionsService")
    ], i.prototype, "gridOptionsService", void 0), i = Wl([
      te("rowCssClassCalculator")
    ], i), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var GO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), bs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Uv = (
  /** @class */
  function(i) {
    GO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      var e = this;
      this.isAccentedSort = this.gridOptionsService.is("accentedSort"), this.primaryColumnsSortGroups = this.gridOptionsService.isColumnsSortingCoupledToGroup(), this.addManagedPropertyListener("accentedSort", function(r) {
        return e.isAccentedSort = r.currentValue;
      }), this.addManagedPropertyListener("autoGroupColumnDef", function() {
        return e.primaryColumnsSortGroups = e.gridOptionsService.isColumnsSortingCoupledToGroup();
      });
    }, t.prototype.doFullSort = function(e, r) {
      var o = function(s, a) {
        return { currentPos: a, rowNode: s };
      }, n = e.map(o);
      return n.sort(this.compareRowNodes.bind(this, r)), n.map(function(s) {
        return s.rowNode;
      });
    }, t.prototype.compareRowNodes = function(e, r, o) {
      for (var n = r.rowNode, s = o.rowNode, a = 0, l = e.length; a < l; a++) {
        var u = e[a], c = u.sort === "desc", p = this.getValue(n, u.column), d = this.getValue(s, u.column), h = void 0, g = this.getComparator(u, n);
        g ? h = g(p, d, n, s, c) : h = le.defaultComparator(p, d, this.isAccentedSort);
        var y = !isNaN(h);
        if (y && h !== 0)
          return u.sort === "asc" ? h : h * -1;
      }
      return r.currentPos - o.currentPos;
    }, t.prototype.getComparator = function(e, r) {
      var o = e.column, n = o.getColDef().comparator;
      if (n != null)
        return n;
      if (o.getColDef().showRowGroup) {
        var s = !r.group && o.getColDef().field;
        if (s) {
          var a = this.columnModel.getPrimaryColumn(s);
          if (a)
            return a.getColDef().comparator;
        }
      }
    }, t.prototype.getValue = function(e, r) {
      var o, n;
      if (!this.primaryColumnsSortGroups)
        return this.valueService.getValue(r, e, !1, !1);
      var s = e.rowGroupColumn === r;
      if (s) {
        var a = this.gridOptionsService.isGroupUseEntireRow(this.columnModel.isPivotActive());
        if (a) {
          var l = r.getColDef().keyCreator;
          if (l)
            return e.key;
          var u = (o = e.allLeafChildren) === null || o === void 0 ? void 0 : o[0];
          return u ? this.valueService.getValue(r, u, !1, !1) : void 0;
        }
        var c = this.columnModel.getGroupDisplayColumnForGroup(r.getId());
        return c ? (n = e.groupData) === null || n === void 0 ? void 0 : n[c.getId()] : void 0;
      }
      if (!(e.group && r.getColDef().showRowGroup))
        return this.valueService.getValue(r, e, !1, !1);
    }, bs([
      v("valueService")
    ], t.prototype, "valueService", void 0), bs([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), bs([
      U
    ], t.prototype, "init", null), t = bs([
      te("rowNodeSorter")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var HO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), VO = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, zv = (
  /** @class */
  function(i) {
    HO(t, i);
    function t() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.ready = !1, r.readyCallbacks = [], r;
    }
    e = t, t.prototype.checkReady = function() {
      if (this.ready = this.gridCtrl != null && this.gridBodyCtrl != null && this.centerRowContainerCtrl != null && this.leftRowContainerCtrl != null && this.rightRowContainerCtrl != null && this.bottomCenterRowContainerCtrl != null && this.bottomLeftRowContainerCtrl != null && this.bottomRightRowContainerCtrl != null && this.topCenterRowContainerCtrl != null && this.topLeftRowContainerCtrl != null && this.topRightRowContainerCtrl != null && this.stickyTopCenterRowContainerCtrl != null && this.stickyTopLeftRowContainerCtrl != null && this.stickyTopRightRowContainerCtrl != null && this.centerHeaderRowContainerCtrl != null && this.leftHeaderRowContainerCtrl != null && this.rightHeaderRowContainerCtrl != null && this.fakeHScrollComp != null && this.fakeVScrollComp != null && this.gridHeaderCtrl != null, this.ready) {
        var r = this.createReadyParams();
        this.readyCallbacks.forEach(function(o) {
          return o(r);
        }), this.readyCallbacks.length = 0;
      }
    }, t.prototype.whenReady = function(r) {
      this.ready ? r(this.createReadyParams()) : this.readyCallbacks.push(r);
    }, t.prototype.createReadyParams = function() {
      return {
        centerRowContainerCtrl: this.centerRowContainerCtrl,
        leftRowContainerCtrl: this.leftRowContainerCtrl,
        rightRowContainerCtrl: this.rightRowContainerCtrl,
        bottomCenterRowContainerCtrl: this.bottomCenterRowContainerCtrl,
        bottomLeftRowContainerCtrl: this.bottomLeftRowContainerCtrl,
        bottomRightRowContainerCtrl: this.bottomRightRowContainerCtrl,
        topCenterRowContainerCtrl: this.topCenterRowContainerCtrl,
        topLeftRowContainerCtrl: this.topLeftRowContainerCtrl,
        topRightRowContainerCtrl: this.topRightRowContainerCtrl,
        stickyTopCenterRowContainerCtrl: this.stickyTopCenterRowContainerCtrl,
        stickyTopLeftRowContainerCtrl: this.stickyTopLeftRowContainerCtrl,
        stickyTopRightRowContainerCtrl: this.stickyTopRightRowContainerCtrl,
        centerHeaderRowContainerCtrl: this.centerHeaderRowContainerCtrl,
        leftHeaderRowContainerCtrl: this.leftHeaderRowContainerCtrl,
        rightHeaderRowContainerCtrl: this.rightHeaderRowContainerCtrl,
        fakeHScrollComp: this.fakeHScrollComp,
        fakeVScrollComp: this.fakeVScrollComp,
        gridBodyCtrl: this.gridBodyCtrl,
        gridCtrl: this.gridCtrl,
        gridHeaderCtrl: this.gridHeaderCtrl
      };
    }, t.prototype.registerFakeHScrollComp = function(r) {
      this.fakeHScrollComp = r, this.checkReady();
    }, t.prototype.registerFakeVScrollComp = function(r) {
      this.fakeVScrollComp = r, this.checkReady();
    }, t.prototype.registerGridHeaderCtrl = function(r) {
      this.gridHeaderCtrl = r, this.checkReady();
    }, t.prototype.registerCenterRowContainerCtrl = function(r) {
      this.centerRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerLeftRowContainerCtrl = function(r) {
      this.leftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerRightRowContainerCtrl = function(r) {
      this.rightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerTopCenterRowContainerCtrl = function(r) {
      this.topCenterRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerTopLeftRowContainerCon = function(r) {
      this.topLeftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerTopRightRowContainerCtrl = function(r) {
      this.topRightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerStickyTopCenterRowContainerCtrl = function(r) {
      this.stickyTopCenterRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerStickyTopLeftRowContainerCon = function(r) {
      this.stickyTopLeftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerStickyTopRightRowContainerCtrl = function(r) {
      this.stickyTopRightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerBottomCenterRowContainerCtrl = function(r) {
      this.bottomCenterRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerBottomLeftRowContainerCtrl = function(r) {
      this.bottomLeftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerBottomRightRowContainerCtrl = function(r) {
      this.bottomRightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerHeaderContainer = function(r, o) {
      switch (o) {
        case "left":
          this.leftHeaderRowContainerCtrl = r;
          break;
        case "right":
          this.rightHeaderRowContainerCtrl = r;
          break;
        default:
          this.centerHeaderRowContainerCtrl = r;
          break;
      }
      this.checkReady();
    }, t.prototype.registerGridBodyCtrl = function(r) {
      this.gridBodyCtrl = r, this.checkReady();
    }, t.prototype.registerGridCtrl = function(r) {
      this.gridCtrl = r, this.checkReady();
    }, t.prototype.getFakeHScrollComp = function() {
      return this.fakeHScrollComp;
    }, t.prototype.getFakeVScrollComp = function() {
      return this.fakeVScrollComp;
    }, t.prototype.getGridHeaderCtrl = function() {
      return this.gridHeaderCtrl;
    }, t.prototype.getGridCtrl = function() {
      return this.gridCtrl;
    }, t.prototype.getCenterRowContainerCtrl = function() {
      return this.centerRowContainerCtrl;
    }, t.prototype.getTopCenterRowContainerCtrl = function() {
      return this.topCenterRowContainerCtrl;
    }, t.prototype.getBottomCenterRowContainerCtrl = function() {
      return this.bottomCenterRowContainerCtrl;
    }, t.prototype.getStickyTopCenterRowContainerCtrl = function() {
      return this.stickyTopCenterRowContainerCtrl;
    }, t.prototype.getGridBodyCtrl = function() {
      return this.gridBodyCtrl;
    }, t.prototype.getHeaderRowContainerCtrls = function() {
      return [this.leftHeaderRowContainerCtrl, this.rightHeaderRowContainerCtrl, this.centerHeaderRowContainerCtrl];
    }, t.prototype.getHeaderRowContainerCtrl = function(r) {
      switch (r) {
        case "left":
          return this.leftHeaderRowContainerCtrl;
        case "right":
          return this.rightHeaderRowContainerCtrl;
        default:
          return this.centerHeaderRowContainerCtrl;
      }
    };
    var e;
    return t.NAME = "ctrlsService", t = e = VO([
      te(e.NAME)
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var BO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), kO = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, jO = (
  /** @class */
  function(i) {
    BO(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.registry = {}, e;
    }
    return t.prototype.register = function(e) {
      this.registry[e.controllerName] = e.controllerClass;
    }, t.prototype.getInstance = function(e) {
      var r = this.registry[e];
      if (r != null)
        return new r();
    }, t = kO([
      te("ctrlsFactory")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var WO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ts = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, $v = (
  /** @class */
  function(i) {
    WO(t, i);
    function t(e, r) {
      var o = i.call(this, e) || this;
      return o.direction = r, o.hideTimeout = null, o;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, m.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this)), this.onScrollVisibilityChanged(), this.addOrRemoveCssClass("ag-apple-scrollbar", Uu() || jo());
    }, t.prototype.initialiseInvisibleScrollbar = function() {
      this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = kn(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
    }, t.prototype.addActiveListenerToggles = function() {
      var e = this, r = ["mouseenter", "mousedown", "touchstart"], o = ["mouseleave", "touchend"], n = this.getGui();
      r.forEach(function(s) {
        return e.addManagedListener(n, s, function() {
          return e.addOrRemoveCssClass("ag-scrollbar-active", !0);
        });
      }), o.forEach(function(s) {
        return e.addManagedListener(n, s, function() {
          return e.addOrRemoveCssClass("ag-scrollbar-active", !1);
        });
      });
    }, t.prototype.onScrollVisibilityChanged = function() {
      this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), this.setScrollVisible();
    }, t.prototype.hideAndShowInvisibleScrollAsNeeded = function() {
      var e = this;
      this.addManagedListener(this.eventService, m.EVENT_BODY_SCROLL, function(r) {
        r.direction === e.direction && (e.hideTimeout !== null && (window.clearTimeout(e.hideTimeout), e.hideTimeout = null), e.addOrRemoveCssClass("ag-scrollbar-scrolling", !0));
      }), this.addManagedListener(this.eventService, m.EVENT_BODY_SCROLL_END, function() {
        e.hideTimeout = window.setTimeout(function() {
          e.addOrRemoveCssClass("ag-scrollbar-scrolling", !1), e.hideTimeout = null;
        }, 400);
      });
    }, t.prototype.getViewport = function() {
      return this.eViewport;
    }, t.prototype.getContainer = function() {
      return this.eContainer;
    }, Ts([
      Y("eViewport")
    ], t.prototype, "eViewport", void 0), Ts([
      Y("eContainer")
    ], t.prototype, "eContainer", void 0), Ts([
      v("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Ts([
      v("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t;
  }(ge)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var UO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ci = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, zO = (
  /** @class */
  function(i) {
    UO(t, i);
    function t() {
      return i.call(this, t.TEMPLATE, "horizontal") || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      i.prototype.postConstruct.call(this);
      var r = this.setFakeHScrollSpacerWidths.bind(this);
      this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, r), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, r), this.addManagedListener(this.eventService, m.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedPropertyListener("domLayout", r), this.ctrlsService.registerFakeHScrollComp(this), this.createManagedBean(new fc(function(o) {
        return e.eContainer.style.width = o + "px";
      }));
    }, t.prototype.initialiseInvisibleScrollbar = function() {
      this.invisibleScrollbar === void 0 && (this.enableRtl = this.gridOptionsService.is("enableRtl"), i.prototype.initialiseInvisibleScrollbar.call(this), this.invisibleScrollbar && this.refreshCompBottom());
    }, t.prototype.onPinnedRowDataChanged = function() {
      this.refreshCompBottom();
    }, t.prototype.refreshCompBottom = function() {
      if (this.invisibleScrollbar) {
        var e = this.pinnedRowModel.getPinnedBottomTotalHeight();
        this.getGui().style.bottom = e + "px";
      }
    }, t.prototype.onScrollVisibilityChanged = function() {
      i.prototype.onScrollVisibilityChanged.call(this), this.setFakeHScrollSpacerWidths();
    }, t.prototype.setFakeHScrollSpacerWidths = function() {
      var e = this.scrollVisibleService.isVerticalScrollShowing(), r = this.columnModel.getDisplayedColumnsRightWidth(), o = !this.enableRtl && e, n = this.gridOptionsService.getScrollbarWidth();
      o && (r += n), Er(this.eRightSpacer, r), this.eRightSpacer.classList.toggle("ag-scroller-corner", r <= n);
      var s = this.columnModel.getDisplayedColumnsLeftWidth(), a = this.enableRtl && e;
      a && (s += n), Er(this.eLeftSpacer, s), this.eLeftSpacer.classList.toggle("ag-scroller-corner", s <= n);
    }, t.prototype.setScrollVisible = function() {
      var e = this.scrollVisibleService.isHorizontalScrollShowing(), r = this.invisibleScrollbar, o = this.gridOptionsService.is("suppressHorizontalScroll"), n = e && this.gridOptionsService.getScrollbarWidth() || 0, s = n === 0 && r ? 16 : n, a = o ? 0 : s;
      this.addOrRemoveCssClass("ag-scrollbar-invisible", r), cn(this.getGui(), a), cn(this.eViewport, a), cn(this.eContainer, a), this.setDisplayed(e, { skipAriaHidden: !0 });
    }, t.TEMPLATE = `<div class="ag-body-horizontal-scroll" aria-hidden="true">
            <div class="ag-horizontal-left-spacer" ref="eLeftSpacer"></div>
            <div class="ag-body-horizontal-scroll-viewport" ref="eViewport">
                <div class="ag-body-horizontal-scroll-container" ref="eContainer"></div>
            </div>
            <div class="ag-horizontal-right-spacer" ref="eRightSpacer"></div>
        </div>`, Ci([
      Y("eLeftSpacer")
    ], t.prototype, "eLeftSpacer", void 0), Ci([
      Y("eRightSpacer")
    ], t.prototype, "eRightSpacer", void 0), Ci([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Ci([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Ci([
      U
    ], t.prototype, "postConstruct", null), t;
  }($v)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var $O = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ul = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, KO = (
  /** @class */
  function(i) {
    $O(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this.checkContainerWidths.bind(this);
      this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, e), this.addManagedPropertyListener("domLayout", e);
    }, t.prototype.checkContainerWidths = function() {
      var e = this.gridOptionsService.isDomLayout("print"), r = e ? 0 : this.columnModel.getDisplayedColumnsLeftWidth(), o = e ? 0 : this.columnModel.getDisplayedColumnsRightWidth();
      r != this.leftWidth && (this.leftWidth = r, this.eventService.dispatchEvent({ type: m.EVENT_LEFT_PINNED_WIDTH_CHANGED })), o != this.rightWidth && (this.rightWidth = o, this.eventService.dispatchEvent({ type: m.EVENT_RIGHT_PINNED_WIDTH_CHANGED }));
    }, t.prototype.getPinnedRightWidth = function() {
      return this.rightWidth;
    }, t.prototype.getPinnedLeftWidth = function() {
      return this.leftWidth;
    }, Ul([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Ul([
      U
    ], t.prototype, "postConstruct", null), t = Ul([
      te("pinnedWidthService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var YO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ps = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, qO = (
  /** @class */
  function(i) {
    YO(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.events = [], e;
    }
    return t.prototype.postConstruct = function() {
      this.rowModel.getType() == "clientSide" && (this.clientSideRowModel = this.rowModel);
    }, t.prototype.dispatchExpanded = function(e) {
      var r = this;
      if (this.clientSideRowModel == null) {
        this.eventService.dispatchEvent(e);
        return;
      }
      this.events.push(e);
      var o = function() {
        r.clientSideRowModel && r.clientSideRowModel.onRowGroupOpened(), r.events.forEach(function(n) {
          return r.eventService.dispatchEvent(n);
        }), r.events = [];
      };
      this.dispatchExpandedDebounced == null && (this.dispatchExpandedDebounced = this.animationFrameService.debounce(o)), this.dispatchExpandedDebounced();
    }, Ps([
      v("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), Ps([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Ps([
      U
    ], t.prototype, "postConstruct", null), t = Ps([
      te("rowNodeEventThrottle")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Cu = function() {
  return Cu = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, Cu.apply(this, arguments);
}, Ao = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, vd = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, XO = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, QO = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(XO(arguments[t]));
  return i;
};
function JO(i) {
  if (typeof i == "number")
    return i;
  if (typeof i == "string")
    return parseInt(i, 10);
}
function gd(i) {
  return i === !0 || i === "true";
}
var Kv = (
  /** @class */
  function() {
    function i() {
      this.destroyed = !1, this.domDataKey = "__AG_" + Math.random().toString(), this.propertyEventService = new mo();
    }
    return Object.defineProperty(i.prototype, "context", {
      // This is quicker then having code call gridOptionsService.get('context')
      get: function() {
        return this.gridOptions.context;
      },
      enumerable: !1,
      configurable: !0
    }), i.prototype.agWire = function(t, e) {
      this.gridOptions.api = t, this.gridOptions.columnApi = e, this.api = t, this.columnApi = e;
    }, i.prototype.init = function() {
      this.gridOptionLookup = new Set(QO(Oi.ALL_PROPERTIES, Oi.EVENT_CALLBACKS));
      var t = !this.is("suppressAsyncEvents");
      this.eventService.addGlobalListener(this.globalEventHandler.bind(this), t), this.getScrollbarWidth();
    }, i.prototype.destroy = function() {
      this.gridOptions.api = null, this.gridOptions.columnApi = null, this.destroyed = !0;
    }, i.prototype.is = function(t) {
      return gd(this.gridOptions[t]);
    }, i.prototype.get = function(t) {
      return this.gridOptions[t];
    }, i.prototype.getNum = function(t) {
      return JO(this.gridOptions[t]);
    }, i.prototype.getCallback = function(t) {
      return this.mergeGridCommonParams(this.gridOptions[t]);
    }, i.prototype.exists = function(t) {
      return k(this.gridOptions[t]);
    }, i.prototype.mergeGridCommonParams = function(t) {
      var e = this;
      if (t) {
        var r = function(o) {
          var n = o;
          return n.api = e.api, n.columnApi = e.columnApi, n.context = e.context, t(n);
        };
        return r;
      }
      return t;
    }, i.prototype.set = function(t, e, r, o) {
      if (r === void 0 && (r = !1), o === void 0 && (o = {}), this.gridOptionLookup.has(t)) {
        var n = this.gridOptions[t];
        if (r || n !== e) {
          this.gridOptions[t] = e;
          var s = Cu({ type: t, currentValue: e, previousValue: n }, o);
          this.propertyEventService.dispatchEvent(s);
        }
      }
    }, i.prototype.addEventListener = function(t, e) {
      this.propertyEventService.addEventListener(t, e);
    }, i.prototype.removeEventListener = function(t, e) {
      this.propertyEventService.removeEventListener(t, e);
    }, i.prototype.globalEventHandler = function(t, e) {
      if (!this.destroyed) {
        var r = Oi.getCallbackForEvent(t);
        typeof this.gridOptions[r] == "function" && this.gridOptions[r](e);
      }
    }, i.prototype.getScrollbarWidth = function() {
      if (this.scrollbarWidth == null) {
        var t = typeof this.gridOptions.scrollbarWidth == "number" && this.gridOptions.scrollbarWidth >= 0, e = t ? this.gridOptions.scrollbarWidth : jf();
        e != null && (this.scrollbarWidth = e, this.eventService.dispatchEvent({
          type: m.EVENT_SCROLLBAR_WIDTH_CHANGED
        }));
      }
      return this.scrollbarWidth;
    }, i.prototype.isRowModelType = function(t) {
      return this.gridOptions.rowModelType === t || t === "clientSide" && ue(this.gridOptions.rowModelType);
    }, i.prototype.isDomLayout = function(t) {
      var e, r = (e = this.gridOptions.domLayout) !== null && e !== void 0 ? e : "normal";
      return r === t;
    }, i.prototype.isRowSelection = function() {
      return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
    }, i.prototype.useAsyncEvents = function() {
      return !this.is("suppressAsyncEvents");
    }, i.prototype.isGetRowHeightFunction = function() {
      return typeof this.gridOptions.getRowHeight == "function";
    }, i.prototype.getRowHeightForNode = function(t, e, r) {
      if (e === void 0 && (e = !1), r == null && (r = this.environment.getDefaultRowHeight()), this.isGetRowHeightFunction()) {
        if (e)
          return { height: r, estimated: !0 };
        var o = {
          node: t,
          data: t.data
        }, n = this.getCallback("getRowHeight")(o);
        if (this.isNumeric(n))
          return n === 0 && Pe(function() {
            return console.warn("AG Grid: The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.");
          }, "invalidRowHeight"), { height: Math.max(1, n), estimated: !1 };
      }
      if (t.detail && this.is("masterDetail"))
        return this.getMasterDetailRowHeight();
      var s = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : r;
      return { height: s, estimated: !1 };
    }, i.prototype.getMasterDetailRowHeight = function() {
      return this.is("detailRowAutoHeight") ? { height: 1, estimated: !1 } : this.isNumeric(this.gridOptions.detailRowHeight) ? { height: this.gridOptions.detailRowHeight, estimated: !1 } : { height: 300, estimated: !1 };
    }, i.prototype.getRowHeightAsNumber = function() {
      if (!this.gridOptions.rowHeight || ue(this.gridOptions.rowHeight))
        return this.environment.getDefaultRowHeight();
      var t = this.gridOptions.rowHeight;
      return t && this.isNumeric(t) ? (this.environment.setRowHeightVariable(t), t) : (console.warn("AG Grid row height must be a number if not using standard row model"), this.environment.getDefaultRowHeight());
    }, i.prototype.isNumeric = function(t) {
      return !isNaN(t) && typeof t == "number" && isFinite(t);
    }, i.prototype.getDomDataKey = function() {
      return this.domDataKey;
    }, i.prototype.getDomData = function(t, e) {
      var r = t[this.getDomDataKey()];
      return r ? r[e] : void 0;
    }, i.prototype.setDomData = function(t, e, r) {
      var o = this.getDomDataKey(), n = t[o];
      ue(n) && (n = {}, t[o] = n), n[e] = r;
    }, i.prototype.getDocument = function() {
      var t = null;
      return this.gridOptions.getDocument && k(this.gridOptions.getDocument) ? t = this.gridOptions.getDocument() : this.eGridDiv && (t = this.eGridDiv.ownerDocument), t && k(t) ? t : document;
    }, i.prototype.getRootNode = function() {
      return this.eGridDiv.getRootNode();
    }, i.prototype.getRowIdFunc = function() {
      var t = this.getCallback("getRowId");
      if (t)
        return t;
      var e = this.gridOptions.getRowNodeId;
      if (e)
        return function(r) {
          return e(r.data);
        };
    }, i.prototype.getAsyncTransactionWaitMillis = function() {
      return k(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : 50;
    }, i.prototype.isAnimateRows = function() {
      return this.is("ensureDomOrder") ? !1 : this.is("animateRows");
    }, i.prototype.isTreeData = function() {
      return this.is("treeData") && pe.assertRegistered(re.RowGroupingModule, "Tree Data");
    }, i.prototype.isMasterDetail = function() {
      return this.is("masterDetail") && pe.assertRegistered(re.MasterDetailModule, "masterDetail");
    }, i.prototype.isEnableRangeSelection = function() {
      return this.is("enableRangeSelection") && pe.isRegistered(re.RangeSelectionModule);
    }, i.prototype.isColumnsSortingCoupledToGroup = function() {
      var t = this.gridOptions.autoGroupColumnDef, e = this.isRowModelType("clientSide");
      return e && !(t != null && t.comparator) && !this.isTreeData();
    }, i.prototype.getGroupAggFiltering = function() {
      var t = this.gridOptions.groupAggFiltering;
      if (typeof t == "function")
        return this.getCallback("groupAggFiltering");
      if (gd(t))
        return function() {
          return !0;
        };
    }, i.prototype.isGroupMultiAutoColumn = function() {
      return this.gridOptions.groupDisplayType ? nu("multipleColumns", this.gridOptions.groupDisplayType) : this.is("groupHideOpenParents");
    }, i.prototype.isGroupUseEntireRow = function(t) {
      return t ? !1 : this.gridOptions.groupDisplayType ? nu("groupRows", this.gridOptions.groupDisplayType) : !1;
    }, Ao([
      v("gridOptions")
    ], i.prototype, "gridOptions", void 0), Ao([
      v("eventService")
    ], i.prototype, "eventService", void 0), Ao([
      v("environment")
    ], i.prototype, "environment", void 0), Ao([
      v("eGridDiv")
    ], i.prototype, "eGridDiv", void 0), Ao([
      vd(0, Bt("gridApi")),
      vd(1, Bt("columnApi"))
    ], i.prototype, "agWire", null), Ao([
      U
    ], i.prototype, "init", null), Ao([
      At
    ], i.prototype, "destroy", null), i = Ao([
      te("gridOptionsService")
    ], i), i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ZO = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), eb = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Yv = (
  /** @class */
  function(i) {
    ZO(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.getLocaleTextFunc = function() {
      var e = this.gridOptionsService.getCallback("getLocaleText");
      if (e)
        return function(n, s, a) {
          var l = {
            key: n,
            defaultValue: s,
            variableValues: a
          };
          return e(l);
        };
      var r = this.gridOptionsService.get("localeTextFunc");
      if (r)
        return r;
      var o = this.gridOptionsService.get("localeText");
      return function(n, s, a) {
        var l = o && o[n];
        if (l && a && a.length)
          for (var u = 0; !(u >= a.length); ) {
            var c = l.indexOf("${variable}");
            if (c === -1)
              break;
            l = l.replace("${variable}", a[u++]);
          }
        return l ?? s;
      };
    }, t = eb([
      te("localeService")
    ], t), t;
  }(j)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var tb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rb = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, ob = (
  /** @class */
  function(i) {
    tb(t, i);
    function t() {
      return i.call(this, t.TEMPLATE, "vertical") || this;
    }
    return t.prototype.postConstruct = function() {
      i.prototype.postConstruct.call(this), this.createManagedBean(new Bh(this.eContainer)), this.ctrlsService.registerFakeVScrollComp(this);
    }, t.prototype.setScrollVisible = function() {
      var e = this.scrollVisibleService.isVerticalScrollShowing(), r = this.invisibleScrollbar, o = e && this.gridOptionsService.getScrollbarWidth() || 0, n = o === 0 && r ? 16 : o;
      this.addOrRemoveCssClass("ag-scrollbar-invisible", r), Er(this.getGui(), n), Er(this.eViewport, n), Er(this.eContainer, n), this.setDisplayed(e, { skipAriaHidden: !0 });
    }, t.TEMPLATE = `<div class="ag-body-vertical-scroll" aria-hidden="true">
            <div class="ag-body-vertical-scroll-viewport" ref="eViewport">
                <div class="ag-body-vertical-scroll-container" ref="eContainer"></div>
            </div>
        </div>`, rb([
      U
    ], t.prototype, "postConstruct", null), t;
  }($v)
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var nb = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, yd = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(nb(arguments[t]));
  return i;
}, ib = (
  /** @class */
  function() {
    function i(t, e, r) {
      if (!e) {
        console.error("AG Grid: no gridOptions provided to the grid");
        return;
      }
      this.gridOptions = e, new qv().create(t, e, function(o) {
        var n = new Nv(t);
        o.createBean(n);
      }, void 0, r);
    }
    return i.prototype.destroy = function() {
      this.gridOptions && this.gridOptions.api && this.gridOptions.api.destroy();
    }, i;
  }()
), qv = (
  /** @class */
  function() {
    function i() {
    }
    return i.prototype.create = function(t, e, r, o, n) {
      var s = this, a = !!e.debug, l = this.getRegisteredModules(n), u = this.createBeansList(e.rowModelType, l), c = this.createProvidedBeans(t, e, n);
      if (u) {
        var p = {
          providedBeanInstances: c,
          beanClasses: u,
          debug: a
        }, d = new pa("AG Grid", function() {
          return e.debug;
        }), h = new pa("Context", function() {
          return p.debug;
        }), g = new nf(p, h), y = g.getBean("beans");
        this.registerModuleUserComponents(y, l), this.registerStackComponents(y, l), this.registerControllers(y, l), r(g), y.ctrlsService.whenReady(function() {
          s.setColumnsAndData(y), s.dispatchGridReadyEvent(y);
          var S = pe.isRegistered(re.EnterpriseCoreModule);
          d.log("initialised successfully, enterprise = " + S);
        }), o && o(g);
      }
    }, i.prototype.registerControllers = function(t, e) {
      e.forEach(function(r) {
        r.controllers && r.controllers.forEach(function(o) {
          return t.ctrlsFactory.register(o);
        });
      });
    }, i.prototype.registerStackComponents = function(t, e) {
      var r = this.createAgStackComponentsList(e);
      t.agStackComponentsRegistry.setupComponents(r);
    }, i.prototype.getRegisteredModules = function(t) {
      var e = t ? t.modules : null, r = pe.getRegisteredModules(), o = [], n = {};
      function s(a, l) {
        function u(c) {
          n[c.moduleName] || (n[c.moduleName] = !0, o.push(c), pe.register(c, a));
        }
        u(l), l.dependantModules && l.dependantModules.forEach(s.bind(null, a));
      }
      return e && e.forEach(s.bind(null, !0)), r && r.forEach(s.bind(null, !pe.isPackageBased())), o;
    }, i.prototype.registerModuleUserComponents = function(t, e) {
      var r = this.extractModuleEntity(e, function(o) {
        return o.userComponents ? o.userComponents : [];
      });
      r.forEach(function(o) {
        t.userComponentRegistry.registerDefaultComponent(o.componentName, o.componentClass);
      });
    }, i.prototype.createProvidedBeans = function(t, e, r) {
      var o = r ? r.frameworkOverrides : null;
      ue(o) && (o = new Tv());
      var n = {
        gridOptions: e,
        eGridDiv: t,
        globalEventListener: r ? r.globalEventListener : null,
        frameworkOverrides: o
      };
      return r && r.providedBeanInstances && Object.assign(n, r.providedBeanInstances), n;
    }, i.prototype.createAgStackComponentsList = function(t) {
      var e = [
        { componentName: "AgCheckbox", componentClass: Yn },
        { componentName: "AgRadioButton", componentClass: nc },
        { componentName: "AgToggleButton", componentClass: yv },
        { componentName: "AgInputTextField", componentClass: Cn },
        { componentName: "AgInputTextArea", componentClass: mv },
        { componentName: "AgInputNumberField", componentClass: xa },
        { componentName: "AgInputRange", componentClass: Cv },
        { componentName: "AgSelect", componentClass: Ii },
        { componentName: "AgSlider", componentClass: wv },
        { componentName: "AgGridBody", componentClass: jh },
        { componentName: "AgHeaderRoot", componentClass: iv },
        { componentName: "AgSortIndicator", componentClass: Ma },
        { componentName: "AgPagination", componentClass: _O },
        { componentName: "AgOverlayWrapper", componentClass: RO },
        { componentName: "AgGroupComponent", componentClass: Sv },
        { componentName: "AgPanel", componentClass: yc },
        { componentName: "AgDialog", componentClass: Ov },
        { componentName: "AgRowContainer", componentClass: Yh },
        { componentName: "AgFakeHorizontalScroll", componentClass: zO },
        { componentName: "AgFakeVerticalScroll", componentClass: ob }
      ], r = this.extractModuleEntity(t, function(o) {
        return o.agStackComponents ? o.agStackComponents : [];
      });
      return e = e.concat(r), e;
    }, i.prototype.createBeansList = function(t, e) {
      t === void 0 && (t = "clientSide");
      var r = e.filter(function(l) {
        return !l.rowModel || l.rowModel === t;
      }), o = {
        clientSide: re.ClientSideRowModelModule,
        infinite: re.InfiniteRowModelModule,
        serverSide: re.ServerSideRowModelModule,
        viewport: re.ViewportRowModelModule
      };
      if (!o[t]) {
        console.error("AG Grid: could not find row model for rowModelType = " + t);
        return;
      }
      if (pe.assertRegistered(o[t], "rowModelType = '" + t + "'")) {
        var n = [
          dc,
          kv,
          jv,
          Wv,
          rO,
          Mh,
          Dh,
          lO,
          cO,
          lv,
          xh,
          CO,
          sv,
          Yv,
          Hm,
          fv,
          Fh,
          _f,
          mo,
          Kv,
          bv,
          VR,
          Ih,
          wf,
          ov,
          vv,
          pv,
          Fv,
          vf,
          Mv,
          Dv,
          zh,
          Hv,
          xv,
          Iv,
          Sf,
          cv,
          av,
          Tt,
          Av,
          Wn,
          Uh,
          Vv,
          Pv,
          dv,
          gv,
          Wh,
          Gv,
          JR,
          eO,
          Bv,
          jm,
          sO,
          uv,
          FO,
          Ef,
          LO,
          NO,
          hv,
          Uv,
          zv,
          KO,
          qO,
          jO
        ], s = this.extractModuleEntity(r, function(l) {
          return l.beans ? l.beans : [];
        });
        n.push.apply(n, yd(s));
        var a = [];
        return n.forEach(function(l) {
          a.indexOf(l) < 0 && a.push(l);
        }), a;
      }
    }, i.prototype.extractModuleEntity = function(t, e) {
      return [].concat.apply([], yd(t.map(e)));
    }, i.prototype.setColumnsAndData = function(t) {
      var e = t.gridOptionsService.get("columnDefs");
      t.columnModel.setColumnDefs(e || [], "gridInitializing"), t.rowModel.start();
    }, i.prototype.dispatchGridReadyEvent = function(t) {
      var e = {
        type: m.EVENT_GRID_READY
      };
      t.eventService.dispatchEvent(e);
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var sb = (
  /** @class */
  function() {
    function i() {
    }
    return i.prototype.wrap = function(t, e, r, o) {
      var n = this;
      r === void 0 && (r = []);
      var s = this.createWrapper(t, o);
      return e.forEach(function(a) {
        n.createMethod(s, a, !0);
      }), r.forEach(function(a) {
        n.createMethod(s, a, !1);
      }), s;
    }, i.prototype.unwrap = function(t) {
      return t;
    }, i.prototype.createMethod = function(t, e, r) {
      t.addMethod(e, this.createMethodProxy(t, e, r));
    }, i.prototype.createMethodProxy = function(t, e, r) {
      return function() {
        return t.hasMethod(e) ? t.callMethod(e, arguments) : (r && console.warn("AG Grid: Framework component is missing the method " + e + "()"), null);
      };
    }, i;
  }()
);
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var ab = {
  columnGroup: [
    "column",
    "stackedColumn",
    "normalizedColumn"
  ],
  barGroup: [
    "bar",
    "stackedBar",
    "normalizedBar"
  ],
  pieGroup: [
    "pie",
    "doughnut"
  ],
  lineGroup: [
    "line"
  ],
  scatterGroup: [
    "scatter",
    "bubble"
  ],
  areaGroup: [
    "area",
    "stackedArea",
    "normalizedArea"
  ],
  histogramGroup: [
    "histogram"
  ],
  combinationGroup: [
    "columnLineCombo",
    "areaColumnCombo",
    "customCombo"
  ]
}, lb = [
  "chartSettings",
  "chartData",
  "chartFormat"
], ub = [
  "chartUnlink",
  "chartLink",
  "chartDownload"
], cb = {
  settings: "chartSettings",
  data: "chartData",
  format: "chartFormat"
};
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var pb = 0;
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var wu;
(function(i) {
  i.InsideBase = "insideBase", i.InsideEnd = "insideEnd", i.Center = "center", i.OutsideEnd = "outsideEnd";
})(wu || (wu = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v29.3.5
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var Qn = typeof global > "u" ? {} : global;
Qn.HTMLElement = typeof HTMLElement > "u" ? {} : HTMLElement;
Qn.HTMLButtonElement = typeof HTMLButtonElement > "u" ? {} : HTMLButtonElement;
Qn.HTMLSelectElement = typeof HTMLSelectElement > "u" ? {} : HTMLSelectElement;
Qn.HTMLInputElement = typeof HTMLInputElement > "u" ? {} : HTMLInputElement;
Qn.Node = typeof Node > "u" ? {} : Node;
Qn.MouseEvent = typeof MouseEvent > "u" ? {} : MouseEvent;
var db = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, md = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(db(arguments[t]));
  return i;
}, fb = (
  /** @class */
  function() {
    function i(t, e, r, o, n, s) {
      this.nextId = 0, this.allNodesMap = {}, this.rootNode = t, this.gridOptionsService = e, this.eventService = r, this.columnModel = o, this.beans = s, this.selectionService = n, this.rootNode.group = !0, this.rootNode.level = -1, this.rootNode.id = i.ROOT_NODE_ID, this.rootNode.allLeafChildren = [], this.rootNode.childrenAfterGroup = [], this.rootNode.childrenAfterSort = [], this.rootNode.childrenAfterAggFilter = [], this.rootNode.childrenAfterFilter = [], this.postConstruct();
    }
    return i.prototype.postConstruct = function() {
      this.suppressParentsInRowNodes = this.gridOptionsService.is("suppressParentsInRowNodes"), this.isRowMasterFunc = this.gridOptionsService.get("isRowMaster"), this.doingTreeData = this.gridOptionsService.isTreeData(), this.doingMasterDetail = this.gridOptionsService.isMasterDetail();
    }, i.prototype.getCopyOfNodesMap = function() {
      return le.cloneObject(this.allNodesMap);
    }, i.prototype.getRowNode = function(t) {
      return this.allNodesMap[t];
    }, i.prototype.setRowData = function(t) {
      var e = this;
      if (typeof t == "string") {
        console.warn("AG Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first");
        return;
      }
      var r = this.rootNode, o = this.rootNode.sibling;
      r.childrenAfterFilter = null, r.childrenAfterGroup = null, r.childrenAfterAggFilter = null, r.childrenAfterSort = null, r.childrenMapped = null, r.updateHasChildren(), this.nextId = 0, this.allNodesMap = {}, t ? r.allLeafChildren = t.map(function(n) {
        return e.createNode(n, e.rootNode, i.TOP_LEVEL);
      }) : (r.allLeafChildren = [], r.childrenAfterGroup = []), o && (o.childrenAfterFilter = r.childrenAfterFilter, o.childrenAfterGroup = r.childrenAfterGroup, o.childrenAfterAggFilter = r.childrenAfterAggFilter, o.childrenAfterSort = r.childrenAfterSort, o.childrenMapped = r.childrenMapped, o.allLeafChildren = r.allLeafChildren);
    }, i.prototype.updateRowData = function(t, e) {
      var r = {
        remove: [],
        update: [],
        add: []
      }, o = [];
      return this.executeRemove(t, r, o), this.executeUpdate(t, r, o), this.executeAdd(t, r), this.updateSelection(o, "rowDataChanged"), e && le.sortRowNodesByOrder(this.rootNode.allLeafChildren, e), r;
    }, i.prototype.updateSelection = function(t, e) {
      var r = t.length > 0;
      if (r && t.forEach(function(n) {
        n.setSelected(!1, !1, !0, e);
      }), this.selectionService.updateGroupsFromChildrenSelections(e), r) {
        var o = {
          type: m.EVENT_SELECTION_CHANGED,
          source: e
        };
        this.eventService.dispatchEvent(o);
      }
    }, i.prototype.executeAdd = function(t, e) {
      var r = this, o, n = t.add, s = t.addIndex;
      if (!le.missingOrEmpty(n)) {
        var a = n.map(function(g) {
          return r.createNode(g, r.rootNode, i.TOP_LEVEL);
        });
        if (typeof s == "number" && s >= 0) {
          var l = this.rootNode.allLeafChildren, u = l.length, c = s;
          if (this.doingTreeData && s > 0 && u > 0) {
            for (var p = 0; p < u; p++)
              if (((o = l[p]) === null || o === void 0 ? void 0 : o.rowIndex) == s - 1) {
                c = p + 1;
                break;
              }
          }
          var d = l.slice(0, c), h = l.slice(c, l.length);
          this.rootNode.allLeafChildren = md(d, a, h);
        } else
          this.rootNode.allLeafChildren = md(this.rootNode.allLeafChildren, a);
        this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren), e.add = a;
      }
    }, i.prototype.executeRemove = function(t, e, r) {
      var o = this, n = t.remove;
      if (!le.missingOrEmpty(n)) {
        var s = {};
        n.forEach(function(a) {
          var l = o.lookupRowNode(a);
          l && (l.isSelected() && r.push(l), l.clearRowTopAndRowIndex(), s[l.id] = !0, delete o.allNodesMap[l.id], e.remove.push(l));
        }), this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter(function(a) {
          return !s[a.id];
        }), this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren);
      }
    }, i.prototype.executeUpdate = function(t, e, r) {
      var o = this, n = t.update;
      le.missingOrEmpty(n) || n.forEach(function(s) {
        var a = o.lookupRowNode(s);
        a && (a.updateData(s), !a.selectable && a.isSelected() && r.push(a), o.setMasterForRow(a, s, i.TOP_LEVEL, !1), e.update.push(a));
      });
    }, i.prototype.lookupRowNode = function(t) {
      var e = this.gridOptionsService.getRowIdFunc(), r;
      if (e) {
        var o = e({ data: t, level: 0 });
        if (r = this.allNodesMap[o], !r)
          return console.error("AG Grid: could not find row id=" + o + ", data item was not found for this id"), null;
      } else if (r = this.rootNode.allLeafChildren.find(function(n) {
        return n.data === t;
      }), !r)
        return console.error("AG Grid: could not find data item as object was not found", t), console.error("Consider using getRowId to help the Grid find matching row data"), null;
      return r || null;
    }, i.prototype.createNode = function(t, e, r) {
      var o = new ye(this.beans);
      return o.group = !1, this.setMasterForRow(o, t, r, !0), e && !this.suppressParentsInRowNodes && (o.parent = e), o.level = r, o.setDataAndId(t, this.nextId.toString()), this.allNodesMap[o.id] && console.warn("AG Grid: duplicate node id '" + o.id + "' detected from getRowId callback, this could cause issues in your grid."), this.allNodesMap[o.id] = o, this.nextId++, o;
    }, i.prototype.setMasterForRow = function(t, e, r, o) {
      if (this.doingTreeData)
        t.setMaster(!1), o && (t.expanded = !1);
      else if (this.doingMasterDetail ? this.isRowMasterFunc ? t.setMaster(this.isRowMasterFunc(e)) : t.setMaster(!0) : t.setMaster(!1), o) {
        var n = this.columnModel.getRowGroupColumns(), s = n ? n.length : 0, a = r + s;
        t.expanded = t.master ? this.isExpanded(a) : !1;
      }
    }, i.prototype.isExpanded = function(t) {
      var e = this.gridOptionsService.getNum("groupDefaultExpanded");
      return e === -1 ? !0 : t < e;
    }, i.TOP_LEVEL = 0, i.ROOT_NODE_ID = "ROOT_NODE_ID", i;
  }()
), hb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rr = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, vb = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, Ds = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i = i.concat(vb(arguments[t]));
  return i;
}, Zr;
(function(i) {
  i[i.Normal = 0] = "Normal", i[i.AfterFilter = 1] = "AfterFilter", i[i.AfterFilterAndSort = 2] = "AfterFilterAndSort", i[i.PivotNodes = 3] = "PivotNodes";
})(Zr || (Zr = {}));
var gb = (
  /** @class */
  function(i) {
    hb(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.onRowHeightChanged_debounced = le.debounce(e.onRowHeightChanged.bind(e), 100), e.rowsToDisplay = [], e;
    }
    return t.prototype.init = function() {
      var e = this.refreshModel.bind(this, { step: xe.EVERYTHING }), r = !this.gridOptionsService.is("suppressAnimationFrame"), o = this.refreshModel.bind(this, {
        step: xe.EVERYTHING,
        afterColumnsChanged: !0,
        keepRenderedRows: !0,
        animate: r
      });
      this.addManagedListener(this.eventService, m.EVENT_NEW_COLUMNS_LOADED, o), this.addManagedListener(this.eventService, m.EVENT_COLUMN_ROW_GROUP_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, { step: xe.PIVOT })), this.addManagedListener(this.eventService, m.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_SORT_CHANGED, this.onSortChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_COLUMN_PIVOT_MODE_CHANGED, e), this.addManagedListener(this.eventService, m.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanges.bind(this));
      var n = this.refreshModel.bind(this, {
        step: xe.MAP,
        keepRenderedRows: !0,
        animate: r
      });
      this.addManagedPropertyListener("groupRemoveSingleChildren", n), this.addManagedPropertyListener("groupRemoveLowestSingleChildren", n), this.rootNode = new ye(this.beans), this.nodeManager = new fb(this.rootNode, this.gridOptionsService, this.eventService, this.columnModel, this.selectionService, this.beans);
    }, t.prototype.start = function() {
      var e = this.gridOptionsService.get("rowData");
      e && this.setRowData(e);
    }, t.prototype.ensureRowHeightsValid = function(e, r, o, n) {
      var s, a = !1;
      do {
        s = !1;
        for (var l = this.getRowIndexAtPixel(e), u = this.getRowIndexAtPixel(r), c = Math.max(l, o), p = Math.min(u, n), d = c; d <= p; d++) {
          var h = this.getRow(d);
          if (h.rowHeightEstimated) {
            var g = this.gridOptionsService.getRowHeightForNode(h);
            h.setRowHeight(g.height), s = !0, a = !0;
          }
        }
        s && this.setRowTopAndRowIndex();
      } while (s);
      return a;
    }, t.prototype.setRowTopAndRowIndex = function() {
      for (var e = this.environment.getDefaultRowHeight(), r = 0, o = /* @__PURE__ */ new Set(), n = this.gridOptionsService.isDomLayout("normal"), s = 0; s < this.rowsToDisplay.length; s++) {
        var a = this.rowsToDisplay[s];
        if (a.id != null && o.add(a.id), a.rowHeight == null) {
          var l = this.gridOptionsService.getRowHeightForNode(a, n, e);
          a.setRowHeight(l.height, l.estimated);
        }
        a.setRowTop(r), a.setRowIndex(s), r += a.rowHeight;
      }
      return o;
    }, t.prototype.clearRowTopAndRowIndex = function(e, r) {
      var o = e.isActive(), n = function(a) {
        a && a.id != null && !r.has(a.id) && a.clearRowTopAndRowIndex();
      }, s = function(a) {
        if (n(a), n(a.detailNode), n(a.sibling), a.hasChildren() && a.childrenAfterGroup) {
          var l = a.level == -1, u = o && !l && !a.expanded;
          u || a.childrenAfterGroup.forEach(s);
        }
      };
      s(this.rootNode);
    }, t.prototype.ensureRowsAtPixel = function(e, r, o) {
      var n = this;
      o === void 0 && (o = 0);
      var s = this.getRowIndexAtPixel(r), a = this.getRow(s), l = !this.gridOptionsService.is("suppressAnimationFrame");
      return a === e[0] ? !1 : (e.forEach(function(u) {
        le.removeFromArray(n.rootNode.allLeafChildren, u);
      }), e.forEach(function(u, c) {
        le.insertIntoArray(n.rootNode.allLeafChildren, u, Math.max(s + o, 0) + c);
      }), this.refreshModel({
        step: xe.EVERYTHING,
        keepRenderedRows: !0,
        keepEditingRows: !0,
        animate: l
      }), !0);
    }, t.prototype.highlightRowAtPixel = function(e, r) {
      var o = r != null ? this.getRowIndexAtPixel(r) : null, n = o != null ? this.getRow(o) : null;
      if (!n || !e || n === e || r == null) {
        this.lastHighlightedRow && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null);
        return;
      }
      var s = this.getHighlightPosition(r, n);
      this.lastHighlightedRow && this.lastHighlightedRow !== n && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null), n.setHighlighted(s), this.lastHighlightedRow = n;
    }, t.prototype.getHighlightPosition = function(e, r) {
      if (!r) {
        var o = this.getRowIndexAtPixel(e);
        if (r = this.getRow(o || 0), !r)
          return no.Below;
      }
      var n = r.rowTop, s = r.rowHeight;
      return e - n < s / 2 ? no.Above : no.Below;
    }, t.prototype.getLastHighlightedRowNode = function() {
      return this.lastHighlightedRow;
    }, t.prototype.isLastRowIndexKnown = function() {
      return !0;
    }, t.prototype.getRowCount = function() {
      return this.rowsToDisplay ? this.rowsToDisplay.length : 0;
    }, t.prototype.getTopLevelRowCount = function() {
      var e = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
      if (e)
        return 1;
      var r = this.rootNode.childrenAfterAggFilter;
      return r ? r.length : 0;
    }, t.prototype.getTopLevelRowDisplayedIndex = function(e) {
      var r = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
      if (r)
        return e;
      var o = this.rootNode.childrenAfterSort[e];
      if (this.gridOptionsService.is("groupHideOpenParents"))
        for (; o.expanded && o.childrenAfterSort && o.childrenAfterSort.length > 0; )
          o = o.childrenAfterSort[0];
      return o.rowIndex;
    }, t.prototype.getRowBounds = function(e) {
      if (le.missing(this.rowsToDisplay))
        return null;
      var r = this.rowsToDisplay[e];
      return r ? {
        rowTop: r.rowTop,
        rowHeight: r.rowHeight
      } : null;
    }, t.prototype.onRowGroupOpened = function() {
      var e = this.gridOptionsService.isAnimateRows();
      this.refreshModel({ step: xe.MAP, keepRenderedRows: !0, animate: e });
    }, t.prototype.onFilterChanged = function(e) {
      if (!e.afterDataChange) {
        var r = this.gridOptionsService.isAnimateRows(), o = e.columns.length === 0 || e.columns.some(function(s) {
          return s.isPrimary();
        }), n = o ? xe.FILTER : xe.FILTER_AGGREGATES;
        this.refreshModel({ step: n, keepRenderedRows: !0, animate: r });
      }
    }, t.prototype.onSortChanged = function() {
      var e = this.gridOptionsService.isAnimateRows();
      this.refreshModel({ step: xe.SORT, keepRenderedRows: !0, animate: e, keepEditingRows: !0 });
    }, t.prototype.getType = function() {
      return "clientSide";
    }, t.prototype.onValueChanged = function() {
      this.columnModel.isPivotActive() ? this.refreshModel({ step: xe.PIVOT }) : this.refreshModel({ step: xe.AGGREGATE });
    }, t.prototype.createChangePath = function(e) {
      var r = le.missingOrEmpty(e), o = new Na(!1, this.rootNode);
      return (r || this.gridOptionsService.isTreeData()) && o.setInactive(), o;
    }, t.prototype.isSuppressModelUpdateAfterUpdateTransaction = function(e) {
      if (!this.gridOptionsService.is("suppressModelUpdateAfterUpdateTransaction") || e.rowNodeTransactions == null)
        return !1;
      var r = e.rowNodeTransactions.filter(function(n) {
        return n.add != null && n.add.length > 0 || n.remove != null && n.remove.length > 0;
      }), o = r == null || r.length == 0;
      return o;
    }, t.prototype.buildRefreshModelParams = function(e) {
      var r = xe.EVERYTHING, o = {
        everything: xe.EVERYTHING,
        group: xe.EVERYTHING,
        filter: xe.FILTER,
        map: xe.MAP,
        aggregate: xe.AGGREGATE,
        sort: xe.SORT,
        pivot: xe.PIVOT
      };
      if (le.exists(e) && (r = o[e]), le.missing(r)) {
        console.error("AG Grid: invalid step " + e + ", available steps are " + Object.keys(o).join(", "));
        return;
      }
      var n = !this.gridOptionsService.is("suppressAnimationFrame"), s = {
        step: r,
        keepRenderedRows: !0,
        keepEditingRows: !0,
        animate: n
      };
      return s;
    }, t.prototype.refreshModel = function(e) {
      var r = typeof e == "object" && "step" in e ? e : this.buildRefreshModelParams(e);
      if (r && !this.isSuppressModelUpdateAfterUpdateTransaction(r)) {
        var o = this.createChangePath(r.rowNodeTransactions);
        switch (r.step) {
          case xe.EVERYTHING:
            this.doRowGrouping(r.groupState, r.rowNodeTransactions, r.rowNodeOrder, o, !!r.afterColumnsChanged);
          case xe.FILTER:
            this.doFilter(o);
          case xe.PIVOT:
            this.doPivot(o);
          case xe.AGGREGATE:
            this.doAggregate(o);
          case xe.FILTER_AGGREGATES:
            this.doFilterAggregates(o);
          case xe.SORT:
            this.doSort(r.rowNodeTransactions, o);
          case xe.MAP:
            this.doRowsToDisplay();
        }
        var n = this.setRowTopAndRowIndex();
        this.clearRowTopAndRowIndex(o, n);
        var s = {
          type: m.EVENT_MODEL_UPDATED,
          animate: r.animate,
          keepRenderedRows: r.keepRenderedRows,
          newData: r.newData,
          newPage: !1,
          keepUndoRedoStack: r.keepUndoRedoStack
        };
        this.eventService.dispatchEvent(s);
      }
    }, t.prototype.isEmpty = function() {
      var e = le.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
      return le.missing(this.rootNode) || e || !this.columnModel.isReady();
    }, t.prototype.isRowsToRender = function() {
      return le.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
    }, t.prototype.getNodesInRangeForSelection = function(e, r) {
      var o = !r, n = !1, s, a = [], l = this.gridOptionsService.is("groupSelectsChildren");
      return this.forEachNodeAfterFilterAndSort(function(u) {
        var c = o && !n;
        o || (u === r || u === e) && (o = !0);
        var p = u.group && l;
        if (!p) {
          var d = o && !n, h = u.isParentOfNode(s);
          (d || h) && a.push(u);
        }
        c && (u === r || u === e) && (n = !0, u === r ? s = r : s = e);
      }), a;
    }, t.prototype.setDatasource = function(e) {
      console.error("AG Grid: should never call setDatasource on clientSideRowController");
    }, t.prototype.getTopLevelNodes = function() {
      return this.rootNode ? this.rootNode.childrenAfterGroup : null;
    }, t.prototype.getRootNode = function() {
      return this.rootNode;
    }, t.prototype.getRow = function(e) {
      return this.rowsToDisplay[e];
    }, t.prototype.isRowPresent = function(e) {
      return this.rowsToDisplay.indexOf(e) >= 0;
    }, t.prototype.getRowIndexAtPixel = function(e) {
      if (this.isEmpty() || this.rowsToDisplay.length === 0)
        return -1;
      var r = 0, o = this.rowsToDisplay.length - 1;
      if (e <= 0)
        return 0;
      var n = le.last(this.rowsToDisplay);
      if (n.rowTop <= e)
        return this.rowsToDisplay.length - 1;
      for (var s = -1, a = -1; ; ) {
        var l = Math.floor((r + o) / 2), u = this.rowsToDisplay[l];
        if (this.isRowInPixel(u, e))
          return l;
        u.rowTop < e ? r = l + 1 : u.rowTop > e && (o = l - 1);
        var c = s === r && a === o;
        if (c)
          return l;
        s = r, a = o;
      }
    }, t.prototype.isRowInPixel = function(e, r) {
      var o = e.rowTop, n = e.rowTop + e.rowHeight, s = o <= r && n > r;
      return s;
    }, t.prototype.forEachLeafNode = function(e) {
      this.rootNode.allLeafChildren && this.rootNode.allLeafChildren.forEach(function(r, o) {
        return e(r, o);
      });
    }, t.prototype.forEachNode = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: Ds(this.rootNode.childrenAfterGroup || []),
        callback: e,
        recursionType: Zr.Normal,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.forEachNodeAfterFilter = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: Ds(this.rootNode.childrenAfterAggFilter || []),
        callback: e,
        recursionType: Zr.AfterFilter,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.forEachNodeAfterFilterAndSort = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: Ds(this.rootNode.childrenAfterSort || []),
        callback: e,
        recursionType: Zr.AfterFilterAndSort,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.forEachPivotNode = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: [this.rootNode],
        callback: e,
        recursionType: Zr.PivotNodes,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.recursivelyWalkNodesAndCallback = function(e) {
      var r, o = e.nodes, n = e.callback, s = e.recursionType, a = e.includeFooterNodes, l = e.index, u = o[0];
      a && (!((r = u == null ? void 0 : u.parent) === null || r === void 0) && r.sibling) && o.push(u.parent.sibling);
      for (var c = 0; c < o.length; c++) {
        var p = o[c];
        if (n(p, l++), p.hasChildren() && !p.footer) {
          var d = null;
          switch (s) {
            case Zr.Normal:
              d = p.childrenAfterGroup;
              break;
            case Zr.AfterFilter:
              d = p.childrenAfterAggFilter;
              break;
            case Zr.AfterFilterAndSort:
              d = p.childrenAfterSort;
              break;
            case Zr.PivotNodes:
              d = p.leafGroup ? null : p.childrenAfterSort;
              break;
          }
          d && (l = this.recursivelyWalkNodesAndCallback({
            nodes: Ds(d),
            callback: n,
            recursionType: s,
            index: l,
            includeFooterNodes: a
          }));
        }
      }
      return l;
    }, t.prototype.doAggregate = function(e) {
      this.aggregationStage && this.aggregationStage.execute({ rowNode: this.rootNode, changedPath: e });
    }, t.prototype.doFilterAggregates = function(e) {
      this.filterAggregatesStage ? this.filterAggregatesStage.execute({ rowNode: this.rootNode, changedPath: e }) : this.rootNode.childrenAfterAggFilter = this.rootNode.childrenAfterFilter;
    }, t.prototype.expandOrCollapseAll = function(e) {
      var r = this.gridOptionsService.isTreeData(), o = this.columnModel.isPivotActive(), n = function(l) {
        l && l.forEach(function(u) {
          var c = function() {
            u.expanded = e, n(u.childrenAfterGroup);
          };
          if (r) {
            var p = le.exists(u.childrenAfterGroup);
            p && c();
            return;
          }
          if (o) {
            var d = !u.leafGroup;
            d && c();
            return;
          }
          var h = u.group;
          h && c();
        });
      };
      this.rootNode && n(this.rootNode.childrenAfterGroup), this.refreshModel({ step: xe.MAP });
      var s = e ? "expandAll" : "collapseAll", a = {
        type: m.EVENT_EXPAND_COLLAPSE_ALL,
        source: s
      };
      this.eventService.dispatchEvent(a);
    }, t.prototype.doSort = function(e, r) {
      this.sortStage.execute({
        rowNode: this.rootNode,
        rowNodeTransactions: e,
        changedPath: r
      });
    }, t.prototype.doRowGrouping = function(e, r, o, n, s) {
      if (this.groupStage) {
        if (r ? this.groupStage.execute({
          rowNode: this.rootNode,
          rowNodeTransactions: r,
          rowNodeOrder: o,
          changedPath: n
        }) : (this.groupStage.execute({
          rowNode: this.rootNode,
          changedPath: n,
          afterColumnsChanged: s
        }), this.restoreGroupState(e)), this.gridOptionsService.is("groupSelectsChildren")) {
          var a = this.selectionService.updateGroupsFromChildrenSelections("rowGroupChanged", n);
          if (a) {
            var l = {
              type: m.EVENT_SELECTION_CHANGED,
              source: "rowGroupChanged"
            };
            this.eventService.dispatchEvent(l);
          }
        }
      } else
        this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren, this.rootNode.sibling && (this.rootNode.sibling.childrenAfterGroup = this.rootNode.childrenAfterGroup), this.rootNode.updateHasChildren();
    }, t.prototype.restoreGroupState = function(e) {
      e && le.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function(r, o) {
        typeof e[o] == "boolean" && (r.expanded = e[o]);
      });
    }, t.prototype.doFilter = function(e) {
      this.filterStage.execute({ rowNode: this.rootNode, changedPath: e });
    }, t.prototype.doPivot = function(e) {
      this.pivotStage && this.pivotStage.execute({ rowNode: this.rootNode, changedPath: e });
    }, t.prototype.getGroupState = function() {
      if (!this.rootNode.childrenAfterGroup || !this.gridOptionsService.is("rememberGroupStateWhenNewData"))
        return null;
      var e = {};
      return le.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function(r, o) {
        return e[o] = r.expanded;
      }), e;
    }, t.prototype.getCopyOfNodesMap = function() {
      return this.nodeManager.getCopyOfNodesMap();
    }, t.prototype.getRowNode = function(e) {
      var r = typeof e == "string" && e.indexOf(ye.ID_PREFIX_ROW_GROUP) == 0;
      if (r) {
        var o = void 0;
        return this.forEachNode(function(n) {
          n.id === e && (o = n);
        }), o;
      }
      return this.nodeManager.getRowNode(e);
    }, t.prototype.setRowData = function(e) {
      var r = this.getGroupState();
      this.nodeManager.setRowData(e), this.selectionService.reset(), this.filterManager.onNewRowsLoaded("rowDataUpdated");
      var o = {
        type: m.EVENT_ROW_DATA_UPDATED
      };
      this.eventService.dispatchEvent(o), this.refreshModel({
        step: xe.EVERYTHING,
        groupState: r,
        newData: !0
      });
    }, t.prototype.batchUpdateRowData = function(e, r) {
      var o = this;
      if (this.applyAsyncTransactionsTimeout == null) {
        this.rowDataTransactionBatch = [];
        var n = this.gridOptionsService.getAsyncTransactionWaitMillis();
        this.applyAsyncTransactionsTimeout = window.setTimeout(function() {
          o.executeBatchUpdateRowData();
        }, n);
      }
      this.rowDataTransactionBatch.push({ rowDataTransaction: e, callback: r });
    }, t.prototype.flushAsyncTransactions = function() {
      this.applyAsyncTransactionsTimeout != null && (clearTimeout(this.applyAsyncTransactionsTimeout), this.executeBatchUpdateRowData());
    }, t.prototype.executeBatchUpdateRowData = function() {
      var e = this;
      this.valueCache.onDataChanged();
      var r = [], o = [], n = !1;
      if (this.rowDataTransactionBatch && this.rowDataTransactionBatch.forEach(function(a) {
        var l = e.nodeManager.updateRowData(a.rowDataTransaction, void 0);
        o.push(l), a.callback && r.push(a.callback.bind(null, l)), typeof a.rowDataTransaction.addIndex == "number" && (n = !0);
      }), this.commonUpdateRowData(o, void 0, n), r.length > 0 && window.setTimeout(function() {
        r.forEach(function(a) {
          return a();
        });
      }, 0), o.length > 0) {
        var s = {
          type: m.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
          results: o
        };
        this.eventService.dispatchEvent(s);
      }
      this.rowDataTransactionBatch = null, this.applyAsyncTransactionsTimeout = void 0;
    }, t.prototype.updateRowData = function(e, r) {
      this.valueCache.onDataChanged();
      var o = this.nodeManager.updateRowData(e, r), n = typeof e.addIndex == "number";
      return this.commonUpdateRowData([o], r, n), o;
    }, t.prototype.createRowNodeOrder = function() {
      var e = this.gridOptionsService.is("suppressMaintainUnsortedOrder");
      if (!e) {
        var r = {};
        if (this.rootNode && this.rootNode.allLeafChildren)
          for (var o = 0; o < this.rootNode.allLeafChildren.length; o++) {
            var n = this.rootNode.allLeafChildren[o];
            r[n.id] = o;
          }
        return r;
      }
    }, t.prototype.commonUpdateRowData = function(e, r, o) {
      var n = !this.gridOptionsService.is("suppressAnimationFrame");
      o && (r = this.createRowNodeOrder()), this.refreshModel({
        step: xe.EVERYTHING,
        rowNodeTransactions: e,
        rowNodeOrder: r,
        keepRenderedRows: !0,
        keepEditingRows: !0,
        animate: n
      }), this.filterManager.onNewRowsLoaded("rowDataUpdated");
      var s = {
        type: m.EVENT_ROW_DATA_UPDATED
      };
      this.eventService.dispatchEvent(s);
    }, t.prototype.doRowsToDisplay = function() {
      this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
    }, t.prototype.onRowHeightChanged = function() {
      this.refreshModel({ step: xe.MAP, keepRenderedRows: !0, keepEditingRows: !0, keepUndoRedoStack: !0 });
    }, t.prototype.onRowHeightChangedDebounced = function() {
      this.onRowHeightChanged_debounced();
    }, t.prototype.resetRowHeights = function() {
      var e = this.resetRowHeightsForAllRowNodes();
      this.rootNode.setRowHeight(this.rootNode.rowHeight, !0), e && this.onRowHeightChanged();
    }, t.prototype.resetRowHeightsForAllRowNodes = function() {
      var e = !1;
      return this.forEachNode(function(r) {
        r.setRowHeight(r.rowHeight, !0);
        var o = r.detailNode;
        o && o.setRowHeight(o.rowHeight, !0), e = !0;
      }), e;
    }, t.prototype.onGridStylesChanges = function() {
      this.columnModel.isAutoRowHeightActive() || this.resetRowHeights();
    }, rr([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), rr([
      v("selectionService")
    ], t.prototype, "selectionService", void 0), rr([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), rr([
      v("valueCache")
    ], t.prototype, "valueCache", void 0), rr([
      v("beans")
    ], t.prototype, "beans", void 0), rr([
      v("filterStage")
    ], t.prototype, "filterStage", void 0), rr([
      v("sortStage")
    ], t.prototype, "sortStage", void 0), rr([
      v("flattenStage")
    ], t.prototype, "flattenStage", void 0), rr([
      Fe("groupStage")
    ], t.prototype, "groupStage", void 0), rr([
      Fe("aggregationStage")
    ], t.prototype, "aggregationStage", void 0), rr([
      Fe("pivotStage")
    ], t.prototype, "pivotStage", void 0), rr([
      Fe("filterAggregatesStage")
    ], t.prototype, "filterAggregatesStage", void 0), rr([
      U
    ], t.prototype, "init", null), t = rr([
      te("rowModel")
    ], t), t;
  }(j)
), yb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cd = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, mb = (
  /** @class */
  function(i) {
    yb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.execute = function(e) {
      var r = e.changedPath;
      this.filterService.filter(r);
    }, Cd([
      v("filterService")
    ], t.prototype, "filterService", void 0), t = Cd([
      te("filterStage")
    ], t), t;
  }(j)
), Cb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), As = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, wb = (
  /** @class */
  function(i) {
    Cb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.execute = function(e) {
      var r = this, o = this.sortController.getSortOptions(), n = le.exists(o) && o.length > 0, s = n && le.exists(e.rowNodeTransactions) && this.gridOptionsService.is("deltaSort"), a = o.some(function(l) {
        return !!r.columnModel.getGroupDisplayColumnForGroup(l.column.getId());
      });
      this.sortService.sort(o, n, s, e.rowNodeTransactions, e.changedPath, a);
    }, As([
      v("sortService")
    ], t.prototype, "sortService", void 0), As([
      v("sortController")
    ], t.prototype, "sortController", void 0), As([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), t = As([
      te("sortStage")
    ], t), t;
  }(j)
), Sb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zl = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, _b = (
  /** @class */
  function(i) {
    Sb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.execute = function(e) {
      var r = e.rowNode, o = [], n = { value: 0 }, s = this.columnModel.isPivotMode(), a = s && r.leafGroup, l = a ? [r] : r.childrenAfterSort;
      this.recursivelyAddToRowsToDisplay(l, o, n, s, 0);
      var u = o.length > 0, c = !a && u && this.gridOptionsService.is("groupIncludeTotalFooter");
      return c && (r.createFooter(), this.addRowNodeToRowsToDisplay(r.sibling, o, n, 0)), o;
    }, t.prototype.recursivelyAddToRowsToDisplay = function(e, r, o, n, s) {
      if (!le.missingOrEmpty(e))
        for (var a = this.gridOptionsService.is("groupHideOpenParents"), l = this.gridOptionsService.is("groupRemoveSingleChildren"), u = !l && this.gridOptionsService.is("groupRemoveLowestSingleChildren"), c = 0; c < e.length; c++) {
          var p = e[c], d = p.hasChildren(), h = n && !d, g = l && d && p.childrenAfterGroup.length === 1, y = u && d && p.leafGroup && p.childrenAfterGroup.length === 1, S = n && p.leafGroup, _ = a && p.expanded && !p.master && !S, w = !h && !_ && !g && !y;
          if (w && this.addRowNodeToRowsToDisplay(p, r, o, s), !(n && p.leafGroup)) {
            if (d) {
              var E = g || y;
              if (p.expanded || E) {
                var R = E ? s : s + 1;
                this.recursivelyAddToRowsToDisplay(p.childrenAfterSort, r, o, n, R), this.gridOptionsService.is("groupIncludeFooter") && this.addRowNodeToRowsToDisplay(p.sibling, r, o, s);
              }
            } else if (p.master && p.expanded) {
              var D = this.createDetailNode(p);
              this.addRowNodeToRowsToDisplay(D, r, o, s);
            }
          }
        }
    }, t.prototype.addRowNodeToRowsToDisplay = function(e, r, o, n) {
      var s = this.gridOptionsService.isGroupMultiAutoColumn();
      r.push(e), e.setUiLevel(s ? 0 : n);
    }, t.prototype.createDetailNode = function(e) {
      if (le.exists(e.detailNode))
        return e.detailNode;
      var r = new ye(this.beans);
      return r.detail = !0, r.selectable = !1, r.parent = e, le.exists(e.id) && (r.id = "detail_" + e.id), r.data = e.data, r.level = e.level + 1, e.detailNode = r, r;
    }, zl([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), zl([
      v("beans")
    ], t.prototype, "beans", void 0), t = zl([
      te("flattenStage")
    ], t), t;
  }(j)
), Eb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Rb = (
  /** @class */
  function(i) {
    Eb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      this.postSortFunc = this.getPostSortFunc();
    }, t.prototype.sort = function(e, r, o, n, s, a) {
      var l = this, u = this.gridOptionsService.is("groupMaintainOrder"), c = this.columnModel.getAllGridColumns().some(function(g) {
        return g.isRowGroupActive();
      }), p = {};
      o && n && (p = this.calculateDirtyNodes(n));
      var d = this.columnModel.isPivotMode(), h = function(g) {
        l.pullDownGroupDataForHideOpenParents(g.childrenAfterAggFilter, !0);
        var y = d && g.leafGroup, S = u && c && !g.leafGroup && !a;
        if (S) {
          var _ = g.childrenAfterAggFilter.slice(0);
          if (g.childrenAfterSort) {
            var w = {};
            g.childrenAfterSort.forEach(function(R, D) {
              w[R.id] = D;
            }), _.sort(function(R, D) {
              var B, H;
              return ((B = w[R.id]) !== null && B !== void 0 ? B : 0) - ((H = w[D.id]) !== null && H !== void 0 ? H : 0);
            });
          }
          g.childrenAfterSort = _;
        } else
          !r || y ? g.childrenAfterSort = g.childrenAfterAggFilter.slice(0) : o ? g.childrenAfterSort = l.doDeltaSort(g, p, s, e) : g.childrenAfterSort = l.rowNodeSorter.doFullSort(g.childrenAfterAggFilter, e);
        if (g.sibling && (g.sibling.childrenAfterSort = g.childrenAfterSort), l.updateChildIndexes(g), l.postSortFunc) {
          var E = { nodes: g.childrenAfterSort };
          l.postSortFunc(E);
        }
      };
      s && s.forEachChangedNodeDepthFirst(h), this.updateGroupDataForHideOpenParents(s);
    }, t.prototype.getPostSortFunc = function() {
      var e = this.gridOptionsService.getCallback("postSortRows");
      if (e)
        return e;
      var r = this.gridOptionsService.get("postSort");
      if (r)
        return function(o) {
          return r(o.nodes);
        };
    }, t.prototype.calculateDirtyNodes = function(e) {
      var r = {}, o = function(n) {
        n && n.forEach(function(s) {
          return r[s.id] = !0;
        });
      };
      return e && e.forEach(function(n) {
        o(n.add), o(n.update), o(n.remove);
      }), r;
    }, t.prototype.doDeltaSort = function(e, r, o, n) {
      var s = this, a = e.childrenAfterAggFilter, l = e.childrenAfterSort;
      if (!l)
        return this.rowNodeSorter.doFullSort(a, n);
      var u = {}, c = [];
      a.forEach(function(g) {
        r[g.id] || !o.canSkip(g) ? c.push(g) : u[g.id] = !0;
      });
      var p = l.filter(function(g) {
        return u[g.id];
      }), d = function(g, y) {
        return { currentPos: y, rowNode: g };
      }, h = c.map(d).sort(function(g, y) {
        return s.rowNodeSorter.compareRowNodes(n, g, y);
      });
      return this.mergeSortedArrays(n, h, p.map(d)).map(function(g) {
        var y = g.rowNode;
        return y;
      });
    }, t.prototype.mergeSortedArrays = function(e, r, o) {
      for (var n = [], s = 0, a = 0; s < r.length && a < o.length; ) {
        var l = this.rowNodeSorter.compareRowNodes(e, r[s], o[a]);
        l < 0 ? n.push(r[s++]) : n.push(o[a++]);
      }
      for (; s < r.length; )
        n.push(r[s++]);
      for (; a < o.length; )
        n.push(o[a++]);
      return n;
    }, t.prototype.updateChildIndexes = function(e) {
      if (!le.missing(e.childrenAfterSort))
        for (var r = e.childrenAfterSort, o = 0; o < r.length; o++) {
          var n = r[o], s = o === 0, a = o === e.childrenAfterSort.length - 1;
          n.setFirstChild(s), n.setLastChild(a), n.setChildIndex(o);
        }
    }, t.prototype.updateGroupDataForHideOpenParents = function(e) {
      var r = this;
      if (this.gridOptionsService.is("groupHideOpenParents")) {
        if (this.gridOptionsService.isTreeData()) {
          var o = "AG Grid: The property hideOpenParents dose not work with Tree Data. This is because Tree Data has values at the group level, it doesn't make sense to hide them (as opposed to Row Grouping, which only has Aggregated Values at the group level).";
          return le.doOnce(function() {
            return console.warn(o);
          }, "sortService.hideOpenParentsWithTreeData"), !1;
        }
        var n = function(s) {
          r.pullDownGroupDataForHideOpenParents(s.childrenAfterSort, !1), s.childrenAfterSort.forEach(function(a) {
            a.hasChildren() && n(a);
          });
        };
        e && e.executeFromRootNode(function(s) {
          return n(s);
        });
      }
    }, t.prototype.pullDownGroupDataForHideOpenParents = function(e, r) {
      var o = this;
      !this.gridOptionsService.is("groupHideOpenParents") || le.missing(e) || e.forEach(function(n) {
        var s = o.columnModel.getGroupDisplayColumns();
        s.forEach(function(a) {
          var l = a.getColDef().showRowGroup;
          if (typeof l != "string") {
            console.error("AG Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup");
            return;
          }
          var u = l, c = o.columnModel.getPrimaryColumn(u), p = c === n.rowGroupColumn;
          if (!p)
            if (r)
              n.setGroupValue(a.getId(), void 0);
            else {
              var d = n.getFirstChildOfFirstChild(c);
              d && n.setGroupValue(a.getId(), d.key);
            }
        });
      });
    }, xs([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), xs([
      v("rowNodeSorter")
    ], t.prototype, "rowNodeSorter", void 0), xs([
      U
    ], t.prototype, "init", null), t = xs([
      te("sortService")
    ], t), t;
  }(j)
), Ob = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), wd = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, bb = (
  /** @class */
  function(i) {
    Ob(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.filter = function(e) {
      var r = this.filterManager.isColumnFilterPresent() || this.filterManager.isQuickFilterPresent() || this.filterManager.isExternalFilterPresent();
      this.filterNodes(r, e);
    }, t.prototype.filterNodes = function(e, r) {
      var o = this, n = function(u, c) {
        u.hasChildren() && e && !c ? u.childrenAfterFilter = u.childrenAfterGroup.filter(function(p) {
          var d = p.childrenAfterFilter && p.childrenAfterFilter.length > 0, h = p.data && o.filterManager.doesRowPassFilter({ rowNode: p });
          return d || h;
        }) : u.childrenAfterFilter = u.childrenAfterGroup, u.sibling && (u.sibling.childrenAfterFilter = u.childrenAfterFilter);
      };
      if (this.doingTreeDataFiltering()) {
        var s = function(u, c) {
          if (u.childrenAfterGroup)
            for (var p = 0; p < u.childrenAfterGroup.length; p++) {
              var d = u.childrenAfterGroup[p], h = c || o.filterManager.doesRowPassFilter({ rowNode: d });
              d.childrenAfterGroup ? s(u.childrenAfterGroup[p], h) : n(d, h);
            }
          n(u, c);
        }, a = function(u) {
          return s(u, !1);
        };
        r.executeFromRootNode(a);
      } else {
        var l = function(u) {
          return n(u, !1);
        };
        r.forEachChangedNodeDepthFirst(l, !0);
      }
    }, t.prototype.doingTreeDataFiltering = function() {
      return this.gridOptionsService.isTreeData() && !this.gridOptionsService.is("excludeChildrenWhenTreeDataFiltering");
    }, wd([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), t = wd([
      te("filterService")
    ], t), t;
  }(j)
), Tb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Fs = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Pb = function(i, t) {
  var e = typeof Symbol == "function" && i[Symbol.iterator];
  if (!e)
    return i;
  var r = e.call(i), o, n = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      n.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (e = r.return) && e.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return n;
}, Db = (
  /** @class */
  function(i) {
    Tb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel);
    }, t.prototype.isActive = function() {
      var e = this.gridOptionsService.exists("getRowId"), r = this.gridOptionsService.is("immutableData"), o = this.gridOptionsService.is("resetRowDataOnUpdate");
      return o ? !1 : e || r;
    }, t.prototype.setRowData = function(e) {
      var r = this.createTransactionForRowData(e);
      if (r) {
        var o = Pb(r, 2), n = o[0], s = o[1];
        this.clientSideRowModel.updateRowData(n, s);
      }
    }, t.prototype.createTransactionForRowData = function(e) {
      if (le.missing(this.clientSideRowModel)) {
        console.error("AG Grid: ImmutableService only works with ClientSideRowModel");
        return;
      }
      var r = this.gridOptionsService.getRowIdFunc();
      if (r == null) {
        console.error("AG Grid: ImmutableService requires getRowId() callback to be implemented, your row data needs IDs!");
        return;
      }
      var o = {
        remove: [],
        update: [],
        add: []
      }, n = this.clientSideRowModel.getCopyOfNodesMap(), s = this.gridOptionsService.is("suppressMaintainUnsortedOrder"), a = s ? void 0 : {};
      return le.exists(e) && e.forEach(function(l, u) {
        var c = r({ data: l, level: 0 }), p = n[c];
        if (a && (a[c] = u), p) {
          var d = p.data !== l;
          d && o.update.push(l), n[c] = void 0;
        } else
          o.add.push(l);
      }), le.iterateObject(n, function(l, u) {
        u && o.remove.push(u.data);
      }), [o, a];
    }, Fs([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Fs([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Fs([
      U
    ], t.prototype, "postConstruct", null), t = Fs([
      te("immutableService")
    ], t), t;
  }(j)
), Ab = "29.3.5", Xv = {
  version: Ab,
  moduleName: re.ClientSideRowModelModule,
  rowModel: "clientSide",
  beans: [gb, mb, wb, _b, Rb, bb, Db]
}, xb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $l = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Sd = (
  /** @class */
  function(i) {
    xb(t, i);
    function t(e, r, o) {
      var n = i.call(this, e) || this;
      return n.parentCache = r, n.params = o, n.startRow = e * o.blockSize, n.endRow = n.startRow + o.blockSize, n;
    }
    return t.prototype.postConstruct = function() {
      this.createRowNodes();
    }, t.prototype.getBlockStateJson = function() {
      return {
        id: "" + this.getId(),
        state: {
          blockNumber: this.getId(),
          startRow: this.getStartRow(),
          endRow: this.getEndRow(),
          pageStatus: this.getState()
        }
      };
    }, t.prototype.setDataAndId = function(e, r, o) {
      !e.id && e.alreadyRendered && (e.alreadyRendered = !1), le.exists(r) ? e.setDataAndId(r, o.toString()) : e.setDataAndId(void 0, void 0);
    }, t.prototype.loadFromDatasource = function() {
      var e = this, r = this.createLoadParams();
      if (le.missing(this.params.datasource.getRows)) {
        console.warn("AG Grid: datasource is missing getRows method");
        return;
      }
      window.setTimeout(function() {
        e.params.datasource.getRows(r);
      }, 0);
    }, t.prototype.processServerFail = function() {
    }, t.prototype.createLoadParams = function() {
      var e = {
        startRow: this.getStartRow(),
        endRow: this.getEndRow(),
        successCallback: this.pageLoaded.bind(this, this.getVersion()),
        failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
        sortModel: this.params.sortModel,
        filterModel: this.params.filterModel,
        context: this.gridOptionsService.context
      };
      return e;
    }, t.prototype.forEachNode = function(e, r, o) {
      var n = this;
      this.rowNodes.forEach(function(s, a) {
        var l = n.startRow + a;
        l < o && e(s, r.next());
      });
    }, t.prototype.getLastAccessed = function() {
      return this.lastAccessed;
    }, t.prototype.getRow = function(e, r) {
      r === void 0 && (r = !1), r || (this.lastAccessed = this.params.lastAccessedSequence.next());
      var o = e - this.startRow;
      return this.rowNodes[o];
    }, t.prototype.getStartRow = function() {
      return this.startRow;
    }, t.prototype.getEndRow = function() {
      return this.endRow;
    }, t.prototype.createRowNodes = function() {
      this.rowNodes = [];
      for (var e = 0; e < this.params.blockSize; e++) {
        var r = this.startRow + e, o = new ye(this.beans);
        o.setRowHeight(this.params.rowHeight), o.uiLevel = 0, o.setRowIndex(r), o.setRowTop(this.params.rowHeight * r), this.rowNodes.push(o);
      }
    }, t.prototype.processServerResult = function(e) {
      var r = this;
      this.rowNodes.forEach(function(n, s) {
        var a = e.rowData ? e.rowData[s] : void 0;
        r.setDataAndId(n, a, r.startRow + s);
      });
      var o = e.rowCount != null && e.rowCount >= 0 ? e.rowCount : void 0;
      this.parentCache.pageLoaded(this, o);
    }, t.prototype.destroyRowNodes = function() {
      this.rowNodes.forEach(function(e) {
        e.clearRowTopAndRowIndex();
      });
    }, $l([
      v("beans")
    ], t.prototype, "beans", void 0), $l([
      U
    ], t.prototype, "postConstruct", null), $l([
      At
    ], t.prototype, "destroyRowNodes", null), t;
  }(aa)
), Fb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ms = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Mb = function(i, t) {
  return function(e, r) {
    t(e, r, i);
  };
}, Ib = (
  /** @class */
  function(i) {
    Fb(t, i);
    function t(e) {
      var r = i.call(this) || this;
      return r.lastRowIndexKnown = !1, r.blocks = {}, r.blockCount = 0, r.rowCount = e.initialRowCount, r.params = e, r;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("InfiniteCache");
    }, t.prototype.getRow = function(e, r) {
      r === void 0 && (r = !1);
      var o = Math.floor(e / this.params.blockSize), n = this.blocks[o];
      if (!n) {
        if (r)
          return;
        n = this.createBlock(o);
      }
      return n.getRow(e);
    }, t.prototype.createBlock = function(e) {
      var r = this.createBean(new Sd(e, this, this.params));
      return this.blocks[r.getId()] = r, this.blockCount++, this.purgeBlocksIfNeeded(r), this.params.rowNodeBlockLoader.addBlock(r), r;
    }, t.prototype.refreshCache = function() {
      var e = this.blockCount == 0;
      if (e) {
        this.purgeCache();
        return;
      }
      this.getBlocksInOrder().forEach(function(r) {
        return r.setStateWaitingToLoad();
      }), this.params.rowNodeBlockLoader.checkBlockToLoad();
    }, t.prototype.destroyAllBlocks = function() {
      var e = this;
      this.getBlocksInOrder().forEach(function(r) {
        return e.destroyBlock(r);
      });
    }, t.prototype.getRowCount = function() {
      return this.rowCount;
    }, t.prototype.isLastRowIndexKnown = function() {
      return this.lastRowIndexKnown;
    }, t.prototype.pageLoaded = function(e, r) {
      this.isAlive() && (this.logger.log("onPageLoaded: page = " + e.getId() + ", lastRow = " + r), this.checkRowCount(e, r), this.onCacheUpdated());
    }, t.prototype.purgeBlocksIfNeeded = function(e) {
      var r = this, o = this.getBlocksInOrder().filter(function(u) {
        return u != e;
      }), n = function(u, c) {
        return c.getLastAccessed() - u.getLastAccessed();
      };
      o.sort(n);
      var s = this.params.maxBlocksInCache > 0, a = s ? this.params.maxBlocksInCache - 1 : null, l = t.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
      o.forEach(function(u, c) {
        var p = u.getState() === Sd.STATE_WAITING_TO_LOAD && c >= l, d = s ? c >= a : !1;
        if (p || d) {
          if (r.isBlockCurrentlyDisplayed(u) || r.isBlockFocused(u))
            return;
          r.removeBlockFromCache(u);
        }
      });
    }, t.prototype.isBlockFocused = function(e) {
      var r = this.focusService.getFocusCellToUseAfterRefresh();
      if (!r || r.rowPinned != null)
        return !1;
      var o = e.getStartRow(), n = e.getEndRow(), s = r.rowIndex >= o && r.rowIndex < n;
      return s;
    }, t.prototype.isBlockCurrentlyDisplayed = function(e) {
      var r = e.getStartRow(), o = e.getEndRow() - 1;
      return this.rowRenderer.isRangeInRenderedViewport(r, o);
    }, t.prototype.removeBlockFromCache = function(e) {
      e && this.destroyBlock(e);
    }, t.prototype.checkRowCount = function(e, r) {
      if (typeof r == "number" && r >= 0)
        this.rowCount = r, this.lastRowIndexKnown = !0;
      else if (!this.lastRowIndexKnown) {
        var o = (e.getId() + 1) * this.params.blockSize, n = o + this.params.overflowSize;
        this.rowCount < n && (this.rowCount = n);
      }
    }, t.prototype.setRowCount = function(e, r) {
      this.rowCount = e, le.exists(r) && (this.lastRowIndexKnown = r), this.lastRowIndexKnown || this.rowCount % this.params.blockSize === 0 && this.rowCount++, this.onCacheUpdated();
    }, t.prototype.forEachNodeDeep = function(e) {
      var r = this, o = new fn();
      this.getBlocksInOrder().forEach(function(n) {
        return n.forEachNode(e, o, r.rowCount);
      });
    }, t.prototype.getBlocksInOrder = function() {
      var e = function(o, n) {
        return o.getId() - n.getId();
      }, r = le.getAllValuesInObject(this.blocks).sort(e);
      return r;
    }, t.prototype.destroyBlock = function(e) {
      delete this.blocks[e.getId()], this.destroyBean(e), this.blockCount--, this.params.rowNodeBlockLoader.removeBlock(e);
    }, t.prototype.onCacheUpdated = function() {
      if (this.isAlive()) {
        this.destroyAllBlocksPastVirtualRowCount();
        var e = {
          type: m.EVENT_STORE_UPDATED
        };
        this.eventService.dispatchEvent(e);
      }
    }, t.prototype.destroyAllBlocksPastVirtualRowCount = function() {
      var e = this, r = [];
      this.getBlocksInOrder().forEach(function(o) {
        var n = o.getId() * e.params.blockSize;
        n >= e.rowCount && r.push(o);
      }), r.length > 0 && r.forEach(function(o) {
        return e.destroyBlock(o);
      });
    }, t.prototype.purgeCache = function() {
      var e = this;
      this.getBlocksInOrder().forEach(function(r) {
        return e.removeBlockFromCache(r);
      }), this.lastRowIndexKnown = !1, this.rowCount === 0 && (this.rowCount = this.params.initialRowCount), this.onCacheUpdated();
    }, t.prototype.getRowNodesInRange = function(e, r) {
      var o = this, n = [], s = -1, a = !1, l = new fn();
      le.missing(e) && (a = !0);
      var u = !1;
      this.getBlocksInOrder().forEach(function(p) {
        if (!u) {
          if (a && s + 1 !== p.getId()) {
            u = !0;
            return;
          }
          s = p.getId(), p.forEachNode(function(d) {
            var h = d === e || d === r;
            (a || h) && n.push(d), h && (a = !a);
          }, l, o.rowCount);
        }
      });
      var c = u || a;
      return c ? [] : n;
    }, t.MAX_EMPTY_BLOCKS_TO_KEEP = 2, Ms([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Ms([
      v("focusService")
    ], t.prototype, "focusService", void 0), Ms([
      Mb(0, Bt("loggerFactory"))
    ], t.prototype, "setBeans", null), Ms([
      At
    ], t.prototype, "destroyAllBlocks", null), t;
  }(j)
), Lb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xo = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Nb = (
  /** @class */
  function(i) {
    Lb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.getRowBounds = function(e) {
      return {
        rowHeight: this.rowHeight,
        rowTop: this.rowHeight * e
      };
    }, t.prototype.ensureRowHeightsValid = function(e, r, o, n) {
      return !1;
    }, t.prototype.init = function() {
      var e = this;
      this.gridOptionsService.isRowModelType("infinite") && (this.rowHeight = this.gridOptionsService.getRowHeightAsNumber(), this.addEventListeners(), this.addDestroyFunc(function() {
        return e.destroyCache();
      }), this.verifyProps());
    }, t.prototype.verifyProps = function() {
      if (this.gridOptionsService.exists("initialGroupOrderComparator") || this.gridOptionsService.exists("defaultGroupOrderComparator")) {
        var e = "AG Grid: initialGroupOrderComparator cannot be used with Infinite Row Model. If using Infinite Row Model, then sorting is done on the server side, nothing to do with the client.";
        le.doOnce(function() {
          return console.warn(e);
        }, "IRM.InitialGroupOrderComparator");
      }
    }, t.prototype.start = function() {
      this.setDatasource(this.gridOptionsService.get("datasource"));
    }, t.prototype.destroyDatasource = function() {
      this.datasource && (this.getContext().destroyBean(this.datasource), this.rowRenderer.datasourceChanged(), this.datasource = null);
    }, t.prototype.addEventListeners = function() {
      this.addManagedListener(this.eventService, m.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_SORT_CHANGED, this.onSortChanged.bind(this)), this.addManagedListener(this.eventService, m.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this)), this.addManagedListener(this.eventService, m.EVENT_STORE_UPDATED, this.onCacheUpdated.bind(this));
    }, t.prototype.onFilterChanged = function() {
      this.reset();
    }, t.prototype.onSortChanged = function() {
      this.reset();
    }, t.prototype.onColumnEverything = function() {
      var e;
      this.cacheParams ? e = this.isSortModelDifferent() : e = !0, e && this.reset();
    }, t.prototype.isSortModelDifferent = function() {
      return !le.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
    }, t.prototype.getType = function() {
      return "infinite";
    }, t.prototype.setDatasource = function(e) {
      this.destroyDatasource(), this.datasource = e, e && this.reset();
    }, t.prototype.isEmpty = function() {
      return !this.infiniteCache;
    }, t.prototype.isRowsToRender = function() {
      return !!this.infiniteCache;
    }, t.prototype.getNodesInRangeForSelection = function(e, r) {
      return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(e, r) : [];
    }, t.prototype.reset = function() {
      if (this.datasource) {
        var e = this.gridOptionsService.getRowIdFunc(), r = e != null;
        r || this.selectionService.reset(), this.resetCache();
        var o = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(o);
      }
    }, t.prototype.createModelUpdatedEvent = function() {
      return {
        type: m.EVENT_MODEL_UPDATED,
        // not sure if these should all be false - noticed if after implementing,
        // maybe they should be true?
        newPage: !1,
        newData: !1,
        keepRenderedRows: !0,
        animate: !1
      };
    }, t.prototype.resetCache = function() {
      this.destroyCache(), this.cacheParams = {
        // the user provided datasource
        datasource: this.datasource,
        // sort and filter model
        filterModel: this.filterManager.getFilterModel(),
        sortModel: this.sortController.getSortModel(),
        rowNodeBlockLoader: this.rowNodeBlockLoader,
        // properties - this way we take a snapshot of them, so if user changes any, they will be
        // used next time we create a new cache, which is generally after a filter or sort change,
        // or a new datasource is set
        initialRowCount: this.defaultIfInvalid(this.gridOptionsService.getNum("infiniteInitialRowCount"), 1),
        maxBlocksInCache: this.gridOptionsService.getNum("maxBlocksInCache"),
        rowHeight: this.gridOptionsService.getRowHeightAsNumber(),
        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
        // the current page and request first row of next page
        overflowSize: this.defaultIfInvalid(this.gridOptionsService.getNum("cacheOverflowSize"), 1),
        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
        // server for one page at a time. so the default if not specified is 100.
        blockSize: this.defaultIfInvalid(this.gridOptionsService.getNum("cacheBlockSize"), 100),
        // the cache could create this, however it is also used by the pages, so handy to create it
        // here as the settings are also passed to the pages
        lastAccessedSequence: new fn()
      }, this.infiniteCache = this.createBean(new Ib(this.cacheParams));
    }, t.prototype.defaultIfInvalid = function(e, r) {
      return e > 0 ? e : r;
    }, t.prototype.destroyCache = function() {
      this.infiniteCache && (this.infiniteCache = this.destroyBean(this.infiniteCache));
    }, t.prototype.onCacheUpdated = function() {
      var e = this.createModelUpdatedEvent();
      this.eventService.dispatchEvent(e);
    }, t.prototype.getRow = function(e) {
      if (this.infiniteCache && !(e >= this.infiniteCache.getRowCount()))
        return this.infiniteCache.getRow(e);
    }, t.prototype.getRowNode = function(e) {
      var r;
      return this.forEachNode(function(o) {
        o.id === e && (r = o);
      }), r;
    }, t.prototype.forEachNode = function(e) {
      this.infiniteCache && this.infiniteCache.forEachNodeDeep(e);
    }, t.prototype.getTopLevelRowCount = function() {
      return this.getRowCount();
    }, t.prototype.getTopLevelRowDisplayedIndex = function(e) {
      return e;
    }, t.prototype.getRowIndexAtPixel = function(e) {
      if (this.rowHeight !== 0) {
        var r = Math.floor(e / this.rowHeight), o = this.getRowCount() - 1;
        return r > o ? o : r;
      }
      return 0;
    }, t.prototype.getRowCount = function() {
      return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }, t.prototype.isRowPresent = function(e) {
      var r = this.getRowNode(e.id);
      return !!r;
    }, t.prototype.refreshCache = function() {
      this.infiniteCache && this.infiniteCache.refreshCache();
    }, t.prototype.purgeCache = function() {
      this.infiniteCache && this.infiniteCache.purgeCache();
    }, t.prototype.isLastRowIndexKnown = function() {
      return this.infiniteCache ? this.infiniteCache.isLastRowIndexKnown() : !1;
    }, t.prototype.setRowCount = function(e, r) {
      this.infiniteCache && this.infiniteCache.setRowCount(e, r);
    }, xo([
      v("filterManager")
    ], t.prototype, "filterManager", void 0), xo([
      v("sortController")
    ], t.prototype, "sortController", void 0), xo([
      v("selectionService")
    ], t.prototype, "selectionService", void 0), xo([
      v("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), xo([
      v("rowNodeBlockLoader")
    ], t.prototype, "rowNodeBlockLoader", void 0), xo([
      U
    ], t.prototype, "init", null), xo([
      At
    ], t.prototype, "destroyDatasource", null), t = xo([
      te("rowModel")
    ], t), t;
  }(j)
), Gb = "29.3.5", Qv = {
  version: Gb,
  moduleName: re.InfiniteRowModelModule,
  rowModel: "infinite",
  beans: [Nb]
}, Jv = (
  /** @class */
  function() {
    function i() {
    }
    return i.prototype.setBeans = function(t) {
      this.beans = t;
    }, i.prototype.getFileName = function(t) {
      var e = this.getDefaultFileExtension();
      return (t == null || !t.length) && (t = this.getDefaultFileName()), t.indexOf(".") === -1 ? t + "." + e : t;
    }, i.prototype.getData = function(t) {
      var e = this.createSerializingSession(t), r = this.beans.gridSerializer.serialize(e, t);
      return r;
    }, i;
  }()
), Zv = (
  /** @class */
  function() {
    function i(t) {
      this.groupColumns = [];
      var e = t.columnModel, r = t.valueService, o = t.gridOptionsService, n = t.processCellCallback, s = t.processHeaderCallback, a = t.processGroupHeaderCallback, l = t.processRowGroupCallback;
      this.columnModel = e, this.valueService = r, this.gridOptionsService = o, this.processCellCallback = n, this.processHeaderCallback = s, this.processGroupHeaderCallback = a, this.processRowGroupCallback = l;
    }
    return i.prototype.prepare = function(t) {
      this.groupColumns = t.filter(function(e) {
        return !!e.getColDef().showRowGroup;
      });
    }, i.prototype.extractHeaderValue = function(t) {
      var e = this.getHeaderName(this.processHeaderCallback, t);
      return e ?? "";
    }, i.prototype.extractRowCellValue = function(t, e, r, o, n) {
      var s = this.gridOptionsService.is("groupHideOpenParents"), a = (!s || n.footer) && this.shouldRenderGroupSummaryCell(n, t, e) ? this.createValueForGroupNode(n) : this.valueService.getValue(t, n), l = this.processCell({
        accumulatedRowIndex: r,
        rowNode: n,
        column: t,
        value: a,
        processCellCallback: this.processCellCallback,
        type: o
      });
      return l ?? "";
    }, i.prototype.shouldRenderGroupSummaryCell = function(t, e, r) {
      var o, n = t && t.group;
      if (!n)
        return !1;
      var s = this.groupColumns.indexOf(e);
      if (s !== -1) {
        if (!((o = t.groupData) === null || o === void 0) && o[e.getId()])
          return !0;
        if (t.footer && t.level === -1) {
          var a = e.getColDef(), l = a == null || a.showRowGroup === !0;
          return l || a.showRowGroup === this.columnModel.getRowGroupColumns()[0].getId();
        }
      }
      var u = this.gridOptionsService.isGroupUseEntireRow(this.columnModel.isPivotMode());
      return r === 0 && u;
    }, i.prototype.getHeaderName = function(t, e) {
      return t ? t({
        column: e,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context
      }) : this.columnModel.getDisplayNameForColumn(e, "csv", !0);
    }, i.prototype.createValueForGroupNode = function(t) {
      if (this.processRowGroupCallback)
        return this.processRowGroupCallback({
          node: t,
          api: this.gridOptionsService.api,
          columnApi: this.gridOptionsService.columnApi,
          context: this.gridOptionsService.context
        });
      var e = t.footer, r = [t.key];
      if (!this.gridOptionsService.isGroupMultiAutoColumn())
        for (; t.parent; )
          t = t.parent, r.push(t.key);
      var o = r.reverse().join(" -> ");
      return e ? "Total " + o : o;
    }, i.prototype.processCell = function(t) {
      var e = t.accumulatedRowIndex, r = t.rowNode, o = t.column, n = t.value, s = t.processCellCallback, a = t.type;
      return s ? s({
        accumulatedRowIndex: e,
        column: o,
        node: r,
        value: n,
        api: this.gridOptionsService.api,
        columnApi: this.gridOptionsService.columnApi,
        context: this.gridOptionsService.context,
        type: a
      }) : n ?? "";
    }, i;
  }()
), eg = (
  /** @class */
  function() {
    function i() {
    }
    return i.download = function(t, e) {
      var r = document.defaultView || window;
      if (!r) {
        console.warn("AG Grid: There is no `window` associated with the current `document`");
        return;
      }
      var o = document.createElement("a"), n = r.URL.createObjectURL(e);
      o.setAttribute("href", n), o.setAttribute("download", t), o.style.display = "none", document.body.appendChild(o), o.dispatchEvent(new MouseEvent("click", {
        bubbles: !1,
        cancelable: !0,
        view: r
      })), document.body.removeChild(o), r.setTimeout(function() {
        r.URL.revokeObjectURL(n);
      }, 0);
    }, i;
  }()
), Hb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), _d = `\r
`, Vb = (
  /** @class */
  function(i) {
    Hb(t, i);
    function t(e) {
      var r = i.call(this, e) || this;
      r.isFirstLine = !0, r.result = "";
      var o = e.suppressQuotes, n = e.columnSeparator;
      return r.suppressQuotes = o, r.columnSeparator = n, r;
    }
    return t.prototype.addCustomContent = function(e) {
      var r = this;
      e && (typeof e == "string" ? (/^\s*\n/.test(e) || this.beginNewLine(), e = e.replace(/\r?\n/g, _d), this.result += e) : e.forEach(function(o) {
        r.beginNewLine(), o.forEach(function(n, s) {
          s !== 0 && (r.result += r.columnSeparator), r.result += r.putInQuotes(n.data.value || ""), n.mergeAcross && r.appendEmptyCells(n.mergeAcross);
        });
      }));
    }, t.prototype.onNewHeaderGroupingRow = function() {
      return this.beginNewLine(), {
        onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
      };
    }, t.prototype.onNewHeaderGroupingRowColumn = function(e, r, o, n) {
      o != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(r), this.appendEmptyCells(n);
    }, t.prototype.appendEmptyCells = function(e) {
      for (var r = 1; r <= e; r++)
        this.result += this.columnSeparator + this.putInQuotes("");
    }, t.prototype.onNewHeaderRow = function() {
      return this.beginNewLine(), {
        onColumn: this.onNewHeaderRowColumn.bind(this)
      };
    }, t.prototype.onNewHeaderRowColumn = function(e, r) {
      r != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractHeaderValue(e));
    }, t.prototype.onNewBodyRow = function() {
      return this.beginNewLine(), {
        onColumn: this.onNewBodyRowColumn.bind(this)
      };
    }, t.prototype.onNewBodyRowColumn = function(e, r, o) {
      r != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractRowCellValue(e, r, r, "csv", o));
    }, t.prototype.putInQuotes = function(e) {
      if (this.suppressQuotes)
        return e;
      if (e == null)
        return '""';
      var r;
      typeof e == "string" ? r = e : typeof e.toString == "function" ? r = e.toString() : (console.warn("AG Grid: unknown value type during csv conversion"), r = "");
      var o = r.replace(/"/g, '""');
      return '"' + o + '"';
    }, t.prototype.parse = function() {
      return this.result;
    }, t.prototype.beginNewLine = function() {
      this.isFirstLine || (this.result += _d), this.isFirstLine = !1;
    }, t;
  }(Zv)
), Bb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Gn = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, tg = (
  /** @class */
  function(i) {
    Bb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.setBeans({
        gridSerializer: this.gridSerializer,
        gridOptionsService: this.gridOptionsService
      });
    }, t.prototype.getMergedParams = function(e) {
      var r = this.gridOptionsService.get("defaultCsvExportParams");
      return Object.assign({}, r, e);
    }, t.prototype.export = function(e) {
      if (this.isExportSuppressed())
        return console.warn("AG Grid: Export cancelled. Export is not allowed as per your configuration."), "";
      var r = this.getMergedParams(e), o = this.getData(r), n = new Blob(["\uFEFF", o], { type: "text/plain" });
      return eg.download(this.getFileName(r.fileName), n), o;
    }, t.prototype.exportDataAsCsv = function(e) {
      return this.export(e);
    }, t.prototype.getDataAsCsv = function(e, r) {
      r === void 0 && (r = !1);
      var o = r ? Object.assign({}, e) : this.getMergedParams(e);
      return this.getData(o);
    }, t.prototype.getDefaultFileName = function() {
      return "export.csv";
    }, t.prototype.getDefaultFileExtension = function() {
      return "csv";
    }, t.prototype.createSerializingSession = function(e) {
      var r = this, o = r.columnModel, n = r.valueService, s = r.gridOptionsService, a = e, l = a.processCellCallback, u = a.processHeaderCallback, c = a.processGroupHeaderCallback, p = a.processRowGroupCallback, d = a.suppressQuotes, h = a.columnSeparator;
      return new Vb({
        columnModel: o,
        valueService: n,
        gridOptionsService: s,
        processCellCallback: l || void 0,
        processHeaderCallback: u || void 0,
        processGroupHeaderCallback: c || void 0,
        processRowGroupCallback: p || void 0,
        suppressQuotes: d || !1,
        columnSeparator: h || ","
      });
    }, t.prototype.isExportSuppressed = function() {
      return this.gridOptionsService.is("suppressCsvExport");
    }, Gn([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Gn([
      v("valueService")
    ], t.prototype, "valueService", void 0), Gn([
      v("gridSerializer")
    ], t.prototype, "gridSerializer", void 0), Gn([
      v("gridOptionsService")
    ], t.prototype, "gridOptionsService", void 0), Gn([
      U
    ], t.prototype, "postConstruct", null), t = Gn([
      te("csvCreator")
    ], t), t;
  }(Jv)
), kb = /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Fo = function(i, t, e, r) {
  var o = arguments.length, n = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(i, t, e, r);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (s = i[a]) && (n = (o < 3 ? s(n) : o > 3 ? s(t, e, n) : s(t, e)) || n);
  return o > 3 && n && Object.defineProperty(t, e, n), n;
}, Su;
(function(i) {
  i[i.HEADER_GROUPING = 0] = "HEADER_GROUPING", i[i.HEADER = 1] = "HEADER", i[i.BODY = 2] = "BODY";
})(Su || (Su = {}));
var rg = (
  /** @class */
  function(i) {
    kb(t, i);
    function t() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return t.prototype.serialize = function(e, r) {
      r === void 0 && (r = {});
      var o = this.getColumnsToExport(r.allColumns, r.columnKeys), n = le.compose(
        // first pass, put in the header names of the cols
        this.prepareSession(o),
        this.prependContent(r),
        this.exportColumnGroups(r, o),
        this.exportHeaders(r, o),
        this.processPinnedTopRows(r, o),
        this.processRows(r, o),
        this.processPinnedBottomRows(r, o),
        this.appendContent(r)
      );
      return n(e).parse();
    }, t.prototype.processRow = function(e, r, o, n) {
      var s = r.shouldRowBeSkipped || function() {
        return !1;
      }, a = this.gridOptionsService.context, l = this.gridOptionsService.api, u = this.gridOptionsService.columnApi, c = this.gridOptionsService.is("groupRemoveSingleChildren"), p = this.gridOptionsService.is("groupRemoveLowestSingleChildren"), d = r.rowPositions != null, h = d || !!r.onlySelected, g = this.gridOptionsService.is("groupHideOpenParents") && !h, y = this.columnModel.isPivotMode() ? n.leafGroup : !n.group, S = !!n.footer, _ = r.skipGroups || r.skipRowGroups, w = p && n.leafGroup, E = n.allChildrenCount === 1 && (c || w);
      if (_ && r.skipGroups && le.doOnce(function() {
        return console.warn("AG Grid: Since v25.2 `skipGroups` has been renamed to `skipRowGroups`.");
      }, "gridSerializer-skipGroups"), !(!y && !S && (r.skipRowGroups || E || g) || r.onlySelected && !n.isSelected() || r.skipPinnedTop && n.rowPinned === "top" || r.skipPinnedBottom && n.rowPinned === "bottom")) {
        var R = n.level === -1;
        if (!(R && !y && !S)) {
          var D = s({ node: n, api: l, columnApi: u, context: a });
          if (!D) {
            var B = e.onNewBodyRow();
            if (o.forEach(function(A, N) {
              B.onColumn(A, N, n);
            }), r.getCustomContentBelowRow) {
              var H = r.getCustomContentBelowRow({ node: n, api: l, columnApi: u, context: a });
              H && e.addCustomContent(H);
            }
          }
        }
      }
    }, t.prototype.appendContent = function(e) {
      return function(r) {
        var o = e.customFooter || e.appendContent;
        return o && (e.customFooter && le.doOnce(function() {
          return console.warn("AG Grid: Since version 25.2.0 the `customFooter` param has been deprecated. Use `appendContent` instead.");
        }, "gridSerializer-customFooter"), r.addCustomContent(o)), r;
      };
    }, t.prototype.prependContent = function(e) {
      return function(r) {
        var o = e.customHeader || e.prependContent;
        return o && (e.customHeader && le.doOnce(function() {
          return console.warn("AG Grid: Since version 25.2.0 the `customHeader` param has been deprecated. Use `prependContent` instead.");
        }, "gridSerializer-customHeader"), r.addCustomContent(o)), r;
      };
    }, t.prototype.prepareSession = function(e) {
      return function(r) {
        return r.prepare(e), r;
      };
    }, t.prototype.exportColumnGroups = function(e, r) {
      var o = this;
      return function(n) {
        if (e.skipColumnGroupHeaders)
          e.columnGroups && le.doOnce(function() {
            return console.warn("AG Grid: Since v25.2 the `columnGroups` param has deprecated, and groups are exported by default.");
          }, "gridSerializer-columnGroups");
        else {
          var s = new Iu(), a = o.displayedGroupCreator.createDisplayedGroups(r, o.columnModel.getGridBalancedTree(), s, null);
          o.recursivelyAddHeaderGroups(a, n, e.processGroupHeaderCallback);
        }
        return n;
      };
    }, t.prototype.exportHeaders = function(e, r) {
      return function(o) {
        if (!e.skipHeader && !e.skipColumnHeaders) {
          var n = o.onNewHeaderRow();
          r.forEach(function(s, a) {
            n.onColumn(s, a, void 0);
          });
        } else
          e.skipHeader && le.doOnce(function() {
            return console.warn("AG Grid: Since v25.2 the `skipHeader` param has been renamed to `skipColumnHeaders`.");
          }, "gridSerializer-skipHeader");
        return o;
      };
    }, t.prototype.processPinnedTopRows = function(e, r) {
      var o = this;
      return function(n) {
        var s = o.processRow.bind(o, n, e, r);
        return e.rowPositions ? e.rowPositions.filter(function(a) {
          return a.rowPinned === "top";
        }).sort(function(a, l) {
          return a.rowIndex - l.rowIndex;
        }).map(function(a) {
          return o.pinnedRowModel.getPinnedTopRow(a.rowIndex);
        }).forEach(s) : o.pinnedRowModel.forEachPinnedTopRow(s), n;
      };
    }, t.prototype.processRows = function(e, r) {
      var o = this;
      return function(n) {
        var s = o.rowModel, a = s.getType(), l = a === "clientSide", u = a === "serverSide", c = !l && e.onlySelected, p = o.processRow.bind(o, n, e, r), d = e.exportedRows, h = d === void 0 ? "filteredAndSorted" : d;
        if (e.rowPositions)
          e.rowPositions.filter(function(y) {
            return y.rowPinned == null;
          }).sort(function(y, S) {
            return y.rowIndex - S.rowIndex;
          }).map(function(y) {
            return s.getRow(y.rowIndex);
          }).forEach(p);
        else if (o.columnModel.isPivotMode())
          l ? s.forEachPivotNode(p, !0) : s.forEachNode(p);
        else if (e.onlySelectedAllPages || c) {
          var g = o.selectionService.getSelectedNodes();
          o.replicateSortedOrder(g), g.forEach(p);
        } else
          h === "all" ? s.forEachNode(p) : l ? s.forEachNodeAfterFilterAndSort(p, !0) : u ? s.forEachNodeAfterFilterAndSort(p) : s.forEachNode(p);
        return n;
      };
    }, t.prototype.replicateSortedOrder = function(e) {
      var r = this, o = this.sortController.getSortOptions(), n = function(s, a) {
        var l, u, c, p;
        return s.rowIndex != null && a.rowIndex != null ? s.rowIndex - a.rowIndex : s.level === a.level ? ((l = s.parent) === null || l === void 0 ? void 0 : l.id) === ((u = a.parent) === null || u === void 0 ? void 0 : u.id) ? r.rowNodeSorter.compareRowNodes(o, {
          rowNode: s,
          currentPos: (c = s.rowIndex) !== null && c !== void 0 ? c : -1
        }, {
          rowNode: a,
          currentPos: (p = a.rowIndex) !== null && p !== void 0 ? p : -1
        }) : n(s.parent, a.parent) : s.level > a.level ? n(s.parent, a) : n(s, a.parent);
      };
      e.sort(n);
    }, t.prototype.processPinnedBottomRows = function(e, r) {
      var o = this;
      return function(n) {
        var s = o.processRow.bind(o, n, e, r);
        return e.rowPositions ? e.rowPositions.filter(function(a) {
          return a.rowPinned === "bottom";
        }).sort(function(a, l) {
          return a.rowIndex - l.rowIndex;
        }).map(function(a) {
          return o.pinnedRowModel.getPinnedBottomRow(a.rowIndex);
        }).forEach(s) : o.pinnedRowModel.forEachPinnedBottomRow(s), n;
      };
    }, t.prototype.getColumnsToExport = function(e, r) {
      e === void 0 && (e = !1);
      var o = this.columnModel.isPivotMode();
      if (r && r.length)
        return this.columnModel.getGridColumns(r);
      if (e && !o) {
        var n = this.gridOptionsService.isTreeData() ? this.columnModel.getGridColumns([zn]) : [];
        return n.concat(this.columnModel.getAllPrimaryColumns() || []);
      }
      return this.columnModel.getAllDisplayedColumns();
    }, t.prototype.recursivelyAddHeaderGroups = function(e, r, o) {
      var n = [];
      e.forEach(function(s) {
        var a = s;
        a.getChildren && a.getChildren().forEach(function(l) {
          return n.push(l);
        });
      }), e.length > 0 && e[0] instanceof qt && this.doAddHeaderHeader(r, e, o), n && n.length > 0 && this.recursivelyAddHeaderGroups(n, r, o);
    }, t.prototype.doAddHeaderHeader = function(e, r, o) {
      var n = this, s = e.onNewHeaderGroupingRow(), a = 0;
      r.forEach(function(l) {
        var u = l, c;
        o ? c = o({
          columnGroup: u,
          api: n.gridOptionsService.api,
          columnApi: n.gridOptionsService.columnApi,
          context: n.gridOptionsService.context
        }) : c = n.columnModel.getDisplayNameForColumnGroup(u, "header");
        var p = u.getLeafColumns().reduce(function(d, h, g, y) {
          var S = le.last(d), _ = h.getColumnGroupShow() === "open";
          return _ ? (!S || S[1] != null) && (S = [g], d.push(S)) : S && S[1] == null && (S[1] = g - 1), g === y.length - 1 && S && S[1] == null && (S[1] = g), d;
        }, []);
        s.onColumn(u, c || "", a++, u.getLeafColumns().length - 1, p);
      });
    }, Fo([
      v("displayedGroupCreator")
    ], t.prototype, "displayedGroupCreator", void 0), Fo([
      v("columnModel")
    ], t.prototype, "columnModel", void 0), Fo([
      v("rowModel")
    ], t.prototype, "rowModel", void 0), Fo([
      v("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Fo([
      v("selectionService")
    ], t.prototype, "selectionService", void 0), Fo([
      v("rowNodeSorter")
    ], t.prototype, "rowNodeSorter", void 0), Fo([
      v("sortController")
    ], t.prototype, "sortController", void 0), t = Fo([
      te("gridSerializer")
    ], t), t;
  }(j)
), jb = "29.3.5", og = {
  version: jb,
  moduleName: re.CsvExportModule,
  beans: [tg, rg]
}, Is = `\r
`, Wb = (
  /** @class */
  function() {
    function i() {
    }
    return i.createHeader = function(t) {
      t === void 0 && (t = {});
      var e = "<?", r = "?>", o = ["version"];
      t.version || (t.version = "1.0"), t.encoding && o.push("encoding"), t.standalone && o.push("standalone");
      var n = o.map(function(s) {
        return s + '="' + t[s] + '"';
      }).join(" ");
      return e + "xml " + n + " " + r;
    }, i.createXml = function(t, e) {
      var r = this, o = "";
      t.properties && (t.properties.prefixedAttributes && t.properties.prefixedAttributes.forEach(function(s) {
        Object.keys(s.map).forEach(function(a) {
          o += r.returnAttributeIfPopulated(s.prefix + a, s.map[a], e);
        });
      }), t.properties.rawMap && Object.keys(t.properties.rawMap).forEach(function(s) {
        o += r.returnAttributeIfPopulated(s, t.properties.rawMap[s], e);
      }));
      var n = "<" + t.name + o;
      return !t.children && t.textNode == null ? n + "/>" + Is : t.textNode != null ? n + ">" + t.textNode + "</" + t.name + ">" + Is : (n += ">" + Is, t.children && t.children.forEach(function(s) {
        n += r.createXml(s, e);
      }), n + "</" + t.name + ">" + Is);
    }, i.returnAttributeIfPopulated = function(t, e, r) {
      if (!e && e !== "" && e !== 0)
        return "";
      var o = e;
      return typeof e == "boolean" && r && (o = r(e)), " " + t + '="' + o + '"';
    }, i;
  }()
), Ub = function(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], r = 0;
  if (e)
    return e.call(i);
  if (i && typeof i.length == "number")
    return {
      next: function() {
        return i && r >= i.length && (i = void 0), { value: i && i[r++], done: !i };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zb = new Uint32Array([
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
]), $b = (
  /** @class */
  function() {
    function i() {
    }
    return i.addFolders = function(t) {
      t.forEach(this.addFolder.bind(this));
    }, i.addFolder = function(t) {
      this.folders.push({
        path: t,
        created: /* @__PURE__ */ new Date(),
        isBase64: !1
      });
    }, i.addFile = function(t, e, r) {
      r === void 0 && (r = !1), this.files.push({
        path: t,
        created: /* @__PURE__ */ new Date(),
        content: e,
        isBase64: r
      });
    }, i.getContent = function(t) {
      t === void 0 && (t = "application/zip");
      var e = this.buildFileStream(), r = this.buildUint8Array(e);
      return this.clearStream(), new Blob([r], { type: t });
    }, i.clearStream = function() {
      this.folders = [], this.files = [];
    }, i.buildFileStream = function(t) {
      var e, r;
      t === void 0 && (t = "");
      var o = this.folders.concat(this.files), n = o.length, s = "", a = 0, l = 0;
      try {
        for (var u = Ub(o), c = u.next(); !c.done; c = u.next()) {
          var p = c.value, d = this.getHeader(p, a), h = d.fileHeader, g = d.folderHeader, y = d.content;
          a += h.length + y.length, l += g.length, t += h + y, s += g;
        }
      } catch (_) {
        e = { error: _ };
      } finally {
        try {
          c && !c.done && (r = u.return) && r.call(u);
        } finally {
          if (e)
            throw e.error;
        }
      }
      var S = this.buildFolderEnd(n, l, a);
      return t + s + S;
    }, i.getHeader = function(t, e) {
      var r = t.content, o = t.path, n = t.created, s = t.isBase64, a = le.utf8_encode, l = le.decToHex, u = a(o), c = u !== o, p = this.convertTime(n), d = this.convertDate(n), h = "";
      if (c) {
        var g = l(1, 1) + l(this.getFromCrc32Table(u), 4) + u;
        h = "up" + l(g.length, 2) + g;
      }
      var y = r ? this.getConvertedContent(r, s) : { size: 0, content: "" }, S = y.size, _ = y.content, w = `
\0` + (c ? "\0\b" : "\0\0") + "\0\0" + l(p, 2) + // last modified time
      l(d, 2) + // last modified date
      l(S ? this.getFromCrc32Table(_) : 0, 4) + l(S, 4) + // compressed size
      l(S, 4) + // uncompressed size
      l(u.length, 2) + // file name length
      l(h.length, 2), E = "PK" + w + u + h, R = "PK\0" + w + // file header
      "\0\0\0\0\0\0" + (r ? "\0\0\0\0" : "\0\0\0") + // external file attributes
      l(e, 4) + // relative offset of local header
      u + // file name
      h;
      return { fileHeader: E, folderHeader: R, content: _ || "" };
    }, i.getConvertedContent = function(t, e) {
      return e === void 0 && (e = !1), e && (t = t.split(";base64,")[1]), t = e ? atob(t) : t, {
        size: t.length,
        content: t
      };
    }, i.buildFolderEnd = function(t, e, r) {
      var o = le.decToHex;
      return "PK\0\0\0\0" + o(t, 2) + // total number of entries in the central folder
      o(t, 2) + // total number of entries in the central folder
      o(e, 4) + // size of the central folder
      o(r, 4) + // central folder start offset
      "\0\0";
    }, i.buildUint8Array = function(t) {
      for (var e = new Uint8Array(t.length), r = 0; r < e.length; r++)
        e[r] = t.charCodeAt(r);
      return e;
    }, i.getFromCrc32Table = function(t) {
      if (!t.length)
        return 0;
      for (var e = t.length, r = new Uint8Array(e), o = 0; o < e; o++)
        r[o] = t.charCodeAt(o);
      for (var n = -1, s = 0, a = 0, l = 0, o = 0; o < e; o++)
        s = r[o], a = (n ^ s) & 255, l = zb[a], n = n >>> 8 ^ l;
      return n ^ -1;
    }, i.convertTime = function(t) {
      var e = t.getHours();
      return e <<= 6, e = e | t.getMinutes(), e <<= 5, e = e | t.getSeconds() / 2, e;
    }, i.convertDate = function(t) {
      var e = t.getFullYear() - 1980;
      return e <<= 4, e = e | t.getMonth() + 1, e <<= 5, e = e | t.getDate(), e;
    }, i.folders = [], i.files = [], i;
  }()
), ng = [Xv, Qv, og];
pe.registerModules(ng);
const Kb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbstractHeaderCellCtrl: Ui,
  AgAbstractField: hn,
  AgAbstractLabel: oc,
  AgCheckbox: Yn,
  AgDialog: Ov,
  AgGroupComponent: Sv,
  AgInputNumberField: xa,
  AgInputRange: Cv,
  AgInputTextArea: mv,
  AgInputTextField: Cn,
  AgMenuItemComponent: Hn,
  AgMenuList: Ev,
  AgMenuPanel: Rv,
  AgPanel: yc,
  AgPickerField: uh,
  AgPromise: nr,
  get AgPromiseStatus() {
    return an;
  },
  AgRadioButton: nc,
  AgSelect: Ii,
  AgSlider: wv,
  AgStackComponentsRegistry: Ef,
  AgToggleButton: yv,
  AlignedGridsService: Dv,
  AllCommunityModules: ng,
  AnimateShowChangeCellRenderer: Oh,
  AnimateSlideCellRenderer: bh,
  AnimationFrameService: uv,
  AutoScrollService: Nh,
  AutoWidthCalculator: cv,
  Autowired: v,
  get BarColumnLabelPlacement() {
    return wu;
  },
  BaseComponentWrapper: sb,
  BaseCreator: Jv,
  BaseGridSerializingSession: Zv,
  Bean: te,
  BeanStub: j,
  Beans: dc,
  BodyDropPivotTarget: qh,
  BodyDropTarget: Qh,
  CHART_TOOLBAR_ALLOW_LIST: ub,
  CHART_TOOL_PANEL_ALLOW_LIST: lb,
  CHART_TOOL_PANEL_MENU_OPTIONS: cb,
  CellComp: Kh,
  CellCtrl: Ho,
  CellNavigationService: Pv,
  CellPositionUtils: jv,
  get CellRangeType() {
    return ln;
  },
  ChangedPath: Na,
  CheckboxSelectionComponent: lc,
  ClientSideRowModelModule: Xv,
  get ClientSideRowModelSteps() {
    return xe;
  },
  ColDefUtil: ru,
  Column: $e,
  ColumnApi: Av,
  ColumnFactory: vf,
  ColumnGroup: qt,
  ColumnKeyCreator: Yd,
  ColumnModel: wf,
  ColumnUtils: Sf,
  Component: ge,
  ComponentUtil: Oi,
  Context: nf,
  CssClassApplier: vc,
  CssClassManager: oh,
  CsvCreator: tg,
  CsvExportModule: og,
  CtrlsService: zv,
  CustomTooltipFeature: Aa,
  DEFAULT_CHART_GROUPS: ab,
  DateFilter: sc,
  DisplayedGroupCreator: _f,
  Downloader: eg,
  DragAndDropService: Tt,
  DragService: Fh,
  get DragSourceType() {
    return kt;
  },
  Environment: Vv,
  EventService: mo,
  Events: m,
  get ExcelFactoryMode() {
    return Li;
  },
  ExpressionService: Fv,
  FilterManager: Ih,
  FloatingFilterMapper: Ah,
  FocusService: Wn,
  GROUP_AUTO_COLUMN_ID: zn,
  Grid: ib,
  GridApi: Mh,
  GridBodyComp: jh,
  GridBodyCtrl: Vh,
  GridComp: Nv,
  GridCoreCreator: qv,
  GridCtrl: Lv,
  GridHeaderComp: iv,
  GridHeaderCtrl: nv,
  GridOptionsService: Kv,
  GridSerializer: rg,
  GroupCellRenderer: hu,
  GroupCellRendererCtrl: Ph,
  GroupInstanceIdCreator: Iu,
  HeaderCellCtrl: ev,
  HeaderFilterCellComp: Lh,
  HeaderFilterCellCtrl: Zh,
  HeaderGroupCellCtrl: tv,
  get HeaderNavigationDirection() {
    return Hr;
  },
  HeaderNavigationService: ov,
  HeaderPositionUtils: Wv,
  HeaderRowComp: Jh,
  HeaderRowContainerComp: js,
  HeaderRowContainerCtrl: rv,
  HeaderRowCtrl: ks,
  get HeaderRowType() {
    return Pt;
  },
  get HorizontalDirection() {
    return Gr;
  },
  HorizontalResizeService: sv,
  InfiniteRowModelModule: Qv,
  KeyCode: L,
  LargeTextCellEditor: Eh,
  get LayoutCssClasses() {
    return lt;
  },
  LocaleService: Yv,
  Logger: pa,
  LoggerFactory: Iv,
  ManagedFocusFeature: wo,
  get ModuleNames() {
    return re;
  },
  ModuleRegistry: pe,
  MouseEventService: Uh,
  MoveColumnFeature: Xh,
  NavigationService: zh,
  NumberFilter: ac,
  NumberSequence: fn,
  Optional: Fe,
  PaginationProxy: vv,
  PinnedRowModel: fv,
  PopupComponent: Xn,
  PopupEditorWrapper: $h,
  PopupService: bv,
  PositionableFeature: rc,
  PostConstruct: U,
  PreConstruct: Zl,
  PreDestroy: At,
  PropertyKeys: Nr,
  ProvidedColumnGroup: et,
  ProvidedFilter: Mi,
  Qualifier: Bt,
  QuerySelector: zC,
  RefSelector: Y,
  ResizeObserverService: lv,
  get RowAnimationCssClasses() {
    return gn;
  },
  RowContainerComp: Yh,
  RowContainerCtrl: hc,
  get RowContainerName() {
    return M;
  },
  get RowContainerType() {
    return It;
  },
  RowCtrl: Vo,
  get RowHighlightPosition() {
    return no;
  },
  RowNode: ye,
  RowNodeBlock: aa,
  RowNodeBlockLoader: hv,
  RowNodeSorter: Uv,
  RowPositionUtils: kv,
  RowRenderer: pv,
  get RowType() {
    return Su;
  },
  ScalarFilter: St,
  ScrollVisibleService: Wh,
  SelectCellEditor: Rh,
  SelectableService: Bv,
  get SelectionHandleType() {
    return Ni;
  },
  get ServerSideTransactionResultStatus() {
    return mu;
  },
  SetLeftFeature: La,
  SimpleFilter: Je,
  SortController: Gv,
  SortIndicatorComp: Ma,
  StandardMenuFactory: av,
  StylingService: gv,
  get TabGuardClassNames() {
    return pn;
  },
  TabGuardComp: zi,
  TabGuardCtrl: _v,
  TabbedLayout: IE,
  TemplateService: Mv,
  TextCellEditor: fu,
  TextFilter: Fa,
  TextFloatingFilter: _h,
  Timer: kC,
  TouchListener: sr,
  UserComponentFactory: xh,
  UserComponentRegistry: Dh,
  ValueCache: Hv,
  ValueFormatterService: dv,
  ValueService: xv,
  VanillaFrameworkOverrides: Tv,
  get VerticalDirection() {
    return vn;
  },
  VirtualList: PR,
  XmlFactory: Wb,
  ZipContainer: $b,
  _: le,
  __FORCE_MODULE_DETECTION: pb,
  getRowContainerTypeForName: kh,
  simpleHttpRequest: LE
}, Symbol.toStringTag, { value: "Module" })), xt = /* @__PURE__ */ zy(Kb);
var Ga = {}, $i = {}, Yb = P && P.__extends || /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}();
Object.defineProperty($i, "__esModule", { value: !0 });
$i.ReactComponent = void 0;
var qb = (
  /** @class */
  /* @__PURE__ */ function() {
    function i() {
    }
    return i;
  }()
), Xb = (
  /** @class */
  function(i) {
    Yb(t, i);
    function t(e, r, o) {
      var n = i.call(this) || this;
      return n.portal = null, n.reactComponent = e, n.portalManager = r, n.componentType = o, n.statelessComponent = n.isStateless(n.reactComponent), n;
    }
    return t.prototype.getGui = function() {
      return this.eParentElement;
    }, t.prototype.destroy = function() {
      return this.componentInstance && typeof this.componentInstance.destroy == "function" && this.componentInstance.destroy(), this.portalManager.destroyPortal(this.portal);
    }, t.prototype.createParentElement = function(e) {
      var r = this.portalManager.getComponentWrappingElement(), o = document.createElement(r || "div");
      return o.classList.add("ag-react-container"), e.reactContainer = o, o;
    }, t.prototype.addParentContainerStyleAndClasses = function() {
      var e = this;
      if (this.componentInstance && (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle() && Object.assign(this.eParentElement.style, this.componentInstance.getReactContainerStyle()), this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses())) {
        var r = this.componentInstance.getReactContainerClasses();
        r.forEach(function(o) {
          return e.eParentElement.classList.add(o);
        });
      }
    }, t.prototype.statelessComponentRendered = function() {
      return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
    }, t.prototype.getFrameworkComponentInstance = function() {
      return this.componentInstance;
    }, t.prototype.isStatelessComponent = function() {
      return this.statelessComponent;
    }, t.prototype.getReactComponentName = function() {
      return this.reactComponent.name;
    }, t.prototype.getMemoType = function() {
      return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
    }, t.prototype.hasSymbol = function() {
      return typeof Symbol == "function" && Symbol.for;
    }, t.prototype.isStateless = function(e) {
      return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent) || typeof e == "object" && e.$$typeof === this.getMemoType();
    }, t.prototype.hasMethod = function(e) {
      var r = this.getFrameworkComponentInstance();
      return !!r && r[e] !== null || this.fallbackMethodAvailable(e);
    }, t.prototype.callMethod = function(e, r) {
      var o = this, n = this.getFrameworkComponentInstance();
      if (this.isStatelessComponent())
        return this.fallbackMethod(e, r && r[0] ? r[0] : {});
      if (!n) {
        setTimeout(function() {
          return o.callMethod(e, r);
        });
        return;
      }
      var s = n[e];
      if (s)
        return s.apply(n, r);
      if (this.fallbackMethodAvailable(e))
        return this.fallbackMethod(e, r && r[0] ? r[0] : {});
    }, t.prototype.addMethod = function(e, r) {
      this[e] = r;
    }, t;
  }(qb)
);
$i.ReactComponent = Xb;
var _u = { exports: {} }, Jo = {};
/** @license React v17.0.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ed;
function Qb() {
  if (Ed)
    return Jo;
  Ed = 1;
  var i = Wd(), t = Ye;
  function e(O) {
    for (var x = "https://reactjs.org/docs/error-decoder.html?invariant=" + O, b = 1; b < arguments.length; b++)
      x += "&args[]=" + encodeURIComponent(arguments[b]);
    return "Minified React error #" + O + "; visit " + x + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = 60106, o = 60107, n = 60108, s = 60114, a = 60109, l = 60110, u = 60112, c = 60113, p = 60120, d = 60115, h = 60116, g = 60121, y = 60117, S = 60119, _ = 60129, w = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var E = Symbol.for;
    r = E("react.portal"), o = E("react.fragment"), n = E("react.strict_mode"), s = E("react.profiler"), a = E("react.provider"), l = E("react.context"), u = E("react.forward_ref"), c = E("react.suspense"), p = E("react.suspense_list"), d = E("react.memo"), h = E("react.lazy"), g = E("react.block"), y = E("react.fundamental"), S = E("react.scope"), _ = E("react.debug_trace_mode"), w = E("react.legacy_hidden");
  }
  function R(O) {
    if (O == null)
      return null;
    if (typeof O == "function")
      return O.displayName || O.name || null;
    if (typeof O == "string")
      return O;
    switch (O) {
      case o:
        return "Fragment";
      case r:
        return "Portal";
      case s:
        return "Profiler";
      case n:
        return "StrictMode";
      case c:
        return "Suspense";
      case p:
        return "SuspenseList";
    }
    if (typeof O == "object")
      switch (O.$$typeof) {
        case l:
          return (O.displayName || "Context") + ".Consumer";
        case a:
          return (O._context.displayName || "Context") + ".Provider";
        case u:
          var x = O.render;
          return x = x.displayName || x.name || "", O.displayName || (x !== "" ? "ForwardRef(" + x + ")" : "ForwardRef");
        case d:
          return R(O.type);
        case g:
          return R(O._render);
        case h:
          x = O._payload, O = O._init;
          try {
            return R(O(x));
          } catch {
          }
      }
    return null;
  }
  var D = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, B = {};
  function H(O, x) {
    for (var b = O._threadCount | 0; b <= x; b++)
      O[b] = O._currentValue2, O._threadCount = b + 1;
  }
  function A(O, x, b, V) {
    if (V && (V = O.contextType, typeof V == "object" && V !== null))
      return H(V, b), V[b];
    if (O = O.contextTypes) {
      b = {};
      for (var q in O)
        b[q] = x[q];
      x = b;
    } else
      x = B;
    return x;
  }
  for (var N = new Uint16Array(16), G = 0; 15 > G; G++)
    N[G] = G + 1;
  N[15] = 0;
  var W = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, J = Object.prototype.hasOwnProperty, de = {}, ve = {};
  function oe(O) {
    return J.call(ve, O) ? !0 : J.call(de, O) ? !1 : W.test(O) ? ve[O] = !0 : (de[O] = !0, !1);
  }
  function ne(O, x, b, V) {
    if (b !== null && b.type === 0)
      return !1;
    switch (typeof x) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return V ? !1 : b !== null ? !b.acceptsBooleans : (O = O.toLowerCase().slice(0, 5), O !== "data-" && O !== "aria-");
      default:
        return !1;
    }
  }
  function fe(O, x, b, V) {
    if (x === null || typeof x > "u" || ne(O, x, b, V))
      return !0;
    if (V)
      return !1;
    if (b !== null)
      switch (b.type) {
        case 3:
          return !x;
        case 4:
          return x === !1;
        case 5:
          return isNaN(x);
        case 6:
          return isNaN(x) || 1 > x;
      }
    return !1;
  }
  function ce(O, x, b, V, q, z, X) {
    this.acceptsBooleans = x === 2 || x === 3 || x === 4, this.attributeName = V, this.attributeNamespace = q, this.mustUseProperty = b, this.propertyName = O, this.type = x, this.sanitizeURL = z, this.removeEmptyString = X;
  }
  var se = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(O) {
    se[O] = new ce(O, 0, !1, O, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(O) {
    var x = O[0];
    se[x] = new ce(x, 1, !1, O[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(O) {
    se[O] = new ce(O, 2, !1, O.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(O) {
    se[O] = new ce(O, 2, !1, O, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(O) {
    se[O] = new ce(O, 3, !1, O.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(O) {
    se[O] = new ce(O, 3, !0, O, null, !1, !1);
  }), ["capture", "download"].forEach(function(O) {
    se[O] = new ce(O, 4, !1, O, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(O) {
    se[O] = new ce(O, 6, !1, O, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(O) {
    se[O] = new ce(O, 5, !1, O.toLowerCase(), null, !1, !1);
  });
  var je = /[\-:]([a-z])/g;
  function _e(O) {
    return O[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(O) {
    var x = O.replace(
      je,
      _e
    );
    se[x] = new ce(x, 1, !1, O, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(O) {
    var x = O.replace(je, _e);
    se[x] = new ce(x, 1, !1, O, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(O) {
    var x = O.replace(je, _e);
    se[x] = new ce(x, 1, !1, O, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(O) {
    se[O] = new ce(O, 1, !1, O.toLowerCase(), null, !1, !1);
  }), se.xlinkHref = new ce("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(O) {
    se[O] = new ce(O, 1, !1, O.toLowerCase(), null, !0, !0);
  });
  var Le = /["'&<>]/;
  function Ee(O) {
    if (typeof O == "boolean" || typeof O == "number")
      return "" + O;
    O = "" + O;
    var x = Le.exec(O);
    if (x) {
      var b = "", V, q = 0;
      for (V = x.index; V < O.length; V++) {
        switch (O.charCodeAt(V)) {
          case 34:
            x = "&quot;";
            break;
          case 38:
            x = "&amp;";
            break;
          case 39:
            x = "&#x27;";
            break;
          case 60:
            x = "&lt;";
            break;
          case 62:
            x = "&gt;";
            break;
          default:
            continue;
        }
        q !== V && (b += O.substring(q, V)), q = V + 1, b += x;
      }
      O = q !== V ? b + O.substring(q, V) : b;
    }
    return O;
  }
  function Re(O, x) {
    var b = se.hasOwnProperty(O) ? se[O] : null, V;
    return (V = O !== "style") && (V = b !== null ? b.type === 0 : !(!(2 < O.length) || O[0] !== "o" && O[0] !== "O" || O[1] !== "n" && O[1] !== "N")), V || fe(O, x, b, !1) ? "" : b !== null ? (O = b.attributeName, V = b.type, V === 3 || V === 4 && x === !0 ? O + '=""' : (b.sanitizeURL && (x = "" + x), O + '="' + (Ee(x) + '"'))) : oe(O) ? O + '="' + (Ee(x) + '"') : "";
  }
  function Me(O, x) {
    return O === x && (O !== 0 || 1 / O === 1 / x) || O !== O && x !== x;
  }
  var it = typeof Object.is == "function" ? Object.is : Me, Ve = null, Ze = null, Se = null, yt = !1, Ge = !1, st = null, Et = 0;
  function De() {
    if (Ve === null)
      throw Error(e(321));
    return Ve;
  }
  function me() {
    if (0 < Et)
      throw Error(e(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function at() {
    return Se === null ? Ze === null ? (yt = !1, Ze = Se = me()) : (yt = !0, Se = Ze) : Se.next === null ? (yt = !1, Se = Se.next = me()) : (yt = !0, Se = Se.next), Se;
  }
  function jt(O, x, b, V) {
    for (; Ge; )
      Ge = !1, Et += 1, Se = null, b = O(x, V);
    return dr(), b;
  }
  function dr() {
    Ve = null, Ge = !1, Ze = null, Et = 0, Se = st = null;
  }
  function kr(O, x) {
    return typeof x == "function" ? x(O) : x;
  }
  function jr(O, x, b) {
    if (Ve = De(), Se = at(), yt) {
      var V = Se.queue;
      if (x = V.dispatch, st !== null && (b = st.get(V), b !== void 0)) {
        st.delete(V), V = Se.memoizedState;
        do
          V = O(V, b.action), b = b.next;
        while (b !== null);
        return Se.memoizedState = V, [V, x];
      }
      return [Se.memoizedState, x];
    }
    return O = O === kr ? typeof x == "function" ? x() : x : b !== void 0 ? b(x) : x, Se.memoizedState = O, O = Se.queue = { last: null, dispatch: null }, O = O.dispatch = Wt.bind(null, Ve, O), [Se.memoizedState, O];
  }
  function lo(O, x) {
    if (Ve = De(), Se = at(), x = x === void 0 ? null : x, Se !== null) {
      var b = Se.memoizedState;
      if (b !== null && x !== null) {
        var V = b[1];
        e:
          if (V === null)
            V = !1;
          else {
            for (var q = 0; q < V.length && q < x.length; q++)
              if (!it(x[q], V[q])) {
                V = !1;
                break e;
              }
            V = !0;
          }
        if (V)
          return b[0];
      }
    }
    return O = O(), Se.memoizedState = [O, x], O;
  }
  function Wt(O, x, b) {
    if (!(25 > Et))
      throw Error(e(301));
    if (O === Ve)
      if (Ge = !0, O = { action: b, next: null }, st === null && (st = /* @__PURE__ */ new Map()), b = st.get(x), b === void 0)
        st.set(x, O);
      else {
        for (x = b; x.next !== null; )
          x = x.next;
        x.next = O;
      }
  }
  function pt() {
  }
  var Te = null, mt = { readContext: function(O) {
    var x = Te.threadID;
    return H(O, x), O[x];
  }, useContext: function(O) {
    De();
    var x = Te.threadID;
    return H(O, x), O[x];
  }, useMemo: lo, useReducer: jr, useRef: function(O) {
    Ve = De(), Se = at();
    var x = Se.memoizedState;
    return x === null ? (O = { current: O }, Se.memoizedState = O) : x;
  }, useState: function(O) {
    return jr(kr, O);
  }, useLayoutEffect: function() {
  }, useCallback: function(O, x) {
    return lo(function() {
      return O;
    }, x);
  }, useImperativeHandle: pt, useEffect: pt, useDebugValue: pt, useDeferredValue: function(O) {
    return De(), O;
  }, useTransition: function() {
    return De(), [function(O) {
      O();
    }, !1];
  }, useOpaqueIdentifier: function() {
    return (Te.identifierPrefix || "") + "R:" + (Te.uniqueID++).toString(36);
  }, useMutableSource: function(O, x) {
    return De(), x(O._source);
  } }, Wr = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
  function br(O) {
    switch (O) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  var We = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, Ut = i({ menuitem: !0 }, We), Rt = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Uo = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Rt).forEach(function(O) {
    Uo.forEach(function(x) {
      x = x + O.charAt(0).toUpperCase() + O.substring(1), Rt[x] = Rt[O];
    });
  });
  var Ur = /([A-Z])/g, Tr = /^ms-/, Xt = t.Children.toArray, So = D.ReactCurrentDispatcher, Sn = { listing: !0, pre: !0, textarea: !0 }, uo = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, _n = {}, fr = {};
  function co(O) {
    if (O == null)
      return O;
    var x = "";
    return t.Children.forEach(O, function(b) {
      b != null && (x += b);
    }), x;
  }
  var En = Object.prototype.hasOwnProperty, Rn = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
  function Pr(O, x) {
    if (O === void 0)
      throw Error(e(152, R(x) || "Component"));
  }
  function On(O, x, b) {
    function V(X, ie) {
      var ee = ie.prototype && ie.prototype.isReactComponent, Nt = A(ie, x, b, ee), Ct = [], Gt = !1, qe = { isMounted: function() {
        return !1;
      }, enqueueForceUpdate: function() {
        if (Ct === null)
          return null;
      }, enqueueReplaceState: function(Jn, Ue) {
        Gt = !0, Ct = [Ue];
      }, enqueueSetState: function(Jn, Ue) {
        if (Ct === null)
          return null;
        Ct.push(Ue);
      } };
      if (ee) {
        if (ee = new ie(X.props, Nt, qe), typeof ie.getDerivedStateFromProps == "function") {
          var Ie = ie.getDerivedStateFromProps.call(null, X.props, ee.state);
          Ie != null && (ee.state = i({}, ee.state, Ie));
        }
      } else if (Ve = {}, ee = ie(
        X.props,
        Nt,
        qe
      ), ee = jt(ie, X.props, ee, Nt), ee == null || ee.render == null) {
        O = ee, Pr(O, ie);
        return;
      }
      if (ee.props = X.props, ee.context = Nt, ee.updater = qe, qe = ee.state, qe === void 0 && (ee.state = qe = null), typeof ee.UNSAFE_componentWillMount == "function" || typeof ee.componentWillMount == "function")
        if (typeof ee.componentWillMount == "function" && typeof ie.getDerivedStateFromProps != "function" && ee.componentWillMount(), typeof ee.UNSAFE_componentWillMount == "function" && typeof ie.getDerivedStateFromProps != "function" && ee.UNSAFE_componentWillMount(), Ct.length) {
          qe = Ct;
          var wt = Gt;
          if (Ct = null, Gt = !1, wt && qe.length === 1)
            ee.state = qe[0];
          else {
            Ie = wt ? qe[0] : ee.state;
            var zr = !0;
            for (wt = wt ? 1 : 0; wt < qe.length; wt++) {
              var Qt = qe[wt];
              Qt = typeof Qt == "function" ? Qt.call(ee, Ie, X.props, Nt) : Qt, Qt != null && (zr ? (zr = !1, Ie = i({}, Ie, Qt)) : i(Ie, Qt));
            }
            ee.state = Ie;
          }
        } else
          Ct = null;
      if (O = ee.render(), Pr(O, ie), typeof ee.getChildContext == "function" && (X = ie.childContextTypes, typeof X == "object")) {
        var Jt = ee.getChildContext();
        for (var ar in Jt)
          if (!(ar in X))
            throw Error(e(108, R(ie) || "Unknown", ar));
      }
      Jt && (x = i({}, x, Jt));
    }
    for (; t.isValidElement(O); ) {
      var q = O, z = q.type;
      if (typeof z != "function")
        break;
      V(q, z);
    }
    return { child: O, context: x };
  }
  var _o = function() {
    function O(b, V, q) {
      t.isValidElement(b) ? b.type !== o ? b = [b] : (b = b.props.children, b = t.isValidElement(b) ? [b] : Xt(b)) : b = Xt(b), b = { type: null, domNamespace: Wr.html, children: b, childIndex: 0, context: B, footer: "" };
      var z = N[0];
      if (z === 0) {
        var X = N;
        z = X.length;
        var ie = 2 * z;
        if (!(65536 >= ie))
          throw Error(e(304));
        var ee = new Uint16Array(ie);
        for (ee.set(X), N = ee, N[0] = z + 1, X = z; X < ie - 1; X++)
          N[X] = X + 1;
        N[ie - 1] = 0;
      } else
        N[0] = N[z];
      this.threadID = z, this.stack = [b], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = V, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = q && q.identifierPrefix || "";
    }
    var x = O.prototype;
    return x.destroy = function() {
      if (!this.exhausted) {
        this.exhausted = !0, this.clearProviders();
        var b = this.threadID;
        N[b] = N[0], N[0] = b;
      }
    }, x.pushProvider = function(b) {
      var V = ++this.contextIndex, q = b.type._context, z = this.threadID;
      H(q, z);
      var X = q[z];
      this.contextStack[V] = q, this.contextValueStack[V] = X, q[z] = b.props.value;
    }, x.popProvider = function() {
      var b = this.contextIndex, V = this.contextStack[b], q = this.contextValueStack[b];
      this.contextStack[b] = null, this.contextValueStack[b] = null, this.contextIndex--, V[this.threadID] = q;
    }, x.clearProviders = function() {
      for (var b = this.contextIndex; 0 <= b; b--)
        this.contextStack[b][this.threadID] = this.contextValueStack[b];
    }, x.read = function(b) {
      if (this.exhausted)
        return null;
      var V = Te;
      Te = this;
      var q = So.current;
      So.current = mt;
      try {
        for (var z = [""], X = !1; z[0].length < b; ) {
          if (this.stack.length === 0) {
            this.exhausted = !0;
            var ie = this.threadID;
            N[ie] = N[0], N[0] = ie;
            break;
          }
          var ee = this.stack[this.stack.length - 1];
          if (X || ee.childIndex >= ee.children.length) {
            var Nt = ee.footer;
            if (Nt !== "" && (this.previousWasTextNode = !1), this.stack.pop(), ee.type === "select")
              this.currentSelectValue = null;
            else if (ee.type != null && ee.type.type != null && ee.type.type.$$typeof === a)
              this.popProvider(ee.type);
            else if (ee.type === c) {
              this.suspenseDepth--;
              var Ct = z.pop();
              if (X) {
                X = !1;
                var Gt = ee.fallbackFrame;
                if (!Gt)
                  throw Error(e(303));
                this.stack.push(Gt), z[this.suspenseDepth] += "<!--$!-->";
                continue;
              } else
                z[this.suspenseDepth] += Ct;
            }
            z[this.suspenseDepth] += Nt;
          } else {
            var qe = ee.children[ee.childIndex++], Ie = "";
            try {
              Ie += this.render(qe, ee.context, ee.domNamespace);
            } catch (wt) {
              throw wt != null && typeof wt.then == "function" ? Error(e(294)) : wt;
            } finally {
            }
            z.length <= this.suspenseDepth && z.push(""), z[this.suspenseDepth] += Ie;
          }
        }
        return z[0];
      } finally {
        So.current = q, Te = V, dr();
      }
    }, x.render = function(b, V, q) {
      if (typeof b == "string" || typeof b == "number")
        return q = "" + b, q === "" ? "" : this.makeStaticMarkup ? Ee(q) : this.previousWasTextNode ? "<!-- -->" + Ee(q) : (this.previousWasTextNode = !0, Ee(q));
      if (V = On(b, V, this.threadID), b = V.child, V = V.context, b === null || b === !1)
        return "";
      if (!t.isValidElement(b)) {
        if (b != null && b.$$typeof != null)
          throw q = b.$$typeof, Error(q === r ? e(257) : e(258, q.toString()));
        return b = Xt(b), this.stack.push({ type: null, domNamespace: q, children: b, childIndex: 0, context: V, footer: "" }), "";
      }
      var z = b.type;
      if (typeof z == "string")
        return this.renderDOM(b, V, q);
      switch (z) {
        case w:
        case _:
        case n:
        case s:
        case p:
        case o:
          return b = Xt(b.props.children), this.stack.push({
            type: null,
            domNamespace: q,
            children: b,
            childIndex: 0,
            context: V,
            footer: ""
          }), "";
        case c:
          throw Error(e(294));
        case S:
          throw Error(e(343));
      }
      if (typeof z == "object" && z !== null)
        switch (z.$$typeof) {
          case u:
            Ve = {};
            var X = z.render(b.props, b.ref);
            return X = jt(z.render, b.props, X, b.ref), X = Xt(X), this.stack.push({ type: null, domNamespace: q, children: X, childIndex: 0, context: V, footer: "" }), "";
          case d:
            return b = [t.createElement(z.type, i({ ref: b.ref }, b.props))], this.stack.push({ type: null, domNamespace: q, children: b, childIndex: 0, context: V, footer: "" }), "";
          case a:
            return z = Xt(b.props.children), q = { type: b, domNamespace: q, children: z, childIndex: 0, context: V, footer: "" }, this.pushProvider(b), this.stack.push(q), "";
          case l:
            z = b.type, X = b.props;
            var ie = this.threadID;
            return H(z, ie), z = Xt(X.children(z[ie])), this.stack.push({ type: b, domNamespace: q, children: z, childIndex: 0, context: V, footer: "" }), "";
          case y:
            throw Error(e(338));
          case h:
            return z = b.type, X = z._init, z = X(z._payload), b = [t.createElement(z, i({ ref: b.ref }, b.props))], this.stack.push({
              type: null,
              domNamespace: q,
              children: b,
              childIndex: 0,
              context: V,
              footer: ""
            }), "";
        }
      throw Error(e(130, z == null ? z : typeof z, ""));
    }, x.renderDOM = function(b, V, q) {
      var z = b.type.toLowerCase();
      if (!_n.hasOwnProperty(z)) {
        if (!uo.test(z))
          throw Error(e(65, z));
        _n[z] = !0;
      }
      var X = b.props;
      if (z === "input")
        X = i({ type: void 0 }, X, { defaultChecked: void 0, defaultValue: void 0, value: X.value != null ? X.value : X.defaultValue, checked: X.checked != null ? X.checked : X.defaultChecked });
      else if (z === "textarea") {
        var ie = X.value;
        if (ie == null) {
          ie = X.defaultValue;
          var ee = X.children;
          if (ee != null) {
            if (ie != null)
              throw Error(e(92));
            if (Array.isArray(ee)) {
              if (!(1 >= ee.length))
                throw Error(e(93));
              ee = ee[0];
            }
            ie = "" + ee;
          }
          ie == null && (ie = "");
        }
        X = i({}, X, { value: void 0, children: "" + ie });
      } else if (z === "select")
        this.currentSelectValue = X.value != null ? X.value : X.defaultValue, X = i({}, X, { value: void 0 });
      else if (z === "option") {
        ee = this.currentSelectValue;
        var Nt = co(X.children);
        if (ee != null) {
          var Ct = X.value != null ? X.value + "" : Nt;
          if (ie = !1, Array.isArray(ee)) {
            for (var Gt = 0; Gt < ee.length; Gt++)
              if ("" + ee[Gt] === Ct) {
                ie = !0;
                break;
              }
          } else
            ie = "" + ee === Ct;
          X = i(
            { selected: void 0, children: void 0 },
            X,
            { selected: ie, children: Nt }
          );
        }
      }
      if (ie = X) {
        if (Ut[z] && (ie.children != null || ie.dangerouslySetInnerHTML != null))
          throw Error(e(137, z));
        if (ie.dangerouslySetInnerHTML != null) {
          if (ie.children != null)
            throw Error(e(60));
          if (!(typeof ie.dangerouslySetInnerHTML == "object" && "__html" in ie.dangerouslySetInnerHTML))
            throw Error(e(61));
        }
        if (ie.style != null && typeof ie.style != "object")
          throw Error(e(62));
      }
      ie = X, ee = this.makeStaticMarkup, Nt = this.stack.length === 1, Ct = "<" + b.type;
      e:
        if (z.indexOf("-") === -1)
          Gt = typeof ie.is == "string";
        else
          switch (z) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              Gt = !1;
              break e;
            default:
              Gt = !0;
          }
      for (Ue in ie)
        if (En.call(ie, Ue)) {
          var qe = ie[Ue];
          if (qe != null) {
            if (Ue === "style") {
              var Ie = void 0, wt = "", zr = "";
              for (Ie in qe)
                if (qe.hasOwnProperty(Ie)) {
                  var Qt = Ie.indexOf("--") === 0, Jt = qe[Ie];
                  if (Jt != null) {
                    if (Qt)
                      var ar = Ie;
                    else if (ar = Ie, fr.hasOwnProperty(ar))
                      ar = fr[ar];
                    else {
                      var Jn = ar.replace(Ur, "-$1").toLowerCase().replace(Tr, "-ms-");
                      ar = fr[ar] = Jn;
                    }
                    wt += zr + ar + ":", zr = Ie, Qt = Jt == null || typeof Jt == "boolean" || Jt === "" ? "" : Qt || typeof Jt != "number" || Jt === 0 || Rt.hasOwnProperty(zr) && Rt[zr] ? ("" + Jt).trim() : Jt + "px", wt += Qt, zr = ";";
                  }
                }
              qe = wt || null;
            }
            Ie = null, Gt ? Rn.hasOwnProperty(Ue) || (Ie = Ue, Ie = oe(Ie) && qe != null ? Ie + '="' + (Ee(qe) + '"') : "") : Ie = Re(Ue, qe), Ie && (Ct += " " + Ie);
          }
        }
      ee || Nt && (Ct += ' data-reactroot=""');
      var Ue = Ct;
      ie = "", We.hasOwnProperty(z) ? Ue += "/>" : (Ue += ">", ie = "</" + b.type + ">");
      e: {
        if (ee = X.dangerouslySetInnerHTML, ee != null) {
          if (ee.__html != null) {
            ee = ee.__html;
            break e;
          }
        } else if (ee = X.children, typeof ee == "string" || typeof ee == "number") {
          ee = Ee(ee);
          break e;
        }
        ee = null;
      }
      return ee != null ? (X = [], Sn.hasOwnProperty(z) && ee.charAt(0) === `
` && (Ue += `
`), Ue += ee) : X = Xt(X.children), b = b.type, q = q == null || q === "http://www.w3.org/1999/xhtml" ? br(b) : q === "http://www.w3.org/2000/svg" && b === "foreignObject" ? "http://www.w3.org/1999/xhtml" : q, this.stack.push({ domNamespace: q, type: z, children: X, childIndex: 0, context: V, footer: ie }), this.previousWasTextNode = !1, Ue;
    }, O;
  }();
  return Jo.renderToNodeStream = function() {
    throw Error(e(207));
  }, Jo.renderToStaticMarkup = function(O, x) {
    O = new _o(O, !0, x);
    try {
      return O.read(1 / 0);
    } finally {
      O.destroy();
    }
  }, Jo.renderToStaticNodeStream = function() {
    throw Error(e(208));
  }, Jo.renderToString = function(O, x) {
    O = new _o(O, !1, x);
    try {
      return O.read(1 / 0);
    } finally {
      O.destroy();
    }
  }, Jo.version = "17.0.0", Jo;
}
var Zo = {};
/** @license React v17.0.0
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rd;
function Jb() {
  return Rd || (Rd = 1, process.env.NODE_ENV !== "production" && function() {
    var i = Ye, t = Wd();
    function e(f) {
      for (var C = "https://reactjs.org/docs/error-decoder.html?invariant=" + f, T = 1; T < arguments.length; T++)
        C += "&args[]=" + encodeURIComponent(arguments[T]);
      return "Minified React error #" + f + "; visit " + C + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var r = "17.0.0", o = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(f) {
      {
        for (var C = arguments.length, T = new Array(C > 1 ? C - 1 : 0), F = 1; F < C; F++)
          T[F - 1] = arguments[F];
        a("warn", f, T);
      }
    }
    function s(f) {
      {
        for (var C = arguments.length, T = new Array(C > 1 ? C - 1 : 0), F = 1; F < C; F++)
          T[F - 1] = arguments[F];
        a("error", f, T);
      }
    }
    function a(f, C, T) {
      {
        var F = o.ReactDebugCurrentFrame, I = F.getStackAddendum();
        I !== "" && (C += "%s", T = T.concat([I]));
        var Q = T.map(function($) {
          return "" + $;
        });
        Q.unshift("Warning: " + C), Function.prototype.apply.call(console[f], console, Q);
      }
    }
    var l = 60106, u = 60107, c = 60108, p = 60114, d = 60109, h = 60110, g = 60112, y = 60113, S = 60120, _ = 60115, w = 60116, E = 60121, R = 60117, D = 60119, B = 60129, H = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var A = Symbol.for;
      A("react.element"), l = A("react.portal"), u = A("react.fragment"), c = A("react.strict_mode"), p = A("react.profiler"), d = A("react.provider"), h = A("react.context"), g = A("react.forward_ref"), y = A("react.suspense"), S = A("react.suspense_list"), _ = A("react.memo"), w = A("react.lazy"), E = A("react.block"), A("react.server.block"), R = A("react.fundamental"), D = A("react.scope"), A("react.opaque.id"), B = A("react.debug_trace_mode"), A("react.offscreen"), H = A("react.legacy_hidden");
    }
    function N(f, C, T) {
      var F = C.displayName || C.name || "";
      return f.displayName || (F !== "" ? T + "(" + F + ")" : T);
    }
    function G(f) {
      return f.displayName || "Context";
    }
    function W(f) {
      if (f == null)
        return null;
      if (typeof f.tag == "number" && s("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof f == "function")
        return f.displayName || f.name || null;
      if (typeof f == "string")
        return f;
      switch (f) {
        case u:
          return "Fragment";
        case l:
          return "Portal";
        case p:
          return "Profiler";
        case c:
          return "StrictMode";
        case y:
          return "Suspense";
        case S:
          return "SuspenseList";
      }
      if (typeof f == "object")
        switch (f.$$typeof) {
          case h:
            var C = f;
            return G(C) + ".Consumer";
          case d:
            var T = f;
            return G(T._context) + ".Provider";
          case g:
            return N(f, f.render, "ForwardRef");
          case _:
            return W(f.type);
          case E:
            return W(f._render);
          case w: {
            var F = f, I = F._payload, Q = F._init;
            try {
              return W(Q(I));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var J = !1, de = 0, ve, oe, ne, fe, ce, se, je;
    function _e() {
    }
    _e.__reactDisabledLog = !0;
    function Le() {
      {
        if (de === 0) {
          ve = console.log, oe = console.info, ne = console.warn, fe = console.error, ce = console.group, se = console.groupCollapsed, je = console.groupEnd;
          var f = {
            configurable: !0,
            enumerable: !0,
            value: _e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: f,
            log: f,
            warn: f,
            error: f,
            group: f,
            groupCollapsed: f,
            groupEnd: f
          });
        }
        de++;
      }
    }
    function Ee() {
      {
        if (de--, de === 0) {
          var f = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: t({}, f, {
              value: ve
            }),
            info: t({}, f, {
              value: oe
            }),
            warn: t({}, f, {
              value: ne
            }),
            error: t({}, f, {
              value: fe
            }),
            group: t({}, f, {
              value: ce
            }),
            groupCollapsed: t({}, f, {
              value: se
            }),
            groupEnd: t({}, f, {
              value: je
            })
          });
        }
        de < 0 && s("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = o.ReactCurrentDispatcher, Me;
    function it(f, C, T) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (I) {
            var F = I.stack.trim().match(/\n( *(at )?)/);
            Me = F && F[1] || "";
          }
        return `
` + Me + f;
      }
    }
    var Ve = !1, Ze;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      Ze = new Se();
    }
    function yt(f, C) {
      if (!f || Ve)
        return "";
      {
        var T = Ze.get(f);
        if (T !== void 0)
          return T;
      }
      var F;
      Ve = !0;
      var I = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = Re.current, Re.current = null, Le();
      try {
        if (C) {
          var $ = function() {
            throw Error();
          };
          if (Object.defineProperty($.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($, []);
            } catch (ot) {
              F = ot;
            }
            Reflect.construct(f, [], $);
          } else {
            try {
              $.call();
            } catch (ot) {
              F = ot;
            }
            f.call($.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ot) {
            F = ot;
          }
          f();
        }
      } catch (ot) {
        if (ot && F && typeof ot.stack == "string") {
          for (var Z = ot.stack.split(`
`), K = F.stack.split(`
`), Ce = Z.length - 1, we = K.length - 1; Ce >= 1 && we >= 0 && Z[Ce] !== K[we]; )
            we--;
          for (; Ce >= 1 && we >= 0; Ce--, we--)
            if (Z[Ce] !== K[we]) {
              if (Ce !== 1 || we !== 1)
                do
                  if (Ce--, we--, we < 0 || Z[Ce] !== K[we]) {
                    var dt = `
` + Z[Ce].replace(" at new ", " at ");
                    return typeof f == "function" && Ze.set(f, dt), dt;
                  }
                while (Ce >= 1 && we >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, Re.current = Q, Ee(), Error.prepareStackTrace = I;
      }
      var Ft = f ? f.displayName || f.name : "", ae = Ft ? it(Ft) : "";
      return typeof f == "function" && Ze.set(f, ae), ae;
    }
    function Ge(f, C, T) {
      return yt(f, !1);
    }
    function st(f) {
      var C = f.prototype;
      return !!(C && C.isReactComponent);
    }
    function Et(f, C, T) {
      if (f == null)
        return "";
      if (typeof f == "function")
        return yt(f, st(f));
      if (typeof f == "string")
        return it(f);
      switch (f) {
        case y:
          return it("Suspense");
        case S:
          return it("SuspenseList");
      }
      if (typeof f == "object")
        switch (f.$$typeof) {
          case g:
            return Ge(f.render);
          case _:
            return Et(f.type, C, T);
          case E:
            return Ge(f._render);
          case w: {
            var F = f, I = F._payload, Q = F._init;
            try {
              return Et(Q(I), C, T);
            } catch {
            }
          }
        }
      return "";
    }
    var De = {}, me = o.ReactDebugCurrentFrame;
    function at(f) {
      if (f) {
        var C = f._owner, T = Et(f.type, f._source, C ? C.type : null);
        me.setExtraStackFrame(T);
      } else
        me.setExtraStackFrame(null);
    }
    function jt(f, C, T, F, I) {
      {
        var Q = Function.call.bind(Object.prototype.hasOwnProperty);
        for (var $ in f)
          if (Q(f, $)) {
            var Z = void 0;
            try {
              if (typeof f[$] != "function") {
                var K = Error((F || "React class") + ": " + T + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw K.name = "Invariant Violation", K;
              }
              Z = f[$](C, $, F, T, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ce) {
              Z = Ce;
            }
            Z && !(Z instanceof Error) && (at(I), s("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", F || "React class", T, $, typeof Z), at(null)), Z instanceof Error && !(Z.message in De) && (De[Z.message] = !0, at(I), s("Failed %s type: %s", T, Z.message), at(null));
          }
      }
    }
    var dr;
    dr = /* @__PURE__ */ new Set();
    var kr = {};
    Object.freeze(kr);
    function jr(f, C) {
      var T = f.contextTypes;
      if (!T)
        return kr;
      var F = {};
      for (var I in T)
        F[I] = C[I];
      return F;
    }
    function lo(f, C, T) {
      jt(f, C, T, "Component");
    }
    function Wt(f, C) {
      for (var T = f._threadCount | 0; T <= C; T++)
        f[T] = f._currentValue2, f._threadCount = T + 1;
    }
    function pt(f, C, T, F) {
      if (F) {
        var I = f.contextType;
        if ("contextType" in f) {
          var Q = (
            // Allow null for conditional declaration
            I === null || I !== void 0 && I.$$typeof === h && I._context === void 0
          );
          if (!Q && !dr.has(f)) {
            dr.add(f);
            var $ = "";
            I === void 0 ? $ = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof I != "object" ? $ = " However, it is set to a " + typeof I + "." : I.$$typeof === d ? $ = " Did you accidentally pass the Context.Provider instead?" : I._context !== void 0 ? $ = " Did you accidentally pass the Context.Consumer instead?" : $ = " However, it is set to an object with keys {" + Object.keys(I).join(", ") + "}.", s("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", W(f) || "Component", $);
          }
        }
        if (typeof I == "object" && I !== null)
          return Wt(I, T), I[T];
        {
          var Z = jr(f, C);
          return f.contextTypes && lo(f.contextTypes, Z, "context"), Z;
        }
      } else {
        var K = jr(f, C);
        return f.contextTypes && lo(f.contextTypes, K, "context"), K;
      }
    }
    for (var Te = new Uint16Array(16), mt = 0; mt < 15; mt++)
      Te[mt] = mt + 1;
    Te[15] = 0;
    function Wr() {
      var f = Te, C = f.length, T = C * 2;
      if (!(T <= 65536))
        throw Error("Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic.");
      var F = new Uint16Array(T);
      F.set(f), Te = F, Te[0] = C + 1;
      for (var I = C; I < T - 1; I++)
        Te[I] = I + 1;
      return Te[T - 1] = 0, C;
    }
    function br() {
      var f = Te[0];
      return f === 0 ? Wr() : (Te[0] = Te[f], f);
    }
    function We(f) {
      Te[f] = Te[0], Te[0] = f;
    }
    var Ut = 0, Rt = 1, Uo = 2, Ur = 3, Tr = 4, Xt = 5, So = 6, Sn = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", uo = Sn + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", _n = "data-reactroot", fr = new RegExp("^[" + Sn + "][" + uo + "]*$"), co = Object.prototype.hasOwnProperty, En = {}, Rn = {};
    function Pr(f) {
      return co.call(Rn, f) ? !0 : co.call(En, f) ? !1 : fr.test(f) ? (Rn[f] = !0, !0) : (En[f] = !0, s("Invalid attribute name: `%s`", f), !1);
    }
    function On(f, C, T) {
      return C !== null ? C.type === Ut : T ? !1 : f.length > 2 && (f[0] === "o" || f[0] === "O") && (f[1] === "n" || f[1] === "N");
    }
    function _o(f, C, T, F) {
      if (T !== null && T.type === Ut)
        return !1;
      switch (typeof C) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (F)
            return !1;
          if (T !== null)
            return !T.acceptsBooleans;
          var I = f.toLowerCase().slice(0, 5);
          return I !== "data-" && I !== "aria-";
        }
        default:
          return !1;
      }
    }
    function O(f, C, T, F) {
      if (C === null || typeof C > "u" || _o(f, C, T, F))
        return !0;
      if (F)
        return !1;
      if (T !== null)
        switch (T.type) {
          case Ur:
            return !C;
          case Tr:
            return C === !1;
          case Xt:
            return isNaN(C);
          case So:
            return isNaN(C) || C < 1;
        }
      return !1;
    }
    function x(f) {
      return V.hasOwnProperty(f) ? V[f] : null;
    }
    function b(f, C, T, F, I, Q, $) {
      this.acceptsBooleans = C === Uo || C === Ur || C === Tr, this.attributeName = F, this.attributeNamespace = I, this.mustUseProperty = T, this.propertyName = f, this.type = C, this.sanitizeURL = Q, this.removeEmptyString = $;
    }
    var V = {}, q = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    q.forEach(function(f) {
      V[f] = new b(
        f,
        Ut,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(f) {
      var C = f[0], T = f[1];
      V[C] = new b(
        C,
        Rt,
        !1,
        // mustUseProperty
        T,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(f) {
      V[f] = new b(
        f,
        Uo,
        !1,
        // mustUseProperty
        f.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(f) {
      V[f] = new b(
        f,
        Uo,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(f) {
      V[f] = new b(
        f,
        Ur,
        !1,
        // mustUseProperty
        f.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(f) {
      V[f] = new b(
        f,
        Ur,
        !0,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(f) {
      V[f] = new b(
        f,
        Tr,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(f) {
      V[f] = new b(
        f,
        So,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(f) {
      V[f] = new b(
        f,
        Xt,
        !1,
        // mustUseProperty
        f.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var z = /[\-\:]([a-z])/g, X = function(f) {
      return f[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(f) {
      var C = f.replace(z, X);
      V[C] = new b(
        C,
        Rt,
        !1,
        // mustUseProperty
        f,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(f) {
      var C = f.replace(z, X);
      V[C] = new b(
        C,
        Rt,
        !1,
        // mustUseProperty
        f,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(f) {
      var C = f.replace(z, X);
      V[C] = new b(
        C,
        Rt,
        !1,
        // mustUseProperty
        f,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(f) {
      V[f] = new b(
        f,
        Rt,
        !1,
        // mustUseProperty
        f.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var ie = "xlinkHref";
    V[ie] = new b(
      "xlinkHref",
      Rt,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(f) {
      V[f] = new b(
        f,
        Rt,
        !1,
        // mustUseProperty
        f.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var ee = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Nt = !1;
    function Ct(f) {
      !Nt && ee.test(f) && (Nt = !0, s("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(f)));
    }
    var Gt = /["'&<>]/;
    function qe(f) {
      var C = "" + f, T = Gt.exec(C);
      if (!T)
        return C;
      var F, I = "", Q, $ = 0;
      for (Q = T.index; Q < C.length; Q++) {
        switch (C.charCodeAt(Q)) {
          case 34:
            F = "&quot;";
            break;
          case 38:
            F = "&amp;";
            break;
          case 39:
            F = "&#x27;";
            break;
          case 60:
            F = "&lt;";
            break;
          case 62:
            F = "&gt;";
            break;
          default:
            continue;
        }
        $ !== Q && (I += C.substring($, Q)), $ = Q + 1, I += F;
      }
      return $ !== Q ? I + C.substring($, Q) : I;
    }
    function Ie(f) {
      return typeof f == "boolean" || typeof f == "number" ? "" + f : qe(f);
    }
    function wt(f) {
      return '"' + Ie(f) + '"';
    }
    function zr() {
      return _n + '=""';
    }
    function Qt(f, C) {
      var T = x(f);
      if (f !== "style" && On(f, T, !1) || O(f, C, T, !1))
        return "";
      if (T !== null) {
        var F = T.attributeName, I = T.type;
        return I === Ur || I === Tr && C === !0 ? F + '=""' : (T.sanitizeURL && (C = "" + C, Ct(C)), F + "=" + wt(C));
      } else if (Pr(f))
        return f + "=" + wt(C);
      return "";
    }
    function Jt(f, C) {
      return !Pr(f) || C == null ? "" : f + "=" + wt(C);
    }
    function ar(f, C) {
      return f === C && (f !== 0 || 1 / f === 1 / C) || f !== f && C !== C;
    }
    var Jn = typeof Object.is == "function" ? Object.is : ar, Ue = null, Xi = null, ze = null, Zn = !1, Qi = !1, Eo = null, Ji = 0, dg = 25, $r = !1, bn;
    function zo() {
      if (Ue === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return $r && s("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Ue;
    }
    function fg(f, C) {
      if (C === null)
        return s("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", bn), !1;
      f.length !== C.length && s(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, bn, "[" + f.join(", ") + "]", "[" + C.join(", ") + "]");
      for (var T = 0; T < C.length && T < f.length; T++)
        if (!Jn(f[T], C[T]))
          return !1;
      return !0;
    }
    function Gc() {
      if (Ji > 0)
        throw Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Va() {
      return ze === null ? Xi === null ? (Zn = !1, Xi = ze = Gc()) : (Zn = !0, ze = Xi) : ze.next === null ? (Zn = !1, ze = ze.next = Gc()) : (Zn = !0, ze = ze.next), ze;
    }
    function Hc(f) {
      Ue = f, $r = !1;
    }
    function Vc(f, C, T, F) {
      for (; Qi; )
        Qi = !1, Ji += 1, ze = null, T = f(C, F);
      return Bc(), T;
    }
    function Bc() {
      $r = !1, Ue = null, Qi = !1, Xi = null, Ji = 0, Eo = null, ze = null;
    }
    function hg(f, C) {
      var T = Tn.threadID;
      return Wt(f, T), $r && s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), f[T];
    }
    function vg(f, C) {
      bn = "useContext", zo();
      var T = Tn.threadID;
      return Wt(f, T), f[T];
    }
    function Ba(f, C) {
      return typeof C == "function" ? C(f) : C;
    }
    function gg(f) {
      return bn = "useState", kc(
        Ba,
        // useReducer has a special case to support lazy useState initializers
        f
      );
    }
    function kc(f, C, T) {
      if (f !== Ba && (bn = "useReducer"), Ue = zo(), ze = Va(), Zn) {
        var F = ze.queue, I = F.dispatch;
        if (Eo !== null) {
          var Q = Eo.get(F);
          if (Q !== void 0) {
            Eo.delete(F);
            var $ = ze.memoizedState, Z = Q;
            do {
              var K = Z.action;
              $r = !0, $ = f($, K), $r = !1, Z = Z.next;
            } while (Z !== null);
            return ze.memoizedState = $, [$, I];
          }
        }
        return [ze.memoizedState, I];
      } else {
        $r = !0;
        var Ce;
        f === Ba ? Ce = typeof C == "function" ? C() : C : Ce = T !== void 0 ? T(C) : C, $r = !1, ze.memoizedState = Ce;
        var we = ze.queue = {
          last: null,
          dispatch: null
        }, dt = we.dispatch = Cg.bind(null, Ue, we);
        return [ze.memoizedState, dt];
      }
    }
    function jc(f, C) {
      Ue = zo(), ze = Va();
      var T = C === void 0 ? null : C;
      if (ze !== null) {
        var F = ze.memoizedState;
        if (F !== null && T !== null) {
          var I = F[1];
          if (fg(T, I))
            return F[0];
        }
      }
      $r = !0;
      var Q = f();
      return $r = !1, ze.memoizedState = [Q, T], Q;
    }
    function yg(f) {
      Ue = zo(), ze = Va();
      var C = ze.memoizedState;
      if (C === null) {
        var T = {
          current: f
        };
        return Object.seal(T), ze.memoizedState = T, T;
      } else
        return C;
    }
    function mg(f, C) {
      bn = "useLayoutEffect", s("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Cg(f, C, T) {
      if (!(Ji < dg))
        throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (f === Ue) {
        Qi = !0;
        var F = {
          action: T,
          next: null
        };
        Eo === null && (Eo = /* @__PURE__ */ new Map());
        var I = Eo.get(C);
        if (I === void 0)
          Eo.set(C, F);
        else {
          for (var Q = I; Q.next !== null; )
            Q = Q.next;
          Q.next = F;
        }
      }
    }
    function wg(f, C) {
      return jc(function() {
        return f;
      }, C);
    }
    function Sg(f, C, T) {
      return zo(), C(f._source);
    }
    function _g(f) {
      return zo(), f;
    }
    function Eg() {
      zo();
      var f = function(C) {
        C();
      };
      return [f, !1];
    }
    function Rg() {
      return (Tn.identifierPrefix || "") + "R:" + (Tn.uniqueID++).toString(36);
    }
    function ka() {
    }
    var Tn = null;
    function Wc(f) {
      Tn = f;
    }
    var Og = {
      readContext: hg,
      useContext: vg,
      useMemo: jc,
      useReducer: kc,
      useRef: yg,
      useState: gg,
      useLayoutEffect: mg,
      useCallback: wg,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: ka,
      // Effects are not run in the server environment.
      useEffect: ka,
      // Debugging effect
      useDebugValue: ka,
      useDeferredValue: _g,
      useTransition: Eg,
      useOpaqueIdentifier: Rg,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Sg
    }, Zi = "http://www.w3.org/1999/xhtml", Uc = "http://www.w3.org/1998/Math/MathML", ja = "http://www.w3.org/2000/svg", Wa = {
      html: Zi,
      mathml: Uc,
      svg: ja
    };
    function zc(f) {
      switch (f) {
        case "svg":
          return ja;
        case "math":
          return Uc;
        default:
          return Zi;
      }
    }
    function bg(f, C) {
      return f == null || f === Zi ? zc(C) : f === ja && C === "foreignObject" ? Zi : f;
    }
    var Tg = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ua(f, C) {
      Tg[C.type] || C.onChange || C.onInput || C.readOnly || C.disabled || C.value == null || s("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), C.onChange || C.readOnly || C.disabled || C.checked == null || s("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    var $c = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Pg = t({
      menuitem: !0
    }, $c), Dg = "__html";
    function Ag(f, C) {
      if (C) {
        if (Pg[f] && !(C.children == null && C.dangerouslySetInnerHTML == null))
          throw Error(f + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (C.dangerouslySetInnerHTML != null) {
          if (C.children != null)
            throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (!(typeof C.dangerouslySetInnerHTML == "object" && Dg in C.dangerouslySetInnerHTML))
            throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!C.suppressContentEditableWarning && C.contentEditable && C.children != null && s("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), !(C.style == null || typeof C.style == "object"))
          throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    var ei = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function xg(f, C) {
      return f + C.charAt(0).toUpperCase() + C.substring(1);
    }
    var Fg = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ei).forEach(function(f) {
      Fg.forEach(function(C) {
        ei[xg(C, f)] = ei[f];
      });
    });
    function Mg(f, C, T) {
      var F = C == null || typeof C == "boolean" || C === "";
      return F ? "" : !T && typeof C == "number" && C !== 0 && !(ei.hasOwnProperty(f) && ei[f]) ? C + "px" : ("" + C).trim();
    }
    var Ig = /([A-Z])/g, Lg = /^ms-/;
    function Ng(f) {
      return f.replace(Ig, "-$1").toLowerCase().replace(Lg, "-ms-");
    }
    function za(f, C) {
      if (f.indexOf("-") === -1)
        return typeof C.is == "string";
      switch (f) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Kc = function() {
    };
    {
      var Gg = /^(?:webkit|moz|o)[A-Z]/, Hg = /^-ms-/, Vg = /-(.)/g, Yc = /;\s*$/, Pn = {}, $a = {}, qc = !1, Xc = !1, Bg = function(f) {
        return f.replace(Vg, function(C, T) {
          return T.toUpperCase();
        });
      }, kg = function(f) {
        Pn.hasOwnProperty(f) && Pn[f] || (Pn[f] = !0, s(
          "Unsupported style property %s. Did you mean %s?",
          f,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Bg(f.replace(Hg, "ms-"))
        ));
      }, jg = function(f) {
        Pn.hasOwnProperty(f) && Pn[f] || (Pn[f] = !0, s("Unsupported vendor-prefixed style property %s. Did you mean %s?", f, f.charAt(0).toUpperCase() + f.slice(1)));
      }, Wg = function(f, C) {
        $a.hasOwnProperty(C) && $a[C] || ($a[C] = !0, s(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, f, C.replace(Yc, "")));
      }, Ug = function(f, C) {
        qc || (qc = !0, s("`NaN` is an invalid value for the `%s` css style property.", f));
      }, zg = function(f, C) {
        Xc || (Xc = !0, s("`Infinity` is an invalid value for the `%s` css style property.", f));
      };
      Kc = function(f, C) {
        f.indexOf("-") > -1 ? kg(f) : Gg.test(f) ? jg(f) : Yc.test(C) && Wg(f, C), typeof C == "number" && (isNaN(C) ? Ug(f, C) : isFinite(C) || zg(f, C));
      };
    }
    var $g = Kc, Qc = {
      "aria-current": 0,
      // state
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Dn = {}, Kg = new RegExp("^(aria)-[" + uo + "]*$"), Yg = new RegExp("^(aria)[A-Z][" + uo + "]*$"), qg = Object.prototype.hasOwnProperty;
    function Xg(f, C) {
      {
        if (qg.call(Dn, C) && Dn[C])
          return !0;
        if (Yg.test(C)) {
          var T = "aria-" + C.slice(4).toLowerCase(), F = Qc.hasOwnProperty(T) ? T : null;
          if (F == null)
            return s("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", C), Dn[C] = !0, !0;
          if (C !== F)
            return s("Invalid ARIA attribute `%s`. Did you mean `%s`?", C, F), Dn[C] = !0, !0;
        }
        if (Kg.test(C)) {
          var I = C.toLowerCase(), Q = Qc.hasOwnProperty(I) ? I : null;
          if (Q == null)
            return Dn[C] = !0, !1;
          if (C !== Q)
            return s("Unknown ARIA attribute `%s`. Did you mean `%s`?", C, Q), Dn[C] = !0, !0;
        }
      }
      return !0;
    }
    function Qg(f, C) {
      {
        var T = [];
        for (var F in C) {
          var I = Xg(f, F);
          I || T.push(F);
        }
        var Q = T.map(function($) {
          return "`" + $ + "`";
        }).join(", ");
        T.length === 1 ? s("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Q, f) : T.length > 1 && s("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Q, f);
      }
    }
    function Jg(f, C) {
      za(f, C) || Qg(f, C);
    }
    var Jc = !1;
    function Zg(f, C) {
      {
        if (f !== "input" && f !== "textarea" && f !== "select")
          return;
        C != null && C.value === null && !Jc && (Jc = !0, f === "select" && C.multiple ? s("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", f) : s("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", f));
      }
    }
    var Zc = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, ep = function() {
    };
    {
      var zt = {}, ey = Object.prototype.hasOwnProperty, tp = /^on./, ty = /^on[^A-Z]/, ry = new RegExp("^(aria)-[" + uo + "]*$"), oy = new RegExp("^(aria)[A-Z][" + uo + "]*$");
      ep = function(f, C, T, F) {
        if (ey.call(zt, C) && zt[C])
          return !0;
        var I = C.toLowerCase();
        if (I === "onfocusin" || I === "onfocusout")
          return s("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), zt[C] = !0, !0;
        if (F != null) {
          var Q = F.registrationNameDependencies, $ = F.possibleRegistrationNames;
          if (Q.hasOwnProperty(C))
            return !0;
          var Z = $.hasOwnProperty(I) ? $[I] : null;
          if (Z != null)
            return s("Invalid event handler property `%s`. Did you mean `%s`?", C, Z), zt[C] = !0, !0;
          if (tp.test(C))
            return s("Unknown event handler property `%s`. It will be ignored.", C), zt[C] = !0, !0;
        } else if (tp.test(C))
          return ty.test(C) && s("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", C), zt[C] = !0, !0;
        if (ry.test(C) || oy.test(C))
          return !0;
        if (I === "innerhtml")
          return s("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), zt[C] = !0, !0;
        if (I === "aria")
          return s("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), zt[C] = !0, !0;
        if (I === "is" && T !== null && T !== void 0 && typeof T != "string")
          return s("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof T), zt[C] = !0, !0;
        if (typeof T == "number" && isNaN(T))
          return s("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", C), zt[C] = !0, !0;
        var K = x(C), Ce = K !== null && K.type === Ut;
        if (Zc.hasOwnProperty(I)) {
          var we = Zc[I];
          if (we !== C)
            return s("Invalid DOM property `%s`. Did you mean `%s`?", C, we), zt[C] = !0, !0;
        } else if (!Ce && C !== I)
          return s("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", C, I), zt[C] = !0, !0;
        return typeof T == "boolean" && _o(C, T, K, !1) ? (T ? s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', T, C, C, T, C) : s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', T, C, C, T, C, C, C), zt[C] = !0, !0) : Ce ? !0 : _o(C, T, K, !1) ? (zt[C] = !0, !1) : ((T === "false" || T === "true") && K !== null && K.type === Ur && (s("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", T, C, T === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', C, T), zt[C] = !0), !0);
      };
    }
    var ny = function(f, C, T) {
      {
        var F = [];
        for (var I in C) {
          var Q = ep(f, I, C[I], T);
          Q || F.push(I);
        }
        var $ = F.map(function(Z) {
          return "`" + Z + "`";
        }).join(", ");
        F.length === 1 ? s("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, f) : F.length > 1 && s("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, f);
      }
    };
    function iy(f, C, T) {
      za(f, C) || ny(f, C, T);
    }
    var Ro = i.Children.toArray, po = [], Ka = o.ReactCurrentDispatcher, es, Ya = null, rp = function() {
      return "";
    }, op = function(f) {
      return "";
    }, np = function(f, C) {
    }, ip = function(f) {
    }, sp = function(f) {
    }, ap = function() {
    }, lp = !1;
    es = o.ReactDebugCurrentFrame, np = function(f, C) {
      Jg(f, C), Zg(f, C), iy(f, C, null);
    }, op = function(f) {
      return Et(f.type, f._source, null);
    }, ip = function(f) {
      po.push(f), po.length === 1 && (Ya = es.getCurrentStack, es.getCurrentStack = rp);
    }, sp = function(f) {
      var C = po[po.length - 1], T = C[C.length - 1];
      T.debugElementStack.push(f);
    }, ap = function() {
      po.pop(), po.length === 0 && (es.getCurrentStack = Ya, Ya = null);
    }, rp = function() {
      if (po.length === 0)
        return "";
      for (var f = po[po.length - 1], C = "", T = f.length - 1; T >= 0; T--)
        for (var F = f[T], I = F.debugElementStack, Q = I.length - 1; Q >= 0; Q--)
          C += op(I[Q]);
      return C;
    };
    var up = !1, cp = !1, pp = !1, dp = !1, fp = !1, hp = {}, vp = {}, gp = {}, yp = {}, mp = {}, Cp = {}, wp = ["value", "defaultValue"], sy = {
      listing: !0,
      pre: !0,
      textarea: !0
    }, ay = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Sp = {};
    function ly(f) {
      if (!Sp.hasOwnProperty(f)) {
        if (!ay.test(f))
          throw Error("Invalid tag: " + f);
        Sp[f] = !0;
      }
    }
    var qa = {}, uy = function(f) {
      if (qa.hasOwnProperty(f))
        return qa[f];
      var C = Ng(f);
      return qa[f] = C, C;
    };
    function cy(f) {
      var C = "", T = "";
      for (var F in f)
        if (f.hasOwnProperty(F)) {
          var I = F.indexOf("--") === 0, Q = f[F];
          I || $g(F, Q), Q != null && (C += T + (I ? F : uy(F)) + ":", C += Mg(F, Q, I), T = ";");
        }
      return C || null;
    }
    function _p(f, C) {
      {
        var T = f.constructor, F = T && W(T) || "ReactClass", I = F + "." + C;
        if (hp[I])
          return;
        s(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, C, C, F), hp[I] = !0;
      }
    }
    function py(f) {
      return f.prototype && f.prototype.isReactComponent;
    }
    function dy(f) {
      var C = f.dangerouslySetInnerHTML;
      if (C != null) {
        if (C.__html != null)
          return C.__html;
      } else {
        var T = f.children;
        if (typeof T == "string" || typeof T == "number")
          return Ie(T);
      }
      return null;
    }
    function fy(f) {
      if (!i.isValidElement(f))
        return Ro(f);
      var C = f;
      if (C.type !== u)
        return [C];
      var T = C.props.children;
      if (!i.isValidElement(T))
        return Ro(T);
      var F = T;
      return [F];
    }
    function hy(f) {
      if (f == null)
        return f;
      var C = "";
      return i.Children.forEach(f, function(T) {
        T != null && (C += T, !fp && typeof T != "string" && typeof T != "number" && (fp = !0, s("Only strings and numbers are supported as <option> children.")));
      }), C;
    }
    var vy = Object.prototype.hasOwnProperty, gy = "style", yy = {
      children: null,
      dangerouslySetInnerHTML: null,
      suppressContentEditableWarning: null,
      suppressHydrationWarning: null
    };
    function my(f, C, T, F, I, Q) {
      var $ = "<" + f, Z = za(C, T);
      for (var K in T)
        if (vy.call(T, K)) {
          var Ce = T[K];
          if (Ce != null) {
            K === gy && (Ce = cy(Ce));
            var we = null;
            Z ? yy.hasOwnProperty(K) || (we = Jt(K, Ce)) : we = Qt(K, Ce), we && ($ += " " + we);
          }
        }
      return I || Q && ($ += " " + zr()), $;
    }
    function Ep(f, C) {
      if (f === void 0)
        throw Error((W(C) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
    }
    function Cy(f, C, T) {
      for (; i.isValidElement(f); ) {
        var F = f, I = F.type;
        if (sp(F), typeof I != "function")
          break;
        Q(F, I);
      }
      function Q($, Z) {
        var K = py(Z), Ce = pt(Z, C, T, K), we = [], dt = !1, Ft = {
          isMounted: function(To) {
            return !1;
          },
          enqueueForceUpdate: function(To) {
            if (we === null)
              return _p(To, "forceUpdate"), null;
          },
          enqueueReplaceState: function(To, xn) {
            dt = !0, we = [xn];
          },
          enqueueSetState: function(To, xn) {
            if (we === null)
              return _p(To, "setState"), null;
            we.push(xn);
          }
        }, ae;
        if (K) {
          if (ae = new Z($.props, Ce, Ft), typeof Z.getDerivedStateFromProps == "function") {
            if (ae.state === null || ae.state === void 0) {
              var ot = W(Z) || "Unknown";
              Cp[ot] || (s("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", ot, ae.state === null ? "null" : "undefined", ot), Cp[ot] = !0);
            }
            var $t = Z.getDerivedStateFromProps.call(null, $.props, ae.state);
            if ($t === void 0) {
              var Zt = W(Z) || "Unknown";
              mp[Zt] || (s("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", Zt), mp[Zt] = !0);
            }
            $t != null && (ae.state = t({}, ae.state, $t));
          }
        } else {
          if (Z.prototype && typeof Z.prototype.render == "function") {
            var er = W(Z) || "Unknown";
            vp[er] || (s("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", er, er), vp[er] = !0);
          }
          var Oo = {};
          if (Hc(Oo), ae = Z($.props, Ce, Ft), ae = Vc(Z, $.props, ae, Ce), ae != null && ae.render != null) {
            var hr = W(Z) || "Unknown";
            gp[hr] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", hr, hr, hr), gp[hr] = !0);
          }
          if (ae == null || ae.render == null) {
            f = ae, Ep(f, Z);
            return;
          }
        }
        ae.props = $.props, ae.context = Ce, ae.updater = Ft;
        var Dr = ae.state;
        if (Dr === void 0 && (ae.state = Dr = null), typeof ae.UNSAFE_componentWillMount == "function" || typeof ae.componentWillMount == "function") {
          if (typeof ae.componentWillMount == "function") {
            if (ae.componentWillMount.__suppressDeprecationWarning !== !0) {
              var bo = W(Z) || "Unknown";
              yp[bo] || (n(
                // keep this warning in sync with ReactStrictModeWarning.js
                `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
                bo
              ), yp[bo] = !0);
            }
            typeof Z.getDerivedStateFromProps != "function" && ae.componentWillMount();
          }
          if (typeof ae.UNSAFE_componentWillMount == "function" && typeof Z.getDerivedStateFromProps != "function" && ae.UNSAFE_componentWillMount(), we.length) {
            var vr = we, Ar = dt;
            if (we = null, dt = !1, Ar && vr.length === 1)
              ae.state = vr[0];
            else {
              for (var Kr = Ar ? vr[0] : ae.state, ts = !0, An = Ar ? 1 : 0; An < vr.length; An++) {
                var xr = vr[An], ti = typeof xr == "function" ? xr.call(ae, Kr, $.props, Ce) : xr;
                ti != null && (ts ? (ts = !1, Kr = t({}, Kr, ti)) : t(Kr, ti));
              }
              ae.state = Kr;
            }
          } else
            we = null;
        }
        f = ae.render(), f === void 0 && ae.render._isMockFunction && (f = null), Ep(f, Z);
        var $o;
        {
          if (typeof ae.getChildContext == "function") {
            var rs = Z.childContextTypes;
            if (typeof rs == "object") {
              $o = ae.getChildContext();
              for (var os in $o)
                if (!(os in rs))
                  throw Error((W(Z) || "Unknown") + '.getChildContext(): key "' + os + '" is not defined in childContextTypes.');
            } else
              s("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", W(Z) || "Unknown");
          }
          $o && (C = t({}, C, $o));
        }
      }
      return {
        child: f,
        context: C
      };
    }
    var Rp = /* @__PURE__ */ function() {
      function f(T, F, I) {
        var Q = fy(T), $ = {
          type: null,
          // Assume all trees start in the HTML namespace (not totally true, but
          // this is what we did historically)
          domNamespace: Wa.html,
          children: Q,
          childIndex: 0,
          context: kr,
          footer: ""
        };
        $.debugElementStack = [], this.threadID = br(), this.stack = [$], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = F, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = I && I.identifierPrefix || "", this.contextProviderStack = [];
      }
      var C = f.prototype;
      return C.destroy = function() {
        this.exhausted || (this.exhausted = !0, this.clearProviders(), We(this.threadID));
      }, C.pushProvider = function(F) {
        var I = ++this.contextIndex, Q = F.type._context, $ = this.threadID;
        Wt(Q, $);
        var Z = Q[$];
        this.contextStack[I] = Q, this.contextValueStack[I] = Z, this.contextProviderStack[I] = F, Q[$] = F.props.value;
      }, C.popProvider = function(F) {
        var I = this.contextIndex;
        (I < 0 || F !== this.contextProviderStack[I]) && s("Unexpected pop.");
        var Q = this.contextStack[I], $ = this.contextValueStack[I];
        this.contextStack[I] = null, this.contextValueStack[I] = null, this.contextProviderStack[I] = null, this.contextIndex--, Q[this.threadID] = $;
      }, C.clearProviders = function() {
        for (var F = this.contextIndex; F >= 0; F--) {
          var I = this.contextStack[F], Q = this.contextValueStack[F];
          I[this.threadID] = Q;
        }
      }, C.read = function(F) {
        if (this.exhausted)
          return null;
        var I = Tn;
        Wc(this);
        var Q = Ka.current;
        Ka.current = Og;
        try {
          for (var $ = [""], Z = !1; $[0].length < F; ) {
            if (this.stack.length === 0) {
              this.exhausted = !0, We(this.threadID);
              break;
            }
            var K = this.stack[this.stack.length - 1];
            if (Z || K.childIndex >= K.children.length) {
              var Ce = K.footer;
              if (Ce !== "" && (this.previousWasTextNode = !1), this.stack.pop(), K.type === "select")
                this.currentSelectValue = null;
              else if (K.type != null && K.type.type != null && K.type.type.$$typeof === d) {
                var we = K.type;
                this.popProvider(we);
              } else if (K.type === y) {
                this.suspenseDepth--;
                var dt = $.pop();
                if (Z) {
                  Z = !1;
                  var Ft = K.fallbackFrame;
                  if (!Ft)
                    throw Error("ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue.");
                  this.stack.push(Ft), $[this.suspenseDepth] += "<!--$!-->";
                  continue;
                } else
                  $[this.suspenseDepth] += dt;
              }
              $[this.suspenseDepth] += Ce;
              continue;
            }
            var ae = K.children[K.childIndex++], ot = "";
            ip(this.stack), K.debugElementStack.length = 0;
            try {
              ot += this.render(ae, K.context, K.domNamespace);
            } catch ($t) {
              if ($t != null && typeof $t.then == "function") {
                if (!J)
                  throw Error("ReactDOMServer does not yet support Suspense.");
              } else
                throw $t;
            } finally {
              ap();
            }
            $.length <= this.suspenseDepth && $.push(""), $[this.suspenseDepth] += ot;
          }
          return $[0];
        } finally {
          Ka.current = Q, Wc(I), Bc();
        }
      }, C.render = function(F, I, Q) {
        if (typeof F == "string" || typeof F == "number") {
          var $ = "" + F;
          return $ === "" ? "" : this.makeStaticMarkup ? Ie($) : this.previousWasTextNode ? "<!-- -->" + Ie($) : (this.previousWasTextNode = !0, Ie($));
        } else {
          var Z, K = Cy(F, I, this.threadID);
          if (Z = K.child, I = K.context, Z === null || Z === !1)
            return "";
          if (!i.isValidElement(Z)) {
            if (Z != null && Z.$$typeof != null) {
              var Ce = Z.$$typeof;
              throw Error(Ce === l ? "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render." : "Unknown element-like object type: " + Ce.toString() + ". This is likely a bug in React. Please file an issue.");
            }
            var we = Ro(Z), dt = {
              type: null,
              domNamespace: Q,
              children: we,
              childIndex: 0,
              context: I,
              footer: ""
            };
            return dt.debugElementStack = [], this.stack.push(dt), "";
          }
          var Ft = Z, ae = Ft.type;
          if (typeof ae == "string")
            return this.renderDOM(Ft, I, Q);
          switch (ae) {
            case H:
            case B:
            case c:
            case p:
            case S:
            case u: {
              var ot = Ro(Z.props.children), $t = {
                type: null,
                domNamespace: Q,
                children: ot,
                childIndex: 0,
                context: I,
                footer: ""
              };
              return $t.debugElementStack = [], this.stack.push($t), "";
            }
            case y:
              throw Error("ReactDOMServer does not yet support Suspense.");
            case D:
              throw Error("ReactDOMServer does not yet support scope components.");
          }
          if (typeof ae == "object" && ae !== null)
            switch (ae.$$typeof) {
              case g: {
                var Zt = Z, er, Oo = {};
                Hc(Oo), er = ae.render(Zt.props, Zt.ref), er = Vc(ae.render, Zt.props, er, Zt.ref), er = Ro(er);
                var hr = {
                  type: null,
                  domNamespace: Q,
                  children: er,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return hr.debugElementStack = [], this.stack.push(hr), "";
              }
              case _: {
                var Dr = Z, bo = [i.createElement(ae.type, t({
                  ref: Dr.ref
                }, Dr.props))], vr = {
                  type: null,
                  domNamespace: Q,
                  children: bo,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return vr.debugElementStack = [], this.stack.push(vr), "";
              }
              case d: {
                var Ar = Z, Kr = Ar.props, ts = Ro(Kr.children), An = {
                  type: Ar,
                  domNamespace: Q,
                  children: ts,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return An.debugElementStack = [], this.pushProvider(Ar), this.stack.push(An), "";
              }
              case h: {
                var xr = Z.type;
                xr._context === void 0 ? xr !== xr.Consumer && (lp || (lp = !0, s("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : xr = xr._context;
                var ti = Z.props, $o = this.threadID;
                Wt(xr, $o);
                var rs = xr[$o], os = Ro(ti.children(rs)), To = {
                  type: Z,
                  domNamespace: Q,
                  children: os,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return To.debugElementStack = [], this.stack.push(To), "";
              }
              case R:
                throw Error("ReactDOMServer does not yet support the fundamental API.");
              case w: {
                var xn = Z, Op = Z.type, Ry = Op._payload, Oy = Op._init, by = Oy(Ry), Ty = [i.createElement(by, t({
                  ref: xn.ref
                }, xn.props))], bp = {
                  type: null,
                  domNamespace: Q,
                  children: Ty,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return bp.debugElementStack = [], this.stack.push(bp), "";
              }
            }
          var Xa = "";
          {
            var Tp = Ft._owner;
            (ae === void 0 || typeof ae == "object" && ae !== null && Object.keys(ae).length === 0) && (Xa += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Pp = Tp ? W(Tp) : null;
            Pp && (Xa += `

Check the render method of \`` + Pp + "`.");
          }
          throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (ae == null ? ae : typeof ae) + "." + Xa);
        }
      }, C.renderDOM = function(F, I, Q) {
        var $ = F.type.toLowerCase(), Z = Q;
        Q === Wa.html && (Z = zc($)), Z === Wa.html && $ !== F.type && s("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", F.type), ly($);
        var K = F.props;
        if ($ === "input")
          Ua("input", K), K.checked !== void 0 && K.defaultChecked !== void 0 && !cp && (s("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", K.type), cp = !0), K.value !== void 0 && K.defaultValue !== void 0 && !up && (s("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", K.type), up = !0), K = t({
            type: void 0
          }, K, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: K.value != null ? K.value : K.defaultValue,
            checked: K.checked != null ? K.checked : K.defaultChecked
          });
        else if ($ === "textarea") {
          Ua("textarea", K), K.value !== void 0 && K.defaultValue !== void 0 && !dp && (s("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), dp = !0);
          var Ce = K.value;
          if (Ce == null) {
            var we = K.defaultValue, dt = K.children;
            if (dt != null) {
              if (s("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), we != null)
                throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
              if (Array.isArray(dt)) {
                if (!(dt.length <= 1))
                  throw Error("<textarea> can only have at most one child.");
                dt = dt[0];
              }
              we = "" + dt;
            }
            we == null && (we = ""), Ce = we;
          }
          K = t({}, K, {
            value: void 0,
            children: "" + Ce
          });
        } else if ($ === "select") {
          {
            Ua("select", K);
            for (var Ft = 0; Ft < wp.length; Ft++) {
              var ae = wp[Ft];
              if (K[ae] != null) {
                var ot = Array.isArray(K[ae]);
                K.multiple && !ot ? s("The `%s` prop supplied to <select> must be an array if `multiple` is true.", ae) : !K.multiple && ot && s("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", ae);
              }
            }
            K.value !== void 0 && K.defaultValue !== void 0 && !pp && (s("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), pp = !0);
          }
          this.currentSelectValue = K.value != null ? K.value : K.defaultValue, K = t({}, K, {
            value: void 0
          });
        } else if ($ === "option") {
          var $t = null, Zt = this.currentSelectValue, er = hy(K.children);
          if (Zt != null) {
            var Oo;
            if (K.value != null ? Oo = K.value + "" : Oo = er, $t = !1, Array.isArray(Zt)) {
              for (var hr = 0; hr < Zt.length; hr++)
                if ("" + Zt[hr] === Oo) {
                  $t = !0;
                  break;
                }
            } else
              $t = "" + Zt === Oo;
            K = t({
              selected: void 0,
              children: void 0
            }, K, {
              selected: $t,
              children: er
            });
          }
        }
        np($, K), Ag($, K);
        var Dr = my(F.type, $, K, Z, this.makeStaticMarkup, this.stack.length === 1), bo = "";
        $c.hasOwnProperty($) ? Dr += "/>" : (Dr += ">", bo = "</" + F.type + ">");
        var vr, Ar = dy(K);
        Ar != null ? (vr = [], sy.hasOwnProperty($) && Ar.charAt(0) === `
` && (Dr += `
`), Dr += Ar) : vr = Ro(K.children);
        var Kr = {
          domNamespace: bg(Q, F.type),
          type: $,
          children: vr,
          childIndex: 0,
          context: I,
          footer: bo
        };
        return Kr.debugElementStack = [], this.stack.push(Kr), this.previousWasTextNode = !1, Dr;
      }, f;
    }();
    function wy(f, C) {
      var T = new Rp(f, !1, C);
      try {
        var F = T.read(1 / 0);
        return F;
      } finally {
        T.destroy();
      }
    }
    function Sy(f, C) {
      var T = new Rp(f, !0, C);
      try {
        var F = T.read(1 / 0);
        return F;
      } finally {
        T.destroy();
      }
    }
    function _y() {
      throw Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function Ey() {
      throw Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    Zo.renderToNodeStream = _y, Zo.renderToStaticMarkup = Sy, Zo.renderToStaticNodeStream = Ey, Zo.renderToString = wy, Zo.version = r;
  }()), Zo;
}
process.env.NODE_ENV === "production" ? _u.exports = Qb() : _u.exports = Jb();
var ig = _u.exports, Ha = {};
Object.defineProperty(Ha, "__esModule", { value: !0 });
var Zb = 0;
function eT() {
  return "agPortalKey_" + ++Zb;
}
Ha.default = eT;
var tT = P && P.__extends || /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rT = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Ga, "__esModule", { value: !0 });
Ga.LegacyReactComponent = void 0;
var Od = Ye, oT = Hi, nT = xt, iT = $i, sT = ig, aT = rT(Ha), lT = (
  /** @class */
  function(i) {
    tT(t, i);
    function t(e, r, o, n) {
      var s = i.call(this, e, o, n) || this;
      return s.staticMarkup = null, s.staticRenderTime = 0, s.parentComponent = r, s;
    }
    return t.prototype.init = function(e) {
      var r = this;
      return this.eParentElement = this.createParentElement(e), this.renderStaticMarkup(e), new nT.AgPromise(function(o) {
        return r.createReactComponent(e, o);
      });
    }, t.prototype.createReactComponent = function(e, r) {
      var o = this;
      this.isStatelessComponent() || (e.ref = function(a) {
        o.componentInstance = a, o.addParentContainerStyleAndClasses(), o.removeStaticMarkup();
      });
      var n = Od.createElement(this.reactComponent, e), s = oT.createPortal(
        n,
        this.eParentElement,
        aT.default()
        // fixed deltaRowModeRefreshCompRenderer
      );
      this.portal = s, this.portalManager.mountReactPortal(s, this, function(a) {
        r(a), o.isStatelessComponent() && (o.isSlowRenderer() && o.removeStaticMarkup(), setTimeout(function() {
          o.removeStaticMarkup();
        }));
      });
    }, t.prototype.fallbackMethodAvailable = function(e) {
      return !1;
    }, t.prototype.fallbackMethod = function(e, r) {
    }, t.prototype.isSlowRenderer = function() {
      return this.staticRenderTime >= t.SLOW_RENDERING_THRESHOLD;
    }, t.prototype.isNullValue = function() {
      return this.staticMarkup === "";
    }, t.prototype.renderStaticMarkup = function(e) {
      if (!(this.parentComponent.isDisableStaticMarkup() || !this.componentType.cellRenderer)) {
        var r = console.error, o = Od.createElement(this.reactComponent, e);
        try {
          console.error = function() {
          };
          var n = Date.now(), s = sT.renderToStaticMarkup(o);
          this.staticRenderTime = Date.now() - n, console.error = r, s === "" ? this.staticMarkup = s : s && (this.staticMarkup = document.createElement("span"), this.staticMarkup.innerHTML = s, this.eParentElement.appendChild(this.staticMarkup));
        } catch {
        } finally {
          console.error = r;
        }
      }
    }, t.prototype.removeStaticMarkup = function() {
      this.parentComponent.isDisableStaticMarkup() || !this.componentType.cellRenderer || this.staticMarkup && (this.staticMarkup.remove ? (this.staticMarkup.remove(), this.staticMarkup = null) : this.eParentElement.removeChild && (this.eParentElement.removeChild(this.staticMarkup), this.staticMarkup = null));
    }, t.prototype.rendered = function() {
      return this.isNullValue() || !!this.staticMarkup || this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    }, t.SLOW_RENDERING_THRESHOLD = 3, t;
  }(iT.ReactComponent)
);
Ga.LegacyReactComponent = lT;
var Ki = {}, uT = P && P.__extends || /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fa = P && P.__assign || function() {
  return fa = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, fa.apply(this, arguments);
}, cT = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Ki, "__esModule", { value: !0 });
Ki.NewReactComponent = void 0;
var bd = Ye, pT = Hi, dT = xt, fT = $i, hT = ig, Td = cT(Ha), vT = (
  /** @class */
  function(i) {
    uT(t, i);
    function t(e, r, o) {
      var n = i.call(this, e, r, o) || this;
      return n.oldPortal = null, n.key = Td.default(), n.portalKey = Td.default(), n;
    }
    return t.prototype.init = function(e) {
      var r = this;
      return this.eParentElement = this.createParentElement(e), this.params = e, this.createOrUpdatePortal(e), new dT.AgPromise(function(o) {
        return r.createReactComponent(o);
      });
    }, t.prototype.createOrUpdatePortal = function(e) {
      var r = this;
      this.isStatelessComponent() || (e.ref = function(o) {
        r.componentInstance = o, r.addParentContainerStyleAndClasses();
      }), this.reactElement = bd.createElement(this.reactComponent, fa(fa({}, e), { key: this.key })), this.portal = pT.createPortal(
        this.reactElement,
        this.eParentElement,
        this.portalKey
        // fixed deltaRowModeRefreshCompRenderer
      );
    }, t.prototype.createReactComponent = function(e) {
      this.portalManager.mountReactPortal(this.portal, this, function(r) {
        e(r);
      });
    }, t.prototype.isNullValue = function() {
      return this.valueRenderedIsNull(this.params);
    }, t.prototype.rendered = function() {
      return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    }, t.prototype.valueRenderedIsNull = function(e) {
      if (!this.componentType.cellRenderer)
        return !1;
      var r = console.error;
      try {
        console.error = function() {
        };
        var o = hT.renderToStaticMarkup(bd.createElement(this.reactComponent, e));
        return o === "";
      } catch {
      } finally {
        console.error = r;
      }
      return !1;
    }, t.prototype.refreshComponent = function(e) {
      this.oldPortal = this.portal, this.createOrUpdatePortal(e), this.portalManager.updateReactPortal(this.oldPortal, this.portal);
    }, t.prototype.fallbackMethod = function(e, r) {
      var o = this[e + "Component"];
      if (o)
        return o.bind(this)(r);
    }, t.prototype.fallbackMethodAvailable = function(e) {
      var r = this[e + "Component"];
      return !!r;
    }, t;
  }(fT.ReactComponent)
);
Ki.NewReactComponent = vT;
var Yi = {}, gT = P && P.__spreadArrays || function() {
  for (var i = 0, t = 0, e = arguments.length; t < e; t++)
    i += arguments[t].length;
  for (var r = Array(i), o = 0, t = 0; t < e; t++)
    for (var n = arguments[t], s = 0, a = n.length; s < a; s++, o++)
      r[o] = n[s];
  return r;
};
Object.defineProperty(Yi, "__esModule", { value: !0 });
Yi.PortalManager = void 0;
var yT = (
  /** @class */
  function() {
    function i(t, e, r) {
      this.destroyed = !1, this.portals = [], this.hasPendingPortalUpdate = !1, this.wrappingElement = e || "div", this.parent = t, this.maxComponentCreationTimeMs = r || i.MAX_COMPONENT_CREATION_TIME_IN_MS;
    }
    return i.prototype.getPortals = function() {
      return this.portals;
    }, i.prototype.destroy = function() {
      this.destroyed = !0;
    }, i.prototype.destroyPortal = function(t) {
      this.portals = this.portals.filter(function(e) {
        return e !== t;
      }), this.batchUpdate();
    }, i.prototype.getComponentWrappingElement = function() {
      return this.wrappingElement;
    }, i.prototype.mountReactPortal = function(t, e, r) {
      this.portals = gT(this.portals, [t]), this.waitForInstance(e, r), this.batchUpdate();
    }, i.prototype.updateReactPortal = function(t, e) {
      this.portals[this.portals.indexOf(t)] = e, this.batchUpdate();
    }, i.prototype.batchUpdate = function() {
      var t = this;
      this.hasPendingPortalUpdate || (setTimeout(function() {
        t.destroyed || t.parent.forceUpdate(function() {
          t.hasPendingPortalUpdate = !1;
        });
      }), this.hasPendingPortalUpdate = !0);
    }, i.prototype.waitForInstance = function(t, e, r) {
      var o = this;
      if (r === void 0 && (r = Date.now()), this.destroyed) {
        e(null);
        return;
      }
      if (t.rendered())
        e(t);
      else {
        if (Date.now() - r >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
          if (t.isNullValue()) {
            e(t);
            return;
          }
          console.error("AG Grid: React Component '" + t.getReactComponentName() + "' not created within " + this.maxComponentCreationTimeMs + "ms");
          return;
        }
        window.setTimeout(function() {
          o.waitForInstance(t, e, r);
        });
      }
    }, i.MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3, i;
  }()
);
Yi.PortalManager = yT;
var wi = {}, mc = {}, _t = {}, mT = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(_t, "__esModule", { value: !0 });
_t.BeansContext = void 0;
var CT = mT(Ye);
_t.BeansContext = CT.default.createContext({});
var Br = {};
Object.defineProperty(Br, "__esModule", { value: !0 });
Br.createSyncJsComp = Br.showJsComp = void 0;
Br.showJsComp = function(i, t, e, r) {
  var o = !i || i.componentFromFramework;
  if (!o) {
    var n = i.newAgStackInstance();
    if (n) {
      var s, a, l = !1;
      return n.then(function(u) {
        if (l) {
          t.destroyBean(u);
          return;
        }
        s = u, a = s.getGui(), e.appendChild(a), Pd(r, s);
      }), function() {
        l = !0, s && (a && a.parentElement && a.parentElement.removeChild(a), t.destroyBean(s), r && Pd(r, void 0));
      };
    }
  }
};
var Pd = function(i, t) {
  if (i)
    if (i instanceof Function) {
      var e = i;
      e(t);
    } else {
      var r = i;
      r.current = t;
    }
};
Br.createSyncJsComp = function(i) {
  var t = i.newAgStackInstance();
  if (t)
    return t.resolveNow(null, function(e) {
      return e;
    });
};
var nt = {};
Object.defineProperty(nt, "__esModule", { value: !0 });
nt.useLayoutEffectOnce = nt.useEffectOnce = void 0;
var wr = Ye;
nt.useEffectOnce = function(i) {
  var t = wr.useRef(i), e = wr.useRef(), r = wr.useRef(!1), o = wr.useRef(!1), n = wr.useState(0), s = n[1];
  r.current && (o.current = !0), wr.useEffect(function() {
    return r.current || (e.current = t.current(), r.current = !0), s(function(a) {
      return a + 1;
    }), function() {
      o.current && e.current && e.current();
    };
  }, []);
};
nt.useLayoutEffectOnce = function(i) {
  var t = wr.useRef(i), e = wr.useRef(), r = wr.useRef(!1), o = wr.useRef(!1), n = wr.useState(0), s = n[1];
  r.current && (o.current = !0), wr.useLayoutEffect(function() {
    return r.current || (e.current = t.current(), r.current = !0), s(function(a) {
      return a + 1;
    }), function() {
      o.current && e.current && e.current();
    };
  }, []);
};
var ct = {}, Eu = P && P.__assign || function() {
  return Eu = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, Eu.apply(this, arguments);
}, wT = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(ct, "__esModule", { value: !0 });
ct.agFlushSync = ct.isComponentStateless = ct.CssClasses = ct.classesList = void 0;
var Ru = wT(Hi);
ct.classesList = function() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i[t] = arguments[t];
  var e = i.filter(function(r) {
    return r != null && r !== "";
  });
  return e.join(" ");
};
var ST = (
  /** @class */
  function() {
    function i() {
      for (var t = this, e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      this.classesMap = {}, e.forEach(function(o) {
        t.classesMap[o] = !0;
      });
    }
    return i.prototype.setClass = function(t, e) {
      var r = !!this.classesMap[t] == e;
      if (r)
        return this;
      var o = new i();
      return o.classesMap = Eu({}, this.classesMap), o.classesMap[t] = e, o;
    }, i.prototype.toString = function() {
      var t = this, e = Object.keys(this.classesMap).filter(function(r) {
        return t.classesMap[r];
      }).join(" ");
      return e;
    }, i;
  }()
);
ct.CssClasses = ST;
ct.isComponentStateless = function(i) {
  var t = function() {
    return typeof Symbol == "function" && Symbol.for;
  }, e = function() {
    return t() ? Symbol.for("react.memo") : 60115;
  };
  return typeof i == "function" && !(i.prototype && i.prototype.isReactComponent) || typeof i == "object" && i.$$typeof === e();
};
var _T = Ru.default.createRoot != null && Ru.default.flushSync != null;
ct.agFlushSync = function(i, t) {
  _T && i ? Ru.default.flushSync(t) : t();
};
var ha = P && P.__assign || function() {
  return ha = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ha.apply(this, arguments);
}, ET = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), RT = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), OT = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && ET(t, i, e);
  return RT(t, i), t;
};
Object.defineProperty(mc, "__esModule", { value: !0 });
var Dd = xt, Be = OT(Ye), bT = _t, TT = Br, PT = nt, Ls = ct, sg = Be.forwardRef(function(i, t) {
  var e = Be.useContext(bT.BeansContext).context, r = Be.useRef(null), o = Be.useRef(null), n = Be.useRef(null), s = Be.useRef(null), a = Be.useRef(null), l = Be.useState(), u = l[0], c = l[1], p = Be.useState(), d = p[0], h = p[1], g = Be.useState(), y = g[0], S = g[1], _ = Be.useState(new Ls.CssClasses()), w = _[0], E = _[1], R = Be.useState(new Ls.CssClasses("ag-hidden")), D = R[0], B = R[1], H = Be.useState(new Ls.CssClasses("ag-hidden")), A = H[0], N = H[1], G = Be.useState(new Ls.CssClasses("ag-invisible")), W = G[0], J = G[1];
  Be.useImperativeHandle(t, function() {
    return {
      // force new instance when grid tries to refresh
      refresh: function() {
        return !1;
      }
    };
  }), Be.useLayoutEffect(function() {
    return TT.showJsComp(u, e, o.current);
  }, [u]), PT.useLayoutEffectOnce(function() {
    var _e = {
      setInnerRenderer: function(Ee, Re) {
        c(Ee), S(Re);
      },
      setChildCount: function(Ee) {
        return h(Ee);
      },
      addOrRemoveCssClass: function(Ee, Re) {
        return E(function(Me) {
          return Me.setClass(Ee, Re);
        });
      },
      setContractedDisplayed: function(Ee) {
        return N(function(Re) {
          return Re.setClass("ag-hidden", !Ee);
        });
      },
      setExpandedDisplayed: function(Ee) {
        return B(function(Re) {
          return Re.setClass("ag-hidden", !Ee);
        });
      },
      setCheckboxVisible: function(Ee) {
        return J(function(Re) {
          return Re.setClass("ag-invisible", !Ee);
        });
      }
    }, Le = e.createBean(new Dd.GroupCellRendererCtrl());
    return Le.init(_e, r.current, n.current, s.current, a.current, sg, i), function() {
      e.destroyBean(Le);
    };
  });
  var de = Be.useMemo(function() {
    return "ag-cell-wrapper " + w.toString();
  }, [w]), ve = Be.useMemo(function() {
    return "ag-group-expanded " + D.toString();
  }, [D]), oe = Be.useMemo(function() {
    return "ag-group-contracted " + A.toString();
  }, [A]), ne = Be.useMemo(function() {
    return "ag-group-checkbox " + W.toString();
  }, [W]), fe = u && u.componentFromFramework, ce = fe ? u.componentClass : void 0, se = u == null && y != null, je = Dd._.escapeString(y, !0);
  return Be.default.createElement(
    "span",
    ha({ className: de, ref: r }, i.colDef ? {} : { role: "gridcell" }),
    Be.default.createElement("span", { className: ve, ref: s }),
    Be.default.createElement("span", { className: oe, ref: a }),
    Be.default.createElement("span", { className: ne, ref: n }),
    Be.default.createElement(
      "span",
      { className: "ag-group-value", ref: o },
      se && Be.default.createElement(Be.default.Fragment, null, je),
      fe && Be.default.createElement(ce, ha({}, u.params))
    ),
    Be.default.createElement("span", { className: "ag-group-child-count" }, d)
  );
});
mc.default = sg;
var Ns = {}, Si = {}, Cc = {}, wc = {}, Sc = {}, _c = {}, Ec = {}, Rc = {}, va = P && P.__assign || function() {
  return va = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, va.apply(this, arguments);
}, DT = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), AT = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), xT = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && DT(t, i, e);
  return AT(t, i), t;
};
Object.defineProperty(Rc, "__esModule", { value: !0 });
var ht = xT(Ye), FT = _t, MT = xt, IT = ct, LT = Br, NT = nt, GT = function(i) {
  var t = ht.useContext(FT.BeansContext).context, e = ht.useState(), r = e[0], o = e[1], n = ht.useState(), s = n[0], a = n[1], l = ht.useState(), u = l[0], c = l[1], p = ht.useState(), d = p[0], h = p[1], g = ht.useState(), y = g[0], S = g[1], _ = ht.useRef(null), w = ht.useRef(null), E = ht.useRef(null), R = ht.useRef(), D = i.ctrl, B = ht.useMemo(function() {
    return new MT.CssClassManager(function() {
      return _.current;
    });
  }, []);
  NT.useLayoutEffectOnce(function() {
    var G = {
      setWidth: function(J) {
        return _.current.style.width = J;
      },
      addOrRemoveCssClass: function(J, de) {
        return B.addOrRemoveCssClass(J, de);
      },
      setColId: function(J) {
        return a(J);
      },
      setTitle: function(J) {
        return o(J);
      },
      setAriaDescription: function(J) {
        return h(J);
      },
      setAriaSort: function(J) {
        return c(J);
      },
      setUserCompDetails: function(J) {
        return S(J);
      },
      getUserCompInstance: function() {
        return R.current || void 0;
      }
    };
    D.setComp(G, _.current, w.current, E.current);
    var W = D.getSelectAllGui();
    w.current.insertAdjacentElement("afterend", W);
  }), ht.useLayoutEffect(function() {
    return LT.showJsComp(y, t, E.current, R);
  }, [y]), ht.useEffect(function() {
    D.setDragSource(_.current);
  }, [y]);
  var H = ht.useMemo(function() {
    var G = (y == null ? void 0 : y.componentFromFramework) && IT.isComponentStateless(y.componentClass);
    return !!G;
  }, [y]), A = y && y.componentFromFramework, N = y && y.componentClass;
  return ht.default.createElement(
    "div",
    { ref: _, className: "ag-header-cell", title: r, "col-id": s, "aria-sort": u, role: "columnheader", tabIndex: -1, "aria-description": d },
    ht.default.createElement("div", { ref: w, className: "ag-header-cell-resize", role: "presentation" }),
    ht.default.createElement(
      "div",
      { ref: E, className: "ag-header-cell-comp-wrapper", role: "presentation" },
      A && H && ht.default.createElement(N, va({}, y.params)),
      A && !H && ht.default.createElement(N, va({}, y.params, { ref: R }))
    )
  );
};
Rc.default = ht.memo(GT);
var Oc = {}, Ou = P && P.__assign || function() {
  return Ou = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, Ou.apply(this, arguments);
}, HT = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), VT = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), BT = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && HT(t, i, e);
  return VT(t, i), t;
};
Object.defineProperty(Oc, "__esModule", { value: !0 });
var Ot = BT(Ye), kT = _t, jT = Br, WT = nt, Ad = ct, UT = function(i) {
  var t = Ot.useContext(kT.BeansContext).context, e = Ot.useState(new Ad.CssClasses()), r = e[0], o = e[1], n = Ot.useState(new Ad.CssClasses()), s = n[0], a = n[1], l = Ot.useState("false"), u = l[0], c = l[1], p = Ot.useState(), d = p[0], h = p[1], g = Ot.useState(), y = g[0], S = g[1], _ = Ot.useState(), w = _[0], E = _[1], R = Ot.useState(), D = R[0], B = R[1], H = Ot.useRef(null), A = Ot.useRef(null), N = i.ctrl;
  WT.useLayoutEffectOnce(function() {
    var ve = {
      setWidth: function(oe) {
        return H.current.style.width = oe;
      },
      addOrRemoveCssClass: function(oe, ne) {
        return o(function(fe) {
          return fe.setClass(oe, ne);
        });
      },
      setColId: function(oe) {
        return S(oe);
      },
      setTitle: function(oe) {
        return h(oe);
      },
      setUserCompDetails: function(oe) {
        return B(oe);
      },
      setResizableDisplayed: function(oe) {
        a(function(ne) {
          return ne.setClass("ag-hidden", !oe);
        }), c(oe ? "false" : "true");
      },
      setAriaExpanded: function(oe) {
        return E(oe);
      }
    };
    N.setComp(ve, H.current, A.current);
  }), Ot.useLayoutEffect(function() {
    return jT.showJsComp(D, t, H.current);
  }, [D]), Ot.useEffect(function() {
    var ve = void 0;
    H.current.childNodes.forEach(function(oe) {
      oe != null && oe !== A.current && (ve = oe);
    }), ve && N.setDragSource(ve);
  }, [D]);
  var G = Ot.useMemo(function() {
    return "ag-header-group-cell " + r.toString();
  }, [r]), W = Ot.useMemo(function() {
    return "ag-header-cell-resize " + s.toString();
  }, [s]), J = D && D.componentFromFramework, de = D && D.componentClass;
  return Ot.default.createElement(
    "div",
    { ref: H, className: G, title: d, "col-id": y, role: "columnheader", tabIndex: -1, "aria-expanded": w },
    J && Ot.default.createElement(de, Ou({}, D.params)),
    Ot.default.createElement("div", { ref: A, "aria-hidden": u, className: W })
  );
};
Oc.default = Ot.memo(UT);
var bc = {}, ga = P && P.__assign || function() {
  return ga = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ga.apply(this, arguments);
}, zT = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), $T = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), KT = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && zT(t, i, e);
  return $T(t, i), t;
};
Object.defineProperty(bc, "__esModule", { value: !0 });
var Xe = KT(Ye), YT = _t, qT = xt, Gs = ct, XT = Br, xd = nt, QT = function(i) {
  var t = Xe.useContext(YT.BeansContext).context, e = Xe.useState(new Gs.CssClasses("ag-header-cell", "ag-floating-filter")), r = e[0], o = e[1], n = Xe.useState(new Gs.CssClasses()), s = n[0], a = n[1], l = Xe.useState(new Gs.CssClasses("ag-floating-filter-button", "ag-hidden")), u = l[0], c = l[1], p = Xe.useState("false"), d = p[0], h = p[1], g = Xe.useState(), y = g[0], S = g[1], _ = Xe.useRef(null), w = Xe.useRef(null), E = Xe.useRef(null), R = Xe.useRef(null), D = Xe.useRef(!1), B = Xe.useRef(), H = Xe.useRef();
  xd.useLayoutEffectOnce(function() {
    H.current = new qT.AgPromise(function(ne) {
      B.current = ne;
    });
  });
  var A = function(ne) {
    D.current || ne != null && (B.current && B.current(ne), D.current = !0);
  }, N = i.ctrl;
  xd.useLayoutEffectOnce(function() {
    var ne = {
      addOrRemoveCssClass: function(fe, ce) {
        return o(function(se) {
          return se.setClass(fe, ce);
        });
      },
      addOrRemoveBodyCssClass: function(fe, ce) {
        return a(function(se) {
          return se.setClass(fe, ce);
        });
      },
      setButtonWrapperDisplayed: function(fe) {
        c(function(ce) {
          return ce.setClass("ag-hidden", !fe);
        }), h(fe ? "false" : "true");
      },
      setWidth: function(fe) {
        return _.current.style.width = fe;
      },
      setCompDetails: function(fe) {
        return S(fe);
      },
      getFloatingFilterComp: function() {
        return H.current ? H.current : null;
      },
      setMenuIcon: function(fe) {
        return R.current.appendChild(fe);
      }
    };
    N.setComp(ne, _.current, R.current, w.current);
  }), Xe.useLayoutEffect(function() {
    return XT.showJsComp(y, t, w.current, A);
  }, [y]);
  var G = Xe.useMemo(function() {
    return r.toString();
  }, [r]), W = Xe.useMemo(function() {
    return s.toString();
  }, [s]), J = Xe.useMemo(function() {
    return u.toString();
  }, [u]), de = Xe.useMemo(function() {
    var ne = y && y.componentFromFramework && Gs.isComponentStateless(y.componentClass);
    return !!ne;
  }, [y]), ve = y && y.componentFromFramework, oe = y && y.componentClass;
  return Xe.default.createElement(
    "div",
    { ref: _, className: G, role: "gridcell", tabIndex: -1 },
    Xe.default.createElement(
      "div",
      { ref: w, className: W, role: "presentation" },
      ve && de && Xe.default.createElement(oe, ga({}, y.params)),
      ve && !de && Xe.default.createElement(oe, ga({}, y.params, { ref: A }))
    ),
    Xe.default.createElement(
      "div",
      { ref: E, "aria-hidden": d, className: J, role: "presentation" },
      Xe.default.createElement("button", { ref: R, type: "button", "aria-label": "Open Filter Menu", className: "ag-floating-filter-button-button", tabIndex: -1 })
    )
  );
};
bc.default = Xe.memo(QT);
var JT = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), ZT = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), eP = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && JT(t, i, e);
  return ZT(t, i), t;
}, tP = P && P.__spreadArrays || function() {
  for (var i = 0, t = 0, e = arguments.length; t < e; t++)
    i += arguments[t].length;
  for (var r = Array(i), o = 0, t = 0; t < e; t++)
    for (var n = arguments[t], s = 0, a = n.length; s < a; s++, o++)
      r[o] = n[s];
  return r;
}, Tc = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Ec, "__esModule", { value: !0 });
var en = xt, Ht = eP(Ye), rP = _t, oP = Tc(Rc), nP = Tc(Oc), iP = Tc(bc), sP = nt, aP = function(i) {
  var t = Ht.useContext(rP.BeansContext).gridOptionsService, e = Ht.useState(), r = e[0], o = e[1], n = Ht.useState(), s = n[0], a = n[1], l = Ht.useState(), u = l[0], c = l[1], p = Ht.useState(), d = p[0], h = p[1], g = Ht.useState([]), y = g[0], S = g[1], _ = Ht.useRef(null), w = i.ctrl, E = w.getType() === en.HeaderRowType.COLUMN, R = w.getType() === en.HeaderRowType.COLUMN_GROUP, D = w.getType() === en.HeaderRowType.FLOATING_FILTER, B = Ht.useCallback(function(G, W) {
    var J = t.is("ensureDomOrder"), de = t.isDomLayout("print");
    if (J || de)
      return W;
    var ve = en._.mapById(G, function(ce) {
      return ce.getInstanceId();
    }), oe = en._.mapById(W, function(ce) {
      return ce.getInstanceId();
    }), ne = G.filter(function(ce) {
      return oe.has(ce.getInstanceId());
    }), fe = W.filter(function(ce) {
      return !ve.has(ce.getInstanceId());
    });
    return tP(ne, fe);
  }, []);
  sP.useLayoutEffectOnce(function() {
    var G = {
      setTransform: function(W) {
        return o(W);
      },
      setHeight: function(W) {
        return a(W);
      },
      setTop: function(W) {
        return c(W);
      },
      setHeaderCtrls: function(W) {
        return S(function(J) {
          return B(J, W);
        });
      },
      setWidth: function(W) {
        return _.current.style.width = W;
      },
      setAriaRowIndex: function(W) {
        return h(W);
      }
    };
    w.setComp(G);
  });
  var H = Ht.useMemo(function() {
    return {
      transform: r,
      height: s,
      top: u
    };
  }, [r, s, u]), A = Ht.useMemo(function() {
    var G = ["ag-header-row"];
    return E && G.push("ag-header-row-column"), R && G.push("ag-header-row-column-group"), D && G.push("ag-header-row-column-filter"), G.join(" ");
  }, []), N = Ht.useCallback(function(G) {
    switch (w.getType()) {
      case en.HeaderRowType.COLUMN_GROUP:
        return Ht.default.createElement(nP.default, { ctrl: G, key: G.getInstanceId() });
      case en.HeaderRowType.FLOATING_FILTER:
        return Ht.default.createElement(iP.default, { ctrl: G, key: G.getInstanceId() });
      default:
        return Ht.default.createElement(oP.default, { ctrl: G, key: G.getInstanceId() });
    }
  }, []);
  return Ht.default.createElement("div", { ref: _, className: A, role: "row", style: H, "aria-rowindex": d }, y.map(N));
};
Ec.default = Ht.memo(aP);
var lP = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), uP = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), cP = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && lP(t, i, e);
  return uP(t, i), t;
}, pP = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(_c, "__esModule", { value: !0 });
var Kt = cP(Ye), dP = _t, fP = xt, hP = ct, vP = pP(Ec), gP = nt, yP = function(i) {
  var t = Kt.useState(new hP.CssClasses()), e = t[0], r = t[1], o = Kt.useState(!1), n = o[0], s = o[1], a = Kt.useState([]), l = a[0], u = a[1], c = Kt.useContext(dP.BeansContext).context, p = Kt.useRef(null), d = Kt.useRef(null), h = i.pinned === "left", g = i.pinned === "right", y = !h && !g;
  gP.useLayoutEffectOnce(function() {
    var w = {
      setDisplayed: function(R) {
        r(function(D) {
          return D.setClass("ag-hidden", !R);
        }), s(!R);
      },
      setCtrls: function(R) {
        return u(R);
      },
      // centre only
      setCenterWidth: function(R) {
        d.current && (d.current.style.width = R);
      },
      setViewportScrollLeft: function(R) {
        p.current && (p.current.scrollLeft = R);
      },
      // pinned only
      setPinnedContainerWidth: function(R) {
        p.current.style.width = R, p.current.style.minWidth = R, p.current.style.maxWidth = R;
      }
    }, E = c.createBean(new fP.HeaderRowContainerCtrl(i.pinned));
    return E.setComp(w, p.current), function() {
      c.destroyBean(E);
    };
  });
  var S = Kt.useMemo(function() {
    return e.toString();
  }, [e]), _ = function() {
    return l.map(function(w) {
      return Kt.default.createElement(vP.default, { ctrl: w, key: w.getInstanceId() });
    });
  };
  return Kt.default.createElement(
    Kt.default.Fragment,
    null,
    h && Kt.default.createElement("div", { ref: p, className: "ag-pinned-left-header " + S, "aria-hidden": n, role: "presentation" }, _()),
    g && Kt.default.createElement("div", { ref: p, className: "ag-pinned-right-header " + S, "aria-hidden": n, role: "presentation" }, _()),
    y && Kt.default.createElement(
      "div",
      { ref: p, className: "ag-header-viewport " + S, role: "presentation" },
      Kt.default.createElement("div", { ref: d, className: "ag-header-container", role: "rowgroup" }, _())
    )
  );
};
_c.default = Kt.memo(yP);
var mP = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), CP = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), wP = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && mP(t, i, e);
  return CP(t, i), t;
}, SP = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Sc, "__esModule", { value: !0 });
var Mr = wP(Ye), _P = _t, EP = xt, RP = ct, Kl = SP(_c), OP = nt, bP = function() {
  var i = Mr.useState(new RP.CssClasses()), t = i[0], e = i[1], r = Mr.useState(), o = r[0], n = r[1], s = Mr.useContext(_P.BeansContext).context, a = Mr.useRef(null);
  OP.useLayoutEffectOnce(function() {
    var c = {
      addOrRemoveCssClass: function(d, h) {
        return e(function(g) {
          return g.setClass(d, h);
        });
      },
      setHeightAndMinHeight: function(d) {
        return n(d);
      }
    }, p = s.createBean(new EP.GridHeaderCtrl());
    return p.setComp(c, a.current, a.current), function() {
      s.destroyBean(p);
    };
  });
  var l = Mr.useMemo(function() {
    var c = t.toString();
    return "ag-header " + c;
  }, [t]), u = Mr.useMemo(function() {
    return {
      height: o,
      minHeight: o
    };
  }, [o]);
  return Mr.default.createElement(
    "div",
    { ref: a, className: l, style: u, role: "presentation" },
    Mr.default.createElement(Kl.default, { pinned: "left" }),
    Mr.default.createElement(Kl.default, { pinned: null }),
    Mr.default.createElement(Kl.default, { pinned: "right" })
  );
};
Sc.default = Mr.memo(bP);
var qi = {};
Object.defineProperty(qi, "__esModule", { value: !0 });
var TP = nt, PP = function(i, t) {
  TP.useEffectOnce(function() {
    var e = t.current, r = e.parentElement;
    if (r) {
      var o = document.createComment(i);
      return r.insertBefore(o, e), function() {
        r.removeChild(o);
      };
    }
  });
};
qi.default = PP;
var Pc = {}, Dc = {}, ag = {}, Ac = {}, DP = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), AP = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), xP = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && DP(t, i, e);
  return AP(t, i), t;
};
Object.defineProperty(Ac, "__esModule", { value: !0 });
var FP = xt, Ri = xP(Ye), MP = Hi, IP = _t, LP = nt, NP = function(i) {
  var t = Ri.useState(), e = t[0], r = t[1], o = Ri.useContext(IP.BeansContext), n = o.context, s = o.popupService, a = o.localeService, l = o.gridOptionsService;
  return LP.useLayoutEffectOnce(function() {
    var u = i.editDetails, c = i.cellCtrl, p = i.eParentCell, d = u.compDetails, h = l.is("stopEditingWhenCellsLoseFocus"), g = n.createBean(new FP.PopupEditorWrapper(d.params)), y = g.getGui();
    if (i.jsChildComp) {
      var S = i.jsChildComp.getGui();
      S && y.appendChild(S);
    }
    var _ = {
      column: c.getColumn(),
      rowNode: c.getRowNode(),
      type: "popupCellEditor",
      eventSource: p,
      ePopup: y,
      position: u.popupPosition,
      keepWithinBounds: !0
    }, w = s.positionPopupByComponent.bind(s, _), E = a.getLocaleTextFunc(), R = s.addPopup({
      modal: h,
      eChild: y,
      closeOnEsc: !0,
      closedCallback: function() {
        c.onPopupEditorClosed();
      },
      anchorToElement: p,
      positionCallback: w,
      ariaLabel: E("ariaLabelCellEditor", "Cell Editor")
    }), D = R ? R.hideFunc : void 0;
    return r(g), i.jsChildComp && i.jsChildComp.afterGuiAttached && i.jsChildComp.afterGuiAttached(), function() {
      D != null && D(), n.destroyBean(g);
    };
  }), Ri.default.createElement(Ri.default.Fragment, null, e && i.wrappedContent && MP.createPortal(i.wrappedContent, e.getGui()));
};
Ac.default = Ri.memo(NP);
var xc = {};
Object.defineProperty(xc, "__esModule", { value: !0 });
var Yl = Ye, GP = _t, HP = nt, VP = function(i, t, e, r, o, n) {
  var s = Yl.useContext(GP.BeansContext), a = s.context;
  s.userComponentFactory;
  var l = Yl.useCallback(function() {
    var u = o.current;
    if (u) {
      var c = u.getGui();
      c && c.parentElement && c.parentElement.removeChild(c), a.destroyBean(u), o.current = void 0;
    }
  }, []);
  Yl.useEffect(function() {
    var u = i != null, c = i && i.compDetails && !i.compDetails.componentFromFramework, p = t && e == null, d = u && c && !p;
    if (!d) {
      l();
      return;
    }
    var h = i.compDetails;
    if (o.current) {
      var g = o.current, y = g.refresh != null && i.force == !1, S = y ? g.refresh(h.params) : !1, _ = S === !0 || S === void 0;
      if (_)
        return;
      l();
    }
    var w = h.newAgStackInstance();
    if (w) {
      var E = w.resolveNow(null, function(B) {
        return B;
      });
      if (E) {
        var R = E.getGui();
        if (R) {
          var D = t ? e : n.current;
          D.appendChild(R), o.current = E;
        }
      }
    }
  }, [i, t, r]), HP.useEffectOnce(function() {
    return l;
  });
};
xc.default = VP;
(function(i) {
  var t = P && P.__assign || function() {
    return t = Object.assign || function(w) {
      for (var E, R = 1, D = arguments.length; R < D; R++) {
        E = arguments[R];
        for (var B in E)
          Object.prototype.hasOwnProperty.call(E, B) && (w[B] = E[B]);
      }
      return w;
    }, t.apply(this, arguments);
  }, e = P && P.__createBinding || (Object.create ? function(w, E, R, D) {
    D === void 0 && (D = R), Object.defineProperty(w, D, { enumerable: !0, get: function() {
      return E[R];
    } });
  } : function(w, E, R, D) {
    D === void 0 && (D = R), w[D] = E[R];
  }), r = P && P.__setModuleDefault || (Object.create ? function(w, E) {
    Object.defineProperty(w, "default", { enumerable: !0, value: E });
  } : function(w, E) {
    w.default = E;
  }), o = P && P.__importStar || function(w) {
    if (w && w.__esModule)
      return w;
    var E = {};
    if (w != null)
      for (var R in w)
        R !== "default" && Object.prototype.hasOwnProperty.call(w, R) && e(E, w, R);
    return r(E, w), E;
  }, n = P && P.__importDefault || function(w) {
    return w && w.__esModule ? w : { default: w };
  };
  Object.defineProperty(i, "__esModule", { value: !0 }), i.CellCompState = void 0;
  var s = xt, a = o(Ye), l = ct, u = n(Ac), c = n(xc), p = _t, d = Br, h = nt;
  (function(w) {
    w[w.ShowValue = 0] = "ShowValue", w[w.EditValue = 1] = "EditValue";
  })(i.CellCompState || (i.CellCompState = {}));
  var g = function(w, E, R) {
    var D = R.getColumn();
    if (!w && E.isPopup && E.isPopup()) {
      var B = "AG Grid: Found an issue in column " + D.getColId() + ". If using React, specify an editor is a popup using colDef.cellEditorPopup=true. AG Grid React cannot depend on the editor component specifying if it's in a popup (via the isPopup() method on the editor), as React needs to know this information BEFORE the component is created.";
      s._.doOnce(function() {
        return console.warn(B);
      }, "jsEditorComp-isPopup-" + R.getColumn().getColId());
    }
    if (w && E.getPopupPosition && E.getPopupPosition() != null) {
      var H = "AG Grid: Found an issue in column " + D.getColId() + ". If using React, specify an editor popup position using colDef.cellEditorPopupPosition=true. AG Grid React cannot depend on the editor component specifying it's position (via the getPopupPosition() method on the editor), as React needs to know this information BEFORE the component is created.";
      s._.doOnce(function() {
        return console.warn(H);
      }, "jsEditorComp-getPopupPosition-" + R.getColumn().getColId());
    }
  }, y = function(w, E, R, D, B, H) {
    var A = w.compDetails, N = A.componentClass, G = A.componentFromFramework && !w.popup, W = A.componentFromFramework && w.popup, J = !A.componentFromFramework && w.popup;
    return a.default.createElement(
      a.default.Fragment,
      null,
      G && a.default.createElement(N, t({}, w.compDetails.params, { ref: E })),
      W && a.default.createElement(u.default, { editDetails: w, cellCtrl: B, eParentCell: D, wrappedContent: a.default.createElement(N, t({}, w.compDetails.params, { ref: R })) }),
      J && H && a.default.createElement(u.default, { editDetails: w, cellCtrl: B, eParentCell: D, jsChildComp: H })
    );
  }, S = function(w, E, R, D, B, H, A) {
    var N = w.compDetails, G = w.value, W = !N, J = N && N.componentFromFramework, de = N && N.componentClass, ve = G != null && G.toString ? G.toString() : G, oe = function() {
      return a.default.createElement(
        a.default.Fragment,
        null,
        W && a.default.createElement(a.default.Fragment, null, ve),
        J && !H && a.default.createElement(de, t({}, N.params, { key: E, ref: D })),
        J && H && a.default.createElement(de, t({}, N.params, { key: E }))
      );
    };
    return a.default.createElement(a.default.Fragment, null, B ? a.default.createElement("span", { role: "presentation", id: "cell-" + R, className: "ag-cell-value", ref: A }, oe()) : oe());
  }, _ = function(w) {
    var E = a.useContext(p.BeansContext).context, R = w.cellCtrl, D = w.printLayout, B = w.editingRow, H = a.useState(), A = H[0], N = H[1], G = a.useState(), W = G[0], J = G[1], de = a.useState(1), ve = de[0], oe = de[1], ne = a.useState(), fe = ne[0], ce = ne[1], se = a.useState(), je = se[0], _e = se[1], Le = a.useState(), Ee = Le[0], Re = Le[1], Me = a.useState(), it = Me[0], Ve = Me[1], Ze = a.useState(), Se = Ze[0], yt = Ze[1], Ge = a.useState(!1), st = Ge[0], Et = Ge[1], De = a.useState(!1), me = De[0], at = De[1], jt = a.useState(!1), dr = jt[0], kr = jt[1], jr = a.useState(), lo = jr[0], Wt = jr[1], pt = a.useMemo(function() {
      return R.isForceWrapper();
    }, []), Te = a.useRef(null), mt = a.useRef(null), Wr = a.useRef(), br = a.useRef(), We = a.useRef(), Ut = a.useState(0), Rt = Ut[0], Uo = Ut[1], Ur = a.useCallback(function(b) {
      We.current = b, Uo(function(V) {
        return V + 1;
      });
    }, []), Tr = a.useRef(), Xt = a.useState(0), So = Xt[0], Sn = Xt[1], uo = a.useCallback(function(b) {
      Tr.current = b, Sn(function(V) {
        return V + 1;
      });
    }, []), _n = A != null && (st || dr || me), fr = pt || _n, co = a.useCallback(function(b, V) {
      if (br.current = V, V) {
        g(b, V, R);
        var q = V.isCancelBeforeStart && V.isCancelBeforeStart();
        q && setTimeout(function() {
          R.stopEditing(!0), R.focusCell(!0);
        });
      }
    }, []), En = a.useCallback(function(b) {
      return co(!0, b);
    }, []), Rn = a.useCallback(function(b) {
      return co(!1, b);
    }, []), Pr = a.useMemo(function() {
      return new s.CssClassManager(function() {
        return Te.current;
      });
    }, []);
    c.default(A, fr, Tr.current, So, Wr, Te);
    var On = a.useRef();
    a.useLayoutEffect(function() {
      var b = On.current, V = A;
      if (On.current = A, !(b == null || b.compDetails == null || V == null || V.compDetails == null)) {
        var q = b.compDetails, z = V.compDetails;
        if (q.componentClass == z.componentClass && !(mt.current == null || mt.current.refresh == null)) {
          var X = mt.current.refresh(z.params);
          X != !0 && oe(function(ie) {
            return ie + 1;
          });
        }
      }
    }, [A]), a.useLayoutEffect(function() {
      var b = W && !W.compDetails.componentFromFramework;
      if (b) {
        var V = W.compDetails, q = W.popup === !0, z = d.createSyncJsComp(V);
        if (z) {
          var X = z.getGui();
          if (co(q, z), !q) {
            var ie = (pt ? We : Te).current;
            ie == null || ie.appendChild(X), z.afterGuiAttached && z.afterGuiAttached();
          }
          return Wt(z), function() {
            E.destroyBean(z), co(q, void 0), Wt(void 0), X && X.parentElement && X.parentElement.removeChild(X);
          };
        }
      }
    }, [W]), a.useLayoutEffect(function() {
      if (!(!R || !E) && !(!We.current || !fr)) {
        var b = [], V = function(z) {
          if (z) {
            var X = z.getGui();
            We.current.insertAdjacentElement("afterbegin", X), b.push(function() {
              E.destroyBean(z), s._.removeFromParent(X);
            });
          }
          return z;
        };
        if (st) {
          var q = R.createSelectionCheckbox();
          V(q);
        }
        return dr && V(R.createDndSource()), me && V(R.createRowDragComp()), function() {
          return b.forEach(function(z) {
            return z();
          });
        };
      }
    }, [fr, dr, me, st, Rt]), h.useLayoutEffectOnce(function() {
      if (R) {
        var b = {
          addOrRemoveCssClass: function(q, z) {
            return Pr.addOrRemoveCssClass(q, z);
          },
          setUserStyles: function(q) {
            return ce(q);
          },
          getFocusableElement: function() {
            return Te.current;
          },
          setTabIndex: function(q) {
            return _e(q);
          },
          setRole: function(q) {
            return Re(q);
          },
          setColId: function(q) {
            return Ve(q);
          },
          setTitle: function(q) {
            return yt(q);
          },
          setIncludeSelection: function(q) {
            return Et(q);
          },
          setIncludeRowDrag: function(q) {
            return at(q);
          },
          setIncludeDndSource: function(q) {
            return kr(q);
          },
          getCellEditor: function() {
            return br.current || null;
          },
          getCellRenderer: function() {
            return mt.current ? mt.current : Wr.current;
          },
          getParentOfValue: function() {
            return Tr.current ? Tr.current : We.current ? We.current : Te.current;
          },
          setRenderDetails: function(q, z, X) {
            N({
              value: z,
              compDetails: q,
              force: X
            });
          },
          setEditDetails: function(q, z, X) {
            q ? (J({
              compDetails: q,
              popup: z,
              popupPosition: X
            }), z || N(void 0)) : J(void 0);
          }
        }, V = We.current || void 0;
        R.setComp(b, Te.current, V, D, B);
      }
    });
    var _o = a.useMemo(function() {
      var b = A && A.compDetails && A.compDetails.componentFromFramework && l.isComponentStateless(A.compDetails.componentClass);
      return !!b;
    }, [A]);
    a.useEffect(function() {
      var b;
      Te.current && (Pr.addOrRemoveCssClass("ag-cell-value", !fr), Pr.addOrRemoveCssClass("ag-cell-inline-editing", !!W && !W.popup), Pr.addOrRemoveCssClass("ag-cell-popup-editing", !!W && !!W.popup), Pr.addOrRemoveCssClass("ag-cell-not-inline-editing", !W || !!W.popup), (b = R.getRowCtrl()) === null || b === void 0 || b.setInlineEditingCss(!!W));
    });
    var O = a.useMemo(function() {
      return R.getInstanceId();
    }, []), x = function() {
      return a.default.createElement(
        a.default.Fragment,
        null,
        A != null && S(A, ve, O, mt, fr, _o, uo),
        W != null && y(W, Rn, En, Te.current, R, lo)
      );
    };
    return a.default.createElement("div", { ref: Te, style: fe, tabIndex: je, role: Ee, "col-id": it, title: Se }, fr ? a.default.createElement("div", { className: "ag-cell-wrapper", role: "presentation", ref: Ur }, x()) : x());
  };
  i.default = a.memo(_);
})(ag);
var ya = P && P.__assign || function() {
  return ya = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ya.apply(this, arguments);
}, BP = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), kP = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), jP = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && BP(t, i, e);
  return kP(t, i), t;
}, WP = P && P.__spreadArrays || function() {
  for (var i = 0, t = 0, e = arguments.length; t < e; t++)
    i += arguments[t].length;
  for (var r = Array(i), o = 0, t = 0; t < e; t++)
    for (var n = arguments[t], s = 0, a = n.length; s < a; s++, o++)
      r[o] = n[s];
  return r;
}, UP = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Dc, "__esModule", { value: !0 });
var ke = jP(Ye), zP = xt, $P = Br, Fd = ct, KP = _t, YP = UP(ag), qP = nt, XP = function(i, t, e) {
  if (e) {
    var r = { list: t, instanceIdMap: /* @__PURE__ */ new Map() };
    return t.forEach(function(u) {
      return r.instanceIdMap.set(u.getInstanceId(), u);
    }), r;
  }
  var o = [], n = [], s = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  t.forEach(function(u) {
    return a.set(u.getInstanceId(), u);
  }), i.list.forEach(function(u) {
    var c = u.getInstanceId();
    a.has(c) && (o.push(u), s.set(c, u));
  }), t.forEach(function(u) {
    var c = u.getInstanceId();
    i.instanceIdMap.has(c) || (n.push(u), s.set(c, u));
  });
  var l = {
    list: WP(o, n),
    instanceIdMap: s
  };
  return l;
}, QP = function(i) {
  var t = ke.useContext(KP.BeansContext).context, e = i.rowCtrl, r = i.containerType, o = ke.useState(), n = o[0], s = o[1], a = ke.useState(), l = a[0], u = a[1], c = ke.useState(), p = c[0], d = c[1], h = ke.useState(), g = h[0], y = h[1], S = ke.useState(), _ = S[0], w = S[1], E = ke.useState(), R = E[0], D = E[1], B = ke.useState({ list: [], instanceIdMap: /* @__PURE__ */ new Map() }), H = B[0], A = B[1], N = ke.useState(), G = N[0], W = N[1], J = ke.useState(!1), de = J[0], ve = J[1], oe = ke.useState(e.getInitialRowTop(r)), ne = oe[0], fe = oe[1], ce = ke.useState(e.getInitialTransform(r)), se = ce[0], je = ce[1], _e = ke.useRef(null), Le = ke.useRef(), Ee = ke.useRef(!1), Re = ke.useState(0), Me = Re[0], it = Re[1];
  ke.useEffect(function() {
    var De;
    if (!Ee.current && G && !(Me > 10)) {
      var me = (De = _e.current) === null || De === void 0 ? void 0 : De.firstChild;
      me ? (e.setupDetailRowAutoHeight(me), Ee.current = !0) : it(function(at) {
        return at + 1;
      });
    }
  }, [G, Me]);
  var Ve = ke.useMemo(function() {
    return new zP.CssClassManager(function() {
      return _e.current;
    });
  }, []);
  qP.useLayoutEffectOnce(function() {
    if (e.isAlive()) {
      var De = {
        // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
        // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
        setTop: function(me) {
          return fe(me);
        },
        setTransform: function(me) {
          return je(me);
        },
        // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
        // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
        addOrRemoveCssClass: function(me, at) {
          return Ve.addOrRemoveCssClass(me, at);
        },
        setDomOrder: function(me) {
          return ve(me);
        },
        setRowIndex: function(me) {
          return s(me);
        },
        setRowId: function(me) {
          return u(me);
        },
        setRowBusinessKey: function(me) {
          return y(me);
        },
        setTabIndex: function(me) {
          return w(me);
        },
        setUserStyles: function(me) {
          return D(me);
        },
        setRole: function(me) {
          return d(me);
        },
        // if we don't maintain the order, then cols will be ripped out and into the dom
        // when cols reordered, which would stop the CSS transitions from working
        setCellCtrls: function(me, at) {
          Fd.agFlushSync(at, function() {
            A(function(jt) {
              return XP(jt, me, de);
            });
          });
        },
        showFullWidth: function(me) {
          return W(me);
        },
        getFullWidthCellRenderer: function() {
          return Le.current;
        }
      };
      return e.setComp(De, _e.current, r), function() {
        e.unsetComp(r);
      };
    }
  }), ke.useLayoutEffect(function() {
    return $P.showJsComp(G, t, _e.current, Le);
  }, [G]);
  var Ze = ke.useMemo(function() {
    var De = { top: ne, transform: se };
    return Object.assign(De, R), De;
  }, [ne, se, R]), Se = G && G.componentFromFramework, yt = H != null, Ge = ke.useMemo(function() {
    var De = (G == null ? void 0 : G.componentFromFramework) && Fd.isComponentStateless(G.componentClass);
    return !!De;
  }, [G]), st = function() {
    return H.list.map(function(De) {
      return ke.default.createElement(YP.default, { cellCtrl: De, editingRow: e.isEditing(), printLayout: e.isPrintLayout(), key: De.getInstanceId() });
    });
  }, Et = function() {
    var De = G.componentClass;
    return ke.default.createElement(
      ke.default.Fragment,
      null,
      Ge && ke.default.createElement(De, ya({}, G.params)),
      !Ge && ke.default.createElement(De, ya({}, G.params, { ref: Le }))
    );
  };
  return ke.default.createElement(
    "div",
    { ref: _e, role: p, style: Ze, "row-index": n, "row-id": l, "row-business-key": g, tabIndex: _ },
    yt && st(),
    Se && Et()
  );
};
Dc.default = ke.memo(QP);
var JP = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), ZP = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), eD = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && JP(t, i, e);
  return ZP(t, i), t;
}, tD = P && P.__spreadArrays || function() {
  for (var i = 0, t = 0, e = arguments.length; t < e; t++)
    i += arguments[t].length;
  for (var r = Array(i), o = 0, t = 0; t < e; t++)
    for (var n = arguments[t], s = 0, a = n.length; s < a; s++, o++)
      r[o] = n[s];
  return r;
}, lg = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Pc, "__esModule", { value: !0 });
var tn = xt, vt = eD(Ye), Hs = ct, rD = lg(qi), oD = lg(Dc), nD = _t, iD = nt, sD = function(i) {
  var t = vt.useContext(nD.BeansContext).context, e = vt.useState([]), r = e[0], o = e[1], n = i.name, s = vt.useMemo(function() {
    return tn.getRowContainerTypeForName(n);
  }, [n]), a = vt.useRef(null), l = vt.useRef(null), u = vt.useRef(null), c = vt.useRef([]), p = vt.useRef(!1), d = vt.useMemo(function() {
    return tn.RowContainerCtrl.getRowContainerCssClasses(n);
  }, [n]), h = vt.useMemo(function() {
    return Hs.classesList(d.wrapper);
  }, []), g = vt.useMemo(function() {
    return Hs.classesList(d.viewport);
  }, []), y = vt.useMemo(function() {
    return Hs.classesList(d.container);
  }, []), S = n === tn.RowContainerName.CENTER, _ = n === tn.RowContainerName.TOP_CENTER || n === tn.RowContainerName.BOTTOM_CENTER || n === tn.RowContainerName.STICKY_TOP_CENTER, w = !S && !_, E = S ? a : _ ? l : u;
  rD.default(" AG Row Container " + n + " ", E);
  function R(B) {
    Hs.agFlushSync(B, function() {
      o(function(H) {
        var A = c.current;
        if (p.current)
          return A;
        var N = H.filter(function(W) {
          return A.indexOf(W) >= 0;
        }), G = A.filter(function(W) {
          return N.indexOf(W) < 0;
        });
        return tD(N, G);
      });
    });
  }
  iD.useLayoutEffectOnce(function() {
    var B = [], H = {
      setViewportHeight: function(N) {
        return l.current.style.height = N;
      },
      setRowCtrls: function(N, G) {
        if (c.current !== N) {
          var W = G && c.current.length > 0 && N.length > 0;
          c.current = N, R(W);
        }
      },
      setDomOrder: function(N) {
        p.current != N && (p.current = N, R(!1));
      },
      setContainerWidth: function(N) {
        return u.current.style.width = N;
      }
    }, A = t.createBean(new tn.RowContainerCtrl(n));
    return B.push(A), A.setComp(H, u.current, l.current, a.current), function() {
      t.destroyBeans(B);
    };
  });
  var D = function() {
    return vt.default.createElement("div", { className: y, ref: u, role: r.length ? "rowgroup" : "presentation" }, r.map(function(B) {
      return vt.default.createElement(oD.default, { rowCtrl: B, containerType: s, key: B.getInstanceId() });
    }));
  };
  return vt.default.createElement(
    vt.default.Fragment,
    null,
    S && vt.default.createElement(
      "div",
      { className: h, ref: a, role: "presentation" },
      vt.default.createElement("div", { className: g, ref: l, role: "presentation" }, D())
    ),
    _ && vt.default.createElement("div", { className: g, ref: l, role: "presentation" }, D()),
    w && D()
  );
};
Pc.default = vt.memo(sD);
var aD = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), lD = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), uD = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && aD(t, i, e);
  return lD(t, i), t;
}, Fc = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(wc, "__esModule", { value: !0 });
var ft = xt, Oe = uD(Ye), cD = _t, pD = Fc(Sc), _i = Fc(qi), dD = Fc(Pc), fD = nt, rn = ct, hD = function() {
  var i = Oe.useContext(cD.BeansContext), t = i.context, e = i.agStackComponentsRegistry, r = i.resizeObserverService, o = Oe.useState(""), n = o[0], s = o[1], a = Oe.useState(0), l = a[0], u = a[1], c = Oe.useState(0), p = c[0], d = c[1], h = Oe.useState("0px"), g = h[0], y = h[1], S = Oe.useState("0px"), _ = S[0], w = S[1], E = Oe.useState("100%"), R = E[0], D = E[1], B = Oe.useState(""), H = B[0], A = B[1], N = Oe.useState(""), G = N[0], W = N[1], J = Oe.useState(null), de = J[0], ve = J[1], oe = Oe.useState(""), ne = oe[0], fe = oe[1], ce = Oe.useState(null), se = ce[0], je = ce[1], _e = Oe.useState("ag-layout-normal"), Le = _e[0], Ee = _e[1], Re = Oe.useMemo(function() {
    return new ft.CssClassManager(function() {
      return Me.current;
    });
  }, []), Me = Oe.useRef(null), it = Oe.useRef(null), Ve = Oe.useRef(null), Ze = Oe.useRef(null), Se = Oe.useRef(null), yt = Oe.useRef(null);
  _i.default(" AG Grid Body ", Me), _i.default(" AG Pinned Top ", it), _i.default(" AG Sticky Top ", Ve), _i.default(" AG Middle ", Se), _i.default(" AG Pinned Bottom ", yt), fD.useLayoutEffectOnce(function() {
    var pt = [], Te = [];
    if (t) {
      var mt = function(We) {
        var Ut = e.getComponentClass(We), Rt = t.createBean(new Ut());
        return pt.push(Rt), Rt;
      };
      Me.current.appendChild(document.createComment(" AG Fake Horizontal Scroll ")), Me.current.appendChild(mt("AG-FAKE-HORIZONTAL-SCROLL").getGui()), Me.current.appendChild(document.createComment(" AG Overlay Wrapper ")), Me.current.appendChild(mt("AG-OVERLAY-WRAPPER").getGui()), Ze.current.appendChild(document.createComment(" AG Fake Vertical Scroll ")), Ze.current.appendChild(mt("AG-FAKE-VERTICAL-SCROLL").getGui());
      var Wr = {
        setRowAnimationCssOnBodyViewport: s,
        setColumnCount: function(We) {
          return ft._.setAriaColCount(Me.current, We);
        },
        setRowCount: function(We) {
          return ft._.setAriaRowCount(Me.current, We);
        },
        setTopHeight: u,
        setBottomHeight: d,
        setStickyTopHeight: y,
        setStickyTopTop: w,
        setStickyTopWidth: D,
        setTopDisplay: A,
        setBottomDisplay: W,
        setColumnMovingCss: function(We, Ut) {
          return Re.addOrRemoveCssClass(We, Ut);
        },
        updateLayoutClasses: Ee,
        setAlwaysVerticalScrollClass: ve,
        setPinnedTopBottomOverflowY: fe,
        setCellSelectableCss: je,
        setBodyViewportWidth: function(We) {
          return Se.current.style.width = We;
        },
        registerBodyViewportResizeListener: function(We) {
          var Ut = r.observeResize(Se.current, We);
          Te.push(function() {
            return Ut();
          });
        }
      }, br = t.createBean(new ft.GridBodyCtrl());
      return pt.push(br), br.setComp(Wr, Me.current, Se.current, it.current, yt.current, Ve.current), function() {
        t.destroyBeans(pt), Te.forEach(function(We) {
          return We();
        });
      };
    }
  });
  var Ge = Oe.useMemo(function() {
    return rn.classesList("ag-root", "ag-unselectable", Le);
  }, [Le]), st = Oe.useMemo(function() {
    return rn.classesList("ag-body-viewport", n, Le, de, se);
  }, [n, Le, de, se]), Et = Oe.useMemo(function() {
    return rn.classesList("ag-body", Le);
  }, [Le]), De = Oe.useMemo(function() {
    return rn.classesList("ag-body-clipper", Le);
  }, [Le]), me = Oe.useMemo(function() {
    return rn.classesList("ag-floating-top", se);
  }, [se]), at = Oe.useMemo(function() {
    return rn.classesList("ag-sticky-top", se);
  }, [se]), jt = Oe.useMemo(function() {
    return rn.classesList("ag-floating-bottom", se);
  }, [se]), dr = Oe.useMemo(function() {
    return {
      height: l,
      minHeight: l,
      display: H,
      overflowY: ne
    };
  }, [l, H, ne]), kr = Oe.useMemo(function() {
    return {
      height: g,
      top: _,
      width: R
    };
  }, [g, _, R]), jr = Oe.useMemo(function() {
    return {
      height: p,
      minHeight: p,
      display: G,
      overflowY: ne
    };
  }, [p, G, ne]), lo = function(pt) {
    return Oe.default.createElement(dD.default, { name: pt, key: pt + "-container" });
  }, Wt = function(pt) {
    var Te = pt.section, mt = pt.children, Wr = pt.className, br = pt.style;
    return Oe.default.createElement("div", { ref: Te, className: Wr, role: "presentation", style: br }, mt.map(lo));
  };
  return Oe.default.createElement(
    "div",
    { ref: Me, className: Ge, role: "treegrid" },
    Oe.default.createElement(pD.default, null),
    Wt({ section: it, className: me, style: dr, children: [
      ft.RowContainerName.TOP_LEFT,
      ft.RowContainerName.TOP_CENTER,
      ft.RowContainerName.TOP_RIGHT,
      ft.RowContainerName.TOP_FULL_WIDTH
    ] }),
    Oe.default.createElement(
      "div",
      { className: Et, ref: Ze, role: "presentation" },
      Oe.default.createElement("div", { className: De, role: "presentation" }, Wt({
        section: Se,
        className: st,
        children: [
          ft.RowContainerName.LEFT,
          ft.RowContainerName.CENTER,
          ft.RowContainerName.RIGHT,
          ft.RowContainerName.FULL_WIDTH
        ]
      }))
    ),
    Wt({ section: Ve, className: at, style: kr, children: [
      ft.RowContainerName.STICKY_TOP_LEFT,
      ft.RowContainerName.STICKY_TOP_CENTER,
      ft.RowContainerName.STICKY_TOP_RIGHT,
      ft.RowContainerName.STICKY_TOP_FULL_WIDTH
    ] }),
    Wt({ section: yt, className: jt, style: jr, children: [
      ft.RowContainerName.BOTTOM_LEFT,
      ft.RowContainerName.BOTTOM_CENTER,
      ft.RowContainerName.BOTTOM_RIGHT,
      ft.RowContainerName.BOTTOM_FULL_WIDTH
    ] })
  );
};
wc.default = Oe.memo(hD);
var Mc = {}, vD = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), gD = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), yD = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && vD(t, i, e);
  return gD(t, i), t;
};
Object.defineProperty(Mc, "__esModule", { value: !0 });
var Lr = yD(Ye), Vs = xt, mD = _t, CD = nt, wD = function(i, t) {
  var e = i.children, r = i.eFocusableElement, o = i.onTabKeyDown, n = i.gridCtrl, s = Lr.useContext(mD.BeansContext).context, a = Lr.useRef(null), l = Lr.useRef(null), u = Lr.useRef(), c = Lr.useState(), p = c[0], d = c[1];
  Lr.useImperativeHandle(t, function() {
    return {
      forceFocusOutOfContainer: function() {
        u.current.forceFocusOutOfContainer();
      }
    };
  }), CD.useLayoutEffectOnce(function() {
    var g = a.current, y = l.current, S = {
      setTabIndex: function(w) {
        return w == null ? d(void 0) : d(parseInt(w, 10));
      }
    }, _ = u.current = s.createBean(new Vs.TabGuardCtrl({
      comp: S,
      eTopGuard: g,
      eBottomGuard: y,
      eFocusableElement: r,
      onTabKeyDown: o,
      focusInnerElement: function(w) {
        return n.focusInnerElement(w);
      }
    }));
    return function() {
      s.destroyBean(_);
    };
  });
  var h = function(g) {
    var y = g === "top" ? Vs.TabGuardClassNames.TAB_GUARD_TOP : Vs.TabGuardClassNames.TAB_GUARD_BOTTOM;
    return Lr.default.createElement("div", { className: Vs.TabGuardClassNames.TAB_GUARD + " " + y, role: "presentation", tabIndex: p, ref: g === "top" ? a : l });
  };
  return Lr.default.createElement(
    Lr.default.Fragment,
    null,
    h("top"),
    e,
    h("bottom")
  );
}, SD = Lr.forwardRef(wD);
Mc.default = Lr.memo(SD);
var _D = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), ED = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), RD = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && _D(t, i, e);
  return ED(t, i), t;
}, Ic = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Cc, "__esModule", { value: !0 });
var Md = xt, Qe = RD(Ye), OD = _t, bD = Ic(wc), TD = Ic(qi), PD = Ic(Mc), Id = nt, Ld = ct, DD = function(i) {
  var t = i.context, e = Qe.useState(""), r = e[0], o = e[1], n = Qe.useState(""), s = n[0], a = n[1], l = Qe.useState(""), u = l[0], c = l[1], p = Qe.useState(null), d = p[0], h = p[1], g = Qe.useState(null), y = g[0], S = g[1], _ = Qe.useState(!1), w = _[0], E = _[1], R = Qe.useState(), D = R[0], B = R[1], H = Qe.useRef(null), A = Qe.useRef(null), N = Qe.useRef(), G = Qe.useRef(null), W = Qe.useRef(function() {
  }), J = Qe.useCallback(function() {
  }, []), de = Qe.useMemo(function() {
    return t.getBean("beans");
  }, []);
  TD.default(" AG Grid ", A), Id.useLayoutEffectOnce(function() {
    var se = H.current = t.createBean(new Md.GridCtrl());
    return function() {
      t.destroyBean(se), H.current = null;
    };
  }), Id.useLayoutEffectOnce(function() {
    var se = H.current;
    W.current = se.focusInnerElement.bind(se);
    var je = {
      destroyGridUi: function() {
      },
      setRtlClass: o,
      addOrRemoveKeyboardFocusClass: function(_e) {
        return a(_e ? Md.FocusService.AG_KEYBOARD_FOCUS : "");
      },
      forceFocusOutOfContainer: function() {
        N.current.forceFocusOutOfContainer();
      },
      updateLayoutClasses: c,
      getFocusableContainers: function() {
        var _e = [], Le = A.current.querySelector(".ag-root"), Ee = A.current.querySelector(".ag-side-bar:not(.ag-hidden)");
        return Le && _e.push(Le), Ee && _e.push(Ee), _e;
      },
      setCursor: h,
      setUserSelect: S
    };
    se.setComp(je, A.current, A.current), E(!0);
  }), Qe.useEffect(function() {
    if (D) {
      var se = H.current, je = [], _e = de.agStackComponentsRegistry, Le = _e.getComponentClass("AG-GRID-HEADER-DROP-ZONES"), Ee = _e.getComponentClass("AG-SIDE-BAR"), Re = _e.getComponentClass("AG-STATUS-BAR"), Me = _e.getComponentClass("AG-WATERMARK"), it = _e.getComponentClass("AG-PAGINATION"), Ve = [], Ze = A.current, Se = G.current;
      if (se.showDropZones() && Le) {
        var yt = t.createBean(new Le()), Ge = yt.getGui();
        Ze.insertAdjacentElement("afterbegin", Ge), Ve.push(Ge), je.push(yt);
      }
      if (se.showSideBar() && Ee) {
        var st = t.createBean(new Ee()), Ge = st.getGui(), Et = Se.querySelector(".ag-tab-guard-bottom");
        Et && (Et.insertAdjacentElement("beforebegin", Ge), Ve.push(Ge)), je.push(st);
      }
      if (se.showStatusBar() && Re) {
        var De = t.createBean(new Re()), Ge = De.getGui();
        Ze.insertAdjacentElement("beforeend", Ge), Ve.push(Ge), je.push(De);
      }
      if (it) {
        var me = t.createBean(new it()), Ge = me.getGui();
        Ze.insertAdjacentElement("beforeend", Ge), Ve.push(Ge), je.push(me);
      }
      if (se.showWatermark() && Me) {
        var at = t.createBean(new Me()), Ge = at.getGui();
        Ze.insertAdjacentElement("beforeend", Ge), Ve.push(Ge), je.push(at);
      }
      return function() {
        t.destroyBeans(je), Ve.forEach(function(jt) {
          jt.parentElement && jt.parentElement.removeChild(jt);
        });
      };
    }
  }, [D]);
  var ve = Qe.useMemo(function() {
    return Ld.classesList("ag-root-wrapper", r, s, u);
  }, [r, s, u]), oe = Qe.useMemo(function() {
    return Ld.classesList("ag-root-wrapper-body", "ag-focus-managed", u);
  }, [u]), ne = Qe.useMemo(function() {
    return {
      userSelect: y ?? "",
      WebkitUserSelect: y ?? "",
      cursor: d ?? ""
    };
  }, [y, d]), fe = G.current, ce = Qe.useCallback(function(se) {
    N.current = se, B(!0);
  }, []);
  return Qe.default.createElement(
    "div",
    { ref: A, className: ve, style: ne, role: "presentation" },
    Qe.default.createElement("div", { className: oe, ref: G, role: "presentation" }, w && fe && Qe.default.createElement(
      OD.BeansContext.Provider,
      { value: de },
      Qe.default.createElement(
        PD.default,
        { ref: ce, eFocusableElement: fe, onTabKeyDown: J, gridCtrl: H.current },
        // we wait for initialised before rending the children, so GridComp has created and registered with it's
        // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
        // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
        // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
        // hangs the UI)
        Qe.default.createElement(bD.default, null)
      )
    ))
  );
};
Cc.default = Qe.memo(DD);
var Nd;
function Lc() {
  if (Nd)
    return Si;
  Nd = 1;
  var i = P && P.__extends || /* @__PURE__ */ function() {
    var y = function(S, _) {
      return y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, E) {
        w.__proto__ = E;
      } || function(w, E) {
        for (var R in E)
          Object.prototype.hasOwnProperty.call(E, R) && (w[R] = E[R]);
      }, y(S, _);
    };
    return function(S, _) {
      y(S, _);
      function w() {
        this.constructor = S;
      }
      S.prototype = _ === null ? Object.create(_) : (w.prototype = _.prototype, new w());
    };
  }(), t = P && P.__assign || function() {
    return t = Object.assign || function(y) {
      for (var S, _ = 1, w = arguments.length; _ < w; _++) {
        S = arguments[_];
        for (var E in S)
          Object.prototype.hasOwnProperty.call(S, E) && (y[E] = S[E]);
      }
      return y;
    }, t.apply(this, arguments);
  }, e = P && P.__createBinding || (Object.create ? function(y, S, _, w) {
    w === void 0 && (w = _), Object.defineProperty(y, w, { enumerable: !0, get: function() {
      return S[_];
    } });
  } : function(y, S, _, w) {
    w === void 0 && (w = _), y[w] = S[_];
  }), r = P && P.__setModuleDefault || (Object.create ? function(y, S) {
    Object.defineProperty(y, "default", { enumerable: !0, value: S });
  } : function(y, S) {
    y.default = S;
  }), o = P && P.__importStar || function(y) {
    if (y && y.__esModule)
      return y;
    var S = {};
    if (y != null)
      for (var _ in y)
        _ !== "default" && Object.prototype.hasOwnProperty.call(y, _) && e(S, y, _);
    return r(S, y), S;
  }, n = P && P.__importDefault || function(y) {
    return y && y.__esModule ? y : { default: y };
  };
  Object.defineProperty(Si, "__esModule", { value: !0 }), Si.AgGridReactUi = void 0;
  var s = xt, a = o(Ye), l = Ki, u = Yi, c = n(Cc), p = ug();
  function d(y, S) {
  }
  var h = (
    /** @class */
    function(y) {
      i(S, y);
      function S(_) {
        var w = y.call(this, _) || this;
        return w.props = _, w.destroyFuncs = [], w.eGui = a.default.createRef(), w.whenReadyFuncs = [], w.ready = !1, w.renderedAfterMount = !1, w.mounted = !1, w.state = { context: void 0 }, w.portalManager = new u.PortalManager(w, _.componentWrappingElement, _.maxComponentCreationTimeMs), w.destroyFuncs.push(function() {
          return w.portalManager.destroy();
        }), w;
      }
      return S.prototype.render = function() {
        return "" + this.state.context, this.state.context && (this.renderedAfterMount = !0), a.default.createElement(
          "div",
          { style: this.createStyleForDiv(), className: this.props.className, ref: this.eGui },
          this.state.context && a.default.createElement(c.default, { context: this.state.context }),
          this.portalManager.getPortals()
        );
      }, S.prototype.createStyleForDiv = function() {
        return t({ height: "100%" }, this.props.containerStyle || {});
      }, S.prototype.componentDidMount = function() {
        var _ = this;
        if (!this.mounted) {
          this.mounted = !0;
          var w = this.props.modules || [], E = {
            providedBeanInstances: {
              frameworkComponentWrapper: new g(this.portalManager)
            },
            modules: w,
            frameworkOverrides: new p.ReactFrameworkOverrides(!0)
          };
          this.gridOptions = this.props.gridOptions || {}, this.gridOptions = s.ComponentUtil.copyAttributesToGridOptions(this.gridOptions, this.props), this.checkForDeprecations(this.props);
          var R = function(H) {
            _.setState({ context: H });
            var A = H.getBean(s.CtrlsService.NAME);
            A.whenReady(function() {
              _.api = _.gridOptions.api, _.columnApi = _.gridOptions.columnApi, _.props.setGridApi(_.api, _.columnApi), _.destroyFuncs.push(function() {
                return _.api.destroy();
              });
            });
          }, D = function(H) {
            var A = H.getBean(s.CtrlsService.NAME);
            A.whenReady(function() {
              _.whenReadyFuncs.forEach(function(N) {
                return N();
              }), _.whenReadyFuncs.length = 0, _.ready = !0;
            });
          }, B = new s.GridCoreCreator();
          B.create(this.eGui.current, this.gridOptions, R, D, E);
        }
      }, S.prototype.checkForDeprecations = function(_) {
        _.rowDataChangeDetectionStrategy && s._.doOnce(function() {
          return console.warn("AG Grid: Since v29 rowDataChangeDetectionStrategy has been deprecated. Row data property changes will be compared by reference via triple equals ===. See https://ag-grid.com/react-data-grid/react-hooks/");
        }, "rowDataChangeDetectionStrategy_Deprecation");
      }, S.prototype.componentWillUnmount = function() {
        this.renderedAfterMount && (this.destroyFuncs.forEach(function(_) {
          return _();
        }), this.destroyFuncs.length = 0);
      }, S.prototype.componentDidUpdate = function(_) {
        this.processPropsChanges(_, this.props);
      }, S.prototype.processPropsChanges = function(_, w) {
        var E = {};
        this.extractGridPropertyChanges(_, w, E), this.processChanges(E);
      }, S.prototype.extractGridPropertyChanges = function(_, w, E) {
        var R = !!w.debug;
        Object.keys(w).forEach(function(D) {
          s.ComponentUtil.ALL_PROPERTIES_SET.has(D) && _[D] !== w[D] && (R && console.log("agGridReact: [" + D + "] property changed"), E[D] = {
            previousValue: _[D],
            currentValue: w[D]
          });
        }), s.ComponentUtil.EVENT_CALLBACKS.forEach(function(D) {
          _[D] !== w[D] && (R && console.log("agGridReact: [" + D + "] event callback changed"), E[D] = {
            previousValue: _[D],
            currentValue: w[D]
          });
        });
      }, S.prototype.processChanges = function(_) {
        var w = this;
        this.processWhenReady(function() {
          return s.ComponentUtil.processOnChange(_, w.api);
        });
      }, S.prototype.processWhenReady = function(_) {
        this.ready ? _() : this.whenReadyFuncs.push(_);
      }, S;
    }(a.Component)
  );
  Si.AgGridReactUi = h;
  var g = (
    /** @class */
    function(y) {
      i(S, y);
      function S(_) {
        var w = y.call(this) || this;
        return w.parent = _, w;
      }
      return S.prototype.createWrapper = function(_, w) {
        return new l.NewReactComponent(_, this.parent, w);
      }, S;
    }(s.BaseComponentWrapper)
  );
  return Si;
}
var Gd;
function AD() {
  if (Gd)
    return Ns;
  Gd = 1;
  var i = P && P.__assign || function() {
    return i = Object.assign || function(c) {
      for (var p, d = 1, h = arguments.length; d < h; d++) {
        p = arguments[d];
        for (var g in p)
          Object.prototype.hasOwnProperty.call(p, g) && (c[g] = p[g]);
      }
      return c;
    }, i.apply(this, arguments);
  }, t = P && P.__createBinding || (Object.create ? function(c, p, d, h) {
    h === void 0 && (h = d), Object.defineProperty(c, h, { enumerable: !0, get: function() {
      return p[d];
    } });
  } : function(c, p, d, h) {
    h === void 0 && (h = d), c[h] = p[d];
  }), e = P && P.__setModuleDefault || (Object.create ? function(c, p) {
    Object.defineProperty(c, "default", { enumerable: !0, value: p });
  } : function(c, p) {
    c.default = p;
  }), r = P && P.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var p = {};
    if (c != null)
      for (var d in c)
        d !== "default" && Object.prototype.hasOwnProperty.call(c, d) && t(p, c, d);
    return e(p, c), p;
  };
  Object.defineProperty(Ns, "__esModule", { value: !0 });
  var o = r(Ye), n = ct, s = _t, a = Lc(), l = nt, u = function(c, p) {
    var d = o.useContext(s.BeansContext), h = d.ctrlsFactory, g = d.context, y = d.gridOptionsService, S = d.resizeObserverService, _ = d.clientSideRowModel, w = d.serverSideRowModel, E = o.useState(new n.CssClasses()), R = E[0], D = E[1], B = o.useState(new n.CssClasses()), H = B[0], A = B[1], N = o.useState(), G = N[0], W = N[1], J = o.useState(), de = J[0], ve = J[1], oe = o.useRef(), ne = o.useRef(null), fe = o.useMemo(function() {
      return R.toString() + " ag-details-row";
    }, [R]), ce = o.useMemo(function() {
      return H.toString() + " ag-details-grid";
    }, [H]);
    p && o.useImperativeHandle(p, function() {
      return {
        refresh: function() {
          return oe.current.refresh();
        }
      };
    }), l.useLayoutEffectOnce(function() {
      c.template && typeof c.template == "string" && console.warn("AG Grid: detailCellRendererParams.template is not supported by React - this only works with frameworks that work against String templates. To change the template, please provide your own React Detail Cell Renderer.");
    }), l.useLayoutEffectOnce(function() {
      var je = {
        addOrRemoveCssClass: function(Re, Me) {
          return D(function(it) {
            return it.setClass(Re, Me);
          });
        },
        addOrRemoveDetailGridCssClass: function(Re, Me) {
          return A(function(it) {
            return it.setClass(Re, Me);
          });
        },
        setDetailGrid: function(Re) {
          return W(Re);
        },
        setRowData: function(Re) {
          return ve(Re);
        },
        getGui: function() {
          return ne.current;
        }
      }, _e = h.getInstance("detailCellRenderer");
      if (_e) {
        g.createBean(_e), _e.init(je, c), oe.current = _e;
        var Le;
        if (y.is("detailRowAutoHeight")) {
          var Ee = function() {
            if (ne.current != null) {
              var Re = ne.current.clientHeight;
              if (Re != null && Re > 0) {
                var Me = function() {
                  c.node.setRowHeight(Re), _ ? _.onRowHeightChanged() : w && w.onRowHeightChanged();
                };
                setTimeout(Me, 0);
              }
            }
          };
          Le = S.observeResize(ne.current, Ee), Ee();
        }
        return function() {
          g.destroyBean(_e), Le && Le();
        };
      }
    });
    var se = o.useCallback(function(je, _e) {
      oe.current.registerDetailWithMaster(je, _e);
    }, []);
    return o.default.createElement("div", { className: fe, ref: ne }, G && o.default.createElement(a.AgGridReactUi, i({ className: ce }, G, { rowData: de, setGridApi: se })));
  };
  return Ns.default = o.forwardRef(u), Ns;
}
var Hd;
function ug() {
  if (Hd)
    return wi;
  Hd = 1;
  var i = P && P.__extends || /* @__PURE__ */ function() {
    var s = function(a, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, c) {
        u.__proto__ = c;
      } || function(u, c) {
        for (var p in c)
          Object.prototype.hasOwnProperty.call(c, p) && (u[p] = c[p]);
      }, s(a, l);
    };
    return function(a, l) {
      s(a, l);
      function u() {
        this.constructor = a;
      }
      a.prototype = l === null ? Object.create(l) : (u.prototype = l.prototype, new u());
    };
  }(), t = P && P.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(wi, "__esModule", { value: !0 }), wi.ReactFrameworkOverrides = void 0;
  var e = xt, r = t(mc), o = t(AD()), n = (
    /** @class */
    function(s) {
      i(a, s);
      function a(l) {
        var u = s.call(this) || this;
        return u.frameworkComponents = {
          agGroupCellRenderer: r.default,
          agGroupRowRenderer: r.default,
          agDetailCellRenderer: o.default
        }, u.reactUi = l, u;
      }
      return a.prototype.frameworkComponent = function(l) {
        if (this.reactUi)
          return this.frameworkComponents[l];
      }, a.prototype.isFrameworkComponent = function(l) {
        if (!l)
          return !1;
        var u = l.prototype, c = u && "getGui" in u;
        return !c;
      }, a;
    }(e.VanillaFrameworkOverrides)
  );
  return wi.ReactFrameworkOverrides = n, wi;
}
var cg = P && P.__extends || /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ma = P && P.__assign || function() {
  return ma = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, ma.apply(this, arguments);
}, xD = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), FD = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), MD = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && xD(t, i, e);
  return FD(t, i), t;
}, ID = P && P.__importDefault || function(i) {
  return i && i.__esModule ? i : { default: i };
};
Object.defineProperty(Ea, "__esModule", { value: !0 });
Ea.AgGridReactLegacy = void 0;
var Yt = xt, Wo = ID($y), Vd = MD(Ye), LD = Ga, ND = Ki, GD = Yi, HD = ug(), Nc = (
  /** @class */
  function(i) {
    cg(t, i);
    function t(e) {
      var r = i.call(this, e) || this;
      return r.props = e, r.api = null, r.destroyed = !1, r.SYNCHRONOUS_CHANGE_PROPERTIES = ["context"], r.portalManager = new GD.PortalManager(r, e.componentWrappingElement, e.maxComponentCreationTimeMs), r;
    }
    return t.prototype.render = function() {
      var e = this;
      return Vd.default.createElement("div", {
        style: this.createStyleForDiv(),
        className: this.props.className,
        ref: function(r) {
          e.eGridDiv = r;
        }
      }, this.portalManager.getPortals());
    }, t.prototype.createStyleForDiv = function() {
      return ma({ height: "100%" }, this.props.containerStyle || {});
    }, t.prototype.componentDidMount = function() {
      var e = this.props.modules || [], r = {
        providedBeanInstances: {
          agGridReact: this,
          frameworkComponentWrapper: new VD(this, this.portalManager)
        },
        modules: e,
        frameworkOverrides: new HD.ReactFrameworkOverrides(!1)
      }, o = this.props.gridOptions || {};
      this.gridOptions = Yt.ComponentUtil.copyAttributesToGridOptions(o, this.props), this.checkForDeprecations(this.props), new Yt.Grid(this.eGridDiv, this.gridOptions, r), this.api = this.gridOptions.api, this.columnApi = this.gridOptions.columnApi, this.props.setGridApi(this.api, this.columnApi);
    }, t.prototype.checkForDeprecations = function(e) {
      e.rowDataChangeDetectionStrategy && Yt._.doOnce(function() {
        return console.warn("AG Grid: Since v29 rowDataChangeDetectionStrategy has been deprecated. Row data property changes will be compared by reference via triple equals ===. See https://ag-grid.com/react-data-grid/react-hooks/");
      }, "rowDataChangeDetectionStrategy_Deprecation");
    }, t.prototype.shouldComponentUpdate = function(e) {
      return this.processPropsChanges(this.props, e), !1;
    }, t.prototype.componentDidUpdate = function(e) {
      this.processPropsChanges(e, this.props);
    }, t.prototype.processPropsChanges = function(e, r) {
      var o = {};
      this.extractGridPropertyChanges(e, r, o), this.processSynchronousChanges(o), this.processAsynchronousChanges(o);
    }, t.prototype.extractGridPropertyChanges = function(e, r, o) {
      var n = !!r.debug;
      Object.keys(r).forEach(function(s) {
        Yt.ComponentUtil.ALL_PROPERTIES_SET.has(s) && e[s] !== r[s] && (n && console.log("agGridReact: [" + s + "] property changed"), o[s] = {
          previousValue: e[s],
          currentValue: r[s]
        });
      }), Yt.ComponentUtil.EVENT_CALLBACKS.forEach(function(s) {
        e[s] !== r[s] && (n && console.log("agGridReact: [" + s + "] event callback changed"), o[s] = {
          previousValue: e[s],
          currentValue: r[s]
        });
      });
    }, t.prototype.componentWillUnmount = function() {
      this.api && (this.api.destroy(), this.api = null), this.destroyed = !0, this.portalManager.destroy();
    }, t.prototype.isDisableStaticMarkup = function() {
      return this.props.disableStaticMarkup === !0;
    }, t.prototype.isLegacyComponentRendering = function() {
      return this.props.legacyComponentRendering === !0;
    }, t.prototype.processSynchronousChanges = function(e) {
      var r = ma({}, e);
      if (Object.keys(r).length > 0) {
        var o = {};
        this.SYNCHRONOUS_CHANGE_PROPERTIES.forEach(function(n) {
          r[n] && (o[n] = r[n], delete r[n]);
        }), Object.keys(o).length > 0 && this.api && Yt.ComponentUtil.processOnChange(o, this.api);
      }
      return r;
    }, t.prototype.processAsynchronousChanges = function(e) {
      var r = this;
      Object.keys(e).length > 0 && window.setTimeout(function() {
        r.api && Yt.ComponentUtil.processOnChange(e, r.api);
      });
    }, t.MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3, t.defaultProps = {
      legacyComponentRendering: !1,
      disableStaticMarkup: !1,
      maxComponentCreationTimeMs: t.MAX_COMPONENT_CREATION_TIME_IN_MS
    }, t;
  }(Vd.Component)
);
Ea.AgGridReactLegacy = Nc;
Nc.propTypes = {
  gridOptions: Wo.default.object
};
wn(Yt.ComponentUtil.EVENT_CALLBACKS, Wo.default.func);
wn(Yt.ComponentUtil.BOOLEAN_PROPERTIES, Wo.default.bool);
wn(Yt.ComponentUtil.STRING_PROPERTIES, Wo.default.string);
wn(Yt.ComponentUtil.OBJECT_PROPERTIES, Wo.default.object);
wn(Yt.ComponentUtil.ARRAY_PROPERTIES, Wo.default.array);
wn(Yt.ComponentUtil.NUMBER_PROPERTIES, Wo.default.number);
wn(Yt.ComponentUtil.FUNCTION_PROPERTIES, Wo.default.func);
function wn(i, t) {
  i.forEach(function(e) {
    Nc[e] = t;
  });
}
var VD = (
  /** @class */
  function(i) {
    cg(t, i);
    function t(e, r) {
      var o = i.call(this) || this;
      return o.agGridReact = e, o.portalManager = r, o;
    }
    return t.prototype.createWrapper = function(e, r) {
      return this.agGridReact.isLegacyComponentRendering() ? new LD.LegacyReactComponent(e, this.agGridReact, this.portalManager, r) : new ND.NewReactComponent(e, this.portalManager, r);
    }, t;
  }(Yt.BaseComponentWrapper)
), BD = P && P.__extends || /* @__PURE__ */ function() {
  var i = function(t, e) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }, i(t, e);
  };
  return function(t, e) {
    i(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ca = P && P.__assign || function() {
  return Ca = Object.assign || function(i) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
    }
    return i;
  }, Ca.apply(this, arguments);
}, kD = P && P.__createBinding || (Object.create ? function(i, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(i, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(i, t, e, r) {
  r === void 0 && (r = e), i[r] = t[e];
}), jD = P && P.__setModuleDefault || (Object.create ? function(i, t) {
  Object.defineProperty(i, "default", { enumerable: !0, value: t });
} : function(i, t) {
  i.default = t;
}), WD = P && P.__importStar || function(i) {
  if (i && i.__esModule)
    return i;
  var t = {};
  if (i != null)
    for (var e in i)
      e !== "default" && Object.prototype.hasOwnProperty.call(i, e) && kD(t, i, e);
  return jD(t, i), t;
};
Object.defineProperty(_a, "__esModule", { value: !0 });
_a.AgGridReact = void 0;
var ql = WD(Ye), UD = Ea, zD = Lc(), $D = (
  /** @class */
  function(i) {
    BD(t, i);
    function t() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.setGridApi = function(r, o) {
        e.api = r, e.columnApi = o;
      }, e;
    }
    return t.prototype.render = function() {
      var e = this.props.suppressReactUi ? ql.default.createElement(UD.AgGridReactLegacy, Ca({}, this.props, { setGridApi: this.setGridApi })) : ql.default.createElement(zD.AgGridReactUi, Ca({}, this.props, { setGridApi: this.setGridApi }));
      return e;
    }, t;
  }(ql.Component)
);
_a.AgGridReact = $D;
var pg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 }), i.ChangeDetectionStrategyType = void 0, function(t) {
    t.IdentityCheck = "IdentityCheck", t.DeepValueCheck = "DeepValueCheck", t.NoCheck = "NoCheck";
  }(i.ChangeDetectionStrategyType || (i.ChangeDetectionStrategyType = {}));
})(pg);
var MA = _a.AgGridReact;
pg.ChangeDetectionStrategyType;
Lc().AgGridReactUi;
const yo = Symbol.for("@ts-pattern/matcher"), KD = Symbol.for("@ts-pattern/isVariadic"), wa = "@ts-pattern/anonymous-select-key", bu = (i) => !!(i && typeof i == "object"), Us = (i) => i && !!i[yo], to = (i, t, e) => {
  if (Us(i)) {
    const r = i[yo](), { matched: o, selections: n } = r.match(t);
    return o && n && Object.keys(n).forEach((s) => e(s, n[s])), o;
  }
  if (bu(i)) {
    if (!bu(t))
      return !1;
    if (Array.isArray(i)) {
      if (!Array.isArray(t))
        return !1;
      let r = [], o = [], n = [];
      for (const s of i.keys()) {
        const a = i[s];
        Us(a) && a[KD] ? n.push(a) : n.length ? o.push(a) : r.push(a);
      }
      if (n.length) {
        if (n.length > 1)
          throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
        if (t.length < r.length + o.length)
          return !1;
        const s = t.slice(0, r.length), a = o.length === 0 ? [] : t.slice(-o.length), l = t.slice(r.length, o.length === 0 ? 1 / 0 : -o.length);
        return r.every((u, c) => to(u, s[c], e)) && o.every((u, c) => to(u, a[c], e)) && (n.length === 0 || to(n[0], l, e));
      }
      return i.length === t.length && i.every((s, a) => to(s, t[a], e));
    }
    return Object.keys(i).every((r) => {
      const o = i[r];
      return (r in t || Us(n = o) && n[yo]().matcherType === "optional") && to(o, t[r], e);
      var n;
    });
  }
  return Object.is(t, i);
}, ko = (i) => {
  var t, e, r;
  return bu(i) ? Us(i) ? (t = (e = (r = i[yo]()).getSelectionKeys) == null ? void 0 : e.call(r)) != null ? t : [] : Array.isArray(i) ? Gi(i, ko) : Gi(Object.values(i), ko) : [];
}, Gi = (i, t) => i.reduce((e, r) => e.concat(t(r)), []);
function Or(i) {
  return Object.assign(i, { optional: () => YD(i), and: (t) => tt(i, t), or: (t) => qD(i, t), select: (t) => t === void 0 ? Bd(i) : Bd(t, i) });
}
function YD(i) {
  return Or({ [yo]: () => ({ match: (t) => {
    let e = {};
    const r = (o, n) => {
      e[o] = n;
    };
    return t === void 0 ? (ko(i).forEach((o) => r(o, void 0)), { matched: !0, selections: e }) : { matched: to(i, t, r), selections: e };
  }, getSelectionKeys: () => ko(i), matcherType: "optional" }) });
}
function tt(...i) {
  return Or({ [yo]: () => ({ match: (t) => {
    let e = {};
    const r = (o, n) => {
      e[o] = n;
    };
    return { matched: i.every((o) => to(o, t, r)), selections: e };
  }, getSelectionKeys: () => Gi(i, ko), matcherType: "and" }) });
}
function qD(...i) {
  return Or({ [yo]: () => ({ match: (t) => {
    let e = {};
    const r = (o, n) => {
      e[o] = n;
    };
    return Gi(i, ko).forEach((o) => r(o, void 0)), { matched: i.some((o) => to(o, t, r)), selections: e };
  }, getSelectionKeys: () => Gi(i, ko), matcherType: "or" }) });
}
function He(i) {
  return { [yo]: () => ({ match: (t) => ({ matched: !!i(t) }) }) };
}
function Bd(...i) {
  const t = typeof i[0] == "string" ? i[0] : void 0, e = i.length === 2 ? i[1] : typeof i[0] == "string" ? void 0 : i[0];
  return Or({ [yo]: () => ({ match: (r) => {
    let o = { [t ?? wa]: r };
    return { matched: e === void 0 || to(e, r, (n, s) => {
      o[n] = s;
    }), selections: o };
  }, getSelectionKeys: () => [t ?? wa].concat(e === void 0 ? [] : ko(e)) }) });
}
function Qr(i) {
  return typeof i == "number";
}
function nn(i) {
  return typeof i == "string";
}
function Mo(i) {
  return typeof i == "bigint";
}
Or(He(function(i) {
  return !0;
}));
const sn = (i) => Object.assign(Or(i), { startsWith: (t) => {
  return sn(tt(i, (e = t, He((r) => nn(r) && r.startsWith(e)))));
  var e;
}, endsWith: (t) => {
  return sn(tt(i, (e = t, He((r) => nn(r) && r.endsWith(e)))));
  var e;
}, minLength: (t) => sn(tt(i, ((e) => He((r) => nn(r) && r.length >= e))(t))), maxLength: (t) => sn(tt(i, ((e) => He((r) => nn(r) && r.length <= e))(t))), includes: (t) => {
  return sn(tt(i, (e = t, He((r) => nn(r) && r.includes(e)))));
  var e;
}, regex: (t) => {
  return sn(tt(i, (e = t, He((r) => nn(r) && !!r.match(e)))));
  var e;
} });
sn(He(nn));
const Jr = (i) => Object.assign(Or(i), { between: (t, e) => Jr(tt(i, ((r, o) => He((n) => Qr(n) && r <= n && o >= n))(t, e))), lt: (t) => Jr(tt(i, ((e) => He((r) => Qr(r) && r < e))(t))), gt: (t) => Jr(tt(i, ((e) => He((r) => Qr(r) && r > e))(t))), lte: (t) => Jr(tt(i, ((e) => He((r) => Qr(r) && r <= e))(t))), gte: (t) => Jr(tt(i, ((e) => He((r) => Qr(r) && r >= e))(t))), int: () => Jr(tt(i, He((t) => Qr(t) && Number.isInteger(t)))), finite: () => Jr(tt(i, He((t) => Qr(t) && Number.isFinite(t)))), positive: () => Jr(tt(i, He((t) => Qr(t) && t > 0))), negative: () => Jr(tt(i, He((t) => Qr(t) && t < 0))) });
Jr(He(Qr));
const Io = (i) => Object.assign(Or(i), { between: (t, e) => Io(tt(i, ((r, o) => He((n) => Mo(n) && r <= n && o >= n))(t, e))), lt: (t) => Io(tt(i, ((e) => He((r) => Mo(r) && r < e))(t))), gt: (t) => Io(tt(i, ((e) => He((r) => Mo(r) && r > e))(t))), lte: (t) => Io(tt(i, ((e) => He((r) => Mo(r) && r <= e))(t))), gte: (t) => Io(tt(i, ((e) => He((r) => Mo(r) && r >= e))(t))), positive: () => Io(tt(i, He((t) => Mo(t) && t > 0))), negative: () => Io(tt(i, He((t) => Mo(t) && t < 0))) });
Io(He(Mo));
Or(He(function(i) {
  return typeof i == "boolean";
}));
Or(He(function(i) {
  return typeof i == "symbol";
}));
Or(He(function(i) {
  return i == null;
}));
Or(He(function(i) {
  return i != null;
}));
const Tu = { matched: !1, value: void 0 };
function IA(i) {
  return new Sa(i, Tu);
}
class Sa {
  constructor(t, e) {
    this.input = void 0, this.state = void 0, this.input = t, this.state = e;
  }
  with(...t) {
    if (this.state.matched)
      return this;
    const e = t[t.length - 1], r = [t[0]];
    let o;
    t.length === 3 && typeof t[1] == "function" ? o = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
    let n = !1, s = {};
    const a = (u, c) => {
      n = !0, s[u] = c;
    }, l = !r.some((u) => to(u, this.input, a)) || o && !o(this.input) ? Tu : { matched: !0, value: e(n ? wa in s ? s[wa] : s : this.input, this.input) };
    return new Sa(this.input, l);
  }
  when(t, e) {
    if (this.state.matched)
      return this;
    const r = !!t(this.input);
    return new Sa(this.input, r ? { matched: !0, value: e(this.input, this.input) } : Tu);
  }
  otherwise(t) {
    return this.state.matched ? this.state.value : t(this.input);
  }
  exhaustive() {
    if (this.state.matched)
      return this.state.value;
    let t;
    try {
      t = JSON.stringify(this.input);
    } catch {
      t = this.input;
    }
    throw new Error(`Pattern matching error: no pattern matches value ${t}`);
  }
  run() {
    return this.exhaustive();
  }
  returnType() {
    return this;
  }
}
const XD = {
  title: "Title"
}, QD = Ud(Pu)`
  padding: var(--space-12) var(--space-24);
  border-radius: var(--br-3) var(--br-3) 0px 0px;
  height: inherit;
`;
function LA(i) {
  const {
    closeIcon: t,
    title: e = XD.title,
    onClose: r,
    extra: o,
    mode: n = "drawer",
    hideClose: s = !1
  } = i, a = /* @__PURE__ */ rt.jsx(Ay, { color: "var(--gray-8)" }), l = /* @__PURE__ */ rt.jsx(Py, { hide: s, children: /* @__PURE__ */ rt.jsx(zd, { title: "Close", destroyTooltipOnHide: !0, children: /* @__PURE__ */ rt.jsx(kd, { icon: a, size: n === "drawer" ? "middle" : "small", onClick: r, iconButton: "default" }) }) });
  return /* @__PURE__ */ rt.jsxs(QD, { justify: "space-between", align: "center", children: [
    e,
    /* @__PURE__ */ rt.jsxs(Pu, { align: "center", space: "8", children: [
      o,
      t || l
    ] })
  ] });
}
export {
  IA as $,
  MA as A,
  Qy as D,
  LA as G,
  Kd as S,
  Xy as a
};
//# sourceMappingURL=main-C3-4ZYQP.mjs.map
